import _defineProperty from "/home/circleci/scoreboard-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/home/circleci/scoreboard-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/circleci/scoreboard-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectWithoutProperties from "/home/circleci/scoreboard-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "/home/circleci/scoreboard-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "/home/circleci/scoreboard-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/home/circleci/scoreboard-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/scoreboard-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _taggedTemplateLiteral from "/home/circleci/scoreboard-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _slicedToArray from "/home/circleci/scoreboard-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  border: 2px solid white;\n  background-color: #f50d0d;\n  color: white;\n  font-weight: bold;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  &:hover {\n    cursor: 'pointer';\n    opacity: 1 !important;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  border: 2px solid white;\n  color: white;\n  font-weight: bold;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  &:hover {\n    cursor: 'pointer';\n    opacity: 1 !important;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  border: 2px solid white;\n  background-color: #0d951b;\n  color: white;\n  font-weight: bold;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  &:hover {\n    cursor: 'pointer';\n    opacity: 1 !important;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(359deg);\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n          ", " 0.8s infinite linear\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  place-items: center;\n  animation: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { animated, useSpring, to, useTransition, config } from '@react-spring/web';
import { Paper, createTheme, ThemeProvider as ThemeProvider$1, CssBaseline, makeStyles, Fade, CircularProgress, IconButton, Modal as Modal$1, Slide, Dialog as Dialog$1, Button as Button$1, Typography, Zoom, Snackbar as Snackbar$1, Checkbox, TableContainer, Table as Table$1, TableHead, TableRow, TableCell, TableBody, DialogTitle as DialogTitle$1, DialogContent as DialogContent$1, DialogContentText, DialogActions as DialogActions$1, withStyles, Tooltip as Tooltip$1, Radio, Box, Avatar, TextField, Accordion as Accordion$1, AccordionSummary as AccordionSummary$1, AccordionDetails as AccordionDetails$1, Fab, Divider, ClickAwayListener, FormControlLabel, InputAdornment, createStyles as createStyles$1, Menu, MenuItem, Collapse } from '@material-ui/core';
import React, { useRef, useState, useEffect, useLayoutEffect, Fragment, forwardRef, createRef, createContext, useContext, useCallback, useMemo, useImperativeHandle } from 'react';
import styled, { css, keyframes } from 'styled-components';
import { useGesture } from 'react-use-gesture';
import produce from 'immer';
import ResizeObserver from 'resize-observer-polyfill';
import { Done, Clear, Remove, ZoomOut, Add, ArrowBack, Check, Terrain, ChevronLeft, Close, ExpandMore, ThumbDown, Refresh, Sms, ArrowDropUp, ArrowDropDown, Search, Update, FiberManualRecord, MoreVert, RateReview, SwapHorizontalCircle, ColorLens, Timer, KeyboardArrowUp, KeyboardArrowDown, Dns, CloudDownload, LiveHelp, Create, AddComment, Flip, FilterNone, VisibilityOffOutlined, Phone, Email } from '@material-ui/icons';
import cx from 'classnames';
import { get, isEmpty as isEmpty$1, union } from 'lodash';
import Merge from 'mdi-react/CheckboxBlankIcon';
import imagePlaceholder from '@mvp/mvp-react/dist/a63bc877a4d4153d.png';
import { Alert, Autocomplete } from '@material-ui/lab';
import FontIcon from '@mvp/mvp-react/dist/ce7a26f4be0448a4.png';
import ImageIcon from '@mvp/mvp-react/dist/1e281ca6e5b92ac4.png';
import AIIcon from '@mvp/mvp-react/dist/d099f59727e98c21.png';
import { createPortal } from 'react-dom';
import isEmpty from 'lodash/isEmpty';
import { Polygon, Marker as Marker$1, withGoogleMap, GoogleMap as GoogleMap$1 } from 'react-google-maps';
import getCenter from '@turf/center';
import { multiPolygon, featureCollection } from '@turf/helpers';
import Src4x6Handout from '@mvp/mvp-react/dist/d11c403adc5b8b73.png';
import SrcPrintKits from '@mvp/mvp-react/dist/3e155a4da686d184.png';
import SrcLogoRedesign from '@mvp/mvp-react/dist/477586bad8b3db7d.png';
import designInProgress from '@mvp/mvp-react/dist/822aae179a9ac336.png';
import _get from 'lodash/get';
import formatDate from 'date-fns/format';
import _debounce from 'lodash/debounce';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { makeStyles as makeStyles$1, createStyles, withStyles as withStyles$1 } from '@material-ui/core/styles';
import DesignChecklistIcon from '@mvp/mvp-react/dist/24c3e0b69aa8b4e9.png';
import CopyIcon from '@mvp/mvp-react/dist/515ec4e9e51c911e.png';
import ApproveIcon from '@mvp/mvp-react/dist/34f0082c2629a204.png';
import RejectedIcon from '@mvp/mvp-react/dist/313005b6b8c40aea.png';
import moment from 'moment';
import _isNil from 'lodash/isNil';
import compareDatesAsc from 'date-fns/compareAsc';
import { v4 } from 'uuid';
import imgViewerPlaceholder from '@mvp/mvp-react/dist/ed6448d2e49899cc.png';
import Popover from '@material-ui/core/Popover';
import { Waypoint } from 'react-waypoint';
import Skeleton from '@material-ui/lab/Skeleton';
import Flickity from 'react-flickity-component';
var AnimatedPaper = animated(Paper);

var Rotate = function Rotate(_ref) {
  var enabledProp = _ref.enabled,
      children = _ref.children;
  var containerRef = useRef(null);

  var _useState = useState(enabledProp),
      _useState2 = _slicedToArray(_useState, 2),
      enabled = _useState2[0],
      setEnabled = _useState2[1];

  useEffect(function () {
    if (!enabledProp && containerRef.current !== null) {
      var container = containerRef.current;

      var disableAnimation = function disableAnimation() {
        setEnabled(false);
      };

      container.addEventListener('animationiteration', disableAnimation);
      return function () {
        container.removeEventListener('animationiteration', disableAnimation);
      };
    } else {
      setEnabled(true);
    }
  }, [enabledProp]);
  return React.createElement(RotateContainer, {
    ref: containerRef,
    enabled: enabled
  }, children);
};

var RotateContainer = styled.div(_templateObject(), function (props) {
  return props.enabled ? css(_templateObject2(), RotateAnimation) : 'unset';
});
var RotateAnimation = keyframes(_templateObject3());
var Workflow;

(function (Workflow) {
  Workflow["Request"] = "Request";
  Workflow["Review"] = "Review";
  Workflow["Submit"] = "Submit";
})(Workflow || (Workflow = {}));

var CardFace;

(function (CardFace) {
  CardFace["Front"] = "Front";
  CardFace["Back"] = "Back";
})(CardFace || (CardFace = {}));

var DesignSide;

(function (DesignSide) {
  DesignSide["Front"] = "Front";
  DesignSide["Back"] = "Back";
})(DesignSide || (DesignSide = {}));

var TaskType;

(function (TaskType) {
  TaskType["DesignConcept"] = "Design Concept";
  TaskType["DesignRevision"] = "Design Revision";
  TaskType["DesignReview"] = "Design Review";
  TaskType["NumberSwap"] = "Number Swap";
})(TaskType || (TaskType = {}));

var MediaType;

(function (MediaType) {
  MediaType["Brochure8Pt5x11"] = "Brochure 8.5x11";
  MediaType["Logo"] = "Logo";
  MediaType["Postcard4x6"] = "Postcard 4x6";
  MediaType["Postcard6x11"] = "Postcard 6x11";
  MediaType["Poster11x17"] = "Poster 11x17";
  MediaType["Trifold5x9"] = "Trifold 5x9";
})(MediaType || (MediaType = {}));

var DesignStatus;

(function (DesignStatus) {
  DesignStatus["InitialReview"] = "Initial Review";
  DesignStatus["DesignPeerReview"] = "Design Peer Review";
  DesignStatus["MarketingReview"] = "Marketing Review";
  DesignStatus["Proofread"] = "Proofread";
  DesignStatus["CustomerReview"] = "Customer Review";
  DesignStatus["FinalInspection"] = "Final Inspection";
  DesignStatus["Approved"] = "Approved";
})(DesignStatus || (DesignStatus = {}));

var getFollowingReviewFromNextReview = function getFollowingReviewFromNextReview(nextReview) {
  var sequence = [DesignStatus.InitialReview, DesignStatus.DesignPeerReview, DesignStatus.Proofread, DesignStatus.MarketingReview, DesignStatus.CustomerReview, DesignStatus.FinalInspection, DesignStatus.Approved];
  var index = sequence.findIndex(function (s) {
    return s === nextReview;
  });

  if (index < sequence.length - 1) {
    return sequence[index + 1];
  }

  return nextReview;
};

var Design =
/*#__PURE__*/
function () {
  function Design(args) {
    _classCallCheck(this, Design);

    this.id = args.id;
    this.accountId = args.accountId;
    this.name = args.name;
    this.folder = args.folder;
    this.nextReview = args.nextReview;
    this.mediaType = args.mediaType;
    this.campaignId = args.campaignId;
    this.campaign = args.campaign;
    this.versionCount = args.versionCount;
    this.currentVersionId = args.currentVersionId;
    this.firstVersionStartedTimestamp = args.firstVersionStartedTimestamp;
    Object.assign(this, args);
  }

  _createClass(Design, null, [{
    key: "fromSalesforce",
    value: function fromSalesforce(sfObj) {
      var baseObj;
      Object.entries(Design.sfKeys).forEach(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            objKey = _ref3[0],
            sfKey = _ref3[1];

        baseObj[objKey] = sfObj[sfKey];
      });
      return baseObj;
    }
  }]);

  return Design;
}();

Design.sfKeys = {
  id: 'Id',
  accountId: 'Account__r.Id',
  name: 'Name',
  folder: 'Folder__c',
  mediaType: 'Media_Type__c',
  campaignId: 'MVP_Campaign__r.Id',
  startingPointId: 'Starting_Point__r.Id',
  versionCount: 'Version_Count__c',
  approvedVersionSubmittedTimestamp: 'Approved_Version_Submitted__c',
  conceptDesignerId: 'Concept_Designer__r.Id',
  firstVersionStartedTimestamp: 'First_Version_Started__c',
  firstVersionSubmittedTimestamp: 'First_Version_Submitted__c',
  designPeerReviewCompletedTimestamp: 'Design_Peer_Review_Completed__c',
  designPeerReviewVersionId: 'Design_Peer_Review_Version__r.Id',
  designPeerReviewerId: 'Design_Peer_Reviewer__r.Id',
  proofreadCompletedTimestamp: 'Proofread_Completed__c',
  proofreadVersionId: 'Proofread_Version__r.Id',
  proofreaderId: 'Proofread_Version__r.Id',
  marketingReviewCompletedTimestamp: 'Marketing_Review_Completed__c',
  marketingReviewVersionId: 'Marketing_Review_Version__r.Id',
  marketingReviewerId: 'Marketing_Reviewer__r.Id',
  customerReviewCompletedTimestamp: 'Customer_Review_Completed__c',
  customerReviewVersionId: 'Customer_Review_Version__r.Id',
  customerReviewerId: 'Customer_Reviewer__r.Id',
  finalInspectionCompletedTimestamp: 'Final_Inspection_Completed__c',
  finalInspectionVersionId: 'Final_Inspection_Version__r.Id',
  finalReviewerId: 'Final_Reviewer__r.Id'
};
var DesignTaskType;

(function (DesignTaskType) {
  DesignTaskType["Concept"] = "Concept";
  DesignTaskType["NumberSwap"] = "Number Swap";
  DesignTaskType["Revision"] = "Revision";
})(DesignTaskType || (DesignTaskType = {}));

var DesignVersionStatus;

(function (DesignVersionStatus) {
  DesignVersionStatus["Requested"] = "Requested";
  DesignVersionStatus["Wip"] = "WIP";
  DesignVersionStatus["InReview"] = "In Review";
  DesignVersionStatus["Approved"] = "Approved";
  DesignVersionStatus["Rejected"] = "Rejected";
})(DesignVersionStatus || (DesignVersionStatus = {}));

var DesignVersion = function DesignVersion(args) {
  _classCallCheck(this, DesignVersion);

  this.version = args.version;
  this.designId = args.designId;
  this.taskType = args.taskType;
  this.status = args.status;
  this.file = args.file;
  this.folder = args.folder;
  this.workHours = args.workHours;
  this.designerId = args.designerId;
  Object.assign(this, args);
};

var ReviewCommentStatus;

(function (ReviewCommentStatus) {
  ReviewCommentStatus["Draft"] = "Draft";
  ReviewCommentStatus["Requested"] = "Requested";
  ReviewCommentStatus["InReview"] = "In Review";
  ReviewCommentStatus["Accepted"] = "Accepted";
  ReviewCommentStatus["Rejected"] = "Rejected";
})(ReviewCommentStatus || (ReviewCommentStatus = {}));

var ReviewComment = function ReviewComment(args) {
  _classCallCheck(this, ReviewComment);

  var _a, _b;

  this.id = args.id;
  this.createdById = args.createdById;
  this.createdDate = args.createdDate;
  this.side = args.side;
  this.status = args.status;
  this.ownerId = args.ownerId;
  this.authorId = args.authorId;
  this.reviewerId = args.reviewerId;
  this.x = (_a = args.x) !== null && _a !== void 0 ? _a : null;
  this.y = (_b = args.y) !== null && _b !== void 0 ? _b : null;
  this.body = args.body;
  Object.assign(this, args);
};

var ActionType;

(function (ActionType) {
  ActionType["peerReview"] = "peerReview";
  ActionType["startTask"] = "startTask";
})(ActionType || (ActionType = {}));

var Status;

(function (Status) {
  Status["pending"] = "Pending";
  Status["completed"] = "Completed";
})(Status || (Status = {}));

var TaskQueueModel = function TaskQueueModel(args) {
  _classCallCheck(this, TaskQueueModel);

  this.id = args.id;
  this.inReview = args.inReview;
  this.name = args.name;
  this.taskType = args.taskType;
  this.requestedDate = args.requestedDate;
  this.dueDate = args.dueDate;
  this.assigned = args.assigned;
  this.progress = args.progress;
};

var CampaignDesignStatus;

(function (CampaignDesignStatus) {
  CampaignDesignStatus["NoLinkedDesign"] = "No linked design";
  CampaignDesignStatus["DesignPending"] = "Design pending";
  CampaignDesignStatus["DesignInProgress"] = "Design in progress";
  CampaignDesignStatus["NeedsFinalApproval"] = "Needs final approval";
  CampaignDesignStatus["PreApproved"] = "Pre-approved";
  CampaignDesignStatus["Requested"] = "Requested";
  CampaignDesignStatus["WIP"] = "WIP";
  CampaignDesignStatus["ReadyForPrePress"] = "Ready for pre-press";
  CampaignDesignStatus["ReadyForFinalApproval"] = "Ready for final approval";
  CampaignDesignStatus["MediaReady"] = "Media ready";
  CampaignDesignStatus["InUse"] = "In use";
  CampaignDesignStatus["SentToDesigner"] = "Sent to designer";
  CampaignDesignStatus["SentToPrinter"] = "Sent to printer";
  CampaignDesignStatus["PdfReady"] = "PDF ready";
  CampaignDesignStatus["Approved"] = "Approved";
  CampaignDesignStatus["Rejected"] = "Rejected ";
  CampaignDesignStatus["Pending"] = "Pending";
})(CampaignDesignStatus || (CampaignDesignStatus = {}));

var CampaignReviewType;

(function (CampaignReviewType) {
  CampaignReviewType["PrePressReview"] = "Pre-press Review";
  CampaignReviewType["FinalApproval"] = "Final Approval";
  CampaignReviewType["Approved"] = "Approved";
})(CampaignReviewType || (CampaignReviewType = {}));

var CampaignMediaStatus;

(function (CampaignMediaStatus) {
  CampaignMediaStatus["NumberSwapRejected"] = "Number Swap Rejected";
})(CampaignMediaStatus || (CampaignMediaStatus = {}));

var DesignType;

(function (DesignType) {
  DesignType["initialDesign"] = "Initial Design";
  DesignType["newDesign"] = "New Design";
  DesignType["numberSwap"] = "Number Swap";
  DesignType["revisions"] = "Revisions";
  DesignType["printOnly"] = "Print Only";
  DesignType["customerProvided"] = "Customer Provided";
})(DesignType || (DesignType = {}));

var CampaignMediaModalType;

(function (CampaignMediaModalType) {
  CampaignMediaModalType["DesignInProgress"] = "Design In Progress";
  CampaignMediaModalType["NumberSwapInProgress"] = "Number Swap In Progress";
  CampaignMediaModalType["WaitingForNumberSwapRequest"] = "Waiting For Number Swap Request";
})(CampaignMediaModalType || (CampaignMediaModalType = {}));

var CommentStatus;

(function (CommentStatus) {
  CommentStatus["Accepted"] = "Accepted";
  CommentStatus["Rejected"] = "Rejected";
  CommentStatus["Pending"] = "Pending";
})(CommentStatus || (CommentStatus = {}));

var getDimensionFactorsByMediaType = function getDimensionFactorsByMediaType(m) {
  if (m === MediaType.Postcard6x11) {
    return {
      heightFactor: 6,
      widthFactor: 11
    };
  }

  if (m === MediaType.Postcard4x6) {
    return {
      heightFactor: 4,
      widthFactor: 6
    };
  }

  if (m === MediaType.Trifold5x9) {
    return {
      heightFactor: 5,
      widthFactor: 9
    };
  }

  return {
    heightFactor: 6,
    widthFactor: 11
  };
};

var convertReviewCommentToCommentMarker = function convertReviewCommentToCommentMarker(r) {
  var status = CommentStatus.Pending;

  if (r.status === ReviewCommentStatus.Accepted) {
    status = CommentStatus.Accepted;
  }

  if (r.status === ReviewCommentStatus.Rejected) {
    status = CommentStatus.Rejected;
  }

  return {
    id: r.id,
    cardFace: r.side === DesignSide.Front ? CardFace.Front : CardFace.Back,
    x: r.x,
    y: r.y,
    status: status,
    dateOriginallyPosted: r.createdDate,
    messages: [convertReviewCommentToCommentMarkerMessage(r)]
  };
};

var convertReviewCommentToCommentMarkerMessage = function convertReviewCommentToCommentMarkerMessage(r) {
  return {
    id: r.id,
    postedBy: r.author.name,
    message: r.body,
    datePosted: r.createdDate
  };
};

var useImageDimensions = function useImageDimensions(_ref4) {
  var imgUrl = _ref4.imgUrl;

  var _useState3 = useState([0, 0]),
      _useState4 = _slicedToArray(_useState3, 2),
      imageDimensions = _useState4[0],
      setImageDimensions = _useState4[1];

  useEffect(function () {
    if (typeof imgUrl !== 'undefined') {
      var imageEl = new Image();

      var loadHandler = function loadHandler() {
        setImageDimensions([imageEl.width, imageEl.height]);
      };

      imageEl.src = imgUrl;
      imageEl.onload = loadHandler;
      return function () {
        imageEl.onload = null;
      };
    }
  }, [imgUrl]);
  return {
    imageDimensions: imageDimensions
  };
};

var DOUBLE_CLICK_THRESHOLD_MS = 220;

var useImageViewer = function useImageViewer(_ref5) {
  var onClickImageArgs = _ref5.onClickImageArgs,
      _ref5$initialCardFace = _ref5.initialCardFace,
      initialCardFace = _ref5$initialCardFace === void 0 ? CardFace.Front : _ref5$initialCardFace,
      _ref5$onChangeCardFac = _ref5.onChangeCardFace,
      onChangeCardFace = _ref5$onChangeCardFac === void 0 ? function () {} : _ref5$onChangeCardFac,
      _ref5$onZoomUpdate = _ref5.onZoomUpdate,
      onZoomUpdate = _ref5$onZoomUpdate === void 0 ? function () {} : _ref5$onZoomUpdate;

  var _useState5 = useState({
    scale: 1.0,
    translateX: 0,
    translateY: 0
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      defaultTransform = _useState6[0],
      setDefaultTransform = _useState6[1];

  var minZoom = defaultTransform.scale / 2;
  var maxZoom = defaultTransform.scale * 4;
  var zoomStepScale = minZoom;

  var _useSpring = useSpring(function () {
    return _objectSpread({}, defaultTransform);
  }),
      _useSpring2 = _slicedToArray(_useSpring, 2),
      _useSpring2$ = _useSpring2[0],
      scale = _useSpring2$.scale,
      translateX = _useSpring2$.translateX,
      translateY = _useSpring2$.translateY,
      setSpring = _useSpring2[1];

  var imgElRef = useRef(null);

  var setDefaultZoom = function setDefaultZoom(containerScale, offsetX, offsetY) {
    setDefaultTransform({
      scale: containerScale,
      translateX: offsetX,
      translateY: offsetY
    });
    setSpring({
      scale: containerScale,
      translateX: offsetX,
      translateY: offsetY
    });
  };

  var _useState7 = useState(initialCardFace),
      _useState8 = _slicedToArray(_useState7, 2),
      cardFace = _useState8[0],
      setCardFaceBase = _useState8[1];

  var _useState9 = useState(true),
      _useState10 = _slicedToArray(_useState9, 2),
      isInteractive = _useState10[0],
      setIsInteractive = _useState10[1];

  var isDragging = useRef(false);
  var singleClickTimeout = useRef(null);

  var resetZoom = function resetZoom(sv) {
    var _a, _b, _c, _d;

    setSpring({
      to: {
        scale: (_a = sv === null || sv === void 0 ? void 0 : sv.s) !== null && _a !== void 0 ? _a : defaultTransform.scale,
        translateX: (_b = sv === null || sv === void 0 ? void 0 : sv.x) !== null && _b !== void 0 ? _b : defaultTransform.translateX,
        translateY: (_c = sv === null || sv === void 0 ? void 0 : sv.y) !== null && _c !== void 0 ? _c : defaultTransform.translateY
      }
    });
    onZoomUpdate((_d = sv === null || sv === void 0 ? void 0 : sv.s) !== null && _d !== void 0 ? _d : defaultTransform.scale);
  };

  var setCardFace = function setCardFace(c, args) {
    if (c === cardFace) {
      return;
    }

    setCardFaceBase(c);
    resetZoom();

    if (args === null || args === void 0 ? void 0 : args.skipCallback) {
      return;
    }

    onChangeCardFace(c);
  };

  var adjustZoomAndAutoCenter = function adjustZoomAndAutoCenter(newScaleValue, previousScaleValue) {
    var newValues = {
      scale: newScaleValue
    };

    if (newScaleValue <= defaultTransform.scale) {
      newValues.translateX = defaultTransform.translateX;
      newValues.translateY = defaultTransform.translateY;
    } else if (newScaleValue < previousScaleValue) {
      var translateFactor = previousScaleValue - newScaleValue;
      var currentTranslateX = translateX.get();
      var currentTranslateY = translateY.get();
      var deltaX = (currentTranslateX - defaultTransform.translateX) * translateFactor;
      var deltaY = (currentTranslateY - defaultTransform.translateY) * translateFactor;
      newValues.translateX = currentTranslateX - deltaX;
      newValues.translateY = currentTranslateY - deltaY;
    }

    setSpring(newValues);
    onZoomUpdate(newScaleValue);
  };

  var zoomIn = function zoomIn() {
    var previousScaleValue = scale.get();
    var newScaleValue = limitWithinRange(scale.get() + zoomStepScale, maxZoom, minZoom);
    adjustZoomAndAutoCenter(newScaleValue, previousScaleValue);
  };

  var zoomOut = function zoomOut() {
    var previousScaleValue = scale.get();
    var newScaleValue = limitWithinRange(scale.get() - zoomStepScale, maxZoom, minZoom);
    adjustZoomAndAutoCenter(newScaleValue, previousScaleValue);
  };

  var onClickImage = function onClickImage(e) {
    var _a, _b;

    e.preventDefault();
    e.stopPropagation();
    var bounds = e.currentTarget.getBoundingClientRect();
    var scaledCoordinates = [e.clientX - bounds.left, e.clientY - bounds.top];
    var imgNaturalWidth = ((_a = imgElRef.current) === null || _a === void 0 ? void 0 : _a.naturalWidth) || 0;
    var imgNaturalHeight = ((_b = imgElRef.current) === null || _b === void 0 ? void 0 : _b.naturalHeight) || 0;
    var percentageCoordinates = [scaledCoordinates[0] / scale.get() / imgNaturalWidth * 100, scaledCoordinates[1] / scale.get() / imgNaturalHeight * 100];

    if (typeof onClickImageArgs !== 'undefined') {
      onClickImageArgs(cardFace, percentageCoordinates[0], percentageCoordinates[1], e.clientX, e.clientY);
    }
  };

  var setSingleClickTimeout = function setSingleClickTimeout(scaledCoordinates, clientX, clientY) {
    var timeout = setTimeout(function () {
      var _a, _b;

      var imgNaturalWidth = ((_a = imgElRef.current) === null || _a === void 0 ? void 0 : _a.naturalWidth) || 0;
      var imgNaturalHeight = ((_b = imgElRef.current) === null || _b === void 0 ? void 0 : _b.naturalHeight) || 0;
      var percentageCoordinates = [scaledCoordinates[0] / scale.get() / imgNaturalWidth * 100, scaledCoordinates[1] / scale.get() / imgNaturalHeight * 100];

      if (typeof onClickImageArgs !== 'undefined') {
        onClickImageArgs(cardFace, percentageCoordinates[0], percentageCoordinates[1], clientX, clientY);
      }

      singleClickTimeout.current = null;
    }, DOUBLE_CLICK_THRESHOLD_MS);
    return timeout;
  };

  var bindGestures = useGesture({
    onClick: function onClick(e) {
      if (isDragging.current) {
        return;
      }

      if (singleClickTimeout.current === null) {
        var bounds = e.currentTarget.getBoundingClientRect();
        var scaledCoordinates = [e.clientX - bounds.left, e.clientY - bounds.top];
        singleClickTimeout.current = setSingleClickTimeout(scaledCoordinates, e.clientX, e.clientY);
      } else {
        clearTimeout(singleClickTimeout.current);
        singleClickTimeout.current = null;
        zoomIn();
      }
    },
    onWheel: function onWheel(_ref6) {
      var distance = _ref6.distance,
          direction = _ref6.direction;
      var y = direction[1];
      var scaleOffset = distance * y * (zoomStepScale * -0.005);
      var previousScaleValue = scale.get();
      var newScaleValue = limitWithinRange(previousScaleValue + scaleOffset, maxZoom, minZoom);
      adjustZoomAndAutoCenter(newScaleValue, previousScaleValue);
    },
    onDragStart: function onDragStart() {},
    onDragEnd: function onDragEnd() {},
    onDrag: function onDrag(_ref7) {
      var movement = _ref7.movement,
          first = _ref7.first,
          last = _ref7.last,
          _ref7$memo = _ref7.memo,
          memo = _ref7$memo === void 0 ? [translateX.get(), translateY.get()] : _ref7$memo;

      if (first) {
        isDragging.current = true;
      } else if (last) {
        requestAnimationFrame(function () {
          isDragging.current = false;
        });
      }

      if (scale.get() <= defaultTransform.scale) {
        return;
      }

      var newTranslateX = memo[0] + movement[0];
      var newTranslateY = memo[1] + movement[1];
      setSpring({
        translateX: newTranslateX,
        translateY: newTranslateY
      });

      if (first) {
        return [newTranslateX, newTranslateY];
      }

      return memo;
    }
  }, {
    drag: {
      filterTaps: true,
      delay: 300
    }
  });

  var _useSpring3 = useSpring({
    onStart: function onStart() {
      setIsInteractive(false);
    },
    onRest: function onRest() {
      setIsInteractive(true);
    },
    opacity: cardFace === CardFace.Front ? 1 : 0,
    transform: "rotateY(".concat(cardFace === CardFace.Front ? 0 : 180, "deg)"),
    config: {
      duration: 300
    }
  }),
      transform = _useSpring3.transform,
      opacity = _useSpring3.opacity;

  return {
    zoomIn: zoomIn,
    zoomOut: zoomOut,
    resetZoom: resetZoom,
    bindGestures: bindGestures,
    transform: transform,
    opacity: opacity,
    cardFace: cardFace,
    setCardFace: setCardFace,
    onClickImage: onClickImage,
    isInteractive: isInteractive,
    setDefaultZoom: setDefaultZoom,
    imgElRef: imgElRef,
    scale: scale,
    translateX: translateX,
    translateY: translateY
  };
};

var limitWithinRange = function limitWithinRange(given, max, min) {
  return Math.min(max, Math.max(given, min));
};

var useMeasure = function useMeasure() {
  var ref = useRef(undefined);

  var _useState11 = useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    left: 0,
    top: 0,
    right: 0,
    bottom: 0
  }),
      _useState12 = _slicedToArray(_useState11, 2),
      bounds = _useState12[0],
      setBounds = _useState12[1];

  var _useState13 = useState(function () {
    return new ResizeObserver(function (_ref8) {
      var _ref9 = _slicedToArray(_ref8, 1),
          entry = _ref9[0];

      return setBounds(entry.contentRect);
    });
  }),
      _useState14 = _slicedToArray(_useState13, 1),
      resizeObserver = _useState14[0];

  useEffect(function () {
    if (ref.current) {
      resizeObserver.observe(ref.current);
    }

    return function () {
      resizeObserver.disconnect();
    };
  }, [resizeObserver]);
  return [ref, bounds];
};

var useWindowMeasure = function useWindowMeasure() {
  var _useState15 = useState({
    width: window.innerWidth,
    height: window.innerHeight
  }),
      _useState16 = _slicedToArray(_useState15, 2),
      measure = _useState16[0],
      setMeasure = _useState16[1];

  useEffect(function () {
    var handleResize = function handleResize() {
      setMeasure({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return measure;
};

var useEscape = function useEscape(onEscape) {
  useEffect(function () {
    var handleEsc = function handleEsc(event) {
      if (event.code === 'Escape') {
        onEscape();
      }
    };

    window.addEventListener('keydown', handleEsc);
    return function () {
      window.removeEventListener('keydown', handleEsc);
    };
  });
};

var getNextValue = function getNextValue(current, next) {
  if (typeof next === 'function') {
    next = next;
    return next(current);
  }

  return next;
};

var setProducedState = function setProducedState(setState, draftFn) {
  setState(function (state) {
    return produce(state, draftFn);
  });
};

var useResizeHandlers = function useResizeHandlers(_ref10) {
  var setDefaultZoom = _ref10.setDefaultZoom,
      imgElRef = _ref10.imgElRef,
      _ref10$dependencies = _ref10.dependencies,
      dependencies = _ref10$dependencies === void 0 ? [] : _ref10$dependencies,
      _ref10$offsetGenerato = _ref10.offsetGenerator,
      offsetGenerator = _ref10$offsetGenerato === void 0 ? function () {
    return {
      offsetX: 0,
      sidebarOffset: 0
    };
  } : _ref10$offsetGenerato,
      _ref10$isWide = _ref10.isWide,
      isWide = _ref10$isWide === void 0 ? true : _ref10$isWide;

  var _useMeasure = useMeasure(),
      _useMeasure2 = _slicedToArray(_useMeasure, 2),
      viewingAreaRef = _useMeasure2[0],
      viewAreaMeasure = _useMeasure2[1];

  var _useMeasure3 = useMeasure(),
      _useMeasure4 = _slicedToArray(_useMeasure3, 2),
      controlAreaRef = _useMeasure4[0],
      controlAreaMeasure = _useMeasure4[1];

  var _useMeasure5 = useMeasure(),
      _useMeasure6 = _slicedToArray(_useMeasure5, 2),
      sidebarAreaRef = _useMeasure6[0],
      sidebarAreaMeasure = _useMeasure6[1];

  var _useMeasure7 = useMeasure(),
      _useMeasure8 = _slicedToArray(_useMeasure7, 2),
      sidebarViewingAreaRef = _useMeasure8[0],
      sidebarViewingAreaMeasure = _useMeasure8[1];

  var floorWidth = Math.floor(viewAreaMeasure.width * 0.1);
  var floorSidebarWidth = Math.floor(sidebarAreaMeasure.width * 0.1);

  var _useState17 = useState(sidebarAreaMeasure.width / 2 * -1),
      _useState18 = _slicedToArray(_useState17, 2),
      sidebarOffset = _useState18[0],
      setSidebarOffset = _useState18[1];

  var autoAdjustZoomAndOffset = function autoAdjustZoomAndOffset(h, w) {
    var _a, _b, _c, _d, _e, _f;

    var hasRefMeasure = imgElRef.current && imgElRef.current.naturalHeight;

    if ((hasRefMeasure || h) && viewingAreaRef.current.clientHeight) {
      var imageHeight = (_b = (_a = imgElRef.current) === null || _a === void 0 ? void 0 : _a.naturalHeight) !== null && _b !== void 0 ? _b : h;
      var imageWidth = (_d = (_c = imgElRef.current) === null || _c === void 0 ? void 0 : _c.naturalWidth) !== null && _d !== void 0 ? _d : w;
      var newScale = viewingAreaRef.current.clientHeight / (imageHeight + 72);
      var newWidth = imageWidth * newScale;

      if (newWidth + 28 > viewingAreaRef.current.clientWidth) {
        newScale = viewingAreaRef.current.clientWidth / (imageWidth + 52);
      }

      var _offsetGenerator = offsetGenerator((_f = (_e = sidebarAreaRef.current) === null || _e === void 0 ? void 0 : _e.clientWidth) !== null && _f !== void 0 ? _f : 0),
          newOffsetX = _offsetGenerator.offsetX,
          newSidebarOffset = _offsetGenerator.sidebarOffset;

      var newOffsetY = (viewingAreaRef.current.clientHeight + controlAreaRef.current.clientHeight) / 2 - (window.innerHeight - 12) / 2;
      setDefaultZoom(newScale, newOffsetX, newOffsetY);
      setSidebarOffset(newSidebarOffset);
      return {
        s: newScale,
        x: newOffsetX,
        y: newOffsetY
      };
    }
  };

  useLayoutEffect(function () {
    autoAdjustZoomAndOffset(); // TODO: Figure out a way to silence this eslint warning without causing a re-render on every action
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [floorWidth, floorSidebarWidth, viewAreaMeasure.height, controlAreaMeasure.height].concat(_toConsumableArray(dependencies)));

  var _useSpring4 = useSpring({
    width: isWide ? 0 : 2
  }),
      width = _useSpring4.width;

  return {
    viewingAreaRef: viewingAreaRef,
    viewAreaMeasure: viewAreaMeasure,
    controlAreaRef: controlAreaRef,
    controlAreaMeasure: controlAreaMeasure,
    sidebarAreaRef: sidebarAreaRef,
    sidebarOffset: sidebarOffset,
    sidebarViewingAreaRef: sidebarViewingAreaRef,
    sidebarViewingAreaMeasure: sidebarViewingAreaMeasure,
    width: width,
    autoAdjustZoomAndOffset: autoAdjustZoomAndOffset
  };
};

var CheckedBadge = function CheckedBadge(_ref11) {
  var scale = _ref11.scale,
      style = _ref11.style,
      onClick = _ref11.onClick,
      onMouseOver = _ref11.onMouseOver;
  return React.createElement(CheckedBadgeContainer, {
    onClick: onClick,
    onMouseOver: onMouseOver,
    style: _objectSpread({
      transform: scale === null || scale === void 0 ? void 0 : scale.to(function (s) {
        return "scale(".concat(1.0 / s, ")");
      })
    }, style)
  }, React.createElement(Done, {
    style: {
      color: 'white'
    }
  }));
};

var CheckedBadgeContainer = styled(animated.div)(_templateObject4());

var NumberedBadge = function NumberedBadge(_ref12) {
  var value = _ref12.value,
      active = _ref12.active,
      scale = _ref12.scale;

  var _useSpring5 = useSpring({
    backgroundColor: active ? '#ed154e' : 'grey'
  }),
      backgroundColor = _useSpring5.backgroundColor;

  return React.createElement(animated.div, {
    style: {
      width: '30px',
      height: '30px',
      borderRadius: '50%',
      border: '2px solid white',
      backgroundColor: backgroundColor,
      color: 'white',
      fontWeight: 'bold',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      transform: scale === null || scale === void 0 ? void 0 : scale.to(function (s) {
        return "scale(".concat(1.0 / s, ")");
      })
    }
  }, value);
};

var PlainNumberedBadge = function PlainNumberedBadge(_ref13) {
  var value = _ref13.value,
      active = _ref13.active,
      x = _ref13.x,
      y = _ref13.y,
      style = _ref13.style,
      onClick = _ref13.onClick,
      onMouseOver = _ref13.onMouseOver;
  return React.createElement(PlainNumberedBadgeContainer, {
    onClick: onClick,
    onMouseOver: onMouseOver,
    style: _objectSpread({
      left: x,
      top: y,
      backgroundColor: active ? '#ed154e' : '#929292'
    }, style)
  }, React.createElement("span", {
    style: {
      pointerEvents: 'none',
      fontSize: '1rem',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, value));
};

var PlainNumberedBadgeContainer = styled(animated.div)(_templateObject5());

var RejectedBadge = function RejectedBadge(_ref14) {
  var scale = _ref14.scale,
      style = _ref14.style,
      onClick = _ref14.onClick,
      onMouseOver = _ref14.onMouseOver,
      onMouseOut = _ref14.onMouseOut;
  return React.createElement(RejectedBadgeContainer, {
    onClick: onClick,
    onMouseOver: onMouseOver,
    onMouseOut: onMouseOut,
    style: _objectSpread({
      transform: scale === null || scale === void 0 ? void 0 : scale.to(function (s) {
        return "scale(".concat(1.0 / s, ")");
      })
    }, style)
  }, React.createElement(Clear, null));
};

var RejectedBadgeContainer = styled(animated.div)(_templateObject6());
var Colors;

(function (Colors) {
  Colors["MVP_GREEN"] = "#0d951b";
  Colors["MVP_GOLD"] = "#efc75e";
  Colors["MVP_RED"] = "#f50d0d";
  Colors["MVP_LIGHT_PINK"] = "#ed154e";
  Colors["MVP_LIGHT_PINK_SEMI_TRANSPARENT"] = "rgba(237, 21, 78, 30)";
  Colors["MVP_DARK_PINK"] = "#b7003d";
  Colors["MVP_LIGHT_GREY"] = "#d3d3d3";
  Colors["MVP_MEDIUM_GREY"] = "#727272";
  Colors["MVP_DARK_GREY"] = "#232323";
  Colors["MVP_BLACK"] = "#141414";
  Colors["MVP_GREY_0"] = "#141414";
  Colors["MVP_GREY_1"] = "#232323";
  Colors["MVP_GREY_2"] = "#666666";
  Colors["MVP_GREY_3"] = "#d3d3d3";
  Colors["MVP_GREY_4"] = "#e4e4e4";
  Colors["MVP_GREY_5"] = "#f3f3f3";
  Colors["MVP_GREY_TONE_0"] = "rgba(0, 0, 0, 235)";
  Colors["MVP_GREY_TONE_1"] = "rgba(0, 0, 0, 219)";
  Colors["MVP_GREY_TONE_2"] = "rgba(0, 0, 0, 153)";
  Colors["MVP_GREY_TONE_3"] = "rgba(0, 0, 0, 43)";
  Colors["MVP_GREY_TONE_4"] = "rgba(0, 0, 0, 28)";
  Colors["MVP_GREY_TONE_5"] = "rgba(0, 0, 0, 5)";
  Colors["MVP_GREEN_0"] = "#087700";
})(Colors || (Colors = {}));

var theme = createTheme({
  palette: {
    primary: {
      main: '#ed154e'
    }
  },
  overrides: {
    MuiButton: {
      text: {
        fontWeight: 'normal',
        color: '#F9F9F9',
        textTransform: 'uppercase'
      },
      contained: {
        color: '#fff',
        fontSize: '1.2rem',
        padding: '.75rem 1.75rem',
        boxShadow: 'none',
        fontWeight: 'normal'
      },
      outlined: {
        color: '#ed154e',
        border: '1px solid #ed154e',
        fontSize: '1.2rem',
        padding: '.75rem 1.75rem',
        boxShadow: 'none'
      },
      textSecondary: {
        fontSize: '.9rem'
      }
    },
    MuiDialogContent: {
      root: {
        maxWidth: '600px',
        padding: '1.2rem 1.8rem'
      }
    }
  },
  typography: {
    fontFamily: ['Roboto Condensed', 'sans-serif'].join(', ')
  }
});

var ThemeProvider = function ThemeProvider(props) {
  return React.createElement(ThemeProvider$1, {
    theme: theme
  }, React.createElement(CssBaseline, null), props.children);
};

var useImageViewerStyles = makeStyles({
  boundsContainer: {
    height: '100%',
    width: '100%',
    overflow: 'hidden'
  },
  centerContainer: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative'
  },
  image: {
    width: 'auto',
    '&:active': {
      cursor: 'grabbing'
    }
  },
  imageWithPin: {
    cursor: "url(/pushpin.svg) 2 32, move"
  },
  imageWithNoPin: {
    cursor: 'move'
  }
});
var useImageViewerControlsStyles = makeStyles({
  container: {
    backgroundColor: 'rgba(43, 43, 43, 0.8)',
    maxWidth: '144px',
    borderRadius: '4px',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '8px'
  }
});
var useBottomOverlayStyles = makeStyles({
  bottomOverlayContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '1em',
    backgroundColor: "rgba(50, 50, 50, 0.5)"
  },
  thumbnail: {
    boxSizing: 'content-box',
    maxHeight: '100px'
  }
});

var BottomOverlay = function BottomOverlay(_ref15) {
  var elements = _ref15.elements,
      children = _ref15.children,
      props = _objectWithoutProperties(_ref15, ["elements", "children"]);

  var _a;

  var classes = useBottomOverlayStyles();
  var numElements = elements.length;
  var selectedIndex = (_a = props.selectedIndex) !== null && _a !== void 0 ? _a : 0;

  var _useMeasure9 = useMeasure(),
      _useMeasure10 = _slicedToArray(_useMeasure9, 2),
      measureRef = _useMeasure10[0],
      _useMeasure10$ = _useMeasure10[1],
      width = _useMeasure10$.width,
      height = _useMeasure10$.height;

  var _useSpring6 = useSpring({
    gap: selectedIndex,
    distance: Math.floor(width * selectedIndex),
    config: {
      mass: 0.5,
      tension: 300,
      friction: 22
    }
  }),
      gap = _useSpring6.gap,
      distance = _useSpring6.distance;

  return React.createElement("div", {
    className: classes.bottomOverlayContainer,
    style: {
      position: 'relative',
      display: 'grid',
      gridTemplate: "auto / repeat(".concat(numElements, ", auto) 1fr auto"),
      gridColumnGap: '1rem',
      overflowY: 'hidden'
    }
  }, typeof props.selectedIndex === 'number' ? React.createElement(animated.div, {
    style: {
      zIndex: 1,
      width: width + 2,
      height: height,
      position: 'absolute',
      top: '0.88rem',
      left: '0.82rem',
      border: "4px solid ".concat(Colors.MVP_LIGHT_PINK),
      pointerEvents: 'none',
      transform: to([distance, gap], function (d, g) {
        return "translateX(calc(".concat(d, "px + ").concat(g, "rem))");
      })
    }
  }) : null, elements.map(function (el, i) {
    var gridArea = "1 / ".concat(i + 1, " / 2 / ").concat(i + 2);
    return React.createElement(Fragment, {
      key: i
    }, React.createElement("div", {
      ref: i === 0 ? measureRef : undefined,
      style: {
        gridArea: gridArea,
        cursor: 'pointer'
      }
    }, el.main), typeof el.overlay !== 'undefined' ? React.createElement("div", {
      style: {
        gridArea: gridArea,
        cursor: 'pointer',
        pointerEvents: 'none',
        zIndex: 2,
        width: '100%',
        height: '6.25rem'
      }
    }, el.overlay) : null);
  }), React.createElement("div", {
    style: {
      gridArea: '1 / -1 / 2 / -2'
    }
  }, children));
};

var useImageLoader = function useImageLoader(_ref16) {
  var src = _ref16.src,
      _ref16$onLoad = _ref16.onLoad,
      onLoad = _ref16$onLoad === void 0 ? function (h, w) {} : _ref16$onLoad,
      _ref16$onError = _ref16.onError,
      onError = _ref16$onError === void 0 ? function () {} : _ref16$onError;
  var image = new Image();
  image.src = src;

  var _useState19 = useState(image.complete),
      _useState20 = _slicedToArray(_useState19, 2),
      hasLoaded = _useState20[0],
      setHasLoaded = _useState20[1];

  useEffect(function () {
    var onLoadHandler = function onLoadHandler(e) {
      var imgEl = e.target;
      setHasLoaded(true);
      onLoad(imgEl.naturalHeight, imgEl.naturalWidth);
    };

    image.addEventListener('load', onLoadHandler);
    image.addEventListener('error', onError);

    if (!image.complete) {
      setHasLoaded(false);
    }

    return function () {
      image.removeEventListener('load', onLoadHandler);
      image.removeEventListener('error', onError);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [src, image.complete]);
  return {
    hasLoaded: hasLoaded
  };
};

var ImageLoader = forwardRef(function (_ref17, ref) {
  var src = _ref17.src,
      alt = _ref17.alt,
      className = _ref17.className,
      onClick = _ref17.onClick,
      style = _ref17.style,
      imgPlaceholder = _ref17.imgPlaceholder,
      widthRatio = _ref17.widthRatio,
      heightRatio = _ref17.heightRatio,
      visible = _ref17.visible,
      _ref17$onLoad = _ref17.onLoad,
      onLoad = _ref17$onLoad === void 0 ? function () {} : _ref17$onLoad,
      _ref17$onError = _ref17.onError,
      onError = _ref17$onError === void 0 ? function () {} : _ref17$onError;

  var _useImageLoader = useImageLoader({
    src: src,
    onLoad: onLoad,
    onError: onError
  }),
      hasLoaded = _useImageLoader.hasLoaded;

  if (!hasLoaded || visible === false) {
    return imgPlaceholder ? React.createElement(Fragment, null, imgPlaceholder) : React.createElement(DefaultImagePlaceholder, {
      ref: ref,
      style: style,
      widthRatio: widthRatio,
      heightRatio: heightRatio
    });
  } // eslint-disable-next-line jsx-a11y/alt-text


  return React.createElement(Fade, {
    in: hasLoaded,
    mountOnEnter: true
  }, React.createElement("img", {
    ref: ref,
    src: src,
    alt: alt,
    onClick: onClick,
    className: className,
    style: style
  }));
});
var DefaultImagePlaceholder = forwardRef(function (_ref18, imgRef) {
  var style = _ref18.style,
      _ref18$widthRatio = _ref18.widthRatio,
      widthRatio = _ref18$widthRatio === void 0 ? 11 : _ref18$widthRatio,
      _ref18$heightRatio = _ref18.heightRatio,
      heightRatio = _ref18$heightRatio === void 0 ? 6 : _ref18$heightRatio;
  var ref = createRef();

  var _useState21 = useState('100%'),
      _useState22 = _slicedToArray(_useState21, 2),
      height = _useState22[0],
      setHeight = _useState22[1];

  useLayoutEffect(function () {
    var _a, _b;

    if ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.clientWidth) {
      var newHeight = ((_b = ref.current) === null || _b === void 0 ? void 0 : _b.clientWidth) / widthRatio * heightRatio;
      setHeight("".concat(newHeight, "px"));
    }
  }, [ref, widthRatio, heightRatio]);
  return React.createElement("div", {
    ref: ref,
    style: _objectSpread({
      backgroundColor: 'transparent',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: height
    }, style)
  }, React.createElement(CircularProgress, null), React.createElement("img", {
    ref: imgRef,
    alt: "Loading...",
    style: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      visibility: 'hidden'
    }
  }));
});

var PortraitLoader = function PortraitLoader(_ref19) {
  var nameFallback = _ref19.nameFallback,
      props = _objectWithoutProperties(_ref19, ["nameFallback"]);

  var _a;

  var _useState23 = useState(undefined),
      _useState24 = _slicedToArray(_useState23, 2),
      fontSize = _useState24[0],
      setFontSize = _useState24[1];

  var _useState25 = useState(''),
      _useState26 = _slicedToArray(_useState25, 2),
      initials = _useState26[0],
      setInitials = _useState26[1];

  var _useState27 = useState(false),
      _useState28 = _slicedToArray(_useState27, 2),
      hasError = _useState28[0],
      setHasError = _useState28[1];

  var ref = createRef();
  useEffect(function () {
    if (nameFallback) {
      var newInitials = nameFallback.split(' ').map(function (s) {
        return s[0];
      }).join('').slice(0, 3);
      setInitials(newInitials);
    }
  }, [nameFallback]);
  useEffect(function () {
    var el = ref.current;
    var resizeObserver = new ResizeObserver(function (_ref20) {
      var _ref21 = _slicedToArray(_ref20, 1),
          entry = _ref21[0];

      var refDimension = Math.min(entry.contentRect.width, entry.contentRect.height);

      if (initials) {
        setFontSize(initials.length > 2 ? refDimension * 0.5 : refDimension * 0.7);
      }
    });

    if (el !== null) {
      resizeObserver.observe(el);
    }

    return function () {
      if (el !== null) {
        resizeObserver.unobserve(el);
      }
    };
  }, [initials, ref]);

  if (hasError && ((_a = nameFallback === null || nameFallback === void 0 ? void 0 : nameFallback.length) !== null && _a !== void 0 ? _a : 0) > 0) {
    return React.createElement("div", {
      className: props.className,
      style: props.style
    }, React.createElement("div", {
      ref: ref,
      onClick: props.onClick,
      style: {
        backgroundColor: '#ed154e',
        width: '100%',
        height: '100%',
        display: 'grid',
        placeItems: 'center',
        color: 'white',
        fontSize: fontSize,
        overflow: 'hidden',
        borderRadius: 'inherit'
      }
    }, initials));
  }

  return React.createElement(ImageLoader, Object.assign({}, props, {
    onError: function onError() {
      setHasError(true);
    }
  }));
};

var ImageViewer = function ImageViewer(_ref22) {
  var imgUrl = _ref22.imgUrl,
      imgAlt = _ref22.imgAlt,
      scale = _ref22.scale,
      translateX = _ref22.translateX,
      translateY = _ref22.translateY,
      imgElRef = _ref22.imgElRef,
      bindGestures = _ref22.bindGestures,
      imageDimensions = _ref22.imageDimensions,
      imageOverlay = _ref22.imageOverlay,
      _ref22$animateOnChang = _ref22.animateOnChangeUrl,
      animateOnChangeUrl = _ref22$animateOnChang === void 0 ? false : _ref22$animateOnChang,
      imageClassName = _ref22.imageClassName,
      imageStyle = _ref22.imageStyle,
      onImageLoad = _ref22.onImageLoad,
      onImageError = _ref22.onImageError;
  var classes = useImageViewerStyles();
  var defaultDimensions = imageDimensions !== null && imageDimensions !== void 0 ? imageDimensions : [0, 0];

  var _useState29 = useState(defaultDimensions),
      _useState30 = _slicedToArray(_useState29, 2),
      dimensions = _useState30[0],
      setDimensions = _useState30[1];

  var rippleTransition = useTransition(animateOnChangeUrl, {
    from: {
      rippleOpacity: 0.5,
      rippleScale: 0
    },
    enter: {
      rippleOpacity: 0,
      rippleScale: 2
    },
    leave: {
      rippleOpacity: 0.5,
      rippleScale: 0
    }
  });
  useEffect(function () {
    var _a, _b;

    var overlayWidth = (_a = imgElRef.current) === null || _a === void 0 ? void 0 : _a.naturalWidth;
    var overlayHeight = (_b = imgElRef.current) === null || _b === void 0 ? void 0 : _b.naturalHeight;

    if (overlayWidth && overlayHeight) {
      setDimensions([overlayWidth, overlayHeight]);
    } else {
      setDimensions(defaultDimensions);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [defaultDimensions[0], defaultDimensions[1], imgElRef, imgUrl]);
  var hasImageOverlay = Boolean(imageOverlay);
  var overlayTransition = useTransition(hasImageOverlay, {
    from: {
      opacity: 0
    },
    enter: {
      opacity: 1
    },
    leave: {
      opacity: 0
    }
  });
  var rippleDiameter = Math.min(dimensions[0], dimensions[1]);

  var _useImageLoader2 = useImageLoader({
    src: imgUrl,
    onLoad: onImageLoad
  }),
      hasLoaded = _useImageLoader2.hasLoaded;

  return React.createElement("div", {
    className: classes.boundsContainer
  }, React.createElement("div", {
    className: classes.centerContainer
  }, rippleTransition(function (_ref23, item) {
    var rippleOpacity = _ref23.rippleOpacity,
        rippleScale = _ref23.rippleScale;
    if (!item) return null;
    return React.createElement(animated.div, {
      style: {
        zIndex: 2,
        width: dimensions[0],
        height: dimensions[1],
        position: 'absolute',
        transform: to([scale, translateX, translateY], function (s, tx, ty) {
          return "translate(".concat(tx, "px, ").concat(ty, "px) scale(").concat(s, ")");
        }),
        pointerEvents: 'none',
        display: 'flex',
        justifyContent: 'center',
        overflow: 'hidden'
      }
    }, React.createElement(animated.div, {
      style: {
        background: 'white',
        width: rippleDiameter,
        height: rippleDiameter,
        borderRadius: '50%',
        transform: rippleScale.to(function (s) {
          return "scale(".concat(s, ")");
        }),
        opacity: rippleOpacity
      }
    }));
  }), React.createElement(animated.img, Object.assign({}, bindGestures(), {
    onError: onImageError,
    ref: imgElRef,
    src: imgUrl,
    alt: imgAlt,
    draggable: false,
    className: cx(classes.image, imageClassName),
    style: _objectSpread({}, imageStyle, {
      visibility: hasLoaded ? 'visible' : 'hidden',
      transform: to([scale, translateX, translateY], function (s, tx, ty) {
        return "translate(".concat(tx, "px, ").concat(ty, "px) scale(").concat(s, ")");
      })
    })
  })), hasLoaded ? React.createElement(Fragment, null, overlayTransition(function (_ref24, item) {
    var opacity = _ref24.opacity;
    if (!item) return null;
    return React.createElement(animated.div, {
      style: {
        opacity: opacity,
        width: dimensions[0],
        height: dimensions[1],
        position: 'absolute',
        transform: to([scale, translateX, translateY], function (s, tx, ty) {
          return "translate(".concat(tx, "px, ").concat(ty, "px) scale(").concat(s, ")");
        }),
        pointerEvents: 'none'
      }
    }, imageOverlay);
  })) : React.createElement(animated.div, {
    style: {
      position: 'absolute',
      transform: to([translateX, translateY], function (tx, ty) {
        return "translate(".concat(tx, "px, ").concat(ty, "px)");
      })
    }
  }, React.createElement(CircularProgress, null))));
};

var ImageViewerControls = function ImageViewerControls(_ref25) {
  var zoomIn = _ref25.zoomIn,
      zoomOut = _ref25.zoomOut,
      resetZoom = _ref25.resetZoom;
  var classes = useImageViewerControlsStyles();
  return React.createElement("div", {
    className: classes.container
  }, React.createElement(IconButton, {
    onClick: zoomOut,
    style: {
      color: '#D3D3D3'
    }
  }, React.createElement(Remove, null)), React.createElement(IconButton, {
    onClick: resetZoom,
    style: {
      color: '#D3D3D3'
    }
  }, React.createElement(ZoomOut, null)), React.createElement(IconButton, {
    onClick: zoomIn,
    style: {
      color: '#D3D3D3'
    }
  }, React.createElement(Add, null)));
};

var TwoSidedImageViewer = function TwoSidedImageViewer(_ref26) {
  var cardFace = _ref26.cardFace,
      frontImgUrl = _ref26.frontImgUrl,
      frontImgAlt = _ref26.frontImgAlt,
      backImgUrl = _ref26.backImgUrl,
      backImgAlt = _ref26.backImgAlt,
      transform = _ref26.transform,
      opacity = _ref26.opacity,
      scale = _ref26.scale,
      translateX = _ref26.translateX,
      translateY = _ref26.translateY,
      _ref26$xOffset = _ref26.xOffset,
      xOffset = _ref26$xOffset === void 0 ? 0 : _ref26$xOffset,
      _ref26$yOffset = _ref26.yOffset,
      yOffset = _ref26$yOffset === void 0 ? 0 : _ref26$yOffset;
  var classes = useImageViewerStyles();
  var isFront = cardFace === CardFace.Front;
  var isBack = cardFace === CardFace.Back;
  return React.createElement("div", {
    className: classes.boundsContainer
  }, React.createElement(animated.div, {
    style: {
      transform: transform,
      width: '100%',
      height: '100%',
      gridArea: '1 / 1 / span 1 / span 1'
    }
  }, React.createElement("div", {
    className: classes.centerContainer,
    style: {}
  }, React.createElement(animated.img, {
    src: frontImgUrl,
    alt: frontImgAlt,
    draggable: false,
    className: classes.image,
    style: {
      pointerEvents: 'none',
      opacity: opacity,
      zIndex: isFront ? 1 : 0,
      position: 'absolute',
      transform: to([scale, translateX, translateY], function (s, tx, ty) {
        return "translate(".concat(tx + xOffset, "px, ").concat(ty, "px) scale(").concat(s, ")");
      })
    }
  }), React.createElement(animated.img, {
    src: backImgUrl,
    alt: backImgAlt,
    draggable: false,
    className: classes.image,
    style: {
      opacity: opacity.to(function (o) {
        return 1 - o;
      }),
      zIndex: isBack ? 1 : 0,
      pointerEvents: 'none',
      position: 'absolute',
      transform: to([scale, translateX, translateY], function (s, tx, ty) {
        return "translate(".concat(tx + xOffset, "px, ").concat(ty, "px) scale(").concat(s, ") rotateY(180deg)");
      })
    }
  }))));
};

var useDesignLabScaffoldStyles = makeStyles({
  gridContainer: {
    width: '100%',
    height: '100vh',
    display: 'grid',
    backgroundColor: 'black'
  },
  gridSpacerTopLeft: {
    gridArea: '1 / 1 / span 1 / span 1',
    zIndex: 1,
    backgroundColor: 'rgba(50, 50, 50, 0.5)'
  },
  gridSpacerTopRight: {
    gridArea: '1 / 4 / span 1 / span 1',
    zIndex: 1,
    backgroundColor: 'rgba(50, 50, 50, 0.5)'
  },
  gridSpacerBottomLeft: {
    gridArea: '4 / 1 / span 1 / span 1',
    zIndex: 1,
    backgroundColor: 'rgba(50, 50, 50, 0.5)'
  },
  gridSpacerBottomRight: {
    gridArea: '4 / 4 / span 1 / span 1',
    zIndex: 1,
    backgroundColor: 'rgba(50, 50, 50, 0.5)'
  },
  gridTop: {
    gridArea: '1 / 2 / span 1 / span 2',
    padding: '0 1em',
    zIndex: 2,
    backgroundColor: 'rgba(50, 50, 50, 0.5)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  gridViewingAreaMeasure: {
    gridArea: '2 / 2 / span 2 / span 1',
    width: '100%'
  },
  gridImageOverlay: {
    gridArea: '1 / 1 / span 4 / span 5',
    height: '100vh',
    width: '100%',
    overflow: 'hidden'
  },
  gridImageControls: {
    gridArea: '3 / 2 / span 1 / span 1',
    zIndex: 0,
    justifySelf: 'center'
  },
  gridBottom: {
    gridArea: '4 / 2 / span 1 / span 2',
    zIndex: 1
  }
});
var useActionsOverlayStyles = makeStyles({
  actionsOverlayContainer: {
    gridArea: '1 / 3 / 2 / 4',
    zIndex: 2,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: '60px'
  }
});
var useRevisionBottomOverlayStyles = makeStyles({
  button: {
    color: '#F9F9F9',
    padding: '12px 32px',
    fontWeight: 'bold'
  }
});
var useActionsOverlayContainerStyles = makeStyles({
  actionsOverlayContainer: {
    gridArea: '1 / 3 / 2 / 4',
    zIndex: 2,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: '80px'
  }
});

var ViewingArea = function ViewingArea(_ref27) {
  var imageViewerProps = _ref27.imageViewerProps,
      designProps = _ref27.designProps,
      isLoading = _ref27.isLoading,
      _ref27$sidebarOffset = _ref27.sidebarOffset,
      sidebarOffset = _ref27$sidebarOffset === void 0 ? 0 : _ref27$sidebarOffset,
      _ref27$hasSidebar = _ref27.hasSidebar,
      hasSidebar = _ref27$hasSidebar === void 0 ? false : _ref27$hasSidebar,
      imageClassName = _ref27.imageClassName,
      imageStyle = _ref27.imageStyle,
      imageOverlay = _ref27.imageOverlay,
      onImageLoad = _ref27.onImageLoad,
      onImageError = _ref27.onImageError;
  var classes = useDesignLabScaffoldStyles();
  var frontPostcardUrl = designProps.frontPostcardUrl,
      backPostcardUrl = designProps.backPostcardUrl,
      previousVersionFrontUrl = designProps.previousVersionFrontUrl,
      previousVersionBackUrl = designProps.previousVersionBackUrl,
      isViewingPrevious = designProps.isViewingPrevious,
      imageDimensions = designProps.imageDimensions,
      imgElRef = designProps.imgElRef,
      scale = designProps.scale,
      translateX = designProps.translateX,
      translateY = designProps.translateY;
  var isInteractive = imageViewerProps.isInteractive,
      cardFace = imageViewerProps.cardFace,
      bindGestures = imageViewerProps.bindGestures,
      transform = imageViewerProps.transform,
      opacity = imageViewerProps.opacity;
  var frontUrl = frontPostcardUrl;
  var backUrl = backPostcardUrl;

  if (previousVersionFrontUrl && previousVersionBackUrl && isViewingPrevious) {
    frontUrl = previousVersionFrontUrl;
    backUrl = previousVersionBackUrl;
  }

  if (isInteractive) {
    return React.createElement("div", {
      className: classes.gridImageOverlay
    }, React.createElement("div", {
      style: {
        overflow: 'hidden',
        width: '100%',
        height: '100vh'
      }
    }, isLoading && !imgElRef ? React.createElement("div", {
      style: {
        gridArea: hasSidebar ? '2 / 2 / span 2 / span 1' : '2 / 2 / span 2 / span 2'
      }
    }, React.createElement(DefaultImagePlaceholder, null)) : React.createElement(ImageViewer, {
      imageDimensions: imageDimensions,
      imgUrl: cardFace === CardFace.Front ? frontUrl : backUrl,
      animateOnChangeUrl: isViewingPrevious,
      imgAlt: cardFace === CardFace.Front ? 'Front Postcard Thumbnail' : 'Back Postcard Thumbnail',
      bindGestures: bindGestures,
      imgElRef: imgElRef,
      scale: scale,
      translateX: translateX,
      translateY: translateY,
      imageOverlay: imageOverlay,
      imageClassName: imageClassName,
      imageStyle: imageStyle,
      onImageLoad: onImageLoad,
      onImageError: onImageError
    })));
  }

  return React.createElement("div", {
    className: classes.gridImageOverlay,
    style: {
      perspective: '2400px',
      gridArea: hasSidebar ? '1 / 1 / span 4 / span 2' : '1 / 1 / span 4 / span 3'
    }
  }, React.createElement(TwoSidedImageViewer, {
    cardFace: cardFace,
    frontImgUrl: frontUrl,
    frontImgAlt: "Front Postcard Thumbnail",
    backImgUrl: backUrl,
    backImgAlt: "Back Postcard Thumbnail",
    transform: transform,
    opacity: opacity,
    scale: scale,
    translateX: translateX,
    translateY: translateY,
    xOffset: sidebarOffset * -1
  }));
};

var DesignLabScaffold = function DesignLabScaffold(_ref28) {
  var imageViewerProps = _ref28.imageViewerProps,
      viewingAreaDesignProps = _ref28.viewingAreaDesignProps,
      resizeHandlerProps = _ref28.resizeHandlerProps,
      controlAreaStyles = _ref28.controlAreaStyles,
      sidebarOverlay = _ref28.sidebarOverlay,
      viewingAreaTopRightOverlay = _ref28.viewingAreaTopRightOverlay,
      viewingAreaImageProps = _ref28.viewingAreaImageProps,
      topOverlay = _ref28.topOverlay,
      bottomOverlay = _ref28.bottomOverlay,
      imageOverlay = _ref28.imageOverlay,
      imageModalOverlay = _ref28.imageModalOverlay,
      modalsOverlay = _ref28.modalsOverlay,
      toastsOverlay = _ref28.toastsOverlay,
      onImageError = _ref28.onImageError,
      _ref28$showBuiltInCon = _ref28.showBuiltInControls,
      showBuiltInControls = _ref28$showBuiltInCon === void 0 ? true : _ref28$showBuiltInCon,
      _ref28$isLoading = _ref28.isLoading,
      isLoading = _ref28$isLoading === void 0 ? false : _ref28$isLoading;
  var classes = useDesignLabScaffoldStyles();
  var zoomIn = imageViewerProps.zoomIn,
      zoomOut = imageViewerProps.zoomOut,
      resetZoom = imageViewerProps.resetZoom;
  var autoAdjustZoomAndOffset = resizeHandlerProps.autoAdjustZoomAndOffset,
      viewingAreaRef = resizeHandlerProps.viewingAreaRef,
      controlAreaRef = resizeHandlerProps.controlAreaRef,
      width = resizeHandlerProps.width,
      sidebarAreaRef = resizeHandlerProps.sidebarAreaRef,
      sidebarViewingAreaRef = resizeHandlerProps.sidebarViewingAreaRef,
      sidebarOffset = resizeHandlerProps.sidebarOffset;
  var hasSidebar = !(typeof sidebarOverlay === 'undefined' || sidebarOverlay === null);
  var hasViewingAreaTopRightOverlay = typeof viewingAreaTopRightOverlay !== 'undefined';
  return React.createElement(Fragment, null, React.createElement(animated.div, {
    className: classes.gridContainer,
    style: {
      gridTemplate: width.to(function (w) {
        return "auto 1fr 56px auto / ".concat(w, "fr 9fr 3fr ").concat(w, "fr");
      })
    }
  }, React.createElement("div", {
    className: classes.gridSpacerTopLeft
  }), React.createElement("div", {
    className: classes.gridSpacerTopRight
  }), React.createElement("div", {
    className: classes.gridTop
  }, topOverlay), React.createElement("div", {
    className: classes.gridViewingAreaMeasure,
    ref: viewingAreaRef,
    style: {
      gridArea: hasSidebar ? '2 / 2 / span 2 / span 1' : '2 / 2 / span 2 / span 2'
    }
  }), hasViewingAreaTopRightOverlay && React.createElement("div", {
    style: {
      gridArea: hasSidebar ? '2 / 2 / span 2 / span 1' : '2 / 2 / span 2 / span 2',
      color: 'white',
      justifySelf: 'end',
      zIndex: 2,
      pointerEvents: 'none'
    }
  }, viewingAreaTopRightOverlay), React.createElement(ViewingArea, {
    designProps: viewingAreaDesignProps,
    sidebarOffset: sidebarOffset,
    imageViewerProps: imageViewerProps,
    hasSidebar: hasSidebar,
    imageStyle: viewingAreaImageProps === null || viewingAreaImageProps === void 0 ? void 0 : viewingAreaImageProps.style,
    imageClassName: viewingAreaImageProps === null || viewingAreaImageProps === void 0 ? void 0 : viewingAreaImageProps.className,
    onImageLoad: function onImageLoad(h, w) {
      if (isLoading) {
        var sv = autoAdjustZoomAndOffset(h, w);
        resetZoom(sv);
      }
    },
    onImageError: onImageError,
    imageOverlay: imageOverlay,
    width: width,
    isLoading: isLoading
  }), imageModalOverlay ? React.createElement("div", {
    className: classes.gridImageOverlay
  }, React.createElement("div", {
    style: {
      overflow: 'hidden',
      width: '100%',
      height: '100vh'
    }
  }, imageModalOverlay)) : null, hasSidebar === true ? React.createElement(Fragment, null, React.createElement("div", {
    ref: sidebarAreaRef,
    style: _objectSpread({
      zIndex: 1,
      gridArea: '1 / 3 / span 4 / span 1',
      width: '100%'
    }, controlAreaStyles)
  }, sidebarOverlay), React.createElement("div", {
    ref: sidebarViewingAreaRef,
    style: {
      gridArea: '2 / 3 / span 2 / span 1',
      height: '100%',
      width: '100%'
    }
  })) : null, showBuiltInControls === true ? React.createElement("div", {
    className: classes.gridImageControls,
    style: {
      gridArea: hasSidebar ? '3 / 2 / span 1 / span 1' : '3 / 2 / span 1 / span 2'
    }
  }, React.createElement(ImageViewerControls, {
    zoomIn: zoomIn,
    zoomOut: zoomOut,
    resetZoom: resetZoom
  })) : null, React.createElement("div", {
    className: classes.gridSpacerBottomLeft
  }), React.createElement("div", {
    className: classes.gridSpacerBottomRight
  }), React.createElement("div", {
    className: classes.gridBottom,
    ref: controlAreaRef
  }, bottomOverlay)), modalsOverlay, toastsOverlay);
};

var ActionsContext = createContext({});
var DesignDerivedStateContext = createContext({});
var CampaignMediaReviewContext = createContext({});
var CampaignContext = {
  Derived: DesignDerivedStateContext,
  CampaignMediaReview: CampaignMediaReviewContext
};
var Comments = createContext([]);
var DerivedComments = createContext({});
var CommentsStore = {
  Comments: Comments,
  DerivedComments: DerivedComments
};
var DerivedActionsContext = createContext({});
var DesignBaseContext = createContext({});
var DesignDerivedStateContext$1 = createContext({});
var DesignContext = {
  Base: DesignBaseContext,
  Derived: DesignDerivedStateContext$1
};
var DesignReviewContext = createContext({});
var RefsContext = createContext({});
var UpdateQueueContext = createContext([]);
var ScaffoldUIStateContext = createContext({});
var ImageViewerUIStateContext = createContext({});
var ImageViewerUIDerivedStateContext = createContext({});
var SidebarUIStateContext = createContext({});
var ScaffoldUIDerivedStateContext = createContext({});
var SidebarUIDerivedStateContext = createContext({});
var UIStateContext = {
  Scaffold: ScaffoldUIStateContext,
  ImageViewer: ImageViewerUIStateContext,
  Sidebar: SidebarUIStateContext,
  Derived: {
    Scaffold: ScaffoldUIDerivedStateContext,
    ImageViewer: ImageViewerUIDerivedStateContext,
    Sidebar: SidebarUIDerivedStateContext
  }
};
var SaaSApiBaseContext = createContext({});

var downloadAsPDF =
/*#__PURE__*/
function () {
  var _ref29 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(option) {
    var _ref30, url;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return convertImagesToPDF(option);

          case 2:
            _ref30 = _context.sent;
            url = _ref30.url;
            window.location.href = url;

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function downloadAsPDF(_x) {
    return _ref29.apply(this, arguments);
  };
}();

var convertImagesToPDF =
/*#__PURE__*/
function () {
  var _ref31 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(option) {
    var images, name, secret, convertApi, params, result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            images = option.images, name = option.name, secret = option.secret; // @ts-ignore

            convertApi = new ConvertApi.auth({
              secret: secret
            });
            params = convertApi.createParams();
            params.add('Files', images.map(function (img) {
              return new URL(img);
            }));
            params.add('FileName', name);
            _context2.next = 7;
            return convertApi.convert('images', 'pdf', params);

          case 7:
            result = _context2.sent;
            return _context2.abrupt("return", {
              url: get(result, 'files.0.Url')
            });

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function convertImagesToPDF(_x2) {
    return _ref31.apply(this, arguments);
  };
}();

var designConcepts = {
  '01196-MVP-8': {
    name: 'Design Option 1',
    accountId: '0010v00000X7tzoAAB',
    front: {
      id: '01196-MVP-8',
      src: 'https://mvpmailhouse.nyc3.digitaloceanspaces.com/staging-files/a0G0v00000458FFEAY-FRONT-FULL.png'
    },
    back: {
      id: '01196-MVP-8',
      src: 'https://mvpmailhouse.nyc3.digitaloceanspaces.com/01196-MVP-8-BACK-FULL.png'
    }
  },
  '01286-MVP-3': {
    name: 'Design Option 2',
    accountId: '0010v00000X7tzoAAB',
    front: {
      id: '01286-MVP-3',
      src: 'https://mvpmailhouse.nyc3.digitaloceanspaces.com/01286-MVP-3-FRONT-FULL.png'
    },
    back: {
      id: '01286-MVP-3',
      src: 'https://mvpmailhouse.nyc3.digitaloceanspaces.com/01286-MVP-3-BACK-FULL.png'
    }
  },
  '01405-MVP-2': {
    name: 'Design Option 3',
    accountId: '0010v00000X7tzoAAB',
    front: {
      id: '01405-MVP-2',
      src: 'https://mvpmailhouse.nyc3.digitaloceanspaces.com/01405-MVP-2-FRONT-FULL.png'
    },
    back: {
      id: '01405-MVP-2',
      src: 'https://mvpmailhouse.nyc3.digitaloceanspaces.com/01405-MVP-2-BACK-FULL.png'
    }
  },
  '01361-MVP-2': {
    name: 'Design Option 4',
    accountId: '0010v00000X7tzoAAB',
    front: {
      id: '01361-MVP-2',
      src: 'https://mvpmailhouse.nyc3.digitaloceanspaces.com/01361-MVP-2-FRONT-FULL.png'
    },
    back: {
      id: '01361-MVP-2',
      src: 'https://mvpmailhouse.nyc3.digitaloceanspaces.com/01361-MVP-2-BACK-FULL.png'
    }
  },
  '01364-MVP-3': {
    name: 'Design Option 5',
    accountId: '0010v00000X7tzoAAB',
    front: {
      id: '01364-MVP-3',
      src: 'https://mvpmailhouse.nyc3.digitaloceanspaces.com/01364-MVP-3-FRONT-FULL.png'
    },
    back: {
      id: '01364-MVP-3',
      src: 'https://mvpmailhouse.nyc3.digitaloceanspaces.com/01364-MVP-3-BACK-FULL.png'
    }
  }
};
var designConceptsSampleData =
/*#__PURE__*/
Object.freeze({
  __proto__: null,
  designConcepts: designConcepts
});

var Modal = function Modal(props) {
  var _a, _b;

  return React.createElement(Modal$1, {
    open: props.open,
    onBackdropClick: props.onBackdropClick,
    style: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: (_a = props.bgColor) !== null && _a !== void 0 ? _a : 'rgba(52, 52, 52, 0.8)',
      outline: 'none'
    }
  }, React.createElement("div", {
    style: _objectSpread({
      backgroundColor: '#fff',
      width: (_b = props.width) !== null && _b !== void 0 ? _b : '500px',
      maxWidth: '1024px',
      padding: '2em',
      borderRadius: '4px',
      outline: 'none'
    }, props.containerStyle)
  }, props.children));
};

var SlideUpTransition = forwardRef(function Transition(props, ref) {
  return React.createElement(Slide, Object.assign({
    direction: "up",
    ref: ref
  }, props));
});

var isPortrait = function isPortrait(imageUrl) {
  var _image = new Image();

  _image.src = imageUrl;
  return _image.height > _image.width;
};

var postcardImg = function postcardImg(imageUrl, computedWidth) {
  var image = {
    img: new Image(),
    width: computedWidth
  };
  var imageContainerStyles = {
    height: 'auto',
    width: 'auto'
  };

  if (isPortrait(imageUrl)) {
    image.width = computedWidth / 1.832;
    imageContainerStyles.height = "".concat(image.width, "px");
    imageContainerStyles.width = "".concat(image.width * 1.832, "px");
  }

  return {
    imageContainerStyles: imageContainerStyles,
    image: image
  };
};

var handleImageOnError = function handleImageOnError(e) {
  e.target.onerror = null;
  e.target.src = imagePlaceholder;
  e.target.style = 'pointer-events: none;';
};

var useStyles = makeStyles({
  selectedOptionsWrapper: {
    width: '100%',
    marginTop: 30,
    display: 'flex',
    justifyContent: 'space-between',
    '& img': {
      maxWidth: 'calc(50% - 6px)',
      boxShadow: '0px 2px 7px -2px rgba(0,0,0,0.29)'
    },
    '& img:first-child': {
      marginRight: 'auto'
    }
  },
  confirm: {
    paddingLeft: '30px',
    paddingRight: '30px',
    '& h3': {
      fontFamily: 'Roboto Condensed',
      fontSize: '37px',
      textAlign: 'center',
      marginTop: '20px',
      marginBottom: '15px'
    },
    '& p': {
      fontFamily: 'Roboto Condensed',
      fontSize: '17px',
      textAlign: 'center',
      lineHeight: 1.6
    }
  },
  confirmBtnsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '45px'
  },
  confirmButtons: {
    textTransform: 'uppercase',
    fontWeight: 'normal',
    fontSize: '17px',
    padding: '11px',
    marginBottom: 16
  },
  proceed: {
    marginBottom: 14
  }
});

var ConfirmationModal = function ConfirmationModal(_ref32) {
  var open = _ref32.open,
      selectedOption = _ref32.selectedOption,
      handleClickConfirm = _ref32.handleClickConfirm,
      handleClickBack = _ref32.handleClickBack,
      options = _ref32.options;
  var classes = useStyles();

  var _useState31 = useState(false),
      _useState32 = _slicedToArray(_useState31, 2),
      submitting = _useState32[0],
      setSubmitting = _useState32[1];

  return React.createElement(Dialog$1, {
    open: open,
    onBackdropClick: handleClickBack,
    TransitionComponent: SlideUpTransition,
    PaperProps: {
      style: {
        width: '550px'
      }
    }
  }, React.createElement("div", {
    className: classes.confirm,
    style: {
      padding: '2.5rem 3rem'
    }
  }, React.createElement("h3", {
    style: {
      marginTop: '0',
      marginBottom: '0'
    }
  }, "Excellent choice."), React.createElement("p", null, "We will refine this concept on the next step -", ' ', React.createElement("strong", null, "Design Review."), React.createElement("br", null), React.createElement("span", {
    style: {
      color: '#F50D0D'
    }
  }, "*You can no longer undo your selection once you confirm.")), React.createElement("div", {
    className: classes.selectedOptionsWrapper
  }, React.createElement(Postcard, {
    imageUrl: options[selectedOption.front.id].front.src
  }), React.createElement(Postcard, {
    imageUrl: options[selectedOption.back.id].back.src
  })), React.createElement("div", {
    className: classes.confirmBtnsWrapper,
    style: {
      marginTop: '2rem'
    }
  }, React.createElement(Button$1, {
    classes: {
      root: cx(classes.confirmButtons, classes.proceed)
    },
    style: {
      marginBottom: '0.5rem'
    },
    size: "large",
    variant: "contained",
    color: "primary",
    onClick: function () {
      var _onClick = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                setSubmitting(true);
                _context3.next = 3;
                return handleClickConfirm();

              case 3:
                setSubmitting(false);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function onClick() {
        return _onClick.apply(this, arguments);
      }

      return onClick;
    }(),
    disabled: submitting
  }, submitting && React.createElement(CircularProgress, {
    style: {
      color: '#fff',
      marginRight: 8
    },
    size: 25
  }), "Confirm selection"), React.createElement(Button$1, {
    classes: {
      root: classes.confirmButtons
    },
    size: "large",
    variant: "outlined",
    color: "primary",
    onClick: handleClickBack
  }, "Back to concept selection"))));
};

var Postcard = function Postcard(_ref33) {
  var imageUrl = _ref33.imageUrl;
  var container = {
    height: '137px',
    width: '219px'
  };
  var imgStyles = {
    maxWidth: '100%'
  };

  if (isPortrait(imageUrl)) {
    imgStyles.transform = 'rotate(-90deg) translateX(-100%)';
    imgStyles.transformOrigin = 'left top';
    imgStyles.height = 219;
  }

  return React.createElement("div", {
    style: container
  }, React.createElement("img", {
    src: imageUrl,
    alt: "",
    style: imgStyles
  }));
};

var DesignConceptModalTypes;

(function (DesignConceptModalTypes) {
  DesignConceptModalTypes["Help"] = "Help";
  DesignConceptModalTypes["VideoWalkthrough"] = "Video Walkthrough";
  DesignConceptModalTypes["ConfirmSelectionModal"] = "Confirm Selection";
})(DesignConceptModalTypes || (DesignConceptModalTypes = {}));

var useDesignConceptModalSelector = function useDesignConceptModalSelector() {
  var _useState33 = useState(undefined),
      _useState34 = _slicedToArray(_useState33, 2),
      modalArgs = _useState34[0],
      setModalArgs = _useState34[1];

  var closeModal = function closeModal() {
    setModalArgs(undefined);
  };

  var openModal = function openModal(args) {
    setModalArgs(args);
  };

  var openConfirmSelectionModal = function openConfirmSelectionModal(args) {
    setModalArgs({
      type: DesignConceptModalTypes.ConfirmSelectionModal,
      args: args
    });
  };

  var openHelpModal = function openHelpModal() {
    setModalArgs({
      type: DesignConceptModalTypes.Help
    });
  };

  var openVideoWalkthroughModal = function openVideoWalkthroughModal() {
    setModalArgs({
      type: DesignConceptModalTypes.VideoWalkthrough
    });
  };

  return {
    modalArgs: modalArgs,
    closeModal: closeModal,
    openModal: openModal,
    openConfirmSelectionModal: openConfirmSelectionModal,
    openHelpModal: openHelpModal,
    openVideoWalkthroughModal: openVideoWalkthroughModal
  };
};

var DesignConceptModalSelector = function DesignConceptModalSelector(_ref34) {
  var modalArgs = _ref34.modalArgs,
      closeModal = _ref34.closeModal;

  if (typeof modalArgs === 'undefined') {
    return null;
  }

  if (modalArgs.type === DesignConceptModalTypes.ConfirmSelectionModal) {
    return React.createElement(ConfirmationModal, Object.assign({}, modalArgs.args));
  }

  if (modalArgs.type === DesignConceptModalTypes.VideoWalkthrough) {
    return React.createElement(VideoModal, {
      open: true,
      onBackdropClick: closeModal,
      videoTitle: "Show me how",
      videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=1"
    });
  }

  if (modalArgs.type === DesignConceptModalTypes.Help) {
    return React.createElement(HelpModal, {
      header: React.createElement(Fragment, null, "Need help or have questions?", React.createElement("br", null), "Just give me a call"),
      open: true,
      onBackdropClick: closeModal,
      coordinator: {
        avatar: 'https://assets-global.website-files.com/5c88fc88555981dc7f314a41/5d4807f1a904cd6566057915_5d1c83174cf9cb8adf5b05a0_Scott-Kubie-Headshot-Web.jpeg',
        name: 'Jim Simons',
        email: 'jim@mvpmailhouse.com',
        position: 'MVP Marketing Consultant',
        phone: '8018508343'
      }
    });
  }

  return null;
};

var DesignConceptPreview = function DesignConceptPreview(_ref35) {
  var isSplit = _ref35.isSplit,
      previewFront = _ref35.previewFront,
      previewBack = _ref35.previewBack,
      handleConfirmSelection = _ref35.handleConfirmSelection,
      closePreview = _ref35.closePreview,
      openHelpModal = _ref35.openHelpModal,
      openVideoWalkthroughModal = _ref35.openVideoWalkthroughModal,
      initialCardFace = _ref35.initialCardFace;
  var imageViewerProps = useImageViewer({
    initialCardFace: initialCardFace
  });
  var imgElRef = imageViewerProps.imgElRef,
      cardFace = imageViewerProps.cardFace,
      setCardFace = imageViewerProps.setCardFace,
      setDefaultZoom = imageViewerProps.setDefaultZoom,
      resetZoom = imageViewerProps.resetZoom,
      scale = imageViewerProps.scale,
      translateX = imageViewerProps.translateX,
      translateY = imageViewerProps.translateY;

  var _useContext = useContext(DesignContext.Derived),
      mediaType = _useContext.mediaType;

  var resizeHandlerProps = useResizeHandlers({
    setDefaultZoom: setDefaultZoom,
    imgElRef: imgElRef,
    dependencies: [cardFace],
    offsetGenerator: function offsetGenerator() {
      return {
        offsetX: 0,
        sidebarOffset: 0
      };
    }
  });

  var _useImageDimensions = useImageDimensions({
    imgUrl: previewFront
  }),
      imageDimensions = _useImageDimensions.imageDimensions;

  return React.createElement(DesignLabScaffold, {
    imageViewerProps: imageViewerProps,
    viewingAreaDesignProps: {
      workflow: Workflow.Review,
      frontPostcardUrl: previewFront,
      backPostcardUrl: previewBack,
      isViewingPrevious: false,
      imageDimensions: imageDimensions,
      imgElRef: imgElRef,
      scale: scale,
      translateX: translateX,
      translateY: translateY
    },
    resizeHandlerProps: resizeHandlerProps,
    topOverlay: React.createElement(Fragment, null, React.createElement("span", {
      style: {
        display: 'flex',
        alignItems: 'center'
      }
    }, React.createElement(IconButton, {
      style: {
        color: '#d3d3d3'
      },
      onClick: closePreview
    }, React.createElement(ArrowBack, null)), React.createElement(Typography, {
      variant: "h6",
      component: "h2",
      style: {
        color: 'white'
      }
    }, "Design Concept - ".concat(cardFace))), React.createElement(ActionsOverlayContainer, {
      openHelpModal: openHelpModal,
      openVideoWalkthroughModal: openVideoWalkthroughModal
    }, React.createElement(Button$1, {
      style: {
        color: '#f9f9f9',
        backgroundColor: '#000',
        border: '1px solid #fff',
        padding: '0.75rem 1.75rem',
        margin: '0 1rem',
        textTransform: 'uppercase'
      },
      variant: "contained",
      onClick: closePreview
    }, "View Other Concepts"), React.createElement(Button$1, {
      style: {
        color: '#f9f9f9',
        backgroundColor: '#ed154e',
        padding: '0.75rem 1.75rem',
        textTransform: 'uppercase'
      },
      variant: "contained",
      onClick: handleConfirmSelection
    }, isSplit ? 'Choose this combination' : 'Choose this concept'))),
    viewingAreaTopRightOverlay: React.createElement(ViewingAreaTopRightOverlay, {
      cardFace: cardFace,
      setCardFace: setCardFace,
      resetZoom: resetZoom,
      isViewingPrevious: false,
      setIsViewingPrevious: function setIsViewingPrevious() {},
      isPreviousVersionLocked: false,
      setIsPreviousVersionLocked: function setIsPreviousVersionLocked() {},
      showingAllMarkers: false,
      setShowingAllMarkers: function setShowingAllMarkers() {},
      showingInactiveMarkers: false,
      setShowingInactiveMarkers: function setShowingInactiveMarkers() {},
      refreshDesign: function () {
        var _refreshDesign = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee4() {
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        function refreshDesign() {
          return _refreshDesign.apply(this, arguments);
        }

        return refreshDesign;
      }(),
      visibleButtons: {
        addUnpinnedComment: false,
        flipPage: true,
        togglePreviousVersion: false,
        refreshDesign: false,
        toggleInactiveMarkers: false,
        toggleAllMarkers: false
      }
    }),
    bottomOverlay: React.createElement(PostcardBottomOverlay, {
      cardFace: cardFace,
      setCardFace: setCardFace,
      frontPostcardUrl: previewFront,
      backPostcardUrl: previewBack,
      comments: [],
      frontComments: [],
      backComments: [],
      doneFront: false,
      doneBack: false,
      mediaType: mediaType
    })
  });
};

var DesignConceptSelection = function DesignConceptSelection(props) {
  var _useDesignConceptModa = useDesignConceptModalSelector(),
      modalArgs = _useDesignConceptModa.modalArgs,
      closeModal = _useDesignConceptModa.closeModal,
      openConfirmSelectionModal = _useDesignConceptModa.openConfirmSelectionModal,
      openHelpModal = _useDesignConceptModa.openHelpModal,
      openVideoWalkthroughModal = _useDesignConceptModa.openVideoWalkthroughModal;

  var _useState35 = useState(undefined),
      _useState36 = _slicedToArray(_useState35, 2),
      openImageViewer = _useState36[0],
      setOpenImageViewer = _useState36[1];

  var closeImageViewer = function closeImageViewer() {
    setOpenImageViewer(undefined);
  };

  useEscape(closeImageViewer);

  var _useState37 = useState(false),
      _useState38 = _slicedToArray(_useState37, 2),
      split = _useState38[0],
      setSplit = _useState38[1];

  var _useState39 = useState(Number),
      _useState40 = _slicedToArray(_useState39, 2),
      boxWidth = _useState40[0],
      setBoxWidth = _useState40[1];

  var options = designConcepts;

  var _useState41 = useState(false),
      _useState42 = _slicedToArray(_useState41, 2),
      submitting = _useState42[0],
      setSubmitting = _useState42[1];

  var _useState43 = useState({
    front: {
      id: Object.keys(options)[0]
    },
    back: {
      id: Object.keys(options)[0]
    }
  }),
      _useState44 = _slicedToArray(_useState43, 2),
      selectedOption = _useState44[0],
      setSelectedOption = _useState44[1];

  var handleConfirmSelection = function handleConfirmSelection() {
    openConfirmSelectionModal({
      open: true,
      selectedOption: _objectSpread({
        split: split
      }, selectedOption),
      handleClickConfirm: function () {
        var _handleClickConfirm = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee5() {
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        function handleClickConfirm() {
          return _handleClickConfirm.apply(this, arguments);
        }

        return handleClickConfirm;
      }(),
      handleClickBack: closeModal,
      options: options
    });
  };

  return React.createElement(Fragment, null, React.createElement(Zoom, {
    in: typeof openImageViewer !== 'undefined',
    mountOnEnter: true,
    unmountOnExit: true
  }, React.createElement("div", null, React.createElement(DesignConceptPreview, {
    initialCardFace: openImageViewer !== null && openImageViewer !== void 0 ? openImageViewer : CardFace.Front,
    isSplit: split,
    handleConfirmSelection: handleConfirmSelection,
    closePreview: closeImageViewer,
    previewFront: options[selectedOption.front.id].front.src,
    previewBack: options[selectedOption.back.id].back.src,
    openHelpModal: openHelpModal,
    openVideoWalkthroughModal: openVideoWalkthroughModal
  }), React.createElement(DesignConceptModalSelector, {
    modalArgs: modalArgs,
    closeModal: closeModal
  }))), !openImageViewer && React.createElement(Fragment, null, React.createElement(Header, {
    title: "Design Concepts",
    buttons: React.createElement(Fragment, null, React.createElement(ActionsOverlayContainer, {
      openHelpModal: openHelpModal,
      openVideoWalkthroughModal: openVideoWalkthroughModal,
      menuButtonStyles: {
        color: 'rgba(0, 0, 0, 0.54)'
      }
    }))
  }), React.createElement("div", {
    style: {
      width: "".concat(boxWidth, "px"),
      margin: '0 auto',
      marginTop: '28px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  }, React.createElement("h4", {
    style: {
      margin: 0,
      fontSize: 22
    }
  }, split ? 'Choose a design combination.' : 'Choose a design concept.'), React.createElement("div", null, React.createElement(IconButton, {
    style: !split ? {
      color: '#ed154e'
    } : {},
    size: "small",
    onClick: function onClick() {
      setSplit(false);
    }
  }, React.createElement(Merge, null)))), React.createElement("div", {
    style: {
      marginTop: '12px'
    }
  }, React.createElement(ImageSlider, {
    images: options,
    initialState: _objectSpread({
      split: split
    }, selectedOption),
    split: split,
    onSelect: function onSelect(selected) {
      if (JSON.stringify(selectedOption) !== JSON.stringify(selected)) {
        setSelectedOption(selected);
      }
    },
    onClickImage: setOpenImageViewer,
    setBoxWidth: setBoxWidth
  })), React.createElement("div", {
    style: {
      width: "".concat(boxWidth, "px"),
      margin: '0 auto',
      marginTop: '28px'
    }
  }, React.createElement(Button$1, {
    style: {
      width: "".concat(boxWidth, "px"),
      background: '#ED154E'
    },
    variant: "contained",
    color: "primary",
    onClick: function () {
      var _onClick2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                setSubmitting(true);
                _context6.next = 3;
                return handleConfirmSelection();

              case 3:
                setSubmitting(false);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function onClick() {
        return _onClick2.apply(this, arguments);
      }

      return onClick;
    }(),
    disabled: submitting
  }, submitting && React.createElement(CircularProgress, {
    style: {
      color: '#fff',
      marginRight: 8
    },
    size: 25
  }), split ? 'Choose this combination' : 'Choose this concept')), React.createElement(DesignConceptModalSelector, {
    modalArgs: modalArgs,
    closeModal: closeModal
  })));
};

var NotificationTypes;

(function (NotificationTypes) {
  NotificationTypes["ReviewSuccess"] = "ReviewSuccess";
  NotificationTypes["PostReviewCommentError"] = "PostReviewCommentError";
  NotificationTypes["DeleteReviewCommentError"] = "DeleteReviewCommentError";
  NotificationTypes["UpdateReviewCommentError"] = "UpdateReviewCommentError";
  NotificationTypes["AcceptReviewCommentError"] = "AcceptReviewCommentError";
  NotificationTypes["RejectReviewCommentError"] = "RejectReviewCommentError";
  NotificationTypes["UndoAcceptedReviewCommentError"] = "UndoAcceptedReviewCommentError";
  NotificationTypes["UndoRejectedReviewCommentError"] = "UndoRejectedReviewCommentError";
})(NotificationTypes || (NotificationTypes = {}));

var NotificationsSelector = function NotificationsSelector() {
  var _useContext2 = useContext(UIStateContext.Scaffold),
      notificationsStatus = _useContext2.notificationsStatus;

  var _useContext3 = useContext(ActionsContext),
      removeNotification = _useContext3.removeNotification;

  var prevStatus = useRef(notificationsStatus);
  useEffect(function () {
    if (typeof notificationsStatus !== 'undefined') {
      prevStatus.current = notificationsStatus;
    }
  });
  return React.createElement(Snackbar$1, {
    open: typeof notificationsStatus !== 'undefined',
    autoHideDuration: 6000,
    onClose: removeNotification,
    style: {
      borderRadius: '4px'
    }
  }, React.createElement(NotificationMessage, {
    notificationsStatus: notificationsStatus !== null && notificationsStatus !== void 0 ? notificationsStatus : prevStatus.current,
    onClose: removeNotification
  }));
};

var NotificationMessage = function NotificationMessage(_ref36) {
  var onClose = _ref36.onClose,
      notificationsStatus = _ref36.notificationsStatus;

  if ((notificationsStatus === null || notificationsStatus === void 0 ? void 0 : notificationsStatus.type) === NotificationTypes.ReviewSuccess) {
    return React.createElement(Alert, {
      elevation: 6,
      variant: "filled",
      onClose: onClose,
      severity: "success",
      style: {
        backgroundColor: '#0d951b',
        fontSize: '1rem'
      }
    }, "Successfully finished reviewing ".concat(notificationsStatus.args.cardFace, " Design."));
  }

  if ((notificationsStatus === null || notificationsStatus === void 0 ? void 0 : notificationsStatus.type) === NotificationTypes.PostReviewCommentError) {
    return React.createElement(Alert, {
      elevation: 6,
      variant: "filled",
      onClose: onClose,
      severity: "error",
      style: {
        backgroundColor: '#ed154e',
        fontSize: '1rem'
      }
    }, "Error posting comment.");
  }

  if ((notificationsStatus === null || notificationsStatus === void 0 ? void 0 : notificationsStatus.type) === NotificationTypes.DeleteReviewCommentError) {
    return React.createElement(Alert, {
      elevation: 6,
      variant: "filled",
      onClose: onClose,
      severity: "error",
      style: {
        backgroundColor: '#ed154e',
        fontSize: '1rem'
      }
    }, "Error deleting comment.");
  }

  if ((notificationsStatus === null || notificationsStatus === void 0 ? void 0 : notificationsStatus.type) === NotificationTypes.UpdateReviewCommentError) {
    return React.createElement(Alert, {
      elevation: 6,
      variant: "filled",
      onClose: onClose,
      severity: "error",
      style: {
        backgroundColor: '#ed154e',
        fontSize: '1rem'
      }
    }, "Error updating comment.");
  }

  if ((notificationsStatus === null || notificationsStatus === void 0 ? void 0 : notificationsStatus.type) === NotificationTypes.AcceptReviewCommentError) {
    return React.createElement(Alert, {
      elevation: 6,
      variant: "filled",
      onClose: onClose,
      severity: "error",
      style: {
        backgroundColor: '#ed154e',
        fontSize: '1rem'
      }
    }, "Error accepting comment.");
  }

  if ((notificationsStatus === null || notificationsStatus === void 0 ? void 0 : notificationsStatus.type) === NotificationTypes.RejectReviewCommentError) {
    return React.createElement(Alert, {
      elevation: 6,
      variant: "filled",
      onClose: onClose,
      severity: "error",
      style: {
        backgroundColor: '#ed154e',
        fontSize: '1rem'
      }
    }, "Error rejecting comment.");
  }

  if ((notificationsStatus === null || notificationsStatus === void 0 ? void 0 : notificationsStatus.type) === NotificationTypes.UndoAcceptedReviewCommentError) {
    return React.createElement(Alert, {
      elevation: 6,
      variant: "filled",
      onClose: onClose,
      severity: "error",
      style: {
        backgroundColor: '#ed154e',
        fontSize: '1rem'
      }
    }, "Error undoing accepted comment.");
  }

  if ((notificationsStatus === null || notificationsStatus === void 0 ? void 0 : notificationsStatus.type) === NotificationTypes.UndoRejectedReviewCommentError) {
    return React.createElement(Alert, {
      elevation: 6,
      variant: "filled",
      onClose: onClose,
      severity: "error",
      style: {
        backgroundColor: '#ed154e',
        fontSize: '1rem'
      }
    }, "Error undoing rejected comment.");
  }

  return null;
};

var ConfirmAuthorizationForm = function ConfirmAuthorizationForm(_ref37) {
  var requireReview = _ref37.requireReview,
      requireAuthorization = _ref37.requireAuthorization,
      reviewText = _ref37.reviewText,
      authorizationText = _ref37.authorizationText,
      reviewError = _ref37.reviewError,
      authorizationError = _ref37.authorizationError,
      reviewed = _ref37.reviewed,
      setReviewed = _ref37.setReviewed,
      authorized = _ref37.authorized,
      setAuthorized = _ref37.setAuthorized,
      reviewHighlighted = _ref37.reviewHighlighted;

  if (!requireReview) {
    setReviewed(true);
  }

  var styles = useSpring({
    backgroundColor: reviewHighlighted ? 'rgb(255, 253, 181)' : '#fff',
    reviewErrorHeight: reviewed ? '0rem' : '2.3rem',
    authorizationErrorHeight: authorized ? '0rem' : '2.3rem'
  });
  var reviewErrorTransition = useTransition(reviewHighlighted && !reviewed, {
    from: {
      opacity: 0
    },
    enter: {
      opacity: 1
    },
    leave: {
      opacity: 0
    }
  });
  var authorizationErrorTransition = useTransition(reviewHighlighted && !authorized, {
    from: {
      opacity: 0
    },
    enter: {
      opacity: 1
    },
    leave: {
      opacity: 0
    }
  });
  return React.createElement(animated.div, {
    style: {
      borderRadius: '4px',
      padding: '1em',
      width: '100%',
      fontSize: '1rem',
      backgroundColor: styles.backgroundColor
    }
  }, requireReview ? React.createElement(Fragment, null, React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, React.createElement("span", null, React.createElement(Checkbox, {
    checked: reviewed,
    onChange: function onChange(_, c) {
      setReviewed(c);
    }
  })), reviewText), reviewErrorTransition(function (_ref38, item) {
    var opacity = _ref38.opacity;

    if (!item) {
      return null;
    }

    return React.createElement(animated.div, {
      style: {
        display: 'flex',
        justifyContent: 'center',
        opacity: opacity,
        height: styles.reviewErrorHeight
      }
    }, reviewError);
  })) : null, requireAuthorization ? React.createElement(Fragment, null, React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, React.createElement("span", null, React.createElement(Checkbox, {
    checked: authorized,
    onChange: function onChange(_, c) {
      setAuthorized(c);
    }
  })), authorizationText), authorizationErrorTransition(function (_ref39, item) {
    var opacity = _ref39.opacity;

    if (!item) {
      return null;
    }

    return React.createElement(animated.div, {
      style: {
        display: 'flex',
        justifyContent: 'center',
        opacity: opacity,
        height: styles.authorizationErrorHeight
      }
    }, authorizationError);
  })) : null);
};

var useConfirmAuthorizationForm = function useConfirmAuthorizationForm(args) {
  var _useState45 = useState(false),
      _useState46 = _slicedToArray(_useState45, 2),
      authorized = _useState46[0],
      setAuthorized = _useState46[1];

  var _useState47 = useState(false),
      _useState48 = _slicedToArray(_useState47, 2),
      reviewed = _useState48[0],
      setReviewed = _useState48[1];

  var _useState49 = useState(false),
      _useState50 = _slicedToArray(_useState49, 2),
      reviewHighlighted = _useState50[0],
      setReviewHighlighted = _useState50[1];

  var _useState51 = useState(false),
      _useState52 = _slicedToArray(_useState51, 2),
      notifyConceptDesigner = _useState52[0],
      setNotifyConceptDesigner = _useState52[1];

  return {
    requireReview: args.requireReview,
    requireAuthorization: args.requireAuthorization,
    authorized: authorized,
    setAuthorized: setAuthorized,
    reviewed: args.requireReview ? reviewed : true,
    setReviewed: setReviewed,
    reviewHighlighted: reviewHighlighted,
    setReviewHighlighted: setReviewHighlighted,
    notifyConceptDesigner: notifyConceptDesigner,
    setNotifyConceptDesigner: setNotifyConceptDesigner
  };
};

var ReviewText = function ReviewText(_ref40) {
  var noCommentSide = _ref40.noCommentSide;

  if (noCommentSide) {
    return React.createElement("span", null, "I reviewed both sides of the design (0 requests for the ", noCommentSide, ").");
  } else {
    return React.createElement("span", null, "I reviewed both sides of the design.");
  }
};

var AuthorizationText = function AuthorizationText(_ref41) {
  var isApproving = _ref41.isApproving,
      name = _ref41.name;

  if (isApproving) {
    return React.createElement("span", null, "I am authorized to approve this design as", ' ', React.createElement("span", {
      style: {
        fontWeight: 'bold'
      }
    }, name), ".");
  }

  return React.createElement("span", null, "I am authorized to request changes as", ' ', React.createElement("span", {
    style: {
      fontWeight: 'bold'
    }
  }, name), ".");
};

var ReviewError = function ReviewError() {
  return React.createElement("span", {
    style: {
      color: Colors.MVP_RED,
      padding: '0.2rem',
      borderRadius: '4px',
      fontSize: '0.8rem'
    }
  }, "*Please confirm that you have reviewed both sides of the design.");
};

var AuthorizationError = function AuthorizationError(_ref42) {
  var isApproving = _ref42.isApproving;

  if (isApproving) {
    return React.createElement("span", {
      style: {
        color: Colors.MVP_RED,
        padding: '0.2rem',
        borderRadius: '4px',
        fontSize: '0.8rem'
      }
    }, "*Please confirm that you are authorized to approve this design.");
  }

  return React.createElement("span", {
    style: {
      color: Colors.MVP_RED,
      padding: '0.2rem',
      borderRadius: '4px',
      fontSize: '0.8rem'
    }
  }, "*Please confirm that you are authorized to request changes.");
};

var ModalTypes;

(function (ModalTypes) {
  ModalTypes["Welcome"] = "Welcome";
  ModalTypes["RevisionReviewWelcome"] = "Revision Review Welcome";
  ModalTypes["Help"] = "Help";
  ModalTypes["VideoWalkthrough"] = "Video Walkthrough";
  ModalTypes["DeleteComment"] = "Delete Comment";
  ModalTypes["DeleteAllComments"] = "Discard All Comments";
  ModalTypes["ConfirmAcceptRejectedComment"] = "Confirm Accept Rejected Comment";
  ModalTypes["FinalizeRequests"] = "Finalize Requests";
  ModalTypes["SuccessfullySubmittedRequests"] = "Successfully Submitted Requests";
  ModalTypes["CustomerSuccessfullySubmittedRequests"] = "Customer Successfully Submitted Requests";
  ModalTypes["SuccessfullySubmittedRevisions"] = "Successfully Submitted Revisions";
  ModalTypes["DesignInProgress"] = "Design in Progress";
  ModalTypes["FinalLook"] = "Final Look";
  ModalTypes["ConfirmSubmission"] = "Confirm Submission";
  ModalTypes["MovedToNextReview"] = "Moved to Next Review";
  ModalTypes["ApproveDesign"] = "Approve Design";
  ModalTypes["DesignApproved"] = "Design Approved";
  ModalTypes["UndoRejectedComment"] = "Undo Rejected Comment";
  ModalTypes["UndoAcceptedComment"] = "Undo Accepted Comment";
  ModalTypes["DesignRequestDetails"] = "Design Request Details";
  ModalTypes["PrePressCampaignMedia"] = "Pre Press Campaign Media";
  ModalTypes["CampaignMediaApproved"] = "Campaign Media Approved";
  ModalTypes["CampaignMediaRejected"] = "Campaign Media Rejected";
})(ModalTypes || (ModalTypes = {}));

var ModalVariant;

(function (ModalVariant) {
  ModalVariant[ModalVariant["Default"] = 0] = "Default";
  ModalVariant[ModalVariant["Customer"] = 1] = "Customer";
})(ModalVariant || (ModalVariant = {}));

var ApproveDesignModalContents = function ApproveDesignModalContents() {
  var _useContext4 = useContext(DesignContext.Derived),
      currentUser = _useContext4.currentUser,
      nextReview = _useContext4.nextReview;

  var _useContext5 = useContext(DerivedActionsContext),
      handlers = _useContext5.handlers;

  var _useContext6 = useContext(UIStateContext.Scaffold),
      hasViewedBack = _useContext6.hasViewedBack;

  var _useContext7 = useContext(UIStateContext.Derived.Scaffold),
      frontPostcardUrl = _useContext7.frontPostcardUrl,
      backPostcardUrl = _useContext7.backPostcardUrl;

  var _useContext8 = useContext(UIStateContext.Derived.ImageViewer),
      isPortrait = _useContext8.isPortrait;

  var _useContext9 = useContext(DesignContext.Base),
      viewedAs = _useContext9.viewedAs,
      experience = _useContext9.experience;

  var _useContext10 = useContext(ActionsContext),
      closeModal = _useContext10.closeModal,
      openModal = _useContext10.openModal;

  var _useState53 = useState(false),
      _useState54 = _slicedToArray(_useState53, 2),
      isLoading = _useState54[0],
      setIsLoading = _useState54[1];

  var confirmAuthorizationFormProps = useConfirmAuthorizationForm({
    requireReview: !hasViewedBack,
    requireAuthorization: true
  });
  return React.createElement("div", {
    style: {
      maxWidth: '768px'
    }
  }, React.createElement("div", {
    style: {
      textAlign: 'center',
      marginBottom: '1.5rem'
    }
  }, React.createElement(Typography, {
    variant: "h4",
    component: "h2",
    style: {
      fontWeight: 'bold',
      marginBottom: '1rem'
    }
  }, "Approval Confirmation")), React.createElement(ThumbnailsWithMarkers, {
    thumbnails: [{
      src: frontPostcardUrl,
      alt: 'Front Design',
      markers: []
    }, {
      src: backPostcardUrl,
      alt: 'Back Design',
      markers: []
    }],
    MarkerComponent: PlainNumberedBadge,
    markerOverlay: React.createElement(Fragment, null, React.createElement("div", {
      style: {
        gridArea: "1 / 1 / 2 / 2",
        width: '100%',
        height: '100%',
        position: 'relative',
        zIndex: 2
      }
    }, React.createElement("div", {
      style: {
        position: 'absolute',
        right: 8,
        top: 8,
        color: 'white'
      }
    }, React.createElement(CheckedBadge, null))), React.createElement("div", {
      style: {
        gridArea: "1 / 2 / 2 / 3",
        width: '100%',
        height: '100%',
        position: 'relative',
        zIndex: 1
      }
    }, React.createElement("div", {
      style: {
        position: 'absolute',
        right: 8,
        top: 8,
        color: 'white'
      }
    }, React.createElement(CheckedBadge, null)))),
    isPortrait: isPortrait
  }), React.createElement(ConfirmAuthorizationForm, Object.assign({}, confirmAuthorizationFormProps, {
    reviewText: React.createElement(ReviewText, null),
    authorizationText: React.createElement(AuthorizationText, {
      isApproving: true,
      name: currentUser.name
    }),
    reviewError: React.createElement(ReviewError, null),
    authorizationError: React.createElement(AuthorizationError, {
      isApproving: true
    })
  })), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    }
  }, React.createElement(Button$1, {
    style: {
      backgroundColor: Colors.MVP_LIGHT_PINK,
      marginBottom: '0.5rem',
      color: '#fff'
    },
    variant: "contained",
    disabled: isLoading,
    onClick: function () {
      var _onClick3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(confirmAuthorizationFormProps.reviewed && confirmAuthorizationFormProps.authorized)) {
                  _context7.next = 29;
                  break;
                }

                setIsLoading(true);
                _context7.prev = 2;

                if (!( // tools app only
                viewedAs === DesignReviewViewedAs.Default && // campaign review only
                experience === DesignReviewExperience.CampaignReview)) {
                  _context7.next = 17;
                  break;
                }

                _context7.prev = 4;

                if (!(handlers === null || handlers === void 0 ? void 0 : handlers.campaignMediaApprove)) {
                  _context7.next = 8;
                  break;
                }

                _context7.next = 8;
                return handlers.campaignMediaApprove();

              case 8:
                openModal({
                  type: ModalTypes.CampaignMediaApproved
                });
                _context7.next = 15;
                break;

              case 11:
                _context7.prev = 11;
                _context7.t0 = _context7["catch"](4);
                closeModal();
                setIsLoading(false);

              case 15:
                _context7.next = 20;
                break;

              case 17:
                _context7.next = 19;
                return handlers.submitDesignReview(confirmAuthorizationFormProps.notifyConceptDesigner);

              case 19:
                if (nextReview === DesignStatus.FinalInspection || nextReview === DesignStatus.Approved) {
                  openModal({
                    type: ModalTypes.DesignApproved
                  });
                } else {
                  openModal({
                    type: ModalTypes.MovedToNextReview
                  });
                }

              case 20:
                return _context7.abrupt("return");

              case 23:
                _context7.prev = 23;
                _context7.t1 = _context7["catch"](2);
                throw new Error(_context7.t1);

              case 26:
                setIsLoading(false);
                _context7.next = 30;
                break;

              case 29:
                confirmAuthorizationFormProps.setReviewHighlighted(true);

              case 30:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[2, 23], [4, 11]]);
      }));

      function onClick() {
        return _onClick3.apply(this, arguments);
      }

      return onClick;
    }()
  }, "Confirm Approval", isLoading && React.createElement(CircularProgress, {
    style: {
      color: '#fff',
      width: 20,
      height: 20,
      marginLeft: 8,
      marginTop: -2
    }
  })), React.createElement(Button$1, {
    style: {
      backgroundColor: 'white'
    },
    variant: "outlined",
    onClick: closeModal
  }, "Go Back to Review")));
};

var ApproveDesignModal = function ApproveDesignModal(_ref43) {
  var open = _ref43.open;

  var _useContext11 = useContext(ActionsContext),
      closeModal = _useContext11.closeModal;

  return React.createElement(Dialog$1, {
    open: open,
    TransitionComponent: SlideUpTransition,
    onBackdropClick: closeModal
  }, React.createElement("div", {
    style: {
      backgroundColor: '#fff',
      minWidth: '550px',
      maxWidth: '1024px',
      padding: '2.5rem 3rem',
      borderRadius: '4px',
      outline: 'none'
    }
  }, React.createElement(ApproveDesignModalContents, null)));
};

var DesignerChecklistForm = function DesignerChecklistForm(_ref44) {
  var steps = _ref44.steps;
  return React.createElement(Fragment, null, React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      margin: '20px 0px'
    }
  }, steps.map(function (step) {
    return React.createElement("span", {
      style: {
        background: step.done || step.isCurrent ? Colors.MVP_RED : '#A3A3A3',
        height: 24,
        width: 24,
        color: '#fff',
        borderRadius: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: 8
      }
    }, step.done ? React.createElement(Check, {
      style: {
        height: 20,
        width: 20
      }
    }) : step.number);
  })));
};

var CampaignDesignerChecklistForm = function CampaignDesignerChecklistForm(_ref45) {
  var trackingNumber = _ref45.trackingNumber,
      setTrackingNumber = _ref45.setTrackingNumber,
      logisticsId = _ref45.logisticsId,
      setLogisticsId = _ref45.setLogisticsId,
      reviewHighlighted = _ref45.reviewHighlighted,
      setReviewHighlighted = _ref45.setReviewHighlighted;
  var styles = useSpring({
    backgroundColor: reviewHighlighted ? 'rgb(255, 253, 181)' : '#fff',
    trackingNumberErrorHeight: trackingNumber ? '0rem' : '2.3rem',
    logisticsIdErrorHeight: logisticsId ? '0rem' : '2.3rem'
  });
  var opacityTransition = {
    from: {
      opacity: 0
    },
    enter: {
      opacity: 1
    },
    leave: {
      opacity: 0
    }
  };
  var trackingNumberErrorTransition = useTransition(reviewHighlighted && !trackingNumber, opacityTransition);
  var logisticsIdErrorTransition = useTransition(reviewHighlighted && !logisticsId, opacityTransition);
  var errorTextStyle = {
    color: Colors.MVP_RED,
    padding: '0.2rem',
    borderRadius: '4px',
    fontSize: '0.8rem'
  };
  return React.createElement(animated.div, {
    style: {
      borderRadius: '4px',
      padding: '1em',
      width: '100%',
      fontSize: '1rem',
      backgroundColor: styles.backgroundColor
    }
  }, React.createElement(Fragment, null, React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: '3.6rem'
    }
  }, React.createElement("span", null, React.createElement(Checkbox, {
    checked: trackingNumber,
    onChange: function onChange(_, c) {
      setTrackingNumber(c);
    }
  })), React.createElement("span", null, "Have you updated all tracking numbers?")), trackingNumberErrorTransition(function (_ref46, item) {
    var opacity = _ref46.opacity;

    if (!item) {
      return null;
    }

    return React.createElement(animated.div, {
      style: {
        display: 'flex',
        justifyContent: 'center',
        opacity: opacity,
        height: styles.trackingNumberErrorHeight
      }
    }, React.createElement("span", {
      style: errorTextStyle
    }, "*Please confirm that all tracking numbers are updated in MVP Design."));
  })), React.createElement(Fragment, null, React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: '3.6rem'
    }
  }, React.createElement("span", null, React.createElement(Checkbox, {
    checked: logisticsId,
    onChange: function onChange(_, c) {
      setLogisticsId(c);
    }
  })), React.createElement("span", null, "Have you updated all logistics id?")), logisticsIdErrorTransition(function (_ref47, item) {
    var opacity = _ref47.opacity;

    if (!item) {
      return null;
    }

    return React.createElement(animated.div, {
      style: {
        display: 'flex',
        justifyContent: 'center',
        opacity: opacity,
        height: styles.logisticsIdErrorHeight
      }
    }, React.createElement("span", {
      style: errorTextStyle
    }, "*Please confirm that you have updated the logistics id in MVP Design."));
  })));
};

var useCampaignDesignerChecklistForm = function useCampaignDesignerChecklistForm() {
  var _useState55 = useState(false),
      _useState56 = _slicedToArray(_useState55, 2),
      trackingNumber = _useState56[0],
      setTrackingNumber = _useState56[1];

  var _useState57 = useState(false),
      _useState58 = _slicedToArray(_useState57, 2),
      logisticsId = _useState58[0],
      setLogisticsId = _useState58[1];

  var _useState59 = useState(false),
      _useState60 = _slicedToArray(_useState59, 2),
      reviewHighlighted = _useState60[0],
      setReviewHighlighted = _useState60[1];

  var validate = function validate() {
    return trackingNumber && logisticsId;
  };

  return {
    trackingNumber: trackingNumber,
    setTrackingNumber: setTrackingNumber,
    logisticsId: logisticsId,
    setLogisticsId: setLogisticsId,
    reviewHighlighted: reviewHighlighted,
    setReviewHighlighted: setReviewHighlighted,
    validate: validate
  };
};

var ActionsCircularProgress = function ActionsCircularProgress() {
  return React.createElement(CircularProgress, {
    style: {
      marginLeft: '8px',
      color: 'white',
      width: '1.2rem',
      height: '1.2rem'
    }
  });
};

var ViewingAreaPlaceholder = function ViewingAreaPlaceholder() {
  return React.createElement("div", {
    style: {
      display: 'grid',
      placeItems: 'center',
      width: '100%',
      height: '100%'
    }
  }, React.createElement(Terrain, {
    style: {
      color: '#727272',
      fontSize: '30rem'
    }
  }));
};

var useStepper = function useStepper() {
  var highlight = {
    textDecoration: 'underline',
    color: Colors.MVP_RED
  };
  var red = {
    color: Colors.MVP_RED
  };
  var heading = {
    fontSize: 25,
    color: Colors.MVP_RED
  };

  var _useState61 = useState(false),
      _useState62 = _slicedToArray(_useState61, 2),
      isPassed = _useState62[0],
      setIsPassed = _useState62[1];

  var _useState63 = useState([{
    number: 1,
    image: null,
    headingText: React.createElement("span", {
      style: heading
    }, "Confirm Submission"),
    desc: React.createElement("p", null, "Please be sure that the following items have been properly checked."),
    isCurrent: true,
    done: false
  }, {
    number: 2,
    image: FontIcon,
    headingText: React.createElement("span", {
      style: heading
    }, "Are these ", React.createElement("span", {
      style: highlight
    }, "fonts"), " in MVP Design?"),
    desc: React.createElement("p", null, "Have you checked all ", React.createElement("span", {
      style: highlight
    }, "fonts"), " if they are used and placed in ", React.createElement("span", {
      style: red
    }, "MVP Design"), "?"),
    isCurrent: false,
    done: false
  }, {
    number: 3,
    image: ImageIcon,
    headingText: React.createElement("span", {
      style: heading
    }, "Are the images ", React.createElement("span", {
      style: highlight
    }, "embedded"), "?"),
    desc: React.createElement("p", null, "Please make sure that the ", React.createElement("span", {
      style: highlight
    }, "images"), " placed are all ", React.createElement("span", {
      style: highlight
    }, "embedded"), " within the file."),
    isCurrent: false,
    done: false
  }, {
    number: 4,
    image: AIIcon,
    headingText: React.createElement("span", {
      style: heading
    }, "Is the AI file less than ", React.createElement("span", {
      style: highlight
    }, "50mb"), "?"),
    desc: React.createElement("p", null, "Check the ", React.createElement("span", {
      style: highlight
    }, "file size"), " if it is less than", ' ', React.createElement("span", {
      style: highlight
    }, "50MB.")),
    isCurrent: false,
    done: false
  }]),
      _useState64 = _slicedToArray(_useState63, 2),
      steps = _useState64[0],
      setSteps = _useState64[1];

  var currentIndex = steps.findIndex(function (step) {
    return step.isCurrent;
  });

  var onSelectNext = function onSelectNext(currentIndex) {
    var _steps = steps;
    var nextIndex = currentIndex + 1;
    _steps = _steps.map(function (step, index) {
      if (index < steps.length) {
        if (index === currentIndex) {
          return _objectSpread({}, step, {
            done: true,
            isCurrent: false
          });
        }

        if (index === nextIndex) {
          return _objectSpread({}, step, {
            done: false,
            isCurrent: true
          });
        }
      }

      return _objectSpread({}, step);
    });

    if (currentIndex < steps.length - 1) {
      setSteps(_steps);
    }

    if (currentIndex === steps.length - 2) {
      setIsPassed(true);
    }
  };

  return {
    steps: steps,
    onSelectNext: onSelectNext,
    currentIndex: currentIndex,
    isPassed: isPassed
  };
};

var ConfirmSubmissionModalContents = function ConfirmSubmissionModalContents() {
  var _useContext12 = useContext(CommentsStore.DerivedComments),
      frontComments = _useContext12.front,
      backComments = _useContext12.back;

  var _useContext13 = useContext(UIStateContext.Derived.Scaffold),
      frontPostcardUrl = _useContext13.frontPostcardUrl,
      backPostcardUrl = _useContext13.backPostcardUrl;

  var _useContext14 = useContext(ActionsContext),
      closeModal = _useContext14.closeModal,
      openModal = _useContext14.openModal;

  var _useContext15 = useContext(DerivedActionsContext),
      handlers = _useContext15.handlers;

  var _useContext16 = useContext(DesignContext.Base),
      experience = _useContext16.experience;

  var _useContext17 = useContext(UIStateContext.Derived.ImageViewer),
      isPortrait = _useContext17.isPortrait;

  var _useState65 = useState(false),
      _useState66 = _slicedToArray(_useState65, 2),
      isLoading = _useState66[0],
      setIsLoading = _useState66[1];

  var isDesignConceptExperience = experience === DesignReviewExperience.DesignConcept;
  var campaignDesignerChecklistFormProps = useCampaignDesignerChecklistForm();
  var checklistProps = campaignDesignerChecklistFormProps;

  var _useState67 = useState(false),
      _useState68 = _slicedToArray(_useState67, 2),
      hasError = _useState68[0],
      setHasError = _useState68[1];

  var handleClose = function handleClose() {
    setHasError(false);
  };

  var _useStepper = useStepper(),
      steps = _useStepper.steps,
      currentIndex = _useStepper.currentIndex,
      onSelectNext = _useStepper.onSelectNext,
      isPassed = _useStepper.isPassed;

  var _currentStep = steps[currentIndex];
  return React.createElement("div", {
    style: {
      width: '544px',
      padding: '0.75em 2em'
    }
  }, React.createElement("div", {
    style: {
      textAlign: 'center',
      marginBottom: '1em'
    }
  }, React.createElement(Typography, {
    variant: "h4",
    component: "h2",
    style: {
      fontWeight: 'bold'
    }
  }, _currentStep.headingText)), _currentStep.image ? React.createElement("div", {
    style: {
      textAlign: 'center'
    }
  }, React.createElement("img", {
    src: _currentStep.image
  })) : React.createElement("div", {
    style: isDesignConceptExperience ? {
      marginTop: 30
    } : {}
  }, React.createElement(ThumbnailsWithMarkers, {
    thumbnails: [{
      src: frontPostcardUrl,
      alt: 'Front Postcard',
      markers: frontComments
    }, {
      src: backPostcardUrl,
      alt: 'Back Postcard',
      markers: backComments
    }],
    MarkerComponent: PlainNumberedBadge,
    TooltipComponent: Tooltip,
    isPortrait: isPortrait
  })), isDesignConceptExperience ? React.createElement(Fragment, null, React.createElement("p", {
    style: {
      color: '#888888',
      textAlign: 'center',
      fontSize: 14,
      marginTop: 20
    }
  }, _currentStep.desc), React.createElement(DesignerChecklistForm, {
    steps: steps
  })) : React.createElement(CampaignDesignerChecklistForm, Object.assign({}, campaignDesignerChecklistFormProps)), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      marginTop: '1rem'
    }
  }, React.createElement(Button$1, {
    style: {
      backgroundColor: '#ed154e',
      marginBottom: '.5em',
      color: '#fff'
    },
    disabled: isLoading,
    variant: "contained",
    onClick: function onClick() {
      var submit =
      /*#__PURE__*/
      function () {
        var _ref48 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee8() {
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  setIsLoading(true);
                  setHasError(false);
                  _context8.prev = 2;
                  _context8.next = 5;
                  return handlers.submitRevisions();

                case 5:
                  openModal({
                    type: ModalTypes.SuccessfullySubmittedRevisions
                  });
                  _context8.next = 12;
                  break;

                case 8:
                  _context8.prev = 8;
                  _context8.t0 = _context8["catch"](2);
                  setHasError(true);
                  setIsLoading(false);

                case 12:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8, null, [[2, 8]]);
        }));

        return function submit() {
          return _ref48.apply(this, arguments);
        };
      }();

      if (isDesignConceptExperience) {
        if (isPassed) {
          submit();
        } else {
          onSelectNext(currentIndex);
        }
      } else {
        if (checklistProps.validate()) {
          submit();
        } else {
          checklistProps.setReviewHighlighted(true);
        }
      }
    }
  }, "Confirm", isLoading ? React.createElement(ActionsCircularProgress, null) : null), React.createElement(Snackbar$1, {
    open: hasError,
    autoHideDuration: 4000,
    onClose: handleClose
  }, React.createElement(Alert, {
    onClose: handleClose,
    severity: "error"
  }, "Sorry! that didn't work. Try to click submit again")), React.createElement(Button$1, {
    style: {
      backgroundColor: 'white',
      color: '#ed154e',
      border: '1px solid #ed154e'
    },
    variant: "outlined",
    onClick: closeModal
  }, "Go Back")));
};

var ConfirmSubmissionModal = function ConfirmSubmissionModal(_ref49) {
  var open = _ref49.open;

  var _useContext18 = useContext(ActionsContext),
      closeModal = _useContext18.closeModal;

  return React.createElement(Dialog$1, {
    open: open,
    TransitionComponent: SlideUpTransition,
    onBackdropClick: closeModal,
    PaperProps: {
      style: {
        overflow: 'visible'
      }
    }
  }, React.createElement("div", {
    style: {
      backgroundColor: '#fff',
      minWidth: '500px',
      maxWidth: '1024px',
      padding: '2em',
      borderRadius: '4px',
      outline: 'none'
    }
  }, React.createElement(ConfirmSubmissionModalContents, null)));
};

var useDesignApprovedModalStyles = makeStyles({
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 10,
    backgroundColor: '#232323',
    color: '#f9f9f9',
    width: '100vw',
    height: '100vh',
    display: 'grid',
    gridTemplate: '3fr 10fr 4fr / 1fr 3fr 3fr 1fr',
    overflow: 'scroll'
  },
  topSection: {
    gridArea: '1 / 2 / span 1 / span 2',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '2em'
  },
  title: {
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: '2.4rem'
  },
  middleLeftSection: {
    gridArea: '2 / 2 / span 1 / span 1',
    display: 'flex',
    flexDirection: 'column',
    // justifyContent: 'space-between',
    paddingRight: '2em',
    paddingBottom: '4em',
    '& > div': {
      width: '100%'
    }
  },
  middleRightSection: {
    gridArea: '2 / 3 / span 1 / span 1',
    display: 'flex',
    justifyContent: 'center',
    paddingLeft: '2em',
    paddingBottom: '4em',
    width: '100%',
    height: '100%',
    borderRadius: '4px'
  },
  bottomLeftSpacer: {
    gridArea: '3 / 1 / span 1 / span 1',
    backgroundColor: '#141414'
  },
  bottomLeftSection: {
    gridArea: '3 / 2 / span 1 / span 1',
    backgroundColor: '#141414',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    height: '100%',
    paddingTop: '2em',
    paddingBottom: '2em'
  },
  bottomRightSection: {
    gridArea: '3 / 3 / span 1 / span 1',
    backgroundColor: '#141414',
    fontSize: '1.1eem',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '2em',
    paddingBottom: '2em'
  },
  bottomRightSpacer: {
    gridArea: '3 / 4 / span 1 / span 1',
    backgroundColor: '#141414'
  },
  singleColumn: {
    flexDirection: 'column-reverse',
    gridColumnEnd: 'span 2'
  }
});
var useMailingsTableStyles = makeStyles({
  table: {
    backgroundColor: '#2e2e2e'
  },
  tableHeader: {
    borderBottomColor: '#232323',
    fontWeight: 'bold',
    color: '#f9f9f9'
  },
  tableCell: {
    borderBottomColor: '#232323',
    color: '#f9f9f9'
  },
  tableCellZone: {
    display: 'flex',
    alignItems: 'center',
    '& > *:first-child': {
      marginRight: '0.5em'
    }
  },
  colorBox: {
    width: '12px',
    height: '12px'
  },
  tableFineprint: {
    marginTop: '0.5em',
    fontStyle: 'italic',
    color: 'grey'
  }
});

var MailingsTable = function MailingsTable(_ref50) {
  var mailings = _ref50.mailings;
  var classes = useMailingsTableStyles();
  return React.createElement("div", null, React.createElement(TableContainer, {
    component: Paper,
    className: classes.table
  }, React.createElement(Table$1, null, React.createElement(TableHead, null, React.createElement(TableRow, null, React.createElement(TableCell, {
    className: classes.tableHeader
  }, "Target Delivery"), React.createElement(TableCell, {
    className: classes.tableHeader
  }, "Quantity"), React.createElement(TableCell, {
    className: classes.tableHeader
  }, "Zone"), React.createElement(TableCell, {
    className: classes.tableHeader,
    align: "right"
  }, "Tracking"))), React.createElement(TableBody, null, mailings.map(function (mailing) {
    return React.createElement(TableRow, {
      key: mailing.id
    }, React.createElement(TableCell, {
      className: classes.tableCell
    }, mailing.tdw), React.createElement(TableCell, {
      className: classes.tableCell
    }, mailing.quantity), React.createElement(TableCell, {
      className: classes.tableCell
    }, React.createElement("div", {
      className: classes.tableCellZone
    }, React.createElement("div", null, mailing.zone), React.createElement("div", {
      className: classes.colorBox,
      style: {
        backgroundColor: mailing.zoneColor
      }
    }))), React.createElement(TableCell, {
      className: classes.tableCell,
      align: "right"
    }, mailing.tracking.length ? mailing.tracking : React.createElement("i", null, "Coming soon")));
  })))), React.createElement("div", {
    className: classes.tableFineprint
  }, "*Payment is due when postcards print (~2 weeks before delivery)"));
};

var PostcardPreviews = function PostcardPreviews(_ref51) {
  var frontPostcardUrl = _ref51.frontPostcardUrl,
      backPostcardUrl = _ref51.backPostcardUrl,
      isFullWidth = _ref51.isFullWidth;

  var _a;

  var oneRem = parseFloat(getComputedStyle(document.documentElement).fontSize);

  var _useState69 = useState(),
      _useState70 = _slicedToArray(_useState69, 2),
      containerRef = _useState70[0],
      setContainerRef = _useState70[1];

  var width = (((_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.clientWidth) !== null && _a !== void 0 ? _a : 0) - oneRem) / 2;
  var height = width * 6 / 11;
  return React.createElement("div", {
    ref: function ref(newRef) {
      return setContainerRef(newRef);
    }
  }, React.createElement("div", {
    style: {
      marginBottom: '1em',
      marginTop: '2em',
      color: 'grey',
      fontWeight: 'bold'
    }
  }, !isFullWidth ? 'Design' : 'Front', isFullWidth && React.createElement("span", {
    style: {
      float: 'right'
    }
  }, "Back")), React.createElement("div", {
    style: {
      width: '100%',
      height: height,
      marginBottom: 16,
      overflowY: 'hidden'
    }
  }, React.createElement(ThumbnailsWithMarkers, {
    thumbnails: [{
      src: frontPostcardUrl,
      alt: 'Front Design',
      markers: []
    }, {
      src: backPostcardUrl,
      alt: 'Back Design',
      markers: []
    }],
    MarkerComponent: PlainNumberedBadge
  })));
};

var MailingAreaMap = function MailingAreaMap(_ref52) {
  var officeMarkerUrl = _ref52.officeMarkerUrl,
      officeMarkerCoordinates = _ref52.officeMarkerCoordinates,
      carrierRoutes = _ref52.carrierRoutes;

  var _a, _b;

  var features = [];
  var paths = carrierRoutes.reduce(function (acc, carrierRoute) {
    var multiPolygon = latlngLiteralToGeoJson(carrierRoute.paths);
    features.push(multiPolygon);
    var nextPaths = carrierRoute.paths.map(function (paths, index) {
      return React.createElement(Polygon, {
        key: "".concat(carrierRoute.carrierRoute, "-").concat(index),
        paths: paths,
        options: carrierRoute.options
      });
    });
    return [].concat(_toConsumableArray(acc), _toConsumableArray(nextPaths));
  }, []);
  var featureCollection$1 = featureCollection(features);
  var center = getCenter(featureCollection$1);
  return React.createElement(GoogleMap, {
    containerElement: React.createElement("div", {
      style: {
        height: '100%',
        width: '100%'
      }
    }),
    mapElement: React.createElement("div", {
      style: {
        height: '100%',
        borderRadius: '4px'
      }
    }),
    defaultZoom: 11,
    defaultCenter: center.geometry ? {
      lat: (_a = center.geometry) === null || _a === void 0 ? void 0 : _a.coordinates[1],
      lng: (_b = center.geometry) === null || _b === void 0 ? void 0 : _b.coordinates[0]
    } : officeMarkerCoordinates
  }, React.createElement(Marker$1, {
    icon: {
      url: officeMarkerUrl,
      scaledSize: new window.google.maps.Size(26, 26)
    },
    position: officeMarkerCoordinates
  }), paths);
};

var latlngLiteralToGeoJson = function latlngLiteralToGeoJson(paths) {
  return multiPolygon(paths.map(function (path) {
    return path.map(function (points) {
      return points.map(function (point) {
        return [point.lng, point.lat];
      });
    });
  }));
};

var BottomLeftSection = function BottomLeftSection() {
  return React.createElement(Fragment, null, React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, React.createElement("div", {
    style: {
      marginBottom: '1em'
    }
  }, React.createElement("span", {
    style: {
      marginRight: '0.5em',
      color: '#929292'
    }
  }, "4x6 Handout"), React.createElement("span", {
    style: {
      fontStyle: 'italic',
      color: '#ed154e',
      fontWeight: 'bold'
    }
  }, "NEW!")), React.createElement("div", {
    style: {
      width: '128px',
      height: '128px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, React.createElement("img", {
    alt: "4x6 Handout",
    src: Src4x6Handout,
    style: {
      height: '7rem'
    }
  }))), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, React.createElement("div", {
    style: {
      marginBottom: '1em'
    }
  }, React.createElement("span", {
    style: {
      marginRight: '0.5em',
      color: '#929292'
    }
  }, "Print Kits"), React.createElement("span", {
    style: {
      fontStyle: 'italic',
      color: '#ed154e',
      fontWeight: 'bold'
    }
  }, "NEW!")), React.createElement("div", {
    style: {
      width: '128px',
      height: '128px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, React.createElement("img", {
    alt: "Print Kits",
    src: SrcPrintKits,
    style: {
      height: '8rem',
      paddingLeft: '2rem'
    }
  }))), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, React.createElement("div", {
    style: {
      marginBottom: '1em'
    }
  }, React.createElement("span", {
    style: {
      marginRight: '0.5em',
      color: '#929292'
    }
  }, "Logo Redesign"), React.createElement("span", {
    style: {
      fontStyle: 'italic',
      color: '#ed154e',
      fontWeight: 'bold'
    }
  }, "NEW!")), React.createElement("div", {
    style: {
      width: '128px',
      height: '128px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, React.createElement("img", {
    alt: "Logo Redesign",
    src: SrcLogoRedesign,
    style: {
      height: '6.5rem'
    }
  }))));
};

var BottomRightSection = function BottomRightSection(_ref53) {
  var onClickOrderNow = _ref53.onClickOrderNow;
  return React.createElement("div", null, React.createElement("div", {
    style: {
      fontSize: '1.2rem',
      marginBottom: '1em',
      fontStyle: 'italic'
    }
  }, "Get ", React.createElement("span", {
    style: {
      textDecoration: 'underline',
      fontSize: '1em',
      fontWeight: 'bold'
    }
  }, "10% Off"), " these products when you order right now!"), React.createElement(Button$1, {
    onClick: onClickOrderNow,
    style: {
      backgroundColor: '#ed154e',
      color: '#f9f9f9',
      padding: '.75rem 1.75rem',
      textTransform: 'uppercase',
      fontWeight: 'bold'
    },
    variant: "contained"
  }, "Order Now & Get 10% Off"));
};

var DesignApprovedModalBase = function DesignApprovedModalBase() {
  var _useContext19 = useContext(DesignReviewContext),
      mailingDetails = _useContext19.mailingDetails;

  var _useContext20 = useContext(UIStateContext.Derived.Scaffold),
      frontPostcardUrl = _useContext20.frontPostcardUrl,
      backPostcardUrl = _useContext20.backPostcardUrl;

  var classes = useDesignApprovedModalStyles();
  var hasMailings = !!(mailingDetails === null || mailingDetails === void 0 ? void 0 : mailingDetails.mailings) && !isEmpty(mailingDetails.mailings);
  var hasMailingAreaMap = !!(mailingDetails === null || mailingDetails === void 0 ? void 0 : mailingDetails.carrierRoutes) && !isEmpty(mailingDetails.carrierRoutes);
  return React.createElement(Slide, {
    in: true,
    mountOnEnter: true,
    unmountOnExit: true
  }, React.createElement("div", {
    className: classes.container
  }, React.createElement("div", {
    className: classes.topSection
  }, React.createElement(Typography, {
    variant: "h4",
    component: "h2",
    className: classes.title
  }, "Your ", hasMailings ? 'Campaign' : 'Design', " is Approved!")), React.createElement("div", {
    className: cx(classes.middleLeftSection, !hasMailingAreaMap && classes.singleColumn)
  }, hasMailings && React.createElement(MailingsTable, {
    mailings: mailingDetails.mailings
  }), React.createElement(PostcardPreviews, {
    isFullWidth: !hasMailings || !hasMailingAreaMap,
    frontPostcardUrl: frontPostcardUrl,
    backPostcardUrl: backPostcardUrl
  })), hasMailings && hasMailingAreaMap && React.createElement("div", {
    className: classes.middleRightSection
  }, React.createElement(MailingAreaMap, {
    officeMarkerUrl: mailingDetails.officeMarkerUrl,
    officeMarkerCoordinates: mailingDetails.officeMarkerCoordinates,
    carrierRoutes: mailingDetails.carrierRoutes
  })), React.createElement("div", {
    className: classes.bottomLeftSpacer
  }), React.createElement("div", {
    className: classes.bottomLeftSection
  }, React.createElement(BottomLeftSection, null)), React.createElement("div", {
    className: classes.bottomRightSection
  }, React.createElement(BottomRightSection, {
    onClickOrderNow: function onClickOrderNow() {}
  })), React.createElement("div", {
    className: classes.bottomRightSpacer
  })));
};

var DesignApprovedModal = function DesignApprovedModal(props) {
  var root = useRef(document.createElement('div'));
  useEffect(function () {
    document.body.appendChild(root.current);
  }, []);
  return createPortal(React.createElement(DesignApprovedModalBase, Object.assign({}, props)), root.current);
};

var formatPhoneNumber = function formatPhoneNumber(phoneNumberString) {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    var intlCode = match[1] ? '+1 ' : '';
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }

  return null;
};

var DesignInProgressModal = function DesignInProgressModal(_ref54) {
  var open = _ref54.open;

  var _useContext21 = useContext(DesignReviewContext),
      mc = _useContext21.mc;

  var _useContext22 = useContext(DesignContext.Derived),
      currentUser = _useContext22.currentUser;

  var isInternalUser = currentUser.roles.includes('internal-user');
  var classes = useStyles$1();
  return React.createElement(Dialog$1, {
    open: open,
    TransitionComponent: SlideUpTransition
  }, React.createElement("div", {
    className: classes.modalContent
  }, React.createElement(Typography, {
    variant: "h4",
    component: "h2",
    className: classes.heading
  }, isInternalUser ? 'Preparing Next Version...' : 'Design In Progress...'), React.createElement("img", {
    className: classes.illustration,
    src: designInProgress,
    alt: ""
  }), isInternalUser ? React.createElement(Typography, {
    className: classes.body
  }, "We are currently processing your postcard design. ", React.createElement("br", null), "We will notify you as soon as the designs are ready.") : React.createElement(Typography, {
    className: classes.body
  }, "Our designers are still working on your postcard design. ", React.createElement("br", null), "We will notify you as soon as the designs are ready."), React.createElement("p", {
    className: classes.sub
  }, "Do you miss something? Reach out to your MVP Marketing Consultant"), !isEmpty$1(mc.phone) && !isEmpty$1(mc.email) && React.createElement("p", {
    className: classes.link
  }, React.createElement("a", {
    href: "tel:".concat(formatPhoneNumber(mc.phone))
  }, formatPhoneNumber(mc.phone)), "|", React.createElement("a", {
    href: "mailto:".concat(mc.email)
  }, mc.email))));
};

var useStyles$1 = makeStyles({
  modalContent: {
    backgroundColor: '#fff',
    minWidth: 500,
    maxWidth: 1024,
    padding: '2em',
    borderRadius: 4,
    outline: 'none',
    textAlign: 'center'
  },
  heading: {
    fontWeight: 'bold',
    marginBottom: '1.5rem',
    textAlign: 'center',
    fontSize: '2.2rem'
  },
  link: {
    fontSize: 15,
    color: 'rgb(223, 223, 223)',
    '& a:first-child': {
      marginRight: 4
    },
    '& a:last-child': {
      marginLeft: 4
    },
    '& a': {
      color: 'rgb(237, 21, 78)',
      textDecoration: 'none'
    }
  },
  body: {
    fontSize: 18
  },
  sub: {
    fontSize: 15
  },
  illustration: {
    height: 250,
    width: 310,
    marginBottom: 16
  }
});

var DiscardDraftCommentMessageModal = function DiscardDraftCommentMessageModal(_ref55) {
  var open = _ref55.open,
      confirmDiscard = _ref55.confirmDiscard,
      closeModal = _ref55.closeModal;
  return React.createElement(Dialog$1, {
    open: open,
    onClose: closeModal,
    onBackdropClick: closeModal,
    TransitionComponent: SlideUpTransition,
    style: {
      width: '28rem',
      margin: '0 auto'
    }
  }, React.createElement(DialogTitle$1, {
    style: {
      fontSize: '1.25rem',
      padding: '1rem 2rem',
      marginTop: '.5rem'
    }
  }, "Discard Comment"), React.createElement(DialogContent$1, null, React.createElement(DialogContentText, null, "Are you sure you want to discard your comment?")), React.createElement(DialogActions$1, {
    style: {
      padding: '1rem 1.5rem',
      marginTop: '-.3rem'
    }
  }, React.createElement(Button$1, {
    className: "el-ignore-click-away",
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      closeModal();
    },
    style: {
      color: 'grey'
    },
    variant: "text",
    color: "secondary"
  }, React.createElement("span", {
    className: "el-ignore-click-away"
  }, "Cancel")), React.createElement(Button$1, {
    onClick: confirmDiscard,
    style: {
      color: 'primary'
    },
    variant: "text",
    color: "secondary"
  }, "Confirm")));
};

var DesignReviewExperience;

(function (DesignReviewExperience) {
  DesignReviewExperience["DesignConcept"] = "Design Concept";
  DesignReviewExperience["CampaignReview"] = "Campaign Review";
})(DesignReviewExperience || (DesignReviewExperience = {}));

var DesignReviewViewedAs;

(function (DesignReviewViewedAs) {
  DesignReviewViewedAs["Default"] = "Default";
  DesignReviewViewedAs["Customer"] = "Customer";
})(DesignReviewViewedAs || (DesignReviewViewedAs = {}));

var FinalizeRequestsModalContents = function FinalizeRequestsModalContents() {
  var _useContext23 = useContext(DesignContext.Derived),
      currentUser = _useContext23.currentUser,
      conceptDesigner = _useContext23.conceptDesigner;

  var _useContext24 = useContext(CommentsStore.DerivedComments),
      frontComments = _useContext24.front,
      backComments = _useContext24.back;

  var numBackComments = backComments.length;
  var numFrontComments = frontComments.length;

  var _useContext25 = useContext(DesignContext.Base),
      viewedAs = _useContext25.viewedAs,
      experience = _useContext25.experience;

  var _useContext26 = useContext(UIStateContext.Derived.Scaffold),
      frontPostcardUrl = _useContext26.frontPostcardUrl,
      backPostcardUrl = _useContext26.backPostcardUrl;

  var _useContext27 = useContext(UIStateContext.Derived.ImageViewer),
      isPortrait = _useContext27.isPortrait;

  var _useContext28 = useContext(ActionsContext),
      closeModal = _useContext28.closeModal,
      openModal = _useContext28.openModal;

  var _useContext29 = useContext(DerivedActionsContext),
      handlers = _useContext29.handlers;

  var _useState71 = useState(false),
      _useState72 = _slicedToArray(_useState71, 2),
      isLoading = _useState72[0],
      setIsLoading = _useState72[1];

  var confirmAuthorizationFormProps = useConfirmAuthorizationForm({
    requireReview: numBackComments > 0 && numFrontComments > 0 ? false : true,
    requireAuthorization: true
  });
  var forApproval = false;
  var noCommentSide = numBackComments === 0 ? 'back' : numFrontComments === 0 ? 'front' : '';

  var _useState73 = useState(false),
      _useState74 = _slicedToArray(_useState73, 2),
      hasError = _useState74[0],
      setHasError = _useState74[1];

  var handleClose = function handleClose() {
    setHasError(false);
  };

  var isInternalUser = currentUser.roles.includes('internal-user');
  return React.createElement("div", {
    style: {
      maxWidth: '48rem',
      padding: '0.75em 2rem'
    }
  }, React.createElement("div", {
    style: {
      textAlign: 'center',
      marginBottom: '2rem'
    }
  }, React.createElement(Typography, {
    variant: "h4",
    component: "h2",
    style: {
      fontWeight: 'bold',
      marginBottom: '1rem'
    }
  }, "Change Request Confirmation")), React.createElement(ThumbnailsWithMarkers, {
    thumbnails: [{
      src: frontPostcardUrl,
      alt: 'Front Postcard',
      markers: frontComments
    }, {
      src: backPostcardUrl,
      alt: 'Back Postcard',
      markers: backComments
    }],
    MarkerComponent: PlainNumberedBadge,
    TooltipComponent: Tooltip,
    isPortrait: isPortrait
  }), React.createElement(ConfirmAuthorizationForm, Object.assign({}, confirmAuthorizationFormProps, {
    reviewText: React.createElement(ReviewText, {
      noCommentSide: noCommentSide
    }),
    authorizationText: React.createElement(AuthorizationText, {
      isApproving: forApproval,
      name: currentUser.name
    }),
    reviewError: React.createElement(ReviewError, null),
    authorizationError: React.createElement(AuthorizationError, {
      isApproving: forApproval
    })
  })), isInternalUser && React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      padding: '0 1rem 1rem',
      marginTop: '-1rem'
    }
  }, React.createElement("span", null, React.createElement(Checkbox, {
    checked: confirmAuthorizationFormProps.notifyConceptDesigner,
    onChange: function onChange(_, c) {
      confirmAuthorizationFormProps.setNotifyConceptDesigner(c);
    }
  })), React.createElement("span", {
    style: {
      fontSize: '1rem'
    }
  }, "This design needs to be returned to", ' ', React.createElement("strong", null, conceptDesigner.name, "."))), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    }
  }, React.createElement(Button$1, {
    style: {
      backgroundColor: Colors.MVP_LIGHT_PINK,
      marginBottom: '0.5rem',
      color: '#fff'
    },
    variant: "contained",
    disabled: isLoading,
    onClick: function () {
      var _onClick4 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        var type;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!(confirmAuthorizationFormProps.reviewed && confirmAuthorizationFormProps.authorized)) {
                  _context9.next = 23;
                  break;
                }

                setIsLoading(true);
                setHasError(false);
                _context9.prev = 3;

                if (!( // tools app only
                viewedAs === DesignReviewViewedAs.Default && // campaign review only
                experience === DesignReviewExperience.CampaignReview)) {
                  _context9.next = 10;
                  break;
                }

                if (!handlers.campaignMediaReject) {
                  _context9.next = 8;
                  break;
                }

                _context9.next = 8;
                return handlers.campaignMediaReject('');

              case 8:
                _context9.next = 12;
                break;

              case 10:
                _context9.next = 12;
                return handlers.submitDesignReview(confirmAuthorizationFormProps.notifyConceptDesigner);

              case 12:
                type = viewedAs === DesignReviewViewedAs.Default ? ModalTypes.SuccessfullySubmittedRequests : ModalTypes.CustomerSuccessfullySubmittedRequests;
                openModal({
                  type: type
                });
                return _context9.abrupt("return");

              case 17:
                _context9.prev = 17;
                _context9.t0 = _context9["catch"](3);
                setHasError(true);

              case 20:
                setIsLoading(false);
                _context9.next = 24;
                break;

              case 23:
                confirmAuthorizationFormProps.setReviewHighlighted(true);

              case 24:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, null, [[3, 17]]);
      }));

      function onClick() {
        return _onClick4.apply(this, arguments);
      }

      return onClick;
    }()
  }, "CONFIRM CHANGE REQUEST", isLoading ? React.createElement(ActionsCircularProgress, null) : null), React.createElement(Snackbar$1, {
    open: hasError,
    autoHideDuration: 4000,
    onClose: handleClose
  }, React.createElement(Alert, {
    onClose: handleClose,
    severity: "error"
  }, "Sorry! that didn't work. Try to click submit again")), React.createElement(Button$1, {
    style: {
      backgroundColor: 'white',
      color: '#ed154e',
      border: '1px solid #ed154e'
    },
    variant: "outlined",
    onClick: closeModal
  }, "GO BACK TO REVIEW")));
};

var FinalizeRequestsModal = function FinalizeRequestsModal(_ref56) {
  var open = _ref56.open;

  var _useContext30 = useContext(ActionsContext),
      closeModal = _useContext30.closeModal;

  return React.createElement(Dialog$1, {
    open: open,
    TransitionComponent: SlideUpTransition,
    onBackdropClick: closeModal,
    PaperProps: {
      style: {
        overflow: 'visible'
      }
    }
  }, React.createElement("div", {
    style: {
      backgroundColor: '#fff',
      minWidth: '500px',
      maxWidth: '1024px',
      padding: '2em',
      borderRadius: '4px',
      outline: 'none'
    }
  }, React.createElement(FinalizeRequestsModalContents, null)));
};

var FinalLookModal = function FinalLookModal(_ref57) {
  var open = _ref57.open;

  var _useContext31 = useContext(ActionsContext),
      setComments = _useContext31.setComments,
      setWorkflow = _useContext31.setWorkflow,
      closeModal = _useContext31.closeModal,
      setCardFace = _useContext31.setCardFace,
      setActiveComment = _useContext31.setActiveComment;

  var _useContext32 = useContext(UIStateContext.Scaffold),
      modalStatus = _useContext32.modalStatus;

  var _useContext33 = useContext(UIStateContext.ImageViewer),
      cardFace = _useContext33.cardFace;

  var _useContext34 = useContext(UIStateContext.Derived.Scaffold),
      frontThumbnailUrl = _useContext34.frontThumbnailUrl;

  var _useContext35 = useContext(DesignContext.Derived),
      mediaType = _useContext35.mediaType;

  var handleClickProceed =
  /*#__PURE__*/
  function () {
    var _ref58 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee10() {
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              if ((modalStatus === null || modalStatus === void 0 ? void 0 : modalStatus.type) === ModalTypes.FinalLook) {
                setActiveComment(null);

                if (cardFace !== CardFace.Front) {
                  setCardFace(CardFace.Front);
                }

                setComments(function (cs) {
                  return cs.filter(function (c) {
                    return c.status === CommentStatus.Rejected;
                  }).map(function (c) {
                    return _objectSpread({}, c, {
                      status: CommentStatus.Pending
                    });
                  });
                });
                setWorkflow(Workflow.Request);
                closeModal();
              }

            case 1:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function handleClickProceed() {
      return _ref58.apply(this, arguments);
    };
  }();

  var _getDimensionFactorsB = getDimensionFactorsByMediaType(mediaType),
      widthFactor = _getDimensionFactorsB.widthFactor,
      heightFactor = _getDimensionFactorsB.heightFactor;

  var imageWidth = 300;
  var imageHeight = imageWidth / widthFactor * heightFactor;
  return React.createElement(Dialog$1, {
    open: open,
    TransitionComponent: SlideUpTransition,
    onBackdropClick: closeModal
  }, React.createElement("div", {
    style: {
      backgroundColor: '#fff',
      minWidth: '550px',
      maxWidth: '1024px',
      padding: '2.5rem 3rem',
      borderRadius: '4px',
      outline: 'none'
    }
  }, React.createElement(Typography, {
    variant: "h4",
    component: "h2",
    style: {
      fontWeight: 'bold',
      marginBottom: '1.2rem',
      textAlign: 'center',
      fontSize: '2.2rem'
    }
  }, "Take a final look on your designs"), React.createElement("div", {
    style: {
      width: imageWidth,
      height: imageHeight,
      margin: '0 auto 0.5rem auto',
      gridArea: '1 / 1 / 2 / 2'
    }
  }, React.createElement(Thumbnail$1, {
    imgSrc: frontThumbnailUrl,
    imgAlt: "Design Review Placeholder",
    orientation: "landscape",
    width: imageWidth,
    height: imageHeight
  })), React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center'
    }
  }, React.createElement("ul", {
    style: {
      listStyle: 'none',
      textAlign: 'left',
      paddingLeft: '0'
    }
  }, React.createElement("li", null, React.createElement(Typography, {
    style: {
      marginBottom: '.6em',
      fontSize: '1.1rem'
    }
  }, React.createElement("span", {
    role: "img",
    "aria-label": "Eyes",
    style: {
      fontSize: '1.4rem'
    }
  }, "\uD83D\uDC40"), React.createElement("span", {
    style: {
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
      paddingLeft: '.7rem'
    }
  }, "Review both sides"), ' ', "of your design.")), React.createElement("li", null, React.createElement(Typography, {
    style: {
      marginBottom: '.6em',
      fontSize: '1.1rem'
    }
  }, React.createElement("span", {
    role: "img",
    "aria-label": "Hand Pointer",
    style: {
      fontSize: '1.5rem'
    }
  }, "\uD83D\uDC46"), React.createElement("span", {
    style: {
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
      paddingLeft: '1rem'
    }
  }, "Click on design"), ' ', "to request a change.")), React.createElement("li", null, React.createElement(Typography, {
    style: {
      marginBottom: '.7rem',
      fontSize: '1.1rem'
    }
  }, React.createElement("span", {
    role: "img",
    "aria-label": "Party Popper",
    style: {
      fontSize: '1.4rem'
    }
  }, "\uD83C\uDF89"), React.createElement("span", {
    style: {
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
      paddingLeft: '.7rem'
    }
  }, "Approve"), ' ', "your design if it\u2019s ready to go.")))), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    }
  }, React.createElement(Button$1, {
    style: {
      backgroundColor: Colors.MVP_LIGHT_PINK,
      marginBottom: '0.3rem'
    },
    variant: "contained",
    onClick: handleClickProceed
  }, "Proceed"), React.createElement(Button$1, {
    style: {
      backgroundColor: 'white'
    },
    variant: "outlined",
    onClick: closeModal
  }, "Back to Review"))));
};

var img = "data:image/svg+xml,%3csvg width='102' height='101' viewBox='0 0 102 101' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3crect x='17.3752' y='15.7413' width='67.0694' height='68.7201' rx='33.5347' fill='%23FFDDE6'/%3e%3crect x='22.7949' y='21.2945' width='56.2299' height='57.6138' rx='28.115' fill='%23ED154E'/%3e%3cpath d='M94.5712 63.4729C95.2606 63.5469 95.7618 64.1804 95.6896 64.8868C95.6175 65.5932 94.9991 66.1067 94.3097 66.0327C93.6203 65.9588 93.1191 65.3253 93.1913 64.6189C93.2634 63.9125 93.8818 63.399 94.5712 63.4729Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.6171'/%3e%3cpath d='M24.9401 89.5407C26.0738 89.6623 26.898 90.7041 26.7793 91.8657C26.6607 93.0273 25.6439 93.8717 24.5102 93.7501C23.3765 93.6286 22.5524 92.5867 22.671 91.4251C22.7897 90.2636 23.8065 89.4191 24.9401 89.5407Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='2.65921'/%3e%3cpath d='M50.2282 2.95178C51.3619 3.07334 52.186 4.11517 52.0674 5.27676C51.9488 6.43835 50.932 7.28277 49.7983 7.1612C48.6646 7.03963 47.8404 5.99781 47.9591 4.83622C48.0777 3.67463 49.0945 2.83021 50.2282 2.95178Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='2.65921'/%3e%3cpath d='M2.39816 30.5103C2.91891 30.5103 3.34172 30.9435 3.34172 31.477C3.34172 32.0106 2.91891 32.4438 2.39816 32.4438C1.8774 32.4438 1.45459 32.0106 1.45459 31.477C1.45459 30.9435 1.8774 30.5103 2.39816 30.5103Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.94378'/%3e%3cpath d='M75.6838 93.5563C76.2046 93.5563 76.6274 93.9896 76.6274 94.5231C76.6274 95.0567 76.2046 95.4899 75.6838 95.4899C75.163 95.4899 74.7402 95.0567 74.7402 94.5231C74.7402 93.9896 75.163 93.5563 75.6838 93.5563Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.94378'/%3e%3cpath d='M89.9194 26.5947L91.0277 22.884' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e%3cpath d='M88.7224 24.1984L92.3439 25.3339' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e%3cpath d='M6.20874 65.9954L7.18628 62.2464' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e%3cpath d='M4.92871 63.6448L8.58765 64.6464' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e%3cpath d='M84.9326 82.7841L85.7089 78.986' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e%3cpath d='M83.5291 80.5086L87.2359 81.304' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e%3cpath d='M69.8796 62.502L67.4941 66.3828L51.5823 56.4253L53.9678 52.5456L69.8796 62.502Z' fill='%23B72048'/%3e%3cpath opacity='0.18' d='M51.8203 56.5747L61.1615 57.0473L54.2058 52.6949C54.2058 52.6949 53.0889 54.9996 51.8203 56.5747Z' fill='black'/%3e%3cpath d='M84.1702 73.3609L83.1419 75.0336C82.4627 76.1382 81.0236 76.4784 79.929 75.7936L63.6165 65.5857C63.4368 65.4735 63.3807 65.2344 63.493 65.0525L66.5768 60.0367C66.689 59.8548 66.9248 59.7987 67.1055 59.9121L83.417 70.1188C84.5126 70.8047 84.8494 72.2551 84.1702 73.3609Z' fill='%23FA3568'/%3e%3cpath d='M37.8606 66.2556C49.807 66.2556 59.4914 56.4855 59.4914 44.4335C59.4914 32.3815 49.807 22.6115 37.8606 22.6115C25.9142 22.6115 16.2297 32.3815 16.2297 44.4335C16.2297 56.4855 25.9142 66.2556 37.8606 66.2556Z' fill='%23FA3568'/%3e%3cpath d='M37.8606 62.2639C47.6076 62.2639 55.5091 54.2926 55.5091 44.4594C55.5091 34.6263 47.6076 26.6549 37.8606 26.6549C28.1136 26.6549 20.2122 34.6263 20.2122 44.4594C20.2122 54.2926 28.1136 62.2639 37.8606 62.2639Z' fill='white'/%3e%3cpath opacity='0.18' d='M44.501 58.3966C41.324 59.3227 38.0415 59.5282 34.7658 59.0959C31.6292 58.6817 28.2749 57.7297 25.6502 55.8875C24.5602 55.1219 23.5588 54.2306 22.7371 53.1787C25.0373 57.0405 28.7812 60.03 33.4467 61.2469C40.5528 63.0992 47.7666 60.3106 51.9382 54.7548C49.7458 56.4343 47.1256 57.631 44.501 58.3966Z' fill='%23EA7699'/%3e%3cpath d='M69.993 61.5488L66.5051 67.2224L65.8281 66.7992L69.3172 61.1255L69.993 61.5488Z' fill='%23F396AF'/%3e%3cpath d='M71.5938 62.5985L68.1059 68.2733L67.429 67.8501L70.918 62.1753L71.5938 62.5985Z' fill='%23F396AF'/%3e%3cpath d='M53.9407 54.5213C48.4411 63.4662 36.7537 66.23 27.8873 60.6821C19.021 55.1342 16.2819 43.3435 21.7815 34.3986C27.2811 25.4537 38.9686 22.6899 47.8349 28.2378C56.7012 33.7857 59.4404 45.5764 53.9407 54.5213ZM23.2465 35.3147C18.2487 43.4446 20.7375 54.1609 28.7966 59.2037C36.8547 64.2464 47.4779 61.734 52.4757 53.6041C57.4736 45.4742 54.9847 34.7578 46.9256 29.7151C38.8664 24.6735 28.2443 27.1848 23.2465 35.3147Z' fill='%23F84473'/%3e%3cpath opacity='0.61' d='M39.7881 29.1864C37.2678 28.542 34.5018 28.8934 32.1297 29.9386C30.0832 30.84 28.0928 32.5542 27.5113 34.8039C27.4226 35.1452 27.8335 35.5336 28.1287 35.2272C29.5107 33.7936 30.9734 32.5351 32.8179 31.7516C34.9272 30.8557 37.1578 30.95 39.3884 31.069C40.4414 31.1263 40.8804 29.4659 39.7881 29.1864Z' fill='%23EA7699'/%3e%3cpath d='M37.7641 62.0383C28.1423 62.0383 20.3132 54.1407 20.3132 44.4336C20.3132 34.7264 28.1412 26.8289 37.7641 26.8289C47.3859 26.8289 55.215 34.7264 55.215 44.4336C55.215 54.1419 47.3871 62.0383 37.7641 62.0383ZM37.7641 27.1635C28.3253 27.1635 20.6455 34.9105 20.6455 44.4336C20.6455 53.9566 28.3253 61.7037 37.7641 61.7037C47.203 61.7037 54.8827 53.9566 54.8827 44.4336C54.8838 34.9117 47.2041 27.1635 37.7641 27.1635Z' fill='%23BA656D'/%3e%3cpath d='M30.4257 39.7884L27.1213 43.2749L36.2519 52.5722L48.5998 39.7884L45.3389 36.3466L36.2519 45.6439L30.4257 39.7884Z' fill='%23F2ABC0'/%3e%3c/svg%3e";
var img$1 = "data:image/svg+xml,%3csvg width='151' height='100' viewBox='0 0 151 100' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg clip-path='url(%23clip0)'%3e%3cpath d='M75.0732 100C116.495 100 150.073 92.3561 150.073 82.9268C150.073 73.4976 116.495 65.8536 75.0732 65.8536C33.6519 65.8536 0.0732422 73.4976 0.0732422 82.9268C0.0732422 92.3561 33.6519 100 75.0732 100Z' fill='%23F5F5F5'/%3e%3cpath d='M128.979 33.561L105.2 5.50732C104.058 3.59512 102.392 2.43903 100.637 2.43903H49.51C47.7545 2.43903 46.0881 3.59512 44.9467 5.50488L21.167 33.5634V56.0976H128.979V33.561Z' stroke='%23D9D9D9'/%3e%3cpath d='M97.6037 41.2951C97.6037 37.3805 99.9334 34.1488 102.823 34.1464H128.979V78.3829C128.979 83.561 125.886 87.8049 122.065 87.8049H28.0811C24.2607 87.8049 21.167 83.5586 21.167 78.3829V34.1464H47.3232C50.2131 34.1464 52.5428 37.3732 52.5428 41.2878V41.3415C52.5428 45.2561 54.8982 48.4171 57.7857 48.4171H92.3607C95.2482 48.4171 97.6037 45.2268 97.6037 41.3122V41.2951Z' fill='%23FAFAFA' stroke='%23D9D9D9'/%3e%3c/g%3e%3cdefs%3e%3cclipPath id='clip0'%3e%3crect width='150' height='100' fill='white' transform='translate(0.0732422)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";
var useStyles$2 = makeStyles(function (theme) {
  return {
    table: {
      minWidth: 470,
      '& th': {
        padding: '10px 20px'
      },
      '& thead': {
        display: 'table',
        width: '100%',
        tableLayout: 'fixed',
        backgroundColor: "#FCFCFC",
        '& tr': {
          display: 'flex'
        },
        '& th': {
          border: 'none'
        }
      },
      '& tbody': {
        display: 'block',
        maxHeight: 278,
        overflowY: 'auto',
        margin: '0px 8px 0px 0px',
        padding: '0px 0px',
        '& tr': {
          display: 'flex',
          width: '100%'
        },
        '& tr th:first-child': {
          padding: '12px 10px'
        },
        '&::-webkit-scrollbar': {
          width: 8
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: '#ECECEC',
          borderRadius: 4,
          margin: '8px 0px'
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#C4C4C4',
          borderRadius: 4
        }
      }
    },
    design: {
      color: theme.palette.primary.light,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: 138,
      display: 'inline-block'
    }
  };
});

var QueueList = function QueueList(_ref59) {
  var designQueueItems = _ref59.designQueueItems,
      selected = _ref59.selected,
      setSelected = _ref59.setSelected;
  var classes = useStyles$2();
  var isListEmpty = isEmpty(designQueueItems);

  var formatDate$1 = function formatDate$1(date) {
    return !!date ? formatDate(new Date(date), 'M/d') : '';
  };

  return React.createElement(TableContainer, {
    component: Paper,
    style: {
      boxShadow: 'none'
    }
  }, React.createElement(Table$1, {
    className: classes.table,
    size: "medium",
    "aria-label": "a dense table"
  }, React.createElement(TableHead, null, React.createElement(TableRow, null, React.createElement(TableCell, {
    style: {
      fontWeight: 'bold',
      padding: '10px 8px 10px 20px',
      flex: 1
    }
  }, "Design Name"), React.createElement(TableCell, {
    style: {
      fontWeight: 'bold',
      width: 141,
      padding: '12px 8px 12px 8px'
    },
    align: "left"
  }, "Task"), React.createElement(TableCell, {
    style: {
      fontWeight: 'bold',
      width: 128,
      padding: '12px 8px 12px 8px'
    },
    align: "right"
  }, "Next Approval Date"))), React.createElement(TableBody, null, isListEmpty && React.createElement(TableRow, null, React.createElement(TableCell, null, React.createElement(EmptyQueue, null))), designQueueItems.map(function (row) {
    var _a;

    return React.createElement(TableRow, {
      key: row.id
    }, React.createElement(TableCell, {
      component: "th",
      scope: "row",
      style: {
        display: 'inline-flex',
        gap: 8,
        width: '100%',
        flex: 1
      }
    }, React.createElement("div", null, React.createElement(Radio, {
      checked: row.id === selected,
      onChange: function onChange() {
        setSelected(row.id);
      },
      value: row.id,
      name: "design-queue-item"
    })), React.createElement("div", null, React.createElement(LightTooltip, {
      title: row.name,
      placement: "top"
    }, React.createElement("span", {
      className: classes.design
    }, row.name)), React.createElement("br", null), React.createElement("span", null, (_a = row === null || row === void 0 ? void 0 : row.account) === null || _a === void 0 ? void 0 : _a.name))), React.createElement(TableCell, {
      align: "left",
      style: {
        padding: '12px 8px',
        width: 148
      }
    }, React.createElement("span", null, row === null || row === void 0 ? void 0 : row.taskType), React.createElement("br", null), React.createElement("span", {
      style: {
        color: Colors.MVP_GREY_3
      }
    }, row === null || row === void 0 ? void 0 : row.mediaType)), React.createElement(TableCell, {
      align: "right",
      style: {
        padding: '12px 8px',
        width: 112
      }
    }, formatDate$1(row === null || row === void 0 ? void 0 : row.nextApprovalDate)));
  }))));
};

var EmptyQueue = function EmptyQueue() {
  return React.createElement("div", {
    style: {
      padding: '43px 35px 43px 43px'
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: 10
    }
  }, React.createElement("img", {
    src: img$1,
    alt: 'Design Queue Empty'
  })), React.createElement(Typography, {
    style: {
      textAlign: 'center',
      padding: '0px 26px',
      fontSize: 14,
      lineHeight: '24px',
      color: '#BFBFBF'
    }
  }, "The queue you're assigned to is currently empty. Reach out to your team and/or manager for your next task."));
};

var LightTooltip = withStyles(function (theme) {
  return {
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.primary.light,
      boxShadow: theme.shadows[1],
      fontSize: 14,
      maxWidth: 185
    }
  };
})(Tooltip$1);

var ScaffoldSuccessModal = function ScaffoldSuccessModal(_ref60) {
  var open = _ref60.open,
      title = _ref60.title,
      subStatus = _ref60.subStatus,
      imageSrc = _ref60.imageSrc,
      renderUrl = _ref60.renderUrl;

  var _a, _b, _c, _d;

  var _useContext36 = useContext(DesignContext.Base),
      designQueueDetails = _useContext36.designQueueDetails;

  var queueDashboardUrl = (_a = designQueueDetails === null || designQueueDetails === void 0 ? void 0 : designQueueDetails.queueDashboardUrl) !== null && _a !== void 0 ? _a : '';
  var designQueueItems = (_b = designQueueDetails === null || designQueueDetails === void 0 ? void 0 : designQueueDetails.items) !== null && _b !== void 0 ? _b : [];
  var nextQueueFor = (_c = designQueueDetails === null || designQueueDetails === void 0 ? void 0 : designQueueDetails.nextQueueFor) !== null && _c !== void 0 ? _c : '';

  var _useState75 = useState(_get(designQueueItems !== null && designQueueItems !== void 0 ? designQueueItems : [], '0.id')),
      _useState76 = _slicedToArray(_useState75, 2),
      selected = _useState76[0],
      setSelected = _useState76[1];

  var hasQueue = designQueueItems && !!designQueueItems.length;
  var count = (_d = designQueueItems === null || designQueueItems === void 0 ? void 0 : designQueueItems.length) !== null && _d !== void 0 ? _d : 0;

  var getDesign = function getDesign(id) {
    return designQueueItems.find(function (row) {
      return row.id === id;
    });
  };

  var getStartTaskUrl = useCallback(function () {
    var _a;

    var queue = getDesign(selected);
    var url = (queue === null || queue === void 0 ? void 0 : queue.taskType) !== TaskType.NumberSwap ? "/#/accounts/".concat((_a = queue === null || queue === void 0 ? void 0 : queue.account) === null || _a === void 0 ? void 0 : _a.id, "/designs/").concat(selected) : "/#/campaigns/".concat(selected, "/design");

    if (renderUrl) {
      return renderUrl(url);
    }

    return url;
  }, [selected]);
  return React.createElement(Dialog$1, {
    open: open,
    TransitionComponent: SlideUpTransition,
    style: {
      backgroundColor: '#232323'
    }
  }, React.createElement("div", {
    style: {
      backgroundColor: '#fff',
      width: '500px',
      borderRadius: '4px',
      outline: 'none'
    }
  }, React.createElement("div", {
    style: {
      padding: 20
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: 20
    }
  }, React.createElement("img", {
    src: imageSrc,
    alt: title
  })), React.createElement(Typography, {
    variant: "h4",
    component: "h2",
    color: "primary",
    style: {
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: 10,
      fontSize: '1.8rem'
    }
  }, title), React.createElement(Typography, {
    style: {
      textAlign: 'center',
      padding: '0px 26px',
      fontSize: 14,
      lineHeight: '20px'
    }
  }, subStatus), React.createElement(Typography, {
    style: {
      textAlign: 'center',
      padding: '0px 26px',
      fontSize: 14,
      lineHeight: '20px'
    }
  }, "Next up queue: ", React.createElement("strong", null, nextQueueFor), " (", count, " Items)")), React.createElement("div", {
    style: {
      margin: '0 0 30px 0'
    }
  }, React.createElement(QueueList, {
    designQueueItems: designQueueItems,
    selected: selected,
    setSelected: setSelected
  })), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      padding: '0 20px 20px 20px',
      justifyContent: 'flex-end'
    }
  }, React.createElement(Button$1, {
    variant: "outlined",
    size: "medium",
    color: "secondary",
    style: {
      padding: '6px 16px',
      textTransform: 'capitalize',
      fontWeight: 'normal',
      fontSize: 14,
      lineHeight: '24px'
    },
    onClick: function onClick() {
      window.open(queueDashboardUrl, '_blank ');
    }
  }, "Design Queues Dashboard"), React.createElement(Button$1, {
    variant: "contained",
    size: "medium",
    color: "secondary",
    disabled: !hasQueue,
    style: {
      padding: '6px 16px',
      textTransform: 'capitalize',
      fontWeight: hasQueue ? 'bold' : 'normal',
      background: hasQueue ? undefined : '#F5F5F5',
      fontSize: 14,
      lineHeight: '24px',
      marginLeft: 10
    },
    onClick: function onClick(element) {
      element.preventDefault(); // force reload

      window.location.href = element.currentTarget.href;
      window.location.reload();
    },
    href: getStartTaskUrl()
  }, "Start Task"))));
};

var MovedToNextReviewModal = function MovedToNextReviewModal(_ref61) {
  var open = _ref61.open;
  return React.createElement(ScaffoldSuccessModal, {
    open: open,
    title: "Review Passed",
    imageSrc: img,
    subStatus: "You have successfully submitted this design!"
  });
};

var img$2 = "data:image/svg+xml,%3csvg width='102' height='101' viewBox='0 0 102 101' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3crect x='17.3752' y='15.0843' width='67.0694' height='68.7201' rx='33.5347' fill='%23FFDDE6'/%3e%3crect x='22.7949' y='20.6375' width='56.2299' height='57.6138' rx='28.115' fill='%23ED154E'/%3e%3cpath d='M94.5712 62.816C95.2606 62.8899 95.7618 63.5234 95.6896 64.2298C95.6175 64.9362 94.9991 65.4497 94.3097 65.3758C93.6203 65.3019 93.1191 64.6683 93.1913 63.9619C93.2634 63.2555 93.8818 62.742 94.5712 62.816Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.6171'/%3e%3cpath d='M24.9401 88.8837C26.0738 89.0053 26.898 90.0471 26.7793 91.2087C26.6607 92.3703 25.6439 93.2147 24.5102 93.0932C23.3765 92.9716 22.5524 91.9298 22.671 90.7682C22.7897 89.6066 23.8065 88.7622 24.9401 88.8837Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='2.65921'/%3e%3cpath d='M50.2282 2.29484C51.3619 2.41641 52.186 3.45823 52.0674 4.61982C51.9488 5.78141 50.932 6.62583 49.7983 6.50426C48.6646 6.3827 47.8404 5.34087 47.9591 4.17928C48.0777 3.01769 49.0945 2.17327 50.2282 2.29484Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='2.65921'/%3e%3cpath d='M2.39816 29.8533C2.91891 29.8533 3.34172 30.2865 3.34172 30.8201C3.34172 31.3536 2.91891 31.7868 2.39816 31.7868C1.8774 31.7868 1.45459 31.3536 1.45459 30.8201C1.45459 30.2865 1.8774 29.8533 2.39816 29.8533Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.94378'/%3e%3cpath d='M75.6838 92.8993C76.2046 92.8993 76.6274 93.3326 76.6274 93.8661C76.6274 94.3997 76.2046 94.8329 75.6838 94.8329C75.163 94.8329 74.7402 94.3997 74.7402 93.8661C74.7402 93.3326 75.163 92.8993 75.6838 92.8993Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.94378'/%3e%3cpath d='M89.9194 25.9377L91.0277 22.227' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e%3cpath d='M88.7224 23.5415L92.3439 24.677' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e%3cpath d='M6.20874 65.3385L7.18628 61.5895' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e%3cpath d='M4.92871 62.9879L8.58765 63.9895' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e%3cpath d='M84.9326 82.1271L85.7089 78.329' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e%3cpath d='M83.5291 79.8516L87.2359 80.647' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e%3cpath d='M33.1511 85.6404C30.3897 85.6404 28.1511 83.4018 28.1511 80.6404L28.1511 18.1404C28.1511 15.3789 30.3897 13.1404 33.1511 13.1404L68.1511 13.1403C70.9125 13.1403 73.1511 15.3789 73.1511 18.1403L73.1511 80.6403C73.1511 83.4018 70.9125 85.6403 68.1511 85.6403L33.1511 85.6404Z' fill='%23D52B57'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M71.6523 84.2467L29 15.4095C29.8925 14.0432 31.4353 13.1404 33.189 13.1404H68.189C70.9505 13.1404 73.189 15.3789 73.189 18.1403L73.189 80.6404C73.189 82.0574 72.5995 83.3368 71.6523 84.2467Z' fill='%23E43F6B'/%3e%3cpath d='M28.1511 58.4529L28.1511 55.9529L31.9011 55.9529L31.9011 58.4529L28.1511 58.4529Z' fill='%23FFDDE6'/%3e%3cpath d='M69.4011 58.4529L69.4011 55.9529L73.1511 55.9529L73.1511 58.4529L69.4011 58.4529Z' fill='%23FFDDE6'/%3e%3cpath d='M34.4011 58.4529L34.4011 55.9529L36.9011 55.9529L36.9011 58.4529L34.4011 58.4529Z' fill='%23FFDDE6'/%3e%3cpath d='M39.4011 58.4529L39.4011 55.9529L41.9011 55.9529L41.9011 58.4529L39.4011 58.4529Z' fill='%23FFDDE6'/%3e%3cpath d='M44.4011 58.4529L44.4011 55.9529L46.9011 55.9529L46.9011 58.4529L44.4011 58.4529Z' fill='%23FFDDE6'/%3e%3cpath d='M49.4011 58.4529L49.4011 55.9529L51.9011 55.9529L51.9011 58.4529L49.4011 58.4529Z' fill='%23FFDDE6'/%3e%3cpath d='M54.4011 58.4529L54.4011 55.9529L56.9011 55.9529L56.9011 58.4529L54.4011 58.4529Z' fill='%23FFDDE6'/%3e%3cpath d='M59.4011 58.4529L59.4011 55.9529L61.9011 55.9529L61.9011 58.4529L59.4011 58.4529Z' fill='%23FFDDE6'/%3e%3cpath d='M64.4011 58.4529L64.4011 55.9529L66.9011 55.9529L66.9011 58.4529L64.4011 58.4529Z' fill='%23FFDDE6'/%3e%3cpath d='M33.1511 46.8904L33.1511 21.8904L68.1501 21.8904L68.1501 46.8904L33.1511 46.8904Z' fill='white'/%3e%3cpath d='M68.1514 40.8517L60.0113 27.9153C59.8237 27.6027 59.5584 27.344 59.2412 27.1644C58.924 26.9848 58.5656 26.8904 58.2011 26.8904C57.8091 26.8904 57.4248 26.9995 57.0913 27.2057C56.7578 27.4118 56.4883 27.7067 56.313 28.0573L46.8967 46.8904L68.1514 46.8904V40.8517Z' fill='%239CC221'/%3e%3cpath d='M68.1511 29.3904L64.919 29.3904C64.3586 29.3904 63.8036 29.5008 63.2858 29.7152C62.7681 29.9297 62.2976 30.2441 61.9013 30.6404C61.505 31.0367 61.0346 31.351 60.5168 31.5655C59.999 31.78 59.4441 31.8904 58.8836 31.8904L58.1514 31.8904C57.4884 31.8904 56.8525 32.1538 56.3837 32.6226C55.9149 33.0914 55.6515 33.7273 55.6515 34.3904C55.6515 35.0534 55.9149 35.6893 56.3837 36.1581C56.8525 36.627 57.4884 36.8904 58.1514 36.8904L68.1511 36.8904L68.1511 29.3904Z' fill='%23CDF4F7'/%3e%3cpath d='M33.1513 21.8904H36.3834C36.9438 21.8904 37.4988 22.0008 38.0166 22.2152C38.5343 22.4297 39.0048 22.7441 39.4011 23.1404C39.7974 23.5367 40.2678 23.851 40.7856 24.0655C41.3034 24.28 41.8583 24.3904 42.4187 24.3904H43.151C43.814 24.3904 44.4498 24.6538 44.9187 25.1226C45.3875 25.5914 45.6509 26.2273 45.6509 26.8904C45.6509 27.5534 45.3875 28.1893 44.9187 28.6581C44.4498 29.127 43.814 29.3904 43.151 29.3904H33.1513V21.8904Z' fill='%23CDF4F7'/%3e%3cpath d='M56.8963 46.8904L48.7717 31.8013C48.5827 31.4504 48.3023 31.1571 47.96 30.9527C47.6178 30.7483 47.2267 30.6404 46.8281 30.6404C46.4647 30.6404 46.1069 30.7301 45.7865 30.9016C45.4661 31.0731 45.1929 31.321 44.9913 31.6234L33.2009 46.8904L38.1469 46.8904L56.8963 46.8904Z' fill='%23ACCD2A'/%3e%3cpath d='M38.1936 63.2612H43.1865V66.5898H38.1936V63.2612Z' fill='%23FFDDE6'/%3e%3cpath d='M46.5154 63.2612H56.5012V66.5898H46.5154V63.2612Z' fill='%23FFDDE6'/%3e%3cpath d='M59.8296 63.2612H68.1511V66.5898H59.8296V63.2612Z' fill='%23FFDDE6'/%3e%3cpath d='M33.2007 69.9184H48.1794V73.247H33.2007V69.9184Z' fill='%23FFDDE6'/%3e%3cpath d='M51.5081 69.9184H61.4939V73.247H51.5081V69.9184Z' fill='%23FFDDE6'/%3e%3cpath d='M64.8225 69.9184H68.1511V73.247H64.8225V69.9184Z' fill='%23FFDDE6'/%3e%3cpath d='M33.2007 76.5756H38.1936V79.9042H33.2007V76.5756Z' fill='%23FFDDE6'/%3e%3cpath d='M41.5222 76.5756H54.8367V79.9042H41.5222V76.5756Z' fill='%23FFDDE6'/%3e%3cpath d='M58.1653 76.5756H68.1511V79.9042H58.1653V76.5756Z' fill='%23FFDDE6'/%3e%3ccircle cx='37.7345' cy='43.557' r='6.16667' fill='%23ED154E' stroke='white'/%3e%3cpath d='M38.8167 47.1039H37.1663V41.85L35.5452 42.3236V41.0736L38.6653 39.9945H38.8167V47.1039Z' fill='white'/%3e%3ccircle cx='63.1679' cy='63.4887' r='6.16667' fill='%23ED154E' stroke='white'/%3e%3cpath d='M65.5635 66.9184H60.6025V65.8442L62.8877 63.4418C63.4508 62.8006 63.7324 62.2911 63.7324 61.9135C63.7324 61.6075 63.6657 61.3748 63.5322 61.2153C63.3988 61.0558 63.2051 60.976 62.9512 60.976C62.7005 60.976 62.4971 61.0835 62.3408 61.2983C62.1846 61.5099 62.1064 61.7752 62.1064 62.0942H60.4561C60.4561 61.658 60.5651 61.256 60.7832 60.8881C61.0013 60.517 61.304 60.2273 61.6914 60.019C62.0788 59.8107 62.5117 59.7065 62.9902 59.7065C63.7585 59.7065 64.3493 59.8839 64.7627 60.2387C65.1794 60.5935 65.3877 61.103 65.3877 61.767C65.3877 62.047 65.3356 62.3204 65.2314 62.5874C65.1273 62.851 64.9645 63.1293 64.7432 63.4223C64.5251 63.712 64.1719 64.101 63.6836 64.5893L62.7656 65.6489H65.5635V66.9184Z' fill='white'/%3e%3c/svg%3e";

var SuccessfullySubmittedRequestsModal = function SuccessfullySubmittedRequestsModal(_ref62) {
  var open = _ref62.open;
  return React.createElement(ScaffoldSuccessModal, {
    open: open,
    title: "Revisions Requested",
    imageSrc: img$2,
    subStatus: "You have successfully submitted this design!"
  });
};

var img$3 = "data:image/svg+xml,%3csvg width='102' height='101' viewBox='0 0 102 101' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3crect x='17.3752' y='15.4271' width='67.0694' height='68.7201' rx='33.5347' fill='%23FFDDE6'/%3e%3crect x='22.7949' y='20.9802' width='56.2299' height='57.6138' rx='28.115' fill='%23ED154E'/%3e%3cpath d='M94.5712 63.1587C95.2606 63.2326 95.7618 63.8661 95.6896 64.5725C95.6175 65.2789 94.9991 65.7924 94.3097 65.7185C93.6203 65.6445 93.1191 65.011 93.1913 64.3046C93.2634 63.5982 93.8818 63.0847 94.5712 63.1587Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.6171'/%3e%3cpath d='M24.9401 89.2264C26.0738 89.348 26.898 90.3898 26.7793 91.5514C26.6607 92.713 25.6439 93.5574 24.5102 93.4359C23.3765 93.3143 22.5524 92.2725 22.671 91.1109C22.7897 89.9493 23.8065 89.1049 24.9401 89.2264Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='2.65921'/%3e%3cpath d='M50.2282 2.63757C51.3619 2.75913 52.186 3.80096 52.0674 4.96255C51.9488 6.12414 50.932 6.96856 49.7983 6.84699C48.6646 6.72542 47.8404 5.6836 47.9591 4.52201C48.0777 3.36042 49.0945 2.516 50.2282 2.63757Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='2.65921'/%3e%3cpath d='M2.39816 30.196C2.91891 30.196 3.34172 30.6292 3.34172 31.1628C3.34172 31.6963 2.91891 32.1296 2.39816 32.1296C1.8774 32.1296 1.45459 31.6963 1.45459 31.1628C1.45459 30.6292 1.8774 30.196 2.39816 30.196Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.94378'/%3e%3cpath d='M75.6838 93.242C76.2046 93.242 76.6274 93.6752 76.6274 94.2088C76.6274 94.7424 76.2046 95.1756 75.6838 95.1756C75.163 95.1756 74.7402 94.7424 74.7402 94.2088C74.7402 93.6752 75.163 93.242 75.6838 93.242Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.94378'/%3e%3cpath d='M89.9194 26.2803L91.0277 22.5697' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e%3cpath d='M88.7224 23.8842L92.3439 25.0197' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e%3cpath d='M6.20874 65.6812L7.18628 61.9322' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e%3cpath d='M4.92871 63.3306L8.58765 64.3322' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e%3cpath d='M84.9326 82.4698L85.7089 78.6717' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e%3cpath d='M83.5291 80.1943L87.2359 80.9897' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e%3cpath d='M33.1511 85.9831C30.3897 85.9831 28.1511 83.7445 28.1511 80.9831L28.1511 18.4831C28.1511 15.7217 30.3897 13.4831 33.1511 13.4831L68.1511 13.4831C70.9125 13.4831 73.1511 15.7217 73.1511 18.4831L73.1511 80.9831C73.1511 83.7445 70.9125 85.9831 68.1511 85.9831L33.1511 85.9831Z' fill='%23D52B57'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M71.6523 84.5894L29 15.7521C29.8925 14.3859 31.4353 13.483 33.189 13.483L68.189 13.483C70.9505 13.483 73.189 15.7216 73.189 18.483L73.189 80.983C73.189 82.4001 72.5995 83.6795 71.6523 84.5894Z' fill='%23E43F6B'/%3e%3cpath d='M28.1511 58.7956L28.1511 56.2956L31.9011 56.2956L31.9011 58.7956L28.1511 58.7956Z' fill='%23FFDDE6'/%3e%3cpath d='M69.4011 58.7956L69.4011 56.2956L73.1511 56.2956L73.1511 58.7956L69.4011 58.7956Z' fill='%23FFDDE6'/%3e%3cpath d='M34.4011 58.7956L34.4011 56.2956L36.9011 56.2956L36.9011 58.7956L34.4011 58.7956Z' fill='%23FFDDE6'/%3e%3cpath d='M39.4011 58.7956L39.4011 56.2956L41.9011 56.2956L41.9011 58.7956L39.4011 58.7956Z' fill='%23FFDDE6'/%3e%3cpath d='M44.4011 58.7956L44.4011 56.2956L46.9011 56.2956L46.9011 58.7956L44.4011 58.7956Z' fill='%23FFDDE6'/%3e%3cpath d='M49.4011 58.7956L49.4011 56.2956L51.9011 56.2956L51.9011 58.7956L49.4011 58.7956Z' fill='%23FFDDE6'/%3e%3cpath d='M54.4011 58.7956L54.4011 56.2956L56.9011 56.2956L56.9011 58.7956L54.4011 58.7956Z' fill='%23FFDDE6'/%3e%3cpath d='M59.4011 58.7956L59.4011 56.2956L61.9011 56.2956L61.9011 58.7956L59.4011 58.7956Z' fill='%23FFDDE6'/%3e%3cpath d='M64.4011 58.7956L64.4011 56.2956L66.9011 56.2956L66.9011 58.7956L64.4011 58.7956Z' fill='%23FFDDE6'/%3e%3cpath d='M33.1511 47.2331L33.1511 22.2331L68.1501 22.2331L68.1501 47.2331L33.1511 47.2331Z' fill='white'/%3e%3cpath d='M68.1514 41.1944L60.0113 28.258C59.8237 27.9454 59.5584 27.6867 59.2412 27.5071C58.924 27.3275 58.5656 27.2331 58.2011 27.2331C57.8091 27.2331 57.4248 27.3423 57.0913 27.5484C56.7578 27.7545 56.4883 28.0494 56.313 28.4001L46.8967 47.2331L68.1514 47.2331V41.1944Z' fill='%239CC221'/%3e%3cpath d='M68.1511 29.7331L64.919 29.7331C64.3586 29.7331 63.8036 29.8435 63.2858 30.058C62.7681 30.2724 62.2976 30.5868 61.9013 30.9831C61.505 31.3794 61.0346 31.6938 60.5168 31.9082C59.999 32.1227 59.4441 32.2331 58.8836 32.2331L58.1514 32.2331C57.4884 32.2331 56.8525 32.4965 56.3837 32.9653C55.9149 33.4342 55.6515 34.0701 55.6515 34.7331C55.6515 35.3961 55.9149 36.032 56.3837 36.5009C56.8525 36.9697 57.4884 37.2331 58.1514 37.2331L68.1511 37.2331L68.1511 29.7331Z' fill='%23CDF4F7'/%3e%3cpath d='M33.1513 22.2331H36.3834C36.9438 22.2331 37.4988 22.3435 38.0166 22.558C38.5343 22.7724 39.0048 23.0868 39.4011 23.4831C39.7974 23.8794 40.2678 24.1938 40.7856 24.4082C41.3034 24.6227 41.8583 24.7331 42.4187 24.7331H43.151C43.814 24.7331 44.4498 24.9965 44.9187 25.4653C45.3875 25.9342 45.6509 26.5701 45.6509 27.2331C45.6509 27.8961 45.3875 28.532 44.9187 29.0009C44.4498 29.4697 43.814 29.7331 43.151 29.7331H33.1513V22.2331Z' fill='%23CDF4F7'/%3e%3cpath d='M56.8963 47.2331L48.7717 32.144C48.5827 31.7931 48.3023 31.4998 47.96 31.2954C47.6178 31.091 47.2267 30.9831 46.8281 30.9831C46.4647 30.9831 46.1069 31.0728 45.7865 31.2443C45.4661 31.4158 45.1929 31.6637 44.9913 31.9661L33.2009 47.2331L38.1469 47.2331L56.8963 47.2331Z' fill='%23ACCD2A'/%3e%3cpath d='M38.1936 63.6039H43.1865V66.9326H38.1936V63.6039Z' fill='%23FFDDE6'/%3e%3cpath d='M46.5154 63.6039H56.5012V66.9326H46.5154V63.6039Z' fill='%23FFDDE6'/%3e%3cpath d='M59.8296 63.6039H68.1511V66.9326H59.8296V63.6039Z' fill='%23FFDDE6'/%3e%3cpath d='M33.2007 70.2611H48.1794V73.5897H33.2007V70.2611Z' fill='%23FFDDE6'/%3e%3cpath d='M51.5081 70.2611H61.4939V73.5897H51.5081V70.2611Z' fill='%23FFDDE6'/%3e%3cpath d='M64.8225 70.2611H68.1511V73.5897H64.8225V70.2611Z' fill='%23FFDDE6'/%3e%3cpath d='M33.2007 76.9183H38.1936V80.247H33.2007V76.9183Z' fill='%23FFDDE6'/%3e%3cpath d='M41.5222 76.9183H54.8367V80.247H41.5222V76.9183Z' fill='%23FFDDE6'/%3e%3cpath d='M58.1653 76.9183H68.1511V80.247H58.1653V76.9183Z' fill='%23FFDDE6'/%3e%3c/svg%3e";

var SuccessfullySubmittedRevisionsModal = function SuccessfullySubmittedRevisionsModal(_ref63) {
  var open = _ref63.open;
  return React.createElement(ScaffoldSuccessModal, {
    open: open,
    title: "Design Submitted",
    imageSrc: img$3,
    renderUrl: function renderUrl(url) {
      return "".concat(url, "?start=true");
    },
    subStatus: "You have successfully submitted this design!"
  });
};

var RevisionReviewMarker = function RevisionReviewMarker(_ref64) {
  var active = _ref64.active,
      value = _ref64.value,
      style = _ref64.style;

  var _useContext37 = useContext(DesignContext.Base),
      workflow = _useContext37.workflow;

  var isRequest = workflow === Workflow.Request;
  var index = typeof value === 'number' ? value : 0;
  var delay = index * 400;

  var _useState77 = useState(isRequest),
      _useState78 = _slicedToArray(_useState77, 2),
      isCheck = _useState78[0],
      setIsCheck = _useState78[1];

  var setIcon = function setIcon() {
    if (isRequest) {
      return React.createElement(RejectedBadge, null);
    } else {
      return React.createElement(CheckedBadge, null);
    }
  };

  var _useSpring7 = useSpring({
    config: config.molasses,
    from: {
      r: 237,
      g: 21,
      b: 78,
      rotate: 0
    },
    to: {
      r: 237,
      g: 21,
      b: 78,
      rotate: 360
    },
    delay: delay,
    onStart: function onStart() {
      setIsCheck(!isRequest);
    }
  }),
      r = _useSpring7.r,
      g = _useSpring7.g,
      b = _useSpring7.b,
      rotate = _useSpring7.rotate;

  return React.createElement(PlainNumberedBadge, {
    active: active,
    value: isCheck ? setIcon() : value,
    style: _objectSpread({
      position: 'absolute'
    }, style, {
      backgroundColor: to([r, g, b], function (r, g, b) {
        return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
      }),
      transformStyle: 'preserve-3d',
      transform: rotate.to(function (r) {
        return "rotateY(".concat(r, "deg)");
      })
    })
  });
};

var RevisionReviewWelcomeModalContents = function RevisionReviewWelcomeModalContents(_ref65) {
  var title = _ref65.title,
      mainButton = _ref65.mainButton,
      body = _ref65.body,
      secondaryButton = _ref65.secondaryButton,
      footer = _ref65.footer;

  var _useContext38 = useContext(UIStateContext.Derived.Scaffold),
      frontPostcardUrl = _useContext38.frontPostcardUrl;

  var _useContext39 = useContext(CommentsStore.DerivedComments),
      frontComments = _useContext39.front;

  var _useContext40 = useContext(UIStateContext.Derived.ImageViewer),
      isPortrait = _useContext40.isPortrait;

  var hasBody = typeof body !== 'undefined';

  var _useContext41 = useContext(DesignContext.Base),
      workflow = _useContext41.workflow;

  var ThumbnailMarker = workflow === Workflow.Request ? PlainNumberedBadge : RevisionReviewMarker;
  return React.createElement("div", {
    style: {
      maxWidth: '768px'
    }
  }, React.createElement("div", {
    style: {
      textAlign: 'center',
      marginBottom: '2.2em'
    }
  }, React.createElement(Typography, {
    variant: "h4",
    component: "h2",
    style: {
      fontWeight: 'bold',
      marginBottom: '.3em',
      fontSize: '2.2rem'
    }
  }, title)), React.createElement("div", {
    style: {
      maxWidth: 300,
      maxHeight: 300,
      margin: '0 auto 0.5rem auto'
    }
  }, React.createElement(ThumbnailsWithMarkers, {
    thumbnails: [{
      src: frontPostcardUrl,
      alt: 'Front Design',
      markers: frontComments
    }],
    MarkerComponent: ThumbnailMarker,
    isPortrait: isPortrait
  })), React.createElement("div", {
    style: {
      marginTop: hasBody ? '1em' : '1.5rem'
    }
  }, body), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    }
  }, mainButton, secondaryButton, footer));
};

var RevisionReviewWelcomeModalBase = function RevisionReviewWelcomeModalBase(props) {
  var open = props.open;

  var _useContext42 = useContext(ActionsContext),
      closeModal = _useContext42.closeModal;

  return React.createElement(Dialog$1, {
    open: open,
    TransitionComponent: SlideUpTransition,
    onBackdropClick: closeModal,
    PaperProps: {
      style: {
        overflow: 'visible'
      }
    }
  }, React.createElement("div", {
    style: {
      backgroundColor: '#fff',
      minWidth: '550px',
      maxWidth: '1024px',
      padding: '2.5rem 3rem',
      borderRadius: '4px',
      outline: 'none'
    }
  }, React.createElement(RevisionReviewWelcomeModalContents, Object.assign({}, props))));
};

var img$4 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='37.613' height='37.613' viewBox='0 0 37.613 37.613'%3e%3cdefs%3e%3cstyle%3e.a%7bfill:%23ed154e%3b%7d.b%2c.c%7bstroke:none%3b%7d.c%7bfill:%23f9f9f9%3b%7d.d%7bfilter:url(%23a)%3b%7d%3c/style%3e%3cfilter id='a' x='0' y='0' width='37.613' height='37.613' filterUnits='userSpaceOnUse'%3e%3cfeOffset dx='3' dy='1' input='SourceAlpha'/%3e%3cfeGaussianBlur stdDeviation='1.5' result='b'/%3e%3cfeFlood flood-opacity='0.502'/%3e%3cfeComposite operator='in' in2='b'/%3e%3cfeComposite in='SourceGraphic'/%3e%3c/filter%3e%3c/defs%3e%3cg class='d' transform='matrix(1%2c 0%2c 0%2c 1%2c 0%2c 0)'%3e%3cg class='a' transform='translate(3 5.62)'%3e%3cpath class='b' d='M 1.212353587150574 25.74199295043945 L 0.9612136483192444 25.74199295043945 L 3.641357352535124e-06 25.74199295043945 L -0.7499963641166687 25.74199295043945 L -0.7499963641166687 24.99199295043945 L -0.7499963641166687 24.03078269958496 L -0.7499963641166687 23.77964401245117 L -0.5987663865089417 23.57915306091309 L 5.646956443786621 15.29860496520996 L 1.812673687934875 11.46431350708008 L 0.5323436260223389 10.18398284912109 L 2.343003749847412 10.18398284912109 L 7.469688415527344 10.18398284912109 L 12.25053310394287 4.720152378082275 L 10.40368366241455 2.873303174972534 L 9.873353958129883 2.342973232269287 L 10.40368366241455 1.81264317035675 L 12.74668407440186 -0.5303568840026855 L 13.27701377868652 -1.060686826705933 L 13.80734348297119 -0.5303568840026855 L 25.52235412597656 11.18465328216553 L 26.05268287658691 11.7149829864502 L 25.52235412597656 12.24531269073486 L 23.17935371398926 14.58831310272217 L 22.64902305603027 15.11864280700684 L 22.11869430541992 14.58831310272217 L 20.2718448638916 12.74146366119385 L 14.80801391601563 17.52230834960938 L 14.80801391601563 22.64899253845215 L 14.80801391601563 24.45965385437012 L 13.52768325805664 23.17932319641113 L 9.693401336669922 19.34504127502441 L 1.412843585014343 25.59076309204102 L 1.212353587150574 25.74199295043945 Z M 10.43267345428467 11.7149829864502 L 10.93401336669922 12.21632289886475 L 15.34035396575928 7.809983253479004 L 14.83901405334473 7.308643341064453 L 10.43267345428467 11.7149829864502 Z'/%3e%3cpath class='c' d='M 13.27701377868652 -2.6702880859375e-05 L 10.93401336669922 2.342973709106445 L 13.27701377868652 4.685972213745117 L 7.810012817382813 10.93398284912109 L 2.34300422668457 10.93398284912109 L 6.638504028320313 15.22949314117432 L 3.814697265625e-06 24.03078269958496 L 3.814697265625e-06 24.99199295043945 L 0.9612140655517578 24.99199295043945 L 9.762514114379883 18.35349273681641 L 14.05801391601563 22.64899253845215 L 14.05801391601563 17.18198394775391 L 20.30602264404297 11.7149829864502 L 22.64902305603027 14.0579833984375 L 24.99202346801758 11.7149829864502 L 13.27701377868652 -2.6702880859375e-05 M 10.93401336669922 13.2769832611084 L 9.372014045715332 11.7149829864502 L 14.83901405334473 6.24797248840332 L 16.4010124206543 7.809982299804688 L 10.93401336669922 13.2769832611084 M 13.27701377868652 -2.121347427368164 L 14.33767318725586 -1.060686111450195 L 26.05268287658691 10.65432357788086 L 27.11334419250488 11.7149829864502 L 26.05268287658691 12.77564334869385 L 23.70968437194824 15.11864280700684 L 22.64902305603027 16.17930221557617 L 21.58836364746094 15.11864280700684 L 20.2376708984375 13.7679500579834 L 15.55801391601563 17.86264419555664 L 15.55801391601563 22.64899253845215 L 15.55801391601563 26.27031326293945 L 12.99735355377197 23.70965385437012 L 9.624288558959961 20.33658790588379 L 1.864473342895508 26.18953323364258 L 1.463483810424805 26.49199295043945 L 0.9612140655517578 26.49199295043945 L 3.814697265625e-06 26.49199295043945 L -1.499996185302734 26.49199295043945 L -1.499996185302734 24.99199295043945 L -1.499996185302734 24.03078269958496 L -1.499996185302734 23.52851295471191 L -1.197536468505859 23.12751388549805 L 4.655405044555664 15.36771297454834 L 1.282342910766602 11.99464321136475 L -1.27830696105957 9.433982849121094 L 2.34300422668457 9.433982849121094 L 7.129352569580078 9.433982849121094 L 11.22404670715332 4.754325866699219 L 9.873353958129883 3.403633117675781 L 8.812694549560547 2.342973709106445 L 9.873353958129883 1.282312393188477 L 12.21635341644287 -1.060686111450195 L 13.27701377868652 -2.121347427368164 Z'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e";

var ThumbnailWithPin = function ThumbnailWithPin(_ref66) {
  var imgSrc = _ref66.imgSrc,
      imageWidth = _ref66.imageWidth,
      imageHeight = _ref66.imageHeight;

  var _useState79 = useState(false),
      _useState80 = _slicedToArray(_useState79, 2),
      imageHasLoaded = _useState80[0],
      setImageHasLoaded = _useState80[1];

  return React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplate: '1fr / 1fr',
      margin: '0 auto 0.2rem auto',
      width: imageWidth,
      height: imageHeight
    }
  }, React.createElement("div", {
    style: {
      gridArea: '1 / 1 / 2 / 2'
    }
  }, React.createElement(Thumbnail$1, {
    imgSrc: imgSrc,
    imgAlt: "Design Review Placeholder",
    orientation: "landscape",
    width: "".concat(imageWidth, "px"),
    height: "".concat(imageHeight, "px"),
    onThumbnailLoad: function onThumbnailLoad() {
      setImageHasLoaded(true);
    }
  })), React.createElement("div", {
    style: {
      gridArea: '1 / 1 / 2 / 2',
      zIndex: 1,
      width: imageWidth,
      height: imageHeight,
      display: 'grid',
      placeItems: 'center'
    }
  }, React.createElement(Fade, {
    in: imageHasLoaded
  }, React.createElement("img", {
    src: img$4,
    alt: "Pin",
    style: {
      width: '60px',
      height: '60px'
    }
  }))));
};

var useWelcomeModalStyles = makeStyles({
  dialog: {
    width: '550px'
  },
  modalContainer: {
    backgroundColor: '#fff',
    minWidth: '550px',
    maxWidth: '1024px',
    padding: '2.5rem 3rem',
    borderRadius: '4px',
    outline: 'none'
  },
  modalHeader: {
    fontWeight: 'bold',
    marginBottom: '1.5rem',
    textAlign: 'center',
    fontSize: '2.2rem'
  }
});
var useButtonStyles = makeStyles({
  mainButton: {
    backgroundColor: Colors.MVP_LIGHT_PINK,
    marginBottom: '0.5em',
    textTransform: 'uppercase',
    color: '#fff',
    '&:hover': {
      backgroundColor: Colors.MVP_LIGHT_PINK
    }
  },
  secondaryButton: {
    backgroundColor: '#fff',
    color: Colors.MVP_LIGHT_PINK,
    border: "1px solid ".concat(Colors.MVP_LIGHT_PINK),
    '&:hover': {
      backgroundColor: '#fff'
    }
  }
});

var WelcomeModalBase = function WelcomeModalBase(_ref67) {
  var open = _ref67.open,
      title = _ref67.title,
      image = _ref67.image,
      mainButton = _ref67.mainButton,
      body = _ref67.body,
      secondaryButton = _ref67.secondaryButton,
      footer = _ref67.footer;

  var _useContext43 = useContext(ActionsContext),
      closeModal = _useContext43.closeModal;

  var classes = useWelcomeModalStyles();
  var hasBody = typeof body !== 'undefined';
  return React.createElement(Dialog$1, {
    open: open,
    TransitionComponent: SlideUpTransition,
    onBackdropClick: closeModal,
    PaperProps: {
      className: classes.dialog
    }
  }, React.createElement("div", {
    className: classes.modalContainer
  }, React.createElement("div", {
    style: {
      maxWidth: '768px'
    }
  }, React.createElement(Typography, {
    variant: "h4",
    component: "h2",
    className: classes.modalHeader
  }, title), image, React.createElement("div", {
    style: {
      margin: !hasBody ? '1.5rem 1.5rem' : '0rem'
    }
  }, body), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    }
  }, mainButton, secondaryButton, footer))));
};

var InitialReview = function InitialReview() {
  return React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      margin: '28px 0 14px 0',
      textAlign: 'center'
    }
  }, React.createElement(Typography, {
    style: {
      marginBottom: '0.6rem',
      marginTop: '1em',
      fontSize: '1.1rem'
    }
  }, "Let\u2019s make sure this design includes all the right offers, messaging, demographics, and content. Also verify correct basics like the location details and names."));
};

var DesignReviewPeerReview = function DesignReviewPeerReview() {
  return React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center'
    }
  }, React.createElement("ul", {
    style: {
      listStyle: 'none',
      textAlign: 'left',
      paddingLeft: '0'
    }
  }, React.createElement("li", null, React.createElement(Typography, {
    style: {
      marginBottom: '0.6rem',
      fontSize: '1.1rem'
    }
  }, React.createElement("span", {
    role: "img",
    "aria-label": "Folder",
    style: {
      fontSize: '1.4rem'
    }
  }, "\uD83D\uDCC2"), React.createElement("span", {
    style: {
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
      paddingLeft: '0.7rem'
    }
  }, "Make sure"), ' ', "the .ai file opens without errors.")), React.createElement("li", null, React.createElement(Typography, {
    style: {
      marginBottom: '0.6rem',
      fontSize: '1.1rem'
    }
  }, React.createElement("span", {
    role: "img",
    "aria-label": "Paint Palette",
    style: {
      fontSize: '1.4rem'
    }
  }, "\uD83C\uDFA8"), React.createElement("span", {
    style: {
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
      paddingLeft: '0.7rem'
    }
  }, "Verify"), ' ', "the design matches the office's brand.")), React.createElement("li", null, React.createElement(Typography, {
    style: {
      marginBottom: '0.8rem',
      fontSize: '1.1rem'
    }
  }, React.createElement("span", {
    role: "img",
    "aria-label": "Mailbox",
    style: {
      fontSize: '1.4rem'
    }
  }, "\uD83D\uDCEC"), React.createElement("span", {
    style: {
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
      paddingLeft: '0.7rem'
    }
  }, "Give feedback"), ' ', "on readability and engagement."))));
};

var FailedDesignPeerReview = function FailedDesignPeerReview() {
  return React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, React.createElement(Typography, {
    style: {
      marginTop: '0.6rem',
      marginBottom: '0.3rem',
      fontSize: '1.1rem',
      textAlign: 'justify'
    }
  }, "The v1 designer will be notified that their design failed verification. Please proceed with design review as you normally would and re-verify once the next version is submitted."), React.createElement("ul", {
    style: {
      listStyle: 'none',
      textAlign: 'left',
      paddingLeft: '0'
    }
  }, React.createElement("li", null, React.createElement(Typography, {
    style: {
      marginBottom: '0.6rem',
      fontSize: '1.1rem'
    }
  }, React.createElement("span", {
    role: "img",
    "aria-label": "Folder",
    style: {
      fontSize: '1.4rem'
    }
  }, "\uD83D\uDCC2"), React.createElement("span", {
    style: {
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
      paddingLeft: '0.7rem'
    }
  }, "Make sure"), ' ', "the .ai file opens without errors.")), React.createElement("li", null, React.createElement(Typography, {
    style: {
      marginBottom: '0.6rem',
      fontSize: '1.1rem'
    }
  }, React.createElement("span", {
    role: "img",
    "aria-label": "Paint Palette",
    style: {
      fontSize: '1.4rem'
    }
  }, "\uD83C\uDFA8"), React.createElement("span", {
    style: {
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
      paddingLeft: '0.7rem'
    }
  }, "Verify"), ' ', "the design matches the office's brand.")), React.createElement("li", null, React.createElement(Typography, {
    style: {
      marginBottom: '0.8rem',
      fontSize: '1.1rem'
    }
  }, React.createElement("span", {
    role: "img",
    "aria-label": "Mailbox",
    style: {
      fontSize: '1.4rem'
    }
  }, "\uD83D\uDCEC"), React.createElement("span", {
    style: {
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
      paddingLeft: '0.7rem'
    }
  }, "Give feedback"), ' ', "on readability and engagement."))));
};

var MarketingReview = function MarketingReview() {
  return React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center'
    }
  }, React.createElement("ul", {
    style: {
      listStyle: 'none',
      textAlign: 'left',
      paddingLeft: '0'
    }
  }, React.createElement("li", null, React.createElement(Typography, {
    style: {
      marginBottom: '0.6rem',
      fontSize: '1.1rem'
    }
  }, React.createElement("span", {
    role: "img",
    "aria-label": "Bag of Money",
    style: {
      fontSize: '1.4rem'
    }
  }, "\uD83D\uDCB0"), React.createElement("span", {
    style: {
      whiteSpace: 'nowrap',
      paddingLeft: '0.7rem'
    }
  }, "Compelling and accurate offers"))), React.createElement("li", null, React.createElement(Typography, {
    style: {
      marginBottom: '0.6rem',
      fontSize: '1.1rem'
    }
  }, React.createElement("span", {
    role: "img",
    "aria-label": "Telephone",
    style: {
      fontSize: '1.4rem'
    }
  }, "\u260E\uFE0F"), React.createElement("span", {
    style: {
      whiteSpace: 'nowrap',
      paddingLeft: '0.7rem'
    }
  }, "Clearly visible calls to action"))), React.createElement("li", null, React.createElement(Typography, {
    style: {
      marginBottom: '0.6rem',
      fontSize: '1.1rem'
    }
  }, React.createElement("span", {
    role: "img",
    "aria-label": "Newspaper",
    style: {
      fontSize: '1.4rem'
    }
  }, "\uD83D\uDCF0"), React.createElement("span", {
    style: {
      whiteSpace: 'nowrap',
      paddingLeft: '0.7rem'
    }
  }, "Relevant and helpful information"))), React.createElement("li", null, React.createElement(Typography, {
    style: {
      marginBottom: '0.6rem',
      fontSize: '1.1rem'
    }
  }, React.createElement("span", {
    role: "img",
    "aria-label": "Globe",
    style: {
      fontSize: '1.4rem'
    }
  }, "\uD83C\uDF0E"), React.createElement("span", {
    style: {
      whiteSpace: 'nowrap',
      paddingLeft: '0.7rem'
    }
  }, "Local and seasonally appropriate"))), React.createElement("li", null, React.createElement(Typography, {
    style: {
      marginBottom: '0.6rem',
      fontSize: '1.1rem'
    }
  }, React.createElement("span", {
    role: "img",
    "aria-label": "Mailbox",
    style: {
      fontSize: '1.4rem'
    }
  }, "\uD83D\uDCEC"), React.createElement("span", {
    style: {
      whiteSpace: 'nowrap',
      paddingLeft: '0.7rem'
    }
  }, "Readable and engaging")))));
};

var FailedMarketingReview = function FailedMarketingReview() {
  return React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, React.createElement(Typography, {
    style: {
      marginTop: '1.5rem',
      marginBottom: '1.5rem',
      fontSize: '1.1rem',
      textAlign: 'center'
    }
  }, "Looks like this design needs a little more work. Feel free to reach out to the design team to clarify your rejected requests."));
};

var FailedCustomerReview = function FailedCustomerReview() {
  return React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, React.createElement(Typography, {
    style: {
      marginTop: '0.6rem',
      marginBottom: '0.6rem',
      fontSize: '1.1rem',
      textAlign: 'justify'
    }
  }, "Looks like this design needs a little more work. You can submit your rejected changes now or you can request more changes first."));
};

var FailedReview = function FailedReview() {
  var buttonClasses = useButtonStyles();

  var _useContext44 = useContext(ActionsContext),
      closeModal = _useContext44.closeModal;

  return React.createElement(RevisionReviewWelcomeModalBase, {
    open: true,
    title: "Design failed verification",
    body: React.createElement(FailedDesignPeerReview, null),
    mainButton: React.createElement(Button$1, {
      className: buttonClasses.mainButton,
      variant: "contained",
      onClick: closeModal
    }, "START PEER REVIEW")
  });
};

var ResumeReview = function ResumeReview() {
  var buttonClasses = useButtonStyles();

  var _useContext45 = useContext(ActionsContext),
      closeModal = _useContext45.closeModal;

  return React.createElement(RevisionReviewWelcomeModalBase, {
    open: true,
    title: "Welcome back to peer review!",
    body: React.createElement(DesignReviewPeerReview, null),
    mainButton: React.createElement(Button$1, {
      className: buttonClasses.mainButton,
      variant: "contained",
      onClick: closeModal
    }, "CONTINUE PEER REVIEW")
  });
};

var Default = function Default() {
  var buttonClasses = useButtonStyles();

  var _useContext46 = useContext(UIStateContext.Derived.Scaffold),
      frontThumbnailUrl = _useContext46.frontThumbnailUrl;

  var _useContext47 = useContext(ActionsContext),
      closeModal = _useContext47.closeModal;

  var _useContext48 = useContext(DesignContext.Derived),
      mediaType = _useContext48.mediaType;

  var _getDimensionFactorsB2 = getDimensionFactorsByMediaType(mediaType),
      widthFactor = _getDimensionFactorsB2.widthFactor,
      heightFactor = _getDimensionFactorsB2.heightFactor;

  var imageWidth = 300;
  var imageHeight = imageWidth / widthFactor * heightFactor;
  return React.createElement(WelcomeModalBase, {
    open: true,
    title: "Ready for peer review!",
    image: React.createElement(ThumbnailWithPin, {
      imgSrc: frontThumbnailUrl,
      imageWidth: imageWidth,
      imageHeight: imageHeight
    }),
    body: React.createElement(DesignReviewPeerReview, null),
    mainButton: React.createElement(Button$1, {
      className: buttonClasses.mainButton,
      variant: "contained",
      onClick: closeModal
    }, "START PEER REVIEW")
  });
};

var FailedReview$1 = function FailedReview$1(_ref68) {
  var numRejected = _ref68.numRejected;
  var buttonClasses = useButtonStyles();

  var _useContext49 = useContext(ActionsContext),
      closeModal = _useContext49.closeModal;

  return React.createElement(RevisionReviewWelcomeModalBase, {
    open: true,
    title: "".concat(numRejected, " rejected requests"),
    body: React.createElement(FailedMarketingReview, null),
    mainButton: React.createElement(Button$1, {
      className: buttonClasses.mainButton,
      variant: "contained",
      onClick: closeModal
    }, "RESUBMIT REJECTED REQUESTS"),
    secondaryButton: React.createElement(Button$1, {
      className: buttonClasses.secondaryButton,
      variant: "contained",
      onClick: closeModal
    }, "REQUEST MORE CHANGES")
  });
};

var ResumeReview$1 = function ResumeReview$1(_ref69) {
  var numPending = _ref69.numPending;
  var buttonClasses = useButtonStyles();

  var _useContext50 = useContext(ActionsContext),
      openModal = _useContext50.openModal,
      closeModal = _useContext50.closeModal;

  return React.createElement(RevisionReviewWelcomeModalBase, {
    open: true,
    title: "Welcome back to Marketing Review!",
    body: React.createElement(MarketingReview, null),
    mainButton: React.createElement(Button$1, {
      className: buttonClasses.mainButton,
      variant: "contained",
      onClick: closeModal
    }, "CONTINUE MARKETING REVIEW"),
    secondaryButton: React.createElement(Button$1, {
      className: buttonClasses.secondaryButton,
      variant: "contained",
      onClick: function () {
        var _onClick5 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee11() {
          return _regeneratorRuntime.wrap(function _callee11$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  openModal({
                    type: ModalTypes.FinalizeRequests
                  });
                  return _context11.abrupt("return");

                case 2:
                case "end":
                  return _context11.stop();
              }
            }
          }, _callee11);
        }));

        function onClick() {
          return _onClick5.apply(this, arguments);
        }

        return onClick;
      }()
    }, "SUBMIT ".concat(numPending, " REQUEST").concat(numPending > 1 ? 'S' : '', " NOW"))
  });
};

var Default$1 = function Default$1() {
  var buttonClasses = useButtonStyles();

  var _useContext51 = useContext(UIStateContext.Derived.Scaffold),
      frontThumbnailUrl = _useContext51.frontThumbnailUrl;

  var _useContext52 = useContext(ActionsContext),
      closeModal = _useContext52.closeModal;

  var _useContext53 = useContext(DesignContext.Derived),
      mediaType = _useContext53.mediaType;

  var _getDimensionFactorsB3 = getDimensionFactorsByMediaType(mediaType),
      widthFactor = _getDimensionFactorsB3.widthFactor,
      heightFactor = _getDimensionFactorsB3.heightFactor;

  var imageWidth = 300;
  var imageHeight = imageWidth / widthFactor * heightFactor;
  return React.createElement(WelcomeModalBase, {
    open: true,
    title: "Ready for marketing review!",
    image: React.createElement(ThumbnailWithPin, {
      imgSrc: frontThumbnailUrl,
      imageWidth: imageWidth,
      imageHeight: imageHeight
    }),
    body: React.createElement(MarketingReview, null),
    mainButton: React.createElement(Button$1, {
      className: buttonClasses.mainButton,
      variant: "contained",
      onClick: closeModal
    }, "START MARKETING REVIEW")
  });
};

var FailedReview$2 = function FailedReview$2() {
  var buttonClasses = useButtonStyles();

  var _useContext54 = useContext(ActionsContext),
      closeModal = _useContext54.closeModal;

  return React.createElement(RevisionReviewWelcomeModalBase, {
    open: true,
    title: "Design failed proofread",
    body: React.createElement(FailedMarketingReview, null),
    mainButton: React.createElement(Button$1, {
      className: buttonClasses.mainButton,
      variant: "contained",
      onClick: closeModal
    }, "ADD PROOFREAD REQUESTS")
  });
};

var ResumeReview$2 = function ResumeReview$2() {
  var buttonClasses = useButtonStyles();

  var _useContext55 = useContext(ActionsContext),
      closeModal = _useContext55.closeModal;

  return React.createElement(RevisionReviewWelcomeModalBase, {
    open: true,
    title: "Welcome back to Proofread!",
    mainButton: React.createElement(Button$1, {
      className: buttonClasses.mainButton,
      variant: "contained",
      onClick: closeModal
    }, "CONTINUE PROOFREAD")
  });
};

var Default$2 = function Default$2() {
  var buttonClasses = useButtonStyles();

  var _useContext56 = useContext(UIStateContext.Derived.Scaffold),
      frontThumbnailUrl = _useContext56.frontThumbnailUrl;

  var _useContext57 = useContext(ActionsContext),
      closeModal = _useContext57.closeModal;

  var _useContext58 = useContext(DesignContext.Derived),
      mediaType = _useContext58.mediaType;

  var _getDimensionFactorsB4 = getDimensionFactorsByMediaType(mediaType),
      widthFactor = _getDimensionFactorsB4.widthFactor,
      heightFactor = _getDimensionFactorsB4.heightFactor;

  var imageWidth = 300;
  var imageHeight = imageWidth / widthFactor * heightFactor;
  return React.createElement(WelcomeModalBase, {
    open: true,
    title: "Ready for proofread!",
    image: React.createElement(ThumbnailWithPin, {
      imgSrc: frontThumbnailUrl,
      imageWidth: imageWidth,
      imageHeight: imageHeight
    }),
    mainButton: React.createElement(Button$1, {
      className: buttonClasses.mainButton,
      variant: "contained",
      onClick: closeModal
    }, "START PROOFREAD")
  });
};

var FailedReview$3 = function FailedReview$3() {
  var buttonClasses = useButtonStyles();

  var _useContext59 = useContext(ActionsContext),
      closeModal = _useContext59.closeModal;

  return React.createElement(RevisionReviewWelcomeModalBase, {
    open: true,
    title: "Design failed verification",
    body: React.createElement(FailedDesignPeerReview, null),
    mainButton: React.createElement(Button$1, {
      className: buttonClasses.mainButton,
      variant: "contained",
      onClick: closeModal
    }, "START INITIAL REVIEW")
  });
};

var ResumeReview$3 = function ResumeReview$3() {
  var buttonClasses = useButtonStyles();

  var _useContext60 = useContext(ActionsContext),
      closeModal = _useContext60.closeModal;

  return React.createElement(RevisionReviewWelcomeModalBase, {
    open: true,
    title: "Welcome back to initial review!",
    body: React.createElement(InitialReview, null),
    mainButton: React.createElement(Button$1, {
      className: buttonClasses.mainButton,
      variant: "contained",
      onClick: closeModal
    }, "CONTINUE INITIAL REVIEW")
  });
};

var Default$3 = function Default$3() {
  var buttonClasses = useButtonStyles();

  var _useContext61 = useContext(UIStateContext.Derived.Scaffold),
      frontThumbnailUrl = _useContext61.frontThumbnailUrl;

  var _useContext62 = useContext(ActionsContext),
      closeModal = _useContext62.closeModal;

  var _useContext63 = useContext(DesignContext.Derived),
      mediaType = _useContext63.mediaType;

  var _getDimensionFactorsB5 = getDimensionFactorsByMediaType(mediaType),
      widthFactor = _getDimensionFactorsB5.widthFactor,
      heightFactor = _getDimensionFactorsB5.heightFactor;

  var imageWidth = 300;
  var imageHeight = imageWidth / widthFactor * heightFactor;
  return React.createElement(WelcomeModalBase, {
    open: true,
    title: "Ready for initial review!",
    image: React.createElement(ThumbnailWithPin, {
      imgSrc: frontThumbnailUrl,
      imageWidth: imageWidth,
      imageHeight: imageHeight
    }),
    body: React.createElement(InitialReview, null),
    mainButton: React.createElement(Button$1, {
      className: buttonClasses.mainButton,
      variant: "contained",
      onClick: closeModal
    }, "START INITIAL REVIEW")
  });
};

var ConfirmReviewForm = function ConfirmReviewForm(_ref70) {
  var reviewText = _ref70.reviewText,
      reviewError = _ref70.reviewError,
      reviewed = _ref70.reviewed,
      setReviewed = _ref70.setReviewed,
      reviewHighlighted = _ref70.reviewHighlighted;
  var styles = useSpring({
    backgroundColor: reviewHighlighted ? 'rgb(255, 253, 181)' : '#fff',
    height: reviewHighlighted && !reviewed ? '5.125rem' : '3.625rem'
  });
  var errorTransition = useTransition(reviewHighlighted && !reviewed, {
    from: {
      opacity: 0
    },
    enter: {
      opacity: 1
    },
    leave: {
      opacity: 0
    }
  });
  return React.createElement(animated.div, {
    style: {
      borderRadius: '4px',
      padding: '0.5rem',
      marginTop: '-1rem',
      marginBottom: '1rem',
      width: '100%',
      height: styles.height,
      fontSize: '1rem',
      backgroundColor: styles.backgroundColor
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, React.createElement("span", null, React.createElement(Checkbox, {
    checked: reviewed,
    onChange: function onChange(_, c) {
      setReviewed(c);
    }
  })), reviewText), errorTransition(function (_ref71, item) {
    var opacity = _ref71.opacity;

    if (!item) {
      return null;
    }

    return React.createElement(animated.div, {
      style: {
        display: 'flex',
        justifyContent: 'center',
        opacity: opacity
      }
    }, reviewError);
  }));
};

var useConfirmReviewForm = function useConfirmReviewForm() {
  var _useState81 = useState(false),
      _useState82 = _slicedToArray(_useState81, 2),
      reviewed = _useState82[0],
      setReviewed = _useState82[1];

  var _useState83 = useState(false),
      _useState84 = _slicedToArray(_useState83, 2),
      reviewHighlighted = _useState84[0],
      setReviewHighlighted = _useState84[1];

  return {
    reviewed: reviewed,
    setReviewed: setReviewed,
    reviewHighlighted: reviewHighlighted,
    setReviewHighlighted: setReviewHighlighted
  };
};

var DesignReviewBody = function DesignReviewBody() {
  return React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center'
    }
  }, React.createElement("ul", {
    style: {
      listStyle: 'none',
      textAlign: 'left',
      paddingLeft: '0'
    }
  }, React.createElement("li", null, React.createElement(Typography, {
    style: {
      marginBottom: '0.6rem',
      fontSize: '1.1rem'
    }
  }, React.createElement("span", {
    role: "img",
    "aria-label": "Eyes",
    style: {
      fontSize: '1.4rem'
    }
  }, "\uD83D\uDC40"), React.createElement("span", {
    style: {
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
      paddingLeft: '0.7rem'
    }
  }, "Review both sides"), ' ', "of your design.")), React.createElement("li", null, React.createElement(Typography, {
    style: {
      marginBottom: '0.6em',
      fontSize: '1.1rem'
    }
  }, React.createElement("span", {
    role: "img",
    "aria-label": "Hand Pointer",
    style: {
      fontSize: '1.5rem'
    }
  }, "\uD83D\uDC46"), React.createElement("span", {
    style: {
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
      paddingLeft: '1rem'
    }
  }, "Click on design"), ' ', "to request a change.")), React.createElement("li", null, React.createElement(Typography, {
    style: {
      marginBottom: '0.8rem',
      fontSize: '1.1rem'
    }
  }, React.createElement("span", {
    role: "img",
    "aria-label": "Party Popper",
    style: {
      fontSize: '1.4rem'
    }
  }, "\uD83C\uDF89"), React.createElement("span", {
    style: {
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
      paddingLeft: '0.7rem'
    }
  }, "Approve"), ' ', "your design if it\u2019s ready to go."))));
};

var DesignReviewFooter = function DesignReviewFooter() {
  return React.createElement(Typography, {
    style: {
      textAlign: 'center'
    }
  }, React.createElement("span", {
    role: "img",
    "aria-label": "Bell",
    style: {
      fontSize: '1rem'
    }
  }, "\uD83D\uDD14"), React.createElement("span", null, " Design Review now available on\xA0"), React.createElement("span", null, React.createElement("a", {
    href: "https://apps.apple.com/us/app/mvp-mailhouse/id1365051972?ls=1",
    target: "_blank",
    rel: "noopener noreferrer",
    style: {
      color: '#ED154E'
    }
  }, "iPhone")), React.createElement("span", null, "\xA0and\xA0"), React.createElement("span", null, React.createElement("a", {
    href: "https://play.google.com/store/apps/details?id=com.mvpmailhouse",
    target: "_blank",
    rel: "noopener noreferrer",
    style: {
      color: '#ED154E'
    }
  }, "Android")), React.createElement("span", null, "."));
};

var FailedReview$4 = function FailedReview$4(_ref72) {
  var numRejected = _ref72.numRejected;
  var buttonClasses = useButtonStyles();

  var _useContext64 = useContext(ActionsContext),
      closeModal = _useContext64.closeModal;

  return React.createElement(RevisionReviewWelcomeModalBase, {
    open: true,
    title: "".concat(numRejected, " rejected requests"),
    body: React.createElement(FailedCustomerReview, null),
    mainButton: React.createElement(Button$1, {
      className: buttonClasses.mainButton,
      variant: "contained",
      onClick: closeModal
    }, "RESUBMIT REJECTED REQUESTS"),
    secondaryButton: React.createElement(Button$1, {
      className: buttonClasses.secondaryButton,
      variant: "contained",
      onClick: closeModal
    }, "REQUEST MORE CHANGES")
  });
};

var ResumeReview$4 = function ResumeReview$4() {
  var buttonClasses = useButtonStyles();

  var _useContext65 = useContext(ActionsContext),
      closeModal = _useContext65.closeModal;

  return React.createElement(RevisionReviewWelcomeModalBase, {
    open: true,
    title: "Welcome back to Design Review!",
    body: React.createElement(DesignReviewBody, null),
    mainButton: React.createElement(Button$1, {
      className: buttonClasses.mainButton,
      variant: "contained",
      onClick: closeModal
    }, "CONTINUE DESIGN REVIEW"),
    footer: React.createElement(DesignReviewFooter, null)
  });
};

var AcceptedAllRevisions = function AcceptedAllRevisions() {
  var buttonClasses = useButtonStyles();

  var _useContext66 = useContext(UIStateContext.Derived.Scaffold),
      frontThumbnailUrl = _useContext66.frontThumbnailUrl;

  var _useContext67 = useContext(DerivedActionsContext),
      handlers = _useContext67.handlers;

  var _useContext68 = useContext(ActionsContext),
      openModal = _useContext68.openModal,
      closeModal = _useContext68.closeModal;

  var _useContext69 = useContext(DesignContext.Derived),
      currentUser = _useContext69.currentUser,
      mediaType = _useContext69.mediaType;

  var confirmReviewFormProps = useConfirmReviewForm();

  var _useState85 = useState(false),
      _useState86 = _slicedToArray(_useState85, 2),
      isLoading = _useState86[0],
      setIsLoading = _useState86[1];

  var _getDimensionFactorsB6 = getDimensionFactorsByMediaType(mediaType),
      widthFactor = _getDimensionFactorsB6.widthFactor,
      heightFactor = _getDimensionFactorsB6.heightFactor;

  var imageWidth = 300;
  var imageHeight = imageWidth / widthFactor * heightFactor;
  return React.createElement(WelcomeModalBase, {
    open: true,
    title: "All changes accepted! Ready to approve?",
    image: React.createElement(ThumbnailWithPin, {
      imgSrc: frontThumbnailUrl,
      imageWidth: imageWidth,
      imageHeight: imageHeight
    }),
    body: React.createElement(Fragment, null, React.createElement(DesignReviewBody, null), React.createElement(ConfirmReviewForm, Object.assign({}, confirmReviewFormProps, {
      reviewText: React.createElement(AuthorizationText, {
        isApproving: true,
        name: currentUser.name
      }),
      reviewError: React.createElement(AuthorizationError, {
        isApproving: true
      })
    }))),
    mainButton: React.createElement(Button$1, {
      className: buttonClasses.mainButton,
      variant: "contained",
      onClick: function () {
        var _onClick6 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee12() {
          return _regeneratorRuntime.wrap(function _callee12$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  if (confirmReviewFormProps.reviewed) {
                    _context12.next = 4;
                    break;
                  }

                  confirmReviewFormProps.setReviewHighlighted(true);
                  _context12.next = 17;
                  break;

                case 4:
                  setIsLoading(true);
                  _context12.prev = 5;
                  _context12.next = 8;
                  return handlers.submitDesignReview(false);

                case 8:
                  openModal({
                    type: ModalTypes.DesignApproved
                  });
                  _context12.next = 14;
                  break;

                case 11:
                  _context12.prev = 11;
                  _context12.t0 = _context12["catch"](5);
                  console.error(_context12.t0);

                case 14:
                  _context12.prev = 14;
                  setIsLoading(false);
                  return _context12.finish(14);

                case 17:
                case "end":
                  return _context12.stop();
              }
            }
          }, _callee12, null, [[5, 11, 14, 17]]);
        }));

        function onClick() {
          return _onClick6.apply(this, arguments);
        }

        return onClick;
      }()
    }, "APPROVE DESIGN", isLoading && React.createElement(CircularProgress, {
      style: {
        color: '#fff',
        width: 20,
        height: 20,
        marginLeft: 8,
        marginTop: -2
      }
    })),
    secondaryButton: React.createElement(Button$1, {
      className: buttonClasses.secondaryButton,
      variant: "contained",
      onClick: closeModal
    }, "REQUEST ADDITIONAL CHANGES")
  });
};

var FromDesignConceptSelection = function FromDesignConceptSelection(props) {
  var buttonClasses = useButtonStyles();

  var _useContext70 = useContext(UIStateContext.Derived.Scaffold),
      frontThumbnailUrl = _useContext70.frontThumbnailUrl;

  var _useContext71 = useContext(ActionsContext),
      openModal = _useContext71.openModal,
      closeModal = _useContext71.closeModal;

  var _useContext72 = useContext(DerivedActionsContext),
      handlers = _useContext72.handlers;

  var _useContext73 = useContext(DesignContext.Derived),
      currentUser = _useContext73.currentUser,
      mediaType = _useContext73.mediaType;

  var confirmReviewFormProps = useConfirmReviewForm();

  var _useState87 = useState(false),
      _useState88 = _slicedToArray(_useState87, 2),
      isLoading = _useState88[0],
      setIsLoading = _useState88[1];

  var _getDimensionFactorsB7 = getDimensionFactorsByMediaType(mediaType),
      widthFactor = _getDimensionFactorsB7.widthFactor,
      heightFactor = _getDimensionFactorsB7.heightFactor;

  var imageWidth = 300;
  var imageHeight = imageWidth / widthFactor * heightFactor;
  var title = props.title;
  return React.createElement(WelcomeModalBase, {
    open: true,
    title: title !== null && title !== void 0 ? title : "Excellent choice! Ready to approve?",
    image: React.createElement(ThumbnailWithPin, {
      imgSrc: frontThumbnailUrl,
      imageWidth: imageWidth,
      imageHeight: imageHeight
    }),
    body: React.createElement(Fragment, null, React.createElement(DesignReviewBody, null), React.createElement(ConfirmReviewForm, Object.assign({}, confirmReviewFormProps, {
      reviewText: React.createElement(AuthorizationText, {
        isApproving: true,
        name: currentUser.name
      }),
      reviewError: React.createElement(AuthorizationError, {
        isApproving: true
      })
    }))),
    mainButton: React.createElement(Button$1, {
      className: buttonClasses.mainButton,
      variant: "contained",
      onClick: function () {
        var _onClick7 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee13() {
          return _regeneratorRuntime.wrap(function _callee13$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  if (confirmReviewFormProps.reviewed) {
                    _context13.next = 4;
                    break;
                  }

                  confirmReviewFormProps.setReviewHighlighted(true);
                  _context13.next = 17;
                  break;

                case 4:
                  setIsLoading(true);
                  _context13.prev = 5;
                  _context13.next = 8;
                  return handlers.submitDesignReview(false);

                case 8:
                  openModal({
                    type: ModalTypes.DesignApproved
                  });
                  _context13.next = 14;
                  break;

                case 11:
                  _context13.prev = 11;
                  _context13.t0 = _context13["catch"](5);
                  console.error(_context13.t0);

                case 14:
                  _context13.prev = 14;
                  setIsLoading(false);
                  return _context13.finish(14);

                case 17:
                case "end":
                  return _context13.stop();
              }
            }
          }, _callee13, null, [[5, 11, 14, 17]]);
        }));

        function onClick() {
          return _onClick7.apply(this, arguments);
        }

        return onClick;
      }()
    }, "APPROVE DESIGN", isLoading && React.createElement(CircularProgress, {
      style: {
        color: '#fff',
        width: 20,
        height: 20,
        marginLeft: 8,
        marginTop: -2
      }
    })),
    secondaryButton: React.createElement(Button$1, {
      className: buttonClasses.secondaryButton,
      variant: "contained",
      onClick: closeModal
    }, "REQUEST CHANGES"),
    footer: React.createElement(DesignReviewFooter, null)
  });
};

var Default$4 = function Default$4() {
  var buttonClasses = useButtonStyles();

  var _useContext74 = useContext(UIStateContext.Derived.Scaffold),
      frontThumbnailUrl = _useContext74.frontThumbnailUrl;

  var _useContext75 = useContext(ActionsContext),
      closeModal = _useContext75.closeModal;

  var _useContext76 = useContext(DesignContext.Derived),
      mediaType = _useContext76.mediaType;

  var _getDimensionFactorsB8 = getDimensionFactorsByMediaType(mediaType),
      widthFactor = _getDimensionFactorsB8.widthFactor,
      heightFactor = _getDimensionFactorsB8.heightFactor;

  var imageWidth = 300;
  var imageHeight = imageWidth / widthFactor * heightFactor;
  return React.createElement(WelcomeModalBase, {
    open: true,
    title: "Your design is ready for review!",
    image: React.createElement(ThumbnailWithPin, {
      imgSrc: frontThumbnailUrl,
      imageWidth: imageWidth,
      imageHeight: imageHeight
    }),
    body: React.createElement(DesignReviewBody, null),
    mainButton: React.createElement(Button$1, {
      className: buttonClasses.mainButton,
      variant: "contained",
      onClick: closeModal
    }, "Start Design Review"),
    footer: React.createElement(DesignReviewFooter, null)
  });
};

var Default$5 = function Default$5() {
  var buttonClasses = useButtonStyles();

  var _useContext77 = useContext(ActionsContext),
      closeModal = _useContext77.closeModal;

  return React.createElement(RevisionReviewWelcomeModalBase, {
    open: true,
    title: "Requests are ready for review!",
    body: React.createElement("div", {
      style: {
        height: '28px'
      }
    }),
    mainButton: React.createElement(Button$1, {
      className: buttonClasses.mainButton,
      variant: "contained",
      onClick: closeModal
    }, "REVIEW CHANGE REQUESTS")
  });
};

var Default$6 = function Default$6() {
  var buttonClasses = useButtonStyles();

  var _useContext78 = useContext(ActionsContext),
      closeModal = _useContext78.closeModal;

  return React.createElement(RevisionReviewWelcomeModalBase, {
    open: true,
    title: "Request are ready for review!",
    mainButton: React.createElement(Button$1, {
      className: buttonClasses.mainButton,
      variant: "contained",
      onClick: closeModal
    }, "REVIEW CHANGE REQUEST")
  });
};

var V1Only = function V1Only() {
  var buttonClasses = useButtonStyles();

  var _useContext79 = useContext(ActionsContext),
      closeModal = _useContext79.closeModal;

  return React.createElement(RevisionReviewWelcomeModalBase, {
    open: true,
    title: "Ready for initial review!",
    body: React.createElement(InitialReview, null),
    mainButton: React.createElement(Button$1, {
      className: buttonClasses.mainButton,
      variant: "contained",
      onClick: closeModal
    }, "START INITIAL REVIEW")
  });
};

var Default$7 = function Default$7() {
  var buttonClasses = useButtonStyles();

  var _useContext80 = useContext(ActionsContext),
      closeModal = _useContext80.closeModal;

  return React.createElement(RevisionReviewWelcomeModalBase, {
    open: true,
    title: "Requests are ready for review!",
    body: React.createElement("div", {
      style: {
        height: '28px'
      }
    }),
    mainButton: React.createElement(Button$1, {
      className: buttonClasses.mainButton,
      variant: "contained",
      onClick: closeModal
    }, "REVIEW CHANGE REQUESTS")
  });
};

var Default$8 = function Default$8() {
  var buttonClasses = useButtonStyles();

  var _useContext81 = useContext(ActionsContext),
      closeModal = _useContext81.closeModal;

  return React.createElement(RevisionReviewWelcomeModalBase, {
    open: true,
    title: "Requests are ready for review!",
    mainButton: React.createElement(Button$1, {
      className: buttonClasses.mainButton,
      variant: "contained",
      onClick: closeModal
    }, "REVIEW CHANGE REQUESTS")
  });
};

var Default$9 = function Default$9() {
  var buttonClasses = useButtonStyles();

  var _useContext82 = useContext(ActionsContext),
      closeModal = _useContext82.closeModal;

  return React.createElement(RevisionReviewWelcomeModalBase, {
    open: true,
    title: "Requests are ready for review!",
    body: React.createElement("div", {
      style: {
        height: '28px'
      }
    }),
    mainButton: React.createElement(Button$1, {
      className: buttonClasses.mainButton,
      variant: "contained",
      onClick: closeModal
    }, "REVIEW CHANGE REQUESTS")
  });
};

var RevisionReviewBody = function RevisionReviewBody() {
  return React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center'
    }
  }, React.createElement("ul", {
    style: {
      listStyle: 'none',
      textAlign: 'left',
      paddingLeft: '0'
    }
  }, React.createElement("li", null, React.createElement(Typography, {
    style: {
      fontSize: '1.1rem',
      marginBottom: '.6em'
    }
  }, React.createElement("span", {
    role: "img",
    "aria-label": "eyes",
    style: {
      fontSize: '1.4rem'
    }
  }, "\uD83D\uDC40"), React.createElement("span", {
    style: {
      fontWeight: 'bold',
      paddingLeft: '.8rem'
    }
  }, "Review your requests"), ' ', "one by one.")), React.createElement("li", null, React.createElement(Typography, {
    style: {
      fontSize: '1.1rem',
      marginBottom: '.6em'
    }
  }, React.createElement("span", {
    role: "img",
    "aria-label": "check",
    style: {
      color: 'green',
      fontSize: '1.5rem'
    }
  }, "\u2714\uFE0F"), React.createElement("span", {
    style: {
      fontWeight: 'bold',
      paddingLeft: '.6rem'
    }
  }, "Accept revisions"), ' ', "that look good.")), React.createElement("li", null, React.createElement(Typography, {
    style: {
      fontSize: '1.1rem',
      marginBottom: '1rem'
    }
  }, React.createElement("span", {
    role: "img",
    "aria-label": "check",
    style: {
      color: 'green',
      fontSize: '1.4rem'
    }
  }, "\u274C"), React.createElement("span", {
    style: {
      fontWeight: 'bold',
      paddingLeft: '.7rem'
    }
  }, "Reject revisions"), ' ', "that need more work."))));
};

var RevisionReviewFooter = function RevisionReviewFooter() {
  return React.createElement(Typography, {
    style: {
      textAlign: 'center'
    }
  }, React.createElement("span", {
    role: "img",
    "aria-label": "Bell",
    style: {
      fontSize: '1rem'
    }
  }, "\uD83D\uDD14"), ' ', React.createElement("span", null, "Revision Review now available on\xA0"), React.createElement("span", null, React.createElement("a", {
    href: "https://apps.apple.com/us/app/mvp-mailhouse/id1365051972?ls=1",
    target: "_blank",
    rel: "noopener noreferrer",
    style: {
      color: '#ED154E'
    }
  }, "iPhone")), React.createElement("span", null, "\xA0and\xA0"), React.createElement("span", null, React.createElement("a", {
    href: "https://play.google.com/store/apps/details?id=com.mvpmailhouse",
    target: "_blank",
    rel: "noopener noreferrer",
    style: {
      color: '#ED154E'
    }
  }, "Android")), React.createElement("span", null, "."));
};

var Default$a = function Default$a() {
  var buttonClasses = useButtonStyles();

  var _useContext83 = useContext(ActionsContext),
      closeModal = _useContext83.closeModal;

  return React.createElement(RevisionReviewWelcomeModalBase, {
    open: true,
    title: "Requests are ready for review!",
    body: React.createElement(RevisionReviewBody, null),
    mainButton: React.createElement(Button$1, {
      className: buttonClasses.mainButton,
      variant: "contained",
      onClick: closeModal
    }, "Start Revision Review"),
    footer: React.createElement(RevisionReviewFooter, null)
  });
};

var Default$b = function Default$b() {
  var _useContext84 = useContext(DesignContext.Base),
      viewedAs = _useContext84.viewedAs;

  if (viewedAs === DesignReviewViewedAs.Default) {
    return React.createElement(InternalReviewer, null);
  }

  return React.createElement(FromDesignConceptSelection, {
    title: "Ready to approve?"
  });
};

var InternalReviewer = function InternalReviewer() {
  var buttonClasses = useButtonStyles();

  var _useContext85 = useContext(ActionsContext),
      closeModal = _useContext85.closeModal;

  var _useContext86 = useContext(CampaignContext.Derived),
      designStatus = _useContext86.designStatus;

  var isPrePressReview = designStatus === CampaignDesignStatus.ReadyForPrePress;
  var isCustomerReview = [CampaignDesignStatus.NeedsFinalApproval, CampaignDesignStatus.ReadyForFinalApproval].includes(designStatus);
  var title = isPrePressReview ? 'Ready for Pre Press Review' : isCustomerReview ? 'Ready for Customer Review' : 'Ready for review!';
  return React.createElement(RevisionReviewWelcomeModalBase, {
    open: true,
    title: title,
    mainButton: React.createElement(Button$1, {
      className: buttonClasses.mainButton,
      variant: "contained",
      onClick: closeModal
    }, "Start Review")
  });
};

var WelcomeModal = function WelcomeModal(_ref73) {
  var open = _ref73.open;

  var _useContext87 = useContext(DesignReviewContext),
      designDetails = _useContext87.designDetails,
      fromDesignConceptSelection = _useContext87.fromDesignConceptSelection;

  var versionNumber = designDetails.versionNumber;

  var _useContext88 = useContext(DesignContext.Base),
      experience = _useContext88.experience;

  var _useContext89 = useContext(DesignContext.Base),
      workflow = _useContext89.workflow,
      previousWorkflow = _useContext89.previousWorkflow;

  var _useContext90 = useContext(DesignContext.Derived),
      currentReview = _useContext90.currentReview;

  var comments = useContext(CommentsStore.Comments); // Designer Concept Review - Designer

  if (workflow === Workflow.Submit && // design review/design concept only
  experience === DesignReviewExperience.DesignConcept) {
    return null;
  } // Number Swap - Reviewer Welcome Modal


  if ( // reviewer only
  workflow !== Workflow.Submit && // campaign review/number swap only
  experience === DesignReviewExperience.CampaignReview) {
    return React.createElement(Default$b, null);
  } // Workflow: Review


  if (workflow === Workflow.Review) {
    if (currentReview === DesignStatus.InitialReview) {
      if (versionNumber === 1) {
        return React.createElement(V1Only, null);
      }

      return React.createElement(Default$7, null);
    }

    if (currentReview === DesignStatus.DesignPeerReview) {
      return React.createElement(Default$5, null);
    }

    if (currentReview === DesignStatus.Proofread) {
      return React.createElement(Default$6, null);
    }

    if (currentReview === DesignStatus.CustomerReview) {
      return React.createElement(Default$8, null);
    }

    if (currentReview === DesignStatus.MarketingReview) {
      return React.createElement(Default$9, null);
    }

    return React.createElement(Default$a, null);
  }

  var _comments$reduce = comments.reduce(function (acc, c) {
    if (c.status === CommentStatus.Rejected) {
      return [acc[0], acc[1] + 1];
    }

    if (c.status === CommentStatus.Pending) {
      return [acc[0] + 1, acc[1]];
    }

    return acc;
  }, [0, 0]),
      _comments$reduce2 = _slicedToArray(_comments$reduce, 2),
      pendingComments = _comments$reduce2[0],
      rejectedComments = _comments$reduce2[1];

  var hasNoPendingComment = pendingComments === 0;

  if (currentReview === DesignStatus.InitialReview) {
    if (hasNoPendingComment && rejectedComments > 0) {
      return React.createElement(FailedReview$3, null);
    }

    if (!hasNoPendingComment) {
      return React.createElement(ResumeReview$3, null);
    }

    return React.createElement(Default$3, null);
  }

  if (currentReview === DesignStatus.DesignPeerReview) {
    if (hasNoPendingComment && rejectedComments > 0) {
      return React.createElement(FailedReview, null);
    }

    if (!hasNoPendingComment) {
      return React.createElement(ResumeReview, null);
    }

    return React.createElement(Default, null);
  }

  if (currentReview === DesignStatus.MarketingReview) {
    if (hasNoPendingComment && rejectedComments > 0) {
      return React.createElement(FailedReview$1, {
        numRejected: rejectedComments
      });
    }

    if (!hasNoPendingComment) {
      return React.createElement(ResumeReview$1, {
        numPending: pendingComments
      });
    }

    return React.createElement(Default$1, null);
  }

  if (currentReview === DesignStatus.Proofread) {
    if (hasNoPendingComment && rejectedComments > 0) {
      return React.createElement(FailedReview$2, null);
    }

    if (!hasNoPendingComment) {
      return React.createElement(ResumeReview$2, null);
    }

    return React.createElement(Default$2, null);
  }

  if (currentReview === DesignStatus.CustomerReview) {
    if (hasNoPendingComment && rejectedComments > 0) {
      return React.createElement(FailedReview$4, {
        numRejected: rejectedComments
      });
    }

    if (!hasNoPendingComment) {
      return React.createElement(ResumeReview$4, null);
    }

    if (hasNoPendingComment && fromDesignConceptSelection) {
      return React.createElement(FromDesignConceptSelection, null);
    }

    if (hasNoPendingComment && previousWorkflow === Workflow.Review) {
      return React.createElement(AcceptedAllRevisions, null);
    }
  }

  return React.createElement(Default$4, null);
};

var UndoRejectedCommentModal = function UndoRejectedCommentModal(_ref74) {
  var open = _ref74.open;

  var _useContext91 = useContext(CommentsStore.DerivedComments),
      commentsById = _useContext91.byId;

  var _useContext92 = useContext(UIStateContext.Scaffold),
      modalStatus = _useContext92.modalStatus;

  var _useContext93 = useContext(ActionsContext),
      closeModal = _useContext93.closeModal,
      commentActionFactory = _useContext93.commentActionFactory;

  var handleUndo =
  /*#__PURE__*/
  function () {
    var _ref75 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee14() {
      var comment, _revertRejectedCommentMarker;

      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              if (!((modalStatus === null || modalStatus === void 0 ? void 0 : modalStatus.type) === ModalTypes.UndoRejectedComment)) {
                _context14.next = 6;
                break;
              }

              comment = commentsById[modalStatus.args.id];
              _revertRejectedCommentMarker = commentActionFactory.revertRejectedCommentMarker(comment);
              _context14.next = 5;
              return _revertRejectedCommentMarker();

            case 5:
              closeModal();

            case 6:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }));

    return function handleUndo() {
      return _ref75.apply(this, arguments);
    };
  }();

  return React.createElement(Dialog$1, {
    open: open,
    onClose: closeModal,
    onBackdropClick: closeModal,
    TransitionComponent: SlideUpTransition,
    style: {
      width: '28rem',
      margin: '0 auto'
    }
  }, React.createElement(DialogTitle$1, {
    style: {
      fontSize: '1.25rem',
      padding: '1rem 2rem',
      marginTop: '.5rem'
    }
  }, "Undo Rejected Comment"), React.createElement(DialogContent$1, {
    style: {
      fontSize: '1.1rem',
      lineHeight: '1',
      padding: '0 2rem',
      marginTop: '-.5rem'
    }
  }, React.createElement(DialogContentText, null, "Your latest comment will be deleted.")), React.createElement(DialogActions$1, {
    style: {
      padding: '1rem 1.5rem',
      marginTop: '-.3rem'
    }
  }, React.createElement(Button$1, {
    className: "el-ignore-click-away",
    onClick: closeModal,
    style: {
      color: 'grey'
    },
    variant: "text",
    color: "secondary"
  }, React.createElement("span", {
    className: "el-ignore-click-away"
  }, "Cancel")), React.createElement(Button$1, {
    onClick: handleUndo,
    style: {
      color: 'primary'
    },
    variant: "text",
    color: "secondary"
  }, "Undo")));
};

var UndoAcceptedCommentModal = function UndoAcceptedCommentModal(_ref76) {
  var open = _ref76.open;

  var _useContext94 = useContext(CommentsStore.DerivedComments),
      commentsById = _useContext94.byId;

  var _useContext95 = useContext(UIStateContext.Scaffold),
      modalStatus = _useContext95.modalStatus;

  var _useContext96 = useContext(ActionsContext),
      closeModal = _useContext96.closeModal,
      commentActionFactory = _useContext96.commentActionFactory;

  var handleUndo =
  /*#__PURE__*/
  function () {
    var _ref77 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee15() {
      var comment, _revertAcceptedCommentMarker;

      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              if (!((modalStatus === null || modalStatus === void 0 ? void 0 : modalStatus.type) === ModalTypes.UndoRejectedComment || (modalStatus === null || modalStatus === void 0 ? void 0 : modalStatus.type) === ModalTypes.UndoAcceptedComment)) {
                _context15.next = 6;
                break;
              }

              comment = commentsById[modalStatus.args.id];
              _revertAcceptedCommentMarker = commentActionFactory.revertAcceptedCommentMarker(comment);
              _context15.next = 5;
              return _revertAcceptedCommentMarker();

            case 5:
              closeModal();

            case 6:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }));

    return function handleUndo() {
      return _ref77.apply(this, arguments);
    };
  }();

  return React.createElement(Dialog$1, {
    open: open,
    onClose: closeModal,
    onBackdropClick: closeModal,
    TransitionComponent: SlideUpTransition,
    style: {
      width: '28rem',
      margin: '0 auto'
    }
  }, React.createElement(DialogTitle$1, {
    style: {
      fontSize: '1.25rem',
      padding: '1rem 2rem',
      marginTop: '.5rem'
    }
  }, "Undo Accepted Revision"), React.createElement(DialogContent$1, {
    style: {
      fontSize: '1.1rem',
      lineHeight: '1',
      padding: '0 2rem',
      marginTop: '-.5rem'
    }
  }, React.createElement(DialogContentText, null, "Are you sure you want to undo and unaccept this revision?")), React.createElement(DialogActions$1, {
    style: {
      padding: '1rem 1.5rem',
      marginTop: '-.3rem'
    }
  }, React.createElement(Button$1, {
    onClick: closeModal,
    style: {
      color: 'grey'
    },
    variant: "text",
    color: "secondary"
  }, "Cancel"), React.createElement(Button$1, {
    onClick: handleUndo,
    style: {
      color: 'primary'
    },
    variant: "text",
    color: "secondary"
  }, "Undo")));
};

var DeleteCommentModal = function DeleteCommentModal(_ref78) {
  var open = _ref78.open;

  var _useContext97 = useContext(ActionsContext),
      closeModal = _useContext97.closeModal,
      setExpandedMarkerIndex = _useContext97.setExpandedMarkerIndex,
      removeCommentMarker = _useContext97.removeCommentMarker;

  var _useContext98 = useContext(UIStateContext.Scaffold),
      modalStatus = _useContext98.modalStatus;

  var handleDiscard = function handleDiscard() {
    if ((modalStatus === null || modalStatus === void 0 ? void 0 : modalStatus.type) === ModalTypes.DeleteComment) {
      removeCommentMarker(modalStatus.args.id);
      setExpandedMarkerIndex(null);
      closeModal();
    }
  };

  return React.createElement(Dialog$1, {
    open: open,
    onClose: closeModal,
    onBackdropClick: closeModal,
    TransitionComponent: SlideUpTransition,
    style: {
      width: '28rem',
      margin: '0 auto'
    }
  }, React.createElement(DialogTitle$1, {
    style: {
      fontSize: '1.25rem',
      padding: '1rem 2rem',
      marginTop: '.5rem'
    }
  }, "Delete Comment"), React.createElement(DialogContent$1, {
    style: {
      fontSize: '1.1rem',
      lineHeight: '1',
      padding: '0 2rem',
      marginTop: '-.5rem'
    }
  }, React.createElement(DialogContentText, null, "Are you sure you want to delete this comment?")), React.createElement(DialogActions$1, {
    style: {
      padding: '1rem 1.5rem',
      marginTop: '-.3rem'
    }
  }, React.createElement(Button$1, {
    onClick: closeModal,
    style: {
      color: 'grey'
    },
    variant: "text",
    color: "secondary"
  }, "Cancel"), React.createElement(Button$1, {
    onClick: handleDiscard,
    style: {
      color: 'primary'
    },
    variant: "text",
    color: "secondary"
  }, "Delete")));
};

var ConfirmAcceptRejectedCommentModal = function ConfirmAcceptRejectedCommentModal(_ref79) {
  var open = _ref79.open;

  var _useContext99 = useContext(CommentsStore.DerivedComments),
      commentsById = _useContext99.byId;

  var _useContext100 = useContext(UIStateContext.Scaffold),
      modalStatus = _useContext100.modalStatus;

  var _useContext101 = useContext(ActionsContext),
      closeModal = _useContext101.closeModal,
      setExpandedMarkerIndex = _useContext101.setExpandedMarkerIndex,
      commentActionFactory = _useContext101.commentActionFactory;

  var handleConfirm = function handleConfirm() {
    if ((modalStatus === null || modalStatus === void 0 ? void 0 : modalStatus.type) === ModalTypes.ConfirmAcceptRejectedComment) {
      var comment = commentsById[modalStatus.args.id];

      var _revertRejectedCommentMarker2 = commentActionFactory.revertRejectedCommentMarker(comment);

      _revertRejectedCommentMarker2(CommentStatus.Accepted);

      setExpandedMarkerIndex(null);
      closeModal();
    }
  };

  return React.createElement(Dialog$1, {
    open: open,
    onClose: closeModal,
    onBackdropClick: closeModal,
    TransitionComponent: SlideUpTransition,
    style: {
      width: '28rem',
      margin: '0 auto'
    }
  }, React.createElement(DialogTitle$1, {
    style: {
      fontSize: '1.25rem',
      padding: '1rem 2rem',
      marginTop: '.5rem'
    }
  }, "Delete Last Comment and Mark Request as Accepted"), React.createElement(DialogContent$1, {
    style: {
      fontSize: '1.1rem',
      lineHeight: '1',
      padding: '0 2rem',
      marginTop: '-.5rem'
    }
  }, React.createElement(DialogContentText, null, React.createElement("span", null, "Deleting this revision request will "), React.createElement("span", {
    style: {
      color: Colors.MVP_LIGHT_PINK
    }
  }, "delete"), React.createElement("span", null, " the last comment, and mark this request as "), React.createElement("span", {
    style: {
      color: Colors.MVP_GREEN
    }
  }, "accepted"), ". Confirm this action?")), React.createElement(DialogActions$1, {
    style: {
      padding: '1rem 1.5rem',
      marginTop: '-.3rem'
    }
  }, React.createElement(Button$1, {
    onClick: closeModal,
    style: {
      color: 'grey'
    },
    variant: "text",
    color: "secondary"
  }, "Cancel"), React.createElement(Button$1, {
    onClick: handleConfirm,
    style: {
      color: 'primary'
    },
    variant: "text",
    color: "secondary"
  }, "Confirm")));
};

var ChecklistModals = function ChecklistModals() {
  var _useContext102 = useContext(UIStateContext.Scaffold),
      modalStatus = _useContext102.modalStatus;

  if (typeof modalStatus === 'undefined') {
    return React.createElement("div", null);
  }

  if (modalStatus.type === ModalTypes.ConfirmSubmission) {
    return React.createElement(ConfirmSubmissionModal, {
      open: true
    });
  }

  if (modalStatus.type === ModalTypes.FinalizeRequests) {
    return React.createElement(FinalizeRequestsModal, {
      open: true
    });
  }

  return React.createElement("div", null);
};

var useStyles$3 = makeStyles(function (theme) {
  return {
    root: {
      minWidth: theme.spacing(75)
    }
  };
});

var Dialog = function Dialog(_ref80) {
  var open = _ref80.open,
      _onClose = _ref80.onClose,
      children = _ref80.children;
  var classes = useStyles$3();
  return React.createElement(Dialog$1, {
    open: open,
    onClose: function onClose(_, reason) {
      if (reason !== 'backdropClick') {
        _onClose();
      }
    },
    TransitionComponent: SlideUpTransition,
    maxWidth: 'md',
    classes: {
      paper: classes.root
    }
  }, children);
};

var PageVariant;

(function (PageVariant) {
  PageVariant["Welcome"] = "welcome";
  PageVariant["Form"] = "form";
  PageVariant["Submit"] = "submit";
})(PageVariant || (PageVariant = {}));

var ChecklistResult;

(function (ChecklistResult) {
  ChecklistResult["Yes"] = "yes";
  ChecklistResult["No"] = "no";
})(ChecklistResult || (ChecklistResult = {}));

var DialogControls = function DialogControls(_ref81) {
  var page = _ref81.page,
      onClose = _ref81.onClose,
      onBack = _ref81.onBack;
  var showBack = page !== PageVariant.Welcome;
  return React.createElement(Box, {
    px: 2,
    pt: 1
  }, showBack && React.createElement(Box, {
    clone: true,
    style: {
      float: 'left'
    }
  }, React.createElement(IconButton, {
    "aria-label": "back",
    onClick: onBack
  }, React.createElement(ChevronLeft, null))), React.createElement(Box, {
    clone: true,
    style: {
      float: 'right'
    }
  }, React.createElement(IconButton, {
    "aria-label": "close",
    onClick: onClose
  }, React.createElement(Close, null))));
};

var DialogTitle = function DialogTitle(_ref82) {
  var page = _ref82.page,
      checklists = _ref82.checklists,
      currentIndex = _ref82.currentIndex;
  var getIconDetails = useCallback(function (index) {
    if (page === PageVariant.Welcome || page === PageVariant.Submit) {
      return {
        icon: img,
        iconAlt: 'Review confirmation icon'
      };
    }

    var item = checklists[index];
    return {
      icon: item.icon,
      iconAlt: item.iconAlt
    };
  }, [checklists, page]);

  var _getIconDetails = getIconDetails(currentIndex),
      icon = _getIconDetails.icon,
      iconAlt = _getIconDetails.iconAlt;

  return React.createElement(Box, {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    clone: true
  }, React.createElement(DialogTitle$1, {
    disableTypography: true
  }, React.createElement("img", {
    src: icon,
    alt: iconAlt,
    height: '150px',
    width: '150px'
  })));
};

var useStyles$4 = makeStyles(function (theme) {
  return {
    root: {
      padding: '0 1.8rem',
      minHeight: 145,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    },
    details: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    },
    title: {
      fontWeight: theme.typography.fontWeightBold,
      marginBottom: theme.spacing(1)
    },
    avatar: {
      fontSize: 12,
      height: 24,
      width: 24,
      lineHeight: 24
    },
    current: {
      backgroundColor: theme.palette.text.secondary
    },
    yes: {
      backgroundColor: theme.palette.info.main
    },
    no: {
      backgroundColor: theme.palette.error.main
    },
    pointer: {
      cursor: 'pointer'
    },
    total: {
      textAlign: 'center',
      margin: '1.2rem 0 0',
      '& *': {
        fontWeight: 'bold !important',
        fontSize: '30px !important'
      }
    },
    totalFail: {
      color: theme.palette.primary.main
    },
    reasonRoot: {
      marginTop: 20
    }
  };
});
var DefaultDescriptions = {
  welcome: 'Perform the pre press review on both the press ready PDF and the full - size thumbnail PNGs that will be uploaded to Digital Ocean',
  allYes: 'Pre Press Review looks good! Click submit to finish the review.'
};
var titles = new Map([[PageVariant.Welcome, 'Pre Press Review'], [PageVariant.Submit, 'Review Summary']]);
var defaultStyle = new Map([[PageVariant.Form, {
  description: {
    color: 'textSecondary'
  }
}]]);

var DialogContent = function DialogContent(_ref83) {
  var page = _ref83.page,
      checklists = _ref83.checklists,
      currentIndex = _ref83.currentIndex,
      failedIndexes = _ref83.failedIndexes,
      doneIndexes = _ref83.doneIndexes,
      setIndex = _ref83.setIndex,
      additionalReason = _ref83.additionalReason,
      handleReasonChange = _ref83.handleReasonChange;

  var _a;

  var classes = useStyles$4();
  var getContent = useCallback(function (page, index) {
    if (page === PageVariant.Welcome) {
      return {
        subtitle: null,
        description: DefaultDescriptions.welcome
      };
    }

    if (page === PageVariant.Form) {
      var item = checklists[index];
      return {
        subtitle: item.title,
        description: item.description
      };
    }

    if (page === PageVariant.Submit) {
      if (failedIndexes.length === 0) {
        return {
          subtitle: null,
          description: DefaultDescriptions.allYes
        };
      }
    }
  }, []);
  var content = getContent(page, currentIndex);
  var title = titles.get(page);
  var overrideProp = defaultStyle.get(page);

  var handleChange = function handleChange(event) {
    handleReasonChange(event.target.value);
  };

  return React.createElement(DialogContent$1, {
    classes: {
      root: classes.root
    }
  }, React.createElement(Box, {
    className: classes.details
  }, !!title && React.createElement(Typography, {
    variant: 'h5',
    color: 'primary',
    align: 'center',
    classes: {
      root: classes.title
    },
    children: title
  }), (content === null || content === void 0 ? void 0 : content.subtitle) && React.createElement(Typography, {
    variant: 'subtitle2',
    align: 'center',
    gutterBottom: true
  }, React.createElement(Box, {
    fontWeight: 700
  }, content === null || content === void 0 ? void 0 : content.subtitle)), (content === null || content === void 0 ? void 0 : content.description) && React.createElement(Typography, {
    variant: 'body2',
    align: 'center',
    color: (_a = overrideProp === null || overrideProp === void 0 ? void 0 : overrideProp.description) === null || _a === void 0 ? void 0 : _a.color
  }, content.description)), page === PageVariant.Form && React.createElement(Box, {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gridGap: 10
  }, checklists.map(function (item, index) {
    var current = currentIndex === index;
    var done = currentIndex !== index && doneIndexes.includes(index);
    var color = done ? failedIndexes.includes(index) ? classes.no : classes.yes : current ? classes.current : undefined;
    return React.createElement(Avatar, {
      key: item.title,
      classes: {
        root: classes.avatar,
        colorDefault: color
      },
      className: cx(_defineProperty({}, classes.pointer, done)),
      children: index + 1,
      onClick: done ? function () {
        return setIndex(index);
      } : undefined
    });
  })), page === PageVariant.Submit && failedIndexes.length !== 0 && React.createElement(Box, {
    display: 'flex',
    flexDirection: 'column',
    className: classes.reasonRoot
  }, React.createElement(Box, {
    ml: 2
  }, React.createElement(Typography, {
    variant: 'body2'
  }, "Please state below your reason for rejection")), React.createElement(TextField, {
    placeholder: 'Additional message (Optional)',
    multiline: true,
    rows: 4,
    variant: "filled",
    inputProps: {
      maxLength: 32000
    },
    style: {
      marginTop: 10
    },
    value: additionalReason,
    onChange: handleChange
  })), page === PageVariant.Submit ? failedIndexes.length === 0 ? React.createElement(Box, {
    color: 'info.main',
    className: cx(classes.total)
  }, React.createElement(Typography, null, checklists.length, "/", checklists.length)) : React.createElement(Box, {
    className: cx(classes.total)
  }, React.createElement(Typography, {
    component: 'span',
    className: cx(classes.totalFail)
  }, failedIndexes.length), React.createElement(Typography, {
    component: 'span'
  }, "/", checklists.length)) : null);
};

var useStyles$5 = makeStyles(function (theme) {
  return {
    root: {
      alignItems: 'stretch',
      flexDirection: 'column',
      padding: '1.2rem 1.8rem',
      gap: 12
    },
    button: {
      height: 44,
      padding: 0,
      margin: '0 !important',
      fontWeight: theme.typography.fontWeightBold
    },
    buttonLabel: {
      textTransform: 'none'
    },
    buttonCenter: {
      display: 'flex',
      gridGap: 8
    },
    margin0: {
      margin: '0 !important'
    },
    blue: {
      backgroundColor: "".concat(theme.palette.info.main, " !important")
    },
    flex: {
      flex: 1
    }
  };
});

var DialogActions = function DialogActions(_ref84) {
  var page = _ref84.page,
      isSubmitting = _ref84.isSubmitting,
      handleNext = _ref84.handleNext,
      handleSubmit = _ref84.handleSubmit;
  var classes = useStyles$5();

  var handleProceed = function handleProceed() {
    return handleNext();
  };

  var handleYes = function handleYes() {
    return handleNext(ChecklistResult.Yes);
  };

  var handleNo = function handleNo() {
    return handleNext(ChecklistResult.No);
  };

  return React.createElement(DialogActions$1, {
    classes: {
      root: classes.root
    }
  }, page === PageVariant.Welcome ? React.createElement(Button, {
    onClick: handleProceed
  }, "Proceed") : null, page === PageVariant.Form ? React.createElement(Box, {
    display: 'flex',
    justifyContent: 'space-evenly',
    gridGap: 10,
    flex: 1,
    className: classes.margin0
  }, React.createElement(Button, {
    classes: {
      root: classes.flex
    },
    onClick: handleNo
  }, "No"), React.createElement(Button, {
    classes: {
      root: cx(classes.blue, classes.flex)
    },
    onClick: handleYes
  }, "Yes")) : null, page === PageVariant.Submit && React.createElement(Button, {
    variant: "outlined",
    onClick: handleSubmit,
    classes: {
      label: classes.buttonCenter
    }
  }, "Submit", isSubmitting && React.createElement(CircularProgress, {
    size: 20
  })));
};

var Button = function Button(props) {
  var children = props.children,
      classes = props.classes;
  var defaultClasses = useStyles$5();
  return React.createElement(Button$1, Object.assign({
    variant: "contained",
    size: "small",
    color: "secondary",
    className: cx(defaultClasses.button)
  }, props, {
    classes: _objectSpread({}, classes, {
      label: cx(defaultClasses.buttonLabel, classes === null || classes === void 0 ? void 0 : classes.label)
    }),
    children: children
  }));
};

var Snackbar = function Snackbar(_ref85) {
  var open = _ref85.open,
      onClose = _ref85.onClose;
  return React.createElement(Snackbar$1, {
    open: open,
    autoHideDuration: 4000,
    onClose: onClose
  }, React.createElement(Alert, {
    onClose: onClose,
    severity: "error"
  }, "Sorry! that didn't work. Try to click submit again"));
};

var img$5 = "data:image/svg+xml,%3csvg width='151' height='151' viewBox='0 0 151 151' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect x='24.881' y='22.6309' width='100.604' height='103.08' rx='50.3021' fill='%23FFDDE6'/%3e %3crect x='33.0105' y='30.9607' width='84.3449' height='86.4208' rx='42.1724' fill='%23ED154E'/%3e %3cpath d='M140.675 94.2283C141.709 94.3392 142.461 95.2895 142.352 96.349C142.244 97.4086 141.317 98.1789 140.283 98.068C139.248 97.9571 138.497 97.0068 138.605 95.9472C138.713 94.8876 139.641 94.1174 140.675 94.2283Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.6171'/%3e %3cpath d='M36.2282 133.33C37.9287 133.512 39.1649 135.075 38.987 136.817C38.809 138.56 37.2838 139.826 35.5833 139.644C33.8827 139.462 32.6465 137.899 32.8245 136.157C33.0025 134.414 34.5277 133.148 36.2282 133.33Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='2.65921'/%3e %3cpath d='M74.1603 3.44661C75.8609 3.62896 77.0971 5.1917 76.9191 6.93409C76.7411 8.67647 75.2159 9.9431 73.5154 9.76075C71.8149 9.5784 70.5787 8.01566 70.7566 6.27328C70.9346 4.53089 72.4598 3.26426 74.1603 3.44661Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='2.65921'/%3e %3cpath d='M2.41535 44.7844C3.19648 44.7844 3.8307 45.4343 3.8307 46.2346C3.8307 47.035 3.19648 47.6848 2.41535 47.6848C1.63422 47.6848 1 47.035 1 46.2346C1 45.4343 1.63422 44.7844 2.41535 44.7844Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.94378'/%3e %3cpath d='M112.344 139.354C113.125 139.354 113.759 140.003 113.759 140.804C113.759 141.604 113.125 142.254 112.344 142.254C111.563 142.254 110.928 141.604 110.928 140.804C110.928 140.003 111.563 139.354 112.344 139.354Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.94378'/%3e %3cpath d='M133.697 38.9111L135.36 33.3452' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M131.902 35.3169L137.334 37.0202' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M8.13123 98.012L9.59753 92.3885' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M6.21118 94.4863L11.6996 95.9887' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M126.217 123.195L127.382 117.498' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M124.112 119.782L129.672 120.975' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M26.9353 30.801H53.2427C54.9656 30.801 56.557 31.7213 57.4168 33.2143L61.7466 39.1293C62.6063 40.6222 64.198 41.5426 65.9207 41.5426H130V109.074C130 112.621 127.124 115.496 123.578 115.496H26.422C22.8754 115.496 20 112.621 20 109.074V49.0339C20 44.0698 20.7669 39.1354 22.2738 34.4055C22.8258 32.2827 24.7421 30.801 26.9353 30.801Z' fill='%23D84D71'/%3e %3cpath d='M114.563 40.4377H30.0101V76.1555H114.563V40.4377Z' fill='%23FBFBFB'/%3e %3cpath d='M125.183 34.012H98.6729C96.7876 34.012 95.0755 35.112 94.2921 36.8267L89.7556 46.7551C88.9719 48.4698 87.26 49.5698 85.3748 49.5698H20V110.679C20 114.226 22.8754 117.101 26.422 117.101H123.578C127.125 117.101 130 114.226 130 110.679V38.8285C130 36.1685 127.843 34.012 125.183 34.012Z' fill='%23FF3B70'/%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M82.5373 62.6597C82.5017 62.5975 82.4354 62.5591 82.3637 62.5591H67.6364C67.5646 62.5591 67.4984 62.5975 67.4628 62.6597L51.2992 90.9037C51.2641 90.9651 51.264 91.0405 51.299 91.102L58.7222 104.135C58.7222 104.135 58.7222 104.135 58.7222 104.135C58.7222 104.135 58.7222 104.135 58.7222 104.135H91.1616C91.2335 104.135 91.2999 104.096 91.3354 104.034L98.5873 91.3018C98.6632 91.1684 98.5669 91.0028 98.4135 91.0028H66.6414C66.4875 91.0028 66.3913 90.8362 66.4682 90.7029L74.9472 75.9999C75.0241 75.8665 75.2165 75.8664 75.2936 75.9997L83.9127 90.9029C83.9485 90.9647 84.0145 91.0028 84.0858 91.0028H98.4127C98.5663 91.0028 98.6625 90.8368 98.5862 90.7034L82.5373 62.6597Z' fill='white'/%3e %3cpath d='M98.5862 90.7034L95.1146 92.6902L98.5862 90.7034ZM83.9127 90.9029L87.3753 88.9003L83.9127 90.9029ZM74.9472 75.9999L71.4821 74.0016L74.9472 75.9999ZM75.2936 75.9997L78.7562 73.9971L75.2936 75.9997ZM66.4682 90.7029L63.0031 88.7046L66.4682 90.7029ZM98.5873 91.3018L95.1115 89.3221L98.5873 91.3018ZM91.3354 104.034L94.8112 106.013L91.3354 104.034ZM58.7222 104.135L55.2464 106.114L58.7222 104.135ZM51.2992 90.9037L47.8275 88.9169L51.2992 90.9037ZM51.299 91.102L54.7748 89.1223L51.299 91.102ZM82.5373 62.6597L79.0656 64.6465L82.5373 62.6597ZM67.4628 62.6597L70.9345 64.6465L67.4628 62.6597ZM67.6364 66.5591H82.3637V58.5591H67.6364V66.5591ZM54.7709 92.8905L70.9345 64.6465L63.9911 60.6729L47.8275 88.9169L54.7709 92.8905ZM62.1979 102.155L54.7748 89.1223L47.8233 93.0817L55.2464 106.114L62.1979 102.155ZM58.7222 108.135H91.1616V100.135H58.7222V108.135ZM94.8112 106.013L102.063 93.2815L95.1115 89.3221L87.8597 102.054L94.8112 106.013ZM98.4135 87.0028H66.6414V95.0028H98.4135V87.0028ZM71.4821 74.0016L63.0031 88.7046L69.9333 92.7012L78.4123 77.9982L71.4821 74.0016ZM87.3753 88.9003L78.7562 73.9971L71.831 78.0022L80.4501 92.9055L87.3753 88.9003ZM98.4127 87.0028H84.0858V95.0028H98.4127V87.0028ZM79.0656 64.6465L95.1146 92.6902L102.058 88.7166L86.009 60.6729L79.0656 64.6465ZM98.4127 95.0028C101.639 95.0028 103.66 91.5166 102.058 88.7166L95.1146 92.6902C93.6648 90.1569 95.4939 87.0028 98.4127 87.0028V95.0028ZM80.4501 92.9055C81.2008 94.2034 82.5864 95.0028 84.0858 95.0028V87.0028C85.4425 87.0028 86.6962 87.726 87.3753 88.9003L80.4501 92.9055ZM78.4123 77.9982C76.9512 80.5318 73.2953 80.5342 71.831 78.0022L78.7562 73.9971C77.1378 71.1986 73.097 71.2012 71.4821 74.0016L78.4123 77.9982ZM66.6414 87.0028C69.5658 87.0028 71.3942 90.1678 69.9333 92.7012L63.0031 88.7046C61.3883 91.5046 63.4092 95.0028 66.6414 95.0028V87.0028ZM102.063 93.2815C103.658 90.4816 101.636 87.0028 98.4135 87.0028V95.0028C95.4981 95.0028 93.6686 91.8553 95.1115 89.3221L102.063 93.2815ZM91.1616 108.135C92.6709 108.135 94.0642 107.325 94.8112 106.013L87.8597 102.054C88.5356 100.867 89.7961 100.135 91.1616 100.135V108.135ZM55.1963 102.246C53.7688 104.911 55.6992 108.135 58.7222 108.135V100.135C61.7451 100.135 63.6756 103.359 62.2481 106.024L55.1963 102.246ZM55.2464 106.114C54.5657 104.919 54.5468 103.458 55.1963 102.246L62.2481 106.024C62.8976 104.811 62.8786 103.35 62.1979 102.155L55.2464 106.114ZM47.8275 88.9169C47.0894 90.2066 47.0878 91.7904 47.8233 93.0817L54.7748 89.1223C55.4402 90.2906 55.4388 91.7235 54.7709 92.8905L47.8275 88.9169ZM82.3637 66.5591C81.0009 66.5591 79.7425 65.8293 79.0656 64.6465L86.009 60.6729C85.2609 59.3657 83.87 58.5591 82.3637 58.5591V66.5591ZM67.6364 58.5591C66.1302 58.5591 64.7392 59.3656 63.9911 60.6729L70.9345 64.6465C70.2576 65.8293 68.9991 66.5591 67.6364 66.5591V58.5591Z' fill='white'/%3e %3ccircle cx='75.4941' cy='85.7204' r='12.2146' fill='white'/%3e %3cpath d='M75.1288 75.6854L67.5204 62.5593L51.2426 91.003L58.7222 104.135L75.1288 75.6854Z' fill='%234CAF50'/%3e %3cpath d='M67.5204 62.5593L83.9705 91.003H98.7576L82.4797 62.5593H67.5204Z' fill='%23FFC107'/%3e %3cpath d='M66.2949 91.0029L58.7222 104.135H91.2779L98.7575 91.0029H66.2949Z' fill='%232196F3'/%3e %3c/svg%3e";
var img$6 = "data:image/svg+xml,%3csvg width='151' height='151' viewBox='0 0 151 151' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect x='24.8809' y='22.6309' width='100.604' height='103.08' rx='50.3021' fill='%23FFDDE6'/%3e %3crect x='33.0105' y='30.9607' width='84.3449' height='86.4208' rx='42.1724' fill='%23ED154E'/%3e %3cpath d='M140.675 94.2283C141.709 94.3392 142.461 95.2895 142.352 96.349C142.244 97.4086 141.317 98.1789 140.283 98.068C139.248 97.9571 138.497 97.0068 138.605 95.9472C138.713 94.8876 139.641 94.1174 140.675 94.2283Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.6171'/%3e %3cpath d='M36.2282 133.33C37.9287 133.512 39.1649 135.075 38.987 136.817C38.809 138.56 37.2838 139.826 35.5833 139.644C33.8827 139.462 32.6465 137.899 32.8245 136.157C33.0025 134.414 34.5277 133.148 36.2282 133.33Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='2.65921'/%3e %3cpath d='M74.1603 3.44661C75.8609 3.62896 77.0971 5.1917 76.9191 6.93409C76.7411 8.67647 75.2159 9.9431 73.5154 9.76075C71.8149 9.5784 70.5787 8.01566 70.7566 6.27328C70.9346 4.53089 72.4598 3.26426 74.1603 3.44661Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='2.65921'/%3e %3cpath d='M2.41535 44.7844C3.19648 44.7844 3.8307 45.4343 3.8307 46.2346C3.8307 47.035 3.19648 47.6848 2.41535 47.6848C1.63422 47.6848 1 47.035 1 46.2346C1 45.4343 1.63422 44.7844 2.41535 44.7844Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.94378'/%3e %3cpath d='M112.344 139.354C113.125 139.354 113.759 140.003 113.759 140.804C113.759 141.604 113.125 142.254 112.344 142.254C111.563 142.254 110.928 141.604 110.928 140.804C110.928 140.003 111.563 139.354 112.344 139.354Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.94378'/%3e %3cpath d='M133.697 38.9111L135.36 33.3452' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M131.902 35.3169L137.334 37.0202' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M8.13135 98.012L9.59765 92.3885' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M6.21118 94.4863L11.6996 95.9887' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M126.217 123.195L127.382 117.498' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M124.112 119.782L129.672 120.975' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cg clip-path='url(%23clip0)'%3e %3cpath d='M46 24.5C42.5625 24.5 39.75 27.3125 39.75 30.75V118.25C39.75 121.688 42.5625 124.5 46 124.5H108.5C111.938 124.5 114.75 121.688 114.75 118.25V49.5L89.75 24.5H46Z' fill='%23FF3B70'/%3e %3cpath d='M96 49.5H114.75L89.75 24.5V43.25C89.75 46.6875 92.5625 49.5 96 49.5Z' fill='%23D84D71'/%3e %3cg style='mix-blend-mode:multiply'%3e %3cpath d='M114.75 68.25L96 49.5H114.75V68.25Z' fill='%23FFBECF'/%3e %3c/g%3e %3cpath d='M102.25 105.75C102.25 107.469 100.844 108.875 99.125 108.875H30.375C28.6562 108.875 27.25 107.469 27.25 105.75V74.5C27.25 72.7812 28.6562 71.375 30.375 71.375H99.125C100.844 71.375 102.25 72.7812 102.25 74.5V105.75Z' fill='%23FFF3F3'/%3e %3cpath d='M40.8721 83.7094C40.8721 82.8844 41.5221 81.9844 42.5689 81.9844H48.3408C51.5908 81.9844 54.5158 84.1594 54.5158 88.3281C54.5158 92.2781 51.5908 94.4781 48.3408 94.4781H44.1689V97.7781C44.1689 98.8781 43.4689 99.5 42.5689 99.5C41.7439 99.5 40.8721 98.8781 40.8721 97.7781V83.7094ZM44.1689 85.1313V91.3562H48.3408C50.0158 91.3562 51.3408 89.8781 51.3408 88.3281C51.3408 86.5812 50.0158 85.1313 48.3408 85.1313H44.1689Z' fill='%23ED154E'/%3e %3cpath d='M59.4096 99.4999C58.5846 99.4999 57.6846 99.0499 57.6846 97.953V83.7592C57.6846 82.8624 58.5846 82.2092 59.4096 82.2092H65.1314C76.5502 82.2092 76.3002 99.4999 65.3564 99.4999H59.4096ZM60.9846 85.2592V96.453H65.1314C71.8783 96.453 72.1783 85.2592 65.1314 85.2592H60.9846Z' fill='%23ED154E'/%3e %3cpath d='M80.3501 85.4594V89.4313H86.7219C87.6219 89.4313 88.5219 90.3313 88.5219 91.2032C88.5219 92.0282 87.6219 92.7032 86.7219 92.7032H80.3501V97.95C80.3501 98.825 79.7282 99.4969 78.8532 99.4969C77.7532 99.4969 77.0813 98.825 77.0813 97.95V83.7563C77.0813 82.8594 77.7563 82.2063 78.8532 82.2063H87.625C88.725 82.2063 89.375 82.8594 89.375 83.7563C89.375 84.5563 88.725 85.4563 87.625 85.4563H80.3501V85.4594Z' fill='%23ED154E'/%3e %3cg style='mix-blend-mode:multiply'%3e %3cpath d='M99.125 108.875H39.75V112H99.125C100.844 112 102.25 110.594 102.25 108.875V105.75C102.25 107.469 100.844 108.875 99.125 108.875Z' fill='%23FFBECF'/%3e %3c/g%3e %3c/g%3e %3cdefs%3e %3cclipPath id='clip0'%3e %3crect width='100' height='100' fill='white' transform='translate(21 24.5)'/%3e %3c/clipPath%3e %3c/defs%3e %3c/svg%3e";
var img$7 = "data:image/svg+xml,%3csvg width='151' height='151' viewBox='0 0 151 151' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect x='24.8809' y='22.6309' width='100.604' height='103.08' rx='50.3021' fill='%23FFDDE6'/%3e %3crect x='33.0105' y='30.9607' width='84.3449' height='86.4208' rx='42.1724' fill='%23ED154E'/%3e %3cpath d='M140.675 94.2283C141.709 94.3392 142.461 95.2895 142.352 96.349C142.244 97.4086 141.317 98.1789 140.283 98.068C139.248 97.9571 138.497 97.0068 138.605 95.9472C138.713 94.8876 139.641 94.1174 140.675 94.2283Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.6171'/%3e %3cpath d='M36.2282 133.33C37.9287 133.512 39.1649 135.075 38.987 136.817C38.809 138.56 37.2838 139.826 35.5833 139.644C33.8827 139.462 32.6465 137.899 32.8245 136.157C33.0025 134.414 34.5277 133.148 36.2282 133.33Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='2.65921'/%3e %3cpath d='M74.1603 3.44661C75.8609 3.62896 77.0971 5.1917 76.9191 6.93409C76.7411 8.67647 75.2159 9.9431 73.5154 9.76075C71.8149 9.5784 70.5787 8.01566 70.7566 6.27328C70.9346 4.53089 72.4598 3.26426 74.1603 3.44661Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='2.65921'/%3e %3cpath d='M2.41535 44.7844C3.19648 44.7844 3.8307 45.4343 3.8307 46.2346C3.8307 47.035 3.19648 47.6848 2.41535 47.6848C1.63422 47.6848 1 47.035 1 46.2346C1 45.4343 1.63422 44.7844 2.41535 44.7844Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.94378'/%3e %3cpath d='M112.344 139.354C113.125 139.354 113.759 140.003 113.759 140.804C113.759 141.604 113.125 142.254 112.344 142.254C111.563 142.254 110.928 141.604 110.928 140.804C110.928 140.003 111.563 139.354 112.344 139.354Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.94378'/%3e %3cpath d='M133.697 38.9111L135.36 33.3452' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M131.902 35.3169L137.334 37.0202' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M8.13135 98.012L9.59765 92.3885' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M6.21118 94.4863L11.6996 95.9887' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M126.217 123.195L127.382 117.498' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M124.112 119.782L129.672 120.975' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M46.0449 128.465C43.2835 128.465 41.0449 126.227 41.0449 123.465L41.0449 24.7151C41.0449 21.9537 43.2835 19.7151 46.0449 19.7151L103.545 19.7151C106.306 19.7151 108.545 21.9537 108.545 24.7151L108.545 123.465C108.545 126.227 106.306 128.465 103.545 128.465L46.0449 128.465Z' fill='%23D52B57'/%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M106.85 127.267L41.7646 22.2252C42.6277 20.7251 44.2467 19.7151 46.1016 19.7151L103.602 19.7151C106.363 19.7151 108.602 21.9537 108.602 24.7151V123.465C108.602 124.987 107.922 126.35 106.85 127.267Z' fill='%23E43F6B'/%3e %3cpath d='M41.0449 87.6838L41.0449 83.9338L46.6699 83.9338L46.6699 87.6838L41.0449 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M102.92 87.6838L102.92 83.9338L108.545 83.9338L108.545 87.6838L102.92 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M50.4199 87.6838L50.4199 83.9338L54.1699 83.9338L54.1699 87.6838L50.4199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M57.9199 87.6838L57.9199 83.9338L61.6699 83.9338L61.6699 87.6838L57.9199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M65.4199 87.6838L65.4199 83.9338L69.1699 83.9338L69.1699 87.6838L65.4199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M72.9199 87.6838L72.9199 83.9338L76.6699 83.9338L76.6699 87.6838L72.9199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M80.4199 87.6838L80.4199 83.9338L84.1699 83.9338L84.1699 87.6838L80.4199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M87.9199 87.6838L87.9199 83.9338L91.6699 83.9338L91.6699 87.6838L87.9199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M95.4199 87.6838L95.4199 83.9338L99.1699 83.9338L99.1699 87.6838L95.4199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M48.5452 70.3401L48.5452 32.8401L101.044 32.8401L101.044 70.3401L48.5452 70.3401Z' fill='white'/%3e %3cpath d='M101.046 61.282L88.8354 41.8775C88.5541 41.4086 88.1561 41.0205 87.6803 40.7511C87.2045 40.4817 86.667 40.3401 86.1201 40.3401C85.5321 40.3401 84.9556 40.5038 84.4554 40.813C83.9552 41.1222 83.5509 41.5646 83.2879 42.0906L69.1636 70.3401L101.046 70.3401L101.046 61.282Z' fill='%239CC221'/%3e %3cpath d='M101.045 44.0901L96.197 44.0901C95.3563 44.0901 94.5239 44.2557 93.7472 44.5774C92.9706 44.8991 92.2649 45.3706 91.6705 45.9651C91.076 46.5595 90.3703 47.0311 89.5937 47.3528C88.817 47.6745 87.9846 47.8401 87.1439 47.8401L86.0456 47.8401C85.0511 47.8401 84.0973 48.2352 83.3941 48.9384C82.6908 49.6417 82.2957 50.5955 82.2957 51.5901C82.2957 52.5847 82.6908 53.5385 83.3941 54.2417C84.0973 54.945 85.0511 55.3401 86.0456 55.3401L101.045 55.3401L101.045 44.0901Z' fill='%23CDF4F7'/%3e %3cpath d='M48.5455 32.8401H53.3937C54.2344 32.8401 55.0668 33.0057 55.8434 33.3274C56.6201 33.6491 57.3258 34.1206 57.9202 34.7151C58.5146 35.3095 59.2203 35.7811 59.997 36.1028C60.7736 36.4245 61.6061 36.5901 62.4467 36.5901H63.545C64.5396 36.5901 65.4934 36.9852 66.1966 37.6884C66.8998 38.3917 67.2949 39.3455 67.2949 40.3401C67.2949 41.3347 66.8998 42.2885 66.1966 42.9917C65.4934 43.695 64.5396 44.0901 63.545 44.0901H48.5455V32.8401Z' fill='%23CDF4F7'/%3e %3cpath d='M84.163 70.3401L71.976 47.7065C71.6926 47.1801 71.2719 46.7402 70.7586 46.4336C70.2452 46.127 69.6585 45.9651 69.0606 45.9651C68.5155 45.9651 67.9788 46.0997 67.4982 46.3569C67.0176 46.6141 66.6079 46.986 66.3055 47.4396L48.6199 70.3401L56.0388 70.3401L84.163 70.3401Z' fill='%23ACCD2A'/%3e %3cpath d='M56.1089 94.8962H63.5983V99.8892H56.1089V94.8962Z' fill='%23FFDDE6'/%3e %3cpath d='M68.5913 94.8962H83.57V99.8892H68.5913V94.8962Z' fill='%23FFDDE6'/%3e %3cpath d='M88.5627 94.8962H101.045V99.8892H88.5627V94.8962Z' fill='%23FFDDE6'/%3e %3cpath d='M48.6194 104.882H71.0875V109.875H48.6194V104.882Z' fill='%23FFDDE6'/%3e %3cpath d='M76.0806 104.882H91.0593V109.875H76.0806V104.882Z' fill='%23FFDDE6'/%3e %3cpath d='M96.0522 104.882H101.045V109.875H96.0522V104.882Z' fill='%23FFDDE6'/%3e %3cpath d='M48.6194 114.868H56.1088V119.861H48.6194V114.868Z' fill='%23FFDDE6'/%3e %3cpath d='M61.1016 114.868H81.0732V119.861H61.1016V114.868Z' fill='%23FFDDE6'/%3e %3cpath d='M86.0664 114.868H101.045V119.861H86.0664V114.868Z' fill='%23FFDDE6'/%3e %3cpath d='M59.6586 117.975C60.9195 116.718 62.9596 116.72 64.2191 117.977L80.1308 133.863C81.3863 135.116 81.3876 137.15 80.1341 138.407L80.1288 138.412C78.8679 139.668 76.8278 139.667 75.5676 138.409L59.6559 122.524C58.4004 121.27 58.3991 119.236 59.6526 117.981L59.6586 117.975Z' fill='%23DF2153'/%3e %3cpath d='M63.053 121.26C72.8782 112.257 73.5591 97.0102 64.5744 87.2052C55.5893 77.3997 40.3416 76.7495 30.5163 85.7527C20.6911 94.7559 20.0088 110.003 28.9939 119.809C37.9786 129.614 53.2278 130.263 63.053 121.26Z' fill='white'/%3e %3cpath d='M63.053 121.26C72.8782 112.257 73.5591 97.0102 64.5744 87.2052C55.5893 77.3997 40.3416 76.7495 30.5163 85.7527C20.6911 94.7559 20.0088 110.003 28.9939 119.809C37.9786 129.614 53.2278 130.263 63.053 121.26Z' stroke='%23FF3C70' stroke-width='4' stroke-miterlimit='10'/%3e %3cpath d='M33.6416 114.493V111.889L35.9482 111.443V95.8913L33.6416 95.4448V92.8257H42.6003V95.4448L40.2937 95.8913V111.443L42.6003 111.889V114.493H33.6416Z' fill='%23D42B57'/%3e %3cpath d='M44.267 114.493V111.889L46.6034 111.398V95.9508L44.267 95.4448V92.8257H53.7764C55.711 92.8257 57.4174 93.2821 58.8956 94.1948C60.3738 95.0976 61.5247 96.3526 62.3481 97.9598C63.1815 99.5571 63.5982 101.393 63.5982 103.466V103.868C63.5982 105.921 63.1864 107.752 62.363 109.359C61.5495 110.956 60.4086 112.211 58.9403 113.124C57.4719 114.037 55.7705 114.493 53.8359 114.493H44.267ZM50.9489 111.175H53.6127C54.8131 111.175 55.83 110.862 56.6634 110.237C57.5067 109.602 58.1466 108.734 58.5831 107.633C59.0196 106.532 59.2379 105.277 59.2379 103.868V103.451C59.2379 102.022 59.0196 100.763 58.5831 99.6712C58.1466 98.57 57.5067 97.7118 56.6634 97.0967C55.83 96.4717 54.8131 96.1592 53.6127 96.1592H50.9489V111.175Z' fill='%23D42B57'/%3e %3c/svg%3e";
var img$8 = "data:image/svg+xml,%3csvg width='151' height='151' viewBox='0 0 151 151' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect x='24.8809' y='22.6309' width='100.604' height='103.08' rx='50.3021' fill='%23FFDDE6'/%3e %3crect x='33.0105' y='30.9607' width='84.3449' height='86.4208' rx='42.1724' fill='%23ED154E'/%3e %3cpath d='M140.675 94.2283C141.709 94.3392 142.461 95.2895 142.352 96.349C142.244 97.4086 141.317 98.1789 140.283 98.068C139.248 97.9571 138.497 97.0068 138.605 95.9472C138.713 94.8876 139.641 94.1174 140.675 94.2283Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.6171'/%3e %3cpath d='M36.2282 133.33C37.9287 133.512 39.1649 135.075 38.987 136.817C38.809 138.56 37.2838 139.826 35.5833 139.644C33.8827 139.462 32.6465 137.899 32.8245 136.157C33.0025 134.414 34.5277 133.148 36.2282 133.33Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='2.65921'/%3e %3cpath d='M74.1603 3.44661C75.8609 3.62896 77.0971 5.1917 76.9191 6.93409C76.7411 8.67647 75.2159 9.9431 73.5154 9.76075C71.8149 9.5784 70.5787 8.01566 70.7566 6.27328C70.9346 4.53089 72.4598 3.26426 74.1603 3.44661Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='2.65921'/%3e %3cpath d='M2.41535 44.7844C3.19648 44.7844 3.8307 45.4343 3.8307 46.2346C3.8307 47.035 3.19648 47.6848 2.41535 47.6848C1.63422 47.6848 1 47.035 1 46.2346C1 45.4343 1.63422 44.7844 2.41535 44.7844Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.94378'/%3e %3cpath d='M112.344 139.354C113.125 139.354 113.759 140.003 113.759 140.804C113.759 141.604 113.125 142.254 112.344 142.254C111.563 142.254 110.928 141.604 110.928 140.804C110.928 140.003 111.563 139.354 112.344 139.354Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.94378'/%3e %3cpath d='M133.697 38.9111L135.36 33.3452' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M131.902 35.3169L137.334 37.0202' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M8.13135 98.012L9.59765 92.3885' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M6.21118 94.4863L11.6996 95.9887' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M126.217 123.195L127.382 117.498' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M124.112 119.782L129.672 120.975' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M46.0449 128.465C43.2835 128.465 41.0449 126.227 41.0449 123.465L41.0449 24.7151C41.0449 21.9537 43.2835 19.7151 46.0449 19.7151L103.545 19.7151C106.306 19.7151 108.545 21.9537 108.545 24.7151L108.545 123.465C108.545 126.227 106.306 128.465 103.545 128.465L46.0449 128.465Z' fill='%23D52B57'/%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M106.85 127.267L41.7646 22.2252C42.6277 20.7251 44.2467 19.7151 46.1016 19.7151L103.602 19.7151C106.363 19.7151 108.602 21.9537 108.602 24.7151V123.465C108.602 124.987 107.922 126.35 106.85 127.267Z' fill='%23E43F6B'/%3e %3cpath d='M41.0449 87.6838L41.0449 83.9338L46.6699 83.9338L46.6699 87.6838L41.0449 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M102.92 87.6838L102.92 83.9338L108.545 83.9338L108.545 87.6838L102.92 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M50.4199 87.6838L50.4199 83.9338L54.1699 83.9338L54.1699 87.6838L50.4199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M57.9199 87.6838L57.9199 83.9338L61.6699 83.9338L61.6699 87.6838L57.9199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M65.4199 87.6838L65.4199 83.9338L69.1699 83.9338L69.1699 87.6838L65.4199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M72.9199 87.6838L72.9199 83.9338L76.6699 83.9338L76.6699 87.6838L72.9199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M80.4199 87.6838L80.4199 83.9338L84.1699 83.9338L84.1699 87.6838L80.4199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M87.9199 87.6838L87.9199 83.9338L91.6699 83.9338L91.6699 87.6838L87.9199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M95.4199 87.6838L95.4199 83.9338L99.1699 83.9338L99.1699 87.6838L95.4199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M48.5452 70.3401L48.5452 32.8401L101.044 32.8401L101.044 70.3401L48.5452 70.3401Z' fill='white'/%3e %3cpath d='M101.046 61.282L88.8354 41.8775C88.5541 41.4086 88.1561 41.0205 87.6803 40.7511C87.2045 40.4817 86.667 40.3401 86.1201 40.3401C85.5321 40.3401 84.9556 40.5038 84.4554 40.813C83.9552 41.1222 83.5509 41.5646 83.2879 42.0906L69.1636 70.3401L101.046 70.3401L101.046 61.282Z' fill='%239CC221'/%3e %3cpath d='M101.045 44.0901L96.197 44.0901C95.3563 44.0901 94.5239 44.2557 93.7472 44.5774C92.9706 44.8991 92.2649 45.3706 91.6705 45.9651C91.076 46.5595 90.3703 47.0311 89.5937 47.3528C88.817 47.6745 87.9846 47.8401 87.1439 47.8401L86.0456 47.8401C85.0511 47.8401 84.0973 48.2352 83.3941 48.9384C82.6908 49.6417 82.2957 50.5955 82.2957 51.5901C82.2957 52.5847 82.6908 53.5385 83.3941 54.2417C84.0973 54.945 85.0511 55.3401 86.0456 55.3401L101.045 55.3401L101.045 44.0901Z' fill='%23CDF4F7'/%3e %3cpath d='M48.5455 32.8401H53.3937C54.2344 32.8401 55.0668 33.0057 55.8434 33.3274C56.6201 33.6491 57.3258 34.1206 57.9202 34.7151C58.5146 35.3095 59.2203 35.7811 59.997 36.1028C60.7736 36.4245 61.6061 36.5901 62.4467 36.5901H63.545C64.5396 36.5901 65.4934 36.9852 66.1966 37.6884C66.8998 38.3917 67.2949 39.3455 67.2949 40.3401C67.2949 41.3347 66.8998 42.2885 66.1966 42.9917C65.4934 43.695 64.5396 44.0901 63.545 44.0901H48.5455V32.8401Z' fill='%23CDF4F7'/%3e %3cpath d='M84.163 70.3401L71.976 47.7065C71.6926 47.1801 71.2719 46.7402 70.7586 46.4336C70.2452 46.127 69.6585 45.9651 69.0606 45.9651C68.5155 45.9651 67.9788 46.0997 67.4982 46.3569C67.0176 46.6141 66.6079 46.986 66.3055 47.4396L48.6199 70.3401L56.0388 70.3401L84.163 70.3401Z' fill='%23ACCD2A'/%3e %3cpath d='M56.1089 94.8962H63.5983V99.8892H56.1089V94.8962Z' fill='%23FFDDE6'/%3e %3cpath d='M68.5913 94.8962H83.57V99.8892H68.5913V94.8962Z' fill='%23FFDDE6'/%3e %3cpath d='M88.5627 94.8962H101.045V99.8892H88.5627V94.8962Z' fill='%23FFDDE6'/%3e %3cpath d='M48.6194 104.882H71.0875V109.875H48.6194V104.882Z' fill='%23FFDDE6'/%3e %3cpath d='M76.0806 104.882H91.0593V109.875H76.0806V104.882Z' fill='%23FFDDE6'/%3e %3cpath d='M96.0522 104.882H101.045V109.875H96.0522V104.882Z' fill='%23FFDDE6'/%3e %3cpath d='M48.6194 114.868H56.1088V119.861H48.6194V114.868Z' fill='%23FFDDE6'/%3e %3cpath d='M61.1016 114.868H81.0732V119.861H61.1016V114.868Z' fill='%23FFDDE6'/%3e %3cpath d='M86.0664 114.868H101.045V119.861H86.0664V114.868Z' fill='%23FFDDE6'/%3e %3cpath d='M111.308 117.975C112.569 116.718 114.609 116.72 115.869 117.977L131.78 133.863C133.036 135.116 133.037 137.15 131.784 138.407L131.778 138.412C130.517 139.668 128.477 139.667 127.217 138.409L111.305 122.524C110.05 121.27 110.048 119.236 111.302 117.981L111.308 117.975Z' fill='%23DF2153'/%3e %3cpath d='M114.702 121.26C124.528 112.257 125.208 97.0102 116.224 87.2052C107.239 77.3997 91.991 76.7495 82.1658 85.7527C72.3405 94.7559 71.6582 110.003 80.6433 119.809C89.628 129.614 104.877 130.263 114.702 121.26Z' fill='white'/%3e %3cpath d='M114.702 121.26C124.528 112.257 125.208 97.0102 116.224 87.2052C107.239 77.3997 91.991 76.7495 82.1658 85.7527C72.3405 94.7559 71.6582 110.003 80.6433 119.809C89.628 129.614 104.877 130.263 114.702 121.26Z' stroke='%23FF3C70' stroke-width='4' stroke-miterlimit='10'/%3e %3cg clip-path='url(%23clip0)'%3e %3cpath d='M113.87 103.507V103.957C113.77 107.857 112.195 111.557 109.495 114.357C109.295 114.557 109.095 114.782 108.87 114.957C102.92 120.457 93.7449 120.457 87.7699 114.957C87.5449 114.757 87.3449 114.557 87.1449 114.357C84.4199 111.557 82.8449 107.832 82.7449 103.957C82.7449 103.807 82.7449 103.657 82.7449 103.507C82.7449 103.357 82.7449 103.207 82.7449 103.057C82.8449 99.157 84.4199 95.457 87.1199 92.657C87.3199 92.457 87.5199 92.232 87.7449 92.032C93.6949 86.532 102.87 86.532 108.845 92.032C109.07 92.232 109.27 92.432 109.47 92.657C112.195 95.457 113.745 99.157 113.845 103.057C113.845 103.207 113.87 103.357 113.87 103.507Z' fill='%23EF557D'/%3e %3cpath d='M113.87 103.507V103.957C113.77 107.857 112.195 111.557 109.495 114.357C109.295 114.557 109.095 114.782 108.87 114.957C102.92 120.457 93.7449 120.457 87.7699 114.957C87.5449 114.757 87.3449 114.557 87.1449 114.357C84.4199 111.557 82.8449 107.832 82.7449 103.957C82.7449 103.807 82.7449 103.657 82.7449 103.507C82.7449 103.357 82.7449 103.207 82.7449 103.057C82.8449 99.157 84.4199 95.457 87.1199 92.657C87.3199 92.457 87.5199 92.232 87.7449 92.032C93.6949 86.532 102.87 86.532 108.845 92.032C109.07 92.232 109.27 92.432 109.47 92.657C112.195 95.457 113.745 99.157 113.845 103.057C113.845 103.207 113.87 103.357 113.87 103.507Z' fill='%23EF557D'/%3e %3cpath d='M113.87 103.508V103.958C113.77 107.858 112.195 111.558 109.495 114.358C109.295 114.558 109.095 114.783 108.87 114.958C106.545 117.108 103.595 118.508 100.47 118.933C99.0449 119.133 97.6199 119.133 96.1949 118.933C93.0449 118.508 90.1199 117.108 87.7949 114.958C87.5699 114.758 87.3699 114.558 87.1699 114.358C84.4199 111.558 82.8449 107.833 82.7449 103.958C82.7449 103.808 82.7449 103.658 82.7449 103.508C82.7449 103.358 82.7449 103.208 82.7449 103.058C82.8449 99.1583 84.4199 95.4583 87.1199 92.6583C87.3199 92.4583 87.5199 92.2333 87.7449 92.0333C90.0699 89.9083 93.0199 88.5333 96.1699 88.0833C97.5949 87.8833 99.0199 87.8833 100.445 88.0833C103.595 88.5083 106.52 89.9083 108.845 92.0583C109.07 92.2583 109.27 92.4583 109.47 92.6833C112.195 95.4833 113.745 99.1833 113.845 103.083C113.845 103.208 113.87 103.358 113.87 103.508Z' fill='%23EF557D'/%3e %3cpath d='M109.47 114.332C108.22 113.107 106.745 112.082 105.145 111.332C105.445 110.182 105.695 109.007 105.845 107.832C105.87 107.582 105.72 107.382 105.47 107.332C105.22 107.307 105.02 107.457 104.97 107.707C104.82 108.807 104.62 109.907 104.32 110.982C100.445 109.407 96.12 109.407 92.245 110.982C91.97 109.907 91.745 108.807 91.595 107.707C91.57 107.457 91.345 107.307 91.095 107.332C90.87 107.357 90.695 107.582 90.72 107.807C90.87 108.982 91.12 110.157 91.42 111.307C89.82 112.057 88.37 113.082 87.095 114.307C87.295 114.507 87.495 114.732 87.72 114.907C88.87 113.782 90.195 112.857 91.67 112.132C92.695 115.432 94.27 117.832 96.145 118.882C97.57 119.082 98.995 119.082 100.42 118.882C102.27 117.832 103.87 115.457 104.895 112.157C106.345 112.857 107.67 113.807 108.845 114.932C109.045 114.757 109.27 114.557 109.47 114.332ZM98.295 118.632C95.945 118.632 93.77 115.982 92.495 111.807C96.22 110.282 100.37 110.282 104.095 111.807C102.82 115.982 100.645 118.632 98.295 118.632Z' fill='%23D42B57'/%3e %3cpath d='M109.47 92.6821C109.27 92.4821 109.045 92.2571 108.845 92.0571C107.695 93.1821 106.37 94.1071 104.895 94.8321C103.87 91.5321 102.295 89.1321 100.445 88.0821C99.0196 87.8821 97.5946 87.8821 96.1696 88.0821C94.3196 89.1321 92.7196 91.5071 91.6946 94.8321C90.2446 94.1321 88.9196 93.1821 87.7446 92.0571C87.5196 92.2571 87.3196 92.4571 87.1196 92.6821C88.3946 93.9071 89.8446 94.9321 91.4446 95.6821C91.1446 96.8321 90.8946 98.0071 90.7446 99.1821C90.7196 99.4321 90.8696 99.6321 91.1196 99.6821C91.3696 99.7321 91.5696 99.5571 91.6196 99.3071C91.7696 98.2071 91.9696 97.1071 92.2696 96.0321C94.1946 96.8071 96.2446 97.2071 98.3196 97.2071C100.395 97.2071 102.445 96.8071 104.37 96.0321C104.645 97.1071 104.87 98.2071 105.02 99.3071C105.045 99.5321 105.245 99.6821 105.445 99.6821H105.495C105.745 99.6571 105.895 99.4321 105.87 99.1821C105.72 98.0071 105.47 96.8321 105.17 95.6821C106.745 94.9321 108.195 93.9071 109.47 92.6821ZM98.2946 96.3321C96.2946 96.3321 94.3446 95.9321 92.4946 95.1821C93.7696 91.0321 95.9446 88.3821 98.2946 88.3821C100.645 88.3821 102.82 91.0321 104.095 95.2071C102.245 95.9571 100.295 96.3571 98.2946 96.3321Z' fill='%23D42B57'/%3e %3cpath d='M113.87 103.507V103.957H109.345C109.095 103.957 108.895 103.757 108.895 103.507C108.895 103.257 109.095 103.057 109.345 103.057H113.87C113.845 103.207 113.87 103.357 113.87 103.507Z' fill='%23D42B57'/%3e %3cpath d='M87.7199 103.507C87.7199 103.757 87.5199 103.932 87.2949 103.957H82.7449C82.7449 103.807 82.7449 103.657 82.7449 103.507C82.7449 103.357 82.7449 103.207 82.7449 103.057H87.2699C87.5199 103.057 87.7199 103.257 87.7199 103.507Z' fill='%23D42B57'/%3e %3cpath d='M87.2698 99.2568H109.32V107.757H87.2698V99.2568Z' fill='%23FFC5D4'/%3e %3cpath d='M96.6948 105.107C96.8698 105.482 97.3948 105.432 97.5198 105.057L98.2948 103.232L99.0698 105.107C99.2198 105.482 99.7948 105.457 99.8948 105.057L101.07 102.257C101.145 102.007 101.045 101.757 100.795 101.682C100.595 101.607 100.345 101.707 100.245 101.907L99.4698 103.807L98.6948 101.957C98.5698 101.582 98.0198 101.557 97.8698 101.932L97.0948 103.832L96.3198 101.957C96.2198 101.732 95.9698 101.632 95.7448 101.707C95.5198 101.807 95.4198 102.057 95.4948 102.282L96.6948 105.107Z' fill='%23474F54'/%3e %3cpath d='M103.445 105.107C103.62 105.482 104.145 105.457 104.27 105.057L105.045 103.232L105.82 105.107C105.97 105.482 106.545 105.457 106.645 105.057L107.82 102.257C107.895 102.032 107.77 101.782 107.545 101.707C107.345 101.632 107.095 101.732 106.995 101.932L106.22 103.832L105.445 101.982C105.32 101.607 104.77 101.582 104.62 101.957L103.845 103.857L103.07 101.982C102.97 101.757 102.72 101.657 102.495 101.757C102.27 101.857 102.17 102.107 102.27 102.332L103.445 105.107Z' fill='%23474F54'/%3e %3cpath d='M90.7949 105.057L91.5699 103.232L92.3449 105.132C92.5199 105.507 93.0449 105.457 93.1699 105.082L94.3449 102.282C94.4199 102.057 94.3199 101.807 94.0949 101.732C93.8699 101.657 93.6449 101.757 93.5449 101.957L92.7699 103.857L91.9949 102.007C91.8699 101.632 91.3449 101.607 91.1699 101.982L90.3949 103.882L89.6199 102.007C89.5199 101.782 89.2699 101.682 89.0449 101.757C88.8199 101.832 88.7199 102.107 88.7949 102.332L89.9949 105.182C90.1199 105.482 90.6699 105.457 90.7949 105.057Z' fill='%23474F54'/%3e %3c/g%3e %3cdefs%3e %3cclipPath id='clip0'%3e %3crect width='32' height='32' fill='white' transform='translate(82.2949 87.5068)'/%3e %3c/clipPath%3e %3c/defs%3e %3c/svg%3e";
var img$9 = "data:image/svg+xml,%3csvg width='151' height='151' viewBox='0 0 151 151' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect x='24.8809' y='22.6309' width='100.604' height='103.08' rx='50.3021' fill='%23FFDDE6'/%3e %3crect x='33.0107' y='30.9607' width='84.3449' height='86.4208' rx='42.1724' fill='%23ED154E'/%3e %3cpath d='M140.675 94.2283C141.709 94.3392 142.46 95.2895 142.352 96.349C142.244 97.4086 141.316 98.1789 140.282 98.068C139.248 97.9571 138.496 97.0068 138.605 95.9472C138.713 94.8876 139.64 94.1174 140.675 94.2283Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.6171'/%3e %3cpath d='M36.2282 133.33C37.9287 133.512 39.1649 135.075 38.987 136.817C38.809 138.56 37.2838 139.826 35.5833 139.644C33.8827 139.462 32.6465 137.899 32.8245 136.157C33.0025 134.414 34.5277 133.148 36.2282 133.33Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='2.65921'/%3e %3cpath d='M74.1603 3.44661C75.8609 3.62896 77.0971 5.1917 76.9191 6.93409C76.7411 8.67647 75.2159 9.9431 73.5154 9.76075C71.8149 9.5784 70.5787 8.01566 70.7566 6.27328C70.9346 4.53089 72.4598 3.26426 74.1603 3.44661Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='2.65921'/%3e %3cpath d='M2.41535 44.7844C3.19648 44.7844 3.8307 45.4343 3.8307 46.2346C3.8307 47.035 3.19648 47.6848 2.41535 47.6848C1.63422 47.6848 1 47.035 1 46.2346C1 45.4343 1.63422 44.7844 2.41535 44.7844Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.94378'/%3e %3cpath d='M112.344 139.354C113.125 139.354 113.759 140.003 113.759 140.804C113.759 141.604 113.125 142.254 112.344 142.254C111.563 142.254 110.929 141.604 110.929 140.804C110.929 140.003 111.563 139.354 112.344 139.354Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.94378'/%3e %3cpath d='M133.697 38.9111L135.36 33.3452' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M131.902 35.3169L137.334 37.0202' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M8.13135 98.012L9.59765 92.3885' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M6.21094 94.4863L11.6993 95.9887' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M126.217 123.195L127.381 117.498' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M124.112 119.782L129.672 120.975' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M46.0449 128.465C43.2835 128.465 41.0449 126.227 41.0449 123.465L41.0449 24.7151C41.0449 21.9537 43.2835 19.7151 46.0449 19.7151L103.545 19.7151C106.306 19.7151 108.545 21.9537 108.545 24.7151L108.545 123.465C108.545 126.227 106.306 128.465 103.545 128.465L46.0449 128.465Z' fill='%23D52B57'/%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M106.85 127.267L41.7646 22.2252C42.6277 20.7251 44.2467 19.7151 46.1016 19.7151L103.602 19.7151C106.363 19.7151 108.602 21.9537 108.602 24.7151V123.465C108.602 124.987 107.922 126.35 106.85 127.267Z' fill='%23E43F6B'/%3e %3cpath d='M41.0449 87.6838L41.0449 83.9338L46.6699 83.9338L46.6699 87.6838L41.0449 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M102.92 87.6838L102.92 83.9338L108.545 83.9338L108.545 87.6838L102.92 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M50.4199 87.6838L50.4199 83.9338L54.1699 83.9338L54.1699 87.6838L50.4199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M57.9199 87.6838L57.9199 83.9338L61.6699 83.9338L61.6699 87.6838L57.9199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M65.4199 87.6838L65.4199 83.9338L69.1699 83.9338L69.1699 87.6838L65.4199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M72.9199 87.6838L72.9199 83.9338L76.6699 83.9338L76.6699 87.6838L72.9199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M80.4199 87.6838L80.4199 83.9338L84.1699 83.9338L84.1699 87.6838L80.4199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M87.9199 87.6838L87.9199 83.9338L91.6699 83.9338L91.6699 87.6838L87.9199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M95.4199 87.6838L95.4199 83.9338L99.1699 83.9338L99.1699 87.6838L95.4199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M48.5449 70.3401L48.5449 32.8401L101.043 32.8401L101.043 70.3401L48.5449 70.3401Z' fill='white'/%3e %3cpath d='M101.046 61.282L88.8354 41.8775C88.5541 41.4086 88.1561 41.0205 87.6803 40.7511C87.2045 40.4817 86.667 40.3401 86.1201 40.3401C85.5321 40.3401 84.9556 40.5038 84.4554 40.813C83.9552 41.1222 83.5509 41.5646 83.2879 42.0906L69.1636 70.3401L101.046 70.3401L101.046 61.282Z' fill='%239CC221'/%3e %3cpath d='M101.045 44.0901L96.1967 44.0901C95.3561 44.0901 94.5236 44.2557 93.747 44.5774C92.9703 44.8991 92.2646 45.3706 91.6702 45.9651C91.0758 46.5595 90.3701 47.0311 89.5934 47.3528C88.8168 47.6745 87.9844 47.8401 87.1437 47.8401L86.0454 47.8401C85.0509 47.8401 84.0971 48.2352 83.3938 48.9384C82.6906 49.6417 82.2955 50.5955 82.2955 51.5901C82.2955 52.5847 82.6906 53.5385 83.3938 54.2417C84.0971 54.945 85.0509 55.3401 86.0454 55.3401L101.045 55.3401L101.045 44.0901Z' fill='%23CDF4F7'/%3e %3cpath d='M48.545 32.8401H53.3932C54.2339 32.8401 55.0663 33.0057 55.8429 33.3274C56.6196 33.6491 57.3253 34.1206 57.9197 34.7151C58.5142 35.3095 59.2198 35.7811 59.9965 36.1028C60.7732 36.4245 61.6056 36.5901 62.4462 36.5901H63.5446C64.5391 36.5901 65.4929 36.9852 66.1961 37.6884C66.8994 38.3917 67.2944 39.3455 67.2944 40.3401C67.2944 41.3347 66.8994 42.2885 66.1961 42.9917C65.4929 43.695 64.5391 44.0901 63.5446 44.0901H48.545V32.8401Z' fill='%23CDF4F7'/%3e %3cpath d='M84.1627 70.3401L71.9758 47.7065C71.6923 47.1801 71.2716 46.7402 70.7583 46.4336C70.245 46.127 69.6583 45.9651 69.0604 45.9651C68.5152 45.9651 67.9786 46.0997 67.4979 46.3569C67.0173 46.6141 66.6076 46.986 66.3053 47.4396L48.6196 70.3401L56.0386 70.3401L84.1627 70.3401Z' fill='%23ACCD2A'/%3e %3cpath d='M56.1084 94.8962H63.5978V99.8892H56.1084V94.8962Z' fill='%23FFDDE6'/%3e %3cpath d='M68.5913 94.8962H83.57V99.8892H68.5913V94.8962Z' fill='%23FFDDE6'/%3e %3cpath d='M88.5625 94.8962H101.045V99.8892H88.5625V94.8962Z' fill='%23FFDDE6'/%3e %3cpath d='M48.6191 104.882H71.0873V109.875H48.6191V104.882Z' fill='%23FFDDE6'/%3e %3cpath d='M76.0801 104.882H91.0588V109.875H76.0801V104.882Z' fill='%23FFDDE6'/%3e %3cpath d='M96.0518 104.882H101.045V109.875H96.0518V104.882Z' fill='%23FFDDE6'/%3e %3cpath d='M48.6191 114.868H56.1085V119.861H48.6191V114.868Z' fill='%23FFDDE6'/%3e %3cpath d='M61.1016 114.868H81.0732V119.861H61.1016V114.868Z' fill='%23FFDDE6'/%3e %3cpath d='M86.0659 114.868H101.045V119.861H86.0659V114.868Z' fill='%23FFDDE6'/%3e %3cpath d='M111.308 117.975C112.569 116.718 114.609 116.72 115.869 117.977L131.78 133.863C133.036 135.116 133.037 137.15 131.784 138.407L131.778 138.412C130.517 139.668 128.477 139.667 127.217 138.409L111.305 122.524C110.05 121.27 110.048 119.236 111.302 117.981L111.308 117.975Z' fill='%23DF2153'/%3e %3cpath d='M114.702 121.26C124.528 112.257 125.208 97.0102 116.224 87.2052C107.239 77.3997 91.991 76.7495 82.1658 85.7527C72.3405 94.7559 71.6582 110.003 80.6433 119.809C89.628 129.614 104.877 130.263 114.702 121.26Z' fill='white'/%3e %3cpath d='M114.702 121.26C124.528 112.257 125.208 97.0102 116.224 87.2052C107.239 77.3997 91.991 76.7495 82.1658 85.7527C72.3405 94.7559 71.6582 110.003 80.6433 119.809C89.628 129.614 104.877 130.263 114.702 121.26Z' stroke='%23FF3C70' stroke-width='4' stroke-miterlimit='10'/%3e %3cg clip-path='url(%23clip0)'%3e %3cpath d='M112.513 101.464L99.5016 89.6084C98.9305 89.0879 98.0693 89.0879 97.4984 89.6083L84.487 101.464C84.0295 101.881 83.8784 102.523 84.1019 103.101C84.3255 103.678 84.8698 104.051 85.4887 104.051H87.5668V115.929C87.5668 116.4 87.9487 116.782 88.4197 116.782H95.5515C96.0225 116.782 96.4043 116.4 96.4043 115.929V108.717H100.596V115.929C100.596 116.4 100.978 116.782 101.449 116.782H108.58C109.051 116.782 109.433 116.4 109.433 115.929V104.051H111.512C112.13 104.051 112.675 103.678 112.898 103.101C113.122 102.523 112.97 101.881 112.513 101.464Z' fill='%23EF557D'/%3e %3cpath d='M109.21 90.9202H103.483L110.063 96.9034V91.7729C110.063 91.302 109.681 90.9202 109.21 90.9202Z' fill='%23EF557D'/%3e %3c/g%3e %3cdefs%3e %3cclipPath id='clip0'%3e %3crect width='29' height='29' fill='white' transform='translate(84 88.5)'/%3e %3c/clipPath%3e %3c/defs%3e %3c/svg%3e";
var img$a = "data:image/svg+xml,%3csvg width='151' height='151' viewBox='0 0 151 151' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect x='24.8809' y='22.6309' width='100.604' height='103.08' rx='50.3021' fill='%23FFDDE6'/%3e %3crect x='33.0107' y='30.9607' width='84.3449' height='86.4208' rx='42.1724' fill='%23ED154E'/%3e %3cpath d='M140.675 94.2283C141.709 94.3392 142.46 95.2895 142.352 96.349C142.244 97.4086 141.316 98.1789 140.282 98.068C139.248 97.9571 138.496 97.0068 138.605 95.9472C138.713 94.8876 139.64 94.1174 140.675 94.2283Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.6171'/%3e %3cpath d='M36.2282 133.33C37.9287 133.512 39.1649 135.075 38.987 136.817C38.809 138.56 37.2838 139.826 35.5833 139.644C33.8827 139.462 32.6465 137.899 32.8245 136.157C33.0025 134.414 34.5277 133.148 36.2282 133.33Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='2.65921'/%3e %3cpath d='M74.1603 3.44661C75.8609 3.62896 77.0971 5.1917 76.9191 6.93409C76.7411 8.67647 75.2159 9.9431 73.5154 9.76075C71.8149 9.5784 70.5787 8.01566 70.7566 6.27328C70.9346 4.53089 72.4598 3.26426 74.1603 3.44661Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='2.65921'/%3e %3cpath d='M2.41535 44.7844C3.19648 44.7844 3.8307 45.4343 3.8307 46.2346C3.8307 47.035 3.19648 47.6848 2.41535 47.6848C1.63422 47.6848 1 47.035 1 46.2346C1 45.4343 1.63422 44.7844 2.41535 44.7844Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.94378'/%3e %3cpath d='M112.344 139.354C113.125 139.354 113.759 140.003 113.759 140.804C113.759 141.604 113.125 142.254 112.344 142.254C111.563 142.254 110.929 141.604 110.929 140.804C110.929 140.003 111.563 139.354 112.344 139.354Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.94378'/%3e %3cpath d='M133.697 38.9111L135.36 33.3452' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M131.902 35.3169L137.334 37.0202' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M8.13135 98.012L9.59765 92.3885' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M6.21094 94.4863L11.6993 95.9887' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M126.217 123.195L127.381 117.498' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M124.112 119.782L129.672 120.975' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M46.0449 128.465C43.2835 128.465 41.0449 126.227 41.0449 123.465L41.0449 24.7151C41.0449 21.9537 43.2835 19.7151 46.0449 19.7151L103.545 19.7151C106.306 19.7151 108.545 21.9537 108.545 24.7151L108.545 123.465C108.545 126.227 106.306 128.465 103.545 128.465L46.0449 128.465Z' fill='%23D52B57'/%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M106.85 127.267L41.7646 22.2252C42.6277 20.7251 44.2467 19.7151 46.1016 19.7151L103.602 19.7151C106.363 19.7151 108.602 21.9537 108.602 24.7151V123.465C108.602 124.987 107.922 126.35 106.85 127.267Z' fill='%23E43F6B'/%3e %3cpath d='M41.0449 87.6838L41.0449 83.9338L46.6699 83.9338L46.6699 87.6838L41.0449 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M102.92 87.6838L102.92 83.9338L108.545 83.9338L108.545 87.6838L102.92 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M50.4199 87.6838L50.4199 83.9338L54.1699 83.9338L54.1699 87.6838L50.4199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M57.9199 87.6838L57.9199 83.9338L61.6699 83.9338L61.6699 87.6838L57.9199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M65.4199 87.6838L65.4199 83.9338L69.1699 83.9338L69.1699 87.6838L65.4199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M72.9199 87.6838L72.9199 83.9338L76.6699 83.9338L76.6699 87.6838L72.9199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M80.4199 87.6838L80.4199 83.9338L84.1699 83.9338L84.1699 87.6838L80.4199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M87.9199 87.6838L87.9199 83.9338L91.6699 83.9338L91.6699 87.6838L87.9199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M95.4199 87.6838L95.4199 83.9338L99.1699 83.9338L99.1699 87.6838L95.4199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M48.5449 70.3401L48.5449 32.8401L101.043 32.8401L101.043 70.3401L48.5449 70.3401Z' fill='white'/%3e %3cpath d='M101.046 61.282L88.8354 41.8775C88.5541 41.4086 88.1561 41.0205 87.6803 40.7511C87.2045 40.4817 86.667 40.3401 86.1201 40.3401C85.5321 40.3401 84.9556 40.5038 84.4554 40.813C83.9552 41.1222 83.5509 41.5646 83.2879 42.0906L69.1636 70.3401L101.046 70.3401L101.046 61.282Z' fill='%239CC221'/%3e %3cpath d='M101.045 44.0901L96.1967 44.0901C95.3561 44.0901 94.5236 44.2557 93.747 44.5774C92.9703 44.8991 92.2646 45.3706 91.6702 45.9651C91.0758 46.5595 90.3701 47.0311 89.5934 47.3528C88.8168 47.6745 87.9844 47.8401 87.1437 47.8401L86.0454 47.8401C85.0509 47.8401 84.0971 48.2352 83.3938 48.9384C82.6906 49.6417 82.2955 50.5955 82.2955 51.5901C82.2955 52.5847 82.6906 53.5385 83.3938 54.2417C84.0971 54.945 85.0509 55.3401 86.0454 55.3401L101.045 55.3401L101.045 44.0901Z' fill='%23CDF4F7'/%3e %3cpath d='M48.545 32.8401H53.3932C54.2339 32.8401 55.0663 33.0057 55.8429 33.3274C56.6196 33.6491 57.3253 34.1206 57.9197 34.7151C58.5142 35.3095 59.2198 35.7811 59.9965 36.1028C60.7732 36.4245 61.6056 36.5901 62.4462 36.5901H63.5446C64.5391 36.5901 65.4929 36.9852 66.1961 37.6884C66.8994 38.3917 67.2944 39.3455 67.2944 40.3401C67.2944 41.3347 66.8994 42.2885 66.1961 42.9917C65.4929 43.695 64.5391 44.0901 63.5446 44.0901H48.545V32.8401Z' fill='%23CDF4F7'/%3e %3cpath d='M84.1627 70.3401L71.9758 47.7065C71.6923 47.1801 71.2716 46.7402 70.7583 46.4336C70.245 46.127 69.6583 45.9651 69.0604 45.9651C68.5152 45.9651 67.9786 46.0997 67.4979 46.3569C67.0173 46.6141 66.6076 46.986 66.3053 47.4396L48.6196 70.3401L56.0386 70.3401L84.1627 70.3401Z' fill='%23ACCD2A'/%3e %3cpath d='M56.1084 94.8962H63.5978V99.8892H56.1084V94.8962Z' fill='%23FFDDE6'/%3e %3cpath d='M68.5913 94.8962H83.57V99.8892H68.5913V94.8962Z' fill='%23FFDDE6'/%3e %3cpath d='M88.5625 94.8962H101.045V99.8892H88.5625V94.8962Z' fill='%23FFDDE6'/%3e %3cpath d='M48.6191 104.882H71.0873V109.875H48.6191V104.882Z' fill='%23FFDDE6'/%3e %3cpath d='M76.0801 104.882H91.0588V109.875H76.0801V104.882Z' fill='%23FFDDE6'/%3e %3cpath d='M96.0518 104.882H101.045V109.875H96.0518V104.882Z' fill='%23FFDDE6'/%3e %3cpath d='M48.6191 114.868H56.1085V119.861H48.6191V114.868Z' fill='%23FFDDE6'/%3e %3cpath d='M61.1016 114.868H81.0732V119.861H61.1016V114.868Z' fill='%23FFDDE6'/%3e %3cpath d='M86.0659 114.868H101.045V119.861H86.0659V114.868Z' fill='%23FFDDE6'/%3e %3cpath d='M112.353 117.975C113.614 116.718 115.654 116.72 116.913 117.977L132.825 133.863C134.081 135.116 134.082 137.15 132.828 138.407L132.823 138.412C131.562 139.668 129.522 139.667 128.262 138.409L112.35 122.524C111.095 121.27 111.093 119.236 112.347 117.981L112.353 117.975Z' fill='%23DF2153'/%3e %3cpath d='M115.747 121.26C125.573 112.257 126.253 97.0102 117.269 87.2052C108.284 77.3997 93.0359 76.7495 83.2107 85.7527C73.3854 94.7559 72.7032 110.003 81.6883 119.809C90.6729 129.614 105.922 130.263 115.747 121.26Z' fill='white'/%3e %3cpath d='M115.747 121.26C125.573 112.257 126.253 97.0102 117.269 87.2052C108.284 77.3997 93.0359 76.7495 83.2107 85.7527C73.3854 94.7559 72.7032 110.003 81.6883 119.809C90.6729 129.614 105.922 130.263 115.747 121.26Z' stroke='%23FF3C70' stroke-width='4' stroke-miterlimit='10'/%3e %3cg clip-path='url(%23clip0)'%3e %3cpath d='M96.0205 94.7532H99.583V96.5344H103.146V91.1907H85.333V96.5344H88.8955V94.7532H92.4581V112.566H88.8955V116.128H99.5813V112.566H96.0205V94.7532Z' fill='%23D42B57'/%3e %3cpath d='M99.583 100.097V105.441H103.146V103.66H104.927V112.566H103.146V116.128H110.271V112.566H108.489V103.659H110.271V105.441H113.833V100.097H99.583V100.097Z' fill='%23D42B57'/%3e %3c/g%3e %3cdefs%3e %3cclipPath id='clip0'%3e %3crect width='28.5' height='28.5' fill='white' transform='translate(85.333 89.4094)'/%3e %3c/clipPath%3e %3c/defs%3e %3c/svg%3e";
var img$b = "data:image/svg+xml,%3csvg width='151' height='151' viewBox='0 0 151 151' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect x='24.8809' y='22.6309' width='100.604' height='103.08' rx='50.3021' fill='%23FFDDE6'/%3e %3crect x='33.0107' y='30.9607' width='84.3449' height='86.4208' rx='42.1724' fill='%23ED154E'/%3e %3cpath d='M140.675 94.2283C141.709 94.3392 142.46 95.2895 142.352 96.349C142.244 97.4086 141.316 98.1789 140.282 98.068C139.248 97.9571 138.496 97.0068 138.605 95.9472C138.713 94.8876 139.64 94.1174 140.675 94.2283Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.6171'/%3e %3cpath d='M36.2282 133.33C37.9287 133.512 39.1649 135.075 38.987 136.817C38.809 138.56 37.2838 139.826 35.5833 139.644C33.8827 139.462 32.6465 137.899 32.8245 136.157C33.0025 134.414 34.5277 133.148 36.2282 133.33Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='2.65921'/%3e %3cpath d='M74.1603 3.44661C75.8609 3.62896 77.0971 5.1917 76.9191 6.93409C76.7411 8.67647 75.2159 9.9431 73.5154 9.76075C71.8149 9.5784 70.5787 8.01566 70.7566 6.27328C70.9346 4.53089 72.4598 3.26426 74.1603 3.44661Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='2.65921'/%3e %3cpath d='M2.41535 44.7844C3.19648 44.7844 3.8307 45.4343 3.8307 46.2346C3.8307 47.035 3.19648 47.6848 2.41535 47.6848C1.63422 47.6848 1 47.035 1 46.2346C1 45.4343 1.63422 44.7844 2.41535 44.7844Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.94378'/%3e %3cpath d='M112.344 139.354C113.125 139.354 113.759 140.003 113.759 140.804C113.759 141.604 113.125 142.254 112.344 142.254C111.563 142.254 110.929 141.604 110.929 140.804C110.929 140.003 111.563 139.354 112.344 139.354Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.94378'/%3e %3cpath d='M133.697 38.9111L135.36 33.3452' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M131.902 35.3169L137.334 37.0202' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M8.13135 98.012L9.59765 92.3885' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M6.21094 94.4863L11.6993 95.9887' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M126.217 123.195L127.381 117.498' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M124.112 119.782L129.672 120.975' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M46.0449 128.465C43.2835 128.465 41.0449 126.227 41.0449 123.465L41.0449 24.7151C41.0449 21.9537 43.2835 19.7151 46.0449 19.7151L103.545 19.7151C106.306 19.7151 108.545 21.9537 108.545 24.7151L108.545 123.465C108.545 126.227 106.306 128.465 103.545 128.465L46.0449 128.465Z' fill='%23D52B57'/%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M106.85 127.267L41.7646 22.2252C42.6277 20.7251 44.2467 19.7151 46.1016 19.7151L103.602 19.7151C106.363 19.7151 108.602 21.9537 108.602 24.7151V123.465C108.602 124.987 107.922 126.35 106.85 127.267Z' fill='%23E43F6B'/%3e %3cpath d='M41.0449 87.6838L41.0449 83.9338L46.6699 83.9338L46.6699 87.6838L41.0449 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M102.92 87.6838L102.92 83.9338L108.545 83.9338L108.545 87.6838L102.92 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M50.4199 87.6838L50.4199 83.9338L54.1699 83.9338L54.1699 87.6838L50.4199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M57.9199 87.6838L57.9199 83.9338L61.6699 83.9338L61.6699 87.6838L57.9199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M65.4199 87.6838L65.4199 83.9338L69.1699 83.9338L69.1699 87.6838L65.4199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M72.9199 87.6838L72.9199 83.9338L76.6699 83.9338L76.6699 87.6838L72.9199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M80.4199 87.6838L80.4199 83.9338L84.1699 83.9338L84.1699 87.6838L80.4199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M87.9199 87.6838L87.9199 83.9338L91.6699 83.9338L91.6699 87.6838L87.9199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M95.4199 87.6838L95.4199 83.9338L99.1699 83.9338L99.1699 87.6838L95.4199 87.6838Z' fill='%23FFDDE6'/%3e %3cpath d='M48.5449 70.3401L48.5449 32.8401L101.043 32.8401L101.043 70.3401L48.5449 70.3401Z' fill='white'/%3e %3cpath d='M101.046 61.282L88.8354 41.8775C88.5541 41.4086 88.1561 41.0205 87.6803 40.7511C87.2045 40.4817 86.667 40.3401 86.1201 40.3401C85.5321 40.3401 84.9556 40.5038 84.4554 40.813C83.9552 41.1222 83.5509 41.5646 83.2879 42.0906L69.1636 70.3401L101.046 70.3401L101.046 61.282Z' fill='%239CC221'/%3e %3cpath d='M101.045 44.0901L96.1967 44.0901C95.3561 44.0901 94.5236 44.2557 93.747 44.5774C92.9703 44.8991 92.2646 45.3706 91.6702 45.9651C91.0758 46.5595 90.3701 47.0311 89.5934 47.3528C88.8168 47.6745 87.9844 47.8401 87.1437 47.8401L86.0454 47.8401C85.0509 47.8401 84.0971 48.2352 83.3938 48.9384C82.6906 49.6417 82.2955 50.5955 82.2955 51.5901C82.2955 52.5847 82.6906 53.5385 83.3938 54.2417C84.0971 54.945 85.0509 55.3401 86.0454 55.3401L101.045 55.3401L101.045 44.0901Z' fill='%23CDF4F7'/%3e %3cpath d='M48.545 32.8401H53.3932C54.2339 32.8401 55.0663 33.0057 55.8429 33.3274C56.6196 33.6491 57.3253 34.1206 57.9197 34.7151C58.5142 35.3095 59.2198 35.7811 59.9965 36.1028C60.7732 36.4245 61.6056 36.5901 62.4462 36.5901H63.5446C64.5391 36.5901 65.4929 36.9852 66.1961 37.6884C66.8994 38.3917 67.2944 39.3455 67.2944 40.3401C67.2944 41.3347 66.8994 42.2885 66.1961 42.9917C65.4929 43.695 64.5391 44.0901 63.5446 44.0901H48.545V32.8401Z' fill='%23CDF4F7'/%3e %3cpath d='M84.1627 70.3401L71.9758 47.7065C71.6923 47.1801 71.2716 46.7402 70.7583 46.4336C70.245 46.127 69.6583 45.9651 69.0604 45.9651C68.5152 45.9651 67.9786 46.0997 67.4979 46.3569C67.0173 46.6141 66.6076 46.986 66.3053 47.4396L48.6196 70.3401L56.0386 70.3401L84.1627 70.3401Z' fill='%23ACCD2A'/%3e %3cpath d='M56.1084 94.8962H63.5978V99.8892H56.1084V94.8962Z' fill='%23FFDDE6'/%3e %3cpath d='M68.5913 94.8962H83.57V99.8892H68.5913V94.8962Z' fill='%23FFDDE6'/%3e %3cpath d='M88.5625 94.8962H101.045V99.8892H88.5625V94.8962Z' fill='%23FFDDE6'/%3e %3cpath d='M48.6191 104.882H71.0873V109.875H48.6191V104.882Z' fill='%23FFDDE6'/%3e %3cpath d='M76.0801 104.882H91.0588V109.875H76.0801V104.882Z' fill='%23FFDDE6'/%3e %3cpath d='M96.0518 104.882H101.045V109.875H96.0518V104.882Z' fill='%23FFDDE6'/%3e %3cpath d='M48.6191 114.868H56.1085V119.861H48.6191V114.868Z' fill='%23FFDDE6'/%3e %3cpath d='M61.1016 114.868H81.0732V119.861H61.1016V114.868Z' fill='%23FFDDE6'/%3e %3cpath d='M86.0659 114.868H101.045V119.861H86.0659V114.868Z' fill='%23FFDDE6'/%3e %3cpath d='M111.308 117.975C112.569 116.718 114.609 116.72 115.869 117.977L131.78 133.863C133.036 135.116 133.037 137.15 131.784 138.407L131.778 138.412C130.517 139.668 128.477 139.667 127.217 138.409L111.305 122.524C110.05 121.27 110.048 119.236 111.302 117.981L111.308 117.975Z' fill='%23DF2153'/%3e %3cpath d='M114.702 121.26C124.528 112.257 125.208 97.0102 116.224 87.2052C107.239 77.3997 91.991 76.7495 82.1658 85.7527C72.3405 94.7559 71.6582 110.003 80.6433 119.809C89.628 129.614 104.877 130.263 114.702 121.26Z' fill='white'/%3e %3cpath d='M114.702 121.26C124.528 112.257 125.208 97.0102 116.224 87.2052C107.239 77.3997 91.991 76.7495 82.1658 85.7527C72.3405 94.7559 71.6582 110.003 80.6433 119.809C89.628 129.614 104.877 130.263 114.702 121.26Z' stroke='%23FF3C70' stroke-width='4' stroke-miterlimit='10'/%3e %3cg clip-path='url(%23clip0)'%3e %3cpath d='M108.327 113.971L98.101 108.556C97.8345 108.415 97.5095 108.435 97.2576 108.605L89.4381 114.02C89.1456 114.223 89.0189 114.592 89.1261 114.931C89.2301 115.268 89.5454 115.5 89.8996 115.5H107.945C108.317 115.5 108.644 115.247 108.733 114.883C108.824 114.52 108.655 114.145 108.327 113.971Z' fill='%23D42B57'/%3e %3cpath d='M111.749 112.427L109.344 101.6C109.286 101.335 109.099 101.119 108.847 101.019C108.593 100.92 108.309 100.954 108.088 101.107L100.267 106.522C100.033 106.684 99.9012 106.956 99.9191 107.237C99.9353 107.521 100.099 107.775 100.35 107.906L110.574 113.321C110.694 113.384 110.824 113.417 110.954 113.417C111.128 113.417 111.302 113.361 111.447 113.249C111.699 113.057 111.817 112.737 111.749 112.427Z' fill='%23D42B57'/%3e %3cpath d='M106.091 99.8204C105.983 99.4807 105.67 99.25 105.314 99.25H97.8974C96.5487 101.692 94.5532 104.027 93.7325 104.941C93.271 105.454 92.6097 105.75 91.919 105.75C91.2284 105.75 90.567 105.454 90.1055 104.941C89.7887 104.588 89.2979 104.024 88.7357 103.326L86.7694 112.175C86.6979 112.502 86.8328 112.838 87.109 113.025C87.2455 113.118 87.4048 113.163 87.5624 113.163C87.7249 113.163 87.8858 113.116 88.0255 113.019L105.775 100.729C106.07 100.529 106.195 100.16 106.091 99.8204Z' fill='%23D42B57'/%3e %3cpath d='M91.9194 89.5C88.7832 89.5 86.2319 92.0512 86.2319 95.1875C86.2319 98.106 90.7949 103.275 91.3149 103.855C91.4693 104.026 91.6887 104.125 91.9194 104.125C92.1502 104.125 92.3696 104.026 92.5239 103.855C93.0439 103.275 97.6069 98.106 97.6069 95.1875C97.6069 92.0512 95.0557 89.5 91.9194 89.5ZM91.9194 97.625C90.5739 97.625 89.4819 96.533 89.4819 95.1875C89.4819 93.842 90.5739 92.75 91.9194 92.75C93.2649 92.75 94.3569 93.842 94.3569 95.1875C94.3569 96.533 93.2649 97.625 91.9194 97.625Z' fill='%23D42B57'/%3e %3c/g%3e %3cdefs%3e %3cclipPath id='clip0'%3e %3crect width='26' height='26' fill='white' transform='translate(86 89.5)'/%3e %3c/clipPath%3e %3c/defs%3e %3c/svg%3e";
var img$c = "data:image/svg+xml,%3csvg width='151' height='151' viewBox='0 0 151 151' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect x='24.8809' y='22.6309' width='100.604' height='103.08' rx='50.3021' fill='%23FFDDE6'/%3e %3crect x='33.0107' y='30.9607' width='84.3449' height='86.4208' rx='42.1724' fill='%23ED154E'/%3e %3cpath d='M140.675 94.2283C141.709 94.3392 142.46 95.2895 142.352 96.349C142.244 97.4086 141.316 98.1789 140.282 98.068C139.248 97.9571 138.496 97.0068 138.605 95.9472C138.713 94.8876 139.64 94.1174 140.675 94.2283Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.6171'/%3e %3cpath d='M36.2282 133.33C37.9287 133.512 39.1649 135.075 38.987 136.817C38.809 138.56 37.2838 139.826 35.5833 139.644C33.8827 139.462 32.6465 137.899 32.8245 136.157C33.0025 134.414 34.5277 133.148 36.2282 133.33Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='2.65921'/%3e %3cpath d='M74.1603 3.44661C75.8609 3.62896 77.0971 5.1917 76.9191 6.93409C76.7411 8.67647 75.2159 9.9431 73.5154 9.76075C71.8149 9.5784 70.5787 8.01566 70.7566 6.27328C70.9346 4.53089 72.4598 3.26426 74.1603 3.44661Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='2.65921'/%3e %3cpath d='M2.41535 44.7844C3.19648 44.7844 3.8307 45.4343 3.8307 46.2346C3.8307 47.035 3.19648 47.6848 2.41535 47.6848C1.63422 47.6848 1 47.035 1 46.2346C1 45.4343 1.63422 44.7844 2.41535 44.7844Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.94378'/%3e %3cpath d='M112.344 139.354C113.125 139.354 113.759 140.003 113.759 140.804C113.759 141.604 113.125 142.254 112.344 142.254C111.563 142.254 110.929 141.604 110.929 140.804C110.929 140.003 111.563 139.354 112.344 139.354Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.94378'/%3e %3cpath d='M133.697 38.9111L135.36 33.3452' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M131.902 35.3169L137.334 37.0202' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M8.13135 98.012L9.59765 92.3885' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M6.21094 94.4863L11.6993 95.9887' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M126.217 123.195L127.381 117.498' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M124.112 119.782L129.672 120.975' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cg clip-path='url(%23clip0)'%3e %3cpath d='M33 64.7504L74.409 91.104C74.882 91.4534 75.441 91.6254 76 91.6254C76.559 91.6254 77.118 91.4534 77.591 91.104L119 64.7504L77.6125 33.0379C76.6558 32.323 75.3442 32.323 74.3875 33.0379L33 64.7504Z' fill='%238D1334'/%3e %3cpath d='M102.875 32.5H49.125C46.1634 32.5 43.75 34.9134 43.75 37.875V97C43.75 98.4835 44.954 99.6875 46.4375 99.6875H105.562C107.046 99.6875 108.25 98.4835 108.25 97V37.875C108.25 34.9134 105.842 32.5 102.875 32.5Z' fill='%23ECEFF1'/%3e %3cg clip-path='url(%23clip1)'%3e %3cpath d='M88.1969 71.5003L74.8243 64.4198C74.4758 64.235 74.0508 64.2605 73.7214 64.4836L63.4959 71.5641C63.1134 71.8297 62.9477 72.3121 63.0879 72.7562C63.2239 73.1961 63.6362 73.5 64.0994 73.5H87.6975C88.1842 73.5 88.6113 73.1685 88.7282 72.6925C88.8472 72.2186 88.6262 71.7277 88.1969 71.5003Z' fill='%23D42B57'/%3e %3cpath d='M92.6723 69.4816L89.5273 55.3227C89.4508 54.9763 89.2064 54.6937 88.8771 54.5641C88.5456 54.4344 88.1737 54.4791 87.8847 54.6788L77.6571 61.7593C77.3511 61.9718 77.1789 62.3267 77.2023 62.6943C77.2236 63.0662 77.4382 63.3977 77.7654 63.5698L91.1359 70.6503C91.2932 70.7332 91.4632 70.7757 91.6332 70.7757C91.8606 70.7757 92.0879 70.7034 92.2771 70.5568C92.6064 70.3061 92.7616 69.8874 92.6723 69.4816Z' fill='%23D42B57'/%3e %3cpath d='M85.2724 52.9959C85.1322 52.5517 84.7221 52.25 84.2567 52.25H74.5582C72.7945 55.4439 70.185 58.4975 69.1118 59.6917C68.5083 60.3632 67.6435 60.75 66.7403 60.75C65.8372 60.75 64.9723 60.3632 64.3688 59.6917C63.9545 59.2306 63.3127 58.4932 62.5775 57.5795L60.0062 69.1522C59.9127 69.5794 60.0891 70.0192 60.4503 70.2636C60.6288 70.3847 60.8371 70.4442 61.0432 70.4442C61.2557 70.4442 61.4661 70.3826 61.6488 70.2551L84.8602 54.1837C85.2448 53.9224 85.4085 53.44 85.2724 52.9959Z' fill='%23D42B57'/%3e %3cpath d='M66.7407 39.5C62.6395 39.5 59.3032 42.8363 59.3032 46.9375C59.3032 50.754 65.2702 57.5136 65.9502 58.2722C66.1521 58.4954 66.439 58.625 66.7407 58.625C67.0425 58.625 67.3293 58.4954 67.5312 58.2722C68.2112 57.5136 74.1782 50.754 74.1782 46.9375C74.1782 42.8363 70.842 39.5 66.7407 39.5ZM66.7407 50.125C64.9812 50.125 63.5532 48.697 63.5532 46.9375C63.5532 45.178 64.9812 43.75 66.7407 43.75C68.5002 43.75 69.9282 45.178 69.9282 46.9375C69.9282 48.697 68.5002 50.125 66.7407 50.125Z' fill='%23D42B57'/%3e %3c/g%3e %3cpath d='M77.591 91.1036C77.118 91.453 76.559 91.625 76 91.625C75.441 91.625 74.882 91.453 74.409 91.1036L33 64.75V113.125C33 116.092 35.408 118.5 38.375 118.5H113.625C116.592 118.5 119 116.092 119 113.125V64.75L77.591 91.1036Z' fill='%23D42B57'/%3e %3cpath d='M113.625 118.5H38.375C35.3596 118.5 33 116.14 33 113.125C33 112.27 33.4085 111.464 34.0965 110.959L74.409 84.0839C74.882 83.7345 75.441 83.5625 76 83.5625C76.559 83.5625 77.118 83.7345 77.591 84.0839L117.903 110.959C118.591 111.464 119 112.27 119 113.125C119 116.14 116.64 118.5 113.625 118.5Z' fill='%23E43F6B'/%3e %3cpath d='M82.38 97.87C81.68 97.87 81.07 98.08 80.47 98.28C79.77 97.07 78.46 96.27 77.05 96.27C75.95 96.27 74.95 96.77 74.24 97.47C73.44 96.47 72.23 95.76 70.83 95.76C68.5 95.76 66.5 97.67 66.5 100C66.5 100.59 66.71 101.19 66.91 101.79C66.334 102.106 65.8531 102.57 65.5172 103.134C65.1813 103.699 65.0027 104.343 65 105C65 107 66.61 108.72 68.62 108.72C68.92 108.72 69.22 108.72 69.42 108.62C69.82 110.13 71.33 111.24 73.14 111.24C74.84 111.24 76.25 110.23 76.75 108.82C77.26 109.03 77.76 109.23 78.26 109.23C79.57 109.23 80.77 108.5 81.37 107.42C81.68 107.5 82 107.5 82.28 107.5C84.89 107.5 87 105.41 87 102.7C87.1 100 85 97.87 82.38 97.87Z' fill='%23FF5280'/%3e %3c/g%3e %3cdefs%3e %3cclipPath id='clip0'%3e %3crect width='86' height='86' fill='white' transform='translate(33 32.5)'/%3e %3c/clipPath%3e %3cclipPath id='clip1'%3e %3crect width='34' height='34' fill='white' transform='translate(59 39.5)'/%3e %3c/clipPath%3e %3c/defs%3e %3c/svg%3e";
var img$d = "data:image/svg+xml,%3csvg width='151' height='151' viewBox='0 0 151 151' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect x='24.8809' y='22.6309' width='100.604' height='103.08' rx='50.3021' fill='%23FFDDE6'/%3e %3crect x='33.0107' y='30.9607' width='84.3449' height='86.4208' rx='42.1724' fill='%23ED154E'/%3e %3cpath d='M140.675 94.2283C141.709 94.3392 142.46 95.2895 142.352 96.349C142.244 97.4086 141.316 98.1789 140.282 98.068C139.248 97.9571 138.496 97.0068 138.605 95.9472C138.713 94.8876 139.64 94.1174 140.675 94.2283Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.6171'/%3e %3cpath d='M36.2282 133.33C37.9287 133.512 39.1649 135.075 38.987 136.817C38.809 138.56 37.2838 139.826 35.5833 139.644C33.8827 139.462 32.6465 137.899 32.8245 136.157C33.0025 134.414 34.5277 133.148 36.2282 133.33Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='2.65921'/%3e %3cpath d='M74.1603 3.44661C75.8609 3.62896 77.0971 5.1917 76.9191 6.93409C76.7411 8.67647 75.2159 9.9431 73.5154 9.76075C71.8149 9.5784 70.5787 8.01566 70.7566 6.27328C70.9346 4.53089 72.4598 3.26426 74.1603 3.44661Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='2.65921'/%3e %3cpath d='M2.41535 44.7844C3.19648 44.7844 3.8307 45.4343 3.8307 46.2346C3.8307 47.035 3.19648 47.6848 2.41535 47.6848C1.63422 47.6848 1 47.035 1 46.2346C1 45.4343 1.63422 44.7844 2.41535 44.7844Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.94378'/%3e %3cpath d='M112.344 139.354C113.125 139.354 113.759 140.003 113.759 140.804C113.759 141.604 113.125 142.254 112.344 142.254C111.563 142.254 110.929 141.604 110.929 140.804C110.929 140.003 111.563 139.354 112.344 139.354Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.94378'/%3e %3cpath d='M133.697 38.9111L135.36 33.3452' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M131.902 35.3169L137.334 37.0202' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M8.13135 98.012L9.59765 92.3885' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M6.21094 94.4863L11.6993 95.9887' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M126.217 123.195L127.381 117.498' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M124.112 119.782L129.672 120.975' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cg clip-path='url(%23clip0)'%3e %3cpath d='M46 24.5C42.5625 24.5 39.75 27.3125 39.75 30.75V118.25C39.75 121.688 42.5625 124.5 46 124.5H108.5C111.938 124.5 114.75 121.688 114.75 118.25V49.5L89.75 24.5H46Z' fill='%23FF3B70'/%3e %3cpath d='M51.1914 68.0007C48.43 68.0007 46.1914 65.7622 46.1914 63.0007L46.1914 35.9993C46.1914 33.2378 48.43 30.9993 51.1914 30.9993L64.1578 30.9993C66.9193 30.9993 69.1578 33.2378 69.1578 35.9993L69.1578 63.0007C69.1578 65.7622 66.9193 68.0007 64.1578 68.0007L51.1914 68.0007Z' fill='%23D52B57'/%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M67.843 66.4012L47.1758 33.0461C48.0856 31.8051 49.5542 30.9993 51.2109 30.9993H64.1773C66.9388 30.9993 69.1773 33.2378 69.1773 35.9993V63.0007C69.1773 64.314 68.671 65.509 67.843 66.4012Z' fill='%23E43F6B'/%3e %3cpath d='M46.1914 54.1252L46.1914 52.8493L48.1053 52.8493L48.1053 54.1252L46.1914 54.1252Z' fill='%23FFDDE6'/%3e %3cpath d='M67.2441 54.1252L67.2441 52.8493L69.158 52.8493L69.158 54.1252L67.2441 54.1252Z' fill='%23FFDDE6'/%3e %3cpath d='M49.3813 54.1252L49.3813 52.8493L50.6573 52.8493L50.6573 54.1252L49.3813 54.1252Z' fill='%23FFDDE6'/%3e %3cpath d='M51.9331 54.1252L51.9331 52.8493L53.209 52.8493L53.209 54.1252L51.9331 54.1252Z' fill='%23FFDDE6'/%3e %3cpath d='M54.4849 54.1252L54.4849 52.8493L55.7608 52.8493L55.7608 54.1252L54.4849 54.1252Z' fill='%23FFDDE6'/%3e %3cpath d='M57.0366 54.1252L57.0366 52.8493L58.3125 52.8493L58.3125 54.1252L57.0366 54.1252Z' fill='%23FFDDE6'/%3e %3cpath d='M59.5884 54.1252L59.5884 52.8493L60.8643 52.8493L60.8643 54.1252L59.5884 54.1252Z' fill='%23FFDDE6'/%3e %3cpath d='M62.1401 54.1252L62.1401 52.8493L63.416 52.8493L63.416 54.1252L62.1401 54.1252Z' fill='%23FFDDE6'/%3e %3cpath d='M64.6924 54.1252L64.6924 52.8493L65.9683 52.8493L65.9683 54.1252L64.6924 54.1252Z' fill='%23FFDDE6'/%3e %3cpath d='M48.7432 48.2241L48.7432 35.465L66.6054 35.465L66.6054 48.2241L48.7432 48.2241Z' fill='white'/%3e %3cpath d='M66.6059 45.1422L62.4515 38.5399C62.3558 38.3804 62.2204 38.2484 62.0585 38.1567C61.8966 38.065 61.7137 38.0168 61.5277 38.0168C61.3276 38.0168 61.1314 38.0726 60.9612 38.1778C60.791 38.283 60.6535 38.4335 60.564 38.6124L55.7583 48.2241L66.6059 48.2241V45.1422Z' fill='%239CC221'/%3e %3cpath d='M66.606 39.2927L64.9564 39.2927C64.6704 39.2927 64.3871 39.3491 64.1229 39.4585C63.8586 39.568 63.6185 39.7284 63.4163 39.9307C63.214 40.1329 62.9739 40.2934 62.7097 40.4028C62.4454 40.5123 62.1622 40.5686 61.8762 40.5686L61.5025 40.5686C61.1641 40.5686 60.8396 40.7031 60.6003 40.9423C60.361 41.1816 60.2266 41.5062 60.2266 41.8446C60.2266 42.1829 60.361 42.5075 60.6003 42.7468C60.8396 42.986 61.1641 43.1205 61.5025 43.1205L66.606 43.1205L66.606 39.2927Z' fill='%23CDF4F7'/%3e %3cpath d='M48.7432 35.4648H50.3928C50.6788 35.4648 50.962 35.5212 51.2263 35.6306C51.4905 35.7401 51.7306 35.9005 51.9329 36.1028C52.1351 36.3051 52.3752 36.4655 52.6395 36.575C52.9037 36.6844 53.187 36.7408 53.473 36.7408H53.8467C54.1851 36.7408 54.5096 36.8752 54.7489 37.1145C54.9881 37.3537 55.1226 37.6783 55.1226 38.0167C55.1226 38.3551 54.9881 38.6796 54.7489 38.9189C54.5096 39.1582 54.1851 39.2926 53.8467 39.2926H48.7432V35.4648Z' fill='%23CDF4F7'/%3e %3cpath d='M60.8619 48.2241L56.7153 40.5232C56.6189 40.3441 56.4757 40.1944 56.3011 40.0901C56.1264 39.9857 55.9268 39.9307 55.7234 39.9307C55.5379 39.9307 55.3553 39.9765 55.1918 40.064C55.0282 40.1515 54.8889 40.278 54.786 40.4324L48.7686 48.2241H51.2928L60.8619 48.2241Z' fill='%23ACCD2A'/%3e %3cpath d='M51.3164 56.5791H53.8646V58.2779H51.3164V56.5791Z' fill='%23FFDDE6'/%3e %3cpath d='M55.564 56.5791H60.6604V58.2779H55.564V56.5791Z' fill='%23FFDDE6'/%3e %3cpath d='M62.3589 56.5791H66.6059V58.2779H62.3589V56.5791Z' fill='%23FFDDE6'/%3e %3cpath d='M48.7686 59.9768H56.4132V61.6756H48.7686V59.9768Z' fill='%23FFDDE6'/%3e %3cpath d='M58.1118 59.9768H63.2082V61.6756H58.1118V59.9768Z' fill='%23FFDDE6'/%3e %3cpath d='M64.9072 59.9768H66.606V61.6756H64.9072V59.9768Z' fill='%23FFDDE6'/%3e %3cpath d='M48.7686 63.3743H51.3168V65.0731H48.7686V63.3743Z' fill='%23FFDDE6'/%3e %3cpath d='M53.0156 63.3743H59.8108V65.0731H53.0156V63.3743Z' fill='%23FFDDE6'/%3e %3cpath d='M61.5098 63.3743H66.6062V65.0731H61.5098V63.3743Z' fill='%23FFDDE6'/%3e %3cpath d='M96 49.5H114.75L89.75 24.5V43.25C89.75 46.6875 92.5625 49.5 96 49.5Z' fill='%23D84D71'/%3e %3cg style='mix-blend-mode:multiply'%3e %3cpath d='M114.75 68.25L96 49.5H114.75V68.25Z' fill='%23FFBECF'/%3e %3c/g%3e %3cpath d='M102.25 105.75C102.25 107.469 100.844 108.875 99.125 108.875H30.375C28.6562 108.875 27.25 107.469 27.25 105.75V74.5C27.25 72.7812 28.6562 71.375 30.375 71.375H99.125C100.844 71.375 102.25 72.7812 102.25 74.5V105.75Z' fill='%23FFF3F3'/%3e %3cpath d='M40.8721 83.7094C40.8721 82.8844 41.5221 81.9844 42.5689 81.9844H48.3408C51.5908 81.9844 54.5158 84.1594 54.5158 88.3281C54.5158 92.2781 51.5908 94.4781 48.3408 94.4781H44.1689V97.7781C44.1689 98.8781 43.4689 99.5 42.5689 99.5C41.7439 99.5 40.8721 98.8781 40.8721 97.7781V83.7094ZM44.1689 85.1313V91.3562H48.3408C50.0158 91.3562 51.3408 89.8781 51.3408 88.3281C51.3408 86.5812 50.0158 85.1313 48.3408 85.1313H44.1689Z' fill='%23ED154E'/%3e %3cpath d='M59.4096 99.4999C58.5846 99.4999 57.6846 99.0499 57.6846 97.953V83.7592C57.6846 82.8624 58.5846 82.2092 59.4096 82.2092H65.1314C76.5502 82.2092 76.3002 99.4999 65.3564 99.4999H59.4096ZM60.9846 85.2592V96.453H65.1314C71.8783 96.453 72.1783 85.2592 65.1314 85.2592H60.9846Z' fill='%23ED154E'/%3e %3cpath d='M80.3503 85.4594V89.4313H86.7222C87.6222 89.4313 88.5222 90.3313 88.5222 91.2032C88.5222 92.0282 87.6222 92.7032 86.7222 92.7032H80.3503V97.95C80.3503 98.825 79.7284 99.4969 78.8534 99.4969C77.7534 99.4969 77.0815 98.825 77.0815 97.95V83.7563C77.0815 82.8594 77.7565 82.2063 78.8534 82.2063H87.6253C88.7253 82.2063 89.3753 82.8594 89.3753 83.7563C89.3753 84.5563 88.7253 85.4563 87.6253 85.4563H80.3503V85.4594Z' fill='%23ED154E'/%3e %3cg style='mix-blend-mode:multiply'%3e %3cpath d='M99.125 108.875H39.75V112H99.125C100.844 112 102.25 110.594 102.25 108.875V105.75C102.25 107.469 100.844 108.875 99.125 108.875Z' fill='%23FFBECF'/%3e %3c/g%3e %3c/g%3e %3cdefs%3e %3cclipPath id='clip0'%3e %3crect width='100' height='100' fill='white' transform='translate(21 24.5)'/%3e %3c/clipPath%3e %3c/defs%3e %3c/svg%3e";
var img$e = "data:image/svg+xml,%3csvg width='151' height='151' viewBox='0 0 151 151' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect x='24.8809' y='22.6309' width='100.604' height='103.08' rx='50.3021' fill='%23FFDDE6'/%3e %3crect x='33.0107' y='30.9607' width='84.3449' height='86.4208' rx='42.1724' fill='%23ED154E'/%3e %3cpath d='M140.675 94.2283C141.709 94.3392 142.46 95.2895 142.352 96.349C142.244 97.4086 141.316 98.1789 140.282 98.068C139.248 97.9571 138.496 97.0068 138.605 95.9472C138.713 94.8876 139.64 94.1174 140.675 94.2283Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.6171'/%3e %3cpath d='M36.2277 133.33C37.9282 133.512 39.1645 135.075 38.9865 136.817C38.8085 138.56 37.2833 139.826 35.5828 139.644C33.8822 139.462 32.646 137.899 32.824 136.157C33.002 134.414 34.5272 133.148 36.2277 133.33Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='2.65921'/%3e %3cpath d='M74.1603 3.44661C75.8609 3.62896 77.0971 5.1917 76.9191 6.93409C76.7411 8.67647 75.2159 9.9431 73.5154 9.76075C71.8149 9.5784 70.5787 8.01566 70.7566 6.27328C70.9346 4.53089 72.4598 3.26426 74.1603 3.44661Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='2.65921'/%3e %3cpath d='M2.41535 44.7844C3.19648 44.7844 3.8307 45.4343 3.8307 46.2346C3.8307 47.035 3.19648 47.6848 2.41535 47.6848C1.63422 47.6848 1 47.035 1 46.2346C1 45.4343 1.63422 44.7844 2.41535 44.7844Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.94378'/%3e %3cpath d='M112.344 139.354C113.125 139.354 113.759 140.004 113.759 140.804C113.759 141.605 113.125 142.255 112.344 142.255C111.563 142.255 110.929 141.605 110.929 140.804C110.929 140.004 111.563 139.354 112.344 139.354Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.94378'/%3e %3cpath d='M133.697 38.9111L135.36 33.3452' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M131.902 35.3164L137.335 37.0197' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M8.13086 98.0129L9.59717 92.3895' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M6.21094 94.4871L11.6993 95.9895' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M126.218 123.195L127.382 117.497' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M124.111 119.781L129.672 120.975' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M46.0449 128.464C43.2835 128.464 41.0449 126.226 41.0449 123.464L41.0449 24.7144C41.0449 21.9529 43.2835 19.7144 46.0449 19.7144L103.545 19.7144C106.306 19.7144 108.545 21.9529 108.545 24.7144L108.545 123.464C108.545 126.226 106.306 128.464 103.545 128.464L46.0449 128.464Z' fill='%23D52B57'/%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M106.85 127.266L41.7646 22.2245C42.6277 20.7244 44.2467 19.7144 46.1016 19.7144L103.602 19.7144C106.363 19.7144 108.602 21.9529 108.602 24.7144V123.464C108.602 124.986 107.922 126.349 106.85 127.266Z' fill='%23E43F6B'/%3e %3cpath d='M41.0449 87.6831L41.0449 83.9331L46.6699 83.9331L46.6699 87.6831L41.0449 87.6831Z' fill='%23FFDDE6'/%3e %3cpath d='M102.92 87.6831L102.92 83.9331L108.545 83.9331L108.545 87.6831L102.92 87.6831Z' fill='%23FFDDE6'/%3e %3cpath d='M50.4199 87.6831L50.4199 83.9331L54.1699 83.9331L54.1699 87.6831L50.4199 87.6831Z' fill='%23FFDDE6'/%3e %3cpath d='M57.9199 87.6831L57.9199 83.9331L61.6699 83.9331L61.6699 87.6831L57.9199 87.6831Z' fill='%23FFDDE6'/%3e %3cpath d='M65.4199 87.6831L65.4199 83.9331L69.1699 83.9331L69.1699 87.6831L65.4199 87.6831Z' fill='%23FFDDE6'/%3e %3cpath d='M72.9199 87.6831L72.9199 83.9331L76.6699 83.9331L76.6699 87.6831L72.9199 87.6831Z' fill='%23FFDDE6'/%3e %3cpath d='M80.4199 87.6831L80.4199 83.9331L84.1699 83.9331L84.1699 87.6831L80.4199 87.6831Z' fill='%23FFDDE6'/%3e %3cpath d='M87.9199 87.6831L87.9199 83.9331L91.6699 83.9331L91.6699 87.6831L87.9199 87.6831Z' fill='%23FFDDE6'/%3e %3cpath d='M95.4199 87.6831L95.4199 83.9331L99.1699 83.9331L99.1699 87.6831L95.4199 87.6831Z' fill='%23FFDDE6'/%3e %3cpath d='M48.5449 70.3394L48.5449 32.8394L101.043 32.8393L101.043 70.3394L48.5449 70.3394Z' fill='white'/%3e %3cpath d='M101.045 61.2813L88.8349 41.8768C88.5536 41.4079 88.1556 41.0198 87.6798 40.7504C87.204 40.481 86.6665 40.3394 86.1197 40.3394C85.5316 40.3394 84.9551 40.5031 84.4549 40.8123C83.9547 41.1215 83.5504 41.5638 83.2874 42.0898L69.1631 70.3394L101.045 70.3394L101.045 61.2813Z' fill='%239CC221'/%3e %3cpath d='M101.045 44.0894L96.1967 44.0894C95.3561 44.0894 94.5236 44.2549 93.747 44.5767C92.9703 44.8984 92.2646 45.3699 91.6702 45.9644C91.0758 46.5588 90.3701 47.0303 89.5934 47.3521C88.8168 47.6738 87.9844 47.8394 87.1437 47.8394L86.0454 47.8394C85.0509 47.8394 84.0971 48.2344 83.3938 48.9377C82.6906 49.641 82.2955 50.5948 82.2955 51.5894C82.2955 52.5839 82.6906 53.5378 83.3938 54.241C84.0971 54.9443 85.0509 55.3394 86.0454 55.3394L101.045 55.3394L101.045 44.0894Z' fill='%23CDF4F7'/%3e %3cpath d='M48.5455 32.8394H53.3937C54.2344 32.8394 55.0668 33.0049 55.8434 33.3267C56.6201 33.6484 57.3258 34.1199 57.9202 34.7144C58.5146 35.3088 59.2203 35.7803 59.997 36.1021C60.7736 36.4238 61.6061 36.5894 62.4467 36.5894H63.545C64.5396 36.5894 65.4934 36.9844 66.1966 37.6877C66.8998 38.391 67.2949 39.3448 67.2949 40.3394C67.2949 41.3339 66.8998 42.2877 66.1966 42.991C65.4934 43.6943 64.5396 44.0894 63.545 44.0894H48.5455V32.8394Z' fill='%23CDF4F7'/%3e %3cpath d='M84.1632 70.3394L71.9763 47.7058C71.6928 47.1793 71.2721 46.7395 70.7588 46.4329C70.2455 46.1263 69.6587 45.9644 69.0608 45.9644C68.5157 45.9644 67.979 46.0989 67.4984 46.3562C67.0178 46.6134 66.6081 46.9853 66.3057 47.4389L48.6201 70.3394L56.0391 70.3394L84.1632 70.3394Z' fill='%23ACCD2A'/%3e %3cpath d='M56.1084 94.896H63.5978V99.8889H56.1084V94.896Z' fill='%23FFDDE6'/%3e %3cpath d='M68.5908 94.896H83.5696V99.8889H68.5908V94.896Z' fill='%23FFDDE6'/%3e %3cpath d='M88.5625 94.896H101.045V99.8889H88.5625V94.896Z' fill='%23FFDDE6'/%3e %3cpath d='M48.6191 104.882H71.0873V109.875H48.6191V104.882Z' fill='%23FFDDE6'/%3e %3cpath d='M76.0801 104.882H91.0588V109.875H76.0801V104.882Z' fill='%23FFDDE6'/%3e %3cpath d='M96.0518 104.882H101.045V109.875H96.0518V104.882Z' fill='%23FFDDE6'/%3e %3cpath d='M48.6191 114.868H56.1085V119.861H48.6191V114.868Z' fill='%23FFDDE6'/%3e %3cpath d='M61.1016 114.868H81.0732V119.861H61.1016V114.868Z' fill='%23FFDDE6'/%3e %3cpath d='M86.0664 114.868H101.045V119.861H86.0664V114.868Z' fill='%23FFDDE6'/%3e %3crect x='75.5918' y='90.6897' width='54.0803' height='54.0803' rx='3.91886' fill='white'/%3e %3cpath d='M78.22 103.548C77.7349 103.548 77.3418 103.941 77.3418 104.426V140.922C77.3418 142.079 78.2832 143.02 79.4402 143.02H125.825C126.982 143.02 127.923 142.079 127.923 140.922V94.5372C127.923 93.3801 126.982 92.4387 125.825 92.4387H79.4402C78.2832 92.4387 77.3418 93.3801 77.3418 94.5372V100.913C77.3418 101.399 77.7349 101.792 78.22 101.792C78.705 101.792 79.0981 101.399 79.0981 100.913V94.5372C79.0981 94.3485 79.2516 94.195 79.4402 94.195H97.8487V96.5368H83.0047C82.1419 96.5368 81.4398 97.2388 81.4398 98.1018V137.357C81.4398 138.22 82.1419 138.922 83.0047 138.922H97.8486V141.264H79.4402C79.2516 141.264 79.0981 141.111 79.0981 140.922V104.426C79.0981 103.941 78.705 103.548 78.22 103.548ZM126.167 94.5372V140.922C126.167 141.111 126.014 141.264 125.825 141.264H107.417V138.922H122.26C123.123 138.922 123.825 138.22 123.825 137.357V98.1018C123.825 97.2388 123.123 96.5368 122.26 96.5368H107.417V94.195H125.825C126.014 94.195 126.167 94.3485 126.167 94.5372ZM99.605 94.195H105.661V96.5368H99.605V94.195ZM83.1962 137.166V98.2931H97.8487V100.557C97.8487 101.042 98.2417 101.435 98.7268 101.435C99.2119 101.435 99.605 101.042 99.605 100.557V98.2931H105.661V100.557C105.661 101.042 106.054 101.435 106.539 101.435C107.024 101.435 107.417 101.042 107.417 100.557V98.2931H122.069V137.166H107.417V134.902C107.417 134.417 107.024 134.024 106.539 134.024C106.054 134.024 105.66 134.417 105.66 134.902V137.166H99.6049V134.902C99.6049 134.417 99.2118 134.024 98.7267 134.024C98.2416 134.024 97.8486 134.417 97.8486 134.902V137.166H83.1962ZM99.605 138.922H105.661V141.264H99.605V138.922Z' fill='%23DF2053' stroke='%23DF2053' stroke-width='0.694854'/%3e %3cpath d='M96.6764 123.751L98.61 129.778L100.538 123.751H103.286V132.414H101.192V130.391L101.394 126.25L99.3002 132.414H97.9199L95.8196 126.244L96.0219 130.391V132.414H93.9336V123.751H96.6764Z' fill='%23FF3B70'/%3e %3cpath d='M104.619 132.414V123.751H107.731C108.845 123.751 109.692 123.956 110.271 124.364C110.854 124.773 111.146 125.366 111.146 126.143C111.146 126.591 111.043 126.974 110.837 127.292C110.63 127.609 110.327 127.843 109.926 127.994C110.379 128.113 110.726 128.335 110.968 128.66C111.209 128.985 111.33 129.382 111.33 129.85C111.33 130.699 111.061 131.337 110.521 131.766C109.986 132.19 109.191 132.406 108.135 132.414H104.619ZM106.708 128.731V130.808H108.076C108.453 130.808 108.742 130.723 108.945 130.552C109.147 130.377 109.248 130.133 109.248 129.82C109.248 129.098 108.889 128.735 108.171 128.731H106.708ZM106.708 127.363H107.796C108.252 127.359 108.578 127.276 108.772 127.113C108.966 126.95 109.064 126.71 109.064 126.393C109.064 126.028 108.959 125.766 108.748 125.608C108.538 125.445 108.199 125.364 107.731 125.364H106.708V127.363Z' fill='%23FF3B70'/%3e %3cpath d='M97.1492 121.312H93.0465V108.252L89.0166 109.429V106.322L96.7729 103.639H97.1492V121.312Z' fill='%23FF3B70'/%3e %3cpath d='M114.75 114.09C114.75 116.477 114.211 118.318 113.135 119.613C112.067 120.908 110.558 121.555 108.608 121.555C106.641 121.555 105.12 120.904 104.044 119.601C102.967 118.298 102.429 116.461 102.429 114.09V110.861C102.429 108.474 102.963 106.633 104.032 105.339C105.108 104.044 106.625 103.396 108.583 103.396C110.542 103.396 112.059 104.048 113.135 105.351C114.211 106.654 114.75 108.495 114.75 110.874V114.09ZM110.659 110.34C110.659 109.069 110.493 108.122 110.161 107.499C109.83 106.868 109.304 106.552 108.583 106.552C107.879 106.552 107.365 106.844 107.042 107.426C106.726 108.009 106.556 108.891 106.532 110.072V114.588C106.532 115.907 106.698 116.874 107.03 117.489C107.361 118.096 107.887 118.399 108.608 118.399C109.304 118.399 109.817 118.104 110.149 117.513C110.481 116.914 110.651 115.98 110.659 114.709V110.34Z' fill='%23FF3B70'/%3e %3c/svg%3e";
var img$f = "data:image/svg+xml,%3csvg width='151' height='151' viewBox='0 0 151 151' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect x='24.8809' y='22.6309' width='100.604' height='103.08' rx='50.3021' fill='%23FFDDE6'/%3e %3crect x='33.0107' y='30.9607' width='84.3449' height='86.4208' rx='42.1724' fill='%23ED154E'/%3e %3cpath d='M140.675 94.2283C141.709 94.3392 142.46 95.2895 142.352 96.349C142.244 97.4086 141.316 98.1789 140.282 98.068C139.248 97.9571 138.496 97.0068 138.605 95.9472C138.713 94.8876 139.64 94.1174 140.675 94.2283Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.6171'/%3e %3cpath d='M36.2277 133.33C37.9282 133.512 39.1645 135.075 38.9865 136.817C38.8085 138.56 37.2833 139.826 35.5828 139.644C33.8822 139.462 32.646 137.899 32.824 136.157C33.002 134.414 34.5272 133.148 36.2277 133.33Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='2.65921'/%3e %3cpath d='M74.1603 3.44661C75.8609 3.62896 77.0971 5.1917 76.9191 6.93409C76.7411 8.67647 75.2159 9.9431 73.5154 9.76075C71.8149 9.5784 70.5787 8.01566 70.7566 6.27328C70.9346 4.53089 72.4598 3.26426 74.1603 3.44661Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='2.65921'/%3e %3cpath d='M2.41535 44.7844C3.19648 44.7844 3.8307 45.4343 3.8307 46.2346C3.8307 47.035 3.19648 47.6848 2.41535 47.6848C1.63422 47.6848 1 47.035 1 46.2346C1 45.4343 1.63422 44.7844 2.41535 44.7844Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.94378'/%3e %3cpath d='M112.344 139.354C113.125 139.354 113.759 140.004 113.759 140.804C113.759 141.605 113.125 142.255 112.344 142.255C111.563 142.255 110.929 141.605 110.929 140.804C110.929 140.004 111.563 139.354 112.344 139.354Z' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.94378'/%3e %3cpath d='M133.697 38.9111L135.36 33.3452' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M131.902 35.3164L137.335 37.0197' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M8.13086 98.0129L9.59717 92.3895' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M6.21094 94.4871L11.6993 95.9895' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M126.218 123.195L127.382 117.497' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cpath d='M124.111 119.781L129.672 120.975' stroke='%23151515' stroke-opacity='0.2' stroke-width='1.13254'/%3e %3cg clip-path='url(%23clip0)'%3e %3cpath d='M118.154 67.4058V99.02L105.393 80.8062C104.975 80.2102 104.292 80.2102 103.874 80.8062L92.9905 96.3396L73.7759 68.9157C73.3581 68.3195 72.6744 68.3195 72.2566 68.9157L52.9937 96.4086L42.0622 80.8064C41.6443 80.2105 40.9607 80.2105 40.5428 80.8064L27.6 99.2791V50.7479C27.6 50.0185 28.194 49.4221 28.92 49.4221H94.3096C94.3792 47.0766 94.8852 44.8397 95.7562 42.7937H22.32C21.594 42.7937 21 43.3905 21 44.1195V110.668C21 111.397 21.594 111.994 22.32 111.994H123.434C124.16 111.994 124.755 111.397 124.755 110.668V63.5721C122.869 65.2823 120.626 66.601 118.154 67.4058Z' fill='%23D42B57'/%3e %3cpath d='M112.541 68.2972C102.481 68.2972 94.2965 60.0773 94.2965 49.9736C94.2965 49.7886 94.3051 49.6056 94.3104 49.4221H28.9206C28.1946 49.4221 27.6006 50.0185 27.6006 50.7479V99.2792L40.5434 80.8065C40.9613 80.2105 41.6449 80.2105 42.0628 80.8065L52.9943 96.4086L72.2571 68.9157C72.6748 68.3196 73.3587 68.3196 73.7765 68.9157L92.9911 96.3397L103.874 80.8063C104.292 80.2103 104.976 80.2103 105.394 80.8063L118.155 99.0201V67.4058C116.385 67.982 114.499 68.2972 112.541 68.2972Z' fill='%23E43F6B'/%3e %3cpath d='M112.54 68.2974C102.48 68.2974 94.2959 60.0774 94.2959 49.9738C94.2959 39.8703 102.48 31.6504 112.54 31.6504C122.6 31.6504 130.785 39.8703 130.785 49.9738C130.785 60.0774 122.6 68.2974 112.54 68.2974Z' fill='%230592FB'/%3e %3cpath d='M105.394 80.5117C104.976 79.9157 104.292 79.9157 103.874 80.5117L92.832 96.2715L99.2037 105.365H116.835C117.561 105.365 118.155 104.769 118.155 104.039V98.7257L105.394 80.5117Z' fill='%23FC85A5'/%3e %3cpath d='M96.3224 101.253L108.124 84.4092L105.394 80.5117C104.976 79.9157 104.292 79.9157 103.874 80.5117L92.832 96.2715L96.3224 101.253Z' fill='%23FFB9CC'/%3e %3cpath d='M73.7759 68.6211C73.358 68.0251 72.6744 68.0251 72.2565 68.6211L52.877 96.2805L59.2421 105.365H99.5206L73.7759 68.6211Z' fill='%23FF9FB9'/%3e %3cpath d='M56.3331 101.213L76.4724 72.4698L73.7759 68.6211C73.358 68.0251 72.6744 68.0251 72.2565 68.6211L52.877 96.2805L56.3331 101.213Z' fill='%23FFBACC'/%3e %3cpath d='M42.0628 80.5117C41.6449 79.9157 40.9613 79.9157 40.5434 80.5117L27.6006 98.9846V104.039C27.6006 104.769 28.1946 105.365 28.9206 105.365H59.4761L42.0628 80.5117Z' fill='%23FC85A5'/%3e %3cpath d='M34.6077 104.039V98.9846L44.8066 84.4281L42.0628 80.5117C41.6449 79.9157 40.9613 79.9157 40.5434 80.5117L27.6006 98.9846V104.039C27.6006 104.769 28.1946 105.365 28.9206 105.365H35.9277C35.2018 105.365 34.6077 104.769 34.6077 104.039Z' fill='%23FFB9CC'/%3e %3cpath d='M112.54 68.5122C122.735 68.5122 131 60.2122 131 49.9737C131 39.7352 122.735 31.4353 112.54 31.4353C102.346 31.4353 94.0811 39.7352 94.0811 49.9737C94.0811 60.2122 102.346 68.5122 112.54 68.5122Z' fill='%23F4F4F4'/%3e %3cpath d='M101.01 49.9738C101.01 40.9254 107.467 33.3951 116.005 31.7662C114.882 31.5522 113.725 31.4355 112.54 31.4355C102.346 31.4355 94.0811 39.7356 94.0811 49.9738C94.0811 60.2124 102.346 68.5122 112.54 68.5122C113.725 68.5122 114.882 68.3953 116.005 68.1816C107.467 66.5524 101.01 59.0226 101.01 49.9738Z' fill='%23F9F9F9'/%3e %3cpath d='M110.437 61.4827C109.948 61.4827 109.552 61.0863 109.552 60.5975V48.6864H105.387C105.038 48.6864 104.722 48.4812 104.579 48.1626C104.437 47.8444 104.494 47.4719 104.727 47.2111L111.879 39.2038C112.047 39.0158 112.287 38.9082 112.54 38.9082C112.792 38.9082 113.032 39.0158 113.2 39.2038L120.352 47.2111C120.585 47.4719 120.642 47.8444 120.5 48.1626C120.357 48.4812 120.041 48.6864 119.692 48.6864H115.527V60.5975C115.527 61.0863 115.131 61.4827 114.642 61.4827H110.437Z' fill='%23FF497A'/%3e %3cpath d='M44.8062 65.9696V63.3608C47.5676 63.3608 49.7111 60.6222 48.6508 57.7159C48.2617 56.6479 47.3998 55.786 46.3242 55.3969C43.4179 54.3442 40.6793 56.4801 40.6793 59.2415H38.0781C38.0781 54.8401 42.3347 51.4074 46.9497 52.8491C48.9635 53.4822 50.5731 55.0842 51.1986 57.098C52.6403 61.7131 49.2076 65.9696 44.8062 65.9696Z' fill='white'/%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M44.8141 63.3759H42.2129V60.7747H44.8141V63.3759Z' fill='white'/%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M42.2126 65.3669H40.2217V63.376H42.2126V65.3669Z' fill='white'/%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M40.2223 63.3761H38.5518V61.7056H40.2223V63.3761Z' fill='white'/%3e %3cpath d='M33.6842 68.609C33.3486 68.3725 32.9214 68.2581 32.4332 68.2581H31.3652V71.6526H32.4408C32.929 71.6526 33.3562 71.5306 33.6918 71.2788C33.8749 71.1491 34.0198 70.9661 34.1266 70.7372C34.2258 70.5084 34.2792 70.2338 34.2792 69.9363C34.2792 69.6388 34.2258 69.3718 34.1266 69.1429C34.0198 68.9141 33.8749 68.731 33.6842 68.609ZM31.9907 68.8302H32.3264C32.7002 68.8302 33.0053 68.9065 33.2418 69.0514C33.5011 69.2116 33.6308 69.5091 33.6308 69.9363C33.6308 70.3787 33.5011 70.6915 33.2418 70.8593C33.0206 71.0042 32.7154 71.0805 32.334 71.0805H31.9907V68.8302Z' fill='white'/%3e %3cpath d='M35.0193 68.2122C34.9125 68.2122 34.8286 68.2503 34.7523 68.319C34.6836 68.3876 34.6455 68.4715 34.6455 68.5783C34.6455 68.6851 34.6836 68.769 34.7523 68.8453C34.821 68.914 34.9125 68.9521 35.0193 68.9521C35.1185 68.9521 35.21 68.914 35.2863 68.8453C35.3549 68.7766 35.3931 68.6851 35.3931 68.5783C35.3931 68.4715 35.3549 68.3876 35.2863 68.319C35.21 68.2503 35.1185 68.2122 35.0193 68.2122Z' fill='white'/%3e %3cpath d='M35.3165 69.2573H34.7139V71.6526H35.3165V69.2573Z' fill='white'/%3e %3cpath d='M37.5055 69.4556C37.3224 69.2955 37.1241 69.1963 36.9028 69.1963C36.5672 69.1963 36.2926 69.3107 36.079 69.5396C35.8654 69.7608 35.751 70.0506 35.751 70.4015C35.751 70.7372 35.8578 71.0271 36.0714 71.2559C36.285 71.4771 36.5672 71.5915 36.8952 71.5915C37.1241 71.5915 37.33 71.5305 37.4902 71.4008V71.4542C37.4902 71.6526 37.4368 71.8051 37.33 71.9119C37.2232 72.0187 37.0783 72.0721 36.8952 72.0721C36.6206 72.0721 36.4451 71.9653 36.2316 71.6755L35.8196 72.0721L35.8273 72.0874C35.9188 72.2094 36.0485 72.3315 36.2316 72.4459C36.407 72.5603 36.6358 72.6214 36.9028 72.6214C37.2614 72.6214 37.5512 72.5146 37.7648 72.2933C37.9784 72.0721 38.0852 71.7823 38.0852 71.4237V69.2497H37.4902V69.4556H37.5055ZM37.3453 70.8745C37.2385 70.9965 37.1012 71.0499 36.9333 71.0499C36.7579 71.0499 36.6282 70.9889 36.5214 70.8745C36.4146 70.7524 36.3689 70.5999 36.3689 70.4092C36.3689 70.2108 36.4223 70.0583 36.5214 69.9362C36.6206 69.8142 36.7655 69.7608 36.9333 69.7608C37.1088 69.7608 37.2385 69.8218 37.3453 69.9362C37.4521 70.0583 37.5055 70.2185 37.5055 70.4092C37.5055 70.5999 37.4521 70.7524 37.3453 70.8745Z' fill='white'/%3e %3cpath d='M39.2149 69.2573H38.6123V71.6526H39.2149V69.2573Z' fill='white'/%3e %3cpath d='M38.9168 68.2122C38.81 68.2122 38.726 68.2503 38.6498 68.319C38.5811 68.3876 38.543 68.4715 38.543 68.5783C38.543 68.6851 38.5811 68.769 38.6498 68.8453C38.7184 68.914 38.81 68.9521 38.9168 68.9521C39.0159 68.9521 39.1075 68.914 39.1837 68.8453C39.2524 68.7766 39.2905 68.6851 39.2905 68.5783C39.2905 68.4715 39.2524 68.3876 39.1837 68.319C39.1075 68.2503 39.0235 68.2122 38.9168 68.2122Z' fill='white'/%3e %3cpath d='M40.5349 68.6089H39.9399V69.2573H39.5967V69.8065H39.9399V70.7982C39.9399 71.1109 40.001 71.3322 40.123 71.4618C40.2451 71.5915 40.4663 71.6525 40.7714 71.6525C40.8706 71.6525 40.9698 71.6525 41.0613 71.6449H41.0918V71.0957L40.8858 71.1033C40.7409 71.1033 40.6494 71.0804 40.6036 71.027C40.5578 70.9736 40.5349 70.8668 40.5349 70.7066V69.7989H41.0994V69.2497H40.5349V68.6089Z' fill='white'/%3e %3cpath d='M44.5235 68.2505H43.9209V71.6527H44.5235V68.2505Z' fill='white'/%3e %3cpath d='M50.6109 70.7983C50.5041 70.9204 50.3896 71.0272 50.3057 71.0806C50.2218 71.134 50.115 71.1645 49.993 71.1645C49.8175 71.1645 49.6726 71.1035 49.5582 70.9662C49.4437 70.8365 49.3827 70.661 49.3827 70.4627C49.3827 70.2567 49.4437 70.0889 49.5582 69.9592C49.6726 69.8296 49.8175 69.7609 49.993 69.7609C50.1837 69.7609 50.3896 69.883 50.5651 70.0889L50.9617 69.7075C50.7024 69.3719 50.3744 69.2117 49.9777 69.2117C49.6497 69.2117 49.3598 69.3337 49.1234 69.5702C48.8869 69.8067 48.7725 70.1042 48.7725 70.4627C48.7725 70.8212 48.8945 71.1187 49.1234 71.3552C49.3598 71.5917 49.6421 71.7137 49.9777 71.7137C50.4125 71.7137 50.7634 71.523 51.0075 71.1797L50.6109 70.7983Z' fill='white'/%3e %3cpath d='M53.0903 69.5929C53.0064 69.4708 52.892 69.3793 52.7471 69.3107C52.6021 69.242 52.4343 69.2039 52.2512 69.2039C51.9156 69.2039 51.641 69.3259 51.435 69.57C51.2367 69.8141 51.1299 70.1116 51.1299 70.4701C51.1299 70.8363 51.2443 71.1338 51.4579 71.3626C51.6791 71.5915 51.969 71.7059 52.3275 71.7059C52.7318 71.7059 53.0674 71.5381 53.3192 71.2177L53.3344 71.2024L52.9378 70.821C52.8996 70.8668 52.8462 70.9126 52.8005 70.9583C52.7394 71.0117 52.686 71.0575 52.625 71.088C52.5335 71.1338 52.4343 71.1567 52.3199 71.1567C52.1521 71.1567 52.0148 71.1109 51.908 71.0117C51.8088 70.9202 51.7478 70.7981 51.7325 70.6456H53.3268L53.3344 70.4244C53.3344 70.2718 53.3115 70.1192 53.2734 69.9819C53.2353 69.8446 53.1742 69.7149 53.0903 69.5929ZM51.7706 70.1574C51.8012 70.043 51.8546 69.9438 51.9308 69.8751C52.0148 69.7912 52.1215 69.7531 52.2436 69.7531C52.3885 69.7531 52.503 69.7912 52.5792 69.8751C52.6479 69.9514 52.6937 70.043 52.7013 70.1574H51.7706Z' fill='white'/%3e %3cpath d='M55.4019 69.4403C55.2189 69.2878 54.9671 69.2039 54.6544 69.2039C54.4561 69.2039 54.2653 69.2496 54.0975 69.3335C53.9373 69.4098 53.7848 69.5471 53.6856 69.7149L53.6932 69.7226L54.0823 70.0887C54.2425 69.837 54.4179 69.7455 54.6544 69.7455C54.7841 69.7455 54.8832 69.776 54.9671 69.8446C55.0434 69.9133 55.0892 69.9972 55.0892 70.104V70.2184C54.9366 70.1726 54.7917 70.1497 54.6468 70.1497C54.3493 70.1497 54.1052 70.2184 53.9221 70.3557C53.739 70.493 53.6475 70.699 53.6475 70.9583C53.6475 71.1872 53.7237 71.3626 53.8839 71.4999C54.0441 71.6296 54.2348 71.6983 54.4637 71.6983C54.6925 71.6983 54.9061 71.6067 55.1044 71.4465V71.6449H55.6994V70.104C55.6766 69.8217 55.585 69.5929 55.4019 69.4403ZM54.334 70.7371C54.4027 70.6914 54.5018 70.6685 54.6239 70.6685C54.7688 70.6685 54.9214 70.699 55.0816 70.7524V70.9888C54.9519 71.1109 54.7764 71.1719 54.5628 71.1719C54.456 71.1719 54.3798 71.149 54.3187 71.1033C54.2653 71.0575 54.2348 71.0041 54.2348 70.9278C54.2348 70.8439 54.2653 70.7829 54.334 70.7371Z' fill='white'/%3e %3cpath d='M57.9949 69.4861C57.8271 69.2954 57.5906 69.2039 57.2931 69.2039C57.0566 69.2039 56.8583 69.2725 56.7133 69.4098V69.2649H56.126V71.6525H56.7286V70.3328C56.7286 70.1498 56.7744 70.0048 56.8583 69.9057C56.9422 69.8065 57.0566 69.7531 57.2168 69.7531C57.3541 69.7531 57.4533 69.7989 57.5296 69.8904C57.6058 69.9819 57.644 70.1116 57.644 70.2642V71.6525H58.2466V70.2642C58.2466 69.9362 58.1627 69.6692 57.9949 69.4861Z' fill='white'/%3e %3cpath d='M43.1666 69.4403C42.9835 69.2878 42.7318 69.2039 42.419 69.2039C42.2207 69.2039 42.03 69.2496 41.8622 69.3335C41.702 69.4098 41.5494 69.5471 41.4503 69.7149L41.4579 69.7226L41.8469 70.0887C42.0071 69.837 42.1826 69.7455 42.419 69.7455C42.5487 69.7455 42.6479 69.776 42.7318 69.8446C42.8081 69.9133 42.8538 69.9972 42.8538 70.104V70.2184C42.7013 70.1726 42.5563 70.1497 42.4114 70.1497C42.1139 70.1497 41.8698 70.2184 41.6867 70.3557C41.5036 70.493 41.4121 70.699 41.4121 70.9583C41.4121 71.1872 41.4884 71.3626 41.6486 71.4999C41.8088 71.6296 41.9995 71.6983 42.2283 71.6983C42.4572 71.6983 42.6708 71.6067 42.8691 71.4465V71.6449H43.4641V70.104C43.4412 69.8217 43.3497 69.5929 43.1666 69.4403ZM42.0986 70.7371C42.1673 70.6914 42.2665 70.6685 42.3885 70.6685C42.5335 70.6685 42.686 70.699 42.8462 70.7524V70.9888C42.7165 71.1109 42.5411 71.1719 42.3275 71.1719C42.2207 71.1719 42.1444 71.149 42.0834 71.1033C42.03 71.0575 41.9995 71.0041 41.9995 70.9278C41.9995 70.8439 42.03 70.7829 42.0986 70.7371Z' fill='white'/%3e %3cpath d='M46.7135 71.706C45.7447 71.706 44.959 70.9203 44.959 69.9515C44.959 68.9827 45.7447 68.197 46.7135 68.197C47.6822 68.197 48.4679 68.9827 48.4679 69.9515C48.4679 70.9203 47.6822 71.706 46.7135 71.706ZM46.7135 68.8149C46.088 68.8149 45.5769 69.326 45.5769 69.9515C45.5769 70.577 46.088 71.0881 46.7135 71.0881C47.339 71.0881 47.8501 70.577 47.8501 69.9515C47.8501 69.326 47.339 68.8149 46.7135 68.8149Z' fill='white'/%3e %3c/g%3e %3cdefs%3e %3cclipPath id='clip0'%3e %3crect width='110' height='110' fill='white' transform='translate(21 16.7144)'/%3e %3c/clipPath%3e %3c/defs%3e %3c/svg%3e";
var ChecklistData = [{
  icon: img$5,
  iconAlt: 'Google drive review icon',
  title: 'Is there only one google Drive folder for the mailing number?',
  description: 'Perform the pre press review on both the press ready PDF and the full - size thumbnail PNGs that will be uploaded to Digital Ocean'
}, {
  icon: img$6,
  iconAlt: 'PDF only one review icon',
  title: 'Is there only one PDF named for the mailing number?',
  description: 'Make sure the PDF is named exactly like the mailing for example 01013-MVP-1.pdf. Make sure no other PDFs exist with the mailing number anywhere in Drive.'
}, {
  icon: img$7,
  iconAlt: 'Logistics id review icon',
  title: 'Does the postcard have the Logistics Id in the lower left corner on the address side?',
  description: 'Logistics Ids can be found on the MVP Campaign in Salesforce at the bottom of the page.'
}, {
  icon: img$8,
  iconAlt: 'Website review icon',
  title: 'Does the postcard have the correct website URL?'
}, {
  icon: img$9,
  iconAlt: 'Address review icon',
  title: 'Does the postcard have the correct physical address of the practice?'
}, {
  icon: img$a,
  iconAlt: 'Spelling review icon',
  title: 'Does the postcard use the correct spelling of the practice name and any doctor/staff names?'
}, {
  icon: img$b,
  iconAlt: 'Tracking number review icon',
  title: 'Does the postcard have the right tracking number?',
  // @todo template to display Tracking number
  description: "Also verify that the tracking number in Salesforce is US int'l format (+18019001464) and that the phone or SMS destination phone numbers are also US int'l format."
}, {
  icon: img$c,
  iconAlt: 'Tracking number tested review icon',
  title: 'Has the tracking number been tested?',
  description: 'Check the mailing in Salesforce.'
}, {
  icon: img$d,
  iconAlt: 'PDF high res review icon',
  title: '[PDF only] Does the postcard design have high res images?'
}, {
  icon: img$a,
  iconAlt: 'Spelling review icon',
  title: 'Does the postcard pass your proofread check for spelling and grammatical errors?',
  description: 'Proofread every word of the postcard before answering this question.'
}, {
  icon: img$a,
  iconAlt: 'Spelling review icon',
  title: 'Does the indicia say PERMIT #1073?',
  description: 'All designs must use the indicia that says PERMIT #1073. The indicia that says MVP MAILHOUSE is not to be used.'
}, {
  icon: img$e,
  iconAlt: 'PDF size review icon',
  title: '[PDF only] Is the exported PDF smaller than 10MB filesize?'
}, {
  icon: img$f,
  iconAlt: 'Digital upload review icon',
  title: 'Would you like us to upload the PNGs to Digital Ocean for you?',
  description: 'There used to be a question here asking if you uploaded the full- and thumb-size PNGs to Digital Ocean. Guess what! Now that will happen automatically after you submit a Pass inspection!'
}];

var composeReason = function composeReason(data) {
  var _data$checklists = data.checklists,
      checklists = _data$checklists === void 0 ? [] : _data$checklists,
      _data$failedIndexes = data.failedIndexes,
      failedIndexes = _data$failedIndexes === void 0 ? [] : _data$failedIndexes,
      additionalReason = data.additionalReason;
  var reviewerText = !!additionalReason ? "".concat(additionalReason, "\n\n") : '';
  var systemText = failedIndexes.map(function (i) {
    return "\n- ".concat(checklists[i].title);
  }).join('');
  return [reviewerText, '# Please check the following:', systemText].join('');
};

var usePrePressReview = function usePrePressReview(_ref86) {
  var handlers = _ref86.handlers,
      openModal = _ref86.openModal,
      closeModal = _ref86.closeModal;

  // ref
  var _useRef = useRef(ChecklistData),
      checklists = _useRef.current; // state


  var _useState89 = useState(PageVariant.Welcome),
      _useState90 = _slicedToArray(_useState89, 2),
      page = _useState90[0],
      setPage = _useState90[1];

  var _useState91 = useState(0),
      _useState92 = _slicedToArray(_useState91, 2),
      index = _useState92[0],
      setIndex = _useState92[1];

  var _useState93 = useState([]),
      _useState94 = _slicedToArray(_useState93, 2),
      failedIndexes = _useState94[0],
      setFailedIndexes = _useState94[1];

  var _useState95 = useState([]),
      _useState96 = _slicedToArray(_useState95, 2),
      doneIndexes = _useState96[0],
      setDoneIndexes = _useState96[1];

  var _useState97 = useState(false),
      _useState98 = _slicedToArray(_useState97, 2),
      isSubmitting = _useState98[0],
      setIsSubmitting = _useState98[1];

  var _useState99 = useState(false),
      _useState100 = _slicedToArray(_useState99, 2),
      hasError = _useState100[0],
      setHasError = _useState100[1];

  var _useState101 = useState(''),
      _useState102 = _slicedToArray(_useState101, 2),
      additionalReason = _useState102[0],
      setAdditionalReason = _useState102[1];

  var submit = useCallback(
  /*#__PURE__*/
  function () {
    var _ref88 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee18(_ref87) {
      var reason, _handlers$campaignMed, campaignMediaApprove, _handlers$campaignMed2, campaignMediaReject;

      return _regeneratorRuntime.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              reason = _ref87.reason;
              _handlers$campaignMed = handlers.campaignMediaApprove, campaignMediaApprove = _handlers$campaignMed === void 0 ?
              /*#__PURE__*/
              _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee16() {
                return _regeneratorRuntime.wrap(function _callee16$(_context16) {
                  while (1) {
                    switch (_context16.prev = _context16.next) {
                      case 0:
                      case "end":
                        return _context16.stop();
                    }
                  }
                }, _callee16);
              })) : _handlers$campaignMed, _handlers$campaignMed2 = handlers.campaignMediaReject, campaignMediaReject = _handlers$campaignMed2 === void 0 ?
              /*#__PURE__*/
              function () {
                var _ref90 = _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee17(_) {
                  return _regeneratorRuntime.wrap(function _callee17$(_context17) {
                    while (1) {
                      switch (_context17.prev = _context17.next) {
                        case 0:
                        case "end":
                          return _context17.stop();
                      }
                    }
                  }, _callee17);
                }));

                return function (_x4) {
                  return _ref90.apply(this, arguments);
                };
              }() : _handlers$campaignMed2;

              if (!reason) {
                _context18.next = 7;
                break;
              }

              _context18.next = 5;
              return campaignMediaReject(reason);

            case 5:
              _context18.next = 9;
              break;

            case 7:
              _context18.next = 9;
              return campaignMediaApprove();

            case 9:
              openModal({
                type: reason ? ModalTypes.CampaignMediaRejected : ModalTypes.CampaignMediaApproved
              });

            case 10:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18);
    }));

    return function (_x3) {
      return _ref88.apply(this, arguments);
    };
  }(), [handlers, openModal]);
  var handleNext = useCallback(_debounce(function (result) {
    if (page === PageVariant.Welcome) {
      setPage(PageVariant.Form);
      setIndex(doneIndexes.length);
      return;
    }

    setFailedIndexes(function (prev) {
      if (result === ChecklistResult.No) {
        !prev.includes(index) && prev.push(index);
      } else {
        var found = prev.findIndex(function (a) {
          return a === index;
        });
        found > -1 && prev.splice(found, 1);
      }

      return prev;
    });
    setDoneIndexes(function (prev) {
      !prev.includes(index) && prev.push(index);
      return prev;
    });
    var nextIndex = doneIndexes.length;
    setPage(function (prev) {
      setIndex(nextIndex);

      if (nextIndex === checklists.length) {
        return PageVariant.Submit;
      }

      return prev;
    });
  }, 300), [page, index, doneIndexes]);
  var handleBack = useCallback(function () {
    setIndex(function (index) {
      setPage(index === 0 ? PageVariant.Welcome : PageVariant.Form);
      return !index ? 0 : index - 1;
    });
  }, []);
  var handleSubmit = useCallback(
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee19() {
    var reason;
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            if (!isSubmitting) {
              _context19.next = 2;
              break;
            }

            return _context19.abrupt("return");

          case 2:
            setHasError(false);
            setIsSubmitting(true);
            _context19.prev = 4;
            reason = failedIndexes.length ? composeReason({
              additionalReason: additionalReason,
              checklists: checklists,
              failedIndexes: failedIndexes
            }) : undefined;
            _context19.next = 8;
            return submit({
              reason: reason
            });

          case 8:
            _context19.next = 14;
            break;

          case 10:
            _context19.prev = 10;
            _context19.t0 = _context19["catch"](4);
            console.error(_context19.t0);
            setHasError(true);

          case 14:
            setIsSubmitting(false);

          case 15:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19, null, [[4, 10]]);
  })), [isSubmitting, additionalReason, checklists, failedIndexes]);
  var handleCloseError = useCallback(function () {
    setHasError(false);
  }, []);
  var handleReasonChange = useCallback(function (value) {
    setAdditionalReason(value);
  }, []);
  var handleCloseModal = useCallback(function () {
    return closeModal();
  }, [closeModal]);
  return {
    page: page,
    checklists: checklists,
    currentIndex: index,
    failedIndexes: failedIndexes,
    doneIndexes: doneIndexes,
    isSubmitting: isSubmitting,
    hasError: hasError,
    additionalReason: additionalReason,
    setIndex: setIndex,
    handleNext: handleNext,
    handleBack: handleBack,
    handleSubmit: handleSubmit,
    handleCloseError: handleCloseError,
    handleReasonChange: handleReasonChange,
    handleCloseModal: handleCloseModal
  };
};

var ReviewCampaignMediaModal = function ReviewCampaignMediaModal(_ref92) {
  var open = _ref92.open;

  var _useContext103 = useContext(CampaignContext.CampaignMediaReview),
      prePressForm = _useContext103.prePressForm;

  var page = prePressForm.page,
      checklists = prePressForm.checklists,
      currentIndex = prePressForm.currentIndex,
      doneIndexes = prePressForm.doneIndexes,
      failedIndexes = prePressForm.failedIndexes,
      isSubmitting = prePressForm.isSubmitting,
      hasError = prePressForm.hasError,
      setIndex = prePressForm.setIndex,
      additionalReason = prePressForm.additionalReason,
      handleNext = prePressForm.handleNext,
      handleBack = prePressForm.handleBack,
      handleSubmit = prePressForm.handleSubmit,
      handleCloseError = prePressForm.handleCloseError,
      handleReasonChange = prePressForm.handleReasonChange,
      handleCloseModal = prePressForm.handleCloseModal;
  return React.createElement(Dialog, {
    open: open,
    onClose: handleCloseModal
  }, React.createElement(DialogControls, {
    page: page,
    onClose: handleCloseModal,
    onBack: handleBack
  }), React.createElement(DialogTitle, {
    page: page,
    checklists: checklists,
    currentIndex: currentIndex
  }), React.createElement(DialogContent, {
    page: page,
    checklists: checklists,
    currentIndex: currentIndex,
    failedIndexes: failedIndexes,
    doneIndexes: doneIndexes,
    additionalReason: additionalReason,
    setIndex: setIndex,
    handleReasonChange: handleReasonChange
  }), React.createElement(DialogActions, {
    page: page,
    isSubmitting: isSubmitting,
    handleNext: handleNext,
    handleSubmit: handleSubmit
  }), React.createElement(Snackbar, {
    open: hasError,
    onClose: handleCloseError
  }));
};

var ConfirmationModals = function ConfirmationModals() {
  var _useContext104 = useContext(UIStateContext.Scaffold),
      modalStatus = _useContext104.modalStatus;

  if (typeof modalStatus === 'undefined') {
    return React.createElement("div", null);
  }

  if (modalStatus.type === ModalTypes.ConfirmAcceptRejectedComment) {
    return React.createElement(ConfirmAcceptRejectedCommentModal, {
      open: true
    });
  }

  if (modalStatus.type === ModalTypes.DeleteComment) {
    return React.createElement(DeleteCommentModal, {
      open: true
    });
  }

  if (modalStatus.type === ModalTypes.UndoRejectedComment) {
    return React.createElement(UndoRejectedCommentModal, {
      open: true
    });
  }

  if (modalStatus.type === ModalTypes.UndoAcceptedComment) {
    return React.createElement(UndoAcceptedCommentModal, {
      open: true
    });
  }

  if (modalStatus.type === ModalTypes.ApproveDesign) {
    return React.createElement(ApproveDesignModal, {
      open: true
    });
  }

  if (modalStatus.type === ModalTypes.FinalLook) {
    return React.createElement(FinalLookModal, {
      open: true
    });
  }

  if (modalStatus.type === ModalTypes.PrePressCampaignMedia) {
    return React.createElement(ReviewCampaignMediaModal, {
      open: true
    });
  }

  return React.createElement(React.Fragment, null, React.createElement(ChecklistModals, null));
};

var useStyles$6 = makeStyles$1(function (theme) {
  return createStyles({
    accountName: {
      fontSize: 15,
      color: '#ED154E'
    },
    cutText: {
      margin: 0,
      whiteSpace: 'nowrap',
      width: 108,
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    },
    campaignName: {
      maxWidth: 149
    },
    closeBtn: {
      float: 'right',
      padding: '6px 16px',
      textTransform: 'capitalize',
      fontWeight: 'bold',
      fontSize: 14,
      lineHeight: '24px',
      marginTop: 30,
      marginRight: '1em'
    },
    rejectedIcon: {
      position: 'relative',
      marginRight: 8,
      fontSize: 22
    },
    container: {
      maxHeight: 137
    },
    heading: {
      marginTop: 0,
      color: '#ED154E',
      fontSize: 25,
      margin: '12px 0px -5px'
    }
  });
});

var DesignRequestDetails = function DesignRequestDetails(_ref93) {
  var open = _ref93.open;
  var classes = useStyles$6();

  var _useContext105 = useContext(ActionsContext),
      closeModal = _useContext105.closeModal;

  var _useContext106 = useContext(DesignReviewContext),
      mailingDetails = _useContext106.mailingDetails;

  var _useContext107 = useContext(DesignContext.Base),
      workflow = _useContext107.workflow;

  var _useState103 = useState(),
      _useState104 = _slicedToArray(_useState103, 2),
      copy = _useState104[0],
      setCopy = _useState104[1];

  var setTooltipText = function setTooltipText() {
    var copiedToClipboard = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return copiedToClipboard ? 'Copied!' : 'Copy to clipboard';
  };

  return React.createElement(Modal, {
    containerStyle: {
      padding: '2em 0em'
    },
    width: 500,
    open: open,
    onBackdropClick: closeModal
  }, React.createElement("div", {
    style: {
      textAlign: 'center'
    }
  }, React.createElement("img", {
    src: DesignChecklistIcon,
    alt: "DesignChecklistIcon"
  }), React.createElement("h2", {
    className: classes.heading
  }, "Campaign Design Checklist"), React.createElement("p", {
    style: {
      fontSize: 15,
      padding: '0em 2em'
    }
  }, workflow !== Workflow.Submit ? "Check the tracking number and logistics IDs if they match to get this campaign's design ready to approve." : "Swap the tracking number and logistics IDs to get this campaign's design ready to print."), !isEmpty$1(mailingDetails === null || mailingDetails === void 0 ? void 0 : mailingDetails.mediaRejectedMessage) && React.createElement(Accordion, {
    defaultExpanded: true
  }, React.createElement(AccordionSummary, {
    expandIcon: React.createElement(ExpandMore, null),
    "aria-controls": "panel1c-content",
    id: "panel1c-header"
  }, React.createElement(ThumbDown, {
    className: classes.rejectedIcon
  }), React.createElement(Typography, {
    variant: "subtitle2"
  }, React.createElement("strong", null, "Reason for rejection"))), React.createElement(AccordionDetails, null, mailingDetails === null || mailingDetails === void 0 ? void 0 : mailingDetails.mediaRejectedMessage))), React.createElement(TableContainer, {
    className: cx(!isEmpty$1(mailingDetails === null || mailingDetails === void 0 ? void 0 : mailingDetails.mediaRejectedMessage) && classes.container)
  }, React.createElement(Table$1, {
    stickyHeader: true
  }, React.createElement(TableHead, null, React.createElement(TableRow, null, React.createElement(TableCell, {
    align: "left"
  }, React.createElement("strong", null, "Campaign")), React.createElement(TableCell, {
    align: "center"
  }, React.createElement("strong", null, "Tracking Number")), React.createElement(TableCell, {
    align: "right"
  }, React.createElement("strong", null, "Logistics ID")))), React.createElement(TableBody, null, mailingDetails === null || mailingDetails === void 0 ? void 0 : mailingDetails.mailings.map(function (mailing, index) {
    return React.createElement(TableRow, {
      key: "tr-".concat(index)
    }, React.createElement(TableCell, {
      component: "th",
      scope: "row"
    }, React.createElement(Tooltip$1, {
      title: mailing.account,
      placement: "top",
      arrow: true
    }, React.createElement("p", {
      className: cx(classes.cutText, classes.accountName)
    }, mailing.account)), React.createElement(Tooltip$1, {
      title: mailing.name,
      placement: "top",
      arrow: true
    }, React.createElement("p", {
      className: cx(classes.cutText, classes.campaignName)
    }, mailing.name))), React.createElement(TableCell, {
      component: "th",
      scope: "row"
    }, React.createElement(CopyToClipboard, {
      text: mailing.tracking,
      onCopy: function onCopy() {
        return setCopy(_objectSpread({}, copy, _defineProperty({}, "".concat(index, "-tracking"), true)));
      }
    }, React.createElement(Tooltip$1, {
      title: setTooltipText(get(copy, "".concat(index, "-tracking"))),
      placement: "top",
      arrow: true
    }, React.createElement(IconButton, {
      onMouseLeave: function onMouseLeave() {
        return (// Set delay to prevent updating tooltip text while fading away
          setTimeout(function () {
            return setCopy({});
          }, 500)
        );
      }
    }, React.createElement("img", {
      src: CopyIcon,
      alt: "CopyIcon"
    })))), mailing.tracking), React.createElement(TableCell, {
      component: "th",
      scope: "row",
      align: "right"
    }, React.createElement(CopyToClipboard, {
      text: mailing.logisticsId,
      onCopy: function onCopy() {
        return setCopy(_objectSpread({}, copy, _defineProperty({}, "".concat(index, "-logistics"), true)));
      }
    }, React.createElement(Tooltip$1, {
      title: setTooltipText(get(copy, "".concat(index, "-logistics"))),
      placement: "top",
      arrow: true
    }, React.createElement(IconButton, {
      onMouseLeave: function onMouseLeave() {
        return setTimeout(function () {
          return setCopy({});
        }, 500);
      }
    }, React.createElement("img", {
      src: CopyIcon,
      alt: "CopyIcon"
    })))), mailing.logisticsId));
  })))), React.createElement(Button$1, {
    color: "primary",
    size: "medium",
    variant: "contained",
    onClick: closeModal,
    className: classes.closeBtn
  }, "Close"));
};

var Accordion = withStyles$1({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    borderRadius: 0,
    // marginBottom: 10,
    '&:not(:last-child)': {
      borderBottom: 0
    },
    '&:before': {
      display: 'none'
    },
    '&$expanded': {
      margin: 'auto'
    }
  },
  expanded: {}
})(Accordion$1);
var AccordionSummary = withStyles$1({
  root: {
    backgroundColor: 'rgba(0, 0, 0, 0)',
    // borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 40,
    '&$expanded': {
      minHeight: 40
    }
  },
  content: {
    '&$expanded': {
      margin: '0px 0'
    }
  },
  expanded: {}
})(AccordionSummary$1);
var AccordionDetails = withStyles$1(function (theme) {
  return {
    root: {
      padding: 0,
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      display: 'block',
      fontSize: 15,
      lineHeight: 2,
      textAlign: 'left',
      whiteSpace: 'pre-line',
      maxHeight: '10em',
      overflowY: 'auto'
    }
  };
})(AccordionDetails$1);

var DesignHelpModal = function DesignHelpModal(_ref94) {
  var open = _ref94.open;

  var _useContext108 = useContext(DesignReviewContext),
      mc = _useContext108.mc;

  var _useContext109 = useContext(ActionsContext),
      closeModal = _useContext109.closeModal;

  return React.createElement(HelpModal, {
    header: React.createElement(Fragment, null, "Need help or have questions?", React.createElement("br", null), "Just give me a call"),
    open: open,
    onBackdropClick: closeModal,
    coordinator: mc
  });
};

var InformationModals = function InformationModals() {
  var _useContext110 = useContext(UIStateContext.Scaffold),
      modalStatus = _useContext110.modalStatus;

  var _useContext111 = useContext(ActionsContext),
      closeModal = _useContext111.closeModal;

  if (typeof modalStatus === 'undefined') {
    return React.createElement("div", null);
  }

  if (modalStatus.type === ModalTypes.VideoWalkthrough) {
    return React.createElement(VideoModal, {
      open: true,
      onBackdropClick: closeModal,
      videoTitle: "Show me how",
      videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=1"
    });
  }

  if (modalStatus.type === ModalTypes.Help) {
    return React.createElement(DesignHelpModal, {
      open: true
    });
  }

  if (modalStatus.type === ModalTypes.DesignRequestDetails) {
    return React.createElement(DesignRequestDetails, {
      open: true
    });
  }

  return React.createElement("div", null);
};

var CampaignMediaNextReviewModal = function CampaignMediaNextReviewModal(_ref95) {
  var open = _ref95.open,
      approve = _ref95.approve;
  var modalIcon = approve ? ApproveIcon : RejectedIcon;
  var modalTitle = approve ? 'Campaign Approved' : 'Campaign Rejected';
  var subStatus = "You have successfully ".concat(approve ? "approved" : "rejected", " this design!");
  return React.createElement(ScaffoldSuccessModal, {
    open: open,
    title: modalTitle,
    imageSrc: modalIcon,
    subStatus: subStatus
  });
};

var img$g = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='358.514' height='289.289' viewBox='0 0 358.514 289.289'%3e %3cg id='illustration' transform='translate(-102.65 -220.291)'%3e %3cpath id='Path_3917' data-name='Path 3917' d='M186.322%2c483.05H176v83.988' transform='translate(-47.64 -170.66)' fill='none' stroke='%23dfdfdf' stroke-miterlimit='10' stroke-width='4'/%3e %3crect id='Rectangle_19054' data-name='Rectangle 19054' width='91.98' height='177.138' transform='translate(158.251 302.029)' fill='%23f3f3f3'/%3e %3crect id='Rectangle_19055' data-name='Rectangle 19055' width='21.395' height='177.138' transform='translate(137.108 302.029)' fill='%23dfdfdf'/%3e %3cpath id='Path_3918' data-name='Path 3918' d='M158.832%2c855.824c-20.76%2c0-56.182-31.682-56.182-57.995%2c0-2%2c.95-5.78%2c3.046-5.78C117.028%2c792.032%2c158.832%2c825.811%2c158.832%2c855.824Z' transform='translate(0 -371.354)' fill='%23b7003d'/%3e %3cpath id='Path_3919' data-name='Path 3919' d='M655.57%2c316.71V432.324h6.635' transform='translate(-359.119 -62.623)' fill='none' stroke='%23dfdfdf' stroke-miterlimit='10' stroke-width='4'/%3e %3cline id='Line_1070' data-name='Line 1070' x1='22.776' y1='38.324' transform='translate(383.138 458.252)' fill='none' stroke='%23ed7562' stroke-linecap='round' stroke-linejoin='round' stroke-width='4'/%3e %3cline id='Line_1071' data-name='Line 1071' x1='22.776' y1='38.324' transform='translate(393.016 458.252)' fill='none' stroke='%23ed7562' stroke-linecap='round' stroke-linejoin='round' stroke-width='4'/%3e %3cline id='Line_1072' data-name='Line 1072' y1='38.324' x2='22.772' transform='translate(343.086 458.252)' fill='none' stroke='%23ed7562' stroke-linecap='round' stroke-linejoin='round' stroke-width='4'/%3e %3cpath id='Path_3920' data-name='Path 3920' d='M852.182%2c668.8h33.673l-22.615%2c81.959H805.87v-2.92h42.548Z' transform='translate(-456.738 -291.304)' fill='%23ed7562'/%3e %3crect id='Rectangle_19056' data-name='Rectangle 19056' width='6.46' height='5.773' transform='matrix(0.988%2c -0.154%2c 0.154%2c 0.988%2c 339.006%2c 494.609)' fill='%23de8e68'/%3e %3crect id='Rectangle_19057' data-name='Rectangle 19057' width='6.46' height='5.773' transform='translate(302.389 486.492) rotate(33)' fill='%23de8e68'/%3e %3cpath id='Path_3921' data-name='Path 3921' d='M696.243%2c822.26c-4.714%2c0-28.244%2c54.781-28.244%2c56.782s5.107%2c4.272%2c5.861%2c4.272c1.174-1.09%2c23.7-33.648%2c26.043-35.92S696.243%2c822.26%2c696.243%2c822.26Z' transform='translate(-367.192 -390.975)' fill='%23b7003d'/%3e %3cpath id='Path_3922' data-name='Path 3922' d='M788.483%2c707.49c-1.549.487-9.113%2c6.968-10.435%2c14.753-1.346-.161-9.422-.5-12.787-.634a7.214%2c7.214%2c0%2c0%2c0-6.106-2.9c-3.747%2c0-6.786%2c2.3-6.786%2c5.142v.186h13.547v-.186a4.083%2c4.083%2c0%2c0%2c0-.561-2.04l11.77%2c1.875%2c13.982%2c1.455%2c1.441-12.212Z' transform='translate(-421.99 -316.433)' fill='%23d37c59'/%3e %3cpath id='Path_3923' data-name='Path 3923' d='M856.649%2c678.843c0-.985-2.454-2.1-4.255-2.1-4.809%2c0-12.944%2c8.763-12.944%2c9.863s5.857%2c6%2c10.358%2c6.3S856.649%2c678.843%2c856.649%2c678.843Z' transform='translate(-478.548 -296.461)' fill='%23fcc486'/%3e %3cpath id='Path_3924' data-name='Path 3924' d='M881.873%2c662.7c27.182%2c0%2c20.971%2c61.4%2c17.525%2c64s-33.648%2c2.832-35.615.238S849.616%2c662.7%2c881.873%2c662.7Z' transform='translate(-491.827 -287.342)' fill='%23fed385'/%3e %3cpath id='Path_3925' data-name='Path 3925' d='M916.1%2c629.19H905.23v14.557c0%2c2.31%2c10.866%2c2.327%2c10.866%2c0Z' transform='translate(-521.271 -265.577)' fill='%23d37c59'/%3e %3cellipse id='Ellipse_1679' data-name='Ellipse 1679' cx='15.966' cy='10.739' rx='15.966' ry='10.739' transform='translate(374.192 370.484) rotate(-80.94)' fill='%23de8e68'/%3e %3cpath id='Path_3926' data-name='Path 3926' d='M961.52%2c541.5c5.258%2c0%2c10.515%2c2.8%2c17.175%2c2.8%2c5.257%2c0%2c10.165-2.1%2c16.474-2.1%2c11.216%2c0%2c14.721%2c7.361%2c14.721%2c11.917%2c0%2c11.567-9.464%2c16.123-16.474%2c16.123-11.217%2c0-12.618-7.711-25.937-7.711-12.969%2c0-11.216-10.515-14.02-10.515-1.4%2c0-2.278.175-2.8.7s-3.155-1.4-3.155-2.1S951%2c541.5%2c961.52%2c541.5Z' transform='translate(-548.726 -208.623)'/%3e %3cpath id='Path_3927' data-name='Path 3927' d='M892.721%2c552.5c-12.4%2c0-14.991%2c9.432-14.991%2c12.156s1.721%2c4.742%2c2.6%2c4.809a27.316%2c27.316%2c0%2c0%2c1%2c3.277-7.851c.7.7%2c3.3%2c2.951%2c5.959%2c3.155a13.212%2c13.212%2c0%2c0%2c1%2c6.257%2c1.949%2c6.689%2c6.689%2c0%2c0%2c0%2c1%2c2.538%2c6.091%2c6.091%2c0%2c0%2c0%2c3.077%2c2.506%2c7.586%2c7.586%2c0%2c0%2c1%2c.529%2c2.453%2c18.934%2c18.934%2c0%2c0%2c1-.7%2c6.309c5.713%2c0%2c8.412-5.885%2c8.412-13.319C908.143%2c554.964%2c897.312%2c552.5%2c892.721%2c552.5Z' transform='translate(-503.41 -215.768)'/%3e %3ccircle id='Ellipse_1680' data-name='Ellipse 1680' cx='3.028' cy='3.028' r='3.028' transform='translate(393.976 355.491)' fill='%23de8e68'/%3e %3cpath id='Path_3928' data-name='Path 3928' d='M828.033%2c727.37c-1.223.295-6.127%2c3.333-9.067%2c8.577-2.892-.54-14.655-3.48-25.1-3.48-.981%2c0-3.53-.806-4.557-.806-6.123%2c0-7.4%2c3.309-7.4%2c4.286s.21%2c1.006.4%2c1.006c21.03%2c0%2c26.319%2c8.871%2c38.149%2c8.871%2c3.827%2c0%2c11.717-2.772%2c16.474-9.874C835.264%2c730.293%2c828.033%2c727.37%2c828.033%2c727.37Z' transform='translate(-441.176 -329.345)' fill='%23de8e68'/%3e %3cpath id='Path_3929' data-name='Path 3929' d='M926.034%2c690.3c6.568%2c6.376-10.042%2c24.024-12.706%2c23.764S901.06%2c703.7%2c900.969%2c700.621%2c919.686%2c684.137%2c926.034%2c690.3Z' transform='translate(-518.504 -304.23)' fill='%23fed892'/%3e %3crect id='Rectangle_19058' data-name='Rectangle 19058' width='148.344' height='4.788' transform='translate(272.687 408.393)' fill='%23fd8369'/%3e %3cpath id='Path_3930' data-name='Path 3930' d='M823.468%2c828.007c0-1.507.263-3.253-.676-3.642-22.3-9.194-54.945-10.385-59.975-10.385s-19.737.512-19.737%2c4.721c0%2c15.2%2c8.472%2c62.015%2c10.193%2c63.764.817.824%2c7.939.273%2c8.826-.617-.06-3.856%2c2.18-42.583.137-47.273%2c18.741%2c6.87%2c40.024%2c10.122%2c45.632%2c10.122C824.12%2c844.681%2c823.468%2c829.795%2c823.468%2c828.007Z' transform='translate(-415.956 -385.598)' fill='%23ed154e'/%3e %3cpath id='Path_3931' data-name='Path 3931' d='M639.141%2c988.661l-5.657-3.771-15.226-3.19-1.448%2c2.391%2c17.943%2c11.093Z' transform='translate(-333.944 -494.531)'/%3e %3cpath id='Path_3932' data-name='Path 3932' d='M762.027%2c1012.08l-6.712%2c1.055L741.95%2c1021.1l.554%2c2.744%2c20.715-3.989Z' transform='translate(-415.222 -514.262)'/%3e %3cline id='Line_1073' data-name='Line 1073' y1='72.744' transform='translate(413.061 411.842)' fill='none' stroke='%23fd8369' stroke-linecap='round' stroke-linejoin='round' stroke-width='4'/%3e %3cline id='Line_1074' data-name='Line 1074' y1='72.744' transform='translate(289.806 411.842)' fill='none' stroke='%23fd8369' stroke-linecap='round' stroke-linejoin='round' stroke-width='4'/%3e %3cline id='Line_1075' data-name='Line 1075' y1='87.321' transform='translate(402.644 411.842)' fill='none' stroke='%23fd8369' stroke-linecap='round' stroke-linejoin='round' stroke-width='4'/%3e %3cline id='Line_1076' data-name='Line 1076' y1='87.321' transform='translate(278.8 411.842)' fill='none' stroke='%23fd8369' stroke-linecap='round' stroke-linejoin='round' stroke-width='4'/%3e %3cline id='Line_1077' data-name='Line 1077' y1='38.324' x2='22.772' transform='translate(353.219 458.252)' fill='none' stroke='%23ed7562' stroke-linecap='round' stroke-linejoin='round' stroke-width='4'/%3e %3crect id='Rectangle_19059' data-name='Rectangle 19059' width='24.63' height='0.88' transform='translate(327.124 407.513)' fill='%2374d5de'/%3e %3crect id='Rectangle_19060' data-name='Rectangle 19060' width='53.775' height='39.05' transform='translate(299.802 350.174)' fill='%23ed154e'/%3e %3cpath id='Path_3933' data-name='Path 3933' d='M706.547%2c681.31l-7.417%2c26.512h13l7.2-26.512Z' transform='translate(-387.411 -299.429)' fill='%23b7003d'/%3e %3cpath id='Path_3934' data-name='Path 3934' d='M608.632%2c255.972A15.678%2c15.678%2c0%2c0%2c0%2c592%2c230.147a21.731%2c21.731%2c0%2c0%2c0-38.205%2c3.389%2c15.678%2c15.678%2c0%2c0%2c0-19.421%2c22.432Z' transform='translate(-279.016 0)' fill='%23dfdfdf'/%3e %3cpath id='Path_3935' data-name='Path 3935' d='M497.016%2c313.62v25.138H419.88v23.887' transform='translate(-206.039 -60.616)' fill='none' stroke='%23dfdfdf' stroke-miterlimit='10' stroke-width='4'/%3e %3cpath id='Path_3936' data-name='Path 3936' d='M198.926%2c820.7c2.05%2c0%2c6.046-6.947%2c6.046-20.421%2c0-9.852-6.9-16.225-8.955-25.986-3.155-14.97-18.777-58.945-43.168-58.945-2.8%2c0-6.568%2c5.892-6.568%2c18.03%2c0%2c14.721%2c14.259%2c29.965%2c14.259%2c33.126C160.553%2c802.6%2c192.389%2c820.7%2c198.926%2c820.7Z' transform='translate(-28.337 -321.538)' fill='%23ed154e'/%3e %3cg id='Group_13036' data-name='Group 13036' transform='translate(124.529 395.736)'%3e %3cpath id='Path_3937' data-name='Path 3937' d='M211.288%2c824.267c0-1.973-2.853-15.212-4.336-18.521s-7.3-19.856-8.216-24.423-17.8-49.183-33.666-60.483' transform='translate(-165.07 -720.84)' fill='none' stroke='%23ff376c' stroke-linecap='round' stroke-linejoin='round' stroke-width='3'/%3e %3cline id='Line_1078' data-name='Line 1078' x1='26.61' y1='5.419' transform='translate(12.327 71.696)' fill='none' stroke='%23ff376c' stroke-linecap='round' stroke-linejoin='round' stroke-width='3'/%3e %3cline id='Line_1079' data-name='Line 1079' x1='24.371' y1='2.029' transform='translate(15.906 78.783)' fill='none' stroke='%23ff376c' stroke-linecap='round' stroke-linejoin='round' stroke-width='3'/%3e %3cline id='Line_1080' data-name='Line 1080' x1='24.735' y1='7.487' transform='translate(7.872 49.547)' fill='none' stroke='%23ff376c' stroke-linecap='round' stroke-linejoin='round' stroke-width='3'/%3e %3cline id='Line_1081' data-name='Line 1081' y1='5.489' x2='7.55' transform='translate(34.963 59.744)' fill='none' stroke='%23ff376c' stroke-linecap='round' stroke-linejoin='round' stroke-width='3'/%3e %3cline id='Line_1082' data-name='Line 1082' y1='8.458' x2='7.459' transform='translate(20.669 20.711)' fill='none' stroke='%23ff376c' stroke-linecap='round' stroke-linejoin='round' stroke-width='3'/%3e %3cline id='Line_1083' data-name='Line 1083' y1='8.612' x2='6.348' transform='translate(18.338 16.053)' fill='none' stroke='%23ff376c' stroke-linecap='round' stroke-linejoin='round' stroke-width='3'/%3e %3c/g%3e %3crect id='Rectangle_19061' data-name='Rectangle 19061' width='76.736' height='14.791' transform='translate(165.871 313.234)' fill='%23dfdfdf'/%3e %3ccircle id='Ellipse_1681' data-name='Ellipse 1681' cx='2.594' cy='2.594' r='2.594' transform='translate(234.503 316.178)' fill='%23f3f3f3'/%3e %3cline id='Line_1084' data-name='Line 1084' x2='39.951' transform='translate(192.369 318.772)' fill='none' stroke='%23f3f3f3' stroke-linecap='round' stroke-linejoin='round' stroke-width='4'/%3e %3crect id='Rectangle_19062' data-name='Rectangle 19062' width='76.736' height='14.791' transform='translate(165.871 338.239)' fill='%23dfdfdf'/%3e %3ccircle id='Ellipse_1682' data-name='Ellipse 1682' cx='2.594' cy='2.594' r='2.594' transform='translate(234.503 341.184)' fill='%23f3f3f3'/%3e %3cline id='Line_1085' data-name='Line 1085' x2='39.951' transform='translate(192.369 343.777)' fill='none' stroke='%23f3f3f3' stroke-linecap='round' stroke-linejoin='round' stroke-width='4'/%3e %3crect id='Rectangle_19063' data-name='Rectangle 19063' width='76.736' height='14.791' transform='translate(165.871 363.241)' fill='%23dfdfdf'/%3e %3ccircle id='Ellipse_1683' data-name='Ellipse 1683' cx='2.594' cy='2.594' r='2.594' transform='translate(234.503 366.185)' fill='%23f3f3f3'/%3e %3cline id='Line_1086' data-name='Line 1086' x2='39.951' transform='translate(192.369 368.779)' fill='none' stroke='%23f3f3f3' stroke-linecap='round' stroke-linejoin='round' stroke-width='4'/%3e %3crect id='Rectangle_19064' data-name='Rectangle 19064' width='76.736' height='14.791' transform='translate(165.871 388.246)' fill='%23dfdfdf'/%3e %3ccircle id='Ellipse_1684' data-name='Ellipse 1684' cx='2.594' cy='2.594' r='2.594' transform='translate(234.503 391.19)' fill='%23f3f3f3'/%3e %3cline id='Line_1087' data-name='Line 1087' x2='39.951' transform='translate(192.369 393.784)' fill='none' stroke='%23f3f3f3' stroke-linecap='round' stroke-linejoin='round' stroke-width='4'/%3e %3crect id='Rectangle_19065' data-name='Rectangle 19065' width='76.736' height='14.791' transform='translate(165.871 413.247)' fill='%23dfdfdf'/%3e %3ccircle id='Ellipse_1685' data-name='Ellipse 1685' cx='2.594' cy='2.594' r='2.594' transform='translate(234.503 416.195)' fill='%23f3f3f3'/%3e %3cline id='Line_1088' data-name='Line 1088' x2='39.951' transform='translate(192.369 418.789)' fill='none' stroke='%23f3f3f3' stroke-linecap='round' stroke-linejoin='round' stroke-width='4'/%3e %3cline id='Line_1089' data-name='Line 1089' x2='11.511' transform='translate(142.05 323.876)' fill='none' stroke='%23f3f3f3' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cline id='Line_1090' data-name='Line 1090' x2='11.511' transform='translate(142.05 326.855)' fill='none' stroke='%23f3f3f3' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cline id='Line_1091' data-name='Line 1091' x2='11.511' transform='translate(142.05 344.145)' fill='none' stroke='%23f3f3f3' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cline id='Line_1092' data-name='Line 1092' x2='11.511' transform='translate(142.05 347.125)' fill='none' stroke='%23f3f3f3' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cline id='Line_1093' data-name='Line 1093' x2='11.511' transform='translate(142.05 368.779)' fill='none' stroke='%23f3f3f3' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cline id='Line_1094' data-name='Line 1094' x2='11.511' transform='translate(142.05 371.762)' fill='none' stroke='%23f3f3f3' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cline id='Line_1095' data-name='Line 1095' x2='11.511' transform='translate(142.05 392.613)' fill='none' stroke='%23f3f3f3' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3cline id='Line_1096' data-name='Line 1096' x2='11.511' transform='translate(142.05 395.596)' fill='none' stroke='%23f3f3f3' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3e %3c/g%3e%3c/svg%3e";

var CustomerSuccessfullySubmittedRequestsModal = function CustomerSuccessfullySubmittedRequestsModal(_ref96) {
  var open = _ref96.open;

  var _useContext112 = useContext(DesignReviewContext),
      mc = _useContext112.mc;

  return React.createElement(Dialog$1, {
    open: open,
    TransitionComponent: SlideUpTransition,
    style: {
      backgroundColor: '#232323'
    }
  }, React.createElement("div", {
    style: {
      backgroundColor: '#fff',
      minWidth: '500px',
      maxWidth: '1024px',
      padding: '4em',
      borderRadius: '4px',
      outline: 'none'
    }
  }, React.createElement(Typography, {
    variant: "h4",
    component: "h2",
    style: {
      fontWeight: 'bold',
      color: '#0d951b',
      textAlign: 'center'
    }
  }, "Successfully Submitted!"), React.createElement("div", {
    style: {
      margin: '2em',
      textAlign: 'center'
    }
  }, React.createElement(Typography, null, "You have successfully submitted your revision requests."), React.createElement(Typography, null, "We will notify you as soon as revisions are applied.")), React.createElement("div", null, React.createElement("img", {
    style: {
      display: 'flex',
      justifyContent: 'center'
    },
    src: img$g,
    alt: "Successfully Submitted Revision Requests"
  })), React.createElement("div", {
    style: {
      fontSize: '1.1eem',
      textAlign: 'center',
      marginTop: '1em'
    }
  }, React.createElement("div", {
    style: {
      marginBottom: '0.25em'
    }
  }, "Did you miss something? Reach out to your MVP Marketing Consultant"), React.createElement("div", null, React.createElement("span", {
    style: {
      marginRight: '4px'
    }
  }, React.createElement("a", {
    href: "/",
    style: {
      textDecoration: 'none',
      color: '#ed154e'
    }
  }, mc.phone)), React.createElement("span", {
    style: {
      color: 'lightgrey',
      marginRight: '4px'
    }
  }, "|"), React.createElement("span", null, React.createElement("a", {
    href: "/",
    style: {
      textDecoration: 'none',
      color: '#ed154e'
    }
  }, mc.email))))));
};

var StateModals = function StateModals() {
  var _useContext113 = useContext(UIStateContext.Scaffold),
      modalStatus = _useContext113.modalStatus;

  if (typeof modalStatus === 'undefined') {
    return React.createElement("div", null);
  }

  if (modalStatus.type === ModalTypes.SuccessfullySubmittedRequests) {
    return React.createElement(SuccessfullySubmittedRequestsModal, {
      open: true
    });
  }

  if (modalStatus.type === ModalTypes.CustomerSuccessfullySubmittedRequests) {
    return React.createElement(CustomerSuccessfullySubmittedRequestsModal, {
      open: true
    });
  }

  if (modalStatus.type === ModalTypes.SuccessfullySubmittedRevisions) {
    return React.createElement(SuccessfullySubmittedRevisionsModal, {
      open: true
    });
  }

  if (modalStatus.type === ModalTypes.MovedToNextReview) {
    return React.createElement(MovedToNextReviewModal, {
      open: true
    });
  }

  if (modalStatus.type === ModalTypes.CampaignMediaApproved) {
    return React.createElement(CampaignMediaNextReviewModal, {
      approve: true,
      open: true
    });
  }

  if (modalStatus.type === ModalTypes.CampaignMediaRejected) {
    return React.createElement(CampaignMediaNextReviewModal, {
      approve: false,
      open: true
    });
  }

  if (modalStatus.type === ModalTypes.DesignApproved) {
    return React.createElement(DesignApprovedModal, {
      open: true
    });
  }

  if (modalStatus.type === ModalTypes.DesignInProgress) {
    return React.createElement(DesignInProgressModal, {
      open: true
    });
  }

  return React.createElement("div", null);
};

var ModalSelector = function ModalSelector() {
  var _useContext114 = useContext(DesignReviewContext),
      designDetails = _useContext114.designDetails;

  var isApproved = designDetails.isApproved;

  var _useContext115 = useContext(UIStateContext.Scaffold),
      modalStatus = _useContext115.modalStatus;

  if (!modalStatus && isApproved) {
    return null;
  }

  if ((modalStatus === null || modalStatus === void 0 ? void 0 : modalStatus.type) === ModalTypes.Welcome) {
    return React.createElement(WelcomeModal, {
      open: true
    });
  }

  return React.createElement(React.Fragment, null, React.createElement(ConfirmationModals, null), React.createElement(InformationModals, null), React.createElement(StateModals, null));
};

var useDesignReviewStyles = makeStyles({
  gridContainer: {
    width: '100%',
    height: '100vh',
    display: 'grid',
    backgroundColor: 'black'
  },
  gridSpacerTopLeft: {
    gridArea: '1 / 1 / span 1 / span 1',
    zIndex: 1,
    backgroundColor: 'rgba(50, 50, 50, 0.5)'
  },
  gridSpacerTopRight: {
    gridArea: '1 / 5 / span 1 / span 1',
    zIndex: 1,
    backgroundColor: 'rgba(50, 50, 50, 0.5)'
  },
  gridSpacerBottomLeft: {
    gridArea: '4 / 1 / span 1 / span 1',
    zIndex: 1,
    backgroundColor: 'rgba(50, 50, 50, 0.5)'
  },
  gridSpacerBottomRight: {
    gridArea: '4 / 5 / span 1 / span 1',
    zIndex: 1,
    backgroundColor: 'rgba(50, 50, 50, 0.5)'
  },
  gridTop: {
    gridArea: '1 / 2 / span 1 / span 3',
    padding: '0 1em',
    zIndex: 1,
    backgroundColor: 'rgba(50, 50, 50, 0.5)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  gridViewingAreaMeasure: {
    gridArea: '2 / 1 / span 2 / span 5',
    width: '100%'
  },
  gridImageOverlay: {
    gridArea: '1 / 1 / span 4 / span 5',
    height: '100vh',
    width: '100%',
    overflow: 'hidden'
  },
  gridImageControls: {
    gridArea: '3 / 3 / span 1 / span 1',
    zIndex: 1
  },
  gridBottom: {
    gridArea: '4 / 2 / span 1 / span 3',
    zIndex: 1
  }
});
var useRevisionBottomOverlayStyles$1 = makeStyles({
  button: {
    color: '#F9F9F9',
    padding: '12px 32px',
    fontWeight: 'bold'
  }
});

var ClickToRequestChange = function ClickToRequestChange(_ref97) {
  var isPreviousVersionLocked = _ref97.isPreviousVersionLocked;
  return React.createElement(Typography, {
    style: {
      color: 'white',
      fontSize: '1rem',
      marginRight: '22px'
    }
  }, isPreviousVersionLocked ? 'Switch to current version of design to request changes' : 'Click on the design to request a change');
};

var RequestActionsOverlay = function RequestActionsOverlay() {
  var classes = useRevisionBottomOverlayStyles$1();

  var _useContext116 = useContext(DesignContext.Base),
      workflow = _useContext116.workflow,
      experience = _useContext116.experience,
      viewedAs = _useContext116.viewedAs;

  var comments = useContext(CommentsStore.Comments);
  var commentUpdateQueue = useContext(UpdateQueueContext);

  var _useContext117 = useContext(UIStateContext.Scaffold),
      isPreviousVersionLocked = _useContext117.isPreviousVersionLocked;

  var _useContext118 = useContext(ActionsContext),
      openModal = _useContext118.openModal;

  var _useContext119 = useContext(CampaignContext.Derived),
      designStatus = _useContext119.designStatus;

  var isUpdating = commentUpdateQueue.length > 0;

  if (workflow === Workflow.Review) {
    return null;
  } // Number swap: Pre press reviewer


  var isPrePressReviewer = experience === DesignReviewExperience.CampaignReview && viewedAs === DesignReviewViewedAs.Default && // TODO: Make a simple state or prop?
  [CampaignDesignStatus.ReadyForPrePress].includes(designStatus);

  if (isPrePressReviewer) {
    return React.createElement(SubmitReviewButton, {
      openModal: openModal
    });
  }

  var commentCount = comments.reduce(function (acc, c) {
    var isCountedComment = c.status === CommentStatus.Pending || c.status === CommentStatus.Rejected;

    if (isCountedComment) {
      return acc + 1;
    }

    return acc;
  }, 0);

  if (commentCount > 0) {
    return React.createElement(Fragment, null, React.createElement(Typography, {
      style: {
        color: 'white',
        fontSize: '1rem',
        marginRight: '22px'
      }
    }, "".concat(commentCount, " pending request").concat(commentCount > 1 ? 's' : '')), React.createElement(Button$1, {
      className: classes.button,
      style: {
        backgroundColor: '#ed154e',
        color: '#fff',
        fontSize: '1.2rem',
        boxShadow: 'none',
        fontWeight: 'normal',
        padding: '.75rem 1.75rem'
      },
      disabled: isUpdating,
      onClick: function () {
        var _onClick8 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee20() {
          return _regeneratorRuntime.wrap(function _callee20$(_context20) {
            while (1) {
              switch (_context20.prev = _context20.next) {
                case 0:
                  openModal({
                    type: ModalTypes.FinalizeRequests
                  });
                  return _context20.abrupt("return");

                case 2:
                case "end":
                  return _context20.stop();
              }
            }
          }, _callee20);
        }));

        function onClick() {
          return _onClick8.apply(this, arguments);
        }

        return onClick;
      }()
    }, "Submit ".concat(commentCount, " request").concat(commentCount > 1 ? 's' : ''), isUpdating ? React.createElement(ActionsCircularProgress, null) : null));
  }

  return React.createElement(Fragment, null, React.createElement(ClickToRequestChange, {
    isPreviousVersionLocked: isPreviousVersionLocked
  }), React.createElement(ApproveButton, {
    isUpdating: isUpdating,
    openModal: openModal
  }));
};

var SubmitReviewButton = function SubmitReviewButton(_ref98) {
  var openModal = _ref98.openModal;
  return React.createElement(Button$1, {
    style: {
      color: '#F9F9F9',
      backgroundColor: '#0d951b',
      padding: '0.75rem 1.75rem',
      textTransform: 'uppercase'
    },
    variant: "contained",
    onClick: function onClick() {
      openModal({
        type: ModalTypes.PrePressCampaignMedia
      });
    },
    children: 'Submit Review'
  });
};

var ApproveButton = function ApproveButton(_ref99) {
  var isUpdating = _ref99.isUpdating,
      openModal = _ref99.openModal;
  return React.createElement(Button$1, {
    style: {
      color: '#F9F9F9',
      backgroundColor: '#0d951b',
      padding: '0.75rem 1.75rem',
      textTransform: 'uppercase'
    },
    variant: "contained",
    disabled: isUpdating,
    onClick: function onClick() {
      openModal({
        type: ModalTypes.ApproveDesign
      });
    }
  }, "Approve", isUpdating ? React.createElement(ActionsCircularProgress, null) : null);
};

var useBaseMarkerStyles = makeStyles({
  container: {
    cursor: 'pointer',
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    border: '2px solid white',
    color: 'white',
    fontWeight: 'bold',
    boxShadow: '0px 0px 3px rgba(20,20,20,0.5)'
  }
});

var BaseMarker = function BaseMarker(_ref100) {
  var xProp = _ref100.x,
      yProp = _ref100.y,
      label = _ref100.label,
      _ref100$onClick = _ref100.onClick,
      _onClick9 = _ref100$onClick === void 0 ? function () {} : _ref100$onClick,
      _ref100$onDragEnd = _ref100.onDragEnd,
      _onDragEnd = _ref100$onDragEnd === void 0 ? function () {} : _ref100$onDragEnd,
      _ref100$color = _ref100.color,
      color = _ref100$color === void 0 ? 'grey' : _ref100$color,
      _ref100$zIndex = _ref100.zIndex,
      zIndex = _ref100$zIndex === void 0 ? 2 : _ref100$zIndex,
      style = _ref100.style;

  var _a;

  var classes = useBaseMarkerStyles();

  var _useContext120 = useContext(RefsContext),
      scale = _useContext120.scale,
      imgElRef = _useContext120.imgElRef;

  var image = imgElRef.current;
  var isPortrait = image !== null && image.naturalHeight > image.naturalWidth;

  var _useSpring8 = useSpring({
    backgroundColor: color
  }),
      backgroundColor = _useSpring8.backgroundColor;

  var _useSpring9 = useSpring(function () {
    return {
      x: xProp,
      y: yProp
    };
  }),
      _useSpring10 = _slicedToArray(_useSpring9, 2),
      _useSpring10$ = _useSpring10[0],
      x = _useSpring10$.x,
      y = _useSpring10$.y,
      setCoords = _useSpring10[1];

  var bindGestures = useGesture({
    onClick: function onClick() {
      _onClick9();
    },
    onDragStart: function onDragStart() {
      _onClick9();
    },
    onDragEnd: function onDragEnd() {
      var xVal = x.get();
      var yVal = y.get();

      if (xVal > 100 || yVal > 100) {
        _onDragEnd(null, null);
      } else {
        _onDragEnd(x.get(), y.get());
      }
    },
    onDrag: function onDrag(_ref101) {
      var movement = _ref101.movement;

      var _a, _b, _c, _d;

      var width = (_b = (_a = imgElRef.current) === null || _a === void 0 ? void 0 : _a.naturalWidth) !== null && _b !== void 0 ? _b : 0;
      var height = (_d = (_c = imgElRef.current) === null || _c === void 0 ? void 0 : _c.naturalHeight) !== null && _d !== void 0 ? _d : 0;
      var scaleFactor = 1 / scale.get();
      var xOffset = movement[0] * scaleFactor / width * 100;
      var yOffset = movement[1] * scaleFactor / height * 100;
      setCoords({
        x: xProp + xOffset,
        y: yProp + yOffset,
        immediate: true
      });
    }
  }, {
    drag: {
      filterTaps: true,
      delay: 300
    }
  });
  useEffect(function () {
    setCoords({
      x: xProp,
      y: yProp,
      immediate: true
    });
  }, [xProp, yProp, setCoords]);
  return React.createElement(animated.div, {
    className: classes.container,
    style: _objectSpread({
      userSelect: 'none',
      zIndex: zIndex,
      pointerEvents: 'none',
      position: 'absolute',
      top: y.to(function (n) {
        return "calc(".concat(n, "% - 15px)");
      }),
      left: x.to(function (n) {
        return "calc(".concat(n, "% - 15px)");
      }),
      backgroundColor: backgroundColor
    }, style, {
      transform: scale.to(function (s) {
        return "scale(".concat(1.0 / s, ")").concat(typeof (style === null || style === void 0 ? void 0 : style.transform) !== 'undefined' ? " ".concat(style.transform) : '');
      })
    })
  }, React.createElement("div", Object.assign({
    style: {
      pointerEvents: (_a = style === null || style === void 0 ? void 0 : style.pointerEvents) !== null && _a !== void 0 ? _a : 'auto',
      height: '100%',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, bindGestures()), label));
};

var Marker = function Marker(_ref102) {
  var _ref102$onClick = _ref102.onClick,
      _onClick10 = _ref102$onClick === void 0 ? function () {} : _ref102$onClick,
      props = _objectWithoutProperties(_ref102, ["onClick"]);

  var _a;

  var isOpen = props.isOpen,
      label = props.label,
      commentMarker = props.commentMarker,
      style = props.style;

  var _useContext121 = useContext(UIStateContext.Derived.Scaffold),
      activeComment = _useContext121.activeComment;

  var _useContext122 = useContext(ActionsContext),
      updateCommentPin = _useContext122.updateCommentPin;

  var commentUpdateQueue = useContext(UpdateQueueContext);
  var baseMarkerStyle = style;
  var isUpdating = commentUpdateQueue.includes(props.commentMarker.id);

  if (isUpdating) {
    baseMarkerStyle.border = 'none';
  }

  var isActive = (activeComment === null || activeComment === void 0 ? void 0 : activeComment.id) === commentMarker.id && !isUpdating;
  return React.createElement(BaseMarker, {
    x: commentMarker.x,
    y: commentMarker.y,
    label: isUpdating ? React.createElement(LoadingLabel, {
      label: label
    }) : label,
    onClick: function onClick() {
      _onClick10(commentMarker.id);
    },
    onDragEnd: function onDragEnd(x, y) {
      updateCommentPin(commentMarker.id, {
        x: x,
        y: y
      });
    },
    color: isActive ? Colors.MVP_LIGHT_PINK : '#929292',
    zIndex: ((_a = style === null || style === void 0 ? void 0 : style.zIndex) !== null && _a !== void 0 ? _a : isOpen) ? 3 : 2,
    style: baseMarkerStyle
  });
};

var NewMarker = function NewMarker(_ref103) {
  var x = _ref103.x,
      y = _ref103.y,
      label = _ref103.label;

  var _useContext123 = useContext(ActionsContext),
      openUnpinnedCommentPrompt = _useContext123.openUnpinnedCommentPrompt,
      setMarkerPrompt = _useContext123.setMarkerPrompt;

  var _useContext124 = useContext(UIStateContext.Derived.ImageViewer),
      isPortrait = _useContext124.isPortrait;

  var onDragEnd = function onDragEnd(xNew, yNew) {
    if (xNew === null || yNew === null) {
      openUnpinnedCommentPrompt();
    } else {
      setMarkerPrompt(isPortrait ? {
        y: xNew,
        x: yNew
      } : {
        x: xNew,
        y: yNew
      });
    }
  };

  return React.createElement(BaseMarker, {
    x: x,
    y: y,
    label: label,
    zIndex: 3,
    onDragEnd: onDragEnd
  });
};

var PinInstructionsOverlay = function PinInstructionsOverlay(_ref104) {
  var visible = _ref104.visible;

  var _useContext125 = useContext(RefsContext),
      scale = _useContext125.scale;

  var _useContext126 = useContext(UIStateContext.Derived.ImageViewer),
      imageDimensions = _useContext126.imageDimensions;

  var width = imageDimensions[0];
  var height = imageDimensions[1];

  var _useSpring11 = useSpring({
    opacity: visible ? 0.6 : 0
  }),
      opacity = _useSpring11.opacity;

  return React.createElement(animated.div, {
    style: {
      opacity: opacity,
      fontSize: scale.to(function (n) {
        return "".concat(1 / n * 1.5, "rem");
      }),
      backgroundColor: '#000',
      color: '#fff',
      width: width,
      height: height,
      display: 'grid',
      placeItems: 'center',
      textAlign: 'center',
      pointerEvents: 'none',
      zIndex: 9999
    }
  }, "Click here to pin comment or press Esc to cancel pinning comment.");
};

var RequestCommentMarkersOverlay = function RequestCommentMarkersOverlay(_ref105) {
  var commentMarkers = _ref105.commentMarkers,
      markerPrompt = _ref105.markerPrompt,
      cardFace = _ref105.cardFace;

  var _useContext127 = useContext(DesignReviewContext),
      moveToNextComment = _useContext127.moveToNextComment;

  var _useContext128 = useContext(UIStateContext.ImageViewer),
      showingAllMarkers = _useContext128.showingAllMarkers,
      isPinningComment = _useContext128.isPinningComment,
      pinCommentPayload = _useContext128.pinCommentPayload,
      hovered = _useContext128.hovered;

  var _useContext129 = useContext(UIStateContext.Derived.ImageViewer),
      isPortrait = _useContext129.isPortrait;

  var _useContext130 = useContext(UIStateContext.Sidebar),
      expandedMarkerIndex = _useContext130.expandedMarkerIndex;

  var _useContext131 = useContext(ActionsContext),
      setExpandedMarkerIndex = _useContext131.setExpandedMarkerIndex,
      setMarkerPrompt = _useContext131.setMarkerPrompt,
      setActiveComment = _useContext131.setActiveComment;

  var _useSpring12 = useSpring({
    opacity: showingAllMarkers ? 1 : 0
  }),
      opacity = _useSpring12.opacity;

  var generateMarkerClickHandler = function generateMarkerClickHandler(i, id) {
    return function () {
      setMarkerPrompt(null);
      setExpandedMarkerIndex(function (currentIndex) {
        return currentIndex === i ? null : i;
      });
      setActiveComment({
        id: id,
        isExpanded: false
      });
    };
  };

  var generateMarkerClickAwayHandler = function generateMarkerClickAwayHandler(i) {
    return function () {
      if (i === expandedMarkerIndex) {
        setExpandedMarkerIndex(null);
        moveToNextComment();
      }
    };
  };

  var adjustedComments = commentMarkers.filter(function (c) {
    return c.status !== CommentStatus.Accepted;
  });
  var numComments = adjustedComments.length;
  var styles = {};
  return React.createElement(Fragment, null, React.createElement(PinInstructionsOverlay, {
    visible: isPinningComment && !hovered
  }), !isPinningComment || hovered ? React.createElement("div", {
    style: _objectSpread({}, styles)
  }, expandedMarkerIndex === null && markerPrompt && markerPrompt.x !== null && markerPrompt.y !== null ? React.createElement(NewMarker, {
    x: isPortrait ? markerPrompt.y : markerPrompt.x,
    y: isPortrait ? markerPrompt.x : markerPrompt.y,
    label: (commentMarkers.length + 1).toString(),
    onlyShowMarker: true
  }) : null, adjustedComments.map(function (commentMarker, index) {
    if (isPinningComment && (pinCommentPayload === null || pinCommentPayload === void 0 ? void 0 : pinCommentPayload.id) === commentMarker.id) {
      return null;
    }

    if (commentMarker.cardFace !== cardFace || commentMarker.x === null || commentMarker.y === null) {
      return null;
    }

    return React.createElement(Marker, {
      key: commentMarker.id,
      label: (index + 1).toString(),
      index: index,
      commentMarker: commentMarker,
      isOpen: expandedMarkerIndex === index,
      onClick: generateMarkerClickHandler(index, commentMarker.id),
      onClickAway: generateMarkerClickAwayHandler(index),
      style: {
        zIndex: numComments - index,
        opacity: opacity,
        pointerEvents: showingAllMarkers ? 'auto' : 'none'
      },
      onlyShowMarker: true
    });
  })) : null);
};

var ReviewActionsOverlay = function ReviewActionsOverlay() {
  var comments = useContext(CommentsStore.Comments);
  var pendingCommentCount = comments.reduce(function (acc, c) {
    if (c.status === CommentStatus.Pending) {
      return acc + 1;
    }

    return acc;
  }, 0);
  var message = pendingCommentCount > 0 ? "".concat(pendingCommentCount, " request").concat(pendingCommentCount > 1 ? 's' : '', " to review") : 'All revisions have been resolved!';
  return React.createElement("div", {
    style: {
      marginRight: '22px',
      color: '#f9f9f9',
      fontSize: '1rem'
    }
  }, message);
};

var CommentMarker = function CommentMarker(_ref106) {
  var comment = _ref106.comment,
      active = _ref106.active,
      index = _ref106.index,
      style = _ref106.style,
      onClick = _ref106.onClick,
      onMouseOver = _ref106.onMouseOver;
  var commentUpdateQueue = useContext(UpdateQueueContext);
  var isUpdating = commentUpdateQueue.includes(comment.id);

  var _getProps = getProps({
    active: active,
    isUpdating: isUpdating,
    index: index,
    status: comment.status
  }),
      baseStyles = _getProps.baseStyles,
      value = _getProps.value,
      shadowRGB = _getProps.shadowRGB;

  if (active) {
    return React.createElement(Beacon, {
      shadowRGB: shadowRGB
    }, React.createElement(PlainNumberedBadge, {
      active: active,
      value: value,
      style: _objectSpread({}, baseStyles, style),
      onClick: onClick,
      onMouseOver: onMouseOver
    }));
  }

  return React.createElement(PlainNumberedBadge, {
    active: active,
    value: value,
    style: _objectSpread({}, baseStyles, style),
    onClick: onClick,
    onMouseOver: onMouseOver
  });
};

var getProps = function getProps(args) {
  var active = args.active,
      isUpdating = args.isUpdating,
      index = args.index,
      status = args.status;
  var baseStyles = {
    transform: 'scale(0.8)',
    opacity: 0.8
  };
  var value = index + 1;
  var shadowRGB = '237, 21, 78';

  if (active) {
    baseStyles.backgroundColor = Colors.MVP_LIGHT_PINK;
  }

  if (status === CommentStatus.Rejected) {
    baseStyles.backgroundColor = Colors.MVP_RED;
    value = React.createElement(Clear, null);
    shadowRGB = '245, 13, 13';
  }

  if (status === CommentStatus.Accepted) {
    baseStyles.backgroundColor = Colors.MVP_GREEN;
    value = React.createElement(Done, null);
    shadowRGB = '13, 149, 27';
  }

  return {
    baseStyles: baseStyles,
    value: isUpdating ? React.createElement(LoadingLabel, {
      label: value
    }) : value,
    shadowRGB: shadowRGB
  };
};

var Beacon = function Beacon(_ref107) {
  var _ref107$shadowRGB = _ref107.shadowRGB,
      shadowRGB = _ref107$shadowRGB === void 0 ? '237, 21, 78' : _ref107$shadowRGB,
      children = _ref107.children;

  var _useSpring13 = useSpring({
    loop: true,
    from: {
      shadowRadius: 0,
      shadowOpacity: 0
    },
    to: function () {
      var _to = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee21(next) {
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return next({
                  shadowRadius: 0,
                  shadowOpacity: 0.6,
                  immediate: true,
                  delay: 900
                });

              case 2:
                _context21.next = 4;
                return next({
                  shadowRadius: 80,
                  shadowOpacity: 0,
                  config: {
                    duration: 600
                  }
                });

              case 4:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21);
      }));

      function to(_x5) {
        return _to.apply(this, arguments);
      }

      return to;
    }()
  }),
      shadowRadius = _useSpring13.shadowRadius,
      shadowOpacity = _useSpring13.shadowOpacity;

  return React.createElement(animated.div, {
    style: {
      width: 30,
      height: 30,
      borderRadius: '50%',
      background: to([shadowRadius, shadowOpacity], function (sr, so) {
        return "rgba(".concat(shadowRGB, ", ").concat(so, ")");
      }),
      boxShadow: to([shadowRadius, shadowOpacity], function (sr, so) {
        return "0 0 0 ".concat(sr, "px rgba(").concat(shadowRGB, ", ").concat(so, ")");
      }),
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative'
    }
  }, children);
};

var MarkerContainer = function MarkerContainer(_ref108) {
  var scale = _ref108.scale,
      x = _ref108.x,
      y = _ref108.y,
      style = _ref108.style,
      children = _ref108.children;
  return React.createElement(animated.div, {
    style: _objectSpread({
      position: 'absolute',
      left: "calc(".concat(x, "% - 15px)"),
      top: "calc(".concat(y, "% - 15px)"),
      transform: to([scale], function (s) {
        return "scale(".concat(1 / s, ")");
      })
    }, style)
  }, children);
};

var BeaconMarkersOverlay = function BeaconMarkersOverlay() {
  var comments = useContext(CommentsStore.Comments);

  var _useContext132 = useContext(UIStateContext.ImageViewer),
      cardFace = _useContext132.cardFace,
      showingAllMarkers = _useContext132.showingAllMarkers;

  var _useContext133 = useContext(UIStateContext.Derived.Sidebar),
      isEditingComment = _useContext133.isEditingComment;

  var _useContext134 = useContext(UIStateContext.Derived.Scaffold),
      activeComment = _useContext134.activeComment;

  var _useContext135 = useContext(RefsContext),
      scale = _useContext135.scale;

  var _useContext136 = useContext(UIStateContext.Derived.ImageViewer),
      isPortrait = _useContext136.isPortrait;

  var _useContext137 = useContext(ActionsContext),
      setActiveComment = _useContext137.setActiveComment;

  var _useSpring14 = useSpring({
    opacity: showingAllMarkers ? 0.8 : 0
  }),
      opacity = _useSpring14.opacity;

  var numComments = comments.length;
  return React.createElement(Fragment, null, comments.map(function (c, i) {
    if (c.x === null || c.y === null || c.cardFace !== cardFace) {
      return null;
    }

    return React.createElement(MarkerContainer, {
      key: c.id,
      scale: scale,
      x: c.x,
      y: c.y,
      style: {
        zIndex: numComments - i
      }
    }, React.createElement(CommentMarker, {
      active: (activeComment === null || activeComment === void 0 ? void 0 : activeComment.id) === c.id,
      comment: c,
      index: i,
      style: {
        position: 'static',
        opacity: opacity,
        boxShadow: '0px 0px 3px rgba(20,20,20,0.5)',
        pointerEvents: 'auto',
        cursor: 'pointer'
      },
      onClick: function onClick() {
        if (isEditingComment) {
          return;
        }

        setActiveComment({
          id: c.id,
          isExpanded: false
        });
      }
    }));
  }));
};

var ReviewCommentMarkersOverlay = function ReviewCommentMarkersOverlay() {
  return React.createElement(BeaconMarkersOverlay, null);
};

var SubmitActionsOverlay = function SubmitActionsOverlay() {
  var _useContext138 = useContext(UIStateContext.Derived.Scaffold),
      areCurrentImagesMissing = _useContext138.areCurrentImagesMissing;

  var _useContext139 = useContext(UIStateContext.Derived.Sidebar),
      hasSidebar = _useContext139.hasSidebar;

  var comments = useContext(CommentsStore.Comments);
  var commentUpdateQueue = useContext(UpdateQueueContext);

  var _useContext140 = useContext(ActionsContext),
      openModal = _useContext140.openModal;

  var isUpdating = commentUpdateQueue.length > 0;
  var pendingCommentCount = comments.reduce(function (acc, c) {
    if (c.isVerified) {
      return acc;
    }

    return acc + 1;
  }, 0);
  var isDoneReviewing = pendingCommentCount === 0;
  var message = !hasSidebar ? 'Upload design and submit for review' : pendingCommentCount > 0 ? "".concat(pendingCommentCount, " Revisions pending") : 'All revisions have been reviewed.';
  return React.createElement(Fragment, null, React.createElement("div", {
    style: {
      marginRight: '22px',
      color: '#f9f9f9',
      fontSize: '1rem'
    }
  }, message), React.createElement(Button$1, {
    onClick: function onClick() {
      openModal({
        type: ModalTypes.ConfirmSubmission
      });
    },
    disabled: areCurrentImagesMissing || !isDoneReviewing || isUpdating,
    style: {
      pointerEvents: 'auto',
      backgroundColor: !areCurrentImagesMissing && isDoneReviewing ? '#ed154e' : '#d3d3d3',
      color: '#f9f9f9',
      padding: '.75rem 1.75rem',
      textTransform: 'uppercase'
    },
    variant: "contained"
  }, "Submit for Review", isUpdating ? React.createElement(ActionsCircularProgress, null) : null));
};

var SubmitViewingAreaPlaceholder = function SubmitViewingAreaPlaceholder() {
  return React.createElement("div", {
    style: {
      display: 'grid',
      placeItems: 'center',
      width: '100%',
      height: '100%'
    }
  }, React.createElement("div", {
    style: {
      display: 'grid',
      placeItems: 'center'
    }
  }, React.createElement("div", {
    style: {
      fontSize: '4rem',
      marginBottom: '1rem'
    }
  }, "Export Final Design & Refresh"), React.createElement("div", {
    style: {
      fontSize: '2rem',
      color: '#727272',
      display: 'flex',
      alignItems: 'center'
    }
  }, React.createElement(Fab, null, React.createElement(Refresh, {
    style: {
      color: '#727272',
      fontSize: '2rem'
    }
  })), React.createElement("span", {
    style: {
      marginLeft: '1rem'
    }
  }, "Click this icon to refresh"))));
};

var ApprovedOverlay = function ApprovedOverlay() {
  var _useContext141 = useContext(DesignReviewContext),
      designDetails = _useContext141.designDetails,
      mailingDetails = _useContext141.mailingDetails;

  var _useContext142 = useContext(DesignContext.Base),
      experience = _useContext142.experience;

  var isDesignConcept = experience === DesignReviewExperience.DesignConcept;
  var customerReviewCompleted = designDetails.customerReviewCompleted,
      customerReviewer = designDetails.customerReviewer;
  var customerReviewerName = customerReviewer === null || customerReviewer === void 0 ? void 0 : customerReviewer.name;

  var _ref109 = isDesignConcept ? [customerReviewerName, customerReviewCompleted] : [mailingDetails === null || mailingDetails === void 0 ? void 0 : mailingDetails.approvedBy, mailingDetails === null || mailingDetails === void 0 ? void 0 : mailingDetails.approvalDate],
      _ref110 = _slicedToArray(_ref109, 2),
      reviewedBy = _ref110[0],
      completedAt = _ref110[1];

  return React.createElement(Typography, {
    style: {
      color: 'white',
      fontSize: '1rem',
      marginRight: '22px'
    }
  }, reviewedBy ? "This design was approved by ".concat(reviewedBy, " on ").concat(moment(completedAt).format('M/D/YYYY')) : 'This design was already approved');
};

var TopOverlay = React.memo(function (_ref111) {
  var title = _ref111.title,
      workflow = _ref111.workflow;

  var _useContext143 = useContext(DesignReviewContext),
      designDetails = _useContext143.designDetails;

  var isApproved = designDetails.isApproved;
  var getOverylayCallback = useCallback(function () {
    return getOverylay({
      isApproved: isApproved,
      workflow: workflow
    });
  }, [isApproved, workflow]);
  return React.createElement(TopOverlayBase, {
    title: title,
    actionsOverlay: getOverylayCallback()
  });
});

var getOverylay = function getOverylay(data) {
  var workflow = data.workflow,
      _data$isApproved = data.isApproved,
      isApproved = _data$isApproved === void 0 ? false : _data$isApproved;

  if (isApproved) {
    return React.createElement(ApprovedOverlay, null);
  }

  switch (workflow) {
    case Workflow.Request:
      return React.createElement(RequestActionsOverlay, null);

    case Workflow.Submit:
      return React.createElement(SubmitActionsOverlay, null);

    default:
      return React.createElement(ReviewActionsOverlay, null);
  }
};

var TopOverlayBase = function TopOverlayBase(_ref112) {
  var title = _ref112.title,
      actionsOverlay = _ref112.actionsOverlay;

  var _useContext144 = useContext(ActionsContext),
      openModal = _useContext144.openModal,
      setGroupComments = _useContext144.setGroupComments;

  var _useContext145 = useContext(UIStateContext.Sidebar),
      groupComments = _useContext145.groupComments;

  return React.createElement(Fragment, null, React.createElement(Typography, {
    variant: "h6",
    component: "h2",
    style: {
      color: 'white'
    }
  }, title), React.createElement(ActionsOverlayContainer, {
    openHelpModal: function openHelpModal() {
      openModal({
        type: ModalTypes.Help
      });
    },
    openVideoWalkthroughModal: function openVideoWalkthroughModal() {
      openModal({
        type: ModalTypes.VideoWalkthrough
      });
    },
    openDesignerChecklist: function openDesignerChecklist() {
      openModal({
        type: ModalTypes.DesignRequestDetails
      });
    },
    toggleComments: function toggleComments() {
      setGroupComments(!groupComments);
    }
  }, actionsOverlay));
};

var CommentMarkersOverlay = React.memo(function (_ref113) {
  var workflow = _ref113.workflow,
      cardFace = _ref113.cardFace;
  var comments = useContext(CommentsStore.Comments);

  var _useContext146 = useContext(UIStateContext.Scaffold),
      markerPrompt = _useContext146.markerPrompt,
      isViewingPrevious = _useContext146.isViewingPrevious;

  var _useContext147 = useContext(UIStateContext.Derived.Scaffold),
      areCurrentImagesMissing = _useContext147.areCurrentImagesMissing,
      arePreviousImagesMissing = _useContext147.arePreviousImagesMissing;

  if (!isViewingPrevious && workflow === Workflow.Submit && areCurrentImagesMissing) {
    return React.createElement(SubmitViewingAreaPlaceholder, null);
  }

  if (!isViewingPrevious && areCurrentImagesMissing || isViewingPrevious && arePreviousImagesMissing) {
    return React.createElement(ViewingAreaPlaceholder, null);
  }

  if (workflow === Workflow.Request) {
    return React.createElement(RequestCommentMarkersOverlay, {
      markerPrompt: markerPrompt,
      commentMarkers: comments,
      cardFace: cardFace
    });
  }

  return React.createElement(ReviewCommentMarkersOverlay, null);
});
var RevisionReviewSidebarContext = createContext({});

var ExpandButton = function ExpandButton(_ref114) {
  var isExpanded = _ref114.isExpanded,
      expandComment = _ref114.expandComment,
      count = _ref114.count;
  if (!isExpanded && count < 2) return React.createElement("div", null);
  return React.createElement("div", {
    style: {
      marginRight: 'auto'
    }
  }, React.createElement(Button$1, {
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      expandComment();
    },
    style: {
      marginRight: 'auto',
      color: '#929292',
      minWidth: 0,
      padding: '6px 0',
      display: 'flex',
      alignItems: 'center'
    }
  }, React.createElement(Fragment, null, React.createElement("span", null, count), React.createElement(Sms, {
    style: {
      fontSize: '1.1rem'
    }
  }))));
};

var img$h = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='28.613' height='28.613' viewBox='0 0 28.613 28.613'%3e %3cg id='pushpin' transform='translate(1.5 2.121)' fill='white'%3e %3cpath d='M 1.212353587150574 25.74199295043945 L 0.9612136483192444 25.74199295043945 L 3.641357352535124e-06 25.74199295043945 L -0.7499963641166687 25.74199295043945 L -0.7499963641166687 24.99199295043945 L -0.7499963641166687 24.03078269958496 L -0.7499963641166687 23.77964401245117 L -0.5987663865089417 23.57915306091309 L 5.646956443786621 15.29860496520996 L 1.812673687934875 11.46431350708008 L 0.5323436260223389 10.18398284912109 L 2.343003749847412 10.18398284912109 L 7.469688415527344 10.18398284912109 L 12.25053310394287 4.720152378082275 L 10.40368366241455 2.873303174972534 L 9.873353958129883 2.342973232269287 L 10.40368366241455 1.81264317035675 L 12.74668407440186 -0.5303568840026855 L 13.27701377868652 -1.060686826705933 L 13.80734348297119 -0.5303568840026855 L 25.52235412597656 11.18465328216553 L 26.05268287658691 11.7149829864502 L 25.52235412597656 12.24531269073486 L 23.17935371398926 14.58831310272217 L 22.64902305603027 15.11864280700684 L 22.11869430541992 14.58831310272217 L 20.2718448638916 12.74146366119385 L 14.80801391601563 17.52230834960938 L 14.80801391601563 22.64899253845215 L 14.80801391601563 24.45965385437012 L 13.52768325805664 23.17932319641113 L 9.693401336669922 19.34504127502441 L 1.412843585014343 25.59076309204102 L 1.212353587150574 25.74199295043945 Z M 10.43267345428467 11.7149829864502 L 10.93401336669922 12.21632289886475 L 15.34035396575928 7.809983253479004 L 14.83901405334473 7.308643341064453 L 10.43267345428467 11.7149829864502 Z' stroke='none'/%3e %3cpath d='M 13.27701377868652 -2.6702880859375e-05 L 10.93401336669922 2.342973709106445 L 13.27701377868652 4.685972213745117 L 7.810012817382813 10.93398284912109 L 2.34300422668457 10.93398284912109 L 6.638504028320313 15.22949314117432 L 3.814697265625e-06 24.03078269958496 L 3.814697265625e-06 24.99199295043945 L 0.9612140655517578 24.99199295043945 L 9.762514114379883 18.35349273681641 L 14.05801391601563 22.64899253845215 L 14.05801391601563 17.18198394775391 L 20.30602264404297 11.7149829864502 L 22.64902305603027 14.0579833984375 L 24.99202346801758 11.7149829864502 L 13.27701377868652 -2.6702880859375e-05 M 10.93401336669922 13.2769832611084 L 9.372014045715332 11.7149829864502 L 14.83901405334473 6.24797248840332 L 16.4010124206543 7.809982299804688 L 10.93401336669922 13.2769832611084 M 13.27701377868652 -2.121347427368164 L 14.33767318725586 -1.060686111450195 L 26.05268287658691 10.65432357788086 L 27.11334419250488 11.7149829864502 L 26.05268287658691 12.77564334869385 L 23.70968437194824 15.11864280700684 L 22.64902305603027 16.17930221557617 L 21.58836364746094 15.11864280700684 L 20.2376708984375 13.7679500579834 L 15.55801391601563 17.86264419555664 L 15.55801391601563 22.64899253845215 L 15.55801391601563 26.27031326293945 L 12.99735355377197 23.70965385437012 L 9.624288558959961 20.33658790588379 L 1.864473342895508 26.18953323364258 L 1.463483810424805 26.49199295043945 L 0.9612140655517578 26.49199295043945 L 3.814697265625e-06 26.49199295043945 L -1.499996185302734 26.49199295043945 L -1.499996185302734 24.99199295043945 L -1.499996185302734 24.03078269958496 L -1.499996185302734 23.52851295471191 L -1.197536468505859 23.12751388549805 L 4.655405044555664 15.36771297454834 L 1.282342910766602 11.99464321136475 L -1.27830696105957 9.433982849121094 L 2.34300422668457 9.433982849121094 L 7.129352569580078 9.433982849121094 L 11.22404670715332 4.754325866699219 L 9.873353958129883 3.403633117675781 L 8.812694549560547 2.342973709106445 L 9.873353958129883 1.282312393188477 L 12.21635341644287 -1.060686111450195 L 13.27701377868652 -2.121347427368164 Z' stroke='none' fill='%23f9f9f9'/%3e %3c/g%3e%3c/svg%3e";
var img$i = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='28.613' height='28.613' viewBox='0 0 28.613 28.613'%3e %3cg id='pushpin' transform='translate(1.5 2.121)' fill='%23929292'%3e %3cpath d='M 1.212353587150574 25.74199295043945 L 0.9612136483192444 25.74199295043945 L 3.641357352535124e-06 25.74199295043945 L -0.7499963641166687 25.74199295043945 L -0.7499963641166687 24.99199295043945 L -0.7499963641166687 24.03078269958496 L -0.7499963641166687 23.77964401245117 L -0.5987663865089417 23.57915306091309 L 5.646956443786621 15.29860496520996 L 1.812673687934875 11.46431350708008 L 0.5323436260223389 10.18398284912109 L 2.343003749847412 10.18398284912109 L 7.469688415527344 10.18398284912109 L 12.25053310394287 4.720152378082275 L 10.40368366241455 2.873303174972534 L 9.873353958129883 2.342973232269287 L 10.40368366241455 1.81264317035675 L 12.74668407440186 -0.5303568840026855 L 13.27701377868652 -1.060686826705933 L 13.80734348297119 -0.5303568840026855 L 25.52235412597656 11.18465328216553 L 26.05268287658691 11.7149829864502 L 25.52235412597656 12.24531269073486 L 23.17935371398926 14.58831310272217 L 22.64902305603027 15.11864280700684 L 22.11869430541992 14.58831310272217 L 20.2718448638916 12.74146366119385 L 14.80801391601563 17.52230834960938 L 14.80801391601563 22.64899253845215 L 14.80801391601563 24.45965385437012 L 13.52768325805664 23.17932319641113 L 9.693401336669922 19.34504127502441 L 1.412843585014343 25.59076309204102 L 1.212353587150574 25.74199295043945 Z M 10.43267345428467 11.7149829864502 L 10.93401336669922 12.21632289886475 L 15.34035396575928 7.809983253479004 L 14.83901405334473 7.308643341064453 L 10.43267345428467 11.7149829864502 Z' stroke='none'/%3e %3cpath d='M 13.27701377868652 -2.6702880859375e-05 L 10.93401336669922 2.342973709106445 L 13.27701377868652 4.685972213745117 L 7.810012817382813 10.93398284912109 L 2.34300422668457 10.93398284912109 L 6.638504028320313 15.22949314117432 L 3.814697265625e-06 24.03078269958496 L 3.814697265625e-06 24.99199295043945 L 0.9612140655517578 24.99199295043945 L 9.762514114379883 18.35349273681641 L 14.05801391601563 22.64899253845215 L 14.05801391601563 17.18198394775391 L 20.30602264404297 11.7149829864502 L 22.64902305603027 14.0579833984375 L 24.99202346801758 11.7149829864502 L 13.27701377868652 -2.6702880859375e-05 M 10.93401336669922 13.2769832611084 L 9.372014045715332 11.7149829864502 L 14.83901405334473 6.24797248840332 L 16.4010124206543 7.809982299804688 L 10.93401336669922 13.2769832611084 M 13.27701377868652 -2.121347427368164 L 14.33767318725586 -1.060686111450195 L 26.05268287658691 10.65432357788086 L 27.11334419250488 11.7149829864502 L 26.05268287658691 12.77564334869385 L 23.70968437194824 15.11864280700684 L 22.64902305603027 16.17930221557617 L 21.58836364746094 15.11864280700684 L 20.2376708984375 13.7679500579834 L 15.55801391601563 17.86264419555664 L 15.55801391601563 22.64899253845215 L 15.55801391601563 26.27031326293945 L 12.99735355377197 23.70965385437012 L 9.624288558959961 20.33658790588379 L 1.864473342895508 26.18953323364258 L 1.463483810424805 26.49199295043945 L 0.9612140655517578 26.49199295043945 L 3.814697265625e-06 26.49199295043945 L -1.499996185302734 26.49199295043945 L -1.499996185302734 24.99199295043945 L -1.499996185302734 24.03078269958496 L -1.499996185302734 23.52851295471191 L -1.197536468505859 23.12751388549805 L 4.655405044555664 15.36771297454834 L 1.282342910766602 11.99464321136475 L -1.27830696105957 9.433982849121094 L 2.34300422668457 9.433982849121094 L 7.129352569580078 9.433982849121094 L 11.22404670715332 4.754325866699219 L 9.873353958129883 3.403633117675781 L 8.812694549560547 2.342973709106445 L 9.873353958129883 1.282312393188477 L 12.21635341644287 -1.060686111450195 L 13.27701377868652 -2.121347427368164 Z' stroke='none' fill='%23f9f9f9'/%3e %3c/g%3e%3c/svg%3e";
var img$j = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='28.613' height='28.613' viewBox='0 0 28.613 28.613'%3e %3cg id='pushpin' transform='translate(1.5 2.121)' fill='%23ed154e'%3e %3cpath d='M 1.212353587150574 25.74199295043945 L 0.9612136483192444 25.74199295043945 L 3.641357352535124e-06 25.74199295043945 L -0.7499963641166687 25.74199295043945 L -0.7499963641166687 24.99199295043945 L -0.7499963641166687 24.03078269958496 L -0.7499963641166687 23.77964401245117 L -0.5987663865089417 23.57915306091309 L 5.646956443786621 15.29860496520996 L 1.812673687934875 11.46431350708008 L 0.5323436260223389 10.18398284912109 L 2.343003749847412 10.18398284912109 L 7.469688415527344 10.18398284912109 L 12.25053310394287 4.720152378082275 L 10.40368366241455 2.873303174972534 L 9.873353958129883 2.342973232269287 L 10.40368366241455 1.81264317035675 L 12.74668407440186 -0.5303568840026855 L 13.27701377868652 -1.060686826705933 L 13.80734348297119 -0.5303568840026855 L 25.52235412597656 11.18465328216553 L 26.05268287658691 11.7149829864502 L 25.52235412597656 12.24531269073486 L 23.17935371398926 14.58831310272217 L 22.64902305603027 15.11864280700684 L 22.11869430541992 14.58831310272217 L 20.2718448638916 12.74146366119385 L 14.80801391601563 17.52230834960938 L 14.80801391601563 22.64899253845215 L 14.80801391601563 24.45965385437012 L 13.52768325805664 23.17932319641113 L 9.693401336669922 19.34504127502441 L 1.412843585014343 25.59076309204102 L 1.212353587150574 25.74199295043945 Z M 10.43267345428467 11.7149829864502 L 10.93401336669922 12.21632289886475 L 15.34035396575928 7.809983253479004 L 14.83901405334473 7.308643341064453 L 10.43267345428467 11.7149829864502 Z' stroke='none'/%3e %3cpath d='M 13.27701377868652 -2.6702880859375e-05 L 10.93401336669922 2.342973709106445 L 13.27701377868652 4.685972213745117 L 7.810012817382813 10.93398284912109 L 2.34300422668457 10.93398284912109 L 6.638504028320313 15.22949314117432 L 3.814697265625e-06 24.03078269958496 L 3.814697265625e-06 24.99199295043945 L 0.9612140655517578 24.99199295043945 L 9.762514114379883 18.35349273681641 L 14.05801391601563 22.64899253845215 L 14.05801391601563 17.18198394775391 L 20.30602264404297 11.7149829864502 L 22.64902305603027 14.0579833984375 L 24.99202346801758 11.7149829864502 L 13.27701377868652 -2.6702880859375e-05 M 10.93401336669922 13.2769832611084 L 9.372014045715332 11.7149829864502 L 14.83901405334473 6.24797248840332 L 16.4010124206543 7.809982299804688 L 10.93401336669922 13.2769832611084 M 13.27701377868652 -2.121347427368164 L 14.33767318725586 -1.060686111450195 L 26.05268287658691 10.65432357788086 L 27.11334419250488 11.7149829864502 L 26.05268287658691 12.77564334869385 L 23.70968437194824 15.11864280700684 L 22.64902305603027 16.17930221557617 L 21.58836364746094 15.11864280700684 L 20.2376708984375 13.7679500579834 L 15.55801391601563 17.86264419555664 L 15.55801391601563 22.64899253845215 L 15.55801391601563 26.27031326293945 L 12.99735355377197 23.70965385437012 L 9.624288558959961 20.33658790588379 L 1.864473342895508 26.18953323364258 L 1.463483810424805 26.49199295043945 L 0.9612140655517578 26.49199295043945 L 3.814697265625e-06 26.49199295043945 L -1.499996185302734 26.49199295043945 L -1.499996185302734 24.99199295043945 L -1.499996185302734 24.03078269958496 L -1.499996185302734 23.52851295471191 L -1.197536468505859 23.12751388549805 L 4.655405044555664 15.36771297454834 L 1.282342910766602 11.99464321136475 L -1.27830696105957 9.433982849121094 L 2.34300422668457 9.433982849121094 L 7.129352569580078 9.433982849121094 L 11.22404670715332 4.754325866699219 L 9.873353958129883 3.403633117675781 L 8.812694549560547 2.342973709106445 L 9.873353958129883 1.282312393188477 L 12.21635341644287 -1.060686111450195 L 13.27701377868652 -2.121347427368164 Z' stroke='none' fill='%23f9f9f9'/%3e %3c/g%3e%3c/svg%3e";

var PinButton = function PinButton(_ref115) {
  var color = _ref115.color,
      onClick = _ref115.onClick;
  return React.createElement(Button$1, {
    onClick: onClick,
    style: {
      minHeight: '2.25rem',
      minWidth: '2.25rem',
      maxHeight: '2.25rem',
      maxWidth: '2.25rem',
      borderRadius: '50%'
    }
  }, React.createElement("div", {
    style: {
      height: '1.5rem',
      width: '1.5rem'
    }
  }, React.createElement("img", {
    src: getIcon(color),
    style: {
      height: '100%',
      width: '100%'
    }
  })));
};

var getIcon = function getIcon(color) {
  if (color === 'white') {
    return img$h;
  }

  if (color === 'grey') {
    return img$i;
  }

  return img$j;
};

var useCommentItemStyles = makeStyles({
  container: {
    display: 'grid',
    gridTemplate: 'auto auto auto / calc(36px + 1rem) auto',
    gridColumnGap: '1em',
    backgroundColor: '#f9f9f9',
    marginBottom: '0.5em',
    borderRadius: '4px',
    opacity: 1
  },
  newCommentItem: {
    padding: '1rem'
  }
});

var CommentBadge = function CommentBadge(_ref116) {
  var index = _ref116.index,
      active = _ref116.active,
      comment = _ref116.comment,
      props = _objectWithoutProperties(_ref116, ["index", "active", "comment"]);

  var _a, _b;

  var _useContext148 = useContext(ActionsContext),
      focusOnCoordinates = _useContext148.focusOnCoordinates,
      setCardFace = _useContext148.setCardFace;

  var _useContext149 = useContext(UIStateContext.ImageViewer),
      cardFace = _useContext149.cardFace;

  var _useContext150 = useContext(UIStateContext.Scaffold),
      markerPrompt = _useContext150.markerPrompt;

  var commentUpdateQueue = useContext(UpdateQueueContext);
  var isUpdating = (_b = commentUpdateQueue.includes((_a = comment === null || comment === void 0 ? void 0 : comment.id) !== null && _a !== void 0 ? _a : '')) !== null && _b !== void 0 ? _b : props.isUpdating;

  var _useContext151 = useContext(DesignContext.Base),
      workflow = _useContext151.workflow;

  var _useSpring15 = useSpring({
    loop: true,
    from: {
      shadowRadius: 0,
      shadowOpacity: 0
    },
    to: function () {
      var _to2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee22(next) {
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.next = 2;
                return next({
                  shadowRadius: 0,
                  shadowOpacity: 0.6,
                  immediate: true,
                  delay: 900
                });

              case 2:
                _context22.next = 4;
                return next({
                  shadowRadius: 20,
                  shadowOpacity: 0,
                  config: {
                    duration: 600
                  }
                });

              case 4:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22);
      }));

      function to(_x6) {
        return _to2.apply(this, arguments);
      }

      return to;
    }()
  }),
      shadowRadius = _useSpring15.shadowRadius,
      shadowOpacity = _useSpring15.shadowOpacity;

  if (isUpdating) {
    return React.createElement(PlainNumberedBadge, {
      value: React.createElement(LoadingLabel, {
        label: "".concat(index),
        style: {
          height: '2.25rem',
          width: '2.25rem'
        }
      }),
      x: 0,
      y: 0,
      style: {
        position: 'static',
        border: 'none',
        height: '2.25rem',
        width: '2.25rem'
      },
      active: active
    });
  }

  if (typeof comment === 'undefined') {
    var hasCoords = (markerPrompt === null || markerPrompt === void 0 ? void 0 : markerPrompt.x) && (markerPrompt === null || markerPrompt === void 0 ? void 0 : markerPrompt.y);
    return React.createElement(PlainNumberedBadge, {
      value: index,
      style: {
        position: 'static',
        height: '2.25rem',
        width: '2.25rem',
        cursor: hasCoords ? 'pointer' : 'auto'
      },
      active: active,
      onClick: function onClick() {
        if (hasCoords) {
          focusOnCoordinates(markerPrompt === null || markerPrompt === void 0 ? void 0 : markerPrompt.x, markerPrompt === null || markerPrompt === void 0 ? void 0 : markerPrompt.x);
        }
      }
    });
  }

  var hadCoordinates = comment.x !== null && comment.y !== null;

  var onClick = function onClick() {
    if (hadCoordinates) {
      if (cardFace !== comment.cardFace) {
        setCardFace(comment.cardFace);
        setTimeout(function () {
          focusOnCoordinates(comment.x, comment.y);
        }, 500);
      } else {
        focusOnCoordinates(comment.x, comment.y);
      }
    }
  };

  if (comment.status === CommentStatus.Accepted) {
    return React.createElement(CheckedBadge, {
      style: {
        height: '2.25rem',
        width: '2.25rem',
        cursor: hadCoordinates ? 'pointer' : 'auto'
      },
      onClick: onClick
    });
  }

  if (comment.status === CommentStatus.Rejected) {
    return React.createElement(RejectedBadge, {
      style: {
        height: '2.25rem',
        width: '2.25rem',
        cursor: hadCoordinates ? 'pointer' : 'auto'
      },
      onClick: onClick
    });
  }

  return React.createElement(animated.div, {
    style: {
      width: '2.25rem',
      height: '2.25rem',
      borderRadius: '50%',
      background: active && workflow === Workflow.Review ? to([shadowRadius, shadowOpacity], function (sr, so) {
        return "rgba(237, 21, 78 , ".concat(so, ")");
      }) : 'transparent',
      boxShadow: active && workflow === Workflow.Review ? to([shadowRadius, shadowOpacity], function (sr, so) {
        return "0 0 0 ".concat(sr, "px rgba(237, 21, 78 , ").concat(so, ")");
      }) : 'none',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative'
    }
  }, React.createElement(PlainNumberedBadge, {
    value: index,
    x: 0,
    y: 0,
    style: {
      position: 'static',
      height: '2.25rem',
      width: '2.25rem',
      cursor: hadCoordinates ? 'pointer' : 'auto'
    },
    active: active,
    onClick: onClick
  }));
};

var NewCommentItemPrompt = function NewCommentItemPrompt(_ref117) {
  var activeCommentRef = _ref117.activeCommentRef,
      x = _ref117.x,
      y = _ref117.y;

  var _useContext152 = useContext(DesignContext.Derived),
      currentUser = _useContext152.currentUser;

  var comments = useContext(CommentsStore.Comments);

  var _useContext153 = useContext(UIStateContext.ImageViewer),
      cardFace = _useContext153.cardFace;

  var _useContext154 = useContext(RefsContext),
      imgElRef = _useContext154.imgElRef;

  var _useContext155 = useContext(ActionsContext),
      cancelAddMarker = _useContext155.cancelAddMarker,
      closeUnpinnedCommentPrompt = _useContext155.closeUnpinnedCommentPrompt,
      addCommentMarker = _useContext155.addCommentMarker,
      pinComment = _useContext155.pinComment;

  var classes = useCommentItemStyles();
  var fadeInTransition = useTransition(true, {
    from: {
      opacity: 0,
      translateY: 30
    },
    enter: {
      opacity: 1,
      translateY: 0
    },
    leave: {
      opacity: 0,
      translateY: 30
    }
  });

  var _useState105 = useState(false),
      _useState106 = _slicedToArray(_useState105, 2),
      isLoading = _useState106[0],
      setIsLoading = _useState106[1];

  var _useState107 = useState(''),
      _useState108 = _slicedToArray(_useState107, 2),
      message = _useState108[0],
      setMessage = _useState108[1];

  var payloadCoords = {
    x: x,
    y: y
  };

  if (!_isNil(x) && !_isNil(y)) {
    var imageEl = imgElRef.current;

    if (imageEl !== null) {
      var _isPortrait = imageEl.naturalHeight > imageEl.naturalWidth;

      if (_isPortrait) {
        payloadCoords = {
          x: y,
          y: x
        };
      }
    }
  }

  return React.createElement(Fragment, null, fadeInTransition(function (_ref118) {
    var opacity = _ref118.opacity,
        translateY = _ref118.translateY;
    return React.createElement(animated.div, {
      ref: activeCommentRef,
      style: {
        marginRight: '1rem',
        marginLeft: '1rem',
        cursor: 'pointer',
        opacity: opacity,
        translateY: translateY
      },
      className: "comment-item",
      "data-id": "new-comment"
    }, React.createElement(AnimatedPaper, {
      style: {
        backgroundColor: '#f9f9f9'
      }
    }, React.createElement("div", {
      style: {
        padding: '1rem 1rem 0 1rem',
        display: 'flex'
      }
    }, React.createElement(CommentBadge, {
      index: comments.length + 1,
      active: true
    }), React.createElement("div", {
      style: {
        marginLeft: '1rem'
      }
    }, React.createElement("span", {
      style: {
        fontWeight: 'bold',
        fontSize: '0.8rem',
        marginRight: '0.5em',
        color: '#929292'
      }
    }, currentUser.name), React.createElement("span", {
      style: {
        fontWeight: 'bold',
        fontSize: '0.8rem',
        marginRight: '0.5em',
        color: '#929292'
      }
    }, "\u2022"), React.createElement("span", {
      style: {
        fontSize: '0.8rem',
        color: '#929292'
      }
    }, formatDate(Date.now(), 'MMM d')))), React.createElement("div", {
      className: classes.newCommentItem
    }, React.createElement(TextField, {
      autoFocus: true,
      style: {
        width: '100%'
      },
      multiline: true,
      rows: 4,
      variant: "filled",
      placeholder: "Enter your comment here",
      onChange: function onChange(e) {
        setMessage(e.target.value);
      },
      InputProps: {
        style: {
          padding: '1em'
        }
      }
    }), React.createElement("div", {
      style: {
        marginTop: '8px',
        display: 'flex',
        justifyContent: 'space-between'
      }
    }, React.createElement("div", null, React.createElement(PinButton, {
      onClick: function onClick() {
        pinComment();
      },
      color: _isNil(x) || _isNil(y) ? 'grey' : 'pink'
    })), React.createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'flex-end'
      }
    }, React.createElement(Button$1, {
      style: {
        color: '#929292',
        textTransform: 'uppercase'
      },
      onClick: function onClick() {
        cancelAddMarker();
        closeUnpinnedCommentPrompt();
      }
    }, "Cancel"), React.createElement(Button$1, {
      style: {
        color: message === '' ? '#929292' : Colors.MVP_LIGHT_PINK,
        textTransform: 'uppercase'
      },
      disabled: message === '' || isLoading,
      onClick: function () {
        var _onClick11 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee23() {
          var _a, _b;

          return _regeneratorRuntime.wrap(function _callee23$(_context23) {
            while (1) {
              switch (_context23.prev = _context23.next) {
                case 0:
                  setIsLoading(true);
                  _context23.next = 3;
                  return addCommentMarker({
                    cardFace: cardFace,
                    x: (_a = payloadCoords.x) !== null && _a !== void 0 ? _a : null,
                    y: (_b = payloadCoords.y) !== null && _b !== void 0 ? _b : null,
                    message: message
                  });

                case 3:
                case "end":
                  return _context23.stop();
              }
            }
          }, _callee23);
        }));

        function onClick() {
          return _onClick11.apply(this, arguments);
        }

        return onClick;
      }()
    }, isLoading ? React.createElement(CircularProgress, {
      style: {
        width: '18px',
        height: '18px'
      }
    }) : 'Add'))))));
  }));
};

var CommentItemContext = createContext({});

var useCommentItem = function useCommentItem(_ref119) {
  var comment = _ref119.comment,
      isActive = _ref119.isActive,
      isExpanded = _ref119.isExpanded;
  var canReadMore = useRef(false);
  var canExpand = canReadMore.current || comment.messages.length > 1;

  var _useContext156 = useContext(UIStateContext.Derived.Scaffold),
      activeComment = _useContext156.activeComment;

  var _useContext157 = useContext(ActionsContext),
      setActiveComment = _useContext157.setActiveComment;

  var oneEm = 14;
  var topHeaderHeight = 48;
  var expandedHeight = topHeaderHeight + 2 * oneEm;

  var _useSpring16 = useSpring({
    translateY: isExpanded ? expandedHeight : oneEm
  }),
      translateY = _useSpring16.translateY;

  var fadeInTransition = useTransition(isExpanded, {
    from: {
      opacity: 0
    },
    enter: {
      opacity: 1
    },
    leave: {
      opacity: 0
    }
  });

  var expandComment = function expandComment() {
    setActiveComment({
      id: comment.id,
      isExpanded: true
    });
  };

  var collapseComment = function collapseComment() {
    if (isActive && activeComment) {
      setActiveComment(_objectSpread({}, activeComment, {
        isExpanded: false
      }));
    }
  };

  var _useSpring17 = useSpring({
    transform: isActive ? 'scale(1.0)' : 'scale(0.9)',
    opacity: getOpacity(isActive),
    marginRight: 0,
    borderRadius: 4
  }),
      transform = _useSpring17.transform,
      opacity = _useSpring17.opacity,
      marginRight = _useSpring17.marginRight,
      borderRadius = _useSpring17.borderRadius;

  return {
    canReadMore: canReadMore,
    canExpand: canExpand,
    expandComment: expandComment,
    collapseComment: collapseComment,
    transform: transform,
    opacity: opacity,
    marginRight: marginRight,
    borderRadius: borderRadius,
    translateY: translateY,
    fadeInTransition: fadeInTransition
  };
};

var getOpacity = function getOpacity(isActive) {
  if (isActive) {
    return 1.0;
  }

  return 0.8;
};

var CommentMessageHeight = 80;

var CommentMessages = function CommentMessages(_ref120) {
  var messagesProp = _ref120.messages,
      isExpanded = _ref120.isExpanded,
      expandComment = _ref120.expandComment,
      collapseComment = _ref120.collapseComment,
      messagesAddon = _ref120.messagesAddon,
      _ref120$collapsedVisi = _ref120.collapsedVisibleIndexes,
      collapsedVisibleIndexes = _ref120$collapsedVisi === void 0 ? [0] : _ref120$collapsedVisi;

  var _a, _b, _c;

  var _useContext158 = useContext(DesignReviewContext),
      _useContext158$resize = _useContext158.resizeHandlerProps,
      sidebarViewingAreaMeasure = _useContext158$resize.sidebarViewingAreaMeasure,
      controlAreaRef = _useContext158$resize.controlAreaRef;

  var _useContext159 = useContext(CommentItemContext),
      canReadMore = _useContext159.canReadMore,
      translateY = _useContext159.translateY;

  var messageRef = useRef(null);
  var firstMessageRef = useRef(null);
  var oneEm = 14;
  var maxHeight = sidebarViewingAreaMeasure.height - ((_a = controlAreaRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) + oneEm;
  var messageHeight = (_c = (_b = messageRef.current) === null || _b === void 0 ? void 0 : _b.scrollHeight) !== null && _c !== void 0 ? _c : 0;
  var expandedHeight = Math.min(maxHeight, messageHeight);

  if (expandedHeight < -1) {
    expandedHeight = messageHeight;
  }

  var _useSpring18 = useSpring({
    height: isExpanded ? "".concat(expandedHeight, "px") : "".concat(CommentMessageHeight, "px")
  }),
      height = _useSpring18.height;

  useEffect(function () {
    var _a, _b;

    canReadMore.current = ((_b = (_a = firstMessageRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight) !== null && _b !== void 0 ? _b : 0) > 60;
  }, [messagesProp]);
  useEffect(function () {
    var _a, _b, _c;

    if (!isExpanded) {
      (_a = messageRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo(0, 0);
    } else {
      (_b = messageRef.current) === null || _b === void 0 ? void 0 : _b.scrollTo(0, (_c = messageRef.current) === null || _c === void 0 ? void 0 : _c.scrollHeight);
    }
  }, [isExpanded]);

  if (!messagesProp) {
    return null;
  }

  var messages = messagesProp;
  var messagesLength = messages[0].message.length;
  return React.createElement(Fragment, null, React.createElement(animated.div, {
    ref: messageRef,
    style: {
      height: height,
      overflowX: 'hidden',
      overflowY: isExpanded ? 'auto' : 'hidden',
      paddingRight: '2em'
    }
  }, messages.map(function (m, i) {
    var visibility = 'hidden';

    if (isExpanded || collapsedVisibleIndexes.includes(i)) {
      visibility = 'visible';
    }

    return React.createElement("div", {
      key: i,
      style: {
        width: '100%',
        visibility: visibility
      }
    }, React.createElement("div", null, React.createElement("span", {
      style: {
        fontWeight: 'bold',
        fontSize: '0.8rem',
        marginRight: '0.5em',
        color: '#929292'
      }
    }, m.postedBy), React.createElement("span", {
      style: {
        fontWeight: 'bold',
        fontSize: '0.8rem',
        marginRight: '0.5em',
        color: '#929292'
      }
    }, "\u2022"), React.createElement("span", {
      style: {
        fontSize: '0.8rem',
        color: '#929292'
      }
    }, formatDate(m.datePosted, 'MMM d'))), React.createElement("div", {
      ref: i === 0 ? firstMessageRef : undefined,
      style: {
        textOverflow: 'ellipsis',
        textAlign: 'left',
        wordBreak: 'break-word'
      }
    }, m.message), i !== messages.length - 1 && isExpanded && React.createElement(Divider, {
      style: {
        margin: '1em 0'
      }
    }));
  }), messagesAddon, React.createElement("div", {
    style: {
      height: '76px',
      visibility: isExpanded ? 'visible' : 'hidden'
    }
  }), isExpanded && (canReadMore.current || messagesLength > CommentMessageHeight) && React.createElement(animated.div, {
    style: {
      height: '36px',
      marginTop: '6px',
      transform: translateY.to(function (ty) {
        return "translateY(-".concat(ty, "px)");
      })
    }
  }, React.createElement(Button$1, {
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      collapseComment();
    },
    style: {
      color: '#ed154e',
      textTransform: 'none'
    }
  }, "Read Less"))), !isExpanded && (canReadMore.current || messagesLength > CommentMessageHeight) && React.createElement("div", {
    style: {
      height: '36px',
      marginTop: '6px'
    }
  }, React.createElement(Button$1, {
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      expandComment();
    },
    style: {
      color: '#ed154e',
      textTransform: 'none'
    }
  }, "Read More")));
};

var CommentItemScaffold = function CommentItemScaffold(_ref121) {
  var badge = _ref121.badge,
      actionsSection = _ref121.actionsSection,
      expandComment = _ref121.expandComment,
      collapseComment = _ref121.collapseComment,
      collapsedVisibleIndexes = _ref121.collapsedVisibleIndexes,
      messagesAddOn = _ref121.messagesAddOn,
      messagesOverride = _ref121.messagesOverride,
      bottomLeftSection = _ref121.bottomLeftSection;

  var _useContext160 = useContext(CommentItemContext),
      comment = _useContext160.comment,
      isExpanded = _useContext160.isExpanded,
      isActive = _useContext160.isActive,
      activeCommentRef = _useContext160.activeCommentRef,
      setActiveComment = _useContext160.setActiveComment,
      style = _useContext160.style,
      transform = _useContext160.transform,
      opacity = _useContext160.opacity,
      marginRight = _useContext160.marginRight,
      borderRadius = _useContext160.borderRadius,
      translateY = _useContext160.translateY,
      fadeInTransition = _useContext160.fadeInTransition;

  var classes = useCommentItemStyles();
  return React.createElement(animated.div, {
    ref: activeCommentRef,
    style: {
      transform: transform,
      opacity: opacity,
      marginRight: marginRight.to(function (m) {
        return "".concat(m, "em");
      }),
      cursor: isActive || isExpanded ? 'auto' : 'pointer'
    },
    className: "comment-item",
    "data-id": comment.id
  }, React.createElement(AnimatedPaper, {
    style: _objectSpread({
      backgroundColor: '#f9f9f9',
      borderRadius: borderRadius
    }, style),
    onClick: function onClick() {
      setActiveComment(comment.id);
    }
  }, React.createElement("div", {
    className: classes.container
  }, React.createElement(Box, {
    style: {
      gridArea: '1 / 1 / span 1 / span 2',
      display: 'flex',
      alignItems: 'center',
      height: 'calc(36px + 2rem)',
      padding: '1rem'
    },
    boxShadow: isExpanded ? 3 : 0
  }, React.createElement("div", {
    style: {
      marginRight: '1rem'
    }
  }, badge), fadeInTransition(function (_ref122, isExpanded) {
    var opacity = _ref122.opacity;
    if (!isExpanded) return null;
    return React.createElement(Fragment, null, React.createElement(animated.div, {
      style: {
        opacity: opacity,
        marginRight: 'auto',
        cursor: 'auto'
      }
    }, "Revision Comments (".concat(comment.messages.length, ")")), React.createElement(animated.div, {
      style: {
        opacity: opacity
      }
    }, React.createElement(Button$1, {
      onClick: function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        collapseComment();
      },
      style: {
        color: '#929292',
        minWidth: 0,
        padding: '6px 0'
      }
    }, React.createElement(Close, null))));
  })), React.createElement(animated.div, {
    style: {
      gridArea: '1 / 2 / span 1 / span 1',
      transform: translateY.to(function (ty) {
        return "translateY(".concat(ty, "px)");
      })
    }
  }, React.createElement(CommentMessages, {
    messages: messagesOverride !== null && messagesOverride !== void 0 ? messagesOverride : comment.messages,
    isExpanded: isExpanded,
    expandComment: expandComment,
    collapseComment: collapseComment,
    messagesAddon: messagesAddOn,
    collapsedVisibleIndexes: collapsedVisibleIndexes
  })), React.createElement("div", {
    style: {
      gridArea: '3 / 1 / span 1 / span 1',
      paddingLeft: '1rem',
      display: 'grid',
      placeItems: 'center'
    }
  }, bottomLeftSection), React.createElement("div", {
    style: {
      gridArea: '3 / 2 / span 1 / span 1',
      display: 'flex',
      justifyContent: 'flex-end',
      width: '100%',
      position: 'relative',
      marginTop: '1rem',
      paddingRight: '1rem',
      paddingBottom: '1rem',
      backgroundColor: '#f9f9f9',
      borderRadius: '4px'
    }
  }, !isExpanded && React.createElement(ExpandButton, {
    isExpanded: isExpanded,
    expandComment: expandComment,
    count: comment.messages.length
  }), actionsSection))));
};

var RequestCommentItem = function RequestCommentItem() {
  var _useContext161 = useContext(CommentItemContext),
      index = _useContext161.index,
      comment = _useContext161.comment,
      isActive = _useContext161.isActive,
      isExpanded = _useContext161.isExpanded,
      expandComment = _useContext161.expandComment,
      collapseComment = _useContext161.collapseComment,
      canReadMore = _useContext161.canReadMore;

  var _useContext162 = useContext(UIStateContext.Derived.Sidebar),
      isEditingComment = _useContext162.isEditingComment;

  var _useContext163 = useContext(ActionsContext),
      commentActionFactory = _useContext163.commentActionFactory,
      openModal = _useContext163.openModal,
      pinComment = _useContext163.pinComment,
      setIsEditingComment = _useContext163.setIsEditingComment;

  var updateLastMessageOnCommentMarker = commentActionFactory.updateLastMessageOnCommentMarker(comment);

  var _useState109 = useState(false),
      _useState110 = _slicedToArray(_useState109, 2),
      isConfirmingDiscardDraft = _useState110[0],
      setIsConfirmingDiscardDraft = _useState110[1];

  var lastMessage = comment.messages[comment.messages.length - 1].message;

  var _useState111 = useState(lastMessage),
      _useState112 = _slicedToArray(_useState111, 2),
      editMessageDraft = _useState112[0],
      setEditMessageDraft = _useState112[1];

  var _useState113 = useState(isEditingComment),
      _useState114 = _slicedToArray(_useState113, 2),
      isCurrentEditing = _useState114[0],
      setIsCurrentEditing = _useState114[1];

  var fadeTransition = useTransition(isCurrentEditing, {
    from: {
      opacity: 0,
      translateY: 24
    },
    enter: {
      opacity: 1,
      translateY: 0
    },
    leave: {
      opacity: 0,
      translateY: 24
    }
  });

  var collapseRequestComment = function collapseRequestComment() {
    setIsEditingComment(false);
    setIsCurrentEditing(false);
    collapseComment();
  };

  var handleDelete =
  /*#__PURE__*/
  function () {
    var _ref123 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee24() {
      return _regeneratorRuntime.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              openModal({
                type: ModalTypes.DeleteComment,
                args: {
                  id: comment.id
                }
              });

            case 1:
            case "end":
              return _context24.stop();
          }
        }
      }, _callee24);
    }));

    return function handleDelete() {
      return _ref123.apply(this, arguments);
    };
  }();

  var handleConfirmUpdate =
  /*#__PURE__*/
  function () {
    var _ref124 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee25() {
      return _regeneratorRuntime.wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              updateLastMessageOnCommentMarker(editMessageDraft);
              collapseRequestComment();

            case 2:
            case "end":
              return _context25.stop();
          }
        }
      }, _callee25);
    }));

    return function handleConfirmUpdate() {
      return _ref124.apply(this, arguments);
    };
  }();

  var confirmDiscardDraft = function confirmDiscardDraft() {
    var nextMessageValid = editMessageDraft !== '' && editMessageDraft !== lastMessage;

    if (isEditingComment && nextMessageValid && isCurrentEditing) {
      setIsConfirmingDiscardDraft(true);
    } else {
      collapseRequestComment();
    }
  };

  useEffect(function () {
    if (isActive && isEditingComment && !isExpanded) {
      expandComment();
    }

    if (isActive && isEditingComment && isExpanded) {
      setIsCurrentEditing(true);
    }
  }, [isActive, isEditingComment, isExpanded]);
  var inputRef = useRef(null);
  var editMessageDraftLength = editMessageDraft.length;
  useEffect(function () {
    if (inputRef.current !== null) {
      inputRef.current.selectionStart = editMessageDraftLength;
      inputRef.current.selectionEnd = editMessageDraftLength;
    }
  }, [isEditingComment]);
  return React.createElement(Fragment, null, React.createElement(ClickAwayListener, {
    onClickAway: function onClickAway(e) {
      var el = e.target;
      var classNames = typeof el.className === 'string' ? el.className.split(' ') : [];
      var isCancelling = classNames.includes('el-ignore-click-away');

      if (!isCancelling && isEditingComment && editMessageDraft !== '' && isCurrentEditing) {
        e.preventDefault();
        e.stopPropagation();
        setIsConfirmingDiscardDraft(true);
      }
    }
  }, React.createElement("div", null, React.createElement(CommentItemScaffold, {
    expandComment: expandComment,
    collapseComment: confirmDiscardDraft,
    badge: React.createElement(CommentBadge, {
      index: index + 1,
      comment: comment,
      active: isActive
    }),
    actionsSection: React.createElement(ActionsSection, {
      isEditing: isEditingComment,
      handleDelete: handleDelete,
      handleConfirmUpdate: handleConfirmUpdate,
      handleCancel: confirmDiscardDraft,
      setIsEditing: setIsEditingComment,
      addDisabled: editMessageDraft === ''
    }),
    messagesAddOn: fadeTransition(function (_ref125, isEditing) {
      var opacity = _ref125.opacity,
          translateY = _ref125.translateY;
      if (!isEditing) return null;
      return React.createElement(animated.div, {
        style: {
          marginTop: '1em',
          paddingRight: '1em',
          opacity: opacity,
          transform: translateY.to(function (ty) {
            return "translateY(".concat(ty, "px)");
          })
        }
      }, React.createElement(Alert, {
        severity: "error",
        color: "warning"
      }, "Darn looks like we got it wrong. Can you tell us what we missed?"), React.createElement(TextField, {
        inputRef: inputRef,
        autoFocus: true,
        style: {
          width: '100%',
          marginTop: '1em',
          marginBottom: '1em'
        },
        multiline: true,
        rows: 2,
        variant: "filled",
        value: editMessageDraft,
        onChange: function onChange(e) {
          setEditMessageDraft(e.target.value);
        },
        InputProps: {
          style: {
            padding: '1em'
          }
        }
      }));
    }),
    bottomLeftSection: React.createElement("div", {
      style: {
        marginBottom: '0.25rem'
      }
    }, React.createElement(PinButton, {
      onClick: function onClick() {
        pinComment(comment.id);
      },
      color: comment.x === null || comment.y === null ? 'grey' : 'pink'
    }))
  }))), React.createElement(DiscardDraftCommentMessageModal, {
    open: isConfirmingDiscardDraft,
    confirmDiscard: function confirmDiscard() {
      setIsConfirmingDiscardDraft(false);
      collapseRequestComment();
      setEditMessageDraft(lastMessage);
    },
    closeModal: function closeModal() {
      setIsConfirmingDiscardDraft(false);
    }
  }));
};

var ActionsSection = function ActionsSection(_ref126) {
  var isEditing = _ref126.isEditing,
      handleDelete = _ref126.handleDelete,
      handleCancel = _ref126.handleCancel,
      handleConfirmUpdate = _ref126.handleConfirmUpdate,
      setIsEditing = _ref126.setIsEditing,
      addDisabled = _ref126.addDisabled;

  var _useContext164 = useContext(CommentItemContext),
      isActive = _useContext164.isActive;

  if (isEditing && isActive) {
    return React.createElement(Fragment, null, React.createElement(Button$1, {
      onClick: handleCancel,
      style: {
        textTransform: 'uppercase',
        color: '#929292'
      }
    }, "Cancel"), React.createElement(Button$1, {
      disabled: addDisabled,
      onClick: function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        handleConfirmUpdate();
      },
      style: {
        textTransform: 'uppercase',
        color: addDisabled ? '#929292' : '#ed154e'
      }
    }, "Update"));
  }

  return React.createElement(Fragment, null, React.createElement(Button$1, {
    onClick: function onClick() {
      setIsEditing(true);
    },
    style: {
      textTransform: 'uppercase',
      color: '#929292'
    },
    variant: "text",
    color: "secondary"
  }, "Edit"), React.createElement(Button$1, {
    onClick: handleDelete,
    style: {
      textTransform: 'uppercase',
      color: '#929292'
    },
    variant: "text",
    color: "secondary"
  }, "Delete"));
};

var PendingComment = function PendingComment() {
  var _useContext165 = useContext(CommentItemContext),
      index = _useContext165.index,
      comment = _useContext165.comment,
      isActive = _useContext165.isActive,
      isExpanded = _useContext165.isExpanded,
      expandComment = _useContext165.expandComment,
      collapseComment = _useContext165.collapseComment;

  var _useContext166 = useContext(DesignReviewContext),
      moveToNextComment = _useContext166.moveToNextComment;

  var comments = useContext(CommentsStore.Comments);

  var _useContext167 = useContext(UIStateContext.Scaffold),
      isViewingPrevious = _useContext167.isViewingPrevious;

  var _useContext168 = useContext(ActionsContext),
      commentActionFactory = _useContext168.commentActionFactory,
      proceedToFinalLook = _useContext168.proceedToFinalLook,
      setIsEditingComment = _useContext168.setIsEditingComment;

  var acceptCommentMarker = commentActionFactory.acceptCommentMarker(comment);
  var rejectCommentMarker = commentActionFactory.rejectCommentMarker(comment);

  var _useState115 = useState(false),
      _useState116 = _slicedToArray(_useState115, 2),
      isConfirmingDiscardDraft = _useState116[0],
      setIsConfirmingDiscardDraft = _useState116[1];

  var _useState117 = useState(false),
      _useState118 = _slicedToArray(_useState117, 2),
      isRejecting = _useState118[0],
      setIsRejecting = _useState118[1];

  var _useState119 = useState(''),
      _useState120 = _slicedToArray(_useState119, 2),
      rejectMessage = _useState120[0],
      setRejectMessageBase = _useState120[1];

  var setRejectMessage = function setRejectMessage(message) {
    setRejectMessageBase(message);

    if (message !== '') {
      setIsEditingComment(true);
    } else {
      setIsEditingComment(false);
    }
  };

  var fadeTransition = useTransition(isRejecting, {
    from: {
      opacity: 0,
      translateY: 24
    },
    enter: {
      opacity: 1,
      translateY: 0
    },
    leave: {
      opacity: 0,
      translateY: 24
    }
  });

  var handleAccept =
  /*#__PURE__*/
  function () {
    var _ref127 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee26() {
      var nextActiveComment, isLastCommentForReview, _comment;

      return _regeneratorRuntime.wrap(function _callee26$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              _context26.next = 2;
              return acceptCommentMarker();

            case 2:
              nextActiveComment = moveToNextComment();
              isLastCommentForReview = false;

              if (nextActiveComment !== null) {
                _comment = comments.find(function (c) {
                  return c.id === nextActiveComment.id;
                });

                if ((_comment === null || _comment === void 0 ? void 0 : _comment.status) === CommentStatus.Accepted) {
                  isLastCommentForReview = true;
                }
              } else {
                isLastCommentForReview = true;
              }

              if (isLastCommentForReview) {
                proceedToFinalLook();
              }

            case 6:
            case "end":
              return _context26.stop();
          }
        }
      }, _callee26);
    }));

    return function handleAccept() {
      return _ref127.apply(this, arguments);
    };
  }();

  var handleConfirmReject =
  /*#__PURE__*/
  function () {
    var _ref128 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee27() {
      var nextActiveComment, isLastCommentForReview, _comment2;

      return _regeneratorRuntime.wrap(function _callee27$(_context27) {
        while (1) {
          switch (_context27.prev = _context27.next) {
            case 0:
              _context27.next = 2;
              return rejectCommentMarker(rejectMessage);

            case 2:
              setIsRejecting(false);
              setIsEditingComment(false);
              collapseComment();
              nextActiveComment = moveToNextComment();
              isLastCommentForReview = false;

              if (nextActiveComment !== null) {
                _comment2 = comments.find(function (c) {
                  return c.id === nextActiveComment.id;
                });

                if ((_comment2 === null || _comment2 === void 0 ? void 0 : _comment2.status) === CommentStatus.Accepted) {
                  isLastCommentForReview = true;
                }
              } else {
                isLastCommentForReview = true;
              }

              if (isLastCommentForReview) {
                proceedToFinalLook();
              }

            case 9:
            case "end":
              return _context27.stop();
          }
        }
      }, _callee27);
    }));

    return function handleConfirmReject() {
      return _ref128.apply(this, arguments);
    };
  }();

  var confirmDiscardDraft = function confirmDiscardDraft() {
    if (isRejecting && rejectMessage !== '') {
      setIsConfirmingDiscardDraft(true);
    } else {
      collapsePendingComment();
    }
  };

  var collapsePendingComment = function collapsePendingComment() {
    setIsRejecting(false);
    setRejectMessage('');
    collapseComment();
  };

  useEffect(function () {
    if (isActive && isRejecting && !isExpanded) {
      expandComment();
    }
  });
  return React.createElement(Fragment, null, React.createElement(ClickAwayListener, {
    onClickAway: function onClickAway(e) {
      var el = e.target;
      var classNames = typeof el.className === 'string' ? el.className.split(' ') : [];
      var isCancelling = classNames.includes('el-ignore-click-away');

      if (!isCancelling && isRejecting && rejectMessage !== '') {
        e.preventDefault();
        e.stopPropagation();
        setIsConfirmingDiscardDraft(true);
      }
    }
  }, React.createElement("div", null, React.createElement(CommentItemScaffold, {
    expandComment: expandComment,
    collapseComment: confirmDiscardDraft,
    badge: React.createElement(CommentBadge, {
      index: index + 1,
      comment: comment,
      active: isActive
    }),
    actionsSection: React.createElement(ActionsSection$1, {
      isViewingPrevious: isViewingPrevious,
      isRejecting: isRejecting,
      handleAccept: handleAccept,
      handleConfirmReject: handleConfirmReject,
      handleCancel: confirmDiscardDraft,
      setIsRejecting: setIsRejecting,
      addDisabled: rejectMessage === ''
    }),
    messagesAddOn: fadeTransition(function (_ref129, isRejecting) {
      var opacity = _ref129.opacity,
          translateY = _ref129.translateY;
      if (!isRejecting) return null;
      return React.createElement(animated.div, {
        style: {
          marginTop: '1em',
          paddingRight: '1em',
          opacity: opacity,
          transform: translateY.to(function (ty) {
            return "translateY(".concat(ty, "px)");
          })
        }
      }, React.createElement(Alert, {
        severity: "error",
        color: "warning"
      }, "Darn looks like we got it wrong. Can you tell us what we missed?"), React.createElement(TextField, {
        autoFocus: true,
        style: {
          width: '100%',
          marginTop: '1em',
          marginBottom: '1em'
        },
        multiline: true,
        rows: 2,
        variant: "filled",
        value: rejectMessage,
        onChange: function onChange(e) {
          setRejectMessage(e.target.value);
        },
        InputProps: {
          style: {
            padding: '1em'
          }
        }
      }));
    })
  }))), React.createElement(DiscardDraftCommentMessageModal, {
    open: isConfirmingDiscardDraft,
    confirmDiscard: function confirmDiscard() {
      setIsConfirmingDiscardDraft(false);
      collapsePendingComment();
    },
    closeModal: function closeModal() {
      setIsConfirmingDiscardDraft(false);
    }
  }));
};

var ActionsSection$1 = function ActionsSection$1(_ref130) {
  var isViewingPrevious = _ref130.isViewingPrevious,
      isRejecting = _ref130.isRejecting,
      handleAccept = _ref130.handleAccept,
      handleCancel = _ref130.handleCancel,
      handleConfirmReject = _ref130.handleConfirmReject,
      setIsRejecting = _ref130.setIsRejecting,
      addDisabled = _ref130.addDisabled;

  var _useContext169 = useContext(CommentItemContext),
      isExpanded = _useContext169.isExpanded,
      expandComment = _useContext169.expandComment;

  if (isViewingPrevious) {
    return React.createElement(Fragment, null, React.createElement(Button$1, {
      onClick: function onClick() {},
      disabled: true
    }, "\xA0"), React.createElement(Typography, {
      style: {
        color: '#929292',
        display: 'flex',
        fontStyle: 'italic',
        alignItems: 'center',
        paddingRight: '8px'
      }
    }, "Previous Version"));
  }

  if (isRejecting) {
    return React.createElement(Fragment, null, React.createElement(Button$1, {
      onClick: handleCancel,
      style: {
        textTransform: 'uppercase',
        color: '#929292'
      }
    }, "Cancel"), React.createElement(Button$1, {
      disabled: addDisabled,
      onClick: handleConfirmReject,
      style: {
        textTransform: 'uppercase',
        color: addDisabled ? '#929292' : '#ed154e'
      }
    }, "Add"));
  }

  return React.createElement(Fragment, null, React.createElement(Button$1, {
    onClick: function onClick() {
      if (!isExpanded) {
        expandComment();
      }

      setIsRejecting(true);
    },
    style: {
      textTransform: 'uppercase',
      color: '#929292'
    },
    variant: "text",
    color: "secondary"
  }, "Reject"), React.createElement(Button$1, {
    onClick: handleAccept,
    style: {
      textTransform: 'uppercase',
      color: '#ed154e'
    },
    variant: "text",
    color: "secondary"
  }, "Accept"));
};

var AcceptedComment = function AcceptedComment() {
  var _useContext170 = useContext(CommentItemContext),
      index = _useContext170.index,
      comment = _useContext170.comment,
      isActive = _useContext170.isActive,
      expandComment = _useContext170.expandComment,
      collapseComment = _useContext170.collapseComment;

  var _useContext171 = useContext(ActionsContext),
      openModal = _useContext171.openModal;

  return React.createElement(CommentItemScaffold, {
    expandComment: expandComment,
    collapseComment: collapseComment,
    badge: React.createElement(CommentBadge, {
      index: index + 1,
      comment: comment,
      active: isActive
    }),
    actionsSection: React.createElement(Fragment, null, React.createElement(Button$1, {
      onClick: function onClick() {
        openModal({
          type: ModalTypes.UndoAcceptedComment,
          args: {
            id: comment.id
          }
        });
      },
      style: {
        textTransform: 'uppercase',
        color: '#929292'
      }
    }, "Undo"), React.createElement(Button$1, {
      disabled: true,
      style: {
        textTransform: 'uppercase',
        color: '#0d951b'
      }
    }, React.createElement(Check, null), " Accepted"))
  });
};

var RejectedComment = function RejectedComment() {
  var _useContext172 = useContext(CommentItemContext),
      cardFace = _useContext172.cardFace,
      index = _useContext172.index,
      comment = _useContext172.comment,
      isActive = _useContext172.isActive,
      isExpanded = _useContext172.isExpanded,
      expandComment = _useContext172.expandComment,
      collapseComment = _useContext172.collapseComment;

  var inputRef = createRef();

  var _useContext173 = useContext(DesignReviewContext),
      moveToNextComment = _useContext173.moveToNextComment;

  var _useContext174 = useContext(UIStateContext.Derived.Sidebar),
      isEditingComment = _useContext174.isEditingComment;

  var _useContext175 = useContext(ActionsContext),
      openModal = _useContext175.openModal,
      commentActionFactory = _useContext175.commentActionFactory,
      setIsEditingComment = _useContext175.setIsEditingComment;

  var acceptCommentMarker = commentActionFactory.acceptCommentMarker(comment);
  var updateLastMessageOnCommentMarker = commentActionFactory.updateLastMessageOnCommentMarker(comment);

  var _useState121 = useState(false),
      _useState122 = _slicedToArray(_useState121, 2),
      isConfirmingDiscardDraft = _useState122[0],
      setIsConfirmingDiscardDraft = _useState122[1];

  var threadLastComment = comment.messages[comment.messages.length - 1].message;

  var _useState123 = useState(threadLastComment),
      _useState124 = _slicedToArray(_useState123, 2),
      newMessage = _useState124[0],
      setNewMessageBase = _useState124[1];

  var promptToUndoRejectedComment = function promptToUndoRejectedComment() {
    openModal({
      type: ModalTypes.UndoRejectedComment,
      args: {
        id: comment.id
      }
    });
  };

  var setNewMessage = function setNewMessage(message) {
    setNewMessageBase(message);
    setIsEditingComment(message !== '');
  };

  var handleAccept =
  /*#__PURE__*/
  function () {
    var _ref131 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee28() {
      return _regeneratorRuntime.wrap(function _callee28$(_context28) {
        while (1) {
          switch (_context28.prev = _context28.next) {
            case 0:
              _context28.next = 2;
              return acceptCommentMarker();

            case 2:
              moveToNextComment();

            case 3:
            case "end":
              return _context28.stop();
          }
        }
      }, _callee28);
    }));

    return function handleAccept() {
      return _ref131.apply(this, arguments);
    };
  }();

  var handleUpdate =
  /*#__PURE__*/
  function () {
    var _ref132 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee29() {
      return _regeneratorRuntime.wrap(function _callee29$(_context29) {
        while (1) {
          switch (_context29.prev = _context29.next) {
            case 0:
              if (!(newMessage === '')) {
                _context29.next = 4;
                break;
              }

              promptToUndoRejectedComment();
              _context29.next = 8;
              break;

            case 4:
              _context29.next = 6;
              return updateLastMessageOnCommentMarker(newMessage);

            case 6:
              setIsEditingComment(false);
              moveToNextComment();

            case 8:
            case "end":
              return _context29.stop();
          }
        }
      }, _callee29);
    }));

    return function handleUpdate() {
      return _ref132.apply(this, arguments);
    };
  }();

  var getMessages = function getMessages() {
    if (isEditingComment) {
      return comment.messages.slice(0, comment.messages.length - 1);
    }

    if (!isExpanded && comment.messages.length > 1) {
      return [comment.messages[comment.messages.length - 1], comment.messages[0]];
    }

    return comment.messages;
  };

  var confirmDiscardDraft = function confirmDiscardDraft() {
    if (isEditingComment && newMessage !== threadLastComment) {
      setIsConfirmingDiscardDraft(true);
    } else {
      collapseRejectedComment();
    }
  };

  var collapseRejectedComment = function collapseRejectedComment() {
    setIsEditingComment(false);
    setNewMessage(threadLastComment);
    collapseComment();
  };

  useLayoutEffect(function () {
    var _a;

    if (isEditingComment && inputRef.current !== null) {
      (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.setSelectionRange(newMessage.length, newMessage.length);
    }
  }, [inputRef, newMessage.length, isEditingComment]);
  return React.createElement(Fragment, null, React.createElement(ClickAwayListener, {
    onClickAway: function onClickAway(e) {
      var el = e.target;
      var classNames = typeof el.className === 'string' ? el.className.split(' ') : [];
      var isCancelling = classNames.includes('el-ignore-click-away');

      if (!isCancelling && isEditingComment && newMessage !== threadLastComment) {
        e.preventDefault();
        e.stopPropagation();
        setIsConfirmingDiscardDraft(true);
      }
    }
  }, React.createElement("div", null, React.createElement(CommentItemScaffold, {
    expandComment: expandComment,
    collapseComment: confirmDiscardDraft,
    collapsedVisibleIndexes: [0, 1],
    badge: React.createElement(CommentBadge, {
      index: index + 1,
      comment: comment,
      active: isActive
    }),
    actionsSection: React.createElement(ActionsSection$2, {
      isEditingComment: isEditingComment,
      handleAccept: handleAccept,
      handleUpdate: handleUpdate,
      handleCancel: confirmDiscardDraft,
      setIsEditingComment: setIsEditingComment,
      cardFace: cardFace,
      index: index,
      updateDisabled: threadLastComment === newMessage,
      promptToUndoRejectedComment: promptToUndoRejectedComment
    }),
    messagesAddOn: React.createElement("div", {
      style: {
        paddingRight: '1em'
      }
    }, React.createElement(TextField, {
      inputRef: inputRef,
      autoFocus: true,
      style: {
        width: '100%',
        marginTop: '1em',
        marginBottom: '1em'
      },
      multiline: true,
      rows: 2,
      variant: "filled",
      value: newMessage,
      onChange: function onChange(e) {
        setNewMessage(e.target.value);
      },
      InputProps: {
        style: {
          padding: '1em'
        }
      }
    })),
    messagesOverride: getMessages()
  }))), React.createElement(DiscardDraftCommentMessageModal, {
    open: isConfirmingDiscardDraft,
    confirmDiscard: function confirmDiscard() {
      setIsConfirmingDiscardDraft(false);
      collapseRejectedComment();
    },
    closeModal: function closeModal() {
      setIsConfirmingDiscardDraft(false);
    }
  }));
};

var ActionsSection$2 = function ActionsSection$2(_ref133) {
  var isEditingComment = _ref133.isEditingComment,
      cardFace = _ref133.cardFace,
      index = _ref133.index,
      handleAccept = _ref133.handleAccept,
      handleUpdate = _ref133.handleUpdate,
      handleCancel = _ref133.handleCancel,
      setIsEditingComment = _ref133.setIsEditingComment,
      updateDisabled = _ref133.updateDisabled,
      promptToUndoRejectedComment = _ref133.promptToUndoRejectedComment;

  var _useContext176 = useContext(CommentItemContext),
      isActive = _useContext176.isActive,
      isExpanded = _useContext176.isExpanded,
      expandComment = _useContext176.expandComment;

  useEffect(function () {
    if (isActive && isEditingComment && !isExpanded) {
      expandComment();
    }
  });

  if (isEditingComment && isActive) {
    return React.createElement(Fragment, null, React.createElement(Button$1, {
      onClick: handleCancel,
      style: {
        textTransform: 'uppercase',
        color: '#929292'
      },
      variant: "text",
      color: "secondary"
    }, "Cancel"), React.createElement(Button$1, {
      disabled: updateDisabled,
      onClick: handleUpdate,
      style: {
        textTransform: 'uppercase',
        color: updateDisabled ? '#929292' : '#ed154e'
      }
    }, "Update"));
  }

  return React.createElement(Fragment, null, React.createElement(Button$1, {
    onClick: function onClick() {
      setIsEditingComment(true);
    },
    style: {
      textTransform: 'uppercase',
      color: '#929292'
    },
    variant: "text",
    color: "secondary"
  }, "Edit"), React.createElement(Button$1, {
    onClick: promptToUndoRejectedComment,
    style: {
      textTransform: 'uppercase',
      color: '#929292'
    },
    variant: "text",
    color: "secondary"
  }, "Undo"), React.createElement(Button$1, {
    disabled: true,
    onClick: function onClick() {},
    style: {
      textTransform: 'uppercase',
      color: '#ed154e'
    },
    variant: "text",
    color: "secondary"
  }, React.createElement(Close, null), " Rejected"));
};

var ReviewCommentItem = function ReviewCommentItem(_ref134) {
  var comment = _ref134.comment;

  if (comment.status === CommentStatus.Rejected) {
    return React.createElement(RejectedComment, null);
  }

  if (comment.status === CommentStatus.Accepted) {
    return React.createElement(AcceptedComment, null);
  }

  if (comment.status === CommentStatus.Pending) {
    return React.createElement(PendingComment, null);
  }

  return null;
};

var PendingComment$1 = function PendingComment$1(_ref135) {
  var isVerifying = _ref135.isVerifying;

  var _useContext177 = useContext(CommentItemContext),
      index = _useContext177.index,
      comment = _useContext177.comment,
      isActive = _useContext177.isActive,
      isExpanded = _useContext177.isExpanded,
      expandComment = _useContext177.expandComment,
      collapseComment = _useContext177.collapseComment;

  var _useContext178 = useContext(DesignReviewContext),
      moveToNextComment = _useContext178.moveToNextComment;

  var _useContext179 = useContext(UIStateContext.Scaffold),
      isViewingPrevious = _useContext179.isViewingPrevious;

  var _useContext180 = useContext(ActionsContext),
      updateCommentLocal = _useContext180.updateCommentLocal;

  var handleVerify =
  /*#__PURE__*/
  function () {
    var _ref136 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee30() {
      return _regeneratorRuntime.wrap(function _callee30$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              _context30.next = 2;
              return updateCommentLocal(comment.id, {
                isVerified: true
              });

            case 2:
              if (isExpanded) {
                collapseComment();
              }

              moveToNextComment();

            case 4:
            case "end":
              return _context30.stop();
          }
        }
      }, _callee30);
    }));

    return function handleVerify() {
      return _ref136.apply(this, arguments);
    };
  }();

  var handleMarkAsDone =
  /*#__PURE__*/
  function () {
    var _ref137 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee31() {
      return _regeneratorRuntime.wrap(function _callee31$(_context31) {
        while (1) {
          switch (_context31.prev = _context31.next) {
            case 0:
              _context31.next = 2;
              return updateCommentLocal(comment.id, {
                isDone: true
              });

            case 2:
              if (isExpanded) {
                collapseComment();
              }

              moveToNextComment();

            case 4:
            case "end":
              return _context31.stop();
          }
        }
      }, _callee31);
    }));

    return function handleMarkAsDone() {
      return _ref137.apply(this, arguments);
    };
  }();

  return React.createElement(Fragment, null, React.createElement("div", null, React.createElement(CommentItemScaffold, {
    expandComment: expandComment,
    collapseComment: collapseComment,
    badge: React.createElement(CommentBadge, {
      index: index + 1,
      comment: comment,
      active: isActive
    }),
    actionsSection: React.createElement(ActionsSection$3, {
      isVerifying: isVerifying,
      isViewingPrevious: isViewingPrevious,
      handleVerify: handleVerify,
      handleMarkAsDone: handleMarkAsDone
    })
  })));
};

var ActionsSection$3 = function ActionsSection$3(_ref138) {
  var isVerifying = _ref138.isVerifying,
      handleVerify = _ref138.handleVerify,
      handleMarkAsDone = _ref138.handleMarkAsDone;

  var _useContext181 = useContext(UIStateContext.Derived.Scaffold),
      areCurrentImagesMissing = _useContext181.areCurrentImagesMissing;

  if (isVerifying) {
    return React.createElement(Fragment, null, React.createElement(Button$1, {
      onClick: handleVerify,
      style: {
        textTransform: 'uppercase',
        color: '#ed154e'
      },
      variant: "text",
      color: "secondary"
    }, "Verify"));
  }

  return React.createElement(Fragment, null, React.createElement(Button$1, {
    onClick: handleMarkAsDone,
    style: {
      textTransform: 'uppercase',
      color: '#ed154e',
      opacity: areCurrentImagesMissing ? 0 : 1
    },
    variant: "text",
    color: "secondary"
  }, "Done"));
};

var VerifiedComment = function VerifiedComment(_ref139) {
  var isVerifying = _ref139.isVerifying;

  var _useContext182 = useContext(CommentItemContext),
      index = _useContext182.index,
      comment = _useContext182.comment,
      isActive = _useContext182.isActive,
      isExpanded = _useContext182.isExpanded,
      expandComment = _useContext182.expandComment,
      collapseComment = _useContext182.collapseComment;

  var _useContext183 = useContext(ActionsContext),
      updateCommentLocal = _useContext183.updateCommentLocal;

  var handleUndo =
  /*#__PURE__*/
  function () {
    var _ref140 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee32() {
      return _regeneratorRuntime.wrap(function _callee32$(_context32) {
        while (1) {
          switch (_context32.prev = _context32.next) {
            case 0:
              if (!isVerifying) {
                _context32.next = 6;
                break;
              }

              _context32.next = 3;
              return updateCommentLocal(comment.id, {
                isVerified: false
              });

            case 3:
              if (isExpanded) {
                collapseComment();
              }

              _context32.next = 9;
              break;

            case 6:
              _context32.next = 8;
              return updateCommentLocal(comment.id, {
                isDone: false
              });

            case 8:
              if (isExpanded) {
                collapseComment();
              }

            case 9:
            case "end":
              return _context32.stop();
          }
        }
      }, _callee32);
    }));

    return function handleUndo() {
      return _ref140.apply(this, arguments);
    };
  }();

  return React.createElement(CommentItemScaffold, {
    expandComment: expandComment,
    collapseComment: collapseComment,
    badge: React.createElement(CommentBadge, {
      index: index + 1,
      comment: comment,
      active: isActive
    }),
    actionsSection: React.createElement(Fragment, null, React.createElement(Button$1, {
      onClick: handleUndo,
      style: {
        textTransform: 'uppercase',
        color: '#929292'
      }
    }, "Undo"), React.createElement(Button$1, {
      disabled: true,
      style: {
        textTransform: 'uppercase',
        color: '#0d951b'
      }
    }, React.createElement(Check, null), " ", isVerifying ? 'Verified' : 'Done'))
  });
};

var SubmitCommentItem = function SubmitCommentItem(_ref141) {
  var comment = _ref141.comment;

  var _useContext184 = useContext(UIStateContext.Derived.Scaffold),
      areCurrentImagesMissing = _useContext184.areCurrentImagesMissing;

  var isVerifying = !areCurrentImagesMissing;

  if (isVerifying) {
    if (comment.isVerified) {
      return React.createElement(VerifiedComment, {
        isVerifying: isVerifying
      });
    } else {
      return React.createElement(PendingComment$1, {
        isVerifying: isVerifying
      });
    }
  } else {
    if (comment.isDone) {
      return React.createElement(VerifiedComment, {
        isVerifying: isVerifying
      });
    } else {
      return React.createElement(PendingComment$1, {
        isVerifying: isVerifying
      });
    }
  }
};

var CommentItem = function CommentItem(_ref142) {
  var cardFace = _ref142.cardFace,
      index = _ref142.index,
      isActive = _ref142.isActive,
      isExpanded = _ref142.isExpanded,
      comment = _ref142.comment,
      activeCommentRefProp = _ref142.activeCommentRef,
      style = _ref142.style;

  var _useContext185 = useContext(DesignContext.Base),
      workflow = _useContext185.workflow;

  var _useContext186 = useContext(ActionsContext),
      setActiveCommentBase = _useContext186.setActiveComment;

  var activeCommentRef = isActive ? activeCommentRefProp : undefined;

  var _useCommentItem = useCommentItem({
    comment: comment,
    cardFace: cardFace,
    index: index,
    isActive: isActive,
    isExpanded: isExpanded
  }),
      expandComment = _useCommentItem.expandComment,
      collapseComment = _useCommentItem.collapseComment,
      transform = _useCommentItem.transform,
      opacity = _useCommentItem.opacity,
      marginRight = _useCommentItem.marginRight,
      borderRadius = _useCommentItem.borderRadius,
      translateY = _useCommentItem.translateY,
      fadeInTransition = _useCommentItem.fadeInTransition,
      canReadMore = _useCommentItem.canReadMore,
      canExpand = _useCommentItem.canExpand;

  var setActiveComment = function setActiveComment(id) {
    setActiveCommentBase({
      id: id,
      isExpanded: canExpand
    });
  };

  useEffect(function () {
    if (isActive && canExpand) {
      expandComment();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [isActive, canExpand]);

  if (workflow === Workflow.Request) {
    return React.createElement(CommentItemContext.Provider, {
      value: {
        canReadMore: canReadMore,
        cardFace: cardFace,
        index: index,
        isActive: isActive,
        isExpanded: isExpanded,
        comment: comment,
        setActiveComment: setActiveComment,
        activeCommentRef: activeCommentRef,
        style: style,
        expandComment: expandComment,
        collapseComment: collapseComment,
        transform: transform,
        opacity: opacity,
        marginRight: marginRight,
        borderRadius: borderRadius,
        translateY: translateY,
        fadeInTransition: fadeInTransition
      }
    }, React.createElement(RequestCommentItem, null));
  }

  if (workflow === Workflow.Review) {
    return React.createElement(CommentItemContext.Provider, {
      value: {
        canReadMore: canReadMore,
        cardFace: cardFace,
        index: index,
        isActive: isActive,
        isExpanded: isExpanded,
        comment: comment,
        setActiveComment: setActiveComment,
        activeCommentRef: activeCommentRef,
        style: style,
        expandComment: expandComment,
        collapseComment: collapseComment,
        transform: transform,
        opacity: opacity,
        marginRight: marginRight,
        borderRadius: borderRadius,
        translateY: translateY,
        fadeInTransition: fadeInTransition
      }
    }, React.createElement(ReviewCommentItem, {
      comment: comment
    }));
  }

  if (workflow === Workflow.Submit) {
    return React.createElement(CommentItemContext.Provider, {
      value: {
        canReadMore: canReadMore,
        cardFace: cardFace,
        index: index,
        isActive: isActive,
        isExpanded: isExpanded,
        comment: comment,
        setActiveComment: setActiveComment,
        activeCommentRef: activeCommentRef,
        style: style,
        expandComment: expandComment,
        collapseComment: collapseComment,
        transform: transform,
        opacity: opacity,
        marginRight: marginRight,
        borderRadius: borderRadius,
        translateY: translateY,
        fadeInTransition: fadeInTransition
      }
    }, React.createElement(SubmitCommentItem, {
      comment: comment
    }));
  }

  return null;
};

var FrontCommentHeader = function FrontCommentHeader(_ref143) {
  var frontComments = _ref143.frontComments;

  if (frontComments.length > 0) {
    return React.createElement("div", {
      style: {
        margin: '6rem 1rem 1rem 1rem',
        color: '#f9f9f9'
      }
    }, "Front Comments");
  }

  return null;
};

var BackCommentHeader = function BackCommentHeader(_ref144) {
  var frontComments = _ref144.frontComments,
      backComments = _ref144.backComments;

  if (backComments.length > 0) {
    if (frontComments.length > 0) {
      return React.createElement("div", {
        style: {
          margin: '1rem',
          color: '#f9f9f9'
        }
      }, "Back Comments");
    }

    return React.createElement("div", {
      style: {
        margin: '6rem 1rem 1rem 1rem',
        color: '#f9f9f9'
      }
    }, "Back Comments");
  }

  return null;
};

var DesignReviewSidebar = function DesignReviewSidebar(_ref145) {
  var comments = _ref145.comments,
      activeComment = _ref145.activeComment;

  var _a, _b;

  var _useContext187 = useContext(UIStateContext.Scaffold),
      markerPrompt = _useContext187.markerPrompt;

  var _useContext188 = useContext(UIStateContext.Sidebar),
      groupComments = _useContext188.groupComments;

  var _useContext189 = useContext(UIStateContext.Derived.Sidebar),
      isNewMarkerPromptOpen = _useContext189.isNewMarkerPromptOpen;

  var _useContext190 = useContext(UIStateContext.ImageViewer),
      cardFace = _useContext190.cardFace;

  var _useContext191 = useContext(DesignReviewContext),
      sidebarViewingAreaRef = _useContext191.resizeHandlerProps.sidebarViewingAreaRef;

  var previousActiveComment = useRef(activeComment);

  var _useState125 = useState({}),
      _useState126 = _slicedToArray(_useState125, 2),
      defaultOffsets = _useState126[0],
      setDefaultOffsets = _useState126[1];

  var containerRef = createRef();
  var activeCommentRef = createRef();

  var _comments = comments.map(function (c, index) {
    return _objectSpread({}, c, {
      label: index
    });
  });

  var frontComments = _comments.filter(function (c) {
    return c.cardFace === 'Front';
  });

  var backComments = _comments.filter(function (c) {
    return c.cardFace === 'Back';
  });

  useEffect(function () {
    var elements = document.querySelectorAll('.comment-item');

    var values = _toConsumableArray(elements).reduce(function (acc, el) {
      return _objectSpread({}, acc, _defineProperty({}, el.dataset.id, el.offsetTop));
    }, {});

    setDefaultOffsets(values);
  }, [groupComments]);
  useEffect(function () {
    var _a;

    var _comparePreviousActiv = comparePreviousActiveComment(activeComment, previousActiveComment.current),
        activeCommentHasChanged = _comparePreviousActiv.activeCommentHasChanged,
        activeCommentKey = _comparePreviousActiv.activeCommentKey;

    if (activeCommentHasChanged) {
      var commentList = cardFace === CardFace.Front ? frontComments : backComments;
      var list = groupComments ? commentList : _comments;
      var index = list.findIndex(function (c) {
        return c.id === (activeComment === null || activeComment === void 0 ? void 0 : activeComment.id);
      });

      if (activeCommentRef.current !== null && containerRef.current !== null) {
        var oneRem = parseFloat(getComputedStyle(document.documentElement).fontSize);
        var topMargin = oneRem * 6;
        var baseOffset = (_a = defaultOffsets[activeCommentKey]) !== null && _a !== void 0 ? _a : activeCommentRef.current.offsetTop;
        var adjustedOffset = index === 0 ? baseOffset - topMargin - oneRem * 2 : baseOffset - topMargin;
        containerRef.current.scrollTo({
          top: adjustedOffset,
          behavior: 'smooth'
        });
      }

      previousActiveComment.current = activeComment;
    }
  });
  return React.createElement(RevisionReviewSidebarContext.Provider, {
    value: {
      containerRef: containerRef,
      activeCommentRef: activeCommentRef
    }
  }, React.createElement("div", {
    style: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'auto',
      overflowX: 'hidden',
      position: 'relative'
    },
    ref: containerRef
  }, isNewMarkerPromptOpen && !comments.length && React.createElement(VisibleAreaSpacer, null), !groupComments && !isNewMarkerPromptOpen && React.createElement(VisibleAreaSpacer, null), !groupComments && comments.map(function (c, i) {
    var _a;

    var isActive = (activeComment === null || activeComment === void 0 ? void 0 : activeComment.id) === c.id;
    var isExpanded = isActive && ((_a = activeComment === null || activeComment === void 0 ? void 0 : activeComment.isExpanded) !== null && _a !== void 0 ? _a : false);
    return React.createElement(CommentItem, {
      cardFace: CardFace.Front,
      key: c.id,
      comment: c,
      index: i,
      isActive: isActive,
      isExpanded: isExpanded,
      activeCommentRef: activeCommentRef,
      style: {
        marginLeft: '1rem',
        marginRight: '1rem'
      }
    });
  }), groupComments && React.createElement(React.Fragment, null, React.createElement(FrontCommentHeader, {
    frontComments: frontComments
  }), frontComments.map(function (c, i) {
    var _a;

    var isActive = (activeComment === null || activeComment === void 0 ? void 0 : activeComment.id) === c.id;
    var isExpanded = isActive && ((_a = activeComment === null || activeComment === void 0 ? void 0 : activeComment.isExpanded) !== null && _a !== void 0 ? _a : false);
    return React.createElement(CommentItem, {
      cardFace: CardFace.Front,
      key: c.id,
      comment: c,
      index: c.label,
      isActive: isActive,
      isExpanded: isExpanded,
      activeCommentRef: activeCommentRef,
      style: {
        marginLeft: '1rem',
        marginRight: '1rem'
      }
    });
  }), React.createElement(BackCommentHeader, {
    frontComments: frontComments,
    backComments: backComments
  }), backComments.map(function (c, i) {
    var _a;

    var isActive = (activeComment === null || activeComment === void 0 ? void 0 : activeComment.id) === c.id;
    var isExpanded = isActive && ((_a = activeComment === null || activeComment === void 0 ? void 0 : activeComment.isExpanded) !== null && _a !== void 0 ? _a : false);
    return React.createElement(CommentItem, {
      cardFace: CardFace.Back,
      key: c.id,
      comment: c,
      index: c.label,
      isActive: isActive,
      isExpanded: isExpanded,
      activeCommentRef: activeCommentRef,
      style: {
        marginLeft: '1rem',
        marginRight: '1rem'
      }
    });
  })), isNewMarkerPromptOpen ? React.createElement(NewCommentItemPrompt, {
    activeCommentRef: activeCommentRef,
    x: markerPrompt === null || markerPrompt === void 0 ? void 0 : markerPrompt.x,
    y: markerPrompt === null || markerPrompt === void 0 ? void 0 : markerPrompt.y
  }) : null, React.createElement("div", {
    style: {
      marginBottom: "calc(".concat((_b = (_a = sidebarViewingAreaRef === null || sidebarViewingAreaRef === void 0 ? void 0 : sidebarViewingAreaRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0, "px - 3rem)")
    }
  })));
};

var comparePreviousActiveComment = function comparePreviousActiveComment(current, previous) {
  var _a;

  var idHasChanged = (current === null || current === void 0 ? void 0 : current.id) !== (previous === null || previous === void 0 ? void 0 : previous.id);
  var expandedStateHasChanged = (current === null || current === void 0 ? void 0 : current.isExpanded) !== (previous === null || previous === void 0 ? void 0 : previous.isExpanded);
  var activeCommentKey = (_a = current === null || current === void 0 ? void 0 : current.id) !== null && _a !== void 0 ? _a : 'placeholder key';
  return {
    activeCommentHasChanged: idHasChanged || expandedStateHasChanged,
    activeCommentKey: activeCommentKey
  };
};

var VisibleAreaSpacer = function VisibleAreaSpacer() {
  return React.createElement("div", {
    style: {
      margin: '5rem 1rem 1rem 1rem',
      color: '#f9f9f9'
    }
  });
};

var RevisionReviewSidebar = function RevisionReviewSidebar(_ref146) {
  var comments = _ref146.comments,
      activeComment = _ref146.activeComment;

  var _a, _b;

  var previousActiveComment = useRef(activeComment);

  var _useContext192 = useContext(UIStateContext.Sidebar),
      groupComments = _useContext192.groupComments;

  var _useContext193 = useContext(DesignReviewContext),
      sidebarViewingAreaRef = _useContext193.resizeHandlerProps.sidebarViewingAreaRef;

  var _useContext194 = useContext(UIStateContext.ImageViewer),
      cardFace = _useContext194.cardFace;

  var _useState127 = useState({}),
      _useState128 = _slicedToArray(_useState127, 2),
      defaultOffsets = _useState128[0],
      setDefaultOffsets = _useState128[1];

  var containerRef = createRef();
  var activeCommentRef = createRef();
  var frontComments = comments.filter(function (c) {
    return c.cardFace === 'Front';
  });
  var backComments = comments.filter(function (c) {
    return c.cardFace === 'Back';
  });
  useEffect(function () {
    var elements = document.querySelectorAll('.comment-item');

    var values = _toConsumableArray(elements).reduce(function (acc, el) {
      return _objectSpread({}, acc, _defineProperty({}, el.dataset.id, el.offsetTop));
    }, {});

    setDefaultOffsets(values);
  }, [groupComments]);
  useEffect(function () {
    var _a;

    var _comparePreviousActiv2 = comparePreviousActiveComment$1(activeComment, previousActiveComment.current),
        activeCommentHasChanged = _comparePreviousActiv2.activeCommentHasChanged,
        activeCommentKey = _comparePreviousActiv2.activeCommentKey;

    if (activeCommentHasChanged) {
      var commentList = cardFace === CardFace.Front ? frontComments : backComments;
      var index = commentList.findIndex(function (c) {
        return c.id === (activeComment === null || activeComment === void 0 ? void 0 : activeComment.id);
      });

      if (activeCommentRef.current !== null && containerRef.current !== null) {
        var oneRem = parseFloat(getComputedStyle(document.documentElement).fontSize);
        var topMargin = oneRem * 6;
        var baseOffset = (_a = defaultOffsets[activeCommentKey]) !== null && _a !== void 0 ? _a : activeCommentRef.current.offsetTop;
        var adjustedOffset = index === 0 ? baseOffset - topMargin - oneRem * 2 : baseOffset - topMargin;
        containerRef.current.scrollTo({
          top: adjustedOffset,
          behavior: 'smooth'
        });
      }

      previousActiveComment.current = activeComment;
    }
  });
  return React.createElement(RevisionReviewSidebarContext.Provider, {
    value: {
      containerRef: containerRef,
      activeCommentRef: activeCommentRef
    }
  }, React.createElement("div", {
    style: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'auto',
      overflowX: 'hidden',
      position: 'relative'
    },
    ref: containerRef
  }, !groupComments && React.createElement(React.Fragment, null, React.createElement(VisibleAreaSpacer$1, null), comments.map(function (c, i) {
    var _a;

    var isActive = (activeComment === null || activeComment === void 0 ? void 0 : activeComment.id) === c.id;
    var isExpanded = isActive && ((_a = activeComment === null || activeComment === void 0 ? void 0 : activeComment.isExpanded) !== null && _a !== void 0 ? _a : false);
    return React.createElement(CommentItem, {
      cardFace: CardFace.Front,
      key: c.id,
      comment: c,
      index: i,
      isActive: isActive,
      isExpanded: isExpanded,
      activeCommentRef: activeCommentRef,
      style: {
        marginLeft: '1rem',
        marginRight: '1rem'
      }
    });
  })), groupComments && React.createElement(React.Fragment, null, React.createElement(FrontCommentHeader, {
    frontComments: frontComments
  }), comments.map(function (c, i) {
    var _a;

    var isActive = (activeComment === null || activeComment === void 0 ? void 0 : activeComment.id) === c.id;
    var isExpanded = isActive && ((_a = activeComment === null || activeComment === void 0 ? void 0 : activeComment.isExpanded) !== null && _a !== void 0 ? _a : false);

    if (c.cardFace === CardFace.Front) {
      return React.createElement(CommentItem, {
        cardFace: CardFace.Front,
        key: c.id,
        comment: c,
        index: i,
        isActive: isActive,
        isExpanded: isExpanded,
        activeCommentRef: activeCommentRef,
        style: {
          marginLeft: '1rem',
          marginRight: '1rem'
        }
      });
    } else {
      return null;
    }
  }), React.createElement(BackCommentHeader, {
    frontComments: frontComments,
    backComments: backComments
  }), comments.map(function (c, i) {
    var _a;

    var isActive = (activeComment === null || activeComment === void 0 ? void 0 : activeComment.id) === c.id;
    var isExpanded = isActive && ((_a = activeComment === null || activeComment === void 0 ? void 0 : activeComment.isExpanded) !== null && _a !== void 0 ? _a : false);

    if (c.cardFace === CardFace.Back) {
      return React.createElement(CommentItem, {
        cardFace: CardFace.Back,
        key: c.id,
        comment: c,
        index: i,
        isActive: isActive,
        isExpanded: isExpanded,
        activeCommentRef: activeCommentRef,
        style: {
          marginLeft: '1rem',
          marginRight: '1rem'
        }
      });
    } else {
      return null;
    }
  })), React.createElement("div", {
    style: {
      marginBottom: "calc(".concat((_b = (_a = sidebarViewingAreaRef === null || sidebarViewingAreaRef === void 0 ? void 0 : sidebarViewingAreaRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0, "px - 3rem)")
    }
  })));
};

var comparePreviousActiveComment$1 = function comparePreviousActiveComment$1(current, previous) {
  var _a;

  var idHasChanged = (current === null || current === void 0 ? void 0 : current.id) !== (previous === null || previous === void 0 ? void 0 : previous.id);
  var expandedStateHasChanged = (current === null || current === void 0 ? void 0 : current.isExpanded) !== (previous === null || previous === void 0 ? void 0 : previous.isExpanded);
  var activeCommentKey = (_a = current === null || current === void 0 ? void 0 : current.id) !== null && _a !== void 0 ? _a : 'placeholder key';
  return {
    activeCommentHasChanged: idHasChanged || expandedStateHasChanged,
    activeCommentKey: activeCommentKey
  };
};

var VisibleAreaSpacer$1 = function VisibleAreaSpacer$1() {
  return React.createElement("div", {
    style: {
      margin: '5rem 1rem 1rem 1rem',
      color: '#f9f9f9'
    }
  });
};

var Sidebar = function Sidebar() {
  var _useContext195 = useContext(DesignContext.Base),
      workflow = _useContext195.workflow;

  var _useContext196 = useContext(UIStateContext.Derived.Scaffold),
      activeComment = _useContext196.activeComment;

  var comments = useContext(CommentsStore.Comments);

  var _useContext197 = useContext(CommentsStore.DerivedComments),
      frontComments = _useContext197.front,
      backComments = _useContext197.back;

  if (workflow === Workflow.Request) {
    return React.createElement(DesignReviewSidebar, {
      comments: comments,
      activeComment: activeComment
    });
  }

  return React.createElement(RevisionReviewSidebar, {
    comments: comments,
    activeComment: activeComment
  });
};

var DesignReview = function DesignReview() {
  var _useImageViewerStyles = useImageViewerStyles(),
      imageWithPinClassName = _useImageViewerStyles.imageWithPin,
      imageWithNoPinClassName = _useImageViewerStyles.imageWithNoPin;

  var _useContext198 = useContext(DesignReviewContext),
      imageViewerProps = _useContext198.imageViewerProps,
      resizeHandlerProps = _useContext198.resizeHandlerProps;

  var _useContext199 = useContext(DerivedActionsContext),
      setCardFace = _useContext199.setCardFace;

  var _useContext200 = useContext(DesignContext.Base),
      workflow = _useContext200.workflow;

  var comments = useContext(CommentsStore.Comments);

  var _useContext201 = useContext(CommentsStore.DerivedComments),
      frontComments = _useContext201.front,
      backComments = _useContext201.back;

  var _useContext202 = useContext(UIStateContext.Scaffold),
      doneFront = _useContext202.doneFront,
      doneBack = _useContext202.doneBack,
      isViewingPrevious = _useContext202.isViewingPrevious,
      isPreviousVersionLocked = _useContext202.isPreviousVersionLocked;

  var _useContext203 = useContext(UIStateContext.Sidebar),
      groupComments = _useContext203.groupComments;

  var _useContext204 = useContext(UIStateContext.ImageViewer),
      cardFace = _useContext204.cardFace,
      isInteractive = _useContext204.isInteractive,
      showingAllMarkers = _useContext204.showingAllMarkers,
      showingInactiveMarkers = _useContext204.showingInactiveMarkers;

  var _useContext205 = useContext(UIStateContext.Derived.Scaffold),
      title = _useContext205.title,
      activeComment = _useContext205.activeComment,
      frontPostcardUrl = _useContext205.frontPostcardUrl,
      backPostcardUrl = _useContext205.backPostcardUrl,
      previousFrontPostcardUrl = _useContext205.previousFrontPostcardUrl,
      previousBackPostcardUrl = _useContext205.previousBackPostcardUrl,
      areCurrentImagesMissing = _useContext205.areCurrentImagesMissing,
      arePreviousImagesMissing = _useContext205.arePreviousImagesMissing;

  var _useContext206 = useContext(UIStateContext.Derived.ImageViewer),
      hasLoaded = _useContext206.hasLoaded,
      imageDimensions = _useContext206.imageDimensions;

  var _useContext207 = useContext(UIStateContext.Derived.Sidebar),
      hasSidebar = _useContext207.hasSidebar;

  var _useContext208 = useContext(ActionsContext),
      setShowingAllMarkers = _useContext208.setShowingAllMarkers,
      setIsViewingPrevious = _useContext208.setIsViewingPrevious,
      setIsPreviousVersionLocked = _useContext208.setIsPreviousVersionLocked,
      setShowingInactiveMarkers = _useContext208.setShowingInactiveMarkers,
      refreshDesign = _useContext208.refreshDesign,
      setDefaultZoom = _useContext208.setDefaultZoom,
      cancelPinComment = _useContext208.cancelPinComment;

  var _useContext209 = useContext(RefsContext),
      imgElRef = _useContext209.imgElRef,
      scale = _useContext209.scale,
      translateX = _useContext209.translateX,
      translateY = _useContext209.translateY;

  var _useContext210 = useContext(DesignContext.Derived),
      mediaType = _useContext210.mediaType;

  var _useContext211 = useContext(CampaignContext.Derived),
      designStatus = _useContext211.designStatus;

  var _useContext212 = useContext(DesignReviewContext),
      designDetails = _useContext212.designDetails;

  var isApproved = designDetails.isApproved;

  var _useContext213 = useContext(DesignContext.Base),
      experience = _useContext213.experience,
      viewedAs = _useContext213.viewedAs;

  var resetZoom = imageViewerProps.resetZoom;
  var viewingAreaImageProps = useMemo(function () {
    if (!isApproved && !isPreviousVersionLocked && ( // Cannot add comment during pre press review to campaign review
    workflow === Workflow.Request && experience === DesignReviewExperience.DesignConcept || experience === DesignReviewExperience.CampaignReview && // TODO: Make a simple state or prop?
    [CampaignDesignStatus.NeedsFinalApproval, CampaignDesignStatus.ReadyForFinalApproval].includes(designStatus))) {
      return {
        className: imageWithPinClassName
      };
    }

    return {
      className: imageWithNoPinClassName
    };
  }, [workflow, imageWithPinClassName, imageWithNoPinClassName, isPreviousVersionLocked]);

  var getThumbnailUrls = function getThumbnailUrls() {
    if (isViewingPrevious) {
      return {
        displayThumbnailPlaceholders: arePreviousImagesMissing,
        frontThumbnailUrl: areCurrentImagesMissing ? previousFrontPostcardUrl : frontPostcardUrl,
        backThumbnailUrl: areCurrentImagesMissing ? previousBackPostcardUrl : backPostcardUrl
      };
    }

    return {
      displayThumbnailPlaceholders: areCurrentImagesMissing,
      frontThumbnailUrl: frontPostcardUrl,
      backThumbnailUrl: backPostcardUrl
    };
  };

  var _getThumbnailUrls = getThumbnailUrls(),
      displayThumbnailPlaceholders = _getThumbnailUrls.displayThumbnailPlaceholders,
      frontThumbnailUrl = _getThumbnailUrls.frontThumbnailUrl,
      backThumbnailUrl = _getThumbnailUrls.backThumbnailUrl;

  useEffect(function () {
    var onKeydown = function onKeydown(e) {
      if (e.keyCode === 27) {
        cancelPinComment();
      }
    };

    document.addEventListener('keydown', onKeydown);
    return function () {
      document.removeEventListener('keydown', onKeydown);
    };
  }, []); // TODO: Move this to a separate function

  var topOverlayVisibleButtons = {
    addUnpinnedComment: workflow === Workflow.Request,
    flipPage: true,
    togglePreviousVersion: !arePreviousImagesMissing,
    refreshDesign: workflow === Workflow.Submit,
    toggleInactiveMarkers: false,
    toggleAllMarkers: true
  };

  if (isApproved) {
    topOverlayVisibleButtons = _objectSpread({}, topOverlayVisibleButtons, {
      addUnpinnedComment: false,
      togglePreviousVersion: false,
      refreshDesign: false,
      toggleAllMarkers: false
    });
  } // Number Swap - Pre-press reviewer controls


  if ( // reviewer only
  workflow !== Workflow.Submit && // tools app only
  viewedAs === DesignReviewViewedAs.Default && // campaign review/number swap only
  experience === DesignReviewExperience.CampaignReview && // pre press review in campaign review
  designStatus === CampaignDesignStatus.ReadyForPrePress) {
    topOverlayVisibleButtons = _objectSpread({}, topOverlayVisibleButtons, {
      addUnpinnedComment: false,
      togglePreviousVersion: false,
      refreshDesign: false,
      toggleAllMarkers: false
    });
  } // Number Swap - Designer controls


  if (workflow === Workflow.Submit && // tools app only
  viewedAs === DesignReviewViewedAs.Default && // campaign review/number swap only
  experience === DesignReviewExperience.CampaignReview) {
    topOverlayVisibleButtons = _objectSpread({}, topOverlayVisibleButtons, {
      addUnpinnedComment: false,
      togglePreviousVersion: true,
      refreshDesign: true,
      toggleAllMarkers: false
    });
  }

  return React.createElement(Fragment, null, React.createElement(DesignLabScaffold, {
    imageViewerProps: _objectSpread({}, imageViewerProps, {
      isInteractive: isInteractive,
      cardFace: cardFace,
      setCardFace: setCardFace,
      imgElRef: imgElRef,
      scale: scale,
      translateX: translateX,
      translateY: translateY,
      setDefaultZoom: setDefaultZoom
    }),
    viewingAreaDesignProps: {
      workflow: workflow,
      frontPostcardUrl: frontPostcardUrl,
      backPostcardUrl: backPostcardUrl,
      previousVersionFrontUrl: previousFrontPostcardUrl,
      previousVersionBackUrl: previousBackPostcardUrl,
      isViewingPrevious: isViewingPrevious,
      imgElRef: imgElRef,
      scale: scale,
      translateX: translateX,
      translateY: translateY,
      imageDimensions: imageDimensions
    },
    resizeHandlerProps: resizeHandlerProps,
    sidebarOverlay: hasSidebar ? React.createElement(Sidebar, null) : null,
    topOverlay: React.createElement(TopOverlay, {
      title: title,
      workflow: workflow
    }),
    isLoading: !hasLoaded,
    viewingAreaTopRightOverlay: React.createElement(ViewingAreaTopRightOverlay, {
      cardFace: cardFace,
      setCardFace: setCardFace,
      resetZoom: resetZoom,
      isViewingPrevious: isViewingPrevious,
      isPreviousVersionLocked: isPreviousVersionLocked,
      showingAllMarkers: showingAllMarkers,
      setShowingAllMarkers: setShowingAllMarkers,
      setIsViewingPrevious: setIsViewingPrevious,
      setIsPreviousVersionLocked: setIsPreviousVersionLocked,
      showingInactiveMarkers: showingInactiveMarkers,
      setShowingInactiveMarkers: setShowingInactiveMarkers,
      refreshDesign: refreshDesign,
      visibleButtons: topOverlayVisibleButtons,
      options: {
        toggleAllMarkersDisabled: comments.length === 0
      }
    }),
    viewingAreaImageProps: viewingAreaImageProps,
    bottomOverlay: React.createElement(PostcardBottomOverlay, {
      cardFace: cardFace,
      setCardFace: setCardFace,
      frontPostcardUrl: frontThumbnailUrl,
      backPostcardUrl: backThumbnailUrl,
      comments: comments,
      frontComments: frontComments,
      backComments: backComments,
      doneFront: doneFront,
      doneBack: doneBack,
      activeComment: activeComment,
      groupByCardFace: groupComments,
      displayPlaceholder: displayThumbnailPlaceholders,
      mediaType: mediaType
    }),
    imageOverlay: React.createElement(CommentMarkersOverlay, {
      workflow: workflow,
      isInteractive: isInteractive,
      cardFace: cardFace
    }),
    modalsOverlay: React.createElement(ModalSelector, null),
    toastsOverlay: React.createElement(NotificationsSelector, null)
  }));
};

var getTitleFromWorkflow = function getTitleFromWorkflow(_ref147) {
  var currentUser = _ref147.currentUser,
      currentReview = _ref147.currentReview,
      workflow = _ref147.workflow,
      designName = _ref147.designName,
      customerName = _ref147.customerName;

  if (workflow === Workflow.Submit) {
    return "".concat(designName).concat(customerName ? " ".concat(customerName) : '');
  }

  if ([DesignStatus.InitialReview, DesignStatus.DesignPeerReview, DesignStatus.Proofread, DesignStatus.MarketingReview, DesignStatus.CustomerReview].includes(currentReview)) {
    if (workflow === Workflow.Review) {
      return "Requests for ".concat(designName);
    }

    if (currentReview === DesignStatus.InitialReview) {
      return "Initial Review for ".concat(designName);
    }

    if (currentReview === DesignStatus.DesignPeerReview) {
      return "Design Peer Review for ".concat(designName);
    }

    if (currentReview === DesignStatus.MarketingReview) {
      return "Marketing Review for ".concat(designName);
    }

    if (currentReview === DesignStatus.Proofread) {
      return "Proofread for ".concat(designName);
    }

    if (currentReview === DesignStatus.CustomerReview) {
      return "Design Review for ".concat(designName);
    }
  }

  if (currentUser.roles.includes('internal-user')) {
    if (workflow === Workflow.Review) {
      return "".concat(currentReview, " (Revisions Review)");
    }

    return "".concat(currentReview, " (Design Review)");
  }

  if (workflow === Workflow.Review) {
    return 'Revisions Review';
  }

  return 'Design Review';
};

var useDesignReview = function useDesignReview(_ref148) {
  var designDetails = _ref148.designDetails,
      state = _ref148.state,
      derivedState = _ref148.derivedState,
      actions = _ref148.actions,
      refs = _ref148.refs,
      imageViewerProps = _ref148.imageViewerProps;
  var workflow = state.workflow,
      uiState = state.ui;
  var activeComment = uiState.scaffold.activeComment.current;
  var setDefaultZoom = actions.setDefaultZoom,
      setActiveComment = actions.setActiveComment;
  var imgElRef = refs.imgElRef;
  var resizeHandlerProps = useResizeHandlers({
    setDefaultZoom: setDefaultZoom,
    imgElRef: imgElRef,
    dependencies: [uiState.imageViewer.cardFace, uiState.scaffold.markerPrompt],
    offsetGenerator: function offsetGenerator(sw) {
      if (state.comments.length > 0 || uiState.scaffold.markerPrompt !== null || uiState.sidebar.addingUnpinnedComment) {
        var sidebarOffset = sw / 2 * -1;
        return {
          offsetX: sidebarOffset,
          sidebarOffset: sidebarOffset
        };
      }

      return {
        offsetX: 0,
        sidebarOffset: 0
      };
    }
  });
  var designReviewState = {
    imageViewerProps: imageViewerProps,
    resizeHandlerProps: resizeHandlerProps
  };
  var isDoneReviewing = state.comments.reduce(function (acc, c) {
    return acc && c.status !== CommentStatus.Pending;
  }, true);
  var submitWorkflowIsVerifying = !derivedState.ui.scaffold.areCurrentImagesMissing && typeof designDetails.currentVersionFrontUrl !== 'undefined';
  var compareFn = useMemo(function () {
    if (workflow === Workflow.Submit) {
      if (submitWorkflowIsVerifying) {
        return function (c) {
          return typeof c.isVerified === 'undefined' || c.isVerified === false;
        };
      }

      return function (c) {
        return typeof c.isDone === 'undefined' || c.isDone === false;
      };
    }

    return function (c) {
      return c.status === CommentStatus.Pending;
    };
  }, [workflow, submitWorkflowIsVerifying]);

  var findNextComment = function findNextComment(_ref149) {
    var allowCurrent = _ref149.allowCurrent,
        preferredCardFace = _ref149.preferredCardFace,
        _ref149$groupByCardFa = _ref149.groupByCardFace,
        groupByCardFace = _ref149$groupByCardFa === void 0 ? true : _ref149$groupByCardFa;
    var hasPreferredCardFace = typeof preferredCardFace !== 'undefined';

    if (!groupByCardFace) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = state.comments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var comment = _step.value;

          if (!allowCurrent && (activeComment === null || activeComment === void 0 ? void 0 : activeComment.id) === comment.id) {
            continue;
          }

          if (compareFn(comment)) {
            return {
              id: comment.id,
              isExpanded: false
            };
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return null;
    }

    if (!hasPreferredCardFace || preferredCardFace === CardFace.Front) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = derivedState.comments.front[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _comment3 = _step2.value;

          if (!allowCurrent && (activeComment === null || activeComment === void 0 ? void 0 : activeComment.id) === _comment3.id) {
            continue;
          }

          if (compareFn(_comment3)) {
            return {
              id: _comment3.id,
              isExpanded: false
            };
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }

    if (!hasPreferredCardFace || preferredCardFace === CardFace.Back) {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = derivedState.comments.back[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _comment4 = _step3.value;

          if (!allowCurrent && (activeComment === null || activeComment === void 0 ? void 0 : activeComment.id) === _comment4.id) {
            continue;
          }

          if (compareFn(_comment4)) {
            return {
              id: _comment4.id,
              isExpanded: false
            };
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }

    return null;
  };

  var moveToNextComment = function moveToNextComment(opts) {
    var _ref150 = opts !== null && opts !== void 0 ? opts : {
      allowCurrent: false
    },
        allowCurrent = _ref150.allowCurrent;

    var nextActiveComment = findNextComment({
      allowCurrent: allowCurrent,
      groupByCardFace: state.ui.sidebar.groupComments
    });
    setActiveComment(nextActiveComment);
    return nextActiveComment;
  };

  useEffect(function () {
    moveToNextComment({
      allowCurrent: true
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitWorkflowIsVerifying]);
  var revisionReviewState = {
    isDoneReviewing: isDoneReviewing,
    findNextComment: findNextComment,
    moveToNextComment: moveToNextComment
  };
  return _objectSpread({}, designReviewState, revisionReviewState);
};

var DOUBLE_CLICK_THRESHOLD_MS$1 = 220;

var useImageViewer$1 = function useImageViewer$1(_ref151) {
  var state = _ref151.state,
      derivedState = _ref151.derivedState,
      actions = _ref151.actions,
      refs = _ref151.refs;
  var _state$ui$imageViewer = state.ui.imageViewer,
      defaultTransform = _state$ui$imageViewer.defaultTransform,
      cardFace = _state$ui$imageViewer.cardFace;
  var setIsInteractive = actions.setIsInteractive,
      adjustZoomAndAutoCenter = actions.adjustZoomAndAutoCenter,
      resetZoom = actions.resetZoom,
      zoomIn = actions.zoomIn,
      zoomOut = actions.zoomOut;
  var setSpring = refs.setImageSpring,
      scale = refs.scale,
      translateX = refs.translateX,
      translateY = refs.translateY,
      imgElRef = refs.imgElRef,
      isDragging = refs.isDragging,
      singleClickTimeoutRef = refs.singleClickTimeoutRef;
  var minZoom = defaultTransform.scale / 2;
  var maxZoom = defaultTransform.scale * 4;
  var zoomStepScale = minZoom;

  var handleClickImage = function handleClickImage(x, y) {
    var _a, _b, _c, _d;

    if (!state.ui.imageViewer.showingAllMarkers) {
      actions.setShowingAllMarkers(true);
    }

    if (derivedState.design.isApproved || state.workflow !== Workflow.Request || // Cannot add comment pre press reviewer to campaign review
    state.workflow === Workflow.Request && state.viewedAs === DesignReviewViewedAs.Default && state.experience === DesignReviewExperience.CampaignReview && // TODO: Make a simple state or prop?
    [CampaignDesignStatus.ReadyForPrePress].includes(derivedState.campaign.designStatus) || typeof state.ui.sidebar.expandedMarkerIndex === 'number' && state.ui.scaffold.isPreviousVersionLocked && derivedState.ui.sidebar.isEditingComment && !state.ui.imageViewer.isPinningComment) {
      return;
    }

    if (state.ui.imageViewer.isPinningComment) {
      if (((_a = state.ui.imageViewer.pinCommentPayload) === null || _a === void 0 ? void 0 : _a.newComment) && ((_b = state.ui.imageViewer.pinCommentPayload) === null || _b === void 0 ? void 0 : _b.id) === null) {
        actions.openPinnedCommentPrompt(x, y);
      } else {
        var id = (_d = (_c = state.ui.imageViewer.pinCommentPayload) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : '';
        var comment = state.comments.find(function (c) {
          return c.id === id;
        });
        var payload = {
          x: x,
          y: y
        };

        if (state.ui.imageViewer.cardFace !== (comment === null || comment === void 0 ? void 0 : comment.cardFace)) {
          payload.cardFace = state.ui.imageViewer.cardFace;
        }

        actions.updateCommentPin(id, payload);
      }
    } else {
      actions.openPinnedCommentPrompt(x, y);
    }
  };

  var onClickImage = function onClickImage(e) {
    var _a, _b;

    e.preventDefault();
    e.stopPropagation();
    var bounds = e.currentTarget.getBoundingClientRect();
    var scaledCoordinates = [e.clientX - bounds.left, e.clientY - bounds.top];
    var imgNaturalWidth = ((_a = imgElRef.current) === null || _a === void 0 ? void 0 : _a.naturalWidth) || 0;
    var imgNaturalHeight = ((_b = imgElRef.current) === null || _b === void 0 ? void 0 : _b.naturalHeight) || 0;
    var percentageCoordinates = [scaledCoordinates[0] / scale.get() / imgNaturalWidth * 100, scaledCoordinates[1] / scale.get() / imgNaturalHeight * 100];
    handleClickImage(percentageCoordinates[0], percentageCoordinates[1]);
  };

  var setSingleClickTimeout = function setSingleClickTimeout(scaledCoordinates) {
    var timeout = setTimeout(function () {
      var _a, _b;

      var imgNaturalWidth = ((_a = imgElRef.current) === null || _a === void 0 ? void 0 : _a.naturalWidth) || 0;
      var imgNaturalHeight = ((_b = imgElRef.current) === null || _b === void 0 ? void 0 : _b.naturalHeight) || 0;
      var percentageCoordinates = [scaledCoordinates[0] / scale.get() / imgNaturalWidth * 100, scaledCoordinates[1] / scale.get() / imgNaturalHeight * 100];
      var isPortrait = imgNaturalHeight > imgNaturalWidth;

      if (isPortrait) {
        handleClickImage(percentageCoordinates[1], percentageCoordinates[0]);
      } else {
        handleClickImage(percentageCoordinates[0], percentageCoordinates[1]);
      }

      singleClickTimeoutRef.current = null;
    }, DOUBLE_CLICK_THRESHOLD_MS$1);
    return timeout;
  };

  var bindGestures = useGesture({
    onMouseEnter: function onMouseEnter() {
      actions.setHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      actions.setHovered(false);
    },
    onClick: function onClick(e) {
      if (isDragging.current) {
        return;
      }

      if (singleClickTimeoutRef.current === null) {
        var bounds = e.currentTarget.getBoundingClientRect();
        var scaledCoordinates = [e.clientX - bounds.left, e.clientY - bounds.top];
        singleClickTimeoutRef.current = setSingleClickTimeout(scaledCoordinates);
      } else {
        clearTimeout(singleClickTimeoutRef.current);
        singleClickTimeoutRef.current = null;
        zoomIn();
      }
    },
    onWheel: function onWheel(_ref152) {
      var distance = _ref152.distance,
          direction = _ref152.direction;
      var y = direction[1];
      var scaleOffset = distance * y * (zoomStepScale * -0.005);
      var previousScaleValue = scale.get();
      var newScaleValue = limitWithinRange$1(previousScaleValue + scaleOffset, maxZoom, minZoom);
      adjustZoomAndAutoCenter(newScaleValue, previousScaleValue);
    },
    onDragStart: function onDragStart() {},
    onDragEnd: function onDragEnd() {},
    onDrag: function onDrag(_ref153) {
      var movement = _ref153.movement,
          first = _ref153.first,
          last = _ref153.last,
          _ref153$memo = _ref153.memo,
          memo = _ref153$memo === void 0 ? [translateX.get(), translateY.get()] : _ref153$memo;

      if (first) {
        isDragging.current = true;
      } else if (last) {
        requestAnimationFrame(function () {
          isDragging.current = false;
        });
      }

      if (scale.get() <= defaultTransform.scale) {
        return;
      }

      var newTranslateX = memo[0] + movement[0];
      var newTranslateY = memo[1] + movement[1];
      setSpring({
        translateX: newTranslateX,
        translateY: newTranslateY
      });

      if (first) {
        return [newTranslateX, newTranslateY];
      }

      return memo;
    }
  }, {
    drag: {
      filterTaps: true,
      delay: 300
    }
  });

  var _useSpring19 = useSpring({
    onStart: function onStart() {
      setIsInteractive(false);
    },
    onRest: function onRest() {
      setIsInteractive(true);
    },
    opacity: cardFace === CardFace.Front ? 1 : 0,
    transform: "rotateY(".concat(cardFace === CardFace.Front ? 0 : 180, "deg)"),
    config: {
      duration: 300
    }
  }),
      transform = _useSpring19.transform,
      opacity = _useSpring19.opacity;

  return {
    zoomIn: zoomIn,
    zoomOut: zoomOut,
    resetZoom: resetZoom,
    bindGestures: bindGestures,
    transform: transform,
    opacity: opacity,
    onClickImage: onClickImage
  };
};

var limitWithinRange$1 = function limitWithinRange$1(given, max, min) {
  return Math.min(max, Math.max(given, min));
};

var getActiveCommentCoordinates = function getActiveCommentCoordinates(ac, comments) {
  if (ac === null || typeof ac === 'undefined') {
    return null;
  }

  var comment = comments.find(function (_ref154) {
    var id = _ref154.id;
    return id === ac.id;
  });

  if (typeof comment === 'undefined') {
    return null;
  }

  return {
    x: comment.x,
    y: comment.y
  };
};

var getDefaultComment = function getDefaultComment(comments) {
  var preferredCardFace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CardFace.Front;
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = comments[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var comment = _step4.value;

      if (comment.cardFace === preferredCardFace) {
        return {
          id: comment.id,
          isExpanded: false
        };
      }
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }

  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    for (var _iterator5 = comments[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      var _comment5 = _step5.value;
      return {
        id: _comment5.id,
        isExpanded: false
      };
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
        _iterator5.return();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }

  return null;
};

var getDefaultOpenModalArgs = function getDefaultOpenModalArgs(props) {
  var experience = props.experience,
      viewedAs = props.viewedAs,
      workflow = props.workflow,
      designDetails = props.designDetails;

  if (designDetails.isApproved) {
    return;
  }

  if (viewedAs === DesignReviewViewedAs.Customer && designDetails.isRequested) {
    return {
      type: ModalTypes.DesignInProgress
    };
  } // Number Swap - Designer Welcome Modal


  if ( // tools app only
  viewedAs === DesignReviewViewedAs.Default && // designer only
  workflow === Workflow.Submit && // campaign review/number swap only
  experience === DesignReviewExperience.CampaignReview) {
    return {
      type: ModalTypes.DesignRequestDetails
    };
  }

  if ( // tools app only
  viewedAs === DesignReviewViewedAs.Default && // reviewer only
  workflow === Workflow.Request && // campaign review/number swap only
  experience === DesignReviewExperience.CampaignReview) {
    return {
      type: ModalTypes.PrePressCampaignMedia
    };
  }

  return {
    type: ModalTypes.Welcome
  };
};

var getPreviousVersionViewingSettings = function getPreviousVersionViewingSettings(args) {
  var noFront = _isNil(args.currentVersionFrontLastModified);

  var noBack = _isNil(args.currentVersionBackLastModified);

  if (args.workflow === Workflow.Submit && args.versionNumber === 1) {
    return false;
  }

  return noFront || noBack;
};

var getUrlsFromDesignDetails = function getUrlsFromDesignDetails(designDetails) {
  var currentVersionFrontLastModified = designDetails.currentVersionFrontLastModified,
      currentVersionBackLastModified = designDetails.currentVersionBackLastModified,
      previousVersionFrontLastModified = designDetails.previousVersionFrontLastModified,
      previousVersionBackLastModified = designDetails.previousVersionBackLastModified;
  var currentVersionFrontUrl = currentVersionFrontLastModified ? "".concat(designDetails.currentVersionFrontUrl, "?mvp=").concat(currentVersionFrontLastModified) : designDetails.currentVersionFrontUrl;
  var currentVersionBackUrl = currentVersionBackLastModified ? "".concat(designDetails.currentVersionBackUrl, "?mvp=").concat(currentVersionBackLastModified) : designDetails.currentVersionBackUrl;
  var currentVersionFrontThumbnailUrl = currentVersionFrontLastModified ? "".concat(designDetails.currentVersionFrontThumbnailUrl, "?mvp=").concat(currentVersionFrontLastModified) : designDetails.currentVersionFrontThumbnailUrl;
  var currentVersionBackThumbnailUrl = currentVersionBackLastModified ? "".concat(designDetails.currentVersionBackThumbnailUrl, "?mvp=").concat(currentVersionBackLastModified) : designDetails.currentVersionBackThumbnailUrl;
  var previousVersionFrontUrl = previousVersionFrontLastModified ? "".concat(designDetails.previousVersionFrontUrl, "?mvp=").concat(previousVersionFrontLastModified) : designDetails.previousVersionFrontUrl;
  var previousVersionBackUrl = previousVersionBackLastModified ? "".concat(designDetails.previousVersionBackUrl, "?mvp=").concat(previousVersionBackLastModified) : designDetails.previousVersionBackUrl;
  return {
    currentVersionFrontUrl: currentVersionFrontUrl,
    currentVersionBackUrl: currentVersionBackUrl,
    currentVersionFrontThumbnailUrl: currentVersionFrontThumbnailUrl,
    currentVersionBackThumbnailUrl: currentVersionBackThumbnailUrl,
    previousVersionFrontUrl: previousVersionFrontUrl,
    previousVersionBackUrl: previousVersionBackUrl
  };
};

var sortAndFilterComments = function sortAndFilterComments(comments, workflow) {
  var newComments = _toConsumableArray(comments);

  if (workflow === Workflow.Request || workflow === Workflow.Submit) {
    newComments = newComments.filter(function (c) {
      return c.status !== CommentStatus.Accepted;
    });
  }

  var threadsWithSortedComments = newComments.map(function (c) {
    var messages = _toConsumableArray(c.messages).sort(function (cur, next) {
      return compareDatesAsc(cur.datePosted, next.datePosted);
    });

    return _objectSpread({}, c, {
      messages: messages
    });
  });
  return threadsWithSortedComments.sort(function (cur, next) {
    return compareDatesAsc(cur.dateOriginallyPosted, next.dateOriginallyPosted);
  });
};

var draftAddToUpdateQueue = function draftAddToUpdateQueue(draft, id) {
  draft.updateQueue.push(id);
};

var draftRemoveFromUpdateQueue = function draftRemoveFromUpdateQueue(draft, id) {
  var index = draft.updateQueue.findIndex(function (qId) {
    return qId === id;
  });

  if (index !== -1) {
    draft.updateQueue.splice(index, 1);
  }
};

var draftUpdateDoneStatus = function draftUpdateDoneStatus(draft, comment) {
  if (comment.cardFace === CardFace.Front && draft.ui.scaffold.doneFront) {
    draft.ui.scaffold.doneFront = false;
  }

  if (comment.cardFace === CardFace.Back && draft.ui.scaffold.doneBack) {
    draft.ui.scaffold.doneBack = false;
  }
};

var draftUpdateComment = function draftUpdateComment(draft, id, updates) {
  var index = draft.comments.findIndex(function (c) {
    return id === c.id;
  });

  if (index > -1) {
    Object.assign(draft.comments[index], updates);
    draftResetDoneStatusByCardFace(draft, draft.comments[index]);
  }
};

var draftResetDoneStatusByCardFace = function draftResetDoneStatusByCardFace(draft, comment) {
  if (comment.cardFace === CardFace.Front && draft.ui.scaffold.doneFront) {
    draft.ui.scaffold.doneFront = false;
  }

  if (comment.cardFace === CardFace.Back && draft.ui.scaffold.doneBack) {
    draft.ui.scaffold.doneBack = false;
  }
};

var draftDeleteComment = function draftDeleteComment(draft, id) {
  var index = draft.comments.findIndex(function (c) {
    return id === c.id;
  });

  if (index > -1) {
    draft.comments.splice(index, 1);
  }
};

var draftShowNotification = function draftShowNotification(draft, args) {
  draft.ui.scaffold.notificationsStatus = args;
};

var draftSetActiveComment = function draftSetActiveComment(draft, newActiveComment) {
  if (newActiveComment !== null) {
    var comment = draft.comments.find(function (c) {
      return c.id === newActiveComment.id;
    });

    if (typeof comment === 'undefined') {
      return;
    }
  }

  draft.ui.scaffold.activeComment.previous = draft.ui.scaffold.activeComment.current;
  draft.ui.scaffold.activeComment.current = newActiveComment;
};

var draftSetMarkerPrompt = function draftSetMarkerPrompt(draft, next) {
  draft.ui.scaffold.markerPrompt = next;
};

var acceptCommentMarker = function acceptCommentMarker(setState, opts) {
  return function (comment) {
    var backupComment = _objectSpread({}, comment);

    var handleRequest =
    /*#__PURE__*/
    function () {
      var _ref155 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee33() {
        var lastMessageInThread;
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                _context33.prev = 0;
                lastMessageInThread = comment.messages[comment.messages.length - 1];
                _context33.next = 4;
                return opts.handlers.acceptReviewComment(lastMessageInThread.id);

              case 4:
                setProducedState(setState, function (draft) {
                  draftRemoveFromUpdateQueue(draft, comment.id);
                });
                _context33.next = 10;
                break;

              case 7:
                _context33.prev = 7;
                _context33.t0 = _context33["catch"](0);
                setProducedState(setState, function (draft) {
                  draftUpdateComment(draft, comment.id, backupComment);
                  draftShowNotification(draft, {
                    type: NotificationTypes.AcceptReviewCommentError
                  });
                  draftRemoveFromUpdateQueue(draft, comment.id);
                });

              case 10:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, null, [[0, 7]]);
      }));

      return function handleRequest() {
        return _ref155.apply(this, arguments);
      };
    }();

    return function () {
      setProducedState(setState, function (draft) {
        draftAddToUpdateQueue(draft, comment.id);
        draftUpdateComment(draft, comment.id, {
          status: CommentStatus.Accepted
        });
      });
      handleRequest();
    };
  };
};

var rejectCommentMarker = function rejectCommentMarker(setState, opts) {
  return function (comment) {
    var backupComment = _objectSpread({}, comment);

    var handleRequest =
    /*#__PURE__*/
    function () {
      var _ref156 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee34(message) {
        var rejectedMarkerId, newReviewComment, newMessage;
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                _context34.prev = 0;
                rejectedMarkerId = backupComment.messages[comment.messages.length - 1].id;
                _context34.next = 4;
                return opts.handlers.rejectReviewComment(rejectedMarkerId);

              case 4:
                _context34.next = 6;
                return opts.handlers.postReviewComment({
                  body: message,
                  side: backupComment.cardFace,
                  x: backupComment.x,
                  y: backupComment.y,
                  replyTo: backupComment.id
                });

              case 6:
                newReviewComment = _context34.sent;
                newMessage = convertReviewCommentToCommentMarkerMessage(newReviewComment);
                setProducedState(setState, function (draft) {
                  var index = draft.comments.findIndex(function (c) {
                    return comment.id === c.id;
                  });

                  if (index > -1) {
                    var c = draft.comments[index];
                    c.messages[c.messages.length - 1] = newMessage;
                    draftResetDoneStatusByCardFace(draft, draft.comments[index]);
                  }

                  draftRemoveFromUpdateQueue(draft, comment.id);
                });
                _context34.next = 14;
                break;

              case 11:
                _context34.prev = 11;
                _context34.t0 = _context34["catch"](0);
                setProducedState(setState, function (draft) {
                  draftUpdateComment(draft, comment.id, backupComment);
                  draftShowNotification(draft, {
                    type: NotificationTypes.RejectReviewCommentError
                  });
                  draftRemoveFromUpdateQueue(draft, comment.id);
                });

              case 14:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, null, [[0, 11]]);
      }));

      return function handleRequest(_x7) {
        return _ref156.apply(this, arguments);
      };
    }();

    return function (message) {
      var tempId = v4();
      var newMessage = {
        id: tempId,
        postedBy: opts.props.currentUser.name,
        datePosted: new Date(),
        message: message
      };
      setProducedState(setState, function (draft) {
        draftAddToUpdateQueue(draft, comment.id);
        var index = draft.comments.findIndex(function (c) {
          return comment.id === c.id;
        });

        if (index > -1) {
          draft.comments[index].status = CommentStatus.Rejected;
          draft.comments[index].messages.push(newMessage);
          draftResetDoneStatusByCardFace(draft, draft.comments[index]);
        }
      });
      handleRequest(message);
    };
  };
};

var revertAcceptedCommentMarker = function revertAcceptedCommentMarker(setState, opts) {
  return function (comment) {
    var backupComment = _objectSpread({}, comment);

    var handleRequest =
    /*#__PURE__*/
    function () {
      var _ref157 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee35() {
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                _context35.prev = 0;
                _context35.next = 3;
                return opts.handlers.updateReviewComment(backupComment.id, {
                  status: ReviewCommentStatus.InReview
                });

              case 3:
                setProducedState(setState, function (draft) {
                  draftRemoveFromUpdateQueue(draft, comment.id);
                });
                _context35.next = 9;
                break;

              case 6:
                _context35.prev = 6;
                _context35.t0 = _context35["catch"](0);
                setProducedState(setState, function (draft) {
                  draftUpdateComment(draft, comment.id, backupComment);
                  draftShowNotification(draft, {
                    type: NotificationTypes.UndoAcceptedReviewCommentError
                  });
                  draftRemoveFromUpdateQueue(draft, comment.id);
                });

              case 9:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, null, [[0, 6]]);
      }));

      return function handleRequest() {
        return _ref157.apply(this, arguments);
      };
    }();

    return function () {
      setProducedState(setState, function (draft) {
        draftAddToUpdateQueue(draft, comment.id);
        draftUpdateComment(draft, comment.id, {
          status: CommentStatus.Pending
        });
      });
      handleRequest();
    };
  };
};

var revertRejectedCommentMarker = function revertRejectedCommentMarker(setState, opts) {
  return function (comment) {
    var backupComment = _objectSpread({}, comment);

    var messageToRevert = backupComment.messages[comment.messages.length - 2];
    var messageToDelete = backupComment.messages[comment.messages.length - 1];

    var handleRequest =
    /*#__PURE__*/
    function () {
      var _ref158 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee36(revertedStatus) {
        var status;
        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                status = ReviewCommentStatus.InReview;

                if (revertedStatus === CommentStatus.Accepted) {
                  status = ReviewCommentStatus.Accepted;
                }

                _context36.prev = 2;
                _context36.next = 5;
                return opts.handlers.updateReviewComment(messageToRevert.id, {
                  status: status
                });

              case 5:
                _context36.next = 7;
                return opts.handlers.deleteReviewComment(messageToDelete.id);

              case 7:
                setProducedState(setState, function (draft) {
                  draftRemoveFromUpdateQueue(draft, comment.id);
                });
                _context36.next = 13;
                break;

              case 10:
                _context36.prev = 10;
                _context36.t0 = _context36["catch"](2);
                setProducedState(setState, function (draft) {
                  draftUpdateComment(draft, comment.id, backupComment);
                  draftShowNotification(draft, {
                    type: NotificationTypes.UndoRejectedReviewCommentError
                  });
                  draftRemoveFromUpdateQueue(draft, comment.id);
                });

              case 13:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, null, [[2, 10]]);
      }));

      return function handleRequest(_x8) {
        return _ref158.apply(this, arguments);
      };
    }();

    return function (revertedStatus) {
      setProducedState(setState, function (draft) {
        draftAddToUpdateQueue(draft, comment.id);
        var index = draft.comments.findIndex(function (c) {
          return comment.id === c.id;
        });

        if (index > -1) {
          draft.comments[index].status = revertedStatus !== null && revertedStatus !== void 0 ? revertedStatus : CommentStatus.Pending;
          draft.comments[index].messages.pop();
          draftResetDoneStatusByCardFace(draft, draft.comments[index]);
        }
      });
      handleRequest();
    };
  };
};

var updateLastMessageOnCommentMarker = function updateLastMessageOnCommentMarker(setState, opts) {
  return function (comment) {
    var backupComment = _objectSpread({}, comment);

    var handleRequest =
    /*#__PURE__*/
    function () {
      var _ref159 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee37(m) {
        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                _context37.prev = 0;
                _context37.next = 3;
                return opts.handlers.updateReviewComment(comment.id, {
                  body: m
                });

              case 3:
                setProducedState(setState, function (draft) {
                  draftRemoveFromUpdateQueue(draft, comment.id);
                });
                _context37.next = 9;
                break;

              case 6:
                _context37.prev = 6;
                _context37.t0 = _context37["catch"](0);
                setProducedState(setState, function (draft) {
                  draftUpdateComment(draft, comment.id, backupComment);
                  draftShowNotification(draft, {
                    type: NotificationTypes.UpdateReviewCommentError
                  });
                  draftRemoveFromUpdateQueue(draft, comment.id);
                });

              case 9:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, null, [[0, 6]]);
      }));

      return function handleRequest(_x9) {
        return _ref159.apply(this, arguments);
      };
    }();

    return function (m) {
      var newMessage = _objectSpread({}, comment.messages[comment.messages.length - 1], {
        datePosted: new Date(),
        message: m
      });

      setProducedState(setState, function (draft) {
        draftAddToUpdateQueue(draft, comment.id);
        var index = draft.comments.findIndex(function (c) {
          return comment.id === c.id;
        });

        if (index > -1) {
          var _comment6 = draft.comments[index];
          _comment6.messages[_comment6.messages.length - 1] = newMessage;
          draftResetDoneStatusByCardFace(draft, _comment6);
        }
      });
      handleRequest(m);
    };
  };
};

var generateCommentsActions = function generateCommentsActions(setState, options) {
  var props = options.props,
      handlers = options.handlers;

  var setComments = function setComments(next) {
    setProducedState(setState, function (draft) {
      draft.comments = getNextValue(draft.comments, next);
    });
  };

  var addToUpdateQueue = function addToUpdateQueue(id) {
    setProducedState(setState, function (draft) {
      draftAddToUpdateQueue(draft, id);
    });
  };

  var removeFromUpdateQueue = function removeFromUpdateQueue(id) {
    setProducedState(setState, function (draft) {
      draftRemoveFromUpdateQueue(draft, id);
    });
  };

  var addCommentMarker =
  /*#__PURE__*/
  function () {
    var _ref160 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee38(args) {
      var cardFace, x, y, message, tempId, now, tempComment, reviewComment, marker;
      return _regeneratorRuntime.wrap(function _callee38$(_context38) {
        while (1) {
          switch (_context38.prev = _context38.next) {
            case 0:
              cardFace = args.cardFace, x = args.x, y = args.y, message = args.message;
              tempId = v4();
              now = new Date();
              tempComment = {
                id: tempId,
                cardFace: cardFace,
                messages: [{
                  id: tempId,
                  postedBy: props.currentUser.name,
                  datePosted: now,
                  message: message
                }],
                x: x,
                y: y,
                status: CommentStatus.Pending,
                dateOriginallyPosted: now
              };
              setProducedState(setState, function (draft) {
                draft.ui.sidebar.addingUnpinnedComment = false;
                draft.ui.scaffold.markerPrompt = null;
                draft.comments.push(tempComment);
                draftAddToUpdateQueue(draft, tempId);
                draftSetActiveComment(draft, {
                  id: tempComment.id,
                  isExpanded: false
                });
                draftUpdateDoneStatus(draft, tempComment);
              });
              _context38.prev = 5;
              _context38.next = 8;
              return handlers.postReviewComment({
                body: message,
                side: cardFace,
                x: x,
                y: y
              });

            case 8:
              reviewComment = _context38.sent;
              marker = convertReviewCommentToCommentMarker(reviewComment);
              setProducedState(setState, function (draft) {
                var _a;

                draftRemoveFromUpdateQueue(draft, tempId);
                draftUpdateComment(draft, tempId, marker);

                if (((_a = draft.ui.scaffold.activeComment.current) === null || _a === void 0 ? void 0 : _a.id) === tempId) {
                  draftSetActiveComment(draft, {
                    id: marker.id,
                    isExpanded: false
                  });
                }
              });
              _context38.next = 16;
              break;

            case 13:
              _context38.prev = 13;
              _context38.t0 = _context38["catch"](5);
              setProducedState(setState, function (draft) {
                draftRemoveFromUpdateQueue(draft, tempId);
                draftDeleteComment(draft, tempId);
                draftShowNotification(draft, {
                  type: NotificationTypes.PostReviewCommentError
                });
              });

            case 16:
            case "end":
              return _context38.stop();
          }
        }
      }, _callee38, null, [[5, 13]]);
    }));

    return function addCommentMarker(_x10) {
      return _ref160.apply(this, arguments);
    };
  }();

  var removeCommentMarker =
  /*#__PURE__*/
  function () {
    var _ref161 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee39(id) {
      return _regeneratorRuntime.wrap(function _callee39$(_context39) {
        while (1) {
          switch (_context39.prev = _context39.next) {
            case 0:
              addToUpdateQueue(id);
              _context39.prev = 1;
              _context39.next = 4;
              return handlers.deleteReviewComment(id);

            case 4:
              setProducedState(setState, function (draft) {
                var comment = draft.comments.find(function (c) {
                  return id === c.id;
                });

                if (typeof comment !== 'undefined') {
                  draftDeleteComment(draft, id);
                  draftUpdateDoneStatus(draft, comment);
                  draftRemoveFromUpdateQueue(draft, id);
                }
              });
              _context39.next = 10;
              break;

            case 7:
              _context39.prev = 7;
              _context39.t0 = _context39["catch"](1);
              setProducedState(setState, function (draft) {
                draftShowNotification(draft, {
                  type: NotificationTypes.DeleteReviewCommentError
                });
                draftRemoveFromUpdateQueue(draft, id);
              });

            case 10:
            case "end":
              return _context39.stop();
          }
        }
      }, _callee39, null, [[1, 7]]);
    }));

    return function removeCommentMarker(_x11) {
      return _ref161.apply(this, arguments);
    };
  }();

  var updateCommentLocal = function updateCommentLocal(id, updates) {
    setProducedState(setState, function (draft) {
      draftUpdateComment(draft, id, updates);
      draft.ui.imageViewer.isPinningComment = false;
      draft.ui.imageViewer.pinCommentPayload = null;
    });
  };

  var updateCommentPin = function updateCommentPin(id, updates) {
    var handleRequest =
    /*#__PURE__*/
    function () {
      var _ref162 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee40() {
        var payload;
        return _regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                _context40.prev = 0;
                payload = _objectSpread({}, updates);

                if (payload.cardFace) {
                  delete payload.cardFace;
                  payload.side = updates.cardFace === CardFace.Front ? DesignSide.Front : DesignSide.Back;
                }

                _context40.next = 5;
                return handlers.updateReviewComment(id, payload);

              case 5:
                setProducedState(setState, function (draft) {
                  draftRemoveFromUpdateQueue(draft, id);
                });
                _context40.next = 11;
                break;

              case 8:
                _context40.prev = 8;
                _context40.t0 = _context40["catch"](0);
                setProducedState(setState, function (draft) {
                  draftShowNotification(draft, {
                    type: NotificationTypes.UpdateReviewCommentError
                  });
                  draftRemoveFromUpdateQueue(draft, id);
                });

              case 11:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, null, [[0, 8]]);
      }));

      return function handleRequest() {
        return _ref162.apply(this, arguments);
      };
    }();

    setProducedState(setState, function (draft) {
      draftAddToUpdateQueue(draft, id);
      draftUpdateComment(draft, id, updates);
      draft.ui.imageViewer.isPinningComment = false;
      draft.ui.imageViewer.pinCommentPayload = null;
    });
    handleRequest();
  };

  var commentActionFactory = {
    acceptCommentMarker: acceptCommentMarker(setState, options),
    rejectCommentMarker: rejectCommentMarker(setState, options),
    revertAcceptedCommentMarker: revertAcceptedCommentMarker(setState, options),
    revertRejectedCommentMarker: revertRejectedCommentMarker(setState, options),
    updateLastMessageOnCommentMarker: updateLastMessageOnCommentMarker(setState, options)
  };

  var setGroupComments = function setGroupComments(next) {
    setProducedState(setState, function (draft) {
      draft.ui.sidebar.groupComments = getNextValue(draft.ui.sidebar.groupComments, next);
    });
  };

  var toggleGroupComments = function toggleGroupComments() {
    setGroupComments(function (g) {
      return !g;
    });
  };

  return {
    setComments: setComments,
    addToUpdateQueue: addToUpdateQueue,
    removeFromUpdateQueue: removeFromUpdateQueue,
    setGroupComments: setGroupComments,
    toggleGroupComments: toggleGroupComments,
    addCommentMarker: addCommentMarker,
    removeCommentMarker: removeCommentMarker,
    updateCommentLocal: updateCommentLocal,
    updateCommentPin: updateCommentPin,
    commentActionFactory: commentActionFactory
  };
};

var generateCommonActions = function generateCommonActions(setState, options) {
  var handlers = options.handlers;

  var setWorkflow = function setWorkflow(next) {
    setProducedState(setState, function (draft) {
      draft.workflow = getNextValue(draft.workflow, next);
    });
  };

  var refreshDesign =
  /*#__PURE__*/
  function () {
    var _ref163 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee41() {
      return _regeneratorRuntime.wrap(function _callee41$(_context41) {
        while (1) {
          switch (_context41.prev = _context41.next) {
            case 0:
              _context41.next = 2;
              return handlers.refreshDesign();

            case 2:
              setProducedState(setState, function (draft) {
                if (draft.workflow === Workflow.Submit) {
                  var _iteratorNormalCompletion6 = true;
                  var _didIteratorError6 = false;
                  var _iteratorError6 = undefined;

                  try {
                    for (var _iterator6 = draft.comments[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                      var c = _step6.value;
                      c.isVerified = false;
                      c.isDone = false;
                    }
                  } catch (err) {
                    _didIteratorError6 = true;
                    _iteratorError6 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
                        _iterator6.return();
                      }
                    } finally {
                      if (_didIteratorError6) {
                        throw _iteratorError6;
                      }
                    }
                  }
                }
              });

            case 3:
            case "end":
              return _context41.stop();
          }
        }
      }, _callee41);
    }));

    return function refreshDesign() {
      return _ref163.apply(this, arguments);
    };
  }();

  var proceedToFinalLook = function proceedToFinalLook() {
    setProducedState(setState, function (draft) {
      draftSetActiveComment(draft, null);

      if (draft.ui.imageViewer.cardFace !== CardFace.Front) {
        draft.ui.imageViewer.cardFace = CardFace.Front;
      }

      draft.comments = draft.comments.filter(function (c) {
        return c.status === CommentStatus.Rejected;
      }).map(function (c) {
        return _objectSpread({}, c, {
          status: CommentStatus.Pending
        });
      });
      draft.workflow = Workflow.Request;
      draft.ui.scaffold.modalStatus = {
        type: ModalTypes.Welcome
      };
    });
  };

  return {
    setWorkflow: setWorkflow,
    refreshDesign: refreshDesign,
    proceedToFinalLook: proceedToFinalLook
  };
};

var generateImageViewerUiActions = function generateImageViewerUiActions(setState, options) {
  var refs = options.refs;

  var setDefaultZoom = function setDefaultZoom(containerScale, offsetX, offsetY) {
    setProducedState(setState, function (draft) {
      Object.assign(draft.ui.imageViewer.defaultTransform, {
        scale: containerScale,
        translateX: offsetX,
        translateY: offsetY
      });
    });
    refs.setImageSpring({
      scale: containerScale,
      translateX: offsetX,
      translateY: offsetY
    });
  };

  var adjustZoomAndAutoCenter = function adjustZoomAndAutoCenter(newScaleValue, previousScaleValue) {
    setProducedState(setState, function (draft) {
      var defaultTransform = draft.ui.imageViewer.defaultTransform;
      var newValues = getAdjustedZoom({
        newScaleValue: newScaleValue,
        previousScaleValue: previousScaleValue,
        defaultTransform: defaultTransform,
        refs: refs
      });
      refs.setImageSpring(newValues);
    });
  };

  var resetZoom = function resetZoom(sv) {
    setProducedState(setState, function (draft) {
      var _a, _b, _c;

      var defaultTransform = draft.ui.imageViewer.defaultTransform;
      refs.setImageSpring({
        to: {
          scale: (_a = sv === null || sv === void 0 ? void 0 : sv.s) !== null && _a !== void 0 ? _a : defaultTransform.scale,
          translateX: (_b = sv === null || sv === void 0 ? void 0 : sv.x) !== null && _b !== void 0 ? _b : defaultTransform.translateX,
          translateY: (_c = sv === null || sv === void 0 ? void 0 : sv.y) !== null && _c !== void 0 ? _c : defaultTransform.translateY
        }
      });
    });
  };

  var zoom = function zoom(getNextZoom) {
    setProducedState(setState, function (draft) {
      var defaultTransform = draft.ui.imageViewer.defaultTransform;
      var scale = refs.scale;
      var minZoom = defaultTransform.scale / 2;
      var maxZoom = defaultTransform.scale * 4;
      var zoomStepScale = minZoom;
      var previousScaleValue = scale.get();
      var newScaleValue = limitWithinRange$2(getNextZoom(scale.get(), zoomStepScale), maxZoom, minZoom);
      var newValues = getAdjustedZoom({
        newScaleValue: newScaleValue,
        previousScaleValue: previousScaleValue,
        defaultTransform: defaultTransform,
        refs: refs
      });
      refs.setImageSpring(newValues);
    });
  };

  var zoomIn = function zoomIn() {
    zoom(zoomAdd);
  };

  var zoomOut = function zoomOut() {
    zoom(zoomSub);
  };

  var setHovered = function setHovered(next) {
    setProducedState(setState, function (draft) {
      draft.ui.imageViewer.hovered = getNextValue(draft.ui.imageViewer.hovered, next);
    });
  };

  var focusOnCoordinates = function focusOnCoordinates(x, y) {
    setProducedState(setState, function (draft) {
      var _a, _b, _c, _d;

      var defaultTransform = draft.ui.imageViewer.defaultTransform;
      var scale = refs.scale,
          imgElRef = refs.imgElRef;
      var baseWidth = (_b = (_a = imgElRef.current) === null || _a === void 0 ? void 0 : _a.naturalWidth) !== null && _b !== void 0 ? _b : 0;
      var baseHeight = (_d = (_c = imgElRef.current) === null || _c === void 0 ? void 0 : _c.naturalHeight) !== null && _d !== void 0 ? _d : 0;
      var scaleValue = scale.get();
      var isPortrait = baseHeight > baseWidth;
      var scaleDiff = defaultTransform.scale * 4 - scaleValue + 1;
      var width = baseWidth * 0.5;
      var height = baseHeight * 0.5;
      var xFactor = (x / 100 * 2 - 1) * -1;
      var yFactor = (y / 100 * 2 - 1) * -1;
      var biasFactor = scaleDiff;
      var xBias = x > 50 ? defaultTransform.translateX * biasFactor : defaultTransform.translateX * biasFactor * -1;
      var yBias = y > 50 ? defaultTransform.translateY * biasFactor : defaultTransform.translateY * biasFactor * -1;
      var calcX = xBias + xFactor * width;
      var calcY = yBias + yFactor * height;
      var translateX = isPortrait ? calcY : calcX;
      var translateY = isPortrait ? calcX : calcY;
      var maxZoom = defaultTransform.scale * 4;
      refs.setImageSpring({
        scale: maxZoom,
        translateX: translateX,
        translateY: translateY
      });
    });
  };

  return {
    setDefaultZoom: setDefaultZoom,
    adjustZoomAndAutoCenter: adjustZoomAndAutoCenter,
    resetZoom: resetZoom,
    zoomIn: zoomIn,
    zoomOut: zoomOut,
    setHovered: setHovered,
    focusOnCoordinates: focusOnCoordinates
  };
};

var zoomAdd = function zoomAdd(scale, step) {
  return scale + step;
};

var zoomSub = function zoomSub(scale, step) {
  return scale - step;
};

var getAdjustedZoom = function getAdjustedZoom(args) {
  var newScaleValue = args.newScaleValue,
      previousScaleValue = args.previousScaleValue,
      defaultTransform = args.defaultTransform,
      refs = args.refs;
  var newValues = {
    scale: newScaleValue
  };

  if (newScaleValue <= defaultTransform.scale) {
    newValues.translateX = defaultTransform.translateX;
    newValues.translateY = defaultTransform.translateY;
  } else if (newScaleValue < previousScaleValue) {
    var translateFactor = previousScaleValue - newScaleValue;
    var currentTranslateX = refs.translateX.get();
    var currentTranslateY = refs.translateY.get();
    var deltaX = (currentTranslateX - defaultTransform.translateX) * translateFactor;
    var deltaY = (currentTranslateY - defaultTransform.translateY) * translateFactor;
    newValues.translateX = currentTranslateX - deltaX;
    newValues.translateY = currentTranslateY - deltaY;
  }

  return newValues;
};

var limitWithinRange$2 = function limitWithinRange$2(given, max, min) {
  return Math.min(max, Math.max(given, min));
};

var generateUiActions = function generateUiActions(setState, options) {
  var setCardFace = function setCardFace(next) {
    setProducedState(setState, function (draft) {
      draft.ui.imageViewer.cardFace = getNextValue(draft.ui.imageViewer.cardFace, next);
    });
  };

  var setDefaultTransform = function setDefaultTransform(next) {
    setProducedState(setState, function (draft) {
      draft.ui.imageViewer.defaultTransform = getNextValue(draft.ui.imageViewer.defaultTransform, next);
    });
  };

  var setIsInteractive = function setIsInteractive(next) {
    setProducedState(setState, function (draft) {
      draft.ui.imageViewer.isInteractive = getNextValue(draft.ui.imageViewer.isInteractive, next);
    });
  };

  var openUnpinnedCommentPrompt = function openUnpinnedCommentPrompt() {
    setProducedState(setState, function (draft) {
      draft.ui.sidebar.addingUnpinnedComment = true;
      draft.ui.imageViewer.isPinningComment = false;
      draft.ui.imageViewer.pinCommentPayload = null;
      draftSetMarkerPrompt(draft, null);
      draftSetActiveComment(draft, null);
    });
  };

  var closeUnpinnedCommentPrompt = function closeUnpinnedCommentPrompt() {
    setProducedState(setState, function (draft) {
      draft.ui.sidebar.addingUnpinnedComment = false;
      draft.ui.imageViewer.isPinningComment = false;
      draft.ui.imageViewer.pinCommentPayload = null;
    });
  };

  var setMarkerPrompt = function setMarkerPrompt(next) {
    setProducedState(setState, function (draft) {
      draftSetMarkerPrompt(draft, getNextValue(draft.ui.scaffold.markerPrompt, next));
      draft.ui.sidebar.addingUnpinnedComment = false;
      draftSetActiveComment(draft, null);
    });
  };

  var setDoneFront = function setDoneFront(next) {
    setProducedState(setState, function (draft) {
      draft.ui.scaffold.doneFront = getNextValue(draft.ui.scaffold.doneFront, next);
    });
  };

  var setDoneBack = function setDoneBack(next) {
    setProducedState(setState, function (draft) {
      draft.ui.scaffold.doneBack = getNextValue(draft.ui.scaffold.doneBack, next);
    });
  };

  var setModalStatus = function setModalStatus(next) {
    setProducedState(setState, function (draft) {
      draft.ui.scaffold.modalStatus = getNextValue(draft.ui.scaffold.modalStatus, next);
    });
  };

  var openPinnedCommentPrompt = function openPinnedCommentPrompt(x, y) {
    setProducedState(setState, function (draft) {
      draft.ui.sidebar.addingUnpinnedComment = false;
      draft.ui.imageViewer.isPinningComment = false;
      draft.ui.imageViewer.pinCommentPayload = null;
      draftSetMarkerPrompt(draft, {
        x: x,
        y: y
      });
      draftSetActiveComment(draft, null);
    });
  };

  var cancelAddMarker = function cancelAddMarker() {
    setMarkerPrompt(null);
  };

  var openModal = function openModal(args) {
    setModalStatus(args);
  };

  var closeModal = function closeModal() {
    setModalStatus(undefined);
  };

  var showNotification = function showNotification(args) {
    setProducedState(setState, function (draft) {
      draftShowNotification(draft, args);
    });
  };

  var removeNotification = function removeNotification() {
    setProducedState(setState, function (draft) {
      draft.ui.scaffold.notificationsStatus = undefined;
    });
  };

  var setHasViewedBack = function setHasViewedBack(next) {
    setProducedState(setState, function (draft) {
      draft.ui.scaffold.hasViewedBack = getNextValue(draft.ui.scaffold.hasViewedBack, next);
    });
  };

  var setIsViewingPrevious = function setIsViewingPrevious(next) {
    setProducedState(setState, function (draft) {
      draft.ui.scaffold.isViewingPrevious = getNextValue(draft.ui.scaffold.isViewingPrevious, next);
    });
  };

  var toggleViewingPrevious = function toggleViewingPrevious() {
    setIsViewingPrevious(function (b) {
      return !b;
    });
  };

  var setIsPreviousVersionLocked = function setIsPreviousVersionLocked(next) {
    setProducedState(setState, function (draft) {
      draft.ui.scaffold.isPreviousVersionLocked = getNextValue(draft.ui.scaffold.isPreviousVersionLocked, next);
    });
  };

  var setShowingInactiveMarkers = function setShowingInactiveMarkers(next) {
    setProducedState(setState, function (draft) {
      draft.ui.imageViewer.showingInactiveMarkers = getNextValue(draft.ui.imageViewer.showingInactiveMarkers, next);
    });
  };

  var setShowingAllMarkers = function setShowingAllMarkers(next) {
    setProducedState(setState, function (draft) {
      draft.ui.imageViewer.showingAllMarkers = getNextValue(draft.ui.imageViewer.showingAllMarkers, next);
    });
  };

  var setExpandedMarkerIndex = function setExpandedMarkerIndex(next) {
    setProducedState(setState, function (draft) {
      draft.ui.sidebar.expandedMarkerIndex = getNextValue(draft.ui.sidebar.expandedMarkerIndex, next);
    });
  };

  var setActiveComment = function setActiveComment(newActiveComment) {
    setProducedState(setState, function (draft) {
      draftSetActiveComment(draft, newActiveComment);

      if (draft.workflow === Workflow.Review || draft.workflow === Workflow.Submit) {
        if (newActiveComment === null || newActiveComment === void 0 ? void 0 : newActiveComment.id) {
          var comment = draft.comments.find(function (c) {
            return c.id === (newActiveComment === null || newActiveComment === void 0 ? void 0 : newActiveComment.id);
          });

          if (comment && comment.cardFace !== draft.ui.imageViewer.cardFace) {
            draft.ui.imageViewer.cardFace = comment.cardFace;
          }
        }
      }
    });
  };

  var pinComment = function pinComment(id) {
    setProducedState(setState, function (draft) {
      draft.ui.imageViewer.isPinningComment = true;
      draft.ui.imageViewer.pinCommentPayload = {
        newComment: typeof id === 'undefined',
        id: id !== null && id !== void 0 ? id : null
      };
    });
  };

  var cancelPinComment = function cancelPinComment() {
    setProducedState(setState, function (draft) {
      draft.ui.imageViewer.isPinningComment = false;
      draft.ui.imageViewer.pinCommentPayload = null;
    });
  };

  var setIsEditingComment = function setIsEditingComment(next) {
    setProducedState(setState, function (draft) {
      draft.ui.sidebar.isEditingComment = getNextValue(draft.ui.sidebar.isEditingComment, next);
    });
  };

  var imageViewerActions = generateImageViewerUiActions(setState, options);
  return _objectSpread({
    setCardFace: setCardFace,
    setDefaultTransform: setDefaultTransform,
    setIsInteractive: setIsInteractive,
    openUnpinnedCommentPrompt: openUnpinnedCommentPrompt,
    closeUnpinnedCommentPrompt: closeUnpinnedCommentPrompt,
    setMarkerPrompt: setMarkerPrompt,
    setDoneFront: setDoneFront,
    setDoneBack: setDoneBack,
    setModalStatus: setModalStatus,
    openPinnedCommentPrompt: openPinnedCommentPrompt,
    cancelAddMarker: cancelAddMarker,
    openModal: openModal,
    closeModal: closeModal,
    showNotification: showNotification,
    removeNotification: removeNotification,
    setHasViewedBack: setHasViewedBack,
    setIsViewingPrevious: setIsViewingPrevious,
    toggleViewingPrevious: toggleViewingPrevious,
    setIsPreviousVersionLocked: setIsPreviousVersionLocked,
    setShowingInactiveMarkers: setShowingInactiveMarkers,
    setShowingAllMarkers: setShowingAllMarkers,
    setExpandedMarkerIndex: setExpandedMarkerIndex,
    setActiveComment: setActiveComment,
    pinComment: pinComment,
    cancelPinComment: cancelPinComment,
    setIsEditingComment: setIsEditingComment
  }, imageViewerActions);
};

var useCombinedRefs = function useCombinedRefs(args) {
  var initialState = args.initialState;
  var imgElRef = useRef(null);
  var isDragging = useRef(false);
  var singleClickTimeoutRef = useRef(null);
  var scaleTransformSpring = useSpring(function () {
    return _objectSpread({}, initialState.defaultTransform);
  });
  var combinedRefs = useMemo(function () {
    var _scaleTransformSpring = _slicedToArray(scaleTransformSpring, 2),
        _scaleTransformSpring2 = _scaleTransformSpring[0],
        scale = _scaleTransformSpring2.scale,
        translateX = _scaleTransformSpring2.translateX,
        translateY = _scaleTransformSpring2.translateY,
        setImageSpring = _scaleTransformSpring[1];

    return {
      scale: scale,
      translateX: translateX,
      translateY: translateY,
      setImageSpring: setImageSpring,
      imgElRef: imgElRef,
      isDragging: isDragging,
      singleClickTimeoutRef: singleClickTimeoutRef
    };
  }, [scaleTransformSpring]);
  return combinedRefs;
};

var useMissingImageChecks = function useMissingImageChecks(src) {
  var _useState129 = useState(true),
      _useState130 = _slicedToArray(_useState129, 2),
      isImageMissing = _useState130[0],
      setIsImageMissing = _useState130[1];

  var _useState131 = useState({
    width: 0,
    height: 0
  }),
      _useState132 = _slicedToArray(_useState131, 2),
      dimensions = _useState132[0],
      setDimensions = _useState132[1];

  useEffect(function () {
    if (typeof src === 'undefined') {
      setIsImageMissing(true);
      return;
    }

    setIsImageMissing(false);
    var img = new Image();
    img.src = src;

    var handleError = function handleError(e) {
      setIsImageMissing(true);
    };

    var handleLoad = function handleLoad() {
      setDimensions({
        width: img.naturalWidth,
        height: img.naturalHeight
      });
    };

    img.addEventListener('error', handleError);
    img.addEventListener('load', handleLoad);
    return function () {
      img.removeEventListener('error', handleError);
      img.removeEventListener('load', handleLoad);
    };
  }, [src]);
  return {
    isImageMissing: isImageMissing,
    setIsImageMissing: setIsImageMissing,
    dimensions: dimensions
  };
};

var useCombinedEffects = function useCombinedEffects(designDetails) {
  var urls = getUrlsFromDesignDetails(designDetails);

  var _useMissingImageCheck = useMissingImageChecks(urls.currentVersionFrontUrl),
      areCurrentImagesMissing = _useMissingImageCheck.isImageMissing,
      currentVersionFrontDimensions = _useMissingImageCheck.dimensions;

  var _useMissingImageCheck2 = useMissingImageChecks(urls.currentVersionBackUrl),
      currentVersionBackDimensions = _useMissingImageCheck2.dimensions;

  var _useMissingImageCheck3 = useMissingImageChecks(urls.previousVersionFrontUrl),
      arePreviousImagesMissing = _useMissingImageCheck3.isImageMissing,
      previousVersionFrontDimensions = _useMissingImageCheck3.dimensions;

  var _useMissingImageCheck4 = useMissingImageChecks(urls.previousVersionFrontUrl),
      previousVersionBackDimensions = _useMissingImageCheck4.dimensions;

  var frontPostcardUrl = getImageUrlWithFallback({
    src: urls.currentVersionFrontUrl,
    fallback: imgViewerPlaceholder,
    hasError: areCurrentImagesMissing
  });
  var backPostcardUrl = getImageUrlWithFallback({
    src: urls.currentVersionBackUrl,
    fallback: imgViewerPlaceholder,
    hasError: areCurrentImagesMissing
  });
  var frontThumbnailUrl = getImageUrlWithFallback({
    src: urls.currentVersionFrontThumbnailUrl,
    fallback: imgViewerPlaceholder,
    hasError: areCurrentImagesMissing
  });
  var backThumbnailUrl = getImageUrlWithFallback({
    src: urls.currentVersionBackThumbnailUrl,
    fallback: imgViewerPlaceholder,
    hasError: areCurrentImagesMissing
  });
  var previousFrontPostcardUrl = getImageUrlWithFallback({
    src: urls.previousVersionFrontUrl,
    fallback: imgViewerPlaceholder,
    hasError: arePreviousImagesMissing
  });
  var previousBackPostcardUrl = getImageUrlWithFallback({
    src: urls.previousVersionBackUrl,
    fallback: imgViewerPlaceholder,
    hasError: arePreviousImagesMissing
  });
  var currentVersionFrontHasLoaded = currentVersionFrontDimensions.width > 0 && currentVersionFrontDimensions.height > 0;
  var currentVersionBackHasLoaded = currentVersionBackDimensions.width > 0 && currentVersionBackDimensions.height > 0;
  var previousVersionFrontHasLoaded = previousVersionFrontDimensions.width > 0 && previousVersionFrontDimensions.height > 0;
  var previousVersionBackHasLoaded = previousVersionBackDimensions.width > 0 && previousVersionBackDimensions.height > 0;
  var scaffold = {
    frontPostcardUrl: frontPostcardUrl,
    backPostcardUrl: backPostcardUrl,
    frontThumbnailUrl: frontThumbnailUrl,
    backThumbnailUrl: backThumbnailUrl,
    previousFrontPostcardUrl: previousFrontPostcardUrl,
    previousBackPostcardUrl: previousBackPostcardUrl,
    areCurrentImagesMissing: areCurrentImagesMissing,
    arePreviousImagesMissing: arePreviousImagesMissing
  };
  var imageViewer = {
    currentVersionFrontDimensions: currentVersionFrontDimensions,
    currentVersionBackDimensions: currentVersionBackDimensions,
    previousVersionFrontDimensions: previousVersionFrontDimensions,
    previousVersionBackDimensions: previousVersionBackDimensions,
    currentVersionFrontHasLoaded: currentVersionFrontHasLoaded,
    currentVersionBackHasLoaded: currentVersionBackHasLoaded,
    previousVersionFrontHasLoaded: previousVersionFrontHasLoaded,
    previousVersionBackHasLoaded: previousVersionBackHasLoaded
  };
  return {
    scaffold: scaffold,
    imageViewer: imageViewer
  };
};

var getImageUrlWithFallback = function getImageUrlWithFallback(_ref164) {
  var src = _ref164.src,
      fallback = _ref164.fallback,
      hasError = _ref164.hasError;

  if (hasError) {
    return fallback;
  }

  return src !== null && src !== void 0 ? src : fallback;
};

var filenamify = function filenamify(text, replace) {
  return text.replace(/[<>:"/\\/|?*]+/g, replace !== null && replace !== void 0 ? replace : ' ').trim();
};

var getFilenameFromDesign = function getFilenameFromDesign(_ref165) {
  var designName = _ref165.designName,
      versionNumber = _ref165.versionNumber,
      customerName = _ref165.customerName;

  var _customerName = customerName ? "".concat(customerName, "-") : '';

  var filename = "".concat(_customerName).concat(designName, "-").concat(versionNumber);
  return filenamify(filename, '-');
};

var getCampaignMediaReviewType = function getCampaignMediaReviewType(args) {
  var mailingDetails = args.mailingDetails;

  if (isEmpty(mailingDetails === null || mailingDetails === void 0 ? void 0 : mailingDetails.prePressCompleted)) {
    return CampaignReviewType.PrePressReview;
  }

  if (isEmpty(mailingDetails === null || mailingDetails === void 0 ? void 0 : mailingDetails.approvalDate)) {
    return CampaignReviewType.FinalApproval;
  }

  return CampaignReviewType.Approved;
};

var getTitleFromCampaign = function getTitleFromCampaign(_ref166) {
  var workflow = _ref166.workflow,
      designStatus = _ref166.designStatus,
      viewedAs = _ref166.viewedAs,
      isApproved = _ref166.isApproved,
      campaignName = _ref166.campaignName,
      customerName = _ref166.customerName;

  if (workflow === Workflow.Submit) {
    return "".concat(campaignName).concat(customerName ? " ".concat(customerName) : '');
  }

  var isPrePressReview = designStatus === CampaignDesignStatus.ReadyForPrePress;

  if (viewedAs === DesignReviewViewedAs.Default) {
    if (isPrePressReview) {
      return "Pre Press Review for ".concat(campaignName).concat(customerName ? " for ".concat(customerName) : '');
    }

    var isCustomerReview = [CampaignDesignStatus.NeedsFinalApproval, CampaignDesignStatus.ReadyForFinalApproval].includes(designStatus);

    if (isCustomerReview) {
      return "Customer Review for ".concat(campaignName).concat(customerName ? " for ".concat(customerName) : '');
    }
  }

  if (isApproved) {
    return "Approved Design for ".concat(campaignName);
  }

  return "Design Review for ".concat(campaignName);
};

var useCombinedState = function useCombinedState(props) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;

  var handlers = props.handlers;
  var initialComments = (_a = props.designDetails.initialComments) !== null && _a !== void 0 ? _a : [];
  var combinedStateProps = useMemo(function () {
    return {
      currentUser: props.currentUser,
      conceptDesigner: props.conceptDesigner
    };
  }, [props.currentUser, props.conceptDesigner]);
  var refInitialProps = useMemo(function () {
    return {
      defaultTransform: {
        scale: 1.0,
        translateX: 0,
        translateY: 0
      }
    };
  }, []);
  var refs = useCombinedRefs({
    initialState: refInitialProps
  });

  var _useState133 = useState({
    viewedAs: (_b = props === null || props === void 0 ? void 0 : props.viewedAs) !== null && _b !== void 0 ? _b : DesignReviewViewedAs.Default,
    experience: (_c = props === null || props === void 0 ? void 0 : props.experience) !== null && _c !== void 0 ? _c : DesignReviewExperience.DesignConcept,
    workflow: props.workflow,
    previousWorkflow: props.workflow,
    comments: sortAndFilterComments(initialComments, props.workflow),
    updateQueue: [],
    ui: {
      scaffold: {
        activeComment: {
          current: getDefaultComment(initialComments),
          previous: getDefaultComment(initialComments)
        },
        markerPrompt: null,
        modalStatus: getDefaultOpenModalArgs(_objectSpread({}, props, {
          viewedAs: (_d = props === null || props === void 0 ? void 0 : props.viewedAs) !== null && _d !== void 0 ? _d : DesignReviewViewedAs.Default,
          experience: (_e = props === null || props === void 0 ? void 0 : props.experience) !== null && _e !== void 0 ? _e : DesignReviewExperience.DesignConcept
        })),
        notificationsStatus: undefined,
        doneFront: false,
        doneBack: false,
        hasViewedBack: false,
        isViewingPrevious: getPreviousVersionViewingSettings({
          workflow: props.workflow,
          currentVersionFrontLastModified: props.designDetails.currentVersionFrontLastModified,
          currentVersionBackLastModified: props.designDetails.currentVersionBackLastModified,
          versionNumber: props.designDetails.versionNumber
        }),
        isPreviousVersionLocked: getPreviousVersionViewingSettings({
          workflow: props.workflow,
          currentVersionFrontLastModified: props.designDetails.currentVersionFrontLastModified,
          currentVersionBackLastModified: props.designDetails.currentVersionBackLastModified,
          versionNumber: props.designDetails.versionNumber
        })
      },
      imageViewer: {
        hovered: false,
        cardFace: CardFace.Front,
        isInteractive: true,
        defaultTransform: refInitialProps.defaultTransform,
        showingInactiveMarkers: true,
        showingAllMarkers: true,
        isPinningComment: false,
        pinCommentPayload: null
      },
      sidebar: {
        addingUnpinnedComment: false,
        expandedMarkerIndex: null,
        groupComments: props.workflow === Workflow.Submit,
        isEditingComment: false
      }
    }
  }),
      _useState134 = _slicedToArray(_useState133, 2),
      state = _useState134[0],
      setState = _useState134[1];

  var commentsById = {};
  state.comments.forEach(function (c) {
    commentsById[c.id] = c;
  });
  var activeCommentId = (_f = state.ui.scaffold.activeComment.current) === null || _f === void 0 ? void 0 : _f.id;
  var activeComment = commentsById[activeCommentId !== null && activeCommentId !== void 0 ? activeCommentId : ''];
  var currentReview = props.nextReview;
  var effectState = useCombinedEffects(props.designDetails);
  var derivedState = {
    design: {
      currentUser: props.currentUser,
      conceptDesigner: props.conceptDesigner,
      currentReview: currentReview,
      nextReview: getFollowingReviewFromNextReview(props.nextReview),
      mediaType: props.mediaType,
      isApproved: (_h = (_g = props.designDetails) === null || _g === void 0 ? void 0 : _g.isApproved) !== null && _h !== void 0 ? _h : false,
      file: {
        name: getFilenameFromDesign({
          customerName: props.customerName,
          designName: props.designDetails.name,
          versionNumber: props.designDetails.versionNumber
        })
      }
    },
    campaign: {
      designStatus: (_k = (_j = props.mailingDetails) === null || _j === void 0 ? void 0 : _j.designStatus) !== null && _k !== void 0 ? _k : CampaignDesignStatus.NoLinkedDesign,
      reviewType: getCampaignMediaReviewType({
        mailingDetails: props.mailingDetails,
        workflow: props.workflow
      })
    },
    comments: {
      front: state.comments.filter(function (c) {
        var extraConditionsMet = true;

        if (state.workflow === Workflow.Request) {
          extraConditionsMet = c.status !== CommentStatus.Accepted;
        }

        return c.cardFace === CardFace.Front && extraConditionsMet;
      }),
      back: state.comments.filter(function (c) {
        var extraConditionsMet = true;

        if (state.workflow === Workflow.Request) {
          extraConditionsMet = c.status !== CommentStatus.Accepted;
        }

        return c.cardFace === CardFace.Back && extraConditionsMet;
      }),
      byId: commentsById
    },
    ui: {
      scaffold: _objectSpread({
        title: (_l = props.title) !== null && _l !== void 0 ? _l : state.experience === DesignReviewExperience.DesignConcept ? getTitleFromWorkflow({
          currentUser: combinedStateProps.currentUser,
          currentReview: currentReview,
          workflow: state.workflow,
          designName: props.designDetails.name,
          customerName: props.customerName
        }) : getTitleFromCampaign({
          workflow: state.workflow,
          designStatus: (_o = (_m = props.mailingDetails) === null || _m === void 0 ? void 0 : _m.designStatus) !== null && _o !== void 0 ? _o : CampaignDesignStatus.NoLinkedDesign,
          viewedAs: state.viewedAs,
          isApproved: (_q = (_p = props.designDetails) === null || _p === void 0 ? void 0 : _p.isApproved) !== null && _q !== void 0 ? _q : false,
          campaignName: (_s = (_r = props.mailingDetails) === null || _r === void 0 ? void 0 : _r.name) !== null && _s !== void 0 ? _s : '',
          customerName: props.customerName
        }),
        activeComment: state.ui.scaffold.activeComment.current,
        activeCommentCardFace: (_t = activeComment === null || activeComment === void 0 ? void 0 : activeComment.cardFace) !== null && _t !== void 0 ? _t : null,
        activeCommentCoords: getActiveCommentCoordinates(state.ui.scaffold.activeComment.current, state.comments),
        previousActiveComment: state.ui.scaffold.activeComment.previous,
        previousActiveCommentCoords: getActiveCommentCoordinates(state.ui.scaffold.activeComment.previous, state.comments)
      }, effectState.scaffold),
      imageViewer: _objectSpread({}, effectState.imageViewer, {
        isPortrait: function () {
          var imageViewer = effectState.imageViewer;

          if (state.ui.scaffold.isViewingPrevious) {
            if (state.ui.imageViewer.cardFace === CardFace.Front) {
              var _imageViewer$previous = imageViewer.previousVersionFrontDimensions,
                  _width2 = _imageViewer$previous.width,
                  _height2 = _imageViewer$previous.height;
              return _height2 > _width2;
            }

            var _imageViewer$previous2 = imageViewer.previousVersionBackDimensions,
                _width = _imageViewer$previous2.width,
                _height = _imageViewer$previous2.height;
            return _height > _width;
          }

          if (state.ui.imageViewer.cardFace === CardFace.Front) {
            var _imageViewer$currentV = imageViewer.currentVersionFrontDimensions,
                _width3 = _imageViewer$currentV.width,
                _height3 = _imageViewer$currentV.height;
            return _height3 > _width3;
          }

          var _imageViewer$currentV2 = imageViewer.currentVersionBackDimensions,
              width = _imageViewer$currentV2.width,
              height = _imageViewer$currentV2.height;
          return height > width;
        }(),
        imageDimensions: function () {
          var imageViewer = effectState.imageViewer;

          if (state.ui.scaffold.isViewingPrevious) {
            if (state.ui.imageViewer.cardFace === CardFace.Front) {
              var _imageViewer$previous3 = imageViewer.previousVersionFrontDimensions,
                  _width5 = _imageViewer$previous3.width,
                  _height5 = _imageViewer$previous3.height;
              return [_width5, _height5];
            }

            var _imageViewer$previous4 = imageViewer.previousVersionBackDimensions,
                _width4 = _imageViewer$previous4.width,
                _height4 = _imageViewer$previous4.height;
            return [_width4, _height4];
          }

          if (state.ui.imageViewer.cardFace === CardFace.Front) {
            var _imageViewer$currentV3 = imageViewer.currentVersionFrontDimensions,
                _width6 = _imageViewer$currentV3.width,
                _height6 = _imageViewer$currentV3.height;
            return [_width6, _height6];
          }

          var _imageViewer$currentV4 = imageViewer.currentVersionBackDimensions,
              width = _imageViewer$currentV4.width,
              height = _imageViewer$currentV4.height;
          return [width, height];
        }(),
        hasLoaded: function () {
          var imageViewer = effectState.imageViewer;

          if (state.ui.scaffold.isViewingPrevious) {
            if (state.ui.imageViewer.cardFace === CardFace.Front) {
              return imageViewer.previousVersionFrontHasLoaded;
            }

            return imageViewer.previousVersionBackHasLoaded;
          }

          if (state.ui.imageViewer.cardFace === CardFace.Front) {
            return imageViewer.currentVersionFrontHasLoaded;
          }

          return imageViewer.currentVersionBackHasLoaded;
        }()
      }),
      sidebar: {
        hasSidebar: state.comments.length > 0 || state.ui.scaffold.markerPrompt !== null || state.ui.sidebar.addingUnpinnedComment,
        isNewMarkerPromptOpen: state.ui.scaffold.markerPrompt !== null || state.ui.sidebar.addingUnpinnedComment,
        isEditingComment: state.ui.sidebar.isEditingComment && Boolean(state.ui.scaffold.activeComment.current)
      }
    }
  };
  var actions = useMemo(function () {
    var commonActions = generateCommonActions(setState, {
      props: combinedStateProps,
      handlers: handlers,
      refs: refs
    });
    var commentsActions = generateCommentsActions(setState, {
      props: combinedStateProps,
      handlers: handlers,
      refs: refs
    });
    var uiActions = generateUiActions(setState, {
      props: combinedStateProps,
      handlers: handlers,
      refs: refs
    });
    return _objectSpread({}, commonActions, commentsActions, uiActions);
  }, [setState, combinedStateProps, handlers, refs]);
  var imageViewerProps = useImageViewer$1({
    state: state,
    derivedState: derivedState,
    actions: actions,
    refs: refs
  });
  var designReviewState = useDesignReview({
    designDetails: props.designDetails,
    state: state,
    derivedState: derivedState,
    actions: actions,
    imageViewerProps: imageViewerProps,
    refs: refs
  });

  var setCardFace = function setCardFace(c, args) {
    if (c === state.ui.imageViewer.cardFace) {
      return;
    }

    actions.setCardFace(c);

    if (args === null || args === void 0 ? void 0 : args.skipCallback) {
      return;
    }

    setState(function (state) {
      return produce(state, function (draft) {
        if (!draft.ui.scaffold.hasViewedBack) {
          draft.ui.scaffold.hasViewedBack = true;
        }

        draft.ui.scaffold.markerPrompt = null;
        draft.ui.sidebar.expandedMarkerIndex = null;
      });
    });
    var nextActiveComment = designReviewState.findNextComment({
      allowCurrent: false,
      preferredCardFace: c
    });

    if (state.workflow !== Workflow.Request) {
      actions.setActiveComment(nextActiveComment);
    }
  };

  var derivedActions = {
    handlers: handlers,
    setCardFace: setCardFace
  };
  var campaignMediaReviewState = {
    prePressForm: usePrePressReview({
      handlers: handlers,
      openModal: actions.openModal,
      closeModal: actions.closeModal
    })
  };
  return {
    state: state,
    derivedState: derivedState,
    actions: actions,
    derivedActions: derivedActions,
    refs: refs,
    campaignMediaReviewState: campaignMediaReviewState,
    designReviewState: _objectSpread({}, props, designReviewState)
  };
};

var DesignReviewProviderBase = function DesignReviewProviderBase(props, ref) {
  var _a;

  var _useCombinedState = useCombinedState(props),
      designReviewState = _useCombinedState.designReviewState,
      state = _useCombinedState.state,
      derivedState = _useCombinedState.derivedState,
      actions = _useCombinedState.actions,
      derivedActions = _useCombinedState.derivedActions,
      refs = _useCombinedState.refs,
      campaignMediaReviewState = _useCombinedState.campaignMediaReviewState;

  useImperativeHandle(ref, function () {
    return {
      comments: state.comments,
      workflow: state.workflow
    };
  });
  return React.createElement(RefsContext.Provider, {
    value: refs
  }, React.createElement(ActionsContext.Provider, {
    value: actions
  }, React.createElement(SaaSApiBaseContext.Provider, {
    value: (_a = props.api) !== null && _a !== void 0 ? _a : {}
  }, React.createElement(DesignContext.Base.Provider, {
    value: {
      experience: state.experience,
      viewedAs: state.viewedAs,
      workflow: state.workflow,
      previousWorkflow: props.workflow,
      designQueueDetails: props.designQueueDetails
    }
  }, React.createElement(CommentsStore.Comments.Provider, {
    value: state.comments
  }, React.createElement(CommentsStore.DerivedComments.Provider, {
    value: derivedState.comments
  }, React.createElement(UpdateQueueContext.Provider, {
    value: state.updateQueue
  }, React.createElement(UIStateContext.Scaffold.Provider, {
    value: state.ui.scaffold
  }, React.createElement(UIStateContext.ImageViewer.Provider, {
    value: state.ui.imageViewer
  }, React.createElement(UIStateContext.Sidebar.Provider, {
    value: state.ui.sidebar
  }, React.createElement(CampaignContext.Derived.Provider, {
    value: derivedState.campaign
  }, React.createElement(DesignContext.Derived.Provider, {
    value: derivedState.design
  }, React.createElement(UIStateContext.Derived.Scaffold.Provider, {
    value: derivedState.ui.scaffold
  }, React.createElement(UIStateContext.Derived.ImageViewer.Provider, {
    value: derivedState.ui.imageViewer
  }, React.createElement(UIStateContext.Derived.Sidebar.Provider, {
    value: derivedState.ui.sidebar
  }, React.createElement(DesignReviewContext.Provider, {
    value: designReviewState
  }, React.createElement(DerivedActionsContext.Provider, {
    value: derivedActions
  }, React.createElement(CampaignContext.CampaignMediaReview.Provider, {
    value: campaignMediaReviewState
  }, props.children))))))))))))))))));
};

var DesignReviewProvider = forwardRef(DesignReviewProviderBase);
var useStyles$7 = makeStyles$1(function (theme) {
  return createStyles({
    item: {
      padding: '8px 16px',
      margin: 0
    },
    listWrapper: {
      display: 'flex',
      flexDirection: 'column',
      padding: '8px 0px'
    },
    button: {
      cursor: 'pointer',
      color: 'rgb(237, 21, 78)',
      display: 'flex',
      alignItems: 'center',
      fontWeight: 'bold',
      fontSize: 14,
      background: 'rgb(249,249,249)',
      padding: '6px 8px 6px 16px',
      borderRadius: '3px',
      marginRight: 4,
      fontFamily: 'Roboto Condensed',
      '& svg': {
        marginLeft: 8,
        color: 'rgb(146, 146, 146)'
      }
    },
    checkbox: {
      padding: 0,
      marginRight: 8,
      color: 'rgb(211, 211, 211)'
    },
    itemLabel: {
      fontSize: 15
    }
  });
});

var Select = function Select(props) {
  var list = props.list,
      onChange = props.onChange,
      name = props.name,
      selectedItems = props.selectedItems;
  var classes = useStyles$7();

  var _useState135 = useState(null),
      _useState136 = _slicedToArray(_useState135, 2),
      anchorEl = _useState136[0],
      setAnchorEl = _useState136[1];

  var _useState137 = useState([]),
      _useState138 = _slicedToArray(_useState137, 2),
      selected = _useState138[0],
      setSelected = _useState138[1];

  useEffect(function () {
    setSelected(selectedItems);
  }, [selectedItems]);

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
    onChange(selected);
  };

  var handleChange = function handleChange(event) {
    if (event.target.checked) {
      setSelected([].concat(_toConsumableArray(selected), [event.target.name]));
    } else {
      setSelected(selected && selected.filter(function (item) {
        return item !== event.target.name;
      }));
    }
  };

  var open = Boolean(anchorEl);
  var id = open ? 'dropdown' : undefined;
  return React.createElement(Fragment, null, React.createElement("div", {
    className: classes.button,
    onClick: handleClick
  }, name ? selected.length === 1 ? selected[0] : name : list[0], ' ', selected.length > 1 ? "(".concat(list.length > selected.length ? selected.length : 'All', ")") : '', open ? React.createElement(ArrowDropUp, null) : React.createElement(ArrowDropDown, null)), React.createElement(Popover, {
    id: id,
    open: open,
    anchorEl: anchorEl,
    onClose: handleClose,
    classes: {
      paper: classes.listWrapper
    },
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  }, list.map(function (item, index) {
    return React.createElement(FormControlLabel, {
      key: "item-".concat(index),
      classes: {
        root: classes.item,
        label: classes.itemLabel
      },
      control: React.createElement(Checkbox, {
        checked: selected && selected.includes(item),
        className: classes.checkbox,
        name: item,
        onChange: handleChange
      }),
      label: item
    });
  })));
};

var useStyles$8 = makeStyles$1(function (theme) {
  return createStyles({
    filtersWrapper: {
      display: 'flex'
    },
    searchField: {
      background: 'rgb(249, 249, 249)',
      '& input': {
        padding: 9,
        fontSize: 15
      },
      '& svg': {
        color: 'rgb(144,144,144)',
        marginRight: -8,
        marginLeft: 2,
        fontSize: 24
      }
    },
    notchedOutline: {
      borderColor: 'rgba(0, 0, 0, 0.23) !important',
      borderWidth: '1px !important'
    }
  });
});

var Filters = function Filters(props) {
  var classes = useStyles$8();
  var filterItems = props.filterItems,
      onChangeSearch = props.onChangeSearch,
      onChangeFilters = props.onChangeFilters;

  var _useState139 = useState(filterItems),
      _useState140 = _slicedToArray(_useState139, 2),
      selectedFilters = _useState140[0],
      setSelectedFilters = _useState140[1];

  useEffect(function () {
    onChangeFilters(selectedFilters);
  }, [selectedFilters, onChangeFilters]);

  var handleSearch = function handleSearch(e) {
    onChangeSearch(e.target.value);
  };

  var handleChangeFilters = function handleChangeFilters(e, selected) {
    var _selectedFilters = {
      name: '',
      selected: [],
      items: []
    };

    var _filterItems = selectedFilters.filter(function (_item) {
      return _item.name !== selected.name;
    });

    filterItems.map(function (item) {
      if (selected.name === item.name) {
        _selectedFilters = {
          name: item.name,
          selected: item.selected.length ? e : union(item.selected, e),
          items: item.items
        };
      }

      return false;
    });

    _filterItems.push(_selectedFilters);

    setSelectedFilters(_filterItems);
  };

  return React.createElement(Fragment, null, React.createElement("div", {
    className: classes.filtersWrapper
  }, filterItems.map(function (filter, index) {
    var name = filter.name,
        selected = filter.selected,
        items = filter.items;
    return React.createElement(Select, {
      key: "item-".concat(index),
      selectedItems: selected,
      name: name,
      list: items,
      onChange: function onChange(e) {
        return handleChangeFilters(e, filter);
      }
    });
  }), React.createElement(TextField, {
    id: "search",
    placeholder: "Search account",
    variant: "outlined",
    classes: {
      root: classes.searchField
    },
    onChange: handleSearch,
    InputProps: {
      startAdornment: React.createElement(InputAdornment, {
        position: "start"
      }, React.createElement(Search, null)),
      classes: {
        notchedOutline: classes.notchedOutline
      }
    }
  })));
};

var useStyles$9 = makeStyles$1(function (theme) {
  return createStyles({
    dots: {
      color: 'rgb(211, 211, 211)',
      height: 16,
      width: 16,
      cursor: 'pointer',
      marginTop: 5
    },
    tip: {
      background: 'rgb(20, 20, 20)',
      padding: '20px 32px'
    },
    tipArrow: {
      '&:before': {
        borderTopColor: 'rgb(20, 20, 20) !important'
      }
    },
    insideTip: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    tipContent: {
      '& h3': {
        margin: 0,
        fontSize: 22,
        marginBottom: 8
      },
      '& p': {
        margin: 0,
        fontSize: 15,
        color: 'rgb(139, 139, 139)',
        lineHeight: 1.3
      }
    },
    iconWrapper: {
      marginRight: '12px',
      padding: '4px',
      background: 'red',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginLeft: '-12px',
      '& svg': {
        height: 28,
        width: 28
      }
    },
    red: {
      color: 'rgb(255, 0, 63)'
    },
    green: {
      color: 'rgb(0, 157, 0)'
    },
    hide: {
      display: 'none !important',
      opacity: '0 !important'
    }
  });
});

var Progress = function Progress(props) {
  var classes = useStyles$9();
  var data = props.data;
  return React.createElement(Fragment, null, data.map(function (row, index) {
    var name = row.name,
        assigned = row.assigned,
        status = row.status,
        completedDate = row.completedDate;
    return React.createElement(Tooltip$1, {
      key: "tip-".concat(index),
      arrow: true,
      classes: {
        tooltip: cx(classes.tip),
        arrow: classes.tipArrow
      },
      placement: "top",
      title: React.createElement(Fragment, null, React.createElement("div", {
        key: "item-".concat(index),
        className: classes.insideTip
      }, React.createElement("div", {
        className: classes.iconWrapper
      }, isEmpty(completedDate) ? React.createElement(Update, null) : React.createElement(Check, null)), React.createElement("div", {
        className: classes.tipContent
      }, React.createElement("h3", null, name), isEmpty(assigned) && React.createElement("p", null, "Not Assigned"), !isEmpty(assigned) && React.createElement("p", null, assigned && "".concat(assigned.name, " (").concat(assigned.role, ")")), isEmpty(completedDate) && React.createElement("p", null, "".concat(status), "..."), !isEmpty(completedDate) && React.createElement("p", null, React.createElement("strong", {
        className: classes.green
      }, status), ' ', moment(completedDate).format('M/D/YYYY')))))
    }, React.createElement(FiberManualRecord, {
      key: "item-circle-".concat(index),
      className: cx(classes.dots, completedDate && classes.red)
    }));
  }));
};

var useStyles$a = makeStyles(function (theme) {
  return createStyles$1({
    menuList: {
      fontSize: 14,
      '& svg': {
        marginRight: -12,
        color: '#929292'
      }
    },
    searchField: {
      background: 'rgb(249, 249, 249)',
      '& input': {
        padding: 9,
        fontSize: 15
      }
    },
    notchedOutline: {
      borderColor: 'rgba(0, 0, 0, 0.23) !important',
      borderWidth: '1px !important'
    },
    searchContainer: {
      padding: '8px 16px'
    },
    modalHeader: {
      marginTop: '-28px',
      marginLeft: '-28px',
      marginRight: '-28px',
      padding: '16px 28px',
      background: 'rgb(249,249,249)',
      borderRadius: '5px',
      color: 'rgb(144,144,144)',
      fontSize: '18px',
      marginBottom: '28px'
    },
    btnWrapper: {
      textAlign: 'right',
      marginTop: 24
    },
    btnRed: {
      color: '#fff',
      background: 'rgb(255, 0, 63)',
      marginLeft: 8,
      '&:hover': {
        color: '#fff',
        background: 'rgb(255, 0, 63)'
      }
    }
  });
});

var ItemActions = function ItemActions(props) {
  var classes = useStyles$a();
  var index = props.index,
      actionContactSearch = props.actionContactSearch,
      onChangeContactSearch = props.onChangeContactSearch,
      actions = props.actions,
      onActionsClick = props.onActionsClick;

  var _useState141 = useState([]),
      _useState142 = _slicedToArray(_useState141, 2),
      menuEl = _useState142[0],
      setMenuEl = _useState142[1];

  var _useState143 = useState(false),
      _useState144 = _slicedToArray(_useState143, 2),
      openModal = _useState144[0],
      setOpenModal = _useState144[1];

  var _useState145 = useState(),
      _useState146 = _slicedToArray(_useState145, 2),
      selected = _useState146[0],
      setSelected = _useState146[1];

  var handleAssign = function handleAssign(event) {
    setOpenModal(!openModal);
    setMenuEl([]);
  };

  var handleMenuClick = function handleMenuClick(id, event) {
    var selectedMenu = _toConsumableArray(menuEl);

    selectedMenu[id] = event.currentTarget;
    setMenuEl(selectedMenu);
  };

  var handleClose = function handleClose() {
    setMenuEl([]);
  };

  var handleClickItem = function handleClickItem(action) {
    onActionsClick && onActionsClick(action);
    setMenuEl([]);
  };

  return React.createElement(Fragment, null, React.createElement(IconButton, {
    size: "small",
    onClick: function onClick(e) {
      return handleMenuClick(index, e);
    }
  }, React.createElement(MoreVert, null)), React.createElement(Menu, {
    id: "menu-".concat(index),
    anchorEl: menuEl[index],
    keepMounted: true,
    open: Boolean(menuEl[index]),
    onClose: handleClose
  }, !isEmpty$1(actionContactSearch) && React.createElement(MenuItem, {
    className: classes.menuList,
    onClick: handleAssign
  }, "Assign"), actions && actions.map(function (list, index) {
    return React.createElement(MenuItem, {
      key: "item-".concat(index),
      className: classes.menuList,
      onClick: function onClick() {
        return handleClickItem(list);
      }
    }, list.name);
  })), !isEmpty$1(actionContactSearch) && React.createElement(Modal, {
    width: 400,
    bgColor: "transparent",
    open: openModal,
    onBackdropClick: function onBackdropClick() {
      return setOpenModal(false);
    }
  }, React.createElement("h3", {
    className: classes.modalHeader
  }, "Assign"), React.createElement(Autocomplete, {
    id: "search-contact",
    options: actionContactSearch && actionContactSearch || [],
    getOptionLabel: function getOptionLabel(option) {
      return option.name;
    },
    onChange: function onChange(event, selected) {
      setSelected(selected);
    },
    renderInput: function renderInput(params) {
      return React.createElement(TextField, Object.assign({}, params, {
        placeholder: "Name",
        variant: "outlined",
        classes: _objectSpread({}, params.classes, {
          root: classes.searchField
        }),
        InputProps: _objectSpread({}, params.InputProps, {
          classes: {
            notchedOutline: classes.notchedOutline
          }
        })
      }));
    }
  }), React.createElement("div", {
    className: classes.btnWrapper
  }, React.createElement(Button$1, {
    color: "primary",
    onClick: function onClick() {
      return setOpenModal(false);
    }
  }, "Cancel"), React.createElement(Button$1, {
    color: "primary",
    onClick: function onClick() {
      onChangeContactSearch && onChangeContactSearch(selected);
      setOpenModal(false);
    },
    className: classes.btnRed
  }, "Apply"))));
};

var TaskIcon = function TaskIcon(props) {
  var taskIcon = function taskIcon(task) {
    switch (task) {
      case TaskType.DesignConcept:
        {
          return React.createElement(ColorLens, null);
        }

      case TaskType.NumberSwap:
        {
          return React.createElement(SwapHorizontalCircle, null);
        }

      case TaskType.DesignRevision:
        {
          return React.createElement(RateReview, null);
        }
    }
  };

  return React.createElement(Fragment, null, taskIcon(props.taskType));
};

var useStyles$b = makeStyles$1(function (theme) {
  return createStyles({
    infinite: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: '60px',
      fontFamily: 'Roboto Condensed',
      color: '#9e9e9e',
      fontSize: '18px',
      fontWeight: 'bold',
      '& strong': {
        color: '#ed393c'
      },
      '& em': {
        fontStyle: 'normal',
        color: '#6f6666'
      }
    }
  });
});

var InfiniteLoader = function InfiniteLoader(props) {
  var classes = useStyles$b();
  var showInfinite = props.showInfinite,
      isEndOfPage = props.isEndOfPage,
      isLoading = props.isLoading,
      data = props.data;

  if (showInfinite || isLoading) {
    return React.createElement("div", {
      className: classes.infinite
    }, "Found", React.createElement("strong", null, "\xA0", data.records.length, "\xA0"), "out of", React.createElement("strong", null, "\xA0", data.meta.totalCount, "\xA0"), "designs so far. Scroll", React.createElement("em", null, "\xA0down\xA0"), "to see more", isLoading && React.createElement(CircularProgress, {
      size: 24,
      style: {
        marginLeft: 12
      }
    }));
  }

  if (isEndOfPage && !isLoading) {
    return React.createElement("div", {
      className: classes.infinite
    }, "Done! Found", React.createElement("strong", null, "\xA0", data.meta.totalCount, "\xA0"), "tasks in total.");
  }

  return React.createElement(Fragment, null);
};

var useStyles$c = makeStyles$1(function (theme) {
  return createStyles({
    tableContainer: {
      background: 'transparent',
      boxShadow: 'none',
      overflow: 'visible',
      '& tbody': {
        background: '#fff',
        boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)'
      }
    },
    thead: {
      background: 'none',
      '& th': {
        borderBottom: 'none',
        color: 'rgb(146,146,146)'
      }
    },
    taskName: {
      '& p': {
        fontWeight: 'bold',
        margin: 0,
        fontSize: 16
      },
      '& label': {
        fontSize: 12,
        color: 'rgb(136, 136, 136)'
      }
    },
    red: {
      color: 'rgb(255, 0, 63)'
    },
    btnRed: {
      color: 'rgb(255, 0, 63)',
      borderColor: 'rgb(255, 0, 63)',
      fontSize: 14,
      padding: '6px 14px',
      width: 140
    },
    btnRedContained: {
      background: 'rgb(255, 0, 63) !important',
      color: '#fff !important'
    },
    green: {
      color: 'rgb(0, 157, 157)'
    },
    textWithIcon: {
      display: 'flex',
      alignItems: 'center',
      '& svg': {
        height: 16,
        width: 16,
        marginRight: 8
      }
    },
    avatar: {
      height: 30,
      width: 30
    },
    infinite: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: '60px',
      fontFamily: 'Roboto Condensed',
      color: '#9e9e9e',
      fontSize: '18px',
      fontWeight: 'bold',
      '& strong': {
        color: '#ed393c'
      },
      '& em': {
        fontStyle: 'normal',
        color: '#6f6666'
      }
    },
    tableLoading: {
      filter: 'blur(2px)',
      position: 'relative',
      '&:before': {
        content: '""',
        height: '100%',
        width: '100%',
        position: 'absolute',
        background: 'rgba(255, 255, 255, 0.5)'
      }
    }
  });
});

var Table = function Table(props) {
  var classes = useStyles$c();
  var data = props.data,
      open = props.open,
      infiniteScroll = props.infiniteScroll,
      onActionClick = props.onActionClick,
      _onChangeContactSearch = props.onChangeContactSearch,
      actionContactSearch = props.actionContactSearch,
      _onActionsClick = props.onActionsClick,
      isLoading = props.isLoading,
      isInitialLoading = props.isInitialLoading;

  var _useState147 = useState(true),
      _useState148 = _slicedToArray(_useState147, 2),
      showInfinite = _useState148[0],
      setShowInfinite = _useState148[1];

  var _useState149 = useState(false),
      _useState150 = _slicedToArray(_useState149, 2),
      isEndOfPage = _useState150[0],
      setIsEndOfPage = _useState150[1];

  var handleAction = function handleAction(id, action) {
    onActionClick({
      action: action,
      id: id
    });
  };

  var handleWaypointEnter = function handleWaypointEnter() {
    if (data.meta.totalCount === data.records.length) {
      setShowInfinite(false);
      setIsEndOfPage(true);
    }
  };

  var getAvatar = function getAvatar(name) {
    return decodeURI("https://ui-avatars.com/api/?name=".concat(encodeURIComponent(name).replace(/%20/g, '+'), "&rounded=true&length=1"));
  };

  var getTask = function getTask(task) {
    switch (task) {
      case TaskType.DesignConcept:
        return 'START CONCEPT';

      case TaskType.DesignRevision:
        return 'START REVISION';

      case TaskType.NumberSwap:
        return 'NUMBER SWAP';

      default:
        return 'PEER REVIEW';
    }
  };

  return React.createElement(Fragment, null, React.createElement(Collapse, {
    in: open
  }, isInitialLoading ? React.createElement(Fragment, null, React.createElement(Skeleton, {
    animation: "wave",
    variant: "rect",
    height: 40,
    style: {
      marginBottom: 15,
      marginTop: 10
    }
  }), React.createElement(Skeleton, {
    animation: "wave",
    variant: "rect",
    height: 300
  })) : React.createElement(TableContainer, {
    className: cx(classes.tableContainer, isLoading && classes.tableLoading),
    component: Paper
  }, React.createElement(Table$1, null, React.createElement(TableHead, {
    className: classes.thead
  }, React.createElement(TableRow, null, React.createElement(TableCell, null, "Task Name"), React.createElement(TableCell, null, "Task Type"), React.createElement(TableCell, null, "Requested"), React.createElement(TableCell, null, "Due"), React.createElement(TableCell, null, "Progress"), React.createElement(TableCell, null, "Action"), React.createElement(TableCell, {
    align: "center"
  }, "Assigned"), React.createElement(TableCell, null))), React.createElement(TableBody, null, data.records.map(function (row, index) {
    var taskType = row.taskType,
        name = row.name,
        requestedDate = row.requestedDate,
        dueDate = row.dueDate,
        progress = row.progress,
        assigned = row.assigned,
        actions = row.actions,
        inReview = row.inReview;
    var avatar = getAvatar(assigned.name);
    var daysLeft = moment(dueDate).diff(moment(), 'days');
    var hoursLeft = moment(dueDate).diff(moment(), 'hours');
    var minsLeft = moment(dueDate).diff(moment(), 'minutes');
    var timeLeft = "".concat(daysLeft, " ").concat(daysLeft > 1 ? 'days' : 'day');

    if (daysLeft === 0) {
      timeLeft = "".concat(hoursLeft, " ").concat(hoursLeft > 1 ? 'hours' : 'hour');
    }

    if (hoursLeft === 0) {
      timeLeft = "".concat(minsLeft, " ").concat(minsLeft > 1 ? 'minutes' : 'minute');
    }

    return React.createElement(TableRow, {
      key: "row-".concat(index)
    }, React.createElement(TableCell, null, React.createElement("div", {
      className: classes.taskName
    }, React.createElement("p", null, name.primary), React.createElement("label", null, name.sub))), React.createElement(TableCell, null, React.createElement("label", {
      className: classes.textWithIcon
    }, React.createElement(TaskIcon, {
      taskType: taskType
    }), " ", taskType)), React.createElement(TableCell, null, moment(requestedDate).format('M/D/YYYY')), React.createElement(TableCell, null, React.createElement("label", {
      className: cx(classes.textWithIcon, daysLeft < 2 && classes.red)
    }, React.createElement(Timer, null), " ", timeLeft)), React.createElement(TableCell, null, React.createElement(Progress, {
      data: progress
    })), React.createElement(TableCell, null, React.createElement(Button$1, {
      className: cx(classes.btnRed, inReview && classes.btnRedContained),
      onClick: function onClick() {
        return handleAction(row.id, inReview ? ActionType.peerReview : ActionType.startTask);
      },
      variant: "outlined"
    }, getTask(inReview ? ActionType.peerReview : row.taskType))), React.createElement(TableCell, {
      align: "center",
      style: {
        verticalAlign: 'bottom'
      }
    }, React.createElement("img", {
      className: classes.avatar,
      src: avatar,
      alt: "avatar"
    })), React.createElement(TableCell, {
      align: "right"
    }, React.createElement(ItemActions, {
      actions: actions,
      actionContactSearch: actionContactSearch,
      onChangeContactSearch: function onChangeContactSearch(contact) {
        _onChangeContactSearch && _onChangeContactSearch(contact);
      },
      onActionsClick: function onActionsClick(action) {
        _onActionsClick && _onActionsClick(action);
      },
      index: index
    })));
  })))), infiniteScroll && !isInitialLoading && React.createElement(InfiniteLoader, {
    isLoading: isLoading,
    showInfinite: showInfinite,
    isEndOfPage: isEndOfPage,
    data: data
  }), React.createElement(Waypoint, {
    onEnter: handleWaypointEnter,
    bottomOffset: 10
  })));
};

var useStyles$d = makeStyles$1(function (theme) {
  return createStyles({
    tableWrapper: {
      marginTop: 16,
      padding: 32,
      '& h4': {
        marginTop: '0px',
        color: 'rgb(146,146,146)',
        fontSize: '14px',
        textTransform: 'uppercase'
      }
    },
    toggle: {
      borderRadius: '5px',
      border: 'solid 1px #eee',
      padding: '1px'
    },
    header: {
      display: 'flex',
      alignItems: 'end',
      justifyContent: 'space-between',
      '& h4': {
        fontFamily: 'Roboto Condensed'
      }
    }
  });
});

var TaskQueue = function TaskQueue(props) {
  var onActionClick = props.onActionClick,
      _onActionsClick2 = props.onActionsClick,
      filters = props.filters,
      actionContactSearch = props.actionContactSearch,
      _onChangeContactSearch2 = props.onChangeContactSearch;
  var myTasks = props.table.myTasks;
  var otherTasks = props.table.otherTasks;
  var _onChangeSearch = otherTasks.onChangeSearch,
      _onChangeFilters = otherTasks.onChangeFilters;
  var classes = useStyles$d();

  var _useState151 = useState(true),
      _useState152 = _slicedToArray(_useState151, 2),
      openMyTasks = _useState152[0],
      setOpenMyTasks = _useState152[1];

  var _useState153 = useState(true),
      _useState154 = _slicedToArray(_useState153, 2),
      openOtherTasks = _useState154[0],
      setOpenOtherTasks = _useState154[1];

  var handleAction = function handleAction(data) {
    return onActionClick(data);
  };

  return React.createElement(Fragment, null, React.createElement(Header, {
    title: "Task Queue",
    buttons: React.createElement(Fragment, null, React.createElement(Filters, {
      filterItems: filters,
      onChangeSearch: function onChangeSearch(search) {
        return _onChangeSearch(search);
      },
      onChangeFilters: function onChangeFilters(filters) {
        return _onChangeFilters(filters);
      }
    }))
  }), React.createElement("div", {
    className: classes.tableWrapper
  }, React.createElement("div", {
    className: classes.header
  }, React.createElement("h4", null, "My Tasks (", myTasks.data.records.length, ")"), React.createElement(IconButton, {
    className: classes.toggle,
    onClick: function onClick() {
      return setOpenMyTasks(!openMyTasks);
    }
  }, openMyTasks ? React.createElement(KeyboardArrowUp, null) : React.createElement(KeyboardArrowDown, null))), React.createElement(Table, {
    isInitialLoading: myTasks.isInitialLoading,
    data: myTasks.data,
    open: openMyTasks,
    onActionClick: handleAction,
    onActionsClick: function onActionsClick(action) {
      _onActionsClick2(action);
    },
    actionContactSearch: actionContactSearch,
    onChangeContactSearch: function onChangeContactSearch(contact) {
      _onChangeContactSearch2(contact);
    },
    infiniteScroll: false,
    isLoading: myTasks.loading
  })), React.createElement("div", {
    className: classes.tableWrapper
  }, React.createElement("div", {
    className: classes.header
  }, React.createElement("h4", null, "Other Tasks (", otherTasks.data.records.length, ")"), React.createElement(IconButton, {
    className: classes.toggle,
    onClick: function onClick() {
      return setOpenOtherTasks(!openOtherTasks);
    }
  }, openOtherTasks ? React.createElement(KeyboardArrowUp, null) : React.createElement(KeyboardArrowDown, null))), React.createElement(Table, {
    data: otherTasks.data,
    open: openOtherTasks,
    onActionClick: handleAction,
    onActionsClick: function onActionsClick(action) {
      _onActionsClick2(action);
    },
    actionContactSearch: actionContactSearch,
    onChangeContactSearch: function onChangeContactSearch(contact) {
      _onChangeContactSearch2(contact);
    },
    infiniteScroll: true,
    isLoading: otherTasks.loading,
    isInitialLoading: otherTasks.isInitialLoading
  })));
};

var ActionsOverlayContainer = function ActionsOverlayContainer(_ref167) {
  var openVideoWalkthroughModal = _ref167.openVideoWalkthroughModal,
      openDesignerChecklist = _ref167.openDesignerChecklist,
      openHelpModal = _ref167.openHelpModal,
      toggleComments = _ref167.toggleComments,
      menuButtonStyles = _ref167.menuButtonStyles,
      children = _ref167.children;
  useEffect(function () {
    // @ts-ignore
    if (typeof ConvertApi === 'undefined') {
      var script = document.createElement('script');
      script.src = 'https://unpkg.com/convertapi-js@1.0.6/lib/convertapi.js';
      document.getElementsByTagName('head')[0].appendChild(script);
    }
  }, []);
  var classes = useActionsOverlayContainerStyles();

  var _useContext214 = useContext(DesignContext.Base),
      viewedAs = _useContext214.viewedAs,
      experience = _useContext214.experience;

  var _useContext215 = useContext(DesignContext.Derived),
      file = _useContext215.file;

  var _useContext216 = useContext(SaaSApiBaseContext),
      convertapi = _useContext216.convertapi;

  var _useContext217 = useContext(UIStateContext.Sidebar),
      groupComments = _useContext217.groupComments;

  var comments = useContext(CommentsStore.Comments);

  var _useContext218 = useContext(UIStateContext.Derived.Scaffold),
      frontPostcardUrl = _useContext218.frontPostcardUrl,
      backPostcardUrl = _useContext218.backPostcardUrl;

  var _useState155 = useState(null),
      _useState156 = _slicedToArray(_useState155, 2),
      menuAnchorEl = _useState156[0],
      setMenuAnchorEl = _useState156[1];

  var _useState157 = useState(false),
      _useState158 = _slicedToArray(_useState157, 2),
      downloading = _useState158[0],
      setDownloading = _useState158[1];

  var handleMenuClick = function handleMenuClick(e) {
    setMenuAnchorEl(e.currentTarget);
  };

  var handleMenuClose = function handleMenuClose() {
    setMenuAnchorEl(null);
  };

  var frontComments = comments.filter(function (c) {
    return c.cardFace === 'Front';
  });
  var backComments = comments.filter(function (c) {
    return c.cardFace === 'Back';
  });
  return React.createElement("div", {
    className: classes.actionsOverlayContainer
  }, children, React.createElement(IconButton, {
    onClick: handleMenuClick,
    style: _objectSpread({
      color: '#d3d3d3'
    }, menuButtonStyles)
  }, React.createElement(MoreVert, null)), React.createElement(Menu, {
    anchorEl: menuAnchorEl,
    keepMounted: true,
    open: Boolean(menuAnchorEl),
    onClose: handleMenuClose
  }, !!frontComments.length && !!backComments.length && React.createElement(MenuItem, {
    onClick: function onClick() {
      toggleComments && toggleComments();
      handleMenuClose();
    }
  }, React.createElement(Dns, {
    style: {
      color: '#929292',
      marginRight: '0.5em'
    }
  }), groupComments ? 'Ungroup' : 'Group', " Comments"), React.createElement(MenuItem, {
    disabled: downloading,
    onClick: function () {
      var _onClick12 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee42() {
        var _a;

        return _regeneratorRuntime.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                setDownloading(true);
                _context42.prev = 1;
                _context42.next = 4;
                return downloadAsPDF({
                  images: [frontPostcardUrl, backPostcardUrl],
                  name: file.name,
                  secret: (_a = convertapi === null || convertapi === void 0 ? void 0 : convertapi.secret) !== null && _a !== void 0 ? _a : ''
                });

              case 4:
                _context42.next = 9;
                break;

              case 6:
                _context42.prev = 6;
                _context42.t0 = _context42["catch"](1);
                console.error(_context42.t0);

              case 9:
                setDownloading(false);
                handleMenuClose();

              case 11:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42, null, [[1, 6]]);
      }));

      function onClick() {
        return _onClick12.apply(this, arguments);
      }

      return onClick;
    }()
  }, downloading ? React.createElement(CircularProgress, {
    style: {
      color: '#929292',
      marginRight: '0.8em',
      height: 24,
      width: 24
    }
  }) : React.createElement(CloudDownload, {
    style: {
      color: '#929292',
      marginRight: '0.5em'
    }
  }), "Download"), React.createElement(MenuItem, {
    onClick: function onClick() {
      openHelpModal();
      handleMenuClose();
    }
  }, React.createElement(LiveHelp, {
    style: {
      color: '#929292',
      marginRight: '0.5em'
    }
  }), "I need help"), // tools app only
  viewedAs === DesignReviewViewedAs.Default && // campaign review/number swap only
  experience === DesignReviewExperience.CampaignReview && React.createElement(MenuItem, {
    onClick: function onClick() {
      openDesignerChecklist && openDesignerChecklist();
      handleMenuClose();
    }
  }, React.createElement(Create, {
    style: {
      color: '#929292',
      marginRight: '0.5em'
    }
  }), "Design Checklist")));
};

var ThumbnailPlaceholder = function ThumbnailPlaceholder(_ref168) {
  var onClick = _ref168.onClick;
  return React.createElement("div", {
    onClick: onClick,
    style: {
      width: '100%',
      height: '100%',
      color: '#727272',
      backgroundColor: '#d3d3d3',
      display: 'grid',
      placeItems: 'center'
    }
  }, React.createElement(Terrain, {
    style: {
      width: '70%',
      height: '70%'
    }
  }));
};

var Thumbnail = function Thumbnail(_ref169) {
  var imgSrc = _ref169.imgSrc,
      imgAlt = _ref169.imgAlt,
      imgRef = _ref169.imgRef,
      style = _ref169.style,
      onClick = _ref169.onClick,
      _ref169$onThumbnailLo = _ref169.onThumbnailLoad,
      onThumbnailLoad = _ref169$onThumbnailLo === void 0 ? function () {} : _ref169$onThumbnailLo,
      children = _ref169.children;
  return React.createElement("div", {
    onClick: onClick,
    style: {
      height: '100%',
      position: 'relative'
    }
  }, React.createElement(ImageLoader, {
    ref: imgRef,
    style: _objectSpread({
      maxHeight: '100%',
      maxWidth: '100%',
      width: '100%',
      boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)'
    }, style),
    src: imgSrc,
    alt: imgAlt,
    onLoad: onThumbnailLoad
  }), children);
};

var ThumbnailSwitcherOverlay = function ThumbnailSwitcherOverlay(_ref170) {
  var imageViewerProps = _ref170.imageViewerProps,
      frontPostcardUrl = _ref170.frontPostcardUrl,
      backPostcardUrl = _ref170.backPostcardUrl,
      mediaType = _ref170.mediaType;
  var cardFace = imageViewerProps.cardFace,
      setCardFace = imageViewerProps.setCardFace,
      resetZoom = imageViewerProps.resetZoom;

  var _getDimensionFactorsB9 = getDimensionFactorsByMediaType(mediaType),
      widthFactor = _getDimensionFactorsB9.widthFactor,
      heightFactor = _getDimensionFactorsB9.heightFactor;

  var height = '6.25rem';
  var width = "calc((".concat(height, " * ").concat(widthFactor, ") / ").concat(heightFactor, ")");
  return React.createElement(BottomOverlay, {
    selectedIndex: cardFace === CardFace.Front ? 0 : 1,
    elements: [{
      main: React.createElement("div", {
        style: {
          height: height,
          width: width,
          overflow: 'hidden'
        }
      }, React.createElement(Thumbnail, {
        imgSrc: frontPostcardUrl,
        imgAlt: "Front Postcard",
        onClick: function onClick() {
          setCardFace(CardFace.Front);
        }
      }))
    }, {
      main: React.createElement("div", {
        style: {
          height: height,
          width: width,
          overflow: 'hidden'
        }
      }, React.createElement(Thumbnail, {
        imgSrc: backPostcardUrl,
        imgAlt: "Back Postcard",
        onClick: function onClick() {
          setCardFace(CardFace.Back);
        }
      }))
    }]
  });
};

var ThumbnailElement = function ThumbnailElement(_ref171) {
  var src = _ref171.src,
      alt = _ref171.alt,
      displayPlaceholder = _ref171.displayPlaceholder,
      imgRef = _ref171.imgRef,
      onClick = _ref171.onClick,
      _ref171$onLoad = _ref171.onLoad,
      onLoad = _ref171$onLoad === void 0 ? function () {} : _ref171$onLoad,
      mediaType = _ref171.mediaType;

  var _getDimensionFactorsB10 = getDimensionFactorsByMediaType(mediaType),
      widthFactor = _getDimensionFactorsB10.widthFactor,
      heightFactor = _getDimensionFactorsB10.heightFactor;

  var height = '6.25rem';
  var width = "calc((".concat(height, " * ").concat(widthFactor, ") / ").concat(heightFactor, ")");
  return React.createElement("div", {
    style: {
      height: height,
      width: width,
      overflow: 'hidden'
    }
  }, displayPlaceholder ? React.createElement(ThumbnailPlaceholder, {
    onClick: onClick
  }) : React.createElement(Thumbnail$1, {
    imgSrc: src,
    imgAlt: alt,
    imgRef: imgRef,
    onClick: onClick,
    onThumbnailLoad: onLoad,
    orientation: "landscape",
    height: height,
    width: width
  }));
};

var ThumbnailOverlay = function ThumbnailOverlay(_ref172) {
  var commentProps = _ref172.comments,
      isPortrait = _ref172.isPortrait,
      cardFace = _ref172.cardFace,
      _ref172$filterByCardF = _ref172.filterByCardFace,
      filterByCardFace = _ref172$filterByCardF === void 0 ? true : _ref172$filterByCardF,
      activeComment = _ref172.activeComment,
      overrideCommentStatus = _ref172.overrideCommentStatus,
      overrideCommentStyles = _ref172.overrideCommentStyles,
      mediaType = _ref172.mediaType;

  var _getDimensionFactorsB11 = getDimensionFactorsByMediaType(mediaType),
      widthFactor = _getDimensionFactorsB11.widthFactor,
      heightFactor = _getDimensionFactorsB11.heightFactor;

  var _useContext219 = useContext(DesignContext.Base),
      workflow = _useContext219.workflow;

  var baseMarkerStyle = {
    transform: 'scale(0.7)',
    zIndex: 2
  };
  var baseCommentsContainerStyle = {
    width: isPortrait ? '6.25rem' : "calc((6.25rem * ".concat(widthFactor, ") / ").concat(heightFactor, ")"),
    height: isPortrait ? "calc((6.25rem * ".concat(widthFactor, ") / ").concat(heightFactor, ")") : '6.25rem',
    position: 'relative'
  };
  var markerStyle = baseMarkerStyle;
  var commentsContainerStyle = baseCommentsContainerStyle;

  if (isPortrait) {
    markerStyle = _objectSpread({}, baseMarkerStyle, {
      transform: 'scale(0.7) rotate(90deg)'
    });
    commentsContainerStyle = _objectSpread({}, baseCommentsContainerStyle, {
      transformOrigin: 'top left',
      transform: 'rotate(-90deg) translate(-6.25rem, 0rem)'
    });
  }

  var comments = filterByCardFace ? commentProps.filter(function (c) {
    return cardFace === c.cardFace;
  }) : commentProps;
  var numComments = comments.length;
  return React.createElement("div", {
    style: commentsContainerStyle
  }, commentProps.map(function (c, i) {
    if (c.x === null || c.y === null) {
      return null;
    }

    if (cardFace !== c.cardFace) {
      return null;
    }

    var isActive = (activeComment === null || activeComment === void 0 ? void 0 : activeComment.id) === c.id;
    var x = c.x;
    var y = c.y;
    return React.createElement(MarkerRevisionReview, {
      key: c.id,
      active: isActive,
      c: _objectSpread({}, c, {
        x: x,
        y: y
      }),
      index: i,
      style: _objectSpread({}, markerStyle, overrideCommentStyles, {
        zIndex: numComments - i
      }),
      statusOverride: overrideCommentStatus
    });
  }));
};

var PostcardBottomOverlay = function PostcardBottomOverlay(_ref173) {
  var cardFace = _ref173.cardFace,
      setCardFace = _ref173.setCardFace,
      frontPostcardUrl = _ref173.frontPostcardUrl,
      backPostcardUrl = _ref173.backPostcardUrl,
      comments = _ref173.comments,
      frontComments = _ref173.frontComments,
      backComments = _ref173.backComments,
      doneFront = _ref173.doneFront,
      doneBack = _ref173.doneBack,
      activeComment = _ref173.activeComment,
      overrideCommentStyles = _ref173.overrideCommentStyles,
      overrideCommentStatus = _ref173.overrideCommentStatus,
      _ref173$groupByCardFa = _ref173.groupByCardFace,
      groupByCardFace = _ref173$groupByCardFa === void 0 ? true : _ref173$groupByCardFa,
      _ref173$displayPlaceh = _ref173.displayPlaceholder,
      displayPlaceholder = _ref173$displayPlaceh === void 0 ? false : _ref173$displayPlaceh,
      mediaType = _ref173.mediaType;
  var selectedIndex = cardFace === CardFace.Front ? 0 : 1;

  var _useState159 = useState(false),
      _useState160 = _slicedToArray(_useState159, 2),
      isFrontPortrait = _useState160[0],
      setIsFrontPortrait = _useState160[1];

  var _useState161 = useState(false),
      _useState162 = _slicedToArray(_useState161, 2),
      isBackPortrait = _useState162[0],
      setIsBackPortrait = _useState162[1];

  var _useScaledComments = useScaledComments({
    comments: comments
  }),
      frontCommentsScaled = _useScaledComments.commentsScaled,
      frontImgRef = _useScaledComments.imgRef,
      setFrontThumbnailHasLoaded = _useScaledComments.setThumbnailHasLoaded;

  var _useScaledComments2 = useScaledComments({
    comments: comments
  }),
      backCommentsScaled = _useScaledComments2.commentsScaled,
      backImgRef = _useScaledComments2.imgRef,
      setBackThumbnailHasLoaded = _useScaledComments2.setThumbnailHasLoaded;

  return React.createElement(BottomOverlay, {
    selectedIndex: selectedIndex,
    elements: [{
      main: React.createElement(ThumbnailElement, {
        src: frontPostcardUrl,
        alt: "Front Postcard",
        imgRef: frontImgRef,
        displayPlaceholder: displayPlaceholder,
        onClick: function onClick() {
          setCardFace(CardFace.Front);
        },
        onLoad: function onLoad(h, w) {
          setIsFrontPortrait(h > w);
          setFrontThumbnailHasLoaded(true);
        },
        mediaType: mediaType
      }),
      overlay: doneFront ? React.createElement("div", {
        style: {
          width: '100%',
          height: '100%',
          position: 'relative'
        }
      }, React.createElement("div", {
        style: {
          position: 'absolute',
          top: 4,
          right: 4
        }
      }, frontComments.length > 0 ? React.createElement(NumberedBadge, {
        value: frontComments.length,
        active: true
      }) : React.createElement(CheckedBadge, null))) : React.createElement(ThumbnailOverlay, {
        cardFace: CardFace.Front,
        comments: frontCommentsScaled,
        activeComment: activeComment,
        isPortrait: isFrontPortrait,
        overrideCommentStatus: overrideCommentStatus,
        overrideCommentStyles: overrideCommentStyles,
        imgRef: frontImgRef,
        filterByCardFace: groupByCardFace,
        mediaType: mediaType
      })
    }, {
      main: React.createElement(ThumbnailElement, {
        src: backPostcardUrl,
        alt: "Back Postcard",
        imgRef: backImgRef,
        displayPlaceholder: displayPlaceholder,
        onClick: function onClick() {
          setCardFace(CardFace.Back);
        },
        onLoad: function onLoad(h, w) {
          setIsBackPortrait(h > w);
          setBackThumbnailHasLoaded(true);
        },
        mediaType: mediaType
      }),
      overlay: doneBack ? React.createElement("div", {
        style: {
          width: '100%',
          height: '100%',
          position: 'relative'
        }
      }, React.createElement("div", {
        style: {
          position: 'absolute',
          top: 4,
          right: 4
        }
      }, backComments.length > 0 ? React.createElement(NumberedBadge, {
        value: backComments.length,
        active: true
      }) : React.createElement(CheckedBadge, null))) : React.createElement(ThumbnailOverlay, {
        cardFace: CardFace.Back,
        comments: backCommentsScaled,
        activeComment: activeComment,
        isPortrait: isBackPortrait,
        overrideCommentStatus: overrideCommentStatus,
        overrideCommentStyles: overrideCommentStyles,
        imgRef: backImgRef,
        filterByCardFace: groupByCardFace,
        mediaType: mediaType
      })
    }]
  });
};

var AddUnpinnedCommentButton = function AddUnpinnedCommentButton() {
  var comments = useContext(CommentsStore.Comments);

  var _useContext220 = useContext(UIStateContext.Sidebar),
      addingUnpinnedComment = _useContext220.addingUnpinnedComment;

  var _useContext221 = useContext(ActionsContext),
      openUnpinnedCommentPrompt = _useContext221.openUnpinnedCommentPrompt;

  var numComments = comments.length;
  var badgeTransition = useTransition(numComments, {
    from: {
      opacity: 0,
      translateY: 12
    },
    enter: {
      opacity: 1,
      translateY: 0
    }
  });
  return React.createElement(Tooltip$1, {
    title: React.createElement("span", {
      style: {
        fontSize: '1rem'
      }
    }, "Add Un-pinned comment")
  }, React.createElement("div", null, React.createElement(Fab, {
    style: {
      marginTop: '1em',
      pointerEvents: 'auto',
      backgroundColor: addingUnpinnedComment ? Colors.MVP_LIGHT_PINK : '#f9f9f9',
      color: addingUnpinnedComment ? '#fff' : '#929292'
    },
    onClick: function onClick() {
      openUnpinnedCommentPrompt();
    }
  }, React.createElement(AddComment, null)), badgeTransition(function (_ref174, numComments) {
    var opacity = _ref174.opacity,
        translateY = _ref174.translateY;

    if (numComments > 0) {
      return React.createElement(animated.div, {
        style: {
          position: 'absolute',
          top: '6px',
          left: '-6px',
          opacity: opacity,
          translateY: translateY
        }
      }, React.createElement(PlainNumberedBadge, {
        active: true,
        value: comments.length,
        style: {
          transform: 'scale(0.8)'
        }
      }));
    }

    return null;
  })));
};

var ViewingAreaTopRightOverlay = function ViewingAreaTopRightOverlay(_ref175) {
  var cardFace = _ref175.cardFace,
      setCardFace = _ref175.setCardFace,
      refreshDesign = _ref175.refreshDesign,
      isViewingPrevious = _ref175.isViewingPrevious,
      setIsViewingPrevious = _ref175.setIsViewingPrevious,
      isPreviousVersionLocked = _ref175.isPreviousVersionLocked,
      setIsPreviousVersionLocked = _ref175.setIsPreviousVersionLocked,
      showingInactiveMarkers = _ref175.showingInactiveMarkers,
      setShowingInactiveMarkers = _ref175.setShowingInactiveMarkers,
      showingAllMarkers = _ref175.showingAllMarkers,
      setShowingAllMarkers = _ref175.setShowingAllMarkers,
      visibleButtons = _ref175.visibleButtons,
      _ref175$options = _ref175.options,
      options = _ref175$options === void 0 ? {
    toggleAllMarkersDisabled: false
  } : _ref175$options;

  var _useState163 = useState(false),
      _useState164 = _slicedToArray(_useState163, 2),
      isRefreshing = _useState164[0],
      setIsRefreshing = _useState164[1];

  var _useContext222 = useContext(UIStateContext.Derived.Sidebar),
      hasSidebar = _useContext222.hasSidebar;

  var _useContext223 = useContext(UIStateContext.Derived.Scaffold),
      areCurrentImagesMissing = _useContext223.areCurrentImagesMissing;

  var useStyles = makeStyles({
    tooltipLabel: {
      fontSize: 14
    }
  });
  var classes = useStyles();

  var getColor = function getColor() {
    if (isPreviousVersionLocked) {
      return 'white';
    }

    return isViewingPrevious ? Colors.MVP_LIGHT_PINK : '#929292';
  };

  var handleRefresh =
  /*#__PURE__*/
  function () {
    var _ref176 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee43() {
      return _regeneratorRuntime.wrap(function _callee43$(_context43) {
        while (1) {
          switch (_context43.prev = _context43.next) {
            case 0:
              setIsRefreshing(true);
              _context43.next = 3;
              return refreshDesign();

            case 3:
              setIsRefreshing(false);
              setIsViewingPrevious(false);
              setIsPreviousVersionLocked(false);

            case 6:
            case "end":
              return _context43.stop();
          }
        }
      }, _callee43);
    }));

    return function handleRefresh() {
      return _ref176.apply(this, arguments);
    };
  }();

  return React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      marginRight: hasSidebar ? 0 : '1rem'
    }
  }, visibleButtons.addUnpinnedComment ? React.createElement(AddUnpinnedCommentButton, null) : null, visibleButtons.flipPage && React.createElement(Tooltip$1, {
    title: React.createElement("span", {
      style: {
        fontSize: '1rem'
      }
    }, "Flip to ", getReverseCardFace(cardFace), " design")
  }, React.createElement(Fab, {
    style: {
      marginTop: '1em',
      pointerEvents: 'auto',
      backgroundColor: '#f9f9f9',
      color: '#929292'
    },
    onClick: function onClick() {
      if (cardFace === 'Back') {
        setCardFace(CardFace.Front);
      } else {
        setCardFace(CardFace.Back);
      }
    }
  }, React.createElement(Flip, null))), visibleButtons.togglePreviousVersion && React.createElement(Tooltip$1, {
    title: isPreviousVersionLocked ? React.createElement("span", {
      style: {
        fontSize: '1rem'
      }
    }, "Click to unlock previous design") : React.createElement("span", {
      style: {
        fontSize: '1rem'
      }
    }, "Click to lock previous design")
  }, React.createElement(Fab, {
    style: {
      backgroundColor: isPreviousVersionLocked ? Colors.MVP_LIGHT_PINK : '#f9f9f9',
      marginTop: '1em',
      pointerEvents: 'auto',
      color: getColor()
    },
    onClick: function onClick() {
      setIsViewingPrevious(function (current) {
        return !current;
      });
      setIsPreviousVersionLocked(function (current) {
        return !current;
      });
    }
  }, React.createElement(FilterNone, null))), visibleButtons.refreshDesign && React.createElement(Tooltip$1, {
    title: 'Click to refresh design',
    placement: 'left',
    arrow: true,
    open: areCurrentImagesMissing,
    classes: {
      tooltip: classes.tooltipLabel
    }
  }, React.createElement(Fab, {
    style: {
      marginTop: '1em',
      pointerEvents: 'auto',
      backgroundColor: '#f9f9f9',
      color: '#929292'
    },
    onClick: handleRefresh
  }, React.createElement(Rotate, {
    enabled: isRefreshing
  }, React.createElement(Refresh, null)))), visibleButtons.toggleInactiveMarkers && React.createElement(Tooltip$1, {
    title: showingInactiveMarkers ? React.createElement("span", {
      style: {
        fontSize: '1rem'
      }
    }, "Click to hide inactive pins") : React.createElement("span", {
      style: {
        fontSize: '1rem'
      }
    }, ' ', "Click to show all pins", ' ')
  }, React.createElement(Fab, {
    style: {
      marginTop: '1em',
      pointerEvents: 'auto',
      backgroundColor: showingInactiveMarkers ? '#f9f9f9' : Colors.MVP_LIGHT_PINK,
      color: showingInactiveMarkers ? '#929292' : 'white'
    },
    onClick: function onClick() {
      setShowingInactiveMarkers(function (s) {
        return !s;
      });
    }
  }, React.createElement(VisibilityOffOutlined, null))), visibleButtons.toggleAllMarkers && React.createElement(Tooltip$1, {
    title: React.createElement(ToggleAllMarkersTitle, {
      showingAllMarkers: showingAllMarkers,
      toggleAllMarkersDisabled: options.toggleAllMarkersDisabled
    })
  }, React.createElement(Fab, {
    style: {
      marginTop: '1em',
      pointerEvents: 'auto',
      backgroundColor: showingAllMarkers ? '#f9f9f9' : Colors.MVP_LIGHT_PINK,
      color: showingAllMarkers ? '#929292' : 'white'
    },
    onClick: function onClick() {
      if (!options.toggleAllMarkersDisabled) {
        setShowingAllMarkers(function (s) {
          return !s;
        });
      }
    }
  }, React.createElement(VisibilityOffOutlined, null))));
};

var ToggleAllMarkersTitle = function ToggleAllMarkersTitle(_ref177) {
  var showingAllMarkers = _ref177.showingAllMarkers,
      toggleAllMarkersDisabled = _ref177.toggleAllMarkersDisabled;

  if (toggleAllMarkersDisabled) {
    return React.createElement("span", {
      style: {
        fontSize: '1rem'
      }
    }, "No pins to hide/show");
  }

  if (showingAllMarkers) {
    return React.createElement("span", {
      style: {
        fontSize: '1rem'
      }
    }, " Click to hide all pins");
  }

  return React.createElement("span", {
    style: {
      fontSize: '1rem'
    }
  }, " Click to show all pins ");
};

var getReverseCardFace = function getReverseCardFace(c) {
  if (c === CardFace.Front) {
    return String(CardFace.Back).toLowerCase();
  }

  return String(CardFace.Front).toLowerCase();
};

var useImageSliderStyles = makeStyles({
  carousel: {
    outline: 'none'
  },
  boxContainer: {
    background: '#fff',
    boxShadow: 'rgba(195, 195, 195, 0.69) 0px 3px 7px',
    padding: '16px 32px',
    borderRadius: 5,
    margin: '6px 35px',
    display: 'flex',
    flexDirection: 'column',
    '& img': {
      cursor: 'pointer',
      boxShadow: 'rgba(195, 195, 195, 0.59) 0px 0px 7px'
    }
  },
  splitSlideWrapper: {
    position: 'relative'
  },
  controlsWrapper: {
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-between',
    position: 'absolute',
    top: 'calc(50% - 10px)',
    zIndex: 10,
    height: 0,
    transition: 'ease .100s all',
    overflow: 'visible',
    '& img': {
      cursor: 'pointer',
      height: 34,
      width: 34
    }
  },
  mergedControls: {
    top: 'calc(50% - 20px)'
  },
  sliderWrapper: {
    overflow: 'hidden',
    '& .flickity-slider>div:not(.is-selected)': {
      opacity: 0.25,
      pointerEvents: 'none'
    }
  },
  merged: {
    '& img': {
      margin: '6px 0px'
    }
  },
  sliderContainer: {
    height: 'auto',
    opacity: 1,
    transition: 'height 0ms 0ms, opacity 600ms 0ms',
    position: 'relative'
  },
  hide: {
    overflow: 'hidden',
    height: 0,
    opacity: 0,
    transition: 'height 0ms 400ms, opacity 400ms 0ms'
  },
  disabled: {
    opacity: 0.25,
    pointerEvents: 'none'
  },
  backDrop: {
    width: '100%',
    height: '100vh',
    display: 'grid',
    gridTemplate: 'auto 1fr auto / 1fr',
    position: 'fixed',
    background: 'black',
    zIndex: 100,
    top: 0,
    left: 0
  },
  close: {
    color: '#fff',
    position: 'absolute',
    'z-index': '100',
    background: 'rgba(43, 43, 43, 0.8)',
    right: '8px',
    top: '8px'
  },
  placeholder: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  sliderDotNav: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 6,
    marginBottom: 0,
    '& svg': {
      height: 14,
      width: 14,
      color: 'rgb(211, 211, 211)',
      marginRight: 2,
      cursor: 'pointer'
    }
  },
  active: {
    color: 'rgb(237, 21, 78) !important'
  },
  sliderDotNavWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0px 53px',
    marginTop: 4,
    '& label': {
      color: 'rgb(156, 156, 156)',
      fontSize: 15
    }
  },
  portraitToLandscape: {
    transform: 'rotate(-90deg) translateX(-100%)',
    transformOrigin: 'left top'
  }
});

var ImageSliderNav = function ImageSliderNav(_ref178) {
  var initialIndex = _ref178.initialIndex,
      images = _ref178.images,
      slider = _ref178.slider;
  var classes = useImageSliderStyles();

  var _useState165 = useState(initialIndex),
      _useState166 = _slicedToArray(_useState165, 2),
      selectedIndex = _useState166[0],
      setSelectedIndex = _useState166[1];

  var handleClick = function handleClick(index) {
    slider && slider.select(index, false, false);
  };

  useLayoutEffect(function () {
    if (slider) {
      slider.on('change', function () {
        setSelectedIndex(slider.selectedIndex);
      });
    }
  }, [slider]);
  return React.createElement("div", {
    className: classes.sliderDotNav
  }, Object.keys(images).map(function (key, index) {
    return React.createElement(FiberManualRecord, {
      key: key,
      className: cx(selectedIndex === index && classes.active),
      onClick: function onClick() {
        return handleClick(index);
      }
    });
  }));
};

var img$k = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='34' height='34' viewBox='0 0 34 34'%3e %3cg id='Group_13927' data-name='Group 13927' transform='translate(-919 -623)'%3e %3ccircle id='Ellipse_1677' data-name='Ellipse 1677' cx='17' cy='17' r='17' transform='translate(919 623)' fill='%23141414' opacity='0.5'/%3e %3cg id='keyboard_arrow_right-24px' transform='translate(924 628)'%3e %3cpath id='Path_3706' data-name='Path 3706' d='M8.59%2c16.59%2c13.17%2c12%2c8.59%2c7.41%2c10%2c6l6%2c6-6%2c6Z' fill='%23d3d3d3'/%3e %3cpath id='Path_3707' data-name='Path 3707' d='M0%2c0H24V24H0Z' fill='none'/%3e %3c/g%3e %3c/g%3e%3c/svg%3e";
var img$l = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='34' height='34' viewBox='0 0 34 34'%3e %3cg id='Group_13928' data-name='Group 13928' transform='translate(953 657) rotate(180)'%3e %3ccircle id='Ellipse_1677' data-name='Ellipse 1677' cx='17' cy='17' r='17' transform='translate(919 623)' fill='%23141414' opacity='0.5'/%3e %3cg id='keyboard_arrow_right-24px' transform='translate(924 628)'%3e %3cpath id='Path_3706' data-name='Path 3706' d='M8.59%2c16.59%2c13.17%2c12%2c8.59%2c7.41%2c10%2c6l6%2c6-6%2c6Z' fill='%23d3d3d3'/%3e %3cpath id='Path_3707' data-name='Path 3707' d='M0%2c0H24V24H0Z' fill='none'/%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var MergedSlider = function MergedSlider(_ref179) {
  var handleDisableControls = _ref179.handleDisableControls,
      handlePrevious = _ref179.handlePrevious,
      setMergedSlider = _ref179.setMergedSlider,
      mergedSlider = _ref179.mergedSlider,
      controlsWrapperStyles = _ref179.controlsWrapperStyles,
      images = _ref179.images,
      initialFrontIndex = _ref179.initialFrontIndex,
      onClickImage = _ref179.onClickImage,
      handleNext = _ref179.handleNext,
      imageWidth = _ref179.imageWidth;
  var classes = useImageSliderStyles();
  return React.createElement(Fragment, null, React.createElement("div", {
    className: cx(classes.controlsWrapper, classes.mergedControls),
    style: controlsWrapperStyles
  }, React.createElement("img", {
    className: handleDisableControls('merged-prev'),
    onClick: function onClick() {
      handlePrevious(mergedSlider);
    },
    src: img$l,
    alt: "prev"
  }), React.createElement("img", {
    className: handleDisableControls('merged-next'),
    onClick: function onClick() {
      handleNext(mergedSlider);
    },
    src: img$k,
    alt: "next"
  })), React.createElement(Flickity, {
    flickityRef: function flickityRef(c) {
      return setMergedSlider(c);
    },
    className: classes.carousel,
    options: {
      selectedAttraction: 0.03,
      initialIndex: initialFrontIndex,
      prevNextButtons: false,
      pageDots: false,
      draggable: false
    }
  }, Object.keys(images).map(function (key) {
    var imgFront = postcardImg(images[key].front.src, imageWidth);
    var imgBack = postcardImg(images[key].back.src, imageWidth);
    return React.createElement("div", {
      key: key,
      id: images[key].front.id + ',' + images[key].back.id,
      className: cx(classes.boxContainer, classes.merged)
    }, React.createElement("div", {
      style: imgFront.imageContainerStyles
    }, React.createElement("img", {
      className: cx(isPortrait(images[key].front.src) && classes.portraitToLandscape),
      onClick: function onClick() {
        onClickImage(CardFace.Front);
      },
      onError: handleImageOnError,
      alt: "",
      width: imgFront.image.width,
      src: "".concat(images[key].front.src)
    })), React.createElement("br", null), isPortrait(images[key].front.src) && React.createElement("div", {
      style: {
        height: 17
      }
    }), React.createElement("div", {
      style: imgBack.imageContainerStyles
    }, React.createElement("img", {
      className: cx(isPortrait(images[key].back.src) && classes.portraitToLandscape),
      onClick: function onClick() {
        onClickImage(CardFace.Back);
      },
      onError: handleImageOnError,
      alt: "",
      width: imgBack.image.width,
      src: "".concat(images[key].back.src)
    })), isPortrait(images[key].back.src) && React.createElement("div", {
      style: {
        height: 17
      }
    }));
  })), React.createElement(ImageSliderNav, {
    initialIndex: initialFrontIndex,
    images: images,
    slider: mergedSlider
  }));
};

var ImageLoader$1 = function ImageLoader$1(_ref180) {
  var imageWidth = _ref180.imageWidth,
      images = _ref180.images;
  var classes = useImageSliderStyles();
  return React.createElement("div", {
    className: cx(classes.sliderContainer, classes.placeholder)
  }, React.createElement("div", {
    className: classes.splitSlideWrapper
  }, React.createElement("div", {
    className: classes.boxContainer
  }, React.createElement(ImageLoader, {
    src: "".concat(images.front),
    alt: "",
    style: {
      width: "".concat(imageWidth, "px"),
      marginBottom: 22
    }
  }), React.createElement(ImageLoader, {
    src: "".concat(images.back),
    alt: "",
    style: {
      width: "".concat(imageWidth, "px"),
      marginBottom: 22
    }
  }))));
};

var ImageSlider = function ImageSlider(_ref181) {
  var images = _ref181.images,
      initialState = _ref181.initialState,
      onSelect = _ref181.onSelect,
      setBoxWidth = _ref181.setBoxWidth,
      _ref181$onClickImage = _ref181.onClickImage,
      onClickImage = _ref181$onClickImage === void 0 ? function () {} : _ref181$onClickImage,
      _ref181$split = _ref181.split,
      split = _ref181$split === void 0 ? false : _ref181$split;
  var initialFrontIndex = Object.keys(images).indexOf(initialState.front.id);
  var initialBackIndex = Object.keys(images).indexOf(initialState.back.id);
  var classes = useImageSliderStyles();

  var _useState167 = useState(),
      _useState168 = _slicedToArray(_useState167, 2),
      splitSliderFront = _useState168[0],
      setSplitSliderFront = _useState168[1];

  var _useState169 = useState(),
      _useState170 = _slicedToArray(_useState169, 2),
      splitSliderBack = _useState170[0],
      setSplitSliderBack = _useState170[1];

  var _useState171 = useState(),
      _useState172 = _slicedToArray(_useState171, 2),
      mergedSlider = _useState172[0],
      setMergedSlider = _useState172[1];

  var _useState173 = useState(initialState.front.id),
      _useState174 = _slicedToArray(_useState173, 2),
      selectedFront = _useState174[0],
      setSelectedFront = _useState174[1];

  var _useState175 = useState(initialFrontIndex),
      _useState176 = _slicedToArray(_useState175, 2),
      selectedIndexFront = _useState176[0],
      setSelectedIndexFront = _useState176[1];

  var _useState177 = useState(initialBackIndex),
      _useState178 = _slicedToArray(_useState177, 2),
      selectedIndexBack = _useState178[0],
      setSelectedIndexBack = _useState178[1];

  var _useState179 = useState(initialState.back.id),
      _useState180 = _slicedToArray(_useState179, 2),
      selectedBack = _useState180[0],
      setSelectedBack = _useState180[1];

  var _useState181 = useState(initialFrontIndex),
      _useState182 = _slicedToArray(_useState181, 2),
      selectedIndexConcept = _useState182[0],
      setSelectedIndexConcept = _useState182[1];

  var _useState183 = useState(false),
      _useState184 = _slicedToArray(_useState183, 2),
      isFrontChanged = _useState184[0],
      setIsFrontChanged = _useState184[1];

  var _useState185 = useState(false),
      _useState186 = _slicedToArray(_useState185, 2),
      isConceptChanged = _useState186[0],
      setIsConceptChanged = _useState186[1];

  var _useState187 = useState(false),
      _useState188 = _slicedToArray(_useState187, 2),
      showSliderSplit = _useState188[0],
      setShowSliderSplit = _useState188[1];

  var _useState189 = useState(false),
      _useState190 = _slicedToArray(_useState189, 2),
      showSliderMerged = _useState190[0],
      setShowSliderMerged = _useState190[1];

  var _useState191 = useState(initialState),
      _useState192 = _slicedToArray(_useState191, 2),
      selectedConcept = _useState192[0],
      setSlectedConcept = _useState192[1];

  var handleDisableControls = function handleDisableControls(type) {
    if (type === 'front-prev' && selectedIndexFront === 0) {
      return classes.disabled;
    }

    if (type === 'back-prev' && selectedIndexBack === 0) {
      return classes.disabled;
    }

    if (type === 'merged-prev' && selectedIndexConcept === 0) {
      return classes.disabled;
    }

    if (type === 'front-next' && selectedIndexFront + 1 === Object.keys(images).length) {
      return classes.disabled;
    }

    if (type === 'back-next' && selectedIndexBack + 1 === Object.keys(images).length) {
      return classes.disabled;
    }

    if (type === 'merged-next' && selectedIndexConcept + 1 === Object.keys(images).length) {
      return classes.disabled;
    }
  };

  if (split) {
    // Check if the slider is ready
    mergedSlider && mergedSlider.on('ready', function () {
      setShowSliderSplit(true);
    });
    splitSliderFront && splitSliderFront.on('change', function () {
      // @ts-ignore
      setSelectedFront(splitSliderFront.selectedElement.getAttribute('id'));
      setSelectedIndexFront(splitSliderFront.selectedIndex);
      setIsFrontChanged(true);
      setIsConceptChanged(false);
    });
    splitSliderBack && splitSliderBack.on('change', function () {
      // @ts-ignore
      setSelectedBack(splitSliderBack.selectedElement.getAttribute('id'));
      setSelectedIndexBack(splitSliderBack.selectedIndex);
      setIsConceptChanged(false);
    });

    if (isConceptChanged && splitSliderFront) {
      splitSliderFront.select(selectedIndexConcept, false, true);
    }

    if (isConceptChanged && splitSliderBack) {
      splitSliderBack.select(selectedIndexConcept, false, true);
    }
  } else {
    mergedSlider && mergedSlider.on('ready', function () {
      setShowSliderMerged(true);
    });
    mergedSlider && mergedSlider.on('change', function () {
      setSlectedConcept({
        split: false,
        front: {
          // @ts-ignore
          id: mergedSlider.selectedElement.getAttribute('id').split(',')[0]
        },
        back: {
          // @ts-ignore
          id: mergedSlider.selectedElement.getAttribute('id').split(',')[1]
        }
      });
      setSelectedIndexConcept(mergedSlider.selectedIndex);
      setSelectedIndexFront(mergedSlider.selectedIndex);
      setSelectedIndexBack(mergedSlider.selectedIndex);
      setIsConceptChanged(true);
      setIsFrontChanged(false);
    });
    isFrontChanged && mergedSlider && mergedSlider.select(selectedIndexFront, false, true);
  }

  useEffect(function () {
    if (split) {
      onSelect({
        front: {
          id: selectedFront
        },
        back: {
          id: selectedBack
        }
      });
    } else {
      onSelect(selectedConcept);
    }
  });

  var handlePrevious = function handlePrevious(slider) {
    if (slider) {
      slider.previous();
    }
  };

  var handleNext = function handleNext(slider) {
    if (slider) {
      slider.next();
    }
  };

  var _useWindowMeasure = useWindowMeasure(),
      height = _useWindowMeasure.height;

  var _window$screen = window.screen,
      screenWidth = _window$screen.width,
      screenHeight = _window$screen.height;
  var imageWidth = 0;

  if (screenWidth >= 1920 && screenHeight >= 1080) {
    imageWidth = height / 1.8;
  } else {
    imageWidth = height / 2.2;
  }

  var controlsWrapperStyles = {
    width: imageWidth + 170,
    left: "calc(50% - (".concat(imageWidth, "px / 2) - 85px)")
  };
  useLayoutEffect(function () {
    if (typeof setBoxWidth !== 'undefined') {
      setBoxWidth(imageWidth + 64);
    }
  }, [setBoxWidth, imageWidth]);
  return React.createElement("div", {
    className: classes.sliderWrapper
  }, !showSliderSplit && !showSliderMerged && React.createElement(ImageLoader$1, {
    images: images,
    imageWidth: imageWidth
  }), React.createElement("div", {
    className: cx(!showSliderSplit && !showSliderMerged && classes.hide)
  }, React.createElement("div", {
    className: cx(classes.sliderContainer, split && classes.hide)
  }, React.createElement(MergedSlider, {
    handleDisableControls: handleDisableControls,
    handlePrevious: handlePrevious,
    setMergedSlider: setMergedSlider,
    mergedSlider: mergedSlider,
    controlsWrapperStyles: controlsWrapperStyles,
    images: images,
    initialFrontIndex: initialFrontIndex,
    onClickImage: onClickImage,
    handleNext: handleNext,
    imageWidth: imageWidth
  }))));
};

var useHelpModalStyles = makeStyles$1({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& h2': {
      marginBottom: '1.5rem',
      marginTop: 5,
      fontFamily: 'Roboto Condensed',
      fontSize: '1.6rem',
      fontWeight: 'bold',
      textAlign: 'center',
      lineHeight: 1.3
    }
  },
  avatar: {
    height: '9rem',
    width: '9rem',
    borderRadius: '100%',
    marginRight: '0 auto'
  },
  infoWrapper: {
    marginTop: '.8rem',
    textAlign: 'center',
    width: '100%',
    '& h3': {
      textTransform: 'uppercase',
      fontFamily: 'Roboto Condensed',
      fontSize: '1.2rem',
      marginTop: '0px',
      marginBottom: '0px',
      fontWeight: 'bold'
    },
    '& p': {
      marginTop: '0px',
      marginBottom: '10px',
      fontFamily: 'Roboto Condensed',
      fontSize: '1.05rem',
      color: '#929292'
    }
  },
  contactInfoWrapper: {
    flexDirection: 'column',
    display: 'flex',
    alignItems: 'center',
    borderTop: 'solid 1px #eee',
    borderBottom: 'solid 1px #eee',
    width: '20rem',
    margin: '13px auto 0px',
    marginBottom: '.5rem',
    padding: '11px',
    background: '#F9F9F9',
    paddingBottom: '1rem',
    '& span:first-child': {
      marginBottom: '5px',
      marginTop: '5px'
    },
    '& span': {
      display: 'flex',
      alignItems: 'center',
      fontFamily: 'Roboto Condensed',
      color: '#ED154E',
      fontSize: '1.2rem',
      '& svg': {
        height: 18,
        width: 18,
        fill: '#ED154E',
        marginRight: '8px'
      }
    }
  },
  links: {
    textDecoration: 'none',
    fontFamily: 'Roboto Condensed',
    color: '#ED154E',
    fontWeight: 'bold'
  }
});

var HelpModal = function HelpModal(_ref182) {
  var open = _ref182.open,
      onBackdropClick = _ref182.onBackdropClick,
      coordinator = _ref182.coordinator,
      header = _ref182.header;
  var classes = useHelpModalStyles();
  return React.createElement(Modal, {
    width: 400,
    open: open,
    onBackdropClick: onBackdropClick
  }, React.createElement("div", {
    className: classes.wrapper
  }, React.createElement("h2", null, header !== null && header !== void 0 ? header : 'Call or email us for prompt response'), React.createElement(PortraitLoader, {
    className: classes.avatar,
    alt: coordinator.name,
    src: coordinator.avatar,
    nameFallback: coordinator.name
  }), React.createElement("div", {
    className: classes.infoWrapper
  }, React.createElement("h3", null, coordinator.name), React.createElement("p", null, coordinator.position), React.createElement("div", {
    className: classes.contactInfoWrapper
  }, React.createElement("span", null, React.createElement(Phone, null), React.createElement("a", {
    className: classes.links,
    href: "tel:".concat(coordinator.phone)
  }, formatPhoneNumber(coordinator.phone))), React.createElement("span", null, React.createElement(Email, null), React.createElement("a", {
    className: classes.links,
    href: "mailto:".concat(coordinator.email)
  }, coordinator.email))))));
};

var getScaledHeight = function getScaledHeight(width) {
  return width / 16 * 9;
};

var VideoModal = function VideoModal(_ref183) {
  var open = _ref183.open,
      onBackdropClick = _ref183.onBackdropClick,
      videoTitle = _ref183.videoTitle,
      _ref183$videoUrl = _ref183.videoUrl,
      videoUrl = _ref183$videoUrl === void 0 ? 'https://www.youtube.com/embed/D6Ac5JpCHmI?&autoplay=1' : _ref183$videoUrl;

  var _useWindowMeasure2 = useWindowMeasure(),
      width = _useWindowMeasure2.width;

  var modalWidth = width / 2;
  var modalHeight = getScaledHeight(modalWidth);
  return React.createElement(Modal, {
    width: modalWidth,
    open: open,
    onBackdropClick: onBackdropClick,
    containerStyle: {
      padding: 0,
      height: modalHeight,
      overflow: 'hidden',
      backgroundColor: 'black'
    }
  }, React.createElement("iframe", {
    title: videoTitle,
    width: modalWidth,
    height: modalHeight,
    src: videoUrl,
    allowFullScreen: true,
    style: {
      border: 'none'
    }
  }));
};

var styles = {
  container: {
    padding: '12px 32px',
    background: '#fff',
    display: 'flex',
    boxShadow: '1px -6px 26px #c3c3c3',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  conceptContainer: {
    padding: '5px 32px',
    background: '#fff',
    display: 'flex',
    boxShadow: '1px -6px 26px #c3c3c3',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  title: {
    margin: 0,
    fontSize: '1.3rem',
    fontFamily: 'Roboto Condensed'
  },
  btnContainer: {
    marginTop: -12,
    marginBottom: -12
  }
};

var Header = function Header(_ref184) {
  var buttons = _ref184.buttons,
      title = _ref184.title;
  return React.createElement(Fragment, null, React.createElement("header", {
    style: title === 'Design Concepts' ? styles.conceptContainer : styles.container
  }, React.createElement("h3", {
    style: styles.title
  }, title), React.createElement("div", {
    style: styles.btnContainer
  }, buttons)));
};

var DEFAULT_CENTER = {
  lat: 28.1779318,
  lng: -81.6377888
};
var DEFAULT_ZOOM = 12;

var GoogleMapBase = function GoogleMapBase(_ref185) {
  var defaultZoom = _ref185.defaultZoom,
      defaultCenter = _ref185.defaultCenter,
      options = _ref185.options,
      children = _ref185.children;
  return React.createElement(GoogleMap$1, {
    defaultZoom: defaultZoom !== null && defaultZoom !== void 0 ? defaultZoom : DEFAULT_ZOOM,
    defaultCenter: defaultCenter !== null && defaultCenter !== void 0 ? defaultCenter : DEFAULT_CENTER,
    options: _objectSpread({
      zoomControl: false,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      gestureHandling: 'none'
    }, options)
  }, children);
};

var GoogleMap = function GoogleMap(props) {
  var Component = withGoogleMap(GoogleMapBase);
  return React.createElement(Component, Object.assign({}, props));
};

var Thumbnail$1 = function Thumbnail$1(_ref186) {
  var orientation = _ref186.orientation,
      width = _ref186.width,
      height = _ref186.height,
      imgSrc = _ref186.imgSrc,
      imgAlt = _ref186.imgAlt,
      imgRef = _ref186.imgRef,
      style = _ref186.style,
      onClick = _ref186.onClick,
      _ref186$onThumbnailLo = _ref186.onThumbnailLoad,
      onThumbnailLoad = _ref186$onThumbnailLo === void 0 ? function () {} : _ref186$onThumbnailLo;

  var _useState193 = useState('landscape'),
      _useState194 = _slicedToArray(_useState193, 2),
      internalOrientation = _useState194[0],
      setInternalOrientation = _useState194[1];

  var _useState195 = useState(false),
      _useState196 = _slicedToArray(_useState195, 2),
      visible = _useState196[0],
      setVisible = _useState196[1];

  var onLoad = function onLoad(h, w) {
    if (h > w) {
      setInternalOrientation('portrait');
    }

    onThumbnailLoad(h, w);
    setVisible(true);
  };

  var containerStyle = {};

  if (typeof orientation !== 'undefined' && orientation !== internalOrientation) {
    if (orientation === 'landscape') {
      containerStyle = _objectSpread({}, containerStyle, {
        width: height,
        height: width,
        transformOrigin: 'left top',
        transform: "rotate(-90deg) translateX(-100%)"
      });
    }
  }

  return React.createElement("div", {
    style: containerStyle
  }, React.createElement(ImageLoader, {
    ref: imgRef,
    style: _objectSpread({
      maxHeight: '100%',
      maxWidth: '100%',
      boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)'
    }, style),
    src: imgSrc,
    alt: imgAlt,
    onLoad: onLoad,
    onClick: onClick,
    visible: visible
  }));
};

var useScaledComments = function useScaledComments(_ref187) {
  var comments = _ref187.comments;

  var _useState197 = useState(false),
      _useState198 = _slicedToArray(_useState197, 2),
      thumbnailHasLoaded = _useState198[0],
      setThumbnailHasLoaded = _useState198[1];

  var imgRef = useRef(new Image());

  var _useState199 = useState([]),
      _useState200 = _slicedToArray(_useState199, 2),
      commentsScaled = _useState200[0],
      setCommentsScaled = _useState200[1];

  useEffect(function () {
    if (thumbnailHasLoaded) {
      setCommentsScaled(comments.map(function (c) {
        if (c.x === null || c.y === null) {
          return c;
        }

        return _objectSpread({}, c, {
          x: c.x - 9,
          y: c.y - 15
        });
      }));
    }
  }, [comments, imgRef, thumbnailHasLoaded]);
  return {
    commentsScaled: commentsScaled,
    imgRef: imgRef,
    setThumbnailHasLoaded: setThumbnailHasLoaded
  };
};

var MarkerRevisionReview = function MarkerRevisionReview(_ref188) {
  var c = _ref188.c,
      index = _ref188.index,
      active = _ref188.active,
      style = _ref188.style,
      statusOverride = _ref188.statusOverride;

  var _a;

  var status = statusOverride !== null && statusOverride !== void 0 ? statusOverride : c.status;
  var valueTransition = useTransition(status, {
    enter: {
      opacity: 1
    },
    leave: {
      opacity: 0
    }
  });

  var _useSpring20 = useSpring({
    x: c.x,
    y: c.y
  }),
      x = _useSpring20.x,
      y = _useSpring20.y;

  var _useSpring21 = useSpring({
    from: {
      translateY: 4,
      opacity: 0
    },
    to: {
      translateY: 0,
      opacity: 1
    }
  }),
      translateY = _useSpring21.translateY,
      opacity = _useSpring21.opacity;

  var _useSpring22 = useSpring({
    to: _objectSpread({}, getColorFromStatus(status, active)),
    config: config.molasses
  }),
      r = _useSpring22.r,
      g = _useSpring22.g,
      b = _useSpring22.b;

  return React.createElement(animated.div, {
    style: {
      position: 'absolute',
      top: y.to(function (y) {
        return "".concat(y, "%");
      }),
      left: x.to(function (x) {
        return "".concat(x, "%");
      }),
      transform: translateY.to(function (ty) {
        return "translateY(".concat(ty, "px)");
      }),
      opacity: opacity,
      zIndex: (_a = style === null || style === void 0 ? void 0 : style.zIndex) !== null && _a !== void 0 ? _a : 2
    }
  }, React.createElement("div", {
    style: {
      position: 'relative'
    }
  }, valueTransition(function (_ref189, status) {
    var opacity = _ref189.opacity;

    if (status === CommentStatus.Accepted) {
      return React.createElement(PlainNumberedBadge, {
        active: active,
        value: React.createElement(Check, null),
        style: _objectSpread({
          position: 'absolute',
          opacity: opacity,
          backgroundColor: to([r, g, b], function (r, g, b) {
            return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
          }),
          transformStyle: 'preserve-3d'
        }, style)
      });
    }

    if (status === CommentStatus.Rejected) {
      return React.createElement(PlainNumberedBadge, {
        active: active,
        value: React.createElement(Clear, null),
        style: _objectSpread({
          position: 'absolute',
          opacity: opacity,
          backgroundColor: to([r, g, b], function (r, g, b) {
            return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
          }),
          transformStyle: 'preserve-3d'
        }, style)
      });
    }

    return React.createElement(PlainNumberedBadge, {
      active: active,
      value: index + 1,
      style: _objectSpread({
        position: 'absolute',
        opacity: opacity,
        backgroundColor: to([r, g, b], function (r, g, b) {
          return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
        }),
        transformStyle: 'preserve-3d'
      }, style)
    });
  })));
};

var getColorFromStatus = function getColorFromStatus(status, active) {
  if (status === CommentStatus.Rejected) {
    return {
      r: 245,
      g: 13,
      b: 13
    };
  }

  if (status === CommentStatus.Accepted) {
    return {
      r: 13,
      g: 149,
      b: 27
    };
  }

  if (active) {
    return {
      r: 237,
      g: 21,
      b: 78
    };
  }

  return {
    r: 114,
    g: 114,
    b: 114
  };
};

var ThumbnailWithMarkers = function ThumbnailWithMarkers(_ref190) {
  var imgSrc = _ref190.imgSrc,
      imgAlt = _ref190.imgAlt,
      imgRef = _ref190.imgRef,
      style = _ref190.style,
      onClick = _ref190.onClick,
      _ref190$onThumbnailLo = _ref190.onThumbnailLoad,
      onThumbnailLoad = _ref190$onThumbnailLo === void 0 ? function () {} : _ref190$onThumbnailLo,
      children = _ref190.children;
  return React.createElement("div", {
    onClick: onClick,
    style: {
      height: '100%',
      position: 'relative'
    }
  }, React.createElement(ImageLoader, {
    ref: imgRef,
    style: _objectSpread({
      maxHeight: '100%',
      maxWidth: '100%',
      boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)'
    }, style),
    src: imgSrc,
    alt: imgAlt,
    onLoad: onThumbnailLoad
  }), children);
};

var Tooltip = function Tooltip(_ref191) {
  var open = _ref191.open,
      message = _ref191.message,
      style = _ref191.style;
  var transition = useTransition(open, {
    from: {
      opacity: 0
    },
    enter: {
      opacity: 1
    },
    leave: {
      opacity: 0
    },
    config: {
      duration: 300
    }
  });
  return React.createElement("div", {
    style: {
      position: 'absolute',
      zIndex: 2,
      pointerEvents: 'none'
    }
  }, transition(function (_ref192, item) {
    var opacity = _ref192.opacity;
    if (!item) return null;
    return React.createElement(animated.div, {
      style: _objectSpread({
        zIndex: 2,
        opacity: opacity,
        position: 'absolute',
        left: 0,
        bottom: 2,
        pointerEvents: 'none',
        width: '280px',
        display: 'flex'
      }, style)
    }, React.createElement(Paper, {
      style: {
        padding: '0.5em',
        maxWidth: '280px'
      }
    }, message));
  }));
};

var ThumbnailsWithMarkers = function ThumbnailsWithMarkers(_ref193) {
  var thumbnails = _ref193.thumbnails,
      MarkerComponent = _ref193.MarkerComponent,
      TooltipComponent = _ref193.TooltipComponent,
      markerOverlay = _ref193.markerOverlay,
      isPortrait = _ref193.isPortrait;

  var _a, _b, _c, _d;

  var _useContext224 = useContext(DesignContext.Base),
      workflow = _useContext224.workflow;

  var containerRulerRef = useRef(null);
  var containerThumbnailRef = useRef(null);

  var _useContext225 = useContext(DesignContext.Derived),
      mediaType = _useContext225.mediaType;

  var fullWidth = (_b = (_a = containerRulerRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 0;
  var numThumbnails = thumbnails.length;
  var width = fullWidth / numThumbnails - 8;
  var thumbContainerHeight = (_d = (_c = containerThumbnailRef.current) === null || _c === void 0 ? void 0 : _c.clientHeight) !== null && _d !== void 0 ? _d : 0;

  var _useState201 = useState(false),
      _useState202 = _slicedToArray(_useState201, 2),
      imageHasPortrait = _useState202[0],
      setImageHasPortrait = _useState202[1];

  var imgIsPortrait = [];

  var _useState203 = useState(null),
      _useState204 = _slicedToArray(_useState203, 2),
      hoveredCommentId = _useState204[0],
      setHoveredCommentId = _useState204[1];

  var _useState205 = useState(thumbnails.map(function () {
    return {
      w: 0,
      h: 0,
      hasLoaded: false,
      isPortrait: false
    };
  })),
      _useState206 = _slicedToArray(_useState205, 2),
      thumbnailsState = _useState206[0],
      setThumbnailsStateBase = _useState206[1];

  var _useState207 = useState(thumbnails.map(function () {
    return [];
  })),
      _useState208 = _slicedToArray(_useState207, 2),
      scaledCommentsByThumbnail = _useState208[0],
      setScaledCommentsByThumbnail = _useState208[1];

  var setThumbnailsState = function setThumbnailsState(i, newState) {
    setThumbnailsStateBase(function (current) {
      var newStates = _toConsumableArray(current);

      newStates[i] = _objectSpread({}, current[i], newState);
      return newStates;
    });
  };

  var allThumbnailsLoaded = thumbnailsState.reduce(function (acc, cur) {
    return acc && cur.hasLoaded;
  }, true);
  useEffect(function () {
    if (allThumbnailsLoaded) {
      setScaledCommentsByThumbnail(thumbnails.map(function (thumbnail, index) {
        var originalComments = thumbnail.markers;
        var thumbnailState = thumbnailsState[index];
        return getScaledComments(originalComments, {
          containerWidth: width,
          containerHeight: thumbContainerHeight,
          naturalWidth: thumbnailState.w,
          naturalHeight: thumbnailState.h
        });
      }));
    }
  }, [allThumbnailsLoaded, width, thumbContainerHeight, thumbnails, thumbnailsState]);
  return React.createElement(Fragment, null, React.createElement("div", {
    style: {
      width: '100%'
    },
    ref: containerRulerRef
  }), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplate: "1fr / repeat(".concat(thumbnails.length, ", 1fr)"),
      gridColumnGap: '1rem',
      width: '100%',
      height: isPortrait || imageHasPortrait ? numThumbnails > 1 && mediaType !== 'Postcard 4x6' ? '8rem' : '10rem' : 'auto',
      pointerEvents: 'none'
    },
    ref: containerThumbnailRef
  }, thumbnails.map(function (thumbnail, index) {
    return React.createElement("div", {
      key: index,
      style: {
        gridArea: "1 / ".concat(index + 1, " / 2 / ").concat(index + 2),
        width: '100%',
        height: '100%'
      }
    }, React.createElement(Thumbnail$1, {
      imgSrc: thumbnail.src,
      imgAlt: thumbnail.alt,
      orientation: "landscape",
      width: "".concat(width, "px"),
      height: "".concat(thumbContainerHeight, "px"),
      onThumbnailLoad: function onThumbnailLoad(h, w) {
        setThumbnailsState(index, {
          w: w,
          h: h,
          hasLoaded: true,
          isPortrait: h > w
        });
        imgIsPortrait.push(h > w);
        setImageHasPortrait(imgIsPortrait.includes(true));
      }
    }));
  }), markerOverlay ? markerOverlay : thumbnails.map(function (t, index) {
    if (t.markers.length > 0) {
      var state = thumbnailsState[index];
      var scaledComments = scaledCommentsByThumbnail[index];
      var markers = [];
      thumbnails.map(function (t, index) {
        markers = markers.concat(scaledCommentsByThumbnail[index]);
      });
      markers = sortAndFilterComments(markers, workflow);
      var numComments = scaledComments.length;
      var containerStyle = {};
      var markerStyle = {
        position: 'absolute',
        pointerEvents: 'auto'
      };

      if (state.isPortrait) {
        containerStyle = {
          transformOrigin: 'left top',
          transform: "rotate(-90deg) translate(-98%)",
          height: width,
          width: thumbContainerHeight
        };
        markerStyle = _objectSpread({}, markerStyle, {
          transform: 'rotate(90deg)'
        });
        markers = markers.map(function (c) {
          return _objectSpread({}, c, {
            x: c.y,
            y: c.x
          });
        });
      }

      return React.createElement("div", {
        key: "".concat(t.src).concat(index),
        style: {
          gridArea: "1 / ".concat(index + 1, " / 2 / ").concat(index + 2),
          width: width,
          height: thumbContainerHeight,
          position: 'relative',
          zIndex: thumbnails.length - index
        }
      }, React.createElement("div", {
        style: containerStyle
      }, markers.map(function (c, index) {
        if (c !== undefined) {
          if (c.x === null || c.y === null) {
            return null;
          }

          if (c.cardFace !== scaledComments[0].cardFace) {
            return null;
          }

          return React.createElement("div", {
            key: c.id,
            style: _objectSpread({}, markerStyle, {
              zIndex: numComments - index,
              top: state.isPortrait ? "".concat(c.x, "%") : "".concat(c.y, "%"),
              left: state.isPortrait ? "".concat(c.y, "%") : "".concat(c.x, "%")
            }),
            onMouseEnter: function onMouseEnter() {
              setHoveredCommentId(c.id);
            },
            onMouseLeave: function onMouseLeave() {
              setHoveredCommentId(null);
            }
          }, React.createElement(MarkerComponent, {
            active: true,
            value: index + 1,
            style: {
              zIndex: numComments - index,
              position: 'static',
              cursor: 'pointer'
            }
          }));
        } else {
          return null;
        }
      })));
    }
  }), TooltipComponent ? thumbnails.map(function (t, index) {
    var state = thumbnailsState[index];
    var scaledComments = scaledCommentsByThumbnail[index];
    var markers = [];
    thumbnails.map(function (t, index) {
      markers = markers.concat(scaledCommentsByThumbnail[index]);
    });
    var containerStyle = {
      pointerEvents: 'none'
    };
    var markerStyle = {
      position: 'absolute',
      pointerEvents: 'none'
    };

    if (state.isPortrait) {
      containerStyle = _objectSpread({}, containerStyle, {
        height: state.isPortrait ? width : thumbContainerHeight,
        width: state.isPortrait ? thumbContainerHeight : width,
        transformOrigin: 'left top',
        transform: "rotate(-90deg) translateX(-".concat(thumbContainerHeight, "px)")
      });
      markerStyle = _objectSpread({}, markerStyle, {
        transform: 'rotate(90deg)'
      });
    }

    return React.createElement("div", {
      key: "".concat(t.src).concat(index),
      style: {
        gridArea: "1 / ".concat(index + 1, " / 2 / ").concat(index + 2),
        width: '100%',
        height: '100%',
        position: 'relative',
        pointerEvents: 'none',
        zIndex: thumbnails.length - index
      }
    }, React.createElement("div", {
      style: containerStyle
    }, scaledComments.map(function (c, index) {
      if (c.x === null || c.y === null) {
        return null;
      }

      var coords = state.isPortrait ? {
        top: "".concat(c.x, "%"),
        left: "".concat(c.y + 30, "%")
      } : {
        top: "".concat(c.y, "%"),
        left: "".concat(c.x, "%")
      };
      return React.createElement("div", {
        key: c.id,
        style: _objectSpread({}, markerStyle, coords)
      }, React.createElement(TooltipComponent, {
        open: c.id === hoveredCommentId,
        message: c.messages[c.messages.length - 1].message,
        style: {
          pointerEvents: 'none'
        }
      }));
    })));
  }) : null));
};

var getScaledComments = function getScaledComments(originalComments, args) {
  var isPortrait = args.naturalHeight > args.naturalWidth;

  if (isPortrait) {
    return originalComments.map(function (c) {
      if (c.x === null || c.y === null) {
        return c;
      }

      return _objectSpread({}, c, {
        x: c.x - 9,
        y: c.y - 15
      });
    });
  }

  return originalComments.map(function (c) {
    if (c.x === null || c.y === null) {
      return c;
    }

    return _objectSpread({}, c, {
      x: c.x - 9,
      y: c.y - 15
    });
  });
};

var LoadingLabel = function LoadingLabel(_ref194) {
  var label = _ref194.label,
      style = _ref194.style;
  return React.createElement("div", {
    style: _objectSpread({
      position: 'absolute',
      width: '30px',
      height: '30px',
      display: 'grid'
    }, style)
  }, React.createElement(CircularProgress, {
    style: _objectSpread({
      color: 'white',
      width: '30px',
      height: '30px',
      gridArea: '1 / 1 / 2 / 2'
    }, style)
  }), React.createElement("div", {
    style: _objectSpread({
      width: '30px',
      height: '30px',
      gridArea: '1 / 1 / 2 / 2',
      display: 'grid',
      placeContent: 'center'
    }, style)
  }, label));
};

var carrierRoute01 = {
  carrierRoute: '45638C015',
  paths: [[[{
    lng: -82.6311,
    lat: 38.5205
  }, {
    lng: -82.6312,
    lat: 38.5206
  }, {
    lng: -82.6311,
    lat: 38.5209
  }, {
    lng: -82.6311,
    lat: 38.5209
  }, {
    lng: -82.6311,
    lat: 38.521
  }, {
    lng: -82.6311,
    lat: 38.5211
  }, {
    lng: -82.6311,
    lat: 38.5211
  }, {
    lng: -82.6311,
    lat: 38.5212
  }, {
    lng: -82.6311,
    lat: 38.5213
  }, {
    lng: -82.6311,
    lat: 38.5214
  }, {
    lng: -82.6311,
    lat: 38.5215
  }, {
    lng: -82.6312,
    lat: 38.5215
  }, {
    lng: -82.6312,
    lat: 38.5216
  }, {
    lng: -82.6312,
    lat: 38.5216
  }, {
    lng: -82.6313,
    lat: 38.5217
  }, {
    lng: -82.6313,
    lat: 38.5217
  }, {
    lng: -82.6313,
    lat: 38.5218
  }, {
    lng: -82.6314,
    lat: 38.5218
  }, {
    lng: -82.6314,
    lat: 38.5218
  }, {
    lng: -82.6315,
    lat: 38.5219
  }, {
    lng: -82.6315,
    lat: 38.5219
  }, {
    lng: -82.6315,
    lat: 38.5219
  }, {
    lng: -82.6315,
    lat: 38.5219
  }, {
    lng: -82.6316,
    lat: 38.522
  }, {
    lng: -82.6316,
    lat: 38.5221
  }, {
    lng: -82.6317,
    lat: 38.5222
  }, {
    lng: -82.6317,
    lat: 38.5222
  }, {
    lng: -82.6317,
    lat: 38.5223
  }, {
    lng: -82.6318,
    lat: 38.5224
  }, {
    lng: -82.6318,
    lat: 38.5225
  }, {
    lng: -82.6318,
    lat: 38.5226
  }, {
    lng: -82.6318,
    lat: 38.5226
  }, {
    lng: -82.6318,
    lat: 38.5226
  }, {
    lng: -82.6318,
    lat: 38.5227
  }, {
    lng: -82.6318,
    lat: 38.5228
  }, {
    lng: -82.6317,
    lat: 38.523
  }, {
    lng: -82.6317,
    lat: 38.5231
  }, {
    lng: -82.6317,
    lat: 38.5232
  }, {
    lng: -82.6317,
    lat: 38.5232
  }, {
    lng: -82.6317,
    lat: 38.5233
  }, {
    lng: -82.6316,
    lat: 38.5234
  }, {
    lng: -82.6317,
    lat: 38.5234
  }, {
    lng: -82.6317,
    lat: 38.5235
  }, {
    lng: -82.6317,
    lat: 38.5235
  }, {
    lng: -82.6317,
    lat: 38.5236
  }, {
    lng: -82.6317,
    lat: 38.5236
  }, {
    lng: -82.6317,
    lat: 38.5238
  }, {
    lng: -82.6318,
    lat: 38.524
  }, {
    lng: -82.6318,
    lat: 38.524
  }, {
    lng: -82.6318,
    lat: 38.5241
  }, {
    lng: -82.6318,
    lat: 38.5241
  }, {
    lng: -82.6318,
    lat: 38.5243
  }, {
    lng: -82.6318,
    lat: 38.5246
  }, {
    lng: -82.6317,
    lat: 38.5248
  }, {
    lng: -82.6317,
    lat: 38.525
  }, {
    lng: -82.6317,
    lat: 38.5251
  }, {
    lng: -82.6317,
    lat: 38.5251
  }, {
    lng: -82.6317,
    lat: 38.5252
  }, {
    lng: -82.6317,
    lat: 38.5253
  }, {
    lng: -82.6317,
    lat: 38.5254
  }, {
    lng: -82.6317,
    lat: 38.5255
  }, {
    lng: -82.6317,
    lat: 38.5256
  }, {
    lng: -82.6317,
    lat: 38.5257
  }, {
    lng: -82.6317,
    lat: 38.5258
  }, {
    lng: -82.6317,
    lat: 38.5259
  }, {
    lng: -82.6317,
    lat: 38.526
  }, {
    lng: -82.6317,
    lat: 38.5261
  }, {
    lng: -82.6317,
    lat: 38.5262
  }, {
    lng: -82.6316,
    lat: 38.5264
  }, {
    lng: -82.6316,
    lat: 38.5267
  }, {
    lng: -82.6316,
    lat: 38.5268
  }, {
    lng: -82.6316,
    lat: 38.527
  }, {
    lng: -82.6316,
    lat: 38.5271
  }, {
    lng: -82.6316,
    lat: 38.5272
  }, {
    lng: -82.6316,
    lat: 38.5274
  }, {
    lng: -82.6316,
    lat: 38.5275
  }, {
    lng: -82.6316,
    lat: 38.5276
  }, {
    lng: -82.6316,
    lat: 38.5277
  }, {
    lng: -82.6316,
    lat: 38.5278
  }, {
    lng: -82.6315,
    lat: 38.5282
  }, {
    lng: -82.6314,
    lat: 38.5284
  }, {
    lng: -82.6314,
    lat: 38.5286
  }, {
    lng: -82.6313,
    lat: 38.5288
  }, {
    lng: -82.6313,
    lat: 38.5289
  }, {
    lng: -82.6312,
    lat: 38.5291
  }, {
    lng: -82.6312,
    lat: 38.5292
  }, {
    lng: -82.6312,
    lat: 38.5294
  }, {
    lng: -82.6312,
    lat: 38.5295
  }, {
    lng: -82.6312,
    lat: 38.5296
  }, {
    lng: -82.6312,
    lat: 38.5297
  }, {
    lng: -82.6312,
    lat: 38.5298
  }, {
    lng: -82.6312,
    lat: 38.5298
  }, {
    lng: -82.6312,
    lat: 38.5299
  }, {
    lng: -82.6312,
    lat: 38.53
  }, {
    lng: -82.6313,
    lat: 38.5301
  }, {
    lng: -82.6313,
    lat: 38.5303
  }, {
    lng: -82.6314,
    lat: 38.5304
  }, {
    lng: -82.6314,
    lat: 38.5304
  }, {
    lng: -82.6314,
    lat: 38.5305
  }, {
    lng: -82.6315,
    lat: 38.5305
  }, {
    lng: -82.6315,
    lat: 38.5306
  }, {
    lng: -82.6316,
    lat: 38.5306
  }, {
    lng: -82.6316,
    lat: 38.5307
  }, {
    lng: -82.6317,
    lat: 38.5307
  }, {
    lng: -82.6318,
    lat: 38.5308
  }, {
    lng: -82.6321,
    lat: 38.5309
  }, {
    lng: -82.6322,
    lat: 38.531
  }, {
    lng: -82.6324,
    lat: 38.5311
  }, {
    lng: -82.6324,
    lat: 38.5312
  }, {
    lng: -82.6326,
    lat: 38.5313
  }, {
    lng: -82.6327,
    lat: 38.5313
  }, {
    lng: -82.6328,
    lat: 38.5314
  }, {
    lng: -82.6328,
    lat: 38.5314
  }, {
    lng: -82.6329,
    lat: 38.5315
  }, {
    lng: -82.6331,
    lat: 38.5317
  }, {
    lng: -82.6331,
    lat: 38.5318
  }, {
    lng: -82.6332,
    lat: 38.5318
  }, {
    lng: -82.6333,
    lat: 38.5319
  }, {
    lng: -82.6334,
    lat: 38.5321
  }, {
    lng: -82.6335,
    lat: 38.5323
  }, {
    lng: -82.6336,
    lat: 38.5323
  }, {
    lng: -82.6336,
    lat: 38.5324
  }, {
    lng: -82.6336,
    lat: 38.5324
  }, {
    lng: -82.6336,
    lat: 38.5325
  }, {
    lng: -82.6337,
    lat: 38.5326
  }, {
    lng: -82.6339,
    lat: 38.5329
  }, {
    lng: -82.6339,
    lat: 38.533
  }, {
    lng: -82.6339,
    lat: 38.533
  }, {
    lng: -82.634,
    lat: 38.5331
  }, {
    lng: -82.634,
    lat: 38.5331
  }, {
    lng: -82.634,
    lat: 38.5332
  }, {
    lng: -82.6341,
    lat: 38.5332
  }, {
    lng: -82.6342,
    lat: 38.5333
  }, {
    lng: -82.6342,
    lat: 38.5334
  }, {
    lng: -82.6343,
    lat: 38.5334
  }, {
    lng: -82.6343,
    lat: 38.5335
  }, {
    lng: -82.6343,
    lat: 38.5335
  }, {
    lng: -82.6344,
    lat: 38.5335
  }, {
    lng: -82.6345,
    lat: 38.5337
  }, {
    lng: -82.6345,
    lat: 38.5338
  }, {
    lng: -82.6346,
    lat: 38.5339
  }, {
    lng: -82.6347,
    lat: 38.5341
  }, {
    lng: -82.6347,
    lat: 38.5342
  }, {
    lng: -82.6348,
    lat: 38.5344
  }, {
    lng: -82.6349,
    lat: 38.5345
  }, {
    lng: -82.6349,
    lat: 38.5346
  }, {
    lng: -82.635,
    lat: 38.5347
  }, {
    lng: -82.635,
    lat: 38.5348
  }, {
    lng: -82.635,
    lat: 38.535
  }, {
    lng: -82.6351,
    lat: 38.5353
  }, {
    lng: -82.6352,
    lat: 38.5355
  }, {
    lng: -82.6353,
    lat: 38.5359
  }, {
    lng: -82.6354,
    lat: 38.5362
  }, {
    lng: -82.6354,
    lat: 38.5363
  }, {
    lng: -82.6355,
    lat: 38.5364
  }, {
    lng: -82.6355,
    lat: 38.5365
  }, {
    lng: -82.6355,
    lat: 38.5366
  }, {
    lng: -82.6356,
    lat: 38.5367
  }, {
    lng: -82.6356,
    lat: 38.5368
  }, {
    lng: -82.6356,
    lat: 38.5369
  }, {
    lng: -82.6356,
    lat: 38.537
  }, {
    lng: -82.6356,
    lat: 38.5371
  }, {
    lng: -82.6357,
    lat: 38.5374
  }, {
    lng: -82.6357,
    lat: 38.5375
  }, {
    lng: -82.6357,
    lat: 38.5375
  }, {
    lng: -82.6357,
    lat: 38.5376
  }, {
    lng: -82.6359,
    lat: 38.5378
  }, {
    lng: -82.636,
    lat: 38.538
  }, {
    lng: -82.6361,
    lat: 38.5381
  }, {
    lng: -82.6361,
    lat: 38.5382
  }, {
    lng: -82.6362,
    lat: 38.5384
  }, {
    lng: -82.6364,
    lat: 38.5387
  }, {
    lng: -82.6364,
    lat: 38.5389
  }, {
    lng: -82.6365,
    lat: 38.539
  }, {
    lng: -82.6365,
    lat: 38.5391
  }, {
    lng: -82.6367,
    lat: 38.5392
  }, {
    lng: -82.6367,
    lat: 38.5393
  }, {
    lng: -82.6368,
    lat: 38.5394
  }, {
    lng: -82.6369,
    lat: 38.5397
  }, {
    lng: -82.6371,
    lat: 38.54
  }, {
    lng: -82.6373,
    lat: 38.5404
  }, {
    lng: -82.6373,
    lat: 38.5405
  }, {
    lng: -82.6374,
    lat: 38.5406
  }, {
    lng: -82.6374,
    lat: 38.5406
  }, {
    lng: -82.6374,
    lat: 38.5407
  }, {
    lng: -82.6375,
    lat: 38.5408
  }, {
    lng: -82.6375,
    lat: 38.5409
  }, {
    lng: -82.6375,
    lat: 38.5409
  }, {
    lng: -82.6375,
    lat: 38.5411
  }, {
    lng: -82.6375,
    lat: 38.5412
  }, {
    lng: -82.6376,
    lat: 38.5415
  }, {
    lng: -82.6376,
    lat: 38.5417
  }, {
    lng: -82.6376,
    lat: 38.5418
  }, {
    lng: -82.6376,
    lat: 38.5419
  }, {
    lng: -82.6376,
    lat: 38.5419
  }, {
    lng: -82.6375,
    lat: 38.542
  }, {
    lng: -82.6375,
    lat: 38.5422
  }, {
    lng: -82.6375,
    lat: 38.5423
  }, {
    lng: -82.6375,
    lat: 38.5425
  }, {
    lng: -82.6374,
    lat: 38.5426
  }, {
    lng: -82.6374,
    lat: 38.5426
  }, {
    lng: -82.6374,
    lat: 38.5428
  }, {
    lng: -82.6374,
    lat: 38.5429
  }, {
    lng: -82.6374,
    lat: 38.543
  }, {
    lng: -82.6374,
    lat: 38.543
  }, {
    lng: -82.6374,
    lat: 38.543
  }, {
    lng: -82.6373,
    lat: 38.5433
  }, {
    lng: -82.6372,
    lat: 38.5435
  }, {
    lng: -82.6372,
    lat: 38.5437
  }, {
    lng: -82.6371,
    lat: 38.5439
  }, {
    lng: -82.6371,
    lat: 38.5442
  }, {
    lng: -82.637,
    lat: 38.5443
  }, {
    lng: -82.637,
    lat: 38.5445
  }, {
    lng: -82.637,
    lat: 38.5446
  }, {
    lng: -82.6369,
    lat: 38.5447
  }, {
    lng: -82.6369,
    lat: 38.5449
  }, {
    lng: -82.6369,
    lat: 38.545
  }, {
    lng: -82.6369,
    lat: 38.5452
  }, {
    lng: -82.6368,
    lat: 38.5453
  }, {
    lng: -82.6368,
    lat: 38.5455
  }, {
    lng: -82.6368,
    lat: 38.5456
  }, {
    lng: -82.6368,
    lat: 38.5458
  }, {
    lng: -82.6368,
    lat: 38.5459
  }, {
    lng: -82.6368,
    lat: 38.546
  }, {
    lng: -82.6368,
    lat: 38.5461
  }, {
    lng: -82.6369,
    lat: 38.5462
  }, {
    lng: -82.6369,
    lat: 38.5462
  }, {
    lng: -82.637,
    lat: 38.5463
  }, {
    lng: -82.6371,
    lat: 38.5464
  }, {
    lng: -82.6372,
    lat: 38.5465
  }, {
    lng: -82.6373,
    lat: 38.5466
  }, {
    lng: -82.6376,
    lat: 38.5468
  }, {
    lng: -82.6378,
    lat: 38.547
  }, {
    lng: -82.6378,
    lat: 38.547
  }, {
    lng: -82.6379,
    lat: 38.5471
  }, {
    lng: -82.638,
    lat: 38.5472
  }, {
    lng: -82.6381,
    lat: 38.5472
  }, {
    lng: -82.6381,
    lat: 38.5473
  }, {
    lng: -82.6382,
    lat: 38.5474
  }, {
    lng: -82.6383,
    lat: 38.5474
  }, {
    lng: -82.6383,
    lat: 38.5474
  }, {
    lng: -82.6384,
    lat: 38.5475
  }, {
    lng: -82.6384,
    lat: 38.5475
  }, {
    lng: -82.6386,
    lat: 38.5476
  }, {
    lng: -82.6387,
    lat: 38.5477
  }, {
    lng: -82.6387,
    lat: 38.5477
  }, {
    lng: -82.6388,
    lat: 38.5478
  }, {
    lng: -82.6389,
    lat: 38.5479
  }, {
    lng: -82.6389,
    lat: 38.548
  }, {
    lng: -82.639,
    lat: 38.548
  }, {
    lng: -82.6391,
    lat: 38.5482
  }, {
    lng: -82.6392,
    lat: 38.5484
  }, {
    lng: -82.6393,
    lat: 38.5486
  }, {
    lng: -82.6393,
    lat: 38.5487
  }, {
    lng: -82.6394,
    lat: 38.5488
  }, {
    lng: -82.6394,
    lat: 38.5488
  }, {
    lng: -82.6395,
    lat: 38.5492
  }, {
    lng: -82.6398,
    lat: 38.5492
  }, {
    lng: -82.6401,
    lat: 38.5491
  }, {
    lng: -82.6402,
    lat: 38.5491
  }, {
    lng: -82.6403,
    lat: 38.549
  }, {
    lng: -82.6405,
    lat: 38.549
  }, {
    lng: -82.6406,
    lat: 38.5489
  }, {
    lng: -82.6409,
    lat: 38.5487
  }, {
    lng: -82.641,
    lat: 38.5487
  }, {
    lng: -82.6411,
    lat: 38.5486
  }, {
    lng: -82.6412,
    lat: 38.5486
  }, {
    lng: -82.6413,
    lat: 38.5485
  }, {
    lng: -82.6415,
    lat: 38.5484
  }, {
    lng: -82.6416,
    lat: 38.5484
  }, {
    lng: -82.6417,
    lat: 38.5484
  }, {
    lng: -82.6417,
    lat: 38.5484
  }, {
    lng: -82.642,
    lat: 38.5483
  }, {
    lng: -82.642,
    lat: 38.5483
  }, {
    lng: -82.6421,
    lat: 38.5483
  }, {
    lng: -82.6423,
    lat: 38.5483
  }, {
    lng: -82.6424,
    lat: 38.5483
  }, {
    lng: -82.6425,
    lat: 38.5483
  }, {
    lng: -82.6426,
    lat: 38.5483
  }, {
    lng: -82.6427,
    lat: 38.5483
  }, {
    lng: -82.6428,
    lat: 38.5484
  }, {
    lng: -82.6428,
    lat: 38.5486
  }, {
    lng: -82.6429,
    lat: 38.5487
  }, {
    lng: -82.6431,
    lat: 38.5489
  }, {
    lng: -82.6432,
    lat: 38.549
  }, {
    lng: -82.6433,
    lat: 38.5491
  }, {
    lng: -82.6434,
    lat: 38.5491
  }, {
    lng: -82.6435,
    lat: 38.5492
  }, {
    lng: -82.6435,
    lat: 38.5493
  }, {
    lng: -82.6436,
    lat: 38.5493
  }, {
    lng: -82.6437,
    lat: 38.5493
  }, {
    lng: -82.6438,
    lat: 38.5494
  }, {
    lng: -82.644,
    lat: 38.5495
  }, {
    lng: -82.6441,
    lat: 38.5495
  }, {
    lng: -82.6442,
    lat: 38.5495
  }, {
    lng: -82.6445,
    lat: 38.5496
  }, {
    lng: -82.6448,
    lat: 38.5497
  }, {
    lng: -82.6451,
    lat: 38.5498
  }, {
    lng: -82.6453,
    lat: 38.55
  }, {
    lng: -82.6456,
    lat: 38.5501
  }, {
    lng: -82.6459,
    lat: 38.5502
  }, {
    lng: -82.6462,
    lat: 38.5504
  }, {
    lng: -82.6465,
    lat: 38.5506
  }, {
    lng: -82.6467,
    lat: 38.5507
  }, {
    lng: -82.6469,
    lat: 38.5508
  }, {
    lng: -82.647,
    lat: 38.5508
  }, {
    lng: -82.6472,
    lat: 38.5509
  }, {
    lng: -82.6472,
    lat: 38.5509
  }, {
    lng: -82.6472,
    lat: 38.5509
  }, {
    lng: -82.6473,
    lat: 38.5509
  }, {
    lng: -82.6476,
    lat: 38.5509
  }, {
    lng: -82.648,
    lat: 38.5509
  }, {
    lng: -82.6482,
    lat: 38.551
  }, {
    lng: -82.6483,
    lat: 38.551
  }, {
    lng: -82.6485,
    lat: 38.551
  }, {
    lng: -82.6486,
    lat: 38.5511
  }, {
    lng: -82.6487,
    lat: 38.5511
  }, {
    lng: -82.6488,
    lat: 38.5511
  }, {
    lng: -82.6489,
    lat: 38.5512
  }, {
    lng: -82.6491,
    lat: 38.5514
  }, {
    lng: -82.6492,
    lat: 38.5515
  }, {
    lng: -82.6493,
    lat: 38.5516
  }, {
    lng: -82.6496,
    lat: 38.5515
  }, {
    lng: -82.6501,
    lat: 38.5514
  }, {
    lng: -82.6506,
    lat: 38.5513
  }, {
    lng: -82.6513,
    lat: 38.5512
  }, {
    lng: -82.6517,
    lat: 38.5511
  }, {
    lng: -82.6522,
    lat: 38.551
  }, {
    lng: -82.6526,
    lat: 38.551
  }, {
    lng: -82.6526,
    lat: 38.551
  }, {
    lng: -82.6527,
    lat: 38.551
  }, {
    lng: -82.6528,
    lat: 38.5509
  }, {
    lng: -82.653,
    lat: 38.5509
  }, {
    lng: -82.6533,
    lat: 38.5508
  }, {
    lng: -82.6537,
    lat: 38.5507
  }, {
    lng: -82.6539,
    lat: 38.5506
  }, {
    lng: -82.6542,
    lat: 38.5505
  }, {
    lng: -82.6543,
    lat: 38.5504
  }, {
    lng: -82.6545,
    lat: 38.5503
  }, {
    lng: -82.6547,
    lat: 38.5502
  }, {
    lng: -82.6548,
    lat: 38.5501
  }, {
    lng: -82.655,
    lat: 38.55
  }, {
    lng: -82.6552,
    lat: 38.5498
  }, {
    lng: -82.6553,
    lat: 38.5497
  }, {
    lng: -82.6555,
    lat: 38.5496
  }, {
    lng: -82.6556,
    lat: 38.5495
  }, {
    lng: -82.6558,
    lat: 38.5493
  }, {
    lng: -82.6559,
    lat: 38.5492
  }, {
    lng: -82.6566,
    lat: 38.5487
  }, {
    lng: -82.657,
    lat: 38.5483
  }, {
    lng: -82.6575,
    lat: 38.548
  }, {
    lng: -82.6576,
    lat: 38.5479
  }, {
    lng: -82.658,
    lat: 38.5476
  }, {
    lng: -82.6584,
    lat: 38.5473
  }, {
    lng: -82.6585,
    lat: 38.5472
  }, {
    lng: -82.6588,
    lat: 38.5471
  }, {
    lng: -82.659,
    lat: 38.547
  }, {
    lng: -82.6591,
    lat: 38.5469
  }, {
    lng: -82.6592,
    lat: 38.5468
  }, {
    lng: -82.6594,
    lat: 38.5467
  }, {
    lng: -82.6597,
    lat: 38.5466
  }, {
    lng: -82.6599,
    lat: 38.5466
  }, {
    lng: -82.66,
    lat: 38.5465
  }, {
    lng: -82.6603,
    lat: 38.5464
  }, {
    lng: -82.6609,
    lat: 38.5463
  }, {
    lng: -82.661,
    lat: 38.5462
  }, {
    lng: -82.6614,
    lat: 38.5462
  }, {
    lng: -82.6617,
    lat: 38.5461
  }, {
    lng: -82.6635,
    lat: 38.5458
  }, {
    lng: -82.6641,
    lat: 38.5457
  }, {
    lng: -82.6647,
    lat: 38.5455
  }, {
    lng: -82.6654,
    lat: 38.5453
  }, {
    lng: -82.6661,
    lat: 38.5451
  }, {
    lng: -82.6668,
    lat: 38.5449
  }, {
    lng: -82.667,
    lat: 38.5448
  }, {
    lng: -82.6677,
    lat: 38.5446
  }, {
    lng: -82.6678,
    lat: 38.5445
  }, {
    lng: -82.6686,
    lat: 38.5442
  }, {
    lng: -82.6691,
    lat: 38.544
  }, {
    lng: -82.6695,
    lat: 38.5438
  }, {
    lng: -82.6701,
    lat: 38.5435
  }, {
    lng: -82.6708,
    lat: 38.5431
  }, {
    lng: -82.6712,
    lat: 38.5428
  }, {
    lng: -82.6715,
    lat: 38.5426
  }, {
    lng: -82.672,
    lat: 38.5433
  }, {
    lng: -82.6721,
    lat: 38.5435
  }, {
    lng: -82.6723,
    lat: 38.5436
  }, {
    lng: -82.6723,
    lat: 38.5436
  }, {
    lng: -82.6724,
    lat: 38.5436
  }, {
    lng: -82.6725,
    lat: 38.5437
  }, {
    lng: -82.6726,
    lat: 38.5437
  }, {
    lng: -82.6727,
    lat: 38.5438
  }, {
    lng: -82.6728,
    lat: 38.5439
  }, {
    lng: -82.6728,
    lat: 38.5439
  }, {
    lng: -82.673,
    lat: 38.544
  }, {
    lng: -82.6731,
    lat: 38.5441
  }, {
    lng: -82.6731,
    lat: 38.5441
  }, {
    lng: -82.6732,
    lat: 38.5442
  }, {
    lng: -82.6733,
    lat: 38.5443
  }, {
    lng: -82.6733,
    lat: 38.5444
  }, {
    lng: -82.6733,
    lat: 38.5446
  }, {
    lng: -82.6733,
    lat: 38.5447
  }, {
    lng: -82.6733,
    lat: 38.5447
  }, {
    lng: -82.6733,
    lat: 38.5448
  }, {
    lng: -82.6732,
    lat: 38.5449
  }, {
    lng: -82.6731,
    lat: 38.5451
  }, {
    lng: -82.6731,
    lat: 38.5453
  }, {
    lng: -82.6732,
    lat: 38.5453
  }, {
    lng: -82.6732,
    lat: 38.5453
  }, {
    lng: -82.6733,
    lat: 38.5454
  }, {
    lng: -82.6734,
    lat: 38.5454
  }, {
    lng: -82.6736,
    lat: 38.5454
  }, {
    lng: -82.6737,
    lat: 38.5454
  }, {
    lng: -82.6738,
    lat: 38.5455
  }, {
    lng: -82.6741,
    lat: 38.5455
  }, {
    lng: -82.6741,
    lat: 38.5456
  }, {
    lng: -82.674,
    lat: 38.5456
  }, {
    lng: -82.6738,
    lat: 38.5457
  }, {
    lng: -82.6736,
    lat: 38.5457
  }, {
    lng: -82.6735,
    lat: 38.5457
  }, {
    lng: -82.6734,
    lat: 38.5457
  }, {
    lng: -82.6734,
    lat: 38.5458
  }, {
    lng: -82.6734,
    lat: 38.5459
  }, {
    lng: -82.6735,
    lat: 38.546
  }, {
    lng: -82.6737,
    lat: 38.5461
  }, {
    lng: -82.6739,
    lat: 38.5462
  }, {
    lng: -82.674,
    lat: 38.5463
  }, {
    lng: -82.6741,
    lat: 38.5464
  }, {
    lng: -82.6742,
    lat: 38.5465
  }, {
    lng: -82.6741,
    lat: 38.5467
  }, {
    lng: -82.6741,
    lat: 38.5468
  }, {
    lng: -82.674,
    lat: 38.5469
  }, {
    lng: -82.6739,
    lat: 38.547
  }, {
    lng: -82.6738,
    lat: 38.5472
  }, {
    lng: -82.6742,
    lat: 38.5469
  }, {
    lng: -82.6741,
    lat: 38.547
  }, {
    lng: -82.6741,
    lat: 38.5472
  }, {
    lng: -82.6741,
    lat: 38.5472
  }, {
    lng: -82.6741,
    lat: 38.5473
  }, {
    lng: -82.6742,
    lat: 38.5473
  }, {
    lng: -82.6742,
    lat: 38.5472
  }, {
    lng: -82.6743,
    lat: 38.5471
  }, {
    lng: -82.6745,
    lat: 38.5469
  }, {
    lng: -82.6747,
    lat: 38.5466
  }, {
    lng: -82.6751,
    lat: 38.5463
  }, {
    lng: -82.6754,
    lat: 38.5461
  }, {
    lng: -82.6756,
    lat: 38.5459
  }, {
    lng: -82.6759,
    lat: 38.5458
  }, {
    lng: -82.6762,
    lat: 38.5456
  }, {
    lng: -82.6764,
    lat: 38.5456
  }, {
    lng: -82.6766,
    lat: 38.5456
  }, {
    lng: -82.6766,
    lat: 38.5456
  }, {
    lng: -82.6767,
    lat: 38.5455
  }, {
    lng: -82.6767,
    lat: 38.5455
  }, {
    lng: -82.6768,
    lat: 38.5455
  }, {
    lng: -82.6769,
    lat: 38.5454
  }, {
    lng: -82.6769,
    lat: 38.5454
  }, {
    lng: -82.677,
    lat: 38.5453
  }, {
    lng: -82.6771,
    lat: 38.5453
  }, {
    lng: -82.6772,
    lat: 38.5451
  }, {
    lng: -82.6773,
    lat: 38.5451
  }, {
    lng: -82.6773,
    lat: 38.545
  }, {
    lng: -82.6774,
    lat: 38.5449
  }, {
    lng: -82.6774,
    lat: 38.5449
  }, {
    lng: -82.6775,
    lat: 38.5448
  }, {
    lng: -82.6775,
    lat: 38.5447
  }, {
    lng: -82.6776,
    lat: 38.5446
  }, {
    lng: -82.6776,
    lat: 38.5445
  }, {
    lng: -82.6779,
    lat: 38.544
  }, {
    lng: -82.678,
    lat: 38.5438
  }, {
    lng: -82.6781,
    lat: 38.5436
  }, {
    lng: -82.6783,
    lat: 38.5433
  }, {
    lng: -82.6785,
    lat: 38.543
  }, {
    lng: -82.6786,
    lat: 38.5428
  }, {
    lng: -82.6786,
    lat: 38.5428
  }, {
    lng: -82.6787,
    lat: 38.5427
  }, {
    lng: -82.6787,
    lat: 38.5426
  }, {
    lng: -82.6788,
    lat: 38.5426
  }, {
    lng: -82.6788,
    lat: 38.5425
  }, {
    lng: -82.6788,
    lat: 38.5424
  }, {
    lng: -82.6789,
    lat: 38.5423
  }, {
    lng: -82.6789,
    lat: 38.5422
  }, {
    lng: -82.679,
    lat: 38.5421
  }, {
    lng: -82.6791,
    lat: 38.5419
  }, {
    lng: -82.6792,
    lat: 38.5418
  }, {
    lng: -82.6792,
    lat: 38.5417
  }, {
    lng: -82.6793,
    lat: 38.5416
  }, {
    lng: -82.6794,
    lat: 38.5414
  }, {
    lng: -82.6796,
    lat: 38.5411
  }, {
    lng: -82.6795,
    lat: 38.5411
  }, {
    lng: -82.6795,
    lat: 38.541
  }, {
    lng: -82.6797,
    lat: 38.541
  }, {
    lng: -82.6795,
    lat: 38.5408
  }, {
    lng: -82.6789,
    lat: 38.5403
  }, {
    lng: -82.6789,
    lat: 38.5402
  }, {
    lng: -82.6787,
    lat: 38.5401
  }, {
    lng: -82.6787,
    lat: 38.54
  }, {
    lng: -82.6783,
    lat: 38.5397
  }, {
    lng: -82.6776,
    lat: 38.5391
  }, {
    lng: -82.6772,
    lat: 38.5388
  }, {
    lng: -82.6771,
    lat: 38.5387
  }, {
    lng: -82.6769,
    lat: 38.5385
  }, {
    lng: -82.6765,
    lat: 38.5381
  }, {
    lng: -82.6762,
    lat: 38.5379
  }, {
    lng: -82.6758,
    lat: 38.5374
  }, {
    lng: -82.6755,
    lat: 38.5372
  }, {
    lng: -82.6753,
    lat: 38.5369
  }, {
    lng: -82.675,
    lat: 38.5366
  }, {
    lng: -82.6748,
    lat: 38.5364
  }, {
    lng: -82.6747,
    lat: 38.5363
  }, {
    lng: -82.6746,
    lat: 38.5362
  }, {
    lng: -82.6746,
    lat: 38.5361
  }, {
    lng: -82.6745,
    lat: 38.536
  }, {
    lng: -82.6744,
    lat: 38.5358
  }, {
    lng: -82.6743,
    lat: 38.5358
  }, {
    lng: -82.674,
    lat: 38.5354
  }, {
    lng: -82.6739,
    lat: 38.5353
  }, {
    lng: -82.6735,
    lat: 38.5348
  }, {
    lng: -82.674,
    lat: 38.5347
  }, {
    lng: -82.6743,
    lat: 38.5345
  }, {
    lng: -82.6745,
    lat: 38.5344
  }, {
    lng: -82.6732,
    lat: 38.5327
  }, {
    lng: -82.6725,
    lat: 38.5319
  }, {
    lng: -82.673,
    lat: 38.5317
  }, {
    lng: -82.6735,
    lat: 38.5314
  }, {
    lng: -82.6728,
    lat: 38.5305
  }, {
    lng: -82.6721,
    lat: 38.5297
  }, {
    lng: -82.6715,
    lat: 38.5289
  }, {
    lng: -82.6709,
    lat: 38.5281
  }, {
    lng: -82.6702,
    lat: 38.5273
  }, {
    lng: -82.6697,
    lat: 38.5276
  }, {
    lng: -82.6692,
    lat: 38.5278
  }, {
    lng: -82.6687,
    lat: 38.5281
  }, {
    lng: -82.6682,
    lat: 38.5284
  }, {
    lng: -82.6675,
    lat: 38.5275
  }, {
    lng: -82.6673,
    lat: 38.5274
  }, {
    lng: -82.6672,
    lat: 38.5271
  }, {
    lng: -82.667,
    lat: 38.527
  }, {
    lng: -82.6669,
    lat: 38.5268
  }, {
    lng: -82.6668,
    lat: 38.5267
  }, {
    lng: -82.6666,
    lat: 38.5266
  }, {
    lng: -82.6665,
    lat: 38.5265
  }, {
    lng: -82.6662,
    lat: 38.5261
  }, {
    lng: -82.6658,
    lat: 38.5258
  }, {
    lng: -82.6657,
    lat: 38.5257
  }, {
    lng: -82.6656,
    lat: 38.5256
  }, {
    lng: -82.6654,
    lat: 38.5254
  }, {
    lng: -82.6653,
    lat: 38.5255
  }, {
    lng: -82.6652,
    lat: 38.5255
  }, {
    lng: -82.6649,
    lat: 38.5257
  }, {
    lng: -82.6634,
    lat: 38.5245
  }, {
    lng: -82.6626,
    lat: 38.5238
  }, {
    lng: -82.6622,
    lat: 38.5235
  }, {
    lng: -82.6618,
    lat: 38.5232
  }, {
    lng: -82.6615,
    lat: 38.523
  }, {
    lng: -82.6619,
    lat: 38.5233
  }, {
    lng: -82.662,
    lat: 38.5234
  }, {
    lng: -82.6622,
    lat: 38.5237
  }, {
    lng: -82.6624,
    lat: 38.5238
  }, {
    lng: -82.6628,
    lat: 38.5242
  }, {
    lng: -82.6633,
    lat: 38.5247
  }, {
    lng: -82.6639,
    lat: 38.5252
  }, {
    lng: -82.6646,
    lat: 38.5258
  }, {
    lng: -82.6645,
    lat: 38.5259
  }, {
    lng: -82.6644,
    lat: 38.5259
  }, {
    lng: -82.6637,
    lat: 38.5253
  }, {
    lng: -82.6628,
    lat: 38.5245
  }, {
    lng: -82.6623,
    lat: 38.524
  }, {
    lng: -82.6619,
    lat: 38.5237
  }, {
    lng: -82.6617,
    lat: 38.5234
  }, {
    lng: -82.6615,
    lat: 38.5232
  }, {
    lng: -82.661,
    lat: 38.5227
  }, {
    lng: -82.6609,
    lat: 38.5226
  }, {
    lng: -82.6607,
    lat: 38.5225
  }, {
    lng: -82.6606,
    lat: 38.5224
  }, {
    lng: -82.6604,
    lat: 38.5221
  }, {
    lng: -82.6603,
    lat: 38.522
  }, {
    lng: -82.6598,
    lat: 38.5216
  }, {
    lng: -82.6596,
    lat: 38.5214
  }, {
    lng: -82.6595,
    lat: 38.5213
  }, {
    lng: -82.6592,
    lat: 38.521
  }, {
    lng: -82.659,
    lat: 38.5209
  }, {
    lng: -82.6586,
    lat: 38.5205
  }, {
    lng: -82.6583,
    lat: 38.5203
  }, {
    lng: -82.658,
    lat: 38.5201
  }, {
    lng: -82.6579,
    lat: 38.52
  }, {
    lng: -82.6577,
    lat: 38.5199
  }, {
    lng: -82.6575,
    lat: 38.5197
  }, {
    lng: -82.6572,
    lat: 38.5195
  }, {
    lng: -82.657,
    lat: 38.5194
  }, {
    lng: -82.6562,
    lat: 38.5189
  }, {
    lng: -82.6556,
    lat: 38.5186
  }, {
    lng: -82.6549,
    lat: 38.5181
  }, {
    lng: -82.6548,
    lat: 38.5181
  }, {
    lng: -82.6547,
    lat: 38.518
  }, {
    lng: -82.6545,
    lat: 38.5179
  }, {
    lng: -82.6542,
    lat: 38.5177
  }, {
    lng: -82.6541,
    lat: 38.5176
  }, {
    lng: -82.654,
    lat: 38.5175
  }, {
    lng: -82.6537,
    lat: 38.5173
  }, {
    lng: -82.6535,
    lat: 38.5171
  }, {
    lng: -82.6532,
    lat: 38.5169
  }, {
    lng: -82.6531,
    lat: 38.5168
  }, {
    lng: -82.653,
    lat: 38.5166
  }, {
    lng: -82.6529,
    lat: 38.5166
  }, {
    lng: -82.6528,
    lat: 38.5165
  }, {
    lng: -82.6527,
    lat: 38.5163
  }, {
    lng: -82.6526,
    lat: 38.5161
  }, {
    lng: -82.6525,
    lat: 38.516
  }, {
    lng: -82.6524,
    lat: 38.5159
  }, {
    lng: -82.6523,
    lat: 38.5158
  }, {
    lng: -82.6523,
    lat: 38.5156
  }, {
    lng: -82.6521,
    lat: 38.5152
  }, {
    lng: -82.652,
    lat: 38.515
  }, {
    lng: -82.6519,
    lat: 38.5147
  }, {
    lng: -82.6519,
    lat: 38.5146
  }, {
    lng: -82.6518,
    lat: 38.5145
  }, {
    lng: -82.6516,
    lat: 38.5146
  }, {
    lng: -82.6514,
    lat: 38.5146
  }, {
    lng: -82.6512,
    lat: 38.5147
  }, {
    lng: -82.6507,
    lat: 38.5147
  }, {
    lng: -82.6505,
    lat: 38.5148
  }, {
    lng: -82.6501,
    lat: 38.5148
  }, {
    lng: -82.6501,
    lat: 38.5148
  }, {
    lng: -82.65,
    lat: 38.5147
  }, {
    lng: -82.6499,
    lat: 38.5147
  }, {
    lng: -82.6483,
    lat: 38.5147
  }, {
    lng: -82.6475,
    lat: 38.5146
  }, {
    lng: -82.6469,
    lat: 38.5147
  }, {
    lng: -82.6464,
    lat: 38.5147
  }, {
    lng: -82.6458,
    lat: 38.5147
  }, {
    lng: -82.6453,
    lat: 38.5148
  }, {
    lng: -82.6447,
    lat: 38.515
  }, {
    lng: -82.644,
    lat: 38.5152
  }, {
    lng: -82.6437,
    lat: 38.5153
  }, {
    lng: -82.6436,
    lat: 38.5154
  }, {
    lng: -82.6433,
    lat: 38.5156
  }, {
    lng: -82.6431,
    lat: 38.516
  }, {
    lng: -82.6428,
    lat: 38.5163
  }, {
    lng: -82.6426,
    lat: 38.5167
  }, {
    lng: -82.6422,
    lat: 38.5174
  }, {
    lng: -82.6419,
    lat: 38.5177
  }, {
    lng: -82.6415,
    lat: 38.5179
  }, {
    lng: -82.6413,
    lat: 38.518
  }, {
    lng: -82.6413,
    lat: 38.5181
  }, {
    lng: -82.641,
    lat: 38.5184
  }, {
    lng: -82.6407,
    lat: 38.5184
  }, {
    lng: -82.6402,
    lat: 38.5185
  }, {
    lng: -82.6399,
    lat: 38.5188
  }, {
    lng: -82.6392,
    lat: 38.519
  }, {
    lng: -82.6387,
    lat: 38.5193
  }, {
    lng: -82.6383,
    lat: 38.5195
  }, {
    lng: -82.6381,
    lat: 38.5195
  }, {
    lng: -82.6377,
    lat: 38.5196
  }, {
    lng: -82.6372,
    lat: 38.5196
  }, {
    lng: -82.6368,
    lat: 38.5196
  }, {
    lng: -82.6365,
    lat: 38.5197
  }, {
    lng: -82.6361,
    lat: 38.5198
  }, {
    lng: -82.636,
    lat: 38.5198
  }, {
    lng: -82.636,
    lat: 38.5198
  }, {
    lng: -82.6358,
    lat: 38.5197
  }, {
    lng: -82.6356,
    lat: 38.5197
  }, {
    lng: -82.6355,
    lat: 38.5196
  }, {
    lng: -82.6355,
    lat: 38.5196
  }, {
    lng: -82.6355,
    lat: 38.5196
  }, {
    lng: -82.6355,
    lat: 38.5193
  }, {
    lng: -82.6357,
    lat: 38.5191
  }, {
    lng: -82.6356,
    lat: 38.5191
  }, {
    lng: -82.6357,
    lat: 38.519
  }, {
    lng: -82.6358,
    lat: 38.5187
  }, {
    lng: -82.6359,
    lat: 38.5185
  }, {
    lng: -82.636,
    lat: 38.5179
  }, {
    lng: -82.636,
    lat: 38.5178
  }, {
    lng: -82.6359,
    lat: 38.5175
  }, {
    lng: -82.6357,
    lat: 38.5172
  }, {
    lng: -82.6352,
    lat: 38.517
  }, {
    lng: -82.6346,
    lat: 38.5168
  }, {
    lng: -82.6341,
    lat: 38.5167
  }, {
    lng: -82.6334,
    lat: 38.5163
  }, {
    lng: -82.633,
    lat: 38.5161
  }, {
    lng: -82.6327,
    lat: 38.5158
  }, {
    lng: -82.6327,
    lat: 38.5156
  }, {
    lng: -82.6327,
    lat: 38.5152
  }, {
    lng: -82.633,
    lat: 38.5149
  }, {
    lng: -82.6331,
    lat: 38.5146
  }, {
    lng: -82.6331,
    lat: 38.5142
  }, {
    lng: -82.6329,
    lat: 38.5138
  }, {
    lng: -82.6326,
    lat: 38.5136
  }, {
    lng: -82.6322,
    lat: 38.5134
  }, {
    lng: -82.6321,
    lat: 38.5135
  }, {
    lng: -82.6319,
    lat: 38.5136
  }, {
    lng: -82.6317,
    lat: 38.5139
  }, {
    lng: -82.6315,
    lat: 38.5143
  }, {
    lng: -82.6314,
    lat: 38.5145
  }, {
    lng: -82.6313,
    lat: 38.5146
  }, {
    lng: -82.6311,
    lat: 38.5149
  }, {
    lng: -82.631,
    lat: 38.5151
  }, {
    lng: -82.6309,
    lat: 38.5154
  }, {
    lng: -82.6308,
    lat: 38.5157
  }, {
    lng: -82.6307,
    lat: 38.516
  }, {
    lng: -82.6307,
    lat: 38.516
  }, {
    lng: -82.6306,
    lat: 38.5163
  }, {
    lng: -82.6306,
    lat: 38.5164
  }, {
    lng: -82.6307,
    lat: 38.5166
  }, {
    lng: -82.631,
    lat: 38.5169
  }, {
    lng: -82.6311,
    lat: 38.5171
  }, {
    lng: -82.6313,
    lat: 38.5176
  }, {
    lng: -82.6314,
    lat: 38.518
  }, {
    lng: -82.6314,
    lat: 38.5186
  }, {
    lng: -82.6315,
    lat: 38.5189
  }, {
    lng: -82.6314,
    lat: 38.5193
  }, {
    lng: -82.6314,
    lat: 38.5198
  }, {
    lng: -82.6312,
    lat: 38.5201
  }, {
    lng: -82.6311,
    lat: 38.5205
  }]]],
  options: {
    fillColor: '#0fbb58',
    fillOpacity: 0.4,
    strokeColor: '#0B8C42',
    strokeWeight: 1,
    strokeOpacity: 0.4,
    clickable: true,
    visible: true,
    zIndex: 1000
  }
};
var carrierRoute02 = {
  carrierRoute: '45638C005',
  paths: [[[{
    lng: -82.6709,
    lat: 38.5281
  }, {
    lng: -82.6715,
    lat: 38.5289
  }, {
    lng: -82.6721,
    lat: 38.5297
  }, {
    lng: -82.6728,
    lat: 38.5305
  }, {
    lng: -82.6735,
    lat: 38.5314
  }, {
    lng: -82.673,
    lat: 38.5317
  }, {
    lng: -82.6725,
    lat: 38.5319
  }, {
    lng: -82.6732,
    lat: 38.5327
  }, {
    lng: -82.6745,
    lat: 38.5344
  }, {
    lng: -82.6743,
    lat: 38.5345
  }, {
    lng: -82.674,
    lat: 38.5347
  }, {
    lng: -82.6735,
    lat: 38.5348
  }, {
    lng: -82.6739,
    lat: 38.5353
  }, {
    lng: -82.674,
    lat: 38.5354
  }, {
    lng: -82.6743,
    lat: 38.5358
  }, {
    lng: -82.6744,
    lat: 38.5358
  }, {
    lng: -82.6745,
    lat: 38.536
  }, {
    lng: -82.6746,
    lat: 38.5361
  }, {
    lng: -82.6746,
    lat: 38.5362
  }, {
    lng: -82.6747,
    lat: 38.5363
  }, {
    lng: -82.6748,
    lat: 38.5364
  }, {
    lng: -82.675,
    lat: 38.5366
  }, {
    lng: -82.6753,
    lat: 38.5369
  }, {
    lng: -82.6755,
    lat: 38.5372
  }, {
    lng: -82.6758,
    lat: 38.5374
  }, {
    lng: -82.6762,
    lat: 38.5379
  }, {
    lng: -82.6765,
    lat: 38.5381
  }, {
    lng: -82.6769,
    lat: 38.5385
  }, {
    lng: -82.6771,
    lat: 38.5387
  }, {
    lng: -82.6772,
    lat: 38.5388
  }, {
    lng: -82.6776,
    lat: 38.5391
  }, {
    lng: -82.6783,
    lat: 38.5397
  }, {
    lng: -82.6787,
    lat: 38.54
  }, {
    lng: -82.6787,
    lat: 38.5401
  }, {
    lng: -82.6789,
    lat: 38.5402
  }, {
    lng: -82.6789,
    lat: 38.5403
  }, {
    lng: -82.6795,
    lat: 38.5408
  }, {
    lng: -82.6797,
    lat: 38.541
  }, {
    lng: -82.6795,
    lat: 38.541
  }, {
    lng: -82.6795,
    lat: 38.5411
  }, {
    lng: -82.6796,
    lat: 38.5411
  }, {
    lng: -82.6797,
    lat: 38.5412
  }, {
    lng: -82.6798,
    lat: 38.5413
  }, {
    lng: -82.6804,
    lat: 38.5419
  }, {
    lng: -82.681,
    lat: 38.5424
  }, {
    lng: -82.6813,
    lat: 38.5426
  }, {
    lng: -82.6814,
    lat: 38.5427
  }, {
    lng: -82.6814,
    lat: 38.5427
  }, {
    lng: -82.6819,
    lat: 38.5431
  }, {
    lng: -82.6819,
    lat: 38.5431
  }, {
    lng: -82.682,
    lat: 38.543
  }, {
    lng: -82.682,
    lat: 38.543
  }, {
    lng: -82.6822,
    lat: 38.5431
  }, {
    lng: -82.6825,
    lat: 38.5433
  }, {
    lng: -82.6826,
    lat: 38.5434
  }, {
    lng: -82.6829,
    lat: 38.543
  }, {
    lng: -82.6831,
    lat: 38.5427
  }, {
    lng: -82.6833,
    lat: 38.5428
  }, {
    lng: -82.6838,
    lat: 38.5432
  }, {
    lng: -82.6839,
    lat: 38.5433
  }, {
    lng: -82.6841,
    lat: 38.5434
  }, {
    lng: -82.684,
    lat: 38.5433
  }, {
    lng: -82.6837,
    lat: 38.543
  }, {
    lng: -82.6833,
    lat: 38.5424
  }, {
    lng: -82.6835,
    lat: 38.5425
  }, {
    lng: -82.6836,
    lat: 38.5426
  }, {
    lng: -82.6837,
    lat: 38.5427
  }, {
    lng: -82.6838,
    lat: 38.5429
  }, {
    lng: -82.6839,
    lat: 38.543
  }, {
    lng: -82.684,
    lat: 38.5432
  }, {
    lng: -82.6842,
    lat: 38.5434
  }, {
    lng: -82.6842,
    lat: 38.5435
  }, {
    lng: -82.684,
    lat: 38.5421
  }, {
    lng: -82.6845,
    lat: 38.5422
  }, {
    lng: -82.6847,
    lat: 38.5425
  }, {
    lng: -82.6849,
    lat: 38.5427
  }, {
    lng: -82.6854,
    lat: 38.5424
  }, {
    lng: -82.6859,
    lat: 38.5422
  }, {
    lng: -82.6862,
    lat: 38.5426
  }, {
    lng: -82.6863,
    lat: 38.5426
  }, {
    lng: -82.6864,
    lat: 38.5427
  }, {
    lng: -82.6864,
    lat: 38.5427
  }, {
    lng: -82.6865,
    lat: 38.5427
  }, {
    lng: -82.6866,
    lat: 38.5428
  }, {
    lng: -82.6867,
    lat: 38.5428
  }, {
    lng: -82.6868,
    lat: 38.5428
  }, {
    lng: -82.6869,
    lat: 38.5427
  }, {
    lng: -82.6869,
    lat: 38.5427
  }, {
    lng: -82.687,
    lat: 38.5427
  }, {
    lng: -82.687,
    lat: 38.5427
  }, {
    lng: -82.6875,
    lat: 38.5424
  }, {
    lng: -82.688,
    lat: 38.5422
  }, {
    lng: -82.6874,
    lat: 38.5414
  }, {
    lng: -82.6868,
    lat: 38.5407
  }, {
    lng: -82.6862,
    lat: 38.5399
  }, {
    lng: -82.6859,
    lat: 38.5395
  }, {
    lng: -82.6855,
    lat: 38.5391
  }, {
    lng: -82.6849,
    lat: 38.5383
  }, {
    lng: -82.6846,
    lat: 38.5379
  }, {
    lng: -82.6842,
    lat: 38.5374
  }, {
    lng: -82.6849,
    lat: 38.5371
  }, {
    lng: -82.6852,
    lat: 38.5369
  }, {
    lng: -82.6845,
    lat: 38.5361
  }, {
    lng: -82.6839,
    lat: 38.5353
  }, {
    lng: -82.6828,
    lat: 38.5358
  }, {
    lng: -82.6825,
    lat: 38.5354
  }, {
    lng: -82.6822,
    lat: 38.535
  }, {
    lng: -82.6817,
    lat: 38.5352
  }, {
    lng: -82.6812,
    lat: 38.5355
  }, {
    lng: -82.6805,
    lat: 38.5347
  }, {
    lng: -82.6799,
    lat: 38.534
  }, {
    lng: -82.6793,
    lat: 38.5332
  }, {
    lng: -82.6788,
    lat: 38.5335
  }, {
    lng: -82.6783,
    lat: 38.5337
  }, {
    lng: -82.6769,
    lat: 38.532
  }, {
    lng: -82.6764,
    lat: 38.5322
  }, {
    lng: -82.6764,
    lat: 38.5322
  }, {
    lng: -82.6764,
    lat: 38.5322
  }, {
    lng: -82.6763,
    lat: 38.5322
  }, {
    lng: -82.6763,
    lat: 38.5322
  }, {
    lng: -82.6763,
    lat: 38.5321
  }, {
    lng: -82.6757,
    lat: 38.5314
  }, {
    lng: -82.6752,
    lat: 38.5317
  }, {
    lng: -82.6745,
    lat: 38.5309
  }, {
    lng: -82.6738,
    lat: 38.53
  }, {
    lng: -82.6732,
    lat: 38.5292
  }, {
    lng: -82.6725,
    lat: 38.5284
  }, {
    lng: -82.6719,
    lat: 38.5276
  }, {
    lng: -82.6714,
    lat: 38.5279
  }, {
    lng: -82.6709,
    lat: 38.5281
  }]]],
  options: {
    fillColor: '#0fbb58',
    fillOpacity: 0.4,
    strokeColor: '#0B8C42',
    strokeWeight: 1,
    strokeOpacity: 0.4,
    clickable: true,
    visible: true,
    zIndex: 1000
  }
};
var carrierRoute03 = {
  carrierRoute: '45638C002',
  paths: [[[{
    lng: -82.6972,
    lat: 38.5474
  }, {
    lng: -82.6976,
    lat: 38.5476
  }, {
    lng: -82.698,
    lat: 38.5479
  }, {
    lng: -82.6982,
    lat: 38.5481
  }, {
    lng: -82.6983,
    lat: 38.5481
  }, {
    lng: -82.6984,
    lat: 38.5482
  }, {
    lng: -82.6985,
    lat: 38.5482
  }, {
    lng: -82.6986,
    lat: 38.5483
  }, {
    lng: -82.6986,
    lat: 38.5484
  }, {
    lng: -82.6987,
    lat: 38.5484
  }, {
    lng: -82.6987,
    lat: 38.5485
  }, {
    lng: -82.6988,
    lat: 38.5486
  }, {
    lng: -82.6988,
    lat: 38.5486
  }, {
    lng: -82.6989,
    lat: 38.5487
  }, {
    lng: -82.6989,
    lat: 38.5487
  }, {
    lng: -82.699,
    lat: 38.5487
  }, {
    lng: -82.6992,
    lat: 38.5488
  }, {
    lng: -82.6993,
    lat: 38.5489
  }, {
    lng: -82.6995,
    lat: 38.549
  }, {
    lng: -82.6996,
    lat: 38.549
  }, {
    lng: -82.6996,
    lat: 38.5491
  }, {
    lng: -82.6997,
    lat: 38.5492
  }, {
    lng: -82.6997,
    lat: 38.5492
  }, {
    lng: -82.6998,
    lat: 38.5494
  }, {
    lng: -82.6999,
    lat: 38.5496
  }, {
    lng: -82.6999,
    lat: 38.5497
  }, {
    lng: -82.7,
    lat: 38.5498
  }, {
    lng: -82.7,
    lat: 38.5499
  }, {
    lng: -82.7,
    lat: 38.55
  }, {
    lng: -82.7001,
    lat: 38.55
  }, {
    lng: -82.7002,
    lat: 38.5501
  }, {
    lng: -82.7003,
    lat: 38.5501
  }, {
    lng: -82.7017,
    lat: 38.5509
  }, {
    lng: -82.7023,
    lat: 38.5511
  }, {
    lng: -82.7017,
    lat: 38.5518
  }, {
    lng: -82.7014,
    lat: 38.5521
  }, {
    lng: -82.7012,
    lat: 38.5525
  }, {
    lng: -82.7009,
    lat: 38.5528
  }, {
    lng: -82.7008,
    lat: 38.5531
  }, {
    lng: -82.7007,
    lat: 38.5532
  }, {
    lng: -82.7007,
    lat: 38.5532
  }, {
    lng: -82.7012,
    lat: 38.5535
  }, {
    lng: -82.7012,
    lat: 38.5535
  }, {
    lng: -82.7012,
    lat: 38.5534
  }, {
    lng: -82.7012,
    lat: 38.5533
  }, {
    lng: -82.7013,
    lat: 38.5533
  }, {
    lng: -82.7023,
    lat: 38.5538
  }, {
    lng: -82.7033,
    lat: 38.5543
  }, {
    lng: -82.704,
    lat: 38.5547
  }, {
    lng: -82.7045,
    lat: 38.5549
  }, {
    lng: -82.7049,
    lat: 38.5552
  }, {
    lng: -82.7052,
    lat: 38.5553
  }, {
    lng: -82.7054,
    lat: 38.5554
  }, {
    lng: -82.7059,
    lat: 38.5557
  }, {
    lng: -82.7062,
    lat: 38.5558
  }, {
    lng: -82.7068,
    lat: 38.5561
  }, {
    lng: -82.7069,
    lat: 38.5561
  }, {
    lng: -82.7071,
    lat: 38.5563
  }, {
    lng: -82.7074,
    lat: 38.5564
  }, {
    lng: -82.708,
    lat: 38.5566
  }, {
    lng: -82.7083,
    lat: 38.5568
  }, {
    lng: -82.7087,
    lat: 38.5569
  }, {
    lng: -82.7091,
    lat: 38.5571
  }, {
    lng: -82.7095,
    lat: 38.5572
  }, {
    lng: -82.7099,
    lat: 38.5574
  }, {
    lng: -82.7103,
    lat: 38.5576
  }, {
    lng: -82.7106,
    lat: 38.5577
  }, {
    lng: -82.7108,
    lat: 38.5578
  }, {
    lng: -82.7108,
    lat: 38.5578
  }, {
    lng: -82.7107,
    lat: 38.5579
  }, {
    lng: -82.7126,
    lat: 38.5586
  }, {
    lng: -82.7127,
    lat: 38.5586
  }, {
    lng: -82.7128,
    lat: 38.5585
  }, {
    lng: -82.7129,
    lat: 38.5583
  }, {
    lng: -82.7131,
    lat: 38.5581
  }, {
    lng: -82.7133,
    lat: 38.5577
  }, {
    lng: -82.715,
    lat: 38.5553
  }, {
    lng: -82.7151,
    lat: 38.5552
  }, {
    lng: -82.7151,
    lat: 38.5551
  }, {
    lng: -82.7152,
    lat: 38.555
  }, {
    lng: -82.715,
    lat: 38.5549
  }, {
    lng: -82.715,
    lat: 38.5549
  }, {
    lng: -82.7149,
    lat: 38.5549
  }, {
    lng: -82.7149,
    lat: 38.5548
  }, {
    lng: -82.7149,
    lat: 38.5548
  }, {
    lng: -82.7149,
    lat: 38.5547
  }, {
    lng: -82.715,
    lat: 38.5546
  }, {
    lng: -82.7152,
    lat: 38.5545
  }, {
    lng: -82.7155,
    lat: 38.5546
  }, {
    lng: -82.7155,
    lat: 38.5545
  }, {
    lng: -82.7156,
    lat: 38.5543
  }, {
    lng: -82.7162,
    lat: 38.553
  }, {
    lng: -82.7162,
    lat: 38.5529
  }, {
    lng: -82.7161,
    lat: 38.5529
  }, {
    lng: -82.7157,
    lat: 38.5527
  }, {
    lng: -82.7156,
    lat: 38.5526
  }, {
    lng: -82.7153,
    lat: 38.5525
  }, {
    lng: -82.7151,
    lat: 38.5523
  }, {
    lng: -82.7147,
    lat: 38.5521
  }, {
    lng: -82.7143,
    lat: 38.5519
  }, {
    lng: -82.7141,
    lat: 38.5518
  }, {
    lng: -82.7139,
    lat: 38.5517
  }, {
    lng: -82.7139,
    lat: 38.5516
  }, {
    lng: -82.7137,
    lat: 38.5515
  }, {
    lng: -82.7135,
    lat: 38.5514
  }, {
    lng: -82.7133,
    lat: 38.5512
  }, {
    lng: -82.713,
    lat: 38.5511
  }, {
    lng: -82.7128,
    lat: 38.551
  }, {
    lng: -82.7127,
    lat: 38.5509
  }, {
    lng: -82.7124,
    lat: 38.5508
  }, {
    lng: -82.7121,
    lat: 38.5507
  }, {
    lng: -82.712,
    lat: 38.5506
  }, {
    lng: -82.7117,
    lat: 38.5506
  }, {
    lng: -82.7115,
    lat: 38.5505
  }, {
    lng: -82.7113,
    lat: 38.5503
  }, {
    lng: -82.711,
    lat: 38.5503
  }, {
    lng: -82.7108,
    lat: 38.5501
  }, {
    lng: -82.7106,
    lat: 38.55
  }, {
    lng: -82.7103,
    lat: 38.5499
  }, {
    lng: -82.71,
    lat: 38.5498
  }, {
    lng: -82.7098,
    lat: 38.5497
  }, {
    lng: -82.7095,
    lat: 38.5496
  }, {
    lng: -82.7091,
    lat: 38.5495
  }, {
    lng: -82.709,
    lat: 38.5494
  }, {
    lng: -82.7088,
    lat: 38.5493
  }, {
    lng: -82.7085,
    lat: 38.5492
  }, {
    lng: -82.7081,
    lat: 38.549
  }, {
    lng: -82.7078,
    lat: 38.5488
  }, {
    lng: -82.7077,
    lat: 38.5488
  }, {
    lng: -82.7076,
    lat: 38.5487
  }, {
    lng: -82.7073,
    lat: 38.5486
  }, {
    lng: -82.7071,
    lat: 38.5485
  }, {
    lng: -82.7068,
    lat: 38.5483
  }, {
    lng: -82.7064,
    lat: 38.5482
  }, {
    lng: -82.7058,
    lat: 38.548
  }, {
    lng: -82.7055,
    lat: 38.5478
  }, {
    lng: -82.7051,
    lat: 38.5476
  }, {
    lng: -82.7048,
    lat: 38.5475
  }, {
    lng: -82.7046,
    lat: 38.5474
  }, {
    lng: -82.7042,
    lat: 38.5473
  }, {
    lng: -82.7041,
    lat: 38.5472
  }, {
    lng: -82.7039,
    lat: 38.5472
  }, {
    lng: -82.7038,
    lat: 38.5471
  }, {
    lng: -82.7037,
    lat: 38.547
  }, {
    lng: -82.7035,
    lat: 38.5469
  }, {
    lng: -82.7031,
    lat: 38.5467
  }, {
    lng: -82.7025,
    lat: 38.5465
  }, {
    lng: -82.7021,
    lat: 38.5462
  }, {
    lng: -82.7017,
    lat: 38.546
  }, {
    lng: -82.7015,
    lat: 38.5459
  }, {
    lng: -82.7013,
    lat: 38.5459
  }, {
    lng: -82.7011,
    lat: 38.5458
  }, {
    lng: -82.7009,
    lat: 38.5458
  }, {
    lng: -82.7008,
    lat: 38.5457
  }, {
    lng: -82.7006,
    lat: 38.5455
  }, {
    lng: -82.7002,
    lat: 38.5454
  }, {
    lng: -82.6999,
    lat: 38.5452
  }, {
    lng: -82.6998,
    lat: 38.5451
  }, {
    lng: -82.6996,
    lat: 38.5451
  }, {
    lng: -82.6995,
    lat: 38.545
  }, {
    lng: -82.6993,
    lat: 38.545
  }, {
    lng: -82.6991,
    lat: 38.545
  }, {
    lng: -82.699,
    lat: 38.5451
  }, {
    lng: -82.6989,
    lat: 38.5452
  }, {
    lng: -82.6988,
    lat: 38.5453
  }, {
    lng: -82.6986,
    lat: 38.5454
  }, {
    lng: -82.6985,
    lat: 38.5455
  }, {
    lng: -82.6983,
    lat: 38.5457
  }, {
    lng: -82.6985,
    lat: 38.5458
  }, {
    lng: -82.6987,
    lat: 38.5459
  }, {
    lng: -82.6986,
    lat: 38.5461
  }, {
    lng: -82.6985,
    lat: 38.5462
  }, {
    lng: -82.6984,
    lat: 38.5463
  }, {
    lng: -82.6983,
    lat: 38.5464
  }, {
    lng: -82.6983,
    lat: 38.5464
  }, {
    lng: -82.6982,
    lat: 38.5465
  }, {
    lng: -82.698,
    lat: 38.5467
  }, {
    lng: -82.698,
    lat: 38.5467
  }, {
    lng: -82.6979,
    lat: 38.5468
  }, {
    lng: -82.6976,
    lat: 38.5471
  }, {
    lng: -82.6972,
    lat: 38.5474
  }]]],
  options: {
    fillColor: '#0fbb58',
    fillOpacity: 0.4,
    strokeColor: '#0B8C42',
    strokeWeight: 1,
    strokeOpacity: 0.4,
    clickable: true,
    visible: true,
    zIndex: 1000
  }
};
var carrierRoute04 = {
  carrierRoute: '41169C004',
  paths: [[[{
    lng: -82.6831,
    lat: 38.5041
  }, {
    lng: -82.6831,
    lat: 38.5048
  }, {
    lng: -82.6831,
    lat: 38.5053
  }, {
    lng: -82.6831,
    lat: 38.5058
  }, {
    lng: -82.6831,
    lat: 38.5059
  }, {
    lng: -82.683,
    lat: 38.506
  }, {
    lng: -82.6826,
    lat: 38.5061
  }, {
    lng: -82.6825,
    lat: 38.5061
  }, {
    lng: -82.6823,
    lat: 38.5061
  }, {
    lng: -82.6822,
    lat: 38.5059
  }, {
    lng: -82.6822,
    lat: 38.5059
  }, {
    lng: -82.6821,
    lat: 38.5058
  }, {
    lng: -82.682,
    lat: 38.5059
  }, {
    lng: -82.6816,
    lat: 38.5061
  }, {
    lng: -82.6816,
    lat: 38.5062
  }, {
    lng: -82.6815,
    lat: 38.5063
  }, {
    lng: -82.6815,
    lat: 38.5065
  }, {
    lng: -82.6816,
    lat: 38.5067
  }, {
    lng: -82.6818,
    lat: 38.5068
  }, {
    lng: -82.6821,
    lat: 38.5071
  }, {
    lng: -82.6827,
    lat: 38.5074
  }, {
    lng: -82.6835,
    lat: 38.5078
  }, {
    lng: -82.6838,
    lat: 38.5079
  }, {
    lng: -82.6841,
    lat: 38.5081
  }, {
    lng: -82.6844,
    lat: 38.5084
  }, {
    lng: -82.6847,
    lat: 38.5086
  }, {
    lng: -82.6849,
    lat: 38.509
  }, {
    lng: -82.6852,
    lat: 38.5096
  }, {
    lng: -82.6857,
    lat: 38.5104
  }, {
    lng: -82.6861,
    lat: 38.5108
  }, {
    lng: -82.6861,
    lat: 38.5108
  }, {
    lng: -82.6864,
    lat: 38.5111
  }, {
    lng: -82.6866,
    lat: 38.5113
  }, {
    lng: -82.6869,
    lat: 38.5116
  }, {
    lng: -82.6873,
    lat: 38.5119
  }, {
    lng: -82.6875,
    lat: 38.5119
  }, {
    lng: -82.6876,
    lat: 38.512
  }, {
    lng: -82.6877,
    lat: 38.512
  }, {
    lng: -82.6878,
    lat: 38.512
  }, {
    lng: -82.6876,
    lat: 38.5125
  }, {
    lng: -82.6874,
    lat: 38.5128
  }, {
    lng: -82.6873,
    lat: 38.5129
  }, {
    lng: -82.6872,
    lat: 38.513
  }, {
    lng: -82.6869,
    lat: 38.5133
  }, {
    lng: -82.6865,
    lat: 38.5135
  }, {
    lng: -82.6861,
    lat: 38.5136
  }, {
    lng: -82.6858,
    lat: 38.5137
  }, {
    lng: -82.6854,
    lat: 38.5138
  }, {
    lng: -82.6851,
    lat: 38.5139
  }, {
    lng: -82.6849,
    lat: 38.514
  }, {
    lng: -82.6847,
    lat: 38.514
  }, {
    lng: -82.6845,
    lat: 38.5142
  }, {
    lng: -82.6844,
    lat: 38.5143
  }, {
    lng: -82.6842,
    lat: 38.5144
  }, {
    lng: -82.684,
    lat: 38.5146
  }, {
    lng: -82.6839,
    lat: 38.5147
  }, {
    lng: -82.6837,
    lat: 38.5148
  }, {
    lng: -82.6836,
    lat: 38.5149
  }, {
    lng: -82.6834,
    lat: 38.515
  }, {
    lng: -82.6837,
    lat: 38.5156
  }, {
    lng: -82.684,
    lat: 38.5163
  }, {
    lng: -82.6841,
    lat: 38.5167
  }, {
    lng: -82.6843,
    lat: 38.5171
  }, {
    lng: -82.6846,
    lat: 38.5179
  }, {
    lng: -82.6849,
    lat: 38.5185
  }, {
    lng: -82.6849,
    lat: 38.5186
  }, {
    lng: -82.685,
    lat: 38.5188
  }, {
    lng: -82.6852,
    lat: 38.5192
  }, {
    lng: -82.6852,
    lat: 38.5192
  }, {
    lng: -82.6852,
    lat: 38.5194
  }, {
    lng: -82.6855,
    lat: 38.52
  }, {
    lng: -82.6858,
    lat: 38.5208
  }, {
    lng: -82.6861,
    lat: 38.5212
  }, {
    lng: -82.6863,
    lat: 38.5216
  }, {
    lng: -82.6866,
    lat: 38.5219
  }, {
    lng: -82.6869,
    lat: 38.5224
  }, {
    lng: -82.6873,
    lat: 38.5228
  }, {
    lng: -82.6874,
    lat: 38.5229
  }, {
    lng: -82.6876,
    lat: 38.5232
  }, {
    lng: -82.6878,
    lat: 38.5234
  }, {
    lng: -82.6878,
    lat: 38.5237
  }, {
    lng: -82.6877,
    lat: 38.5237
  }, {
    lng: -82.6877,
    lat: 38.5238
  }, {
    lng: -82.6877,
    lat: 38.5238
  }, {
    lng: -82.6877,
    lat: 38.5238
  }, {
    lng: -82.6876,
    lat: 38.5238
  }, {
    lng: -82.6876,
    lat: 38.5239
  }, {
    lng: -82.6876,
    lat: 38.5239
  }, {
    lng: -82.6876,
    lat: 38.5239
  }, {
    lng: -82.6876,
    lat: 38.5239
  }, {
    lng: -82.6876,
    lat: 38.5239
  }, {
    lng: -82.6876,
    lat: 38.524
  }, {
    lng: -82.6876,
    lat: 38.5241
  }, {
    lng: -82.6877,
    lat: 38.5243
  }, {
    lng: -82.6878,
    lat: 38.5248
  }, {
    lng: -82.6872,
    lat: 38.5248
  }, {
    lng: -82.6877,
    lat: 38.5256
  }, {
    lng: -82.6878,
    lat: 38.5258
  }, {
    lng: -82.688,
    lat: 38.5261
  }, {
    lng: -82.6881,
    lat: 38.5262
  }, {
    lng: -82.6881,
    lat: 38.5263
  }, {
    lng: -82.6882,
    lat: 38.5264
  }, {
    lng: -82.6883,
    lat: 38.5266
  }, {
    lng: -82.6884,
    lat: 38.5267
  }, {
    lng: -82.6885,
    lat: 38.5269
  }, {
    lng: -82.6886,
    lat: 38.5271
  }, {
    lng: -82.6887,
    lat: 38.5272
  }, {
    lng: -82.6888,
    lat: 38.5273
  }, {
    lng: -82.6889,
    lat: 38.5275
  }, {
    lng: -82.6889,
    lat: 38.5277
  }, {
    lng: -82.689,
    lat: 38.5281
  }, {
    lng: -82.6903,
    lat: 38.5298
  }, {
    lng: -82.6906,
    lat: 38.5303
  }, {
    lng: -82.6908,
    lat: 38.5306
  }, {
    lng: -82.691,
    lat: 38.5308
  }, {
    lng: -82.6911,
    lat: 38.5309
  }, {
    lng: -82.6912,
    lat: 38.5311
  }, {
    lng: -82.6912,
    lat: 38.5312
  }, {
    lng: -82.6913,
    lat: 38.5315
  }, {
    lng: -82.6917,
    lat: 38.5322
  }, {
    lng: -82.692,
    lat: 38.5326
  }, {
    lng: -82.6922,
    lat: 38.533
  }, {
    lng: -82.6925,
    lat: 38.5333
  }, {
    lng: -82.6927,
    lat: 38.5336
  }, {
    lng: -82.6927,
    lat: 38.5337
  }, {
    lng: -82.6931,
    lat: 38.5343
  }, {
    lng: -82.6932,
    lat: 38.5344
  }, {
    lng: -82.6934,
    lat: 38.5346
  }, {
    lng: -82.6938,
    lat: 38.535
  }, {
    lng: -82.6938,
    lat: 38.5351
  }, {
    lng: -82.6939,
    lat: 38.5352
  }, {
    lng: -82.694,
    lat: 38.5353
  }, {
    lng: -82.6946,
    lat: 38.536
  }, {
    lng: -82.6949,
    lat: 38.5354
  }, {
    lng: -82.695,
    lat: 38.5353
  }, {
    lng: -82.6953,
    lat: 38.5352
  }, {
    lng: -82.6956,
    lat: 38.5351
  }, {
    lng: -82.6958,
    lat: 38.535
  }, {
    lng: -82.6959,
    lat: 38.5348
  }, {
    lng: -82.6958,
    lat: 38.5347
  }, {
    lng: -82.6957,
    lat: 38.5345
  }, {
    lng: -82.6957,
    lat: 38.5345
  }, {
    lng: -82.6959,
    lat: 38.5342
  }, {
    lng: -82.6959,
    lat: 38.5341
  }, {
    lng: -82.6963,
    lat: 38.5345
  }, {
    lng: -82.6966,
    lat: 38.5349
  }, {
    lng: -82.6963,
    lat: 38.5352
  }, {
    lng: -82.696,
    lat: 38.5354
  }, {
    lng: -82.696,
    lat: 38.5355
  }, {
    lng: -82.696,
    lat: 38.5355
  }, {
    lng: -82.6964,
    lat: 38.5358
  }, {
    lng: -82.697,
    lat: 38.5361
  }, {
    lng: -82.6972,
    lat: 38.5357
  }, {
    lng: -82.6972,
    lat: 38.5357
  }, {
    lng: -82.6972,
    lat: 38.5356
  }, {
    lng: -82.6973,
    lat: 38.5355
  }, {
    lng: -82.6973,
    lat: 38.5355
  }, {
    lng: -82.6973,
    lat: 38.5354
  }, {
    lng: -82.6974,
    lat: 38.5354
  }, {
    lng: -82.6975,
    lat: 38.5353
  }, {
    lng: -82.6976,
    lat: 38.5351
  }, {
    lng: -82.6977,
    lat: 38.5349
  }, {
    lng: -82.6978,
    lat: 38.5347
  }, {
    lng: -82.698,
    lat: 38.5344
  }, {
    lng: -82.6982,
    lat: 38.534
  }, {
    lng: -82.6984,
    lat: 38.5337
  }, {
    lng: -82.6989,
    lat: 38.5334
  }, {
    lng: -82.699,
    lat: 38.5333
  }, {
    lng: -82.6991,
    lat: 38.5333
  }, {
    lng: -82.699,
    lat: 38.5332
  }, {
    lng: -82.6987,
    lat: 38.5329
  }, {
    lng: -82.6983,
    lat: 38.5326
  }, {
    lng: -82.6977,
    lat: 38.5323
  }, {
    lng: -82.6974,
    lat: 38.532
  }, {
    lng: -82.6978,
    lat: 38.5317
  }, {
    lng: -82.6979,
    lat: 38.5316
  }, {
    lng: -82.6977,
    lat: 38.5315
  }, {
    lng: -82.6975,
    lat: 38.5314
  }, {
    lng: -82.6974,
    lat: 38.5314
  }, {
    lng: -82.6969,
    lat: 38.531
  }, {
    lng: -82.6969,
    lat: 38.531
  }, {
    lng: -82.6967,
    lat: 38.5309
  }, {
    lng: -82.6962,
    lat: 38.5305
  }, {
    lng: -82.696,
    lat: 38.5304
  }, {
    lng: -82.6958,
    lat: 38.5302
  }, {
    lng: -82.6949,
    lat: 38.5295
  }, {
    lng: -82.6945,
    lat: 38.5292
  }, {
    lng: -82.694,
    lat: 38.5289
  }, {
    lng: -82.6936,
    lat: 38.5286
  }, {
    lng: -82.6933,
    lat: 38.5285
  }, {
    lng: -82.6924,
    lat: 38.528
  }, {
    lng: -82.692,
    lat: 38.5278
  }, {
    lng: -82.6918,
    lat: 38.5277
  }, {
    lng: -82.6916,
    lat: 38.5275
  }, {
    lng: -82.6911,
    lat: 38.5272
  }, {
    lng: -82.6906,
    lat: 38.5269
  }, {
    lng: -82.6902,
    lat: 38.5265
  }, {
    lng: -82.69,
    lat: 38.5263
  }, {
    lng: -82.6899,
    lat: 38.5262
  }, {
    lng: -82.6898,
    lat: 38.5261
  }, {
    lng: -82.6899,
    lat: 38.526
  }, {
    lng: -82.6901,
    lat: 38.5258
  }, {
    lng: -82.6902,
    lat: 38.5257
  }, {
    lng: -82.6904,
    lat: 38.5255
  }, {
    lng: -82.6905,
    lat: 38.5254
  }, {
    lng: -82.6906,
    lat: 38.5253
  }, {
    lng: -82.6908,
    lat: 38.5251
  }, {
    lng: -82.6909,
    lat: 38.5249
  }, {
    lng: -82.6912,
    lat: 38.5247
  }, {
    lng: -82.6914,
    lat: 38.5246
  }, {
    lng: -82.6917,
    lat: 38.5245
  }, {
    lng: -82.6922,
    lat: 38.5243
  }, {
    lng: -82.693,
    lat: 38.524
  }, {
    lng: -82.6933,
    lat: 38.5239
  }, {
    lng: -82.6935,
    lat: 38.5238
  }, {
    lng: -82.6937,
    lat: 38.5238
  }, {
    lng: -82.6939,
    lat: 38.5237
  }, {
    lng: -82.694,
    lat: 38.5236
  }, {
    lng: -82.6941,
    lat: 38.5235
  }, {
    lng: -82.6944,
    lat: 38.5231
  }, {
    lng: -82.6946,
    lat: 38.5229
  }, {
    lng: -82.6951,
    lat: 38.5223
  }, {
    lng: -82.6953,
    lat: 38.5221
  }, {
    lng: -82.6955,
    lat: 38.5219
  }, {
    lng: -82.6956,
    lat: 38.5217
  }, {
    lng: -82.6956,
    lat: 38.5215
  }, {
    lng: -82.6955,
    lat: 38.5213
  }, {
    lng: -82.6951,
    lat: 38.5206
  }, {
    lng: -82.6951,
    lat: 38.5204
  }, {
    lng: -82.6951,
    lat: 38.5204
  }, {
    lng: -82.6951,
    lat: 38.52
  }, {
    lng: -82.6951,
    lat: 38.5198
  }, {
    lng: -82.6952,
    lat: 38.5196
  }, {
    lng: -82.6953,
    lat: 38.5194
  }, {
    lng: -82.6957,
    lat: 38.5185
  }, {
    lng: -82.6959,
    lat: 38.5182
  }, {
    lng: -82.696,
    lat: 38.5174
  }, {
    lng: -82.6961,
    lat: 38.5169
  }, {
    lng: -82.6961,
    lat: 38.5167
  }, {
    lng: -82.696,
    lat: 38.5165
  }, {
    lng: -82.696,
    lat: 38.5163
  }, {
    lng: -82.6963,
    lat: 38.5166
  }, {
    lng: -82.6967,
    lat: 38.5169
  }, {
    lng: -82.6968,
    lat: 38.517
  }, {
    lng: -82.697,
    lat: 38.5171
  }, {
    lng: -82.6971,
    lat: 38.5172
  }, {
    lng: -82.6973,
    lat: 38.5172
  }, {
    lng: -82.6975,
    lat: 38.5172
  }, {
    lng: -82.6976,
    lat: 38.5172
  }, {
    lng: -82.6978,
    lat: 38.5173
  }, {
    lng: -82.698,
    lat: 38.5172
  }, {
    lng: -82.6981,
    lat: 38.5172
  }, {
    lng: -82.6985,
    lat: 38.5172
  }, {
    lng: -82.6998,
    lat: 38.5171
  }, {
    lng: -82.6988,
    lat: 38.516
  }, {
    lng: -82.6971,
    lat: 38.5141
  }, {
    lng: -82.6965,
    lat: 38.5135
  }, {
    lng: -82.6961,
    lat: 38.513
  }, {
    lng: -82.696,
    lat: 38.5129
  }, {
    lng: -82.696,
    lat: 38.5128
  }, {
    lng: -82.6959,
    lat: 38.5127
  }, {
    lng: -82.6959,
    lat: 38.5125
  }, {
    lng: -82.6959,
    lat: 38.5124
  }, {
    lng: -82.6959,
    lat: 38.5122
  }, {
    lng: -82.6963,
    lat: 38.512
  }, {
    lng: -82.6967,
    lat: 38.5118
  }, {
    lng: -82.6971,
    lat: 38.5116
  }, {
    lng: -82.6972,
    lat: 38.5115
  }, {
    lng: -82.6973,
    lat: 38.5115
  }, {
    lng: -82.6973,
    lat: 38.5114
  }, {
    lng: -82.6973,
    lat: 38.5113
  }, {
    lng: -82.6973,
    lat: 38.5112
  }, {
    lng: -82.6971,
    lat: 38.5104
  }, {
    lng: -82.6969,
    lat: 38.51
  }, {
    lng: -82.6969,
    lat: 38.51
  }, {
    lng: -82.6968,
    lat: 38.5098
  }, {
    lng: -82.6968,
    lat: 38.5097
  }, {
    lng: -82.6967,
    lat: 38.5096
  }, {
    lng: -82.6966,
    lat: 38.5096
  }, {
    lng: -82.6966,
    lat: 38.5095
  }, {
    lng: -82.6963,
    lat: 38.5094
  }, {
    lng: -82.696,
    lat: 38.5092
  }, {
    lng: -82.6958,
    lat: 38.5092
  }, {
    lng: -82.6956,
    lat: 38.5091
  }, {
    lng: -82.6959,
    lat: 38.5083
  }, {
    lng: -82.6961,
    lat: 38.5074
  }, {
    lng: -82.6961,
    lat: 38.5072
  }, {
    lng: -82.6961,
    lat: 38.507
  }, {
    lng: -82.6961,
    lat: 38.5069
  }, {
    lng: -82.6961,
    lat: 38.5068
  }, {
    lng: -82.6961,
    lat: 38.5067
  }, {
    lng: -82.696,
    lat: 38.5066
  }, {
    lng: -82.696,
    lat: 38.5065
  }, {
    lng: -82.6958,
    lat: 38.5064
  }, {
    lng: -82.6956,
    lat: 38.5063
  }, {
    lng: -82.6946,
    lat: 38.5059
  }, {
    lng: -82.695,
    lat: 38.5067
  }, {
    lng: -82.695,
    lat: 38.5068
  }, {
    lng: -82.6951,
    lat: 38.5071
  }, {
    lng: -82.6951,
    lat: 38.5073
  }, {
    lng: -82.695,
    lat: 38.5076
  }, {
    lng: -82.6949,
    lat: 38.5078
  }, {
    lng: -82.6948,
    lat: 38.5083
  }, {
    lng: -82.6946,
    lat: 38.5086
  }, {
    lng: -82.6946,
    lat: 38.5087
  }, {
    lng: -82.6945,
    lat: 38.5088
  }, {
    lng: -82.6944,
    lat: 38.509
  }, {
    lng: -82.6942,
    lat: 38.5091
  }, {
    lng: -82.6941,
    lat: 38.5092
  }, {
    lng: -82.6939,
    lat: 38.5092
  }, {
    lng: -82.6938,
    lat: 38.5093
  }, {
    lng: -82.6937,
    lat: 38.5093
  }, {
    lng: -82.6936,
    lat: 38.5093
  }, {
    lng: -82.6935,
    lat: 38.5093
  }, {
    lng: -82.6934,
    lat: 38.5093
  }, {
    lng: -82.6933,
    lat: 38.5093
  }, {
    lng: -82.6931,
    lat: 38.5093
  }, {
    lng: -82.6929,
    lat: 38.5093
  }, {
    lng: -82.6928,
    lat: 38.5094
  }, {
    lng: -82.6927,
    lat: 38.5094
  }, {
    lng: -82.6926,
    lat: 38.5095
  }, {
    lng: -82.6925,
    lat: 38.5096
  }, {
    lng: -82.6925,
    lat: 38.5096
  }, {
    lng: -82.6923,
    lat: 38.5098
  }, {
    lng: -82.6915,
    lat: 38.5106
  }, {
    lng: -82.6913,
    lat: 38.5107
  }, {
    lng: -82.6912,
    lat: 38.5108
  }, {
    lng: -82.6911,
    lat: 38.5108
  }, {
    lng: -82.6911,
    lat: 38.5108
  }, {
    lng: -82.691,
    lat: 38.5109
  }, {
    lng: -82.6909,
    lat: 38.5109
  }, {
    lng: -82.6906,
    lat: 38.511
  }, {
    lng: -82.6904,
    lat: 38.5109
  }, {
    lng: -82.6902,
    lat: 38.5109
  }, {
    lng: -82.6901,
    lat: 38.5109
  }, {
    lng: -82.6899,
    lat: 38.5108
  }, {
    lng: -82.6897,
    lat: 38.5107
  }, {
    lng: -82.6896,
    lat: 38.5106
  }, {
    lng: -82.6898,
    lat: 38.5105
  }, {
    lng: -82.6899,
    lat: 38.5104
  }, {
    lng: -82.69,
    lat: 38.5103
  }, {
    lng: -82.6901,
    lat: 38.5101
  }, {
    lng: -82.6902,
    lat: 38.51
  }, {
    lng: -82.6902,
    lat: 38.5098
  }, {
    lng: -82.6903,
    lat: 38.5096
  }, {
    lng: -82.6904,
    lat: 38.5094
  }, {
    lng: -82.6904,
    lat: 38.5089
  }, {
    lng: -82.6904,
    lat: 38.5088
  }, {
    lng: -82.6903,
    lat: 38.5085
  }, {
    lng: -82.6903,
    lat: 38.5083
  }, {
    lng: -82.6903,
    lat: 38.5081
  }, {
    lng: -82.6903,
    lat: 38.5078
  }, {
    lng: -82.6904,
    lat: 38.5075
  }, {
    lng: -82.6906,
    lat: 38.5071
  }, {
    lng: -82.6907,
    lat: 38.5066
  }, {
    lng: -82.6908,
    lat: 38.5062
  }, {
    lng: -82.6908,
    lat: 38.5058
  }, {
    lng: -82.6908,
    lat: 38.5057
  }, {
    lng: -82.6907,
    lat: 38.5055
  }, {
    lng: -82.6907,
    lat: 38.5053
  }, {
    lng: -82.6907,
    lat: 38.5051
  }, {
    lng: -82.6907,
    lat: 38.505
  }, {
    lng: -82.6907,
    lat: 38.5048
  }, {
    lng: -82.6907,
    lat: 38.5047
  }, {
    lng: -82.6907,
    lat: 38.5045
  }, {
    lng: -82.6892,
    lat: 38.5045
  }, {
    lng: -82.6847,
    lat: 38.5044
  }, {
    lng: -82.6844,
    lat: 38.5043
  }, {
    lng: -82.6842,
    lat: 38.5043
  }, {
    lng: -82.6839,
    lat: 38.5043
  }, {
    lng: -82.6838,
    lat: 38.5043
  }, {
    lng: -82.6836,
    lat: 38.5043
  }, {
    lng: -82.6831,
    lat: 38.5041
  }]]],
  options: {
    fillColor: '#0fbb58',
    fillOpacity: 0.4,
    strokeColor: '#0B8C42',
    strokeWeight: 1,
    strokeOpacity: 0.4,
    clickable: true,
    visible: true,
    zIndex: 1000
  }
};
var carrierRoute05 = {
  carrierRoute: '41169C002',
  paths: [[[{
    lng: -82.6959,
    lat: 38.5083
  }, {
    lng: -82.6962,
    lat: 38.5083
  }, {
    lng: -82.6965,
    lat: 38.5084
  }, {
    lng: -82.6967,
    lat: 38.5084
  }, {
    lng: -82.6968,
    lat: 38.5085
  }, {
    lng: -82.6969,
    lat: 38.5085
  }, {
    lng: -82.697,
    lat: 38.5086
  }, {
    lng: -82.6972,
    lat: 38.5088
  }, {
    lng: -82.6973,
    lat: 38.5089
  }, {
    lng: -82.698,
    lat: 38.5096
  }, {
    lng: -82.6983,
    lat: 38.5099
  }, {
    lng: -82.6986,
    lat: 38.5103
  }, {
    lng: -82.6988,
    lat: 38.5105
  }, {
    lng: -82.6989,
    lat: 38.5105
  }, {
    lng: -82.699,
    lat: 38.5105
  }, {
    lng: -82.6993,
    lat: 38.5106
  }, {
    lng: -82.6993,
    lat: 38.5106
  }, {
    lng: -82.6994,
    lat: 38.5106
  }, {
    lng: -82.7,
    lat: 38.5105
  }, {
    lng: -82.7008,
    lat: 38.5104
  }, {
    lng: -82.7009,
    lat: 38.5104
  }, {
    lng: -82.701,
    lat: 38.5104
  }, {
    lng: -82.701,
    lat: 38.5103
  }, {
    lng: -82.7012,
    lat: 38.5102
  }, {
    lng: -82.7015,
    lat: 38.5096
  }, {
    lng: -82.7015,
    lat: 38.5095
  }, {
    lng: -82.7015,
    lat: 38.5094
  }, {
    lng: -82.7015,
    lat: 38.5093
  }, {
    lng: -82.7013,
    lat: 38.5092
  }, {
    lng: -82.701,
    lat: 38.509
  }, {
    lng: -82.7009,
    lat: 38.509
  }, {
    lng: -82.7006,
    lat: 38.5089
  }, {
    lng: -82.7004,
    lat: 38.5089
  }, {
    lng: -82.7002,
    lat: 38.5088
  }, {
    lng: -82.7001,
    lat: 38.5086
  }, {
    lng: -82.6999,
    lat: 38.5085
  }, {
    lng: -82.6998,
    lat: 38.5084
  }, {
    lng: -82.6997,
    lat: 38.5082
  }, {
    lng: -82.6988,
    lat: 38.5072
  }, {
    lng: -82.6984,
    lat: 38.5068
  }, {
    lng: -82.6983,
    lat: 38.5067
  }, {
    lng: -82.6981,
    lat: 38.5065
  }, {
    lng: -82.698,
    lat: 38.5065
  }, {
    lng: -82.6979,
    lat: 38.5065
  }, {
    lng: -82.6977,
    lat: 38.5064
  }, {
    lng: -82.6976,
    lat: 38.5064
  }, {
    lng: -82.6975,
    lat: 38.5065
  }, {
    lng: -82.6973,
    lat: 38.5066
  }, {
    lng: -82.6972,
    lat: 38.5066
  }, {
    lng: -82.6972,
    lat: 38.5067
  }, {
    lng: -82.697,
    lat: 38.5073
  }, {
    lng: -82.6969,
    lat: 38.5074
  }, {
    lng: -82.6967,
    lat: 38.5075
  }, {
    lng: -82.6965,
    lat: 38.5075
  }, {
    lng: -82.6963,
    lat: 38.5075
  }, {
    lng: -82.6962,
    lat: 38.5075
  }, {
    lng: -82.6961,
    lat: 38.5074
  }, {
    lng: -82.6959,
    lat: 38.5083
  }]], [[{
    lng: -82.6927,
    lat: 38.5034
  }, {
    lng: -82.6926,
    lat: 38.5036
  }, {
    lng: -82.6926,
    lat: 38.5037
  }, {
    lng: -82.6927,
    lat: 38.5038
  }, {
    lng: -82.6927,
    lat: 38.5039
  }, {
    lng: -82.6927,
    lat: 38.5041
  }, {
    lng: -82.6928,
    lat: 38.5042
  }, {
    lng: -82.6929,
    lat: 38.5044
  }, {
    lng: -82.693,
    lat: 38.5045
  }, {
    lng: -82.6937,
    lat: 38.5045
  }, {
    lng: -82.6941,
    lat: 38.5046
  }, {
    lng: -82.6944,
    lat: 38.5046
  }, {
    lng: -82.6946,
    lat: 38.5047
  }, {
    lng: -82.6947,
    lat: 38.5047
  }, {
    lng: -82.6967,
    lat: 38.5051
  }, {
    lng: -82.6967,
    lat: 38.5052
  }, {
    lng: -82.6966,
    lat: 38.5053
  }, {
    lng: -82.6964,
    lat: 38.5054
  }, {
    lng: -82.6963,
    lat: 38.5056
  }, {
    lng: -82.6964,
    lat: 38.5058
  }, {
    lng: -82.6966,
    lat: 38.5059
  }, {
    lng: -82.6966,
    lat: 38.506
  }, {
    lng: -82.6966,
    lat: 38.506
  }, {
    lng: -82.6969,
    lat: 38.5061
  }, {
    lng: -82.6974,
    lat: 38.5061
  }, {
    lng: -82.6975,
    lat: 38.5061
  }, {
    lng: -82.6988,
    lat: 38.5063
  }, {
    lng: -82.6995,
    lat: 38.5063
  }, {
    lng: -82.6998,
    lat: 38.5063
  }, {
    lng: -82.7006,
    lat: 38.5065
  }, {
    lng: -82.7009,
    lat: 38.5066
  }, {
    lng: -82.7012,
    lat: 38.5066
  }, {
    lng: -82.7014,
    lat: 38.5066
  }, {
    lng: -82.7017,
    lat: 38.5065
  }, {
    lng: -82.7023,
    lat: 38.5063
  }, {
    lng: -82.7033,
    lat: 38.5064
  }, {
    lng: -82.7037,
    lat: 38.5064
  }, {
    lng: -82.7039,
    lat: 38.5065
  }, {
    lng: -82.7041,
    lat: 38.5065
  }, {
    lng: -82.7042,
    lat: 38.5065
  }, {
    lng: -82.7044,
    lat: 38.5066
  }, {
    lng: -82.7046,
    lat: 38.5067
  }, {
    lng: -82.7048,
    lat: 38.5068
  }, {
    lng: -82.7049,
    lat: 38.5069
  }, {
    lng: -82.7051,
    lat: 38.507
  }, {
    lng: -82.7053,
    lat: 38.507
  }, {
    lng: -82.7066,
    lat: 38.508
  }, {
    lng: -82.7072,
    lat: 38.5084
  }, {
    lng: -82.7075,
    lat: 38.5085
  }, {
    lng: -82.7078,
    lat: 38.5088
  }, {
    lng: -82.7081,
    lat: 38.5089
  }, {
    lng: -82.7083,
    lat: 38.509
  }, {
    lng: -82.7087,
    lat: 38.5092
  }, {
    lng: -82.709,
    lat: 38.5093
  }, {
    lng: -82.7093,
    lat: 38.5095
  }, {
    lng: -82.7095,
    lat: 38.5095
  }, {
    lng: -82.7111,
    lat: 38.51
  }, {
    lng: -82.7115,
    lat: 38.5101
  }, {
    lng: -82.7121,
    lat: 38.5103
  }, {
    lng: -82.7129,
    lat: 38.5107
  }, {
    lng: -82.7131,
    lat: 38.5108
  }, {
    lng: -82.7133,
    lat: 38.5109
  }, {
    lng: -82.714,
    lat: 38.5102
  }, {
    lng: -82.7143,
    lat: 38.5102
  }, {
    lng: -82.7145,
    lat: 38.5103
  }, {
    lng: -82.7149,
    lat: 38.5104
  }, {
    lng: -82.7155,
    lat: 38.5106
  }, {
    lng: -82.716,
    lat: 38.5093
  }, {
    lng: -82.7178,
    lat: 38.5098
  }, {
    lng: -82.7179,
    lat: 38.5098
  }, {
    lng: -82.7181,
    lat: 38.5099
  }, {
    lng: -82.7183,
    lat: 38.51
  }, {
    lng: -82.7186,
    lat: 38.5101
  }, {
    lng: -82.7189,
    lat: 38.5096
  }, {
    lng: -82.7189,
    lat: 38.5095
  }, {
    lng: -82.719,
    lat: 38.5095
  }, {
    lng: -82.719,
    lat: 38.5096
  }, {
    lng: -82.7191,
    lat: 38.5096
  }, {
    lng: -82.7192,
    lat: 38.5096
  }, {
    lng: -82.7193,
    lat: 38.5097
  }, {
    lng: -82.7194,
    lat: 38.5095
  }, {
    lng: -82.7195,
    lat: 38.5094
  }, {
    lng: -82.7197,
    lat: 38.5091
  }, {
    lng: -82.7201,
    lat: 38.5085
  }, {
    lng: -82.72,
    lat: 38.5085
  }, {
    lng: -82.72,
    lat: 38.5085
  }, {
    lng: -82.7199,
    lat: 38.5084
  }, {
    lng: -82.7196,
    lat: 38.5083
  }, {
    lng: -82.7185,
    lat: 38.5078
  }, {
    lng: -82.718,
    lat: 38.5076
  }, {
    lng: -82.7179,
    lat: 38.5075
  }, {
    lng: -82.7175,
    lat: 38.5073
  }, {
    lng: -82.7171,
    lat: 38.5071
  }, {
    lng: -82.7167,
    lat: 38.5069
  }, {
    lng: -82.7165,
    lat: 38.5069
  }, {
    lng: -82.7167,
    lat: 38.5066
  }, {
    lng: -82.7167,
    lat: 38.5066
  }, {
    lng: -82.7166,
    lat: 38.5065
  }, {
    lng: -82.7166,
    lat: 38.5065
  }, {
    lng: -82.7166,
    lat: 38.5064
  }, {
    lng: -82.7166,
    lat: 38.5064
  }, {
    lng: -82.7166,
    lat: 38.5063
  }, {
    lng: -82.7154,
    lat: 38.5064
  }, {
    lng: -82.7143,
    lat: 38.5065
  }, {
    lng: -82.7142,
    lat: 38.5066
  }, {
    lng: -82.7142,
    lat: 38.5065
  }, {
    lng: -82.7136,
    lat: 38.5071
  }, {
    lng: -82.7134,
    lat: 38.507
  }, {
    lng: -82.7135,
    lat: 38.507
  }, {
    lng: -82.7137,
    lat: 38.5068
  }, {
    lng: -82.714,
    lat: 38.5065
  }, {
    lng: -82.7141,
    lat: 38.5064
  }, {
    lng: -82.7142,
    lat: 38.5064
  }, {
    lng: -82.7134,
    lat: 38.5063
  }, {
    lng: -82.7139,
    lat: 38.5058
  }, {
    lng: -82.7141,
    lat: 38.5055
  }, {
    lng: -82.7144,
    lat: 38.5053
  }, {
    lng: -82.7147,
    lat: 38.5051
  }, {
    lng: -82.7149,
    lat: 38.505
  }, {
    lng: -82.7151,
    lat: 38.5048
  }, {
    lng: -82.7153,
    lat: 38.5045
  }, {
    lng: -82.7156,
    lat: 38.504
  }, {
    lng: -82.7157,
    lat: 38.5039
  }, {
    lng: -82.7158,
    lat: 38.5039
  }, {
    lng: -82.7159,
    lat: 38.5038
  }, {
    lng: -82.716,
    lat: 38.5038
  }, {
    lng: -82.7177,
    lat: 38.5043
  }, {
    lng: -82.7182,
    lat: 38.5045
  }, {
    lng: -82.7209,
    lat: 38.5053
  }, {
    lng: -82.7223,
    lat: 38.5057
  }, {
    lng: -82.7225,
    lat: 38.5054
  }, {
    lng: -82.7227,
    lat: 38.5051
  }, {
    lng: -82.723,
    lat: 38.5049
  }, {
    lng: -82.7233,
    lat: 38.5046
  }, {
    lng: -82.7236,
    lat: 38.5043
  }, {
    lng: -82.7239,
    lat: 38.504
  }, {
    lng: -82.7242,
    lat: 38.5038
  }, {
    lng: -82.7244,
    lat: 38.5037
  }, {
    lng: -82.7246,
    lat: 38.5036
  }, {
    lng: -82.7257,
    lat: 38.503
  }, {
    lng: -82.7261,
    lat: 38.5028
  }, {
    lng: -82.7269,
    lat: 38.5022
  }, {
    lng: -82.7271,
    lat: 38.5021
  }, {
    lng: -82.7272,
    lat: 38.502
  }, {
    lng: -82.7274,
    lat: 38.5018
  }, {
    lng: -82.7275,
    lat: 38.5017
  }, {
    lng: -82.7275,
    lat: 38.5016
  }, {
    lng: -82.7276,
    lat: 38.5015
  }, {
    lng: -82.7277,
    lat: 38.5014
  }, {
    lng: -82.7278,
    lat: 38.5012
  }, {
    lng: -82.7279,
    lat: 38.5011
  }, {
    lng: -82.728,
    lat: 38.501
  }, {
    lng: -82.728,
    lat: 38.5007
  }, {
    lng: -82.7282,
    lat: 38.5004
  }, {
    lng: -82.7283,
    lat: 38.5003
  }, {
    lng: -82.7284,
    lat: 38.5001
  }, {
    lng: -82.7288,
    lat: 38.4997
  }, {
    lng: -82.729,
    lat: 38.4995
  }, {
    lng: -82.729,
    lat: 38.4995
  }, {
    lng: -82.7292,
    lat: 38.4994
  }, {
    lng: -82.7293,
    lat: 38.4993
  }, {
    lng: -82.7294,
    lat: 38.4992
  }, {
    lng: -82.7295,
    lat: 38.4991
  }, {
    lng: -82.7296,
    lat: 38.499
  }, {
    lng: -82.7298,
    lat: 38.4988
  }, {
    lng: -82.7299,
    lat: 38.4987
  }, {
    lng: -82.7299,
    lat: 38.4986
  }, {
    lng: -82.73,
    lat: 38.4985
  }, {
    lng: -82.73,
    lat: 38.4984
  }, {
    lng: -82.73,
    lat: 38.4983
  }, {
    lng: -82.7299,
    lat: 38.4982
  }, {
    lng: -82.7299,
    lat: 38.4981
  }, {
    lng: -82.7298,
    lat: 38.498
  }, {
    lng: -82.7297,
    lat: 38.4979
  }, {
    lng: -82.7296,
    lat: 38.4978
  }, {
    lng: -82.7296,
    lat: 38.4978
  }, {
    lng: -82.7295,
    lat: 38.4978
  }, {
    lng: -82.7294,
    lat: 38.4977
  }, {
    lng: -82.7294,
    lat: 38.4977
  }, {
    lng: -82.7292,
    lat: 38.4976
  }, {
    lng: -82.7288,
    lat: 38.4975
  }, {
    lng: -82.7277,
    lat: 38.4972
  }, {
    lng: -82.7267,
    lat: 38.4969
  }, {
    lng: -82.7263,
    lat: 38.4968
  }, {
    lng: -82.7261,
    lat: 38.4967
  }, {
    lng: -82.7259,
    lat: 38.4967
  }, {
    lng: -82.7258,
    lat: 38.4966
  }, {
    lng: -82.7258,
    lat: 38.4965
  }, {
    lng: -82.7264,
    lat: 38.4949
  }, {
    lng: -82.7263,
    lat: 38.4944
  }, {
    lng: -82.7261,
    lat: 38.4936
  }, {
    lng: -82.7274,
    lat: 38.4938
  }, {
    lng: -82.7271,
    lat: 38.4932
  }, {
    lng: -82.728,
    lat: 38.4921
  }, {
    lng: -82.7292,
    lat: 38.4924
  }, {
    lng: -82.7295,
    lat: 38.4924
  }, {
    lng: -82.7297,
    lat: 38.4925
  }, {
    lng: -82.73,
    lat: 38.4924
  }, {
    lng: -82.7301,
    lat: 38.4924
  }, {
    lng: -82.7314,
    lat: 38.4917
  }, {
    lng: -82.7326,
    lat: 38.4913
  }, {
    lng: -82.733,
    lat: 38.4916
  }, {
    lng: -82.7329,
    lat: 38.491
  }, {
    lng: -82.7327,
    lat: 38.4906
  }, {
    lng: -82.7327,
    lat: 38.4903
  }, {
    lng: -82.7325,
    lat: 38.4898
  }, {
    lng: -82.7325,
    lat: 38.4895
  }, {
    lng: -82.7325,
    lat: 38.4894
  }, {
    lng: -82.7322,
    lat: 38.4882
  }, {
    lng: -82.732,
    lat: 38.4881
  }, {
    lng: -82.7319,
    lat: 38.4881
  }, {
    lng: -82.7317,
    lat: 38.488
  }, {
    lng: -82.7315,
    lat: 38.488
  }, {
    lng: -82.7313,
    lat: 38.488
  }, {
    lng: -82.7312,
    lat: 38.488
  }, {
    lng: -82.7311,
    lat: 38.488
  }, {
    lng: -82.7309,
    lat: 38.488
  }, {
    lng: -82.7309,
    lat: 38.4879
  }, {
    lng: -82.7308,
    lat: 38.4876
  }, {
    lng: -82.7306,
    lat: 38.4869
  }, {
    lng: -82.7305,
    lat: 38.4874
  }, {
    lng: -82.7303,
    lat: 38.4879
  }, {
    lng: -82.7301,
    lat: 38.4884
  }, {
    lng: -82.73,
    lat: 38.4885
  }, {
    lng: -82.7298,
    lat: 38.4887
  }, {
    lng: -82.7295,
    lat: 38.4889
  }, {
    lng: -82.7288,
    lat: 38.4894
  }, {
    lng: -82.7275,
    lat: 38.4903
  }, {
    lng: -82.7272,
    lat: 38.4906
  }, {
    lng: -82.7268,
    lat: 38.4909
  }, {
    lng: -82.7267,
    lat: 38.4909
  }, {
    lng: -82.7255,
    lat: 38.4914
  }, {
    lng: -82.7245,
    lat: 38.4919
  }, {
    lng: -82.7243,
    lat: 38.492
  }, {
    lng: -82.7242,
    lat: 38.4922
  }, {
    lng: -82.7241,
    lat: 38.4924
  }, {
    lng: -82.7237,
    lat: 38.4927
  }, {
    lng: -82.7235,
    lat: 38.4929
  }, {
    lng: -82.7234,
    lat: 38.4928
  }, {
    lng: -82.7233,
    lat: 38.4928
  }, {
    lng: -82.7233,
    lat: 38.4927
  }, {
    lng: -82.7232,
    lat: 38.4927
  }, {
    lng: -82.7231,
    lat: 38.4927
  }, {
    lng: -82.723,
    lat: 38.4927
  }, {
    lng: -82.7229,
    lat: 38.4927
  }, {
    lng: -82.7228,
    lat: 38.4927
  }, {
    lng: -82.7227,
    lat: 38.4927
  }, {
    lng: -82.7226,
    lat: 38.4928
  }, {
    lng: -82.7223,
    lat: 38.493
  }, {
    lng: -82.7222,
    lat: 38.4931
  }, {
    lng: -82.7219,
    lat: 38.4933
  }, {
    lng: -82.7213,
    lat: 38.4936
  }, {
    lng: -82.7211,
    lat: 38.4937
  }, {
    lng: -82.721,
    lat: 38.4938
  }, {
    lng: -82.7209,
    lat: 38.4938
  }, {
    lng: -82.7204,
    lat: 38.4939
  }, {
    lng: -82.72,
    lat: 38.494
  }, {
    lng: -82.7199,
    lat: 38.494
  }, {
    lng: -82.7199,
    lat: 38.4941
  }, {
    lng: -82.7197,
    lat: 38.4942
  }, {
    lng: -82.7193,
    lat: 38.4944
  }, {
    lng: -82.7191,
    lat: 38.4946
  }, {
    lng: -82.7185,
    lat: 38.4953
  }, {
    lng: -82.7183,
    lat: 38.4956
  }, {
    lng: -82.7178,
    lat: 38.4964
  }, {
    lng: -82.7172,
    lat: 38.4972
  }, {
    lng: -82.7167,
    lat: 38.4981
  }, {
    lng: -82.7164,
    lat: 38.4984
  }, {
    lng: -82.7163,
    lat: 38.4986
  }, {
    lng: -82.7162,
    lat: 38.4987
  }, {
    lng: -82.716,
    lat: 38.4989
  }, {
    lng: -82.7158,
    lat: 38.499
  }, {
    lng: -82.7157,
    lat: 38.4992
  }, {
    lng: -82.7154,
    lat: 38.4994
  }, {
    lng: -82.7151,
    lat: 38.4996
  }, {
    lng: -82.7151,
    lat: 38.4997
  }, {
    lng: -82.7149,
    lat: 38.4998
  }, {
    lng: -82.7148,
    lat: 38.4998
  }, {
    lng: -82.7148,
    lat: 38.4999
  }, {
    lng: -82.7146,
    lat: 38.4999
  }, {
    lng: -82.7143,
    lat: 38.5
  }, {
    lng: -82.7142,
    lat: 38.5001
  }, {
    lng: -82.7141,
    lat: 38.5001
  }, {
    lng: -82.714,
    lat: 38.5001
  }, {
    lng: -82.7138,
    lat: 38.5001
  }, {
    lng: -82.7137,
    lat: 38.5002
  }, {
    lng: -82.7131,
    lat: 38.5002
  }, {
    lng: -82.7125,
    lat: 38.5002
  }, {
    lng: -82.7123,
    lat: 38.5002
  }, {
    lng: -82.7109,
    lat: 38.5001
  }, {
    lng: -82.7106,
    lat: 38.5001
  }, {
    lng: -82.7099,
    lat: 38.5001
  }, {
    lng: -82.709,
    lat: 38.4999
  }, {
    lng: -82.7088,
    lat: 38.4999
  }, {
    lng: -82.7087,
    lat: 38.4999
  }, {
    lng: -82.7086,
    lat: 38.4999
  }, {
    lng: -82.7084,
    lat: 38.5
  }, {
    lng: -82.7082,
    lat: 38.5
  }, {
    lng: -82.7078,
    lat: 38.5002
  }, {
    lng: -82.7078,
    lat: 38.5002
  }, {
    lng: -82.7076,
    lat: 38.5003
  }, {
    lng: -82.7074,
    lat: 38.5004
  }, {
    lng: -82.7071,
    lat: 38.5005
  }, {
    lng: -82.7069,
    lat: 38.5007
  }, {
    lng: -82.7065,
    lat: 38.501
  }, {
    lng: -82.7062,
    lat: 38.5012
  }, {
    lng: -82.7058,
    lat: 38.5016
  }, {
    lng: -82.7056,
    lat: 38.5017
  }, {
    lng: -82.7055,
    lat: 38.5018
  }, {
    lng: -82.7052,
    lat: 38.5021
  }, {
    lng: -82.705,
    lat: 38.5022
  }, {
    lng: -82.7048,
    lat: 38.5023
  }, {
    lng: -82.7043,
    lat: 38.5027
  }, {
    lng: -82.7042,
    lat: 38.5028
  }, {
    lng: -82.7036,
    lat: 38.5032
  }, {
    lng: -82.7029,
    lat: 38.5037
  }, {
    lng: -82.7012,
    lat: 38.5049
  }, {
    lng: -82.7009,
    lat: 38.5051
  }, {
    lng: -82.7007,
    lat: 38.5051
  }, {
    lng: -82.7003,
    lat: 38.5053
  }, {
    lng: -82.7002,
    lat: 38.5053
  }, {
    lng: -82.6999,
    lat: 38.5053
  }, {
    lng: -82.6998,
    lat: 38.5053
  }, {
    lng: -82.6995,
    lat: 38.5054
  }, {
    lng: -82.699,
    lat: 38.5054
  }, {
    lng: -82.6983,
    lat: 38.5053
  }, {
    lng: -82.6984,
    lat: 38.505
  }, {
    lng: -82.6985,
    lat: 38.5047
  }, {
    lng: -82.6985,
    lat: 38.5044
  }, {
    lng: -82.6985,
    lat: 38.5041
  }, {
    lng: -82.6985,
    lat: 38.504
  }, {
    lng: -82.6985,
    lat: 38.5038
  }, {
    lng: -82.6984,
    lat: 38.5037
  }, {
    lng: -82.6983,
    lat: 38.5035
  }, {
    lng: -82.6982,
    lat: 38.5034
  }, {
    lng: -82.6981,
    lat: 38.5032
  }, {
    lng: -82.6981,
    lat: 38.503
  }, {
    lng: -82.698,
    lat: 38.5027
  }, {
    lng: -82.698,
    lat: 38.5026
  }, {
    lng: -82.698,
    lat: 38.5024
  }, {
    lng: -82.698,
    lat: 38.5023
  }, {
    lng: -82.698,
    lat: 38.5022
  }, {
    lng: -82.6981,
    lat: 38.5021
  }, {
    lng: -82.6971,
    lat: 38.5021
  }, {
    lng: -82.697,
    lat: 38.5025
  }, {
    lng: -82.6965,
    lat: 38.5034
  }, {
    lng: -82.6958,
    lat: 38.5044
  }, {
    lng: -82.6949,
    lat: 38.5041
  }, {
    lng: -82.6942,
    lat: 38.5037
  }, {
    lng: -82.6939,
    lat: 38.5035
  }, {
    lng: -82.6938,
    lat: 38.5034
  }, {
    lng: -82.6937,
    lat: 38.5032
  }, {
    lng: -82.6937,
    lat: 38.5031
  }, {
    lng: -82.6937,
    lat: 38.503
  }, {
    lng: -82.6937,
    lat: 38.5029
  }, {
    lng: -82.6937,
    lat: 38.5028
  }, {
    lng: -82.6937,
    lat: 38.5027
  }, {
    lng: -82.6938,
    lat: 38.5026
  }, {
    lng: -82.6938,
    lat: 38.5026
  }, {
    lng: -82.694,
    lat: 38.5025
  }, {
    lng: -82.6941,
    lat: 38.5024
  }, {
    lng: -82.6945,
    lat: 38.5021
  }, {
    lng: -82.695,
    lat: 38.5017
  }, {
    lng: -82.6951,
    lat: 38.5016
  }, {
    lng: -82.6949,
    lat: 38.5016
  }, {
    lng: -82.6945,
    lat: 38.5018
  }, {
    lng: -82.6941,
    lat: 38.5019
  }, {
    lng: -82.694,
    lat: 38.502
  }, {
    lng: -82.6938,
    lat: 38.5022
  }, {
    lng: -82.6932,
    lat: 38.5028
  }, {
    lng: -82.6931,
    lat: 38.503
  }, {
    lng: -82.6928,
    lat: 38.5032
  }, {
    lng: -82.6928,
    lat: 38.5033
  }, {
    lng: -82.6927,
    lat: 38.5034
  }, {
    lng: -82.6927,
    lat: 38.5034
  }]]],
  options: {
    fillColor: '#0fbb58',
    fillOpacity: 0.4,
    strokeColor: '#0B8C42',
    strokeWeight: 1,
    strokeOpacity: 0.4,
    clickable: true,
    visible: true,
    zIndex: 1000
  }
};
var carrierRoute06 = {
  "carrierRoute": "41169C001",
  "paths": [[[{
    "lng": -82.6898,
    "lat": 38.5261
  }, {
    "lng": -82.6899,
    "lat": 38.5262
  }, {
    "lng": -82.69,
    "lat": 38.5263
  }, {
    "lng": -82.6902,
    "lat": 38.5265
  }, {
    "lng": -82.6906,
    "lat": 38.5269
  }, {
    "lng": -82.6911,
    "lat": 38.5272
  }, {
    "lng": -82.6916,
    "lat": 38.5275
  }, {
    "lng": -82.6918,
    "lat": 38.5277
  }, {
    "lng": -82.692,
    "lat": 38.5278
  }, {
    "lng": -82.6924,
    "lat": 38.528
  }, {
    "lng": -82.6933,
    "lat": 38.5285
  }, {
    "lng": -82.6936,
    "lat": 38.5286
  }, {
    "lng": -82.694,
    "lat": 38.5289
  }, {
    "lng": -82.6945,
    "lat": 38.5292
  }, {
    "lng": -82.6949,
    "lat": 38.5295
  }, {
    "lng": -82.6958,
    "lat": 38.5302
  }, {
    "lng": -82.696,
    "lat": 38.5304
  }, {
    "lng": -82.6962,
    "lat": 38.5305
  }, {
    "lng": -82.6967,
    "lat": 38.5309
  }, {
    "lng": -82.6969,
    "lat": 38.531
  }, {
    "lng": -82.6969,
    "lat": 38.531
  }, {
    "lng": -82.6974,
    "lat": 38.5314
  }, {
    "lng": -82.6975,
    "lat": 38.5314
  }, {
    "lng": -82.6977,
    "lat": 38.5315
  }, {
    "lng": -82.6979,
    "lat": 38.5316
  }, {
    "lng": -82.6978,
    "lat": 38.5317
  }, {
    "lng": -82.6974,
    "lat": 38.532
  }, {
    "lng": -82.6977,
    "lat": 38.5323
  }, {
    "lng": -82.6983,
    "lat": 38.5326
  }, {
    "lng": -82.6987,
    "lat": 38.5329
  }, {
    "lng": -82.699,
    "lat": 38.5332
  }, {
    "lng": -82.6991,
    "lat": 38.5333
  }, {
    "lng": -82.699,
    "lat": 38.5333
  }, {
    "lng": -82.6989,
    "lat": 38.5334
  }, {
    "lng": -82.6984,
    "lat": 38.5337
  }, {
    "lng": -82.6982,
    "lat": 38.534
  }, {
    "lng": -82.698,
    "lat": 38.5344
  }, {
    "lng": -82.6978,
    "lat": 38.5347
  }, {
    "lng": -82.6977,
    "lat": 38.5349
  }, {
    "lng": -82.6976,
    "lat": 38.5351
  }, {
    "lng": -82.6975,
    "lat": 38.5353
  }, {
    "lng": -82.6974,
    "lat": 38.5354
  }, {
    "lng": -82.6973,
    "lat": 38.5354
  }, {
    "lng": -82.6973,
    "lat": 38.5355
  }, {
    "lng": -82.6973,
    "lat": 38.5355
  }, {
    "lng": -82.6972,
    "lat": 38.5356
  }, {
    "lng": -82.6972,
    "lat": 38.5357
  }, {
    "lng": -82.6972,
    "lat": 38.5357
  }, {
    "lng": -82.697,
    "lat": 38.5361
  }, {
    "lng": -82.6964,
    "lat": 38.5358
  }, {
    "lng": -82.696,
    "lat": 38.5355
  }, {
    "lng": -82.696,
    "lat": 38.5355
  }, {
    "lng": -82.696,
    "lat": 38.5354
  }, {
    "lng": -82.6963,
    "lat": 38.5352
  }, {
    "lng": -82.6966,
    "lat": 38.5349
  }, {
    "lng": -82.6963,
    "lat": 38.5345
  }, {
    "lng": -82.6959,
    "lat": 38.5341
  }, {
    "lng": -82.6959,
    "lat": 38.5342
  }, {
    "lng": -82.6957,
    "lat": 38.5345
  }, {
    "lng": -82.6957,
    "lat": 38.5345
  }, {
    "lng": -82.6958,
    "lat": 38.5347
  }, {
    "lng": -82.6959,
    "lat": 38.5348
  }, {
    "lng": -82.6958,
    "lat": 38.535
  }, {
    "lng": -82.6956,
    "lat": 38.5351
  }, {
    "lng": -82.6953,
    "lat": 38.5352
  }, {
    "lng": -82.695,
    "lat": 38.5353
  }, {
    "lng": -82.6949,
    "lat": 38.5354
  }, {
    "lng": -82.6946,
    "lat": 38.536
  }, {
    "lng": -82.6949,
    "lat": 38.5364
  }, {
    "lng": -82.695,
    "lat": 38.5365
  }, {
    "lng": -82.6951,
    "lat": 38.5366
  }, {
    "lng": -82.6952,
    "lat": 38.5367
  }, {
    "lng": -82.6953,
    "lat": 38.5368
  }, {
    "lng": -82.6955,
    "lat": 38.5369
  }, {
    "lng": -82.6957,
    "lat": 38.5371
  }, {
    "lng": -82.6958,
    "lat": 38.5372
  }, {
    "lng": -82.6959,
    "lat": 38.5373
  }, {
    "lng": -82.6961,
    "lat": 38.5375
  }, {
    "lng": -82.6963,
    "lat": 38.5377
  }, {
    "lng": -82.6966,
    "lat": 38.5379
  }, {
    "lng": -82.6967,
    "lat": 38.5381
  }, {
    "lng": -82.6969,
    "lat": 38.5382
  }, {
    "lng": -82.697,
    "lat": 38.5383
  }, {
    "lng": -82.6973,
    "lat": 38.5385
  }, {
    "lng": -82.6976,
    "lat": 38.5387
  }, {
    "lng": -82.6978,
    "lat": 38.539
  }, {
    "lng": -82.698,
    "lat": 38.5391
  }, {
    "lng": -82.6983,
    "lat": 38.5393
  }, {
    "lng": -82.6985,
    "lat": 38.5395
  }, {
    "lng": -82.6986,
    "lat": 38.5396
  }, {
    "lng": -82.6988,
    "lat": 38.5397
  }, {
    "lng": -82.6989,
    "lat": 38.5398
  }, {
    "lng": -82.6991,
    "lat": 38.54
  }, {
    "lng": -82.6993,
    "lat": 38.54
  }, {
    "lng": -82.6994,
    "lat": 38.5402
  }, {
    "lng": -82.6997,
    "lat": 38.5403
  }, {
    "lng": -82.7,
    "lat": 38.5405
  }, {
    "lng": -82.7004,
    "lat": 38.5407
  }, {
    "lng": -82.7008,
    "lat": 38.5409
  }, {
    "lng": -82.7011,
    "lat": 38.5411
  }, {
    "lng": -82.7014,
    "lat": 38.5412
  }, {
    "lng": -82.7016,
    "lat": 38.5413
  }, {
    "lng": -82.7019,
    "lat": 38.5414
  }, {
    "lng": -82.702,
    "lat": 38.5415
  }, {
    "lng": -82.7024,
    "lat": 38.5416
  }, {
    "lng": -82.7026,
    "lat": 38.5417
  }, {
    "lng": -82.7028,
    "lat": 38.5418
  }, {
    "lng": -82.7034,
    "lat": 38.5421
  }, {
    "lng": -82.7038,
    "lat": 38.5423
  }, {
    "lng": -82.704,
    "lat": 38.5424
  }, {
    "lng": -82.7042,
    "lat": 38.5425
  }, {
    "lng": -82.7046,
    "lat": 38.5427
  }, {
    "lng": -82.707,
    "lat": 38.5436
  }, {
    "lng": -82.7073,
    "lat": 38.5437
  }, {
    "lng": -82.708,
    "lat": 38.5441
  }, {
    "lng": -82.7084,
    "lat": 38.5443
  }, {
    "lng": -82.7088,
    "lat": 38.5444
  }, {
    "lng": -82.7093,
    "lat": 38.5446
  }, {
    "lng": -82.7096,
    "lat": 38.5448
  }, {
    "lng": -82.7097,
    "lat": 38.5448
  }, {
    "lng": -82.7099,
    "lat": 38.5449
  }, {
    "lng": -82.7102,
    "lat": 38.5446
  }, {
    "lng": -82.711,
    "lat": 38.5438
  }, {
    "lng": -82.7114,
    "lat": 38.5435
  }, {
    "lng": -82.7124,
    "lat": 38.5431
  }, {
    "lng": -82.7126,
    "lat": 38.5428
  }, {
    "lng": -82.7126,
    "lat": 38.5427
  }, {
    "lng": -82.7134,
    "lat": 38.543
  }, {
    "lng": -82.7155,
    "lat": 38.5438
  }, {
    "lng": -82.7166,
    "lat": 38.5442
  }, {
    "lng": -82.717,
    "lat": 38.5442
  }, {
    "lng": -82.7189,
    "lat": 38.5446
  }, {
    "lng": -82.7189,
    "lat": 38.5445
  }, {
    "lng": -82.7202,
    "lat": 38.5441
  }, {
    "lng": -82.7203,
    "lat": 38.5439
  }, {
    "lng": -82.7206,
    "lat": 38.5436
  }, {
    "lng": -82.721,
    "lat": 38.5432
  }, {
    "lng": -82.7214,
    "lat": 38.5428
  }, {
    "lng": -82.7216,
    "lat": 38.5427
  }, {
    "lng": -82.722,
    "lat": 38.5423
  }, {
    "lng": -82.722,
    "lat": 38.5423
  }, {
    "lng": -82.7241,
    "lat": 38.5427
  }, {
    "lng": -82.7275,
    "lat": 38.5432
  }, {
    "lng": -82.7277,
    "lat": 38.5433
  }, {
    "lng": -82.7281,
    "lat": 38.5433
  }, {
    "lng": -82.729,
    "lat": 38.5434
  }, {
    "lng": -82.729,
    "lat": 38.5435
  }, {
    "lng": -82.7296,
    "lat": 38.5435
  }, {
    "lng": -82.7297,
    "lat": 38.5435
  }, {
    "lng": -82.7308,
    "lat": 38.5435
  }, {
    "lng": -82.7313,
    "lat": 38.5435
  }, {
    "lng": -82.7335,
    "lat": 38.5433
  }, {
    "lng": -82.7402,
    "lat": 38.5444
  }, {
    "lng": -82.7404,
    "lat": 38.5444
  }, {
    "lng": -82.7405,
    "lat": 38.5442
  }, {
    "lng": -82.7406,
    "lat": 38.5441
  }, {
    "lng": -82.741,
    "lat": 38.5438
  }, {
    "lng": -82.7412,
    "lat": 38.5436
  }, {
    "lng": -82.7424,
    "lat": 38.5428
  }, {
    "lng": -82.7425,
    "lat": 38.5427
  }, {
    "lng": -82.7433,
    "lat": 38.5421
  }, {
    "lng": -82.7434,
    "lat": 38.5419
  }, {
    "lng": -82.7435,
    "lat": 38.5419
  }, {
    "lng": -82.7435,
    "lat": 38.5418
  }, {
    "lng": -82.7436,
    "lat": 38.5417
  }, {
    "lng": -82.7437,
    "lat": 38.5416
  }, {
    "lng": -82.7404,
    "lat": 38.5411
  }, {
    "lng": -82.7391,
    "lat": 38.5409
  }, {
    "lng": -82.7371,
    "lat": 38.5406
  }, {
    "lng": -82.7361,
    "lat": 38.5404
  }, {
    "lng": -82.7355,
    "lat": 38.5404
  }, {
    "lng": -82.7353,
    "lat": 38.5403
  }, {
    "lng": -82.7346,
    "lat": 38.5403
  }, {
    "lng": -82.7336,
    "lat": 38.5402
  }, {
    "lng": -82.7326,
    "lat": 38.5402
  }, {
    "lng": -82.7316,
    "lat": 38.5402
  }, {
    "lng": -82.7313,
    "lat": 38.5402
  }, {
    "lng": -82.7309,
    "lat": 38.5402
  }, {
    "lng": -82.7308,
    "lat": 38.5402
  }, {
    "lng": -82.7308,
    "lat": 38.5401
  }, {
    "lng": -82.7298,
    "lat": 38.5401
  }, {
    "lng": -82.7287,
    "lat": 38.5402
  }, {
    "lng": -82.7286,
    "lat": 38.5403
  }, {
    "lng": -82.7281,
    "lat": 38.5403
  }, {
    "lng": -82.7267,
    "lat": 38.5403
  }, {
    "lng": -82.7253,
    "lat": 38.5403
  }, {
    "lng": -82.7244,
    "lat": 38.5404
  }, {
    "lng": -82.7244,
    "lat": 38.5403
  }, {
    "lng": -82.7241,
    "lat": 38.5403
  }, {
    "lng": -82.7226,
    "lat": 38.5403
  }, {
    "lng": -82.7222,
    "lat": 38.5403
  }, {
    "lng": -82.7215,
    "lat": 38.5403
  }, {
    "lng": -82.7212,
    "lat": 38.5403
  }, {
    "lng": -82.7199,
    "lat": 38.5404
  }, {
    "lng": -82.7185,
    "lat": 38.5404
  }, {
    "lng": -82.718,
    "lat": 38.5404
  }, {
    "lng": -82.7174,
    "lat": 38.5404
  }, {
    "lng": -82.7171,
    "lat": 38.5404
  }, {
    "lng": -82.7168,
    "lat": 38.5404
  }, {
    "lng": -82.7165,
    "lat": 38.5404
  }, {
    "lng": -82.7163,
    "lat": 38.5404
  }, {
    "lng": -82.7159,
    "lat": 38.5404
  }, {
    "lng": -82.7156,
    "lat": 38.5403
  }, {
    "lng": -82.7154,
    "lat": 38.54
  }, {
    "lng": -82.7157,
    "lat": 38.5398
  }, {
    "lng": -82.7159,
    "lat": 38.5397
  }, {
    "lng": -82.7162,
    "lat": 38.5396
  }, {
    "lng": -82.7163,
    "lat": 38.5396
  }, {
    "lng": -82.7167,
    "lat": 38.5395
  }, {
    "lng": -82.717,
    "lat": 38.5395
  }, {
    "lng": -82.7172,
    "lat": 38.5396
  }, {
    "lng": -82.7174,
    "lat": 38.5396
  }, {
    "lng": -82.7175,
    "lat": 38.5395
  }, {
    "lng": -82.7176,
    "lat": 38.5394
  }, {
    "lng": -82.7176,
    "lat": 38.5393
  }, {
    "lng": -82.7175,
    "lat": 38.5392
  }, {
    "lng": -82.7175,
    "lat": 38.5389
  }, {
    "lng": -82.7175,
    "lat": 38.5388
  }, {
    "lng": -82.7176,
    "lat": 38.5385
  }, {
    "lng": -82.7177,
    "lat": 38.5382
  }, {
    "lng": -82.718,
    "lat": 38.5375
  }, {
    "lng": -82.7181,
    "lat": 38.5373
  }, {
    "lng": -82.7183,
    "lat": 38.5368
  }, {
    "lng": -82.7183,
    "lat": 38.5367
  }, {
    "lng": -82.7183,
    "lat": 38.5366
  }, {
    "lng": -82.7185,
    "lat": 38.536
  }, {
    "lng": -82.7186,
    "lat": 38.5355
  }, {
    "lng": -82.7186,
    "lat": 38.5354
  }, {
    "lng": -82.7187,
    "lat": 38.5353
  }, {
    "lng": -82.7189,
    "lat": 38.535
  }, {
    "lng": -82.7192,
    "lat": 38.5347
  }, {
    "lng": -82.72,
    "lat": 38.534
  }, {
    "lng": -82.7206,
    "lat": 38.5335
  }, {
    "lng": -82.7208,
    "lat": 38.5334
  }, {
    "lng": -82.7209,
    "lat": 38.5334
  }, {
    "lng": -82.7212,
    "lat": 38.5334
  }, {
    "lng": -82.7216,
    "lat": 38.5334
  }, {
    "lng": -82.722,
    "lat": 38.5335
  }, {
    "lng": -82.7226,
    "lat": 38.5336
  }, {
    "lng": -82.7231,
    "lat": 38.5336
  }, {
    "lng": -82.7232,
    "lat": 38.5336
  }, {
    "lng": -82.7234,
    "lat": 38.5337
  }, {
    "lng": -82.7236,
    "lat": 38.5337
  }, {
    "lng": -82.7244,
    "lat": 38.5341
  }, {
    "lng": -82.7263,
    "lat": 38.5348
  }, {
    "lng": -82.7264,
    "lat": 38.5348
  }, {
    "lng": -82.7264,
    "lat": 38.5348
  }, {
    "lng": -82.7264,
    "lat": 38.5348
  }, {
    "lng": -82.7265,
    "lat": 38.5347
  }, {
    "lng": -82.7276,
    "lat": 38.5355
  }, {
    "lng": -82.728,
    "lat": 38.5351
  }, {
    "lng": -82.7284,
    "lat": 38.5354
  }, {
    "lng": -82.7287,
    "lat": 38.5357
  }, {
    "lng": -82.7291,
    "lat": 38.5359
  }, {
    "lng": -82.7295,
    "lat": 38.5362
  }, {
    "lng": -82.7296,
    "lat": 38.5363
  }, {
    "lng": -82.7298,
    "lat": 38.5365
  }, {
    "lng": -82.7299,
    "lat": 38.5366
  }, {
    "lng": -82.7301,
    "lat": 38.5365
  }, {
    "lng": -82.7302,
    "lat": 38.5365
  }, {
    "lng": -82.7302,
    "lat": 38.5364
  }, {
    "lng": -82.7303,
    "lat": 38.5362
  }, {
    "lng": -82.7305,
    "lat": 38.5359
  }, {
    "lng": -82.7305,
    "lat": 38.5358
  }, {
    "lng": -82.7296,
    "lat": 38.5351
  }, {
    "lng": -82.7292,
    "lat": 38.5346
  }, {
    "lng": -82.7289,
    "lat": 38.534
  }, {
    "lng": -82.7288,
    "lat": 38.5339
  }, {
    "lng": -82.7284,
    "lat": 38.5333
  }, {
    "lng": -82.7284,
    "lat": 38.5323
  }, {
    "lng": -82.7286,
    "lat": 38.5312
  }, {
    "lng": -82.7285,
    "lat": 38.5305
  }, {
    "lng": -82.7283,
    "lat": 38.5301
  }, {
    "lng": -82.7279,
    "lat": 38.5292
  }, {
    "lng": -82.7276,
    "lat": 38.5279
  }, {
    "lng": -82.7272,
    "lat": 38.5267
  }, {
    "lng": -82.727,
    "lat": 38.5262
  }, {
    "lng": -82.7269,
    "lat": 38.5254
  }, {
    "lng": -82.7261,
    "lat": 38.5254
  }, {
    "lng": -82.7259,
    "lat": 38.526
  }, {
    "lng": -82.726,
    "lat": 38.5277
  }, {
    "lng": -82.7259,
    "lat": 38.5274
  }, {
    "lng": -82.7256,
    "lat": 38.5272
  }, {
    "lng": -82.7256,
    "lat": 38.5271
  }, {
    "lng": -82.7255,
    "lat": 38.527
  }, {
    "lng": -82.7254,
    "lat": 38.527
  }, {
    "lng": -82.7254,
    "lat": 38.527
  }, {
    "lng": -82.7253,
    "lat": 38.527
  }, {
    "lng": -82.7252,
    "lat": 38.527
  }, {
    "lng": -82.7251,
    "lat": 38.5271
  }, {
    "lng": -82.7249,
    "lat": 38.5271
  }, {
    "lng": -82.7248,
    "lat": 38.5272
  }, {
    "lng": -82.7245,
    "lat": 38.5275
  }, {
    "lng": -82.7247,
    "lat": 38.5277
  }, {
    "lng": -82.7248,
    "lat": 38.5279
  }, {
    "lng": -82.7249,
    "lat": 38.528
  }, {
    "lng": -82.725,
    "lat": 38.5281
  }, {
    "lng": -82.7248,
    "lat": 38.5282
  }, {
    "lng": -82.7247,
    "lat": 38.5282
  }, {
    "lng": -82.7244,
    "lat": 38.5282
  }, {
    "lng": -82.7242,
    "lat": 38.5285
  }, {
    "lng": -82.7241,
    "lat": 38.5286
  }, {
    "lng": -82.724,
    "lat": 38.5288
  }, {
    "lng": -82.7238,
    "lat": 38.5292
  }, {
    "lng": -82.7235,
    "lat": 38.5292
  }, {
    "lng": -82.7233,
    "lat": 38.5296
  }, {
    "lng": -82.7217,
    "lat": 38.5309
  }, {
    "lng": -82.7205,
    "lat": 38.5315
  }, {
    "lng": -82.7193,
    "lat": 38.5319
  }, {
    "lng": -82.7194,
    "lat": 38.532
  }, {
    "lng": -82.7194,
    "lat": 38.5322
  }, {
    "lng": -82.7193,
    "lat": 38.5322
  }, {
    "lng": -82.7192,
    "lat": 38.5323
  }, {
    "lng": -82.7191,
    "lat": 38.5324
  }, {
    "lng": -82.719,
    "lat": 38.5324
  }, {
    "lng": -82.7189,
    "lat": 38.5325
  }, {
    "lng": -82.7186,
    "lat": 38.5327
  }, {
    "lng": -82.7186,
    "lat": 38.5328
  }, {
    "lng": -82.7185,
    "lat": 38.5328
  }, {
    "lng": -82.7184,
    "lat": 38.533
  }, {
    "lng": -82.7182,
    "lat": 38.5331
  }, {
    "lng": -82.7181,
    "lat": 38.5333
  }, {
    "lng": -82.7181,
    "lat": 38.5334
  }, {
    "lng": -82.7179,
    "lat": 38.5335
  }, {
    "lng": -82.7177,
    "lat": 38.5337
  }, {
    "lng": -82.7174,
    "lat": 38.5341
  }, {
    "lng": -82.7171,
    "lat": 38.5343
  }, {
    "lng": -82.717,
    "lat": 38.5343
  }, {
    "lng": -82.7169,
    "lat": 38.5344
  }, {
    "lng": -82.7166,
    "lat": 38.5345
  }, {
    "lng": -82.7164,
    "lat": 38.5345
  }, {
    "lng": -82.7163,
    "lat": 38.5346
  }, {
    "lng": -82.7161,
    "lat": 38.5346
  }, {
    "lng": -82.716,
    "lat": 38.5347
  }, {
    "lng": -82.7158,
    "lat": 38.5348
  }, {
    "lng": -82.7155,
    "lat": 38.535
  }, {
    "lng": -82.7152,
    "lat": 38.5351
  }, {
    "lng": -82.7151,
    "lat": 38.5352
  }, {
    "lng": -82.715,
    "lat": 38.5353
  }, {
    "lng": -82.7149,
    "lat": 38.5353
  }, {
    "lng": -82.7148,
    "lat": 38.5354
  }, {
    "lng": -82.7147,
    "lat": 38.5354
  }, {
    "lng": -82.7147,
    "lat": 38.5354
  }, {
    "lng": -82.7146,
    "lat": 38.5354
  }, {
    "lng": -82.7146,
    "lat": 38.5352
  }, {
    "lng": -82.7145,
    "lat": 38.5358
  }, {
    "lng": -82.7147,
    "lat": 38.5359
  }, {
    "lng": -82.715,
    "lat": 38.5362
  }, {
    "lng": -82.7154,
    "lat": 38.5362
  }, {
    "lng": -82.7158,
    "lat": 38.5364
  }, {
    "lng": -82.7161,
    "lat": 38.5367
  }, {
    "lng": -82.7164,
    "lat": 38.5369
  }, {
    "lng": -82.7167,
    "lat": 38.5373
  }, {
    "lng": -82.7168,
    "lat": 38.5375
  }, {
    "lng": -82.717,
    "lat": 38.5378
  }, {
    "lng": -82.717,
    "lat": 38.5379
  }, {
    "lng": -82.717,
    "lat": 38.5383
  }, {
    "lng": -82.7168,
    "lat": 38.5385
  }, {
    "lng": -82.7164,
    "lat": 38.5387
  }, {
    "lng": -82.716,
    "lat": 38.5389
  }, {
    "lng": -82.7156,
    "lat": 38.5388
  }, {
    "lng": -82.7151,
    "lat": 38.5389
  }, {
    "lng": -82.7148,
    "lat": 38.539
  }, {
    "lng": -82.7147,
    "lat": 38.5392
  }, {
    "lng": -82.7148,
    "lat": 38.5395
  }, {
    "lng": -82.715,
    "lat": 38.5398
  }, {
    "lng": -82.7151,
    "lat": 38.54
  }, {
    "lng": -82.7153,
    "lat": 38.5402
  }, {
    "lng": -82.7153,
    "lat": 38.5403
  }, {
    "lng": -82.7153,
    "lat": 38.5404
  }, {
    "lng": -82.7152,
    "lat": 38.5404
  }, {
    "lng": -82.715,
    "lat": 38.5404
  }, {
    "lng": -82.7148,
    "lat": 38.5404
  }, {
    "lng": -82.715,
    "lat": 38.5405
  }, {
    "lng": -82.7143,
    "lat": 38.5407
  }, {
    "lng": -82.714,
    "lat": 38.541
  }, {
    "lng": -82.7135,
    "lat": 38.5408
  }, {
    "lng": -82.7132,
    "lat": 38.5407
  }, {
    "lng": -82.7126,
    "lat": 38.5405
  }, {
    "lng": -82.7118,
    "lat": 38.5402
  }, {
    "lng": -82.7112,
    "lat": 38.5399
  }, {
    "lng": -82.7105,
    "lat": 38.5396
  }, {
    "lng": -82.7098,
    "lat": 38.5393
  }, {
    "lng": -82.7092,
    "lat": 38.539
  }, {
    "lng": -82.7085,
    "lat": 38.5387
  }, {
    "lng": -82.7079,
    "lat": 38.5383
  }, {
    "lng": -82.7073,
    "lat": 38.538
  }, {
    "lng": -82.7066,
    "lat": 38.5376
  }, {
    "lng": -82.7057,
    "lat": 38.5371
  }, {
    "lng": -82.7053,
    "lat": 38.5369
  }, {
    "lng": -82.7045,
    "lat": 38.5365
  }, {
    "lng": -82.7038,
    "lat": 38.5361
  }, {
    "lng": -82.7031,
    "lat": 38.5358
  }, {
    "lng": -82.7028,
    "lat": 38.5357
  }, {
    "lng": -82.7026,
    "lat": 38.5356
  }, {
    "lng": -82.7023,
    "lat": 38.5355
  }, {
    "lng": -82.702,
    "lat": 38.5353
  }, {
    "lng": -82.6994,
    "lat": 38.5331
  }, {
    "lng": -82.6996,
    "lat": 38.533
  }, {
    "lng": -82.6999,
    "lat": 38.5329
  }, {
    "lng": -82.7,
    "lat": 38.5328
  }, {
    "lng": -82.7001,
    "lat": 38.5329
  }, {
    "lng": -82.7012,
    "lat": 38.5335
  }, {
    "lng": -82.7021,
    "lat": 38.534
  }, {
    "lng": -82.7031,
    "lat": 38.5347
  }, {
    "lng": -82.7038,
    "lat": 38.5351
  }, {
    "lng": -82.7041,
    "lat": 38.5353
  }, {
    "lng": -82.7042,
    "lat": 38.5353
  }, {
    "lng": -82.7042,
    "lat": 38.5354
  }, {
    "lng": -82.7043,
    "lat": 38.5354
  }, {
    "lng": -82.7045,
    "lat": 38.5356
  }, {
    "lng": -82.7047,
    "lat": 38.5358
  }, {
    "lng": -82.7049,
    "lat": 38.536
  }, {
    "lng": -82.705,
    "lat": 38.5359
  }, {
    "lng": -82.7051,
    "lat": 38.5359
  }, {
    "lng": -82.7056,
    "lat": 38.5356
  }, {
    "lng": -82.7058,
    "lat": 38.5354
  }, {
    "lng": -82.7059,
    "lat": 38.5354
  }, {
    "lng": -82.7059,
    "lat": 38.5353
  }, {
    "lng": -82.7061,
    "lat": 38.5352
  }, {
    "lng": -82.7065,
    "lat": 38.5348
  }, {
    "lng": -82.7067,
    "lat": 38.5345
  }, {
    "lng": -82.7069,
    "lat": 38.5343
  }, {
    "lng": -82.707,
    "lat": 38.5342
  }, {
    "lng": -82.707,
    "lat": 38.5342
  }, {
    "lng": -82.7069,
    "lat": 38.534
  }, {
    "lng": -82.7066,
    "lat": 38.5339
  }, {
    "lng": -82.7064,
    "lat": 38.5338
  }, {
    "lng": -82.7062,
    "lat": 38.5336
  }, {
    "lng": -82.706,
    "lat": 38.5334
  }, {
    "lng": -82.7059,
    "lat": 38.5332
  }, {
    "lng": -82.7058,
    "lat": 38.5331
  }, {
    "lng": -82.7057,
    "lat": 38.5329
  }, {
    "lng": -82.7057,
    "lat": 38.5328
  }, {
    "lng": -82.7056,
    "lat": 38.5327
  }, {
    "lng": -82.7056,
    "lat": 38.5326
  }, {
    "lng": -82.7056,
    "lat": 38.5325
  }, {
    "lng": -82.7056,
    "lat": 38.5323
  }, {
    "lng": -82.7057,
    "lat": 38.5322
  }, {
    "lng": -82.7057,
    "lat": 38.5321
  }, {
    "lng": -82.7057,
    "lat": 38.532
  }, {
    "lng": -82.7057,
    "lat": 38.5319
  }, {
    "lng": -82.7058,
    "lat": 38.5318
  }, {
    "lng": -82.7056,
    "lat": 38.5315
  }, {
    "lng": -82.7048,
    "lat": 38.531
  }, {
    "lng": -82.7046,
    "lat": 38.5308
  }, {
    "lng": -82.7045,
    "lat": 38.5308
  }, {
    "lng": -82.7045,
    "lat": 38.5309
  }, {
    "lng": -82.7043,
    "lat": 38.531
  }, {
    "lng": -82.7041,
    "lat": 38.5311
  }, {
    "lng": -82.7039,
    "lat": 38.5312
  }, {
    "lng": -82.7038,
    "lat": 38.5314
  }, {
    "lng": -82.7036,
    "lat": 38.5316
  }, {
    "lng": -82.7035,
    "lat": 38.5317
  }, {
    "lng": -82.7034,
    "lat": 38.5318
  }, {
    "lng": -82.7033,
    "lat": 38.5318
  }, {
    "lng": -82.7032,
    "lat": 38.5318
  }, {
    "lng": -82.7032,
    "lat": 38.5319
  }, {
    "lng": -82.7032,
    "lat": 38.5319
  }, {
    "lng": -82.7031,
    "lat": 38.5319
  }, {
    "lng": -82.7031,
    "lat": 38.5319
  }, {
    "lng": -82.703,
    "lat": 38.5319
  }, {
    "lng": -82.7029,
    "lat": 38.5319
  }, {
    "lng": -82.7027,
    "lat": 38.532
  }, {
    "lng": -82.7026,
    "lat": 38.532
  }, {
    "lng": -82.7024,
    "lat": 38.532
  }, {
    "lng": -82.702,
    "lat": 38.532
  }, {
    "lng": -82.7027,
    "lat": 38.5318
  }, {
    "lng": -82.7027,
    "lat": 38.5311
  }, {
    "lng": -82.703,
    "lat": 38.5307
  }, {
    "lng": -82.7031,
    "lat": 38.5305
  }, {
    "lng": -82.7034,
    "lat": 38.53
  }, {
    "lng": -82.7028,
    "lat": 38.5298
  }, {
    "lng": -82.7025,
    "lat": 38.5297
  }, {
    "lng": -82.7025,
    "lat": 38.5295
  }, {
    "lng": -82.7027,
    "lat": 38.5292
  }, {
    "lng": -82.7022,
    "lat": 38.529
  }, {
    "lng": -82.7021,
    "lat": 38.529
  }, {
    "lng": -82.7021,
    "lat": 38.529
  }, {
    "lng": -82.7019,
    "lat": 38.5294
  }, {
    "lng": -82.7013,
    "lat": 38.5292
  }, {
    "lng": -82.7009,
    "lat": 38.5291
  }, {
    "lng": -82.7004,
    "lat": 38.5284
  }, {
    "lng": -82.7003,
    "lat": 38.5284
  }, {
    "lng": -82.6992,
    "lat": 38.5282
  }, {
    "lng": -82.6989,
    "lat": 38.528
  }, {
    "lng": -82.6987,
    "lat": 38.5279
  }, {
    "lng": -82.6984,
    "lat": 38.5277
  }, {
    "lng": -82.6983,
    "lat": 38.5276
  }, {
    "lng": -82.6983,
    "lat": 38.5273
  }, {
    "lng": -82.6983,
    "lat": 38.527
  }, {
    "lng": -82.6983,
    "lat": 38.5268
  }, {
    "lng": -82.6982,
    "lat": 38.5266
  }, {
    "lng": -82.6982,
    "lat": 38.5265
  }, {
    "lng": -82.6981,
    "lat": 38.5264
  }, {
    "lng": -82.698,
    "lat": 38.5264
  }, {
    "lng": -82.698,
    "lat": 38.5258
  }, {
    "lng": -82.6979,
    "lat": 38.5251
  }, {
    "lng": -82.6979,
    "lat": 38.5247
  }, {
    "lng": -82.6978,
    "lat": 38.5244
  }, {
    "lng": -82.699,
    "lat": 38.5234
  }, {
    "lng": -82.6994,
    "lat": 38.5232
  }, {
    "lng": -82.6996,
    "lat": 38.5232
  }, {
    "lng": -82.6997,
    "lat": 38.5232
  }, {
    "lng": -82.6998,
    "lat": 38.5232
  }, {
    "lng": -82.6999,
    "lat": 38.5232
  }, {
    "lng": -82.6999,
    "lat": 38.5232
  }, {
    "lng": -82.7,
    "lat": 38.5231
  }, {
    "lng": -82.7009,
    "lat": 38.5213
  }, {
    "lng": -82.7014,
    "lat": 38.52
  }, {
    "lng": -82.7012,
    "lat": 38.52
  }, {
    "lng": -82.7008,
    "lat": 38.521
  }, {
    "lng": -82.7005,
    "lat": 38.521
  }, {
    "lng": -82.7008,
    "lat": 38.5203
  }, {
    "lng": -82.7007,
    "lat": 38.5201
  }, {
    "lng": -82.701,
    "lat": 38.52
  }, {
    "lng": -82.7011,
    "lat": 38.5199
  }, {
    "lng": -82.7009,
    "lat": 38.5197
  }, {
    "lng": -82.7009,
    "lat": 38.5194
  }, {
    "lng": -82.7033,
    "lat": 38.5172
  }, {
    "lng": -82.7037,
    "lat": 38.5167
  }, {
    "lng": -82.7038,
    "lat": 38.5168
  }, {
    "lng": -82.704,
    "lat": 38.5169
  }, {
    "lng": -82.7042,
    "lat": 38.517
  }, {
    "lng": -82.7046,
    "lat": 38.5163
  }, {
    "lng": -82.7046,
    "lat": 38.5162
  }, {
    "lng": -82.7045,
    "lat": 38.5161
  }, {
    "lng": -82.7045,
    "lat": 38.5159
  }, {
    "lng": -82.7044,
    "lat": 38.5158
  }, {
    "lng": -82.7044,
    "lat": 38.5157
  }, {
    "lng": -82.7045,
    "lat": 38.5154
  }, {
    "lng": -82.7045,
    "lat": 38.5153
  }, {
    "lng": -82.7045,
    "lat": 38.5153
  }, {
    "lng": -82.7046,
    "lat": 38.5152
  }, {
    "lng": -82.7047,
    "lat": 38.5151
  }, {
    "lng": -82.7047,
    "lat": 38.515
  }, {
    "lng": -82.7048,
    "lat": 38.515
  }, {
    "lng": -82.705,
    "lat": 38.5148
  }, {
    "lng": -82.7052,
    "lat": 38.5147
  }, {
    "lng": -82.7053,
    "lat": 38.5145
  }, {
    "lng": -82.7055,
    "lat": 38.5144
  }, {
    "lng": -82.7057,
    "lat": 38.5141
  }, {
    "lng": -82.7058,
    "lat": 38.5139
  }, {
    "lng": -82.706,
    "lat": 38.5138
  }, {
    "lng": -82.7061,
    "lat": 38.5136
  }, {
    "lng": -82.7064,
    "lat": 38.513
  }, {
    "lng": -82.7065,
    "lat": 38.5129
  }, {
    "lng": -82.7066,
    "lat": 38.5127
  }, {
    "lng": -82.7071,
    "lat": 38.5119
  }, {
    "lng": -82.7072,
    "lat": 38.5117
  }, {
    "lng": -82.7073,
    "lat": 38.5116
  }, {
    "lng": -82.7079,
    "lat": 38.5105
  }, {
    "lng": -82.7081,
    "lat": 38.5103
  }, {
    "lng": -82.7083,
    "lat": 38.51
  }, {
    "lng": -82.7083,
    "lat": 38.51
  }, {
    "lng": -82.7084,
    "lat": 38.5099
  }, {
    "lng": -82.7085,
    "lat": 38.5098
  }, {
    "lng": -82.7086,
    "lat": 38.5097
  }, {
    "lng": -82.709,
    "lat": 38.5093
  }, {
    "lng": -82.7087,
    "lat": 38.5092
  }, {
    "lng": -82.7083,
    "lat": 38.509
  }, {
    "lng": -82.7081,
    "lat": 38.5089
  }, {
    "lng": -82.7078,
    "lat": 38.5088
  }, {
    "lng": -82.7075,
    "lat": 38.5085
  }, {
    "lng": -82.7072,
    "lat": 38.5084
  }, {
    "lng": -82.7066,
    "lat": 38.508
  }, {
    "lng": -82.7053,
    "lat": 38.507
  }, {
    "lng": -82.7051,
    "lat": 38.507
  }, {
    "lng": -82.7049,
    "lat": 38.5069
  }, {
    "lng": -82.7048,
    "lat": 38.5068
  }, {
    "lng": -82.7046,
    "lat": 38.5067
  }, {
    "lng": -82.7044,
    "lat": 38.5066
  }, {
    "lng": -82.7042,
    "lat": 38.5065
  }, {
    "lng": -82.7041,
    "lat": 38.5065
  }, {
    "lng": -82.7039,
    "lat": 38.5065
  }, {
    "lng": -82.7037,
    "lat": 38.5064
  }, {
    "lng": -82.7033,
    "lat": 38.5064
  }, {
    "lng": -82.7023,
    "lat": 38.5063
  }, {
    "lng": -82.7017,
    "lat": 38.5065
  }, {
    "lng": -82.7014,
    "lat": 38.5066
  }, {
    "lng": -82.7012,
    "lat": 38.5066
  }, {
    "lng": -82.7009,
    "lat": 38.5066
  }, {
    "lng": -82.7006,
    "lat": 38.5065
  }, {
    "lng": -82.6998,
    "lat": 38.5063
  }, {
    "lng": -82.6995,
    "lat": 38.5063
  }, {
    "lng": -82.6988,
    "lat": 38.5063
  }, {
    "lng": -82.6975,
    "lat": 38.5061
  }, {
    "lng": -82.6974,
    "lat": 38.5061
  }, {
    "lng": -82.6969,
    "lat": 38.5061
  }, {
    "lng": -82.6966,
    "lat": 38.506
  }, {
    "lng": -82.6966,
    "lat": 38.506
  }, {
    "lng": -82.6966,
    "lat": 38.5059
  }, {
    "lng": -82.6964,
    "lat": 38.5058
  }, {
    "lng": -82.6963,
    "lat": 38.5056
  }, {
    "lng": -82.6964,
    "lat": 38.5054
  }, {
    "lng": -82.6966,
    "lat": 38.5053
  }, {
    "lng": -82.6967,
    "lat": 38.5052
  }, {
    "lng": -82.6967,
    "lat": 38.5051
  }, {
    "lng": -82.6947,
    "lat": 38.5047
  }, {
    "lng": -82.6946,
    "lat": 38.5047
  }, {
    "lng": -82.6944,
    "lat": 38.5046
  }, {
    "lng": -82.6941,
    "lat": 38.5046
  }, {
    "lng": -82.6937,
    "lat": 38.5045
  }, {
    "lng": -82.693,
    "lat": 38.5045
  }, {
    "lng": -82.6935,
    "lat": 38.5052
  }, {
    "lng": -82.6937,
    "lat": 38.5054
  }, {
    "lng": -82.6938,
    "lat": 38.5055
  }, {
    "lng": -82.694,
    "lat": 38.5056
  }, {
    "lng": -82.6942,
    "lat": 38.5057
  }, {
    "lng": -82.6946,
    "lat": 38.5059
  }, {
    "lng": -82.6956,
    "lat": 38.5063
  }, {
    "lng": -82.6958,
    "lat": 38.5064
  }, {
    "lng": -82.696,
    "lat": 38.5065
  }, {
    "lng": -82.696,
    "lat": 38.5066
  }, {
    "lng": -82.6961,
    "lat": 38.5067
  }, {
    "lng": -82.6961,
    "lat": 38.5068
  }, {
    "lng": -82.6961,
    "lat": 38.5069
  }, {
    "lng": -82.6961,
    "lat": 38.507
  }, {
    "lng": -82.6961,
    "lat": 38.5072
  }, {
    "lng": -82.6961,
    "lat": 38.5074
  }, {
    "lng": -82.6962,
    "lat": 38.5075
  }, {
    "lng": -82.6963,
    "lat": 38.5075
  }, {
    "lng": -82.6965,
    "lat": 38.5075
  }, {
    "lng": -82.6967,
    "lat": 38.5075
  }, {
    "lng": -82.6969,
    "lat": 38.5074
  }, {
    "lng": -82.697,
    "lat": 38.5073
  }, {
    "lng": -82.6972,
    "lat": 38.5067
  }, {
    "lng": -82.6972,
    "lat": 38.5066
  }, {
    "lng": -82.6973,
    "lat": 38.5066
  }, {
    "lng": -82.6975,
    "lat": 38.5065
  }, {
    "lng": -82.6976,
    "lat": 38.5064
  }, {
    "lng": -82.6977,
    "lat": 38.5064
  }, {
    "lng": -82.6979,
    "lat": 38.5065
  }, {
    "lng": -82.698,
    "lat": 38.5065
  }, {
    "lng": -82.6981,
    "lat": 38.5065
  }, {
    "lng": -82.6983,
    "lat": 38.5067
  }, {
    "lng": -82.6984,
    "lat": 38.5068
  }, {
    "lng": -82.6988,
    "lat": 38.5072
  }, {
    "lng": -82.6997,
    "lat": 38.5082
  }, {
    "lng": -82.6998,
    "lat": 38.5084
  }, {
    "lng": -82.6999,
    "lat": 38.5085
  }, {
    "lng": -82.7001,
    "lat": 38.5086
  }, {
    "lng": -82.7002,
    "lat": 38.5088
  }, {
    "lng": -82.7004,
    "lat": 38.5089
  }, {
    "lng": -82.7006,
    "lat": 38.5089
  }, {
    "lng": -82.7009,
    "lat": 38.509
  }, {
    "lng": -82.701,
    "lat": 38.509
  }, {
    "lng": -82.7013,
    "lat": 38.5092
  }, {
    "lng": -82.7015,
    "lat": 38.5093
  }, {
    "lng": -82.7015,
    "lat": 38.5094
  }, {
    "lng": -82.7015,
    "lat": 38.5095
  }, {
    "lng": -82.7015,
    "lat": 38.5096
  }, {
    "lng": -82.7012,
    "lat": 38.5102
  }, {
    "lng": -82.701,
    "lat": 38.5103
  }, {
    "lng": -82.701,
    "lat": 38.5104
  }, {
    "lng": -82.7009,
    "lat": 38.5104
  }, {
    "lng": -82.7008,
    "lat": 38.5104
  }, {
    "lng": -82.7,
    "lat": 38.5105
  }, {
    "lng": -82.6994,
    "lat": 38.5106
  }, {
    "lng": -82.6993,
    "lat": 38.5106
  }, {
    "lng": -82.6993,
    "lat": 38.5106
  }, {
    "lng": -82.699,
    "lat": 38.5105
  }, {
    "lng": -82.6989,
    "lat": 38.5105
  }, {
    "lng": -82.6988,
    "lat": 38.5105
  }, {
    "lng": -82.6986,
    "lat": 38.5103
  }, {
    "lng": -82.6983,
    "lat": 38.5099
  }, {
    "lng": -82.698,
    "lat": 38.5096
  }, {
    "lng": -82.6973,
    "lat": 38.5089
  }, {
    "lng": -82.6972,
    "lat": 38.5088
  }, {
    "lng": -82.697,
    "lat": 38.5086
  }, {
    "lng": -82.6969,
    "lat": 38.5085
  }, {
    "lng": -82.6968,
    "lat": 38.5085
  }, {
    "lng": -82.6967,
    "lat": 38.5084
  }, {
    "lng": -82.6965,
    "lat": 38.5084
  }, {
    "lng": -82.6962,
    "lat": 38.5083
  }, {
    "lng": -82.6959,
    "lat": 38.5083
  }, {
    "lng": -82.6956,
    "lat": 38.5091
  }, {
    "lng": -82.6958,
    "lat": 38.5092
  }, {
    "lng": -82.696,
    "lat": 38.5092
  }, {
    "lng": -82.6963,
    "lat": 38.5094
  }, {
    "lng": -82.6966,
    "lat": 38.5095
  }, {
    "lng": -82.6966,
    "lat": 38.5096
  }, {
    "lng": -82.6967,
    "lat": 38.5096
  }, {
    "lng": -82.6968,
    "lat": 38.5097
  }, {
    "lng": -82.6968,
    "lat": 38.5098
  }, {
    "lng": -82.6969,
    "lat": 38.51
  }, {
    "lng": -82.6969,
    "lat": 38.51
  }, {
    "lng": -82.6971,
    "lat": 38.5104
  }, {
    "lng": -82.6973,
    "lat": 38.5112
  }, {
    "lng": -82.6973,
    "lat": 38.5113
  }, {
    "lng": -82.6973,
    "lat": 38.5114
  }, {
    "lng": -82.6973,
    "lat": 38.5115
  }, {
    "lng": -82.6972,
    "lat": 38.5115
  }, {
    "lng": -82.6971,
    "lat": 38.5116
  }, {
    "lng": -82.6967,
    "lat": 38.5118
  }, {
    "lng": -82.6963,
    "lat": 38.512
  }, {
    "lng": -82.6959,
    "lat": 38.5122
  }, {
    "lng": -82.6959,
    "lat": 38.5124
  }, {
    "lng": -82.6959,
    "lat": 38.5125
  }, {
    "lng": -82.6959,
    "lat": 38.5127
  }, {
    "lng": -82.696,
    "lat": 38.5128
  }, {
    "lng": -82.696,
    "lat": 38.5129
  }, {
    "lng": -82.6961,
    "lat": 38.513
  }, {
    "lng": -82.6965,
    "lat": 38.5135
  }, {
    "lng": -82.6971,
    "lat": 38.5141
  }, {
    "lng": -82.6988,
    "lat": 38.516
  }, {
    "lng": -82.6998,
    "lat": 38.5171
  }, {
    "lng": -82.6985,
    "lat": 38.5172
  }, {
    "lng": -82.6981,
    "lat": 38.5172
  }, {
    "lng": -82.698,
    "lat": 38.5172
  }, {
    "lng": -82.6978,
    "lat": 38.5173
  }, {
    "lng": -82.6976,
    "lat": 38.5172
  }, {
    "lng": -82.6975,
    "lat": 38.5172
  }, {
    "lng": -82.6973,
    "lat": 38.5172
  }, {
    "lng": -82.6971,
    "lat": 38.5172
  }, {
    "lng": -82.697,
    "lat": 38.5171
  }, {
    "lng": -82.6968,
    "lat": 38.517
  }, {
    "lng": -82.6967,
    "lat": 38.5169
  }, {
    "lng": -82.6963,
    "lat": 38.5166
  }, {
    "lng": -82.696,
    "lat": 38.5163
  }, {
    "lng": -82.696,
    "lat": 38.5165
  }, {
    "lng": -82.6961,
    "lat": 38.5167
  }, {
    "lng": -82.6961,
    "lat": 38.5169
  }, {
    "lng": -82.696,
    "lat": 38.5174
  }, {
    "lng": -82.6959,
    "lat": 38.5182
  }, {
    "lng": -82.6957,
    "lat": 38.5185
  }, {
    "lng": -82.6953,
    "lat": 38.5194
  }, {
    "lng": -82.6952,
    "lat": 38.5196
  }, {
    "lng": -82.6951,
    "lat": 38.5198
  }, {
    "lng": -82.6951,
    "lat": 38.52
  }, {
    "lng": -82.6951,
    "lat": 38.5204
  }, {
    "lng": -82.6951,
    "lat": 38.5204
  }, {
    "lng": -82.6951,
    "lat": 38.5206
  }, {
    "lng": -82.6955,
    "lat": 38.5213
  }, {
    "lng": -82.6956,
    "lat": 38.5215
  }, {
    "lng": -82.6956,
    "lat": 38.5217
  }, {
    "lng": -82.6955,
    "lat": 38.5219
  }, {
    "lng": -82.6953,
    "lat": 38.5221
  }, {
    "lng": -82.6951,
    "lat": 38.5223
  }, {
    "lng": -82.6946,
    "lat": 38.5229
  }, {
    "lng": -82.6944,
    "lat": 38.5231
  }, {
    "lng": -82.6941,
    "lat": 38.5235
  }, {
    "lng": -82.694,
    "lat": 38.5236
  }, {
    "lng": -82.6939,
    "lat": 38.5237
  }, {
    "lng": -82.6937,
    "lat": 38.5238
  }, {
    "lng": -82.6935,
    "lat": 38.5238
  }, {
    "lng": -82.6933,
    "lat": 38.5239
  }, {
    "lng": -82.693,
    "lat": 38.524
  }, {
    "lng": -82.6922,
    "lat": 38.5243
  }, {
    "lng": -82.6917,
    "lat": 38.5245
  }, {
    "lng": -82.6914,
    "lat": 38.5246
  }, {
    "lng": -82.6912,
    "lat": 38.5247
  }, {
    "lng": -82.6909,
    "lat": 38.5249
  }, {
    "lng": -82.6908,
    "lat": 38.5251
  }, {
    "lng": -82.6906,
    "lat": 38.5253
  }, {
    "lng": -82.6905,
    "lat": 38.5254
  }, {
    "lng": -82.6904,
    "lat": 38.5255
  }, {
    "lng": -82.6902,
    "lat": 38.5257
  }, {
    "lng": -82.6901,
    "lat": 38.5258
  }, {
    "lng": -82.6899,
    "lat": 38.526
  }, {
    "lng": -82.6898,
    "lat": 38.5261
  }]]],
  "options": {
    "fillColor": "#0fbb58",
    "fillOpacity": 0.4,
    "strokeColor": "#0B8C42",
    "strokeWeight": 1,
    "strokeOpacity": 0.4,
    "clickable": true,
    "visible": true,
    "zIndex": 1000
  }
};
var carrierRoute07 = {
  "carrierRoute": "41139R001",
  "paths": [[[{
    "lng": -82.7045,
    "lat": 38.5159
  }, {
    "lng": -82.7045,
    "lat": 38.5161
  }, {
    "lng": -82.7046,
    "lat": 38.5162
  }, {
    "lng": -82.7046,
    "lat": 38.5163
  }, {
    "lng": -82.7051,
    "lat": 38.5165
  }, {
    "lng": -82.7071,
    "lat": 38.5172
  }, {
    "lng": -82.7074,
    "lat": 38.5173
  }, {
    "lng": -82.7085,
    "lat": 38.5178
  }, {
    "lng": -82.7092,
    "lat": 38.5181
  }, {
    "lng": -82.7099,
    "lat": 38.5183
  }, {
    "lng": -82.7101,
    "lat": 38.5184
  }, {
    "lng": -82.711,
    "lat": 38.5188
  }, {
    "lng": -82.7113,
    "lat": 38.5189
  }, {
    "lng": -82.7118,
    "lat": 38.5181
  }, {
    "lng": -82.712,
    "lat": 38.5178
  }, {
    "lng": -82.7124,
    "lat": 38.517
  }, {
    "lng": -82.7125,
    "lat": 38.5169
  }, {
    "lng": -82.7134,
    "lat": 38.5153
  }, {
    "lng": -82.7144,
    "lat": 38.5137
  }, {
    "lng": -82.7145,
    "lat": 38.5136
  }, {
    "lng": -82.7145,
    "lat": 38.5135
  }, {
    "lng": -82.715,
    "lat": 38.5137
  }, {
    "lng": -82.7152,
    "lat": 38.5137
  }, {
    "lng": -82.7157,
    "lat": 38.5139
  }, {
    "lng": -82.7158,
    "lat": 38.514
  }, {
    "lng": -82.7158,
    "lat": 38.514
  }, {
    "lng": -82.7157,
    "lat": 38.5142
  }, {
    "lng": -82.7151,
    "lat": 38.5151
  }, {
    "lng": -82.7184,
    "lat": 38.5162
  }, {
    "lng": -82.7186,
    "lat": 38.5163
  }, {
    "lng": -82.7186,
    "lat": 38.5163
  }, {
    "lng": -82.7186,
    "lat": 38.5163
  }, {
    "lng": -82.7186,
    "lat": 38.5164
  }, {
    "lng": -82.7186,
    "lat": 38.5164
  }, {
    "lng": -82.7184,
    "lat": 38.5169
  }, {
    "lng": -82.7182,
    "lat": 38.5171
  }, {
    "lng": -82.7188,
    "lat": 38.5173
  }, {
    "lng": -82.7191,
    "lat": 38.5168
  }, {
    "lng": -82.7192,
    "lat": 38.5166
  }, {
    "lng": -82.7193,
    "lat": 38.5164
  }, {
    "lng": -82.7193,
    "lat": 38.5164
  }, {
    "lng": -82.7194,
    "lat": 38.5164
  }, {
    "lng": -82.7195,
    "lat": 38.5164
  }, {
    "lng": -82.7196,
    "lat": 38.5165
  }, {
    "lng": -82.7201,
    "lat": 38.5166
  }, {
    "lng": -82.7205,
    "lat": 38.5168
  }, {
    "lng": -82.7207,
    "lat": 38.5163
  }, {
    "lng": -82.721,
    "lat": 38.5158
  }, {
    "lng": -82.7213,
    "lat": 38.5153
  }, {
    "lng": -82.7216,
    "lat": 38.5149
  }, {
    "lng": -82.7208,
    "lat": 38.5145
  }, {
    "lng": -82.72,
    "lat": 38.5139
  }, {
    "lng": -82.7202,
    "lat": 38.5133
  }, {
    "lng": -82.7203,
    "lat": 38.5129
  }, {
    "lng": -82.7204,
    "lat": 38.5127
  }, {
    "lng": -82.7205,
    "lat": 38.5122
  }, {
    "lng": -82.7206,
    "lat": 38.5119
  }, {
    "lng": -82.7206,
    "lat": 38.5116
  }, {
    "lng": -82.7208,
    "lat": 38.5112
  }, {
    "lng": -82.7209,
    "lat": 38.5105
  }, {
    "lng": -82.721,
    "lat": 38.5102
  }, {
    "lng": -82.7213,
    "lat": 38.509
  }, {
    "lng": -82.7214,
    "lat": 38.5085
  }, {
    "lng": -82.7216,
    "lat": 38.5078
  }, {
    "lng": -82.7218,
    "lat": 38.5073
  }, {
    "lng": -82.7219,
    "lat": 38.5071
  }, {
    "lng": -82.722,
    "lat": 38.5066
  }, {
    "lng": -82.7221,
    "lat": 38.5063
  }, {
    "lng": -82.7221,
    "lat": 38.5061
  }, {
    "lng": -82.7222,
    "lat": 38.506
  }, {
    "lng": -82.7223,
    "lat": 38.5057
  }, {
    "lng": -82.7209,
    "lat": 38.5053
  }, {
    "lng": -82.7182,
    "lat": 38.5045
  }, {
    "lng": -82.7177,
    "lat": 38.5043
  }, {
    "lng": -82.716,
    "lat": 38.5038
  }, {
    "lng": -82.7159,
    "lat": 38.5038
  }, {
    "lng": -82.7158,
    "lat": 38.5039
  }, {
    "lng": -82.7157,
    "lat": 38.5039
  }, {
    "lng": -82.7156,
    "lat": 38.504
  }, {
    "lng": -82.7153,
    "lat": 38.5045
  }, {
    "lng": -82.7151,
    "lat": 38.5048
  }, {
    "lng": -82.7149,
    "lat": 38.505
  }, {
    "lng": -82.7147,
    "lat": 38.5051
  }, {
    "lng": -82.7144,
    "lat": 38.5053
  }, {
    "lng": -82.7141,
    "lat": 38.5055
  }, {
    "lng": -82.7139,
    "lat": 38.5058
  }, {
    "lng": -82.7134,
    "lat": 38.5063
  }, {
    "lng": -82.7142,
    "lat": 38.5064
  }, {
    "lng": -82.7141,
    "lat": 38.5064
  }, {
    "lng": -82.714,
    "lat": 38.5065
  }, {
    "lng": -82.7137,
    "lat": 38.5068
  }, {
    "lng": -82.7135,
    "lat": 38.507
  }, {
    "lng": -82.7134,
    "lat": 38.507
  }, {
    "lng": -82.7136,
    "lat": 38.5071
  }, {
    "lng": -82.7142,
    "lat": 38.5065
  }, {
    "lng": -82.7142,
    "lat": 38.5066
  }, {
    "lng": -82.7143,
    "lat": 38.5065
  }, {
    "lng": -82.7154,
    "lat": 38.5064
  }, {
    "lng": -82.7166,
    "lat": 38.5063
  }, {
    "lng": -82.7166,
    "lat": 38.5064
  }, {
    "lng": -82.7166,
    "lat": 38.5064
  }, {
    "lng": -82.7166,
    "lat": 38.5065
  }, {
    "lng": -82.7166,
    "lat": 38.5065
  }, {
    "lng": -82.7167,
    "lat": 38.5066
  }, {
    "lng": -82.7167,
    "lat": 38.5066
  }, {
    "lng": -82.7165,
    "lat": 38.5069
  }, {
    "lng": -82.7167,
    "lat": 38.5069
  }, {
    "lng": -82.7171,
    "lat": 38.5071
  }, {
    "lng": -82.7175,
    "lat": 38.5073
  }, {
    "lng": -82.7179,
    "lat": 38.5075
  }, {
    "lng": -82.718,
    "lat": 38.5076
  }, {
    "lng": -82.7185,
    "lat": 38.5078
  }, {
    "lng": -82.7196,
    "lat": 38.5083
  }, {
    "lng": -82.7199,
    "lat": 38.5084
  }, {
    "lng": -82.72,
    "lat": 38.5085
  }, {
    "lng": -82.72,
    "lat": 38.5085
  }, {
    "lng": -82.7201,
    "lat": 38.5085
  }, {
    "lng": -82.7197,
    "lat": 38.5091
  }, {
    "lng": -82.7195,
    "lat": 38.5094
  }, {
    "lng": -82.7194,
    "lat": 38.5095
  }, {
    "lng": -82.7193,
    "lat": 38.5097
  }, {
    "lng": -82.7192,
    "lat": 38.5096
  }, {
    "lng": -82.7191,
    "lat": 38.5096
  }, {
    "lng": -82.719,
    "lat": 38.5096
  }, {
    "lng": -82.719,
    "lat": 38.5095
  }, {
    "lng": -82.7189,
    "lat": 38.5095
  }, {
    "lng": -82.7189,
    "lat": 38.5096
  }, {
    "lng": -82.7186,
    "lat": 38.5101
  }, {
    "lng": -82.7183,
    "lat": 38.51
  }, {
    "lng": -82.7181,
    "lat": 38.5099
  }, {
    "lng": -82.7179,
    "lat": 38.5098
  }, {
    "lng": -82.7178,
    "lat": 38.5098
  }, {
    "lng": -82.716,
    "lat": 38.5093
  }, {
    "lng": -82.7155,
    "lat": 38.5106
  }, {
    "lng": -82.7149,
    "lat": 38.5104
  }, {
    "lng": -82.7145,
    "lat": 38.5103
  }, {
    "lng": -82.7143,
    "lat": 38.5102
  }, {
    "lng": -82.714,
    "lat": 38.5102
  }, {
    "lng": -82.7133,
    "lat": 38.5109
  }, {
    "lng": -82.7131,
    "lat": 38.5108
  }, {
    "lng": -82.7129,
    "lat": 38.5107
  }, {
    "lng": -82.7121,
    "lat": 38.5103
  }, {
    "lng": -82.7115,
    "lat": 38.5101
  }, {
    "lng": -82.7111,
    "lat": 38.51
  }, {
    "lng": -82.7095,
    "lat": 38.5095
  }, {
    "lng": -82.7093,
    "lat": 38.5095
  }, {
    "lng": -82.709,
    "lat": 38.5093
  }, {
    "lng": -82.7086,
    "lat": 38.5097
  }, {
    "lng": -82.7085,
    "lat": 38.5098
  }, {
    "lng": -82.7084,
    "lat": 38.5099
  }, {
    "lng": -82.7083,
    "lat": 38.51
  }, {
    "lng": -82.7083,
    "lat": 38.51
  }, {
    "lng": -82.7081,
    "lat": 38.5103
  }, {
    "lng": -82.7079,
    "lat": 38.5105
  }, {
    "lng": -82.7073,
    "lat": 38.5116
  }, {
    "lng": -82.7072,
    "lat": 38.5117
  }, {
    "lng": -82.7071,
    "lat": 38.5119
  }, {
    "lng": -82.7066,
    "lat": 38.5127
  }, {
    "lng": -82.7065,
    "lat": 38.5129
  }, {
    "lng": -82.7064,
    "lat": 38.513
  }, {
    "lng": -82.7061,
    "lat": 38.5136
  }, {
    "lng": -82.706,
    "lat": 38.5138
  }, {
    "lng": -82.7058,
    "lat": 38.5139
  }, {
    "lng": -82.7057,
    "lat": 38.5141
  }, {
    "lng": -82.7055,
    "lat": 38.5144
  }, {
    "lng": -82.7053,
    "lat": 38.5145
  }, {
    "lng": -82.7052,
    "lat": 38.5147
  }, {
    "lng": -82.705,
    "lat": 38.5148
  }, {
    "lng": -82.7048,
    "lat": 38.515
  }, {
    "lng": -82.7047,
    "lat": 38.515
  }, {
    "lng": -82.7047,
    "lat": 38.5151
  }, {
    "lng": -82.7046,
    "lat": 38.5152
  }, {
    "lng": -82.7045,
    "lat": 38.5153
  }, {
    "lng": -82.7045,
    "lat": 38.5153
  }, {
    "lng": -82.7045,
    "lat": 38.5154
  }, {
    "lng": -82.7044,
    "lat": 38.5157
  }, {
    "lng": -82.7044,
    "lat": 38.5158
  }, {
    "lng": -82.7045,
    "lat": 38.5159
  }]], [[{
    "lng": -82.7154,
    "lat": 38.4986
  }, {
    "lng": -82.7158,
    "lat": 38.499
  }, {
    "lng": -82.716,
    "lat": 38.4989
  }, {
    "lng": -82.7162,
    "lat": 38.4987
  }, {
    "lng": -82.7163,
    "lat": 38.4986
  }, {
    "lng": -82.7164,
    "lat": 38.4984
  }, {
    "lng": -82.7167,
    "lat": 38.4981
  }, {
    "lng": -82.7172,
    "lat": 38.4972
  }, {
    "lng": -82.7178,
    "lat": 38.4964
  }, {
    "lng": -82.7183,
    "lat": 38.4956
  }, {
    "lng": -82.7185,
    "lat": 38.4953
  }, {
    "lng": -82.7191,
    "lat": 38.4946
  }, {
    "lng": -82.7193,
    "lat": 38.4944
  }, {
    "lng": -82.7197,
    "lat": 38.4942
  }, {
    "lng": -82.7199,
    "lat": 38.4941
  }, {
    "lng": -82.7199,
    "lat": 38.494
  }, {
    "lng": -82.7199,
    "lat": 38.4938
  }, {
    "lng": -82.7197,
    "lat": 38.4936
  }, {
    "lng": -82.7198,
    "lat": 38.4935
  }, {
    "lng": -82.72,
    "lat": 38.494
  }, {
    "lng": -82.7204,
    "lat": 38.4939
  }, {
    "lng": -82.7209,
    "lat": 38.4938
  }, {
    "lng": -82.721,
    "lat": 38.4938
  }, {
    "lng": -82.7211,
    "lat": 38.4937
  }, {
    "lng": -82.7213,
    "lat": 38.4936
  }, {
    "lng": -82.7219,
    "lat": 38.4933
  }, {
    "lng": -82.7222,
    "lat": 38.4931
  }, {
    "lng": -82.7223,
    "lat": 38.493
  }, {
    "lng": -82.7226,
    "lat": 38.4928
  }, {
    "lng": -82.7227,
    "lat": 38.4927
  }, {
    "lng": -82.7228,
    "lat": 38.4927
  }, {
    "lng": -82.7229,
    "lat": 38.4927
  }, {
    "lng": -82.723,
    "lat": 38.4927
  }, {
    "lng": -82.7231,
    "lat": 38.4927
  }, {
    "lng": -82.7232,
    "lat": 38.4927
  }, {
    "lng": -82.7233,
    "lat": 38.4927
  }, {
    "lng": -82.7233,
    "lat": 38.4928
  }, {
    "lng": -82.723,
    "lat": 38.4926
  }, {
    "lng": -82.7226,
    "lat": 38.4927
  }, {
    "lng": -82.7211,
    "lat": 38.4936
  }, {
    "lng": -82.7204,
    "lat": 38.4926
  }, {
    "lng": -82.7195,
    "lat": 38.4922
  }, {
    "lng": -82.719,
    "lat": 38.4923
  }, {
    "lng": -82.7192,
    "lat": 38.4933
  }, {
    "lng": -82.7188,
    "lat": 38.4934
  }, {
    "lng": -82.7189,
    "lat": 38.4937
  }, {
    "lng": -82.719,
    "lat": 38.4938
  }, {
    "lng": -82.7188,
    "lat": 38.494
  }, {
    "lng": -82.7187,
    "lat": 38.4941
  }, {
    "lng": -82.7184,
    "lat": 38.4945
  }, {
    "lng": -82.7183,
    "lat": 38.4946
  }, {
    "lng": -82.7182,
    "lat": 38.4947
  }, {
    "lng": -82.718,
    "lat": 38.4949
  }, {
    "lng": -82.7177,
    "lat": 38.4952
  }, {
    "lng": -82.7176,
    "lat": 38.4955
  }, {
    "lng": -82.7168,
    "lat": 38.4966
  }, {
    "lng": -82.7165,
    "lat": 38.4971
  }, {
    "lng": -82.7163,
    "lat": 38.4973
  }, {
    "lng": -82.7163,
    "lat": 38.4974
  }, {
    "lng": -82.7159,
    "lat": 38.498
  }, {
    "lng": -82.7158,
    "lat": 38.4981
  }, {
    "lng": -82.7158,
    "lat": 38.4982
  }, {
    "lng": -82.7155,
    "lat": 38.4985
  }, {
    "lng": -82.7154,
    "lat": 38.4986
  }]], [[{
    "lng": -82.7223,
    "lat": 38.5057
  }, {
    "lng": -82.7225,
    "lat": 38.5059
  }, {
    "lng": -82.7245,
    "lat": 38.5069
  }, {
    "lng": -82.7251,
    "lat": 38.5071
  }, {
    "lng": -82.7257,
    "lat": 38.5073
  }, {
    "lng": -82.7259,
    "lat": 38.5066
  }, {
    "lng": -82.7262,
    "lat": 38.5058
  }, {
    "lng": -82.7281,
    "lat": 38.5066
  }, {
    "lng": -82.7285,
    "lat": 38.5068
  }, {
    "lng": -82.7287,
    "lat": 38.5068
  }, {
    "lng": -82.7291,
    "lat": 38.5078
  }, {
    "lng": -82.7296,
    "lat": 38.5084
  }, {
    "lng": -82.73,
    "lat": 38.509
  }, {
    "lng": -82.7302,
    "lat": 38.509
  }, {
    "lng": -82.7302,
    "lat": 38.509
  }, {
    "lng": -82.7302,
    "lat": 38.5094
  }, {
    "lng": -82.7302,
    "lat": 38.5095
  }, {
    "lng": -82.7302,
    "lat": 38.5099
  }, {
    "lng": -82.73,
    "lat": 38.5098
  }, {
    "lng": -82.7299,
    "lat": 38.5097
  }, {
    "lng": -82.7299,
    "lat": 38.5098
  }, {
    "lng": -82.7301,
    "lat": 38.5103
  }, {
    "lng": -82.7308,
    "lat": 38.512
  }, {
    "lng": -82.7309,
    "lat": 38.5123
  }, {
    "lng": -82.7314,
    "lat": 38.5125
  }, {
    "lng": -82.7315,
    "lat": 38.5126
  }, {
    "lng": -82.7316,
    "lat": 38.5128
  }, {
    "lng": -82.7318,
    "lat": 38.5129
  }, {
    "lng": -82.7322,
    "lat": 38.5131
  }, {
    "lng": -82.7327,
    "lat": 38.5133
  }, {
    "lng": -82.7337,
    "lat": 38.5138
  }, {
    "lng": -82.7337,
    "lat": 38.5143
  }, {
    "lng": -82.7337,
    "lat": 38.5144
  }, {
    "lng": -82.7338,
    "lat": 38.5144
  }, {
    "lng": -82.7338,
    "lat": 38.5144
  }, {
    "lng": -82.7341,
    "lat": 38.5144
  }, {
    "lng": -82.7345,
    "lat": 38.5143
  }, {
    "lng": -82.7349,
    "lat": 38.5142
  }, {
    "lng": -82.7353,
    "lat": 38.5141
  }, {
    "lng": -82.7358,
    "lat": 38.514
  }, {
    "lng": -82.736,
    "lat": 38.514
  }, {
    "lng": -82.7362,
    "lat": 38.514
  }, {
    "lng": -82.7365,
    "lat": 38.5139
  }, {
    "lng": -82.738,
    "lat": 38.5138
  }, {
    "lng": -82.7381,
    "lat": 38.5138
  }, {
    "lng": -82.7383,
    "lat": 38.5137
  }, {
    "lng": -82.7384,
    "lat": 38.5137
  }, {
    "lng": -82.7384,
    "lat": 38.5137
  }, {
    "lng": -82.7385,
    "lat": 38.5137
  }, {
    "lng": -82.7389,
    "lat": 38.5136
  }, {
    "lng": -82.7396,
    "lat": 38.5134
  }, {
    "lng": -82.7398,
    "lat": 38.5134
  }, {
    "lng": -82.7401,
    "lat": 38.5133
  }, {
    "lng": -82.7403,
    "lat": 38.5132
  }, {
    "lng": -82.7404,
    "lat": 38.5132
  }, {
    "lng": -82.7405,
    "lat": 38.5131
  }, {
    "lng": -82.7406,
    "lat": 38.5131
  }, {
    "lng": -82.7408,
    "lat": 38.5129
  }, {
    "lng": -82.7413,
    "lat": 38.5126
  }, {
    "lng": -82.742,
    "lat": 38.5122
  }, {
    "lng": -82.7422,
    "lat": 38.512
  }, {
    "lng": -82.7424,
    "lat": 38.5119
  }, {
    "lng": -82.7427,
    "lat": 38.5114
  }, {
    "lng": -82.7431,
    "lat": 38.511
  }, {
    "lng": -82.7436,
    "lat": 38.5105
  }, {
    "lng": -82.7436,
    "lat": 38.5104
  }, {
    "lng": -82.7439,
    "lat": 38.51
  }, {
    "lng": -82.7439,
    "lat": 38.5095
  }, {
    "lng": -82.7439,
    "lat": 38.5091
  }, {
    "lng": -82.7439,
    "lat": 38.509
  }, {
    "lng": -82.7439,
    "lat": 38.5089
  }, {
    "lng": -82.7439,
    "lat": 38.5089
  }, {
    "lng": -82.744,
    "lat": 38.5088
  }, {
    "lng": -82.7444,
    "lat": 38.5082
  }, {
    "lng": -82.7445,
    "lat": 38.508
  }, {
    "lng": -82.7445,
    "lat": 38.5079
  }, {
    "lng": -82.7446,
    "lat": 38.5079
  }, {
    "lng": -82.7451,
    "lat": 38.5074
  }, {
    "lng": -82.7455,
    "lat": 38.507
  }, {
    "lng": -82.7457,
    "lat": 38.5068
  }, {
    "lng": -82.7459,
    "lat": 38.5067
  }, {
    "lng": -82.746,
    "lat": 38.5065
  }, {
    "lng": -82.7462,
    "lat": 38.5064
  }, {
    "lng": -82.7464,
    "lat": 38.5063
  }, {
    "lng": -82.7465,
    "lat": 38.5062
  }, {
    "lng": -82.7467,
    "lat": 38.5061
  }, {
    "lng": -82.7469,
    "lat": 38.5059
  }, {
    "lng": -82.7472,
    "lat": 38.5058
  }, {
    "lng": -82.7476,
    "lat": 38.5056
  }, {
    "lng": -82.7478,
    "lat": 38.5055
  }, {
    "lng": -82.7481,
    "lat": 38.5054
  }, {
    "lng": -82.7482,
    "lat": 38.5053
  }, {
    "lng": -82.7486,
    "lat": 38.505
  }, {
    "lng": -82.7487,
    "lat": 38.505
  }, {
    "lng": -82.7488,
    "lat": 38.5049
  }, {
    "lng": -82.7489,
    "lat": 38.5049
  }, {
    "lng": -82.749,
    "lat": 38.5048
  }, {
    "lng": -82.749,
    "lat": 38.5048
  }, {
    "lng": -82.7491,
    "lat": 38.5048
  }, {
    "lng": -82.7493,
    "lat": 38.5048
  }, {
    "lng": -82.7495,
    "lat": 38.5048
  }, {
    "lng": -82.7503,
    "lat": 38.5047
  }, {
    "lng": -82.7505,
    "lat": 38.5047
  }, {
    "lng": -82.751,
    "lat": 38.5047
  }, {
    "lng": -82.7527,
    "lat": 38.5047
  }, {
    "lng": -82.7533,
    "lat": 38.5046
  }, {
    "lng": -82.7537,
    "lat": 38.5045
  }, {
    "lng": -82.7539,
    "lat": 38.5044
  }, {
    "lng": -82.7546,
    "lat": 38.5042
  }, {
    "lng": -82.7549,
    "lat": 38.5041
  }, {
    "lng": -82.755,
    "lat": 38.504
  }, {
    "lng": -82.7552,
    "lat": 38.5039
  }, {
    "lng": -82.7554,
    "lat": 38.5039
  }, {
    "lng": -82.7557,
    "lat": 38.5038
  }, {
    "lng": -82.7559,
    "lat": 38.5038
  }, {
    "lng": -82.7562,
    "lat": 38.5039
  }, {
    "lng": -82.7566,
    "lat": 38.5041
  }, {
    "lng": -82.7568,
    "lat": 38.5042
  }, {
    "lng": -82.7569,
    "lat": 38.5042
  }, {
    "lng": -82.7575,
    "lat": 38.5044
  }, {
    "lng": -82.7579,
    "lat": 38.5044
  }, {
    "lng": -82.7588,
    "lat": 38.5045
  }, {
    "lng": -82.7593,
    "lat": 38.5045
  }, {
    "lng": -82.7601,
    "lat": 38.5044
  }, {
    "lng": -82.7602,
    "lat": 38.5044
  }, {
    "lng": -82.7604,
    "lat": 38.5043
  }, {
    "lng": -82.7607,
    "lat": 38.5042
  }, {
    "lng": -82.761,
    "lat": 38.504
  }, {
    "lng": -82.7613,
    "lat": 38.5039
  }, {
    "lng": -82.7616,
    "lat": 38.5037
  }, {
    "lng": -82.7621,
    "lat": 38.5035
  }, {
    "lng": -82.7624,
    "lat": 38.5033
  }, {
    "lng": -82.7627,
    "lat": 38.5032
  }, {
    "lng": -82.7629,
    "lat": 38.5031
  }, {
    "lng": -82.7632,
    "lat": 38.503
  }, {
    "lng": -82.7633,
    "lat": 38.5029
  }, {
    "lng": -82.7634,
    "lat": 38.5028
  }, {
    "lng": -82.7635,
    "lat": 38.5027
  }, {
    "lng": -82.7636,
    "lat": 38.5024
  }, {
    "lng": -82.7639,
    "lat": 38.5021
  }, {
    "lng": -82.7642,
    "lat": 38.5017
  }, {
    "lng": -82.7645,
    "lat": 38.5011
  }, {
    "lng": -82.7651,
    "lat": 38.5004
  }, {
    "lng": -82.7652,
    "lat": 38.5001
  }, {
    "lng": -82.7653,
    "lat": 38.5
  }, {
    "lng": -82.7654,
    "lat": 38.4997
  }, {
    "lng": -82.7655,
    "lat": 38.4995
  }, {
    "lng": -82.7656,
    "lat": 38.4994
  }, {
    "lng": -82.7656,
    "lat": 38.4994
  }, {
    "lng": -82.7658,
    "lat": 38.4991
  }, {
    "lng": -82.7661,
    "lat": 38.4988
  }, {
    "lng": -82.7657,
    "lat": 38.4984
  }, {
    "lng": -82.7659,
    "lat": 38.4981
  }, {
    "lng": -82.7663,
    "lat": 38.4978
  }, {
    "lng": -82.7669,
    "lat": 38.4974
  }, {
    "lng": -82.7673,
    "lat": 38.4971
  }, {
    "lng": -82.7675,
    "lat": 38.497
  }, {
    "lng": -82.7676,
    "lat": 38.4968
  }, {
    "lng": -82.7678,
    "lat": 38.4967
  }, {
    "lng": -82.7681,
    "lat": 38.4966
  }, {
    "lng": -82.7683,
    "lat": 38.4965
  }, {
    "lng": -82.7684,
    "lat": 38.4964
  }, {
    "lng": -82.7687,
    "lat": 38.4963
  }, {
    "lng": -82.769,
    "lat": 38.4963
  }, {
    "lng": -82.7692,
    "lat": 38.4962
  }, {
    "lng": -82.7694,
    "lat": 38.4961
  }, {
    "lng": -82.7697,
    "lat": 38.4961
  }, {
    "lng": -82.7697,
    "lat": 38.496
  }, {
    "lng": -82.7698,
    "lat": 38.496
  }, {
    "lng": -82.7698,
    "lat": 38.4959
  }, {
    "lng": -82.7699,
    "lat": 38.4957
  }, {
    "lng": -82.77,
    "lat": 38.4956
  }, {
    "lng": -82.7702,
    "lat": 38.4954
  }, {
    "lng": -82.7706,
    "lat": 38.495
  }, {
    "lng": -82.7706,
    "lat": 38.4949
  }, {
    "lng": -82.7707,
    "lat": 38.4948
  }, {
    "lng": -82.7708,
    "lat": 38.4947
  }, {
    "lng": -82.7708,
    "lat": 38.4944
  }, {
    "lng": -82.7708,
    "lat": 38.494
  }, {
    "lng": -82.7705,
    "lat": 38.4935
  }, {
    "lng": -82.77,
    "lat": 38.4931
  }, {
    "lng": -82.7698,
    "lat": 38.4927
  }, {
    "lng": -82.7696,
    "lat": 38.4917
  }, {
    "lng": -82.7695,
    "lat": 38.4911
  }, {
    "lng": -82.7693,
    "lat": 38.4905
  }, {
    "lng": -82.7689,
    "lat": 38.4898
  }, {
    "lng": -82.7682,
    "lat": 38.4893
  }, {
    "lng": -82.7681,
    "lat": 38.4892
  }, {
    "lng": -82.7672,
    "lat": 38.4887
  }, {
    "lng": -82.7659,
    "lat": 38.4881
  }, {
    "lng": -82.765,
    "lat": 38.4877
  }, {
    "lng": -82.7636,
    "lat": 38.4871
  }, {
    "lng": -82.763,
    "lat": 38.4867
  }, {
    "lng": -82.7609,
    "lat": 38.4863
  }, {
    "lng": -82.7606,
    "lat": 38.4861
  }, {
    "lng": -82.7605,
    "lat": 38.486
  }, {
    "lng": -82.7602,
    "lat": 38.4858
  }, {
    "lng": -82.76,
    "lat": 38.4855
  }, {
    "lng": -82.7599,
    "lat": 38.4854
  }, {
    "lng": -82.7597,
    "lat": 38.4851
  }, {
    "lng": -82.7594,
    "lat": 38.4848
  }, {
    "lng": -82.7592,
    "lat": 38.4843
  }, {
    "lng": -82.7591,
    "lat": 38.4841
  }, {
    "lng": -82.759,
    "lat": 38.4833
  }, {
    "lng": -82.7589,
    "lat": 38.4828
  }, {
    "lng": -82.7587,
    "lat": 38.4824
  }, {
    "lng": -82.7586,
    "lat": 38.4821
  }, {
    "lng": -82.758,
    "lat": 38.4824
  }, {
    "lng": -82.7576,
    "lat": 38.4824
  }, {
    "lng": -82.7569,
    "lat": 38.4828
  }, {
    "lng": -82.7565,
    "lat": 38.483
  }, {
    "lng": -82.7563,
    "lat": 38.4831
  }, {
    "lng": -82.756,
    "lat": 38.4832
  }, {
    "lng": -82.7558,
    "lat": 38.4832
  }, {
    "lng": -82.7557,
    "lat": 38.4833
  }, {
    "lng": -82.7555,
    "lat": 38.4832
  }, {
    "lng": -82.7553,
    "lat": 38.4833
  }, {
    "lng": -82.755,
    "lat": 38.4834
  }, {
    "lng": -82.7546,
    "lat": 38.4835
  }, {
    "lng": -82.7545,
    "lat": 38.4835
  }, {
    "lng": -82.7545,
    "lat": 38.4836
  }, {
    "lng": -82.7543,
    "lat": 38.4837
  }, {
    "lng": -82.7536,
    "lat": 38.4838
  }, {
    "lng": -82.7531,
    "lat": 38.4839
  }, {
    "lng": -82.7527,
    "lat": 38.4839
  }, {
    "lng": -82.7523,
    "lat": 38.4839
  }, {
    "lng": -82.752,
    "lat": 38.4839
  }, {
    "lng": -82.7517,
    "lat": 38.4839
  }, {
    "lng": -82.7517,
    "lat": 38.4841
  }, {
    "lng": -82.7504,
    "lat": 38.4836
  }, {
    "lng": -82.7495,
    "lat": 38.483
  }, {
    "lng": -82.749,
    "lat": 38.4825
  }, {
    "lng": -82.7488,
    "lat": 38.4824
  }, {
    "lng": -82.748,
    "lat": 38.4822
  }, {
    "lng": -82.7475,
    "lat": 38.4821
  }, {
    "lng": -82.7464,
    "lat": 38.482
  }, {
    "lng": -82.7439,
    "lat": 38.4823
  }, {
    "lng": -82.7429,
    "lat": 38.4824
  }, {
    "lng": -82.7426,
    "lat": 38.4824
  }, {
    "lng": -82.742,
    "lat": 38.4817
  }, {
    "lng": -82.7414,
    "lat": 38.4815
  }, {
    "lng": -82.7406,
    "lat": 38.4819
  }, {
    "lng": -82.7401,
    "lat": 38.482
  }, {
    "lng": -82.7396,
    "lat": 38.482
  }, {
    "lng": -82.7392,
    "lat": 38.482
  }, {
    "lng": -82.7389,
    "lat": 38.4819
  }, {
    "lng": -82.7386,
    "lat": 38.4818
  }, {
    "lng": -82.7384,
    "lat": 38.4816
  }, {
    "lng": -82.7382,
    "lat": 38.4815
  }, {
    "lng": -82.7379,
    "lat": 38.4815
  }, {
    "lng": -82.7359,
    "lat": 38.4818
  }, {
    "lng": -82.7356,
    "lat": 38.4818
  }, {
    "lng": -82.7348,
    "lat": 38.4817
  }, {
    "lng": -82.7346,
    "lat": 38.4817
  }, {
    "lng": -82.734,
    "lat": 38.4815
  }, {
    "lng": -82.733,
    "lat": 38.481
  }, {
    "lng": -82.7328,
    "lat": 38.481
  }, {
    "lng": -82.7323,
    "lat": 38.4808
  }, {
    "lng": -82.7316,
    "lat": 38.4807
  }, {
    "lng": -82.7318,
    "lat": 38.4805
  }, {
    "lng": -82.7321,
    "lat": 38.4804
  }, {
    "lng": -82.7337,
    "lat": 38.4787
  }, {
    "lng": -82.7347,
    "lat": 38.4782
  }, {
    "lng": -82.7351,
    "lat": 38.478
  }, {
    "lng": -82.7361,
    "lat": 38.4773
  }, {
    "lng": -82.7363,
    "lat": 38.4772
  }, {
    "lng": -82.7364,
    "lat": 38.4771
  }, {
    "lng": -82.7364,
    "lat": 38.477
  }, {
    "lng": -82.7365,
    "lat": 38.4763
  }, {
    "lng": -82.7366,
    "lat": 38.4757
  }, {
    "lng": -82.7365,
    "lat": 38.4754
  }, {
    "lng": -82.7362,
    "lat": 38.4752
  }, {
    "lng": -82.7357,
    "lat": 38.4747
  }, {
    "lng": -82.7354,
    "lat": 38.4742
  }, {
    "lng": -82.7352,
    "lat": 38.4736
  }, {
    "lng": -82.7348,
    "lat": 38.4736
  }, {
    "lng": -82.7344,
    "lat": 38.4735
  }, {
    "lng": -82.7342,
    "lat": 38.4735
  }, {
    "lng": -82.7339,
    "lat": 38.4735
  }, {
    "lng": -82.7337,
    "lat": 38.4733
  }, {
    "lng": -82.7336,
    "lat": 38.473
  }, {
    "lng": -82.7335,
    "lat": 38.4729
  }, {
    "lng": -82.7332,
    "lat": 38.4727
  }, {
    "lng": -82.7328,
    "lat": 38.4725
  }, {
    "lng": -82.7325,
    "lat": 38.4722
  }, {
    "lng": -82.7317,
    "lat": 38.4715
  }, {
    "lng": -82.7313,
    "lat": 38.4713
  }, {
    "lng": -82.731,
    "lat": 38.4713
  }, {
    "lng": -82.7304,
    "lat": 38.4711
  }, {
    "lng": -82.7282,
    "lat": 38.4704
  }, {
    "lng": -82.7271,
    "lat": 38.4702
  }, {
    "lng": -82.7262,
    "lat": 38.47
  }, {
    "lng": -82.7263,
    "lat": 38.4704
  }, {
    "lng": -82.7263,
    "lat": 38.4704
  }, {
    "lng": -82.7263,
    "lat": 38.4705
  }, {
    "lng": -82.7263,
    "lat": 38.4705
  }, {
    "lng": -82.7263,
    "lat": 38.4705
  }, {
    "lng": -82.7263,
    "lat": 38.4706
  }, {
    "lng": -82.7262,
    "lat": 38.4706
  }, {
    "lng": -82.7258,
    "lat": 38.4709
  }, {
    "lng": -82.7255,
    "lat": 38.471
  }, {
    "lng": -82.7252,
    "lat": 38.4711
  }, {
    "lng": -82.7251,
    "lat": 38.4712
  }, {
    "lng": -82.725,
    "lat": 38.4712
  }, {
    "lng": -82.7247,
    "lat": 38.4712
  }, {
    "lng": -82.7247,
    "lat": 38.4712
  }, {
    "lng": -82.7245,
    "lat": 38.4712
  }, {
    "lng": -82.7244,
    "lat": 38.4712
  }, {
    "lng": -82.7244,
    "lat": 38.4712
  }, {
    "lng": -82.7243,
    "lat": 38.4712
  }, {
    "lng": -82.7242,
    "lat": 38.4711
  }, {
    "lng": -82.7242,
    "lat": 38.471
  }, {
    "lng": -82.7241,
    "lat": 38.471
  }, {
    "lng": -82.7241,
    "lat": 38.4709
  }, {
    "lng": -82.7239,
    "lat": 38.4707
  }, {
    "lng": -82.7225,
    "lat": 38.4753
  }, {
    "lng": -82.7252,
    "lat": 38.4754
  }, {
    "lng": -82.7255,
    "lat": 38.4756
  }, {
    "lng": -82.7258,
    "lat": 38.4757
  }, {
    "lng": -82.7261,
    "lat": 38.476
  }, {
    "lng": -82.7263,
    "lat": 38.4762
  }, {
    "lng": -82.7266,
    "lat": 38.4764
  }, {
    "lng": -82.7267,
    "lat": 38.4767
  }, {
    "lng": -82.7271,
    "lat": 38.4771
  }, {
    "lng": -82.7274,
    "lat": 38.4775
  }, {
    "lng": -82.7276,
    "lat": 38.4776
  }, {
    "lng": -82.7279,
    "lat": 38.4778
  }, {
    "lng": -82.7283,
    "lat": 38.478
  }, {
    "lng": -82.7286,
    "lat": 38.4783
  }, {
    "lng": -82.7288,
    "lat": 38.4785
  }, {
    "lng": -82.7289,
    "lat": 38.4788
  }, {
    "lng": -82.729,
    "lat": 38.4792
  }, {
    "lng": -82.7291,
    "lat": 38.4793
  }, {
    "lng": -82.7294,
    "lat": 38.4795
  }, {
    "lng": -82.7297,
    "lat": 38.4797
  }, {
    "lng": -82.7299,
    "lat": 38.4799
  }, {
    "lng": -82.7301,
    "lat": 38.48
  }, {
    "lng": -82.7302,
    "lat": 38.4802
  }, {
    "lng": -82.7301,
    "lat": 38.4804
  }, {
    "lng": -82.73,
    "lat": 38.4808
  }, {
    "lng": -82.73,
    "lat": 38.481
  }, {
    "lng": -82.7299,
    "lat": 38.4813
  }, {
    "lng": -82.7298,
    "lat": 38.4815
  }, {
    "lng": -82.7297,
    "lat": 38.4818
  }, {
    "lng": -82.7297,
    "lat": 38.4819
  }, {
    "lng": -82.7296,
    "lat": 38.4824
  }, {
    "lng": -82.7296,
    "lat": 38.4827
  }, {
    "lng": -82.7297,
    "lat": 38.4829
  }, {
    "lng": -82.7294,
    "lat": 38.4829
  }, {
    "lng": -82.7298,
    "lat": 38.4833
  }, {
    "lng": -82.7303,
    "lat": 38.4838
  }, {
    "lng": -82.7304,
    "lat": 38.4841
  }, {
    "lng": -82.7306,
    "lat": 38.4845
  }, {
    "lng": -82.7308,
    "lat": 38.4851
  }, {
    "lng": -82.7309,
    "lat": 38.4858
  }, {
    "lng": -82.7306,
    "lat": 38.4869
  }, {
    "lng": -82.7308,
    "lat": 38.4876
  }, {
    "lng": -82.7309,
    "lat": 38.4879
  }, {
    "lng": -82.7309,
    "lat": 38.488
  }, {
    "lng": -82.7311,
    "lat": 38.488
  }, {
    "lng": -82.7312,
    "lat": 38.488
  }, {
    "lng": -82.7313,
    "lat": 38.488
  }, {
    "lng": -82.7315,
    "lat": 38.488
  }, {
    "lng": -82.7317,
    "lat": 38.488
  }, {
    "lng": -82.7319,
    "lat": 38.4881
  }, {
    "lng": -82.732,
    "lat": 38.4881
  }, {
    "lng": -82.7322,
    "lat": 38.4882
  }, {
    "lng": -82.7325,
    "lat": 38.4894
  }, {
    "lng": -82.7325,
    "lat": 38.4895
  }, {
    "lng": -82.7325,
    "lat": 38.4898
  }, {
    "lng": -82.7327,
    "lat": 38.4903
  }, {
    "lng": -82.7327,
    "lat": 38.4906
  }, {
    "lng": -82.7329,
    "lat": 38.491
  }, {
    "lng": -82.733,
    "lat": 38.4916
  }, {
    "lng": -82.7326,
    "lat": 38.4913
  }, {
    "lng": -82.7314,
    "lat": 38.4917
  }, {
    "lng": -82.7301,
    "lat": 38.4924
  }, {
    "lng": -82.73,
    "lat": 38.4924
  }, {
    "lng": -82.7297,
    "lat": 38.4925
  }, {
    "lng": -82.7295,
    "lat": 38.4924
  }, {
    "lng": -82.7292,
    "lat": 38.4924
  }, {
    "lng": -82.728,
    "lat": 38.4921
  }, {
    "lng": -82.7271,
    "lat": 38.4932
  }, {
    "lng": -82.7274,
    "lat": 38.4938
  }, {
    "lng": -82.7261,
    "lat": 38.4936
  }, {
    "lng": -82.7263,
    "lat": 38.4944
  }, {
    "lng": -82.7264,
    "lat": 38.4949
  }, {
    "lng": -82.7258,
    "lat": 38.4965
  }, {
    "lng": -82.7258,
    "lat": 38.4966
  }, {
    "lng": -82.7259,
    "lat": 38.4967
  }, {
    "lng": -82.7261,
    "lat": 38.4967
  }, {
    "lng": -82.7263,
    "lat": 38.4968
  }, {
    "lng": -82.7267,
    "lat": 38.4969
  }, {
    "lng": -82.7277,
    "lat": 38.4972
  }, {
    "lng": -82.7288,
    "lat": 38.4975
  }, {
    "lng": -82.7292,
    "lat": 38.4976
  }, {
    "lng": -82.7294,
    "lat": 38.4977
  }, {
    "lng": -82.7294,
    "lat": 38.4977
  }, {
    "lng": -82.7295,
    "lat": 38.4978
  }, {
    "lng": -82.7296,
    "lat": 38.4978
  }, {
    "lng": -82.7296,
    "lat": 38.4978
  }, {
    "lng": -82.7297,
    "lat": 38.4979
  }, {
    "lng": -82.7298,
    "lat": 38.498
  }, {
    "lng": -82.7299,
    "lat": 38.4981
  }, {
    "lng": -82.7299,
    "lat": 38.4982
  }, {
    "lng": -82.73,
    "lat": 38.4983
  }, {
    "lng": -82.73,
    "lat": 38.4984
  }, {
    "lng": -82.73,
    "lat": 38.4985
  }, {
    "lng": -82.7299,
    "lat": 38.4986
  }, {
    "lng": -82.7299,
    "lat": 38.4987
  }, {
    "lng": -82.7298,
    "lat": 38.4988
  }, {
    "lng": -82.7296,
    "lat": 38.499
  }, {
    "lng": -82.7295,
    "lat": 38.4991
  }, {
    "lng": -82.7294,
    "lat": 38.4992
  }, {
    "lng": -82.7293,
    "lat": 38.4993
  }, {
    "lng": -82.7292,
    "lat": 38.4994
  }, {
    "lng": -82.729,
    "lat": 38.4995
  }, {
    "lng": -82.729,
    "lat": 38.4995
  }, {
    "lng": -82.7288,
    "lat": 38.4997
  }, {
    "lng": -82.7284,
    "lat": 38.5001
  }, {
    "lng": -82.7283,
    "lat": 38.5003
  }, {
    "lng": -82.7282,
    "lat": 38.5004
  }, {
    "lng": -82.728,
    "lat": 38.5007
  }, {
    "lng": -82.728,
    "lat": 38.501
  }, {
    "lng": -82.7279,
    "lat": 38.5011
  }, {
    "lng": -82.7278,
    "lat": 38.5012
  }, {
    "lng": -82.7277,
    "lat": 38.5014
  }, {
    "lng": -82.7276,
    "lat": 38.5015
  }, {
    "lng": -82.7275,
    "lat": 38.5016
  }, {
    "lng": -82.7275,
    "lat": 38.5017
  }, {
    "lng": -82.7274,
    "lat": 38.5018
  }, {
    "lng": -82.7272,
    "lat": 38.502
  }, {
    "lng": -82.7271,
    "lat": 38.5021
  }, {
    "lng": -82.7269,
    "lat": 38.5022
  }, {
    "lng": -82.7261,
    "lat": 38.5028
  }, {
    "lng": -82.7257,
    "lat": 38.503
  }, {
    "lng": -82.7246,
    "lat": 38.5036
  }, {
    "lng": -82.7244,
    "lat": 38.5037
  }, {
    "lng": -82.7242,
    "lat": 38.5038
  }, {
    "lng": -82.7239,
    "lat": 38.504
  }, {
    "lng": -82.7236,
    "lat": 38.5043
  }, {
    "lng": -82.7233,
    "lat": 38.5046
  }, {
    "lng": -82.723,
    "lat": 38.5049
  }, {
    "lng": -82.7227,
    "lat": 38.5051
  }, {
    "lng": -82.7225,
    "lat": 38.5054
  }, {
    "lng": -82.7223,
    "lat": 38.5057
  }]]],
  "options": {
    "fillColor": "#0fbb58",
    "fillOpacity": 0.4,
    "strokeColor": "#0B8C42",
    "strokeWeight": 1,
    "strokeOpacity": 0.4,
    "clickable": true,
    "visible": true,
    "zIndex": 1000
  }
};
var carrierRoute08 = {
  carrierRoute: '41139C001',
  paths: [[[{
    lng: -82.6978,
    lat: 38.5244
  }, {
    lng: -82.6979,
    lat: 38.5247
  }, {
    lng: -82.6979,
    lat: 38.5251
  }, {
    lng: -82.698,
    lat: 38.5258
  }, {
    lng: -82.698,
    lat: 38.5264
  }, {
    lng: -82.6981,
    lat: 38.5264
  }, {
    lng: -82.6982,
    lat: 38.5265
  }, {
    lng: -82.6982,
    lat: 38.5266
  }, {
    lng: -82.6983,
    lat: 38.5268
  }, {
    lng: -82.6983,
    lat: 38.527
  }, {
    lng: -82.6983,
    lat: 38.5273
  }, {
    lng: -82.6983,
    lat: 38.5276
  }, {
    lng: -82.6984,
    lat: 38.5277
  }, {
    lng: -82.6987,
    lat: 38.5279
  }, {
    lng: -82.6989,
    lat: 38.528
  }, {
    lng: -82.6992,
    lat: 38.5282
  }, {
    lng: -82.7003,
    lat: 38.5284
  }, {
    lng: -82.7004,
    lat: 38.5284
  }, {
    lng: -82.7009,
    lat: 38.5291
  }, {
    lng: -82.7013,
    lat: 38.5292
  }, {
    lng: -82.7019,
    lat: 38.5294
  }, {
    lng: -82.7021,
    lat: 38.529
  }, {
    lng: -82.7021,
    lat: 38.529
  }, {
    lng: -82.7022,
    lat: 38.529
  }, {
    lng: -82.7027,
    lat: 38.5292
  }, {
    lng: -82.7025,
    lat: 38.5295
  }, {
    lng: -82.7025,
    lat: 38.5297
  }, {
    lng: -82.7028,
    lat: 38.5298
  }, {
    lng: -82.7034,
    lat: 38.53
  }, {
    lng: -82.7031,
    lat: 38.5305
  }, {
    lng: -82.703,
    lat: 38.5307
  }, {
    lng: -82.7027,
    lat: 38.5311
  }, {
    lng: -82.7027,
    lat: 38.5318
  }, {
    lng: -82.702,
    lat: 38.532
  }, {
    lng: -82.7024,
    lat: 38.532
  }, {
    lng: -82.7026,
    lat: 38.532
  }, {
    lng: -82.7027,
    lat: 38.532
  }, {
    lng: -82.7029,
    lat: 38.5319
  }, {
    lng: -82.703,
    lat: 38.5319
  }, {
    lng: -82.7031,
    lat: 38.5319
  }, {
    lng: -82.7031,
    lat: 38.5319
  }, {
    lng: -82.7032,
    lat: 38.5319
  }, {
    lng: -82.7032,
    lat: 38.5319
  }, {
    lng: -82.7032,
    lat: 38.5318
  }, {
    lng: -82.7033,
    lat: 38.5318
  }, {
    lng: -82.7034,
    lat: 38.5318
  }, {
    lng: -82.7035,
    lat: 38.5317
  }, {
    lng: -82.7036,
    lat: 38.5316
  }, {
    lng: -82.7038,
    lat: 38.5314
  }, {
    lng: -82.7039,
    lat: 38.5312
  }, {
    lng: -82.7041,
    lat: 38.5311
  }, {
    lng: -82.7043,
    lat: 38.531
  }, {
    lng: -82.7045,
    lat: 38.5309
  }, {
    lng: -82.7045,
    lat: 38.5308
  }, {
    lng: -82.7046,
    lat: 38.5308
  }, {
    lng: -82.7048,
    lat: 38.531
  }, {
    lng: -82.7056,
    lat: 38.5315
  }, {
    lng: -82.7058,
    lat: 38.5318
  }, {
    lng: -82.7057,
    lat: 38.5319
  }, {
    lng: -82.7057,
    lat: 38.532
  }, {
    lng: -82.7057,
    lat: 38.5321
  }, {
    lng: -82.7057,
    lat: 38.5322
  }, {
    lng: -82.7056,
    lat: 38.5323
  }, {
    lng: -82.7056,
    lat: 38.5325
  }, {
    lng: -82.7056,
    lat: 38.5326
  }, {
    lng: -82.7056,
    lat: 38.5327
  }, {
    lng: -82.7057,
    lat: 38.5328
  }, {
    lng: -82.7057,
    lat: 38.5329
  }, {
    lng: -82.7058,
    lat: 38.5331
  }, {
    lng: -82.7059,
    lat: 38.5332
  }, {
    lng: -82.706,
    lat: 38.5334
  }, {
    lng: -82.7062,
    lat: 38.5336
  }, {
    lng: -82.7064,
    lat: 38.5338
  }, {
    lng: -82.7066,
    lat: 38.5339
  }, {
    lng: -82.7069,
    lat: 38.534
  }, {
    lng: -82.707,
    lat: 38.5342
  }, {
    lng: -82.707,
    lat: 38.5342
  }, {
    lng: -82.7069,
    lat: 38.5343
  }, {
    lng: -82.7067,
    lat: 38.5345
  }, {
    lng: -82.7065,
    lat: 38.5348
  }, {
    lng: -82.7061,
    lat: 38.5352
  }, {
    lng: -82.7059,
    lat: 38.5353
  }, {
    lng: -82.7059,
    lat: 38.5354
  }, {
    lng: -82.7058,
    lat: 38.5354
  }, {
    lng: -82.7056,
    lat: 38.5356
  }, {
    lng: -82.7051,
    lat: 38.5359
  }, {
    lng: -82.705,
    lat: 38.5359
  }, {
    lng: -82.7049,
    lat: 38.536
  }, {
    lng: -82.7047,
    lat: 38.5358
  }, {
    lng: -82.7045,
    lat: 38.5356
  }, {
    lng: -82.7043,
    lat: 38.5354
  }, {
    lng: -82.7042,
    lat: 38.5354
  }, {
    lng: -82.7042,
    lat: 38.5353
  }, {
    lng: -82.7041,
    lat: 38.5353
  }, {
    lng: -82.7038,
    lat: 38.5351
  }, {
    lng: -82.7031,
    lat: 38.5347
  }, {
    lng: -82.7021,
    lat: 38.534
  }, {
    lng: -82.7012,
    lat: 38.5335
  }, {
    lng: -82.7001,
    lat: 38.5329
  }, {
    lng: -82.7,
    lat: 38.5328
  }, {
    lng: -82.6999,
    lat: 38.5329
  }, {
    lng: -82.6996,
    lat: 38.533
  }, {
    lng: -82.6994,
    lat: 38.5331
  }, {
    lng: -82.702,
    lat: 38.5353
  }, {
    lng: -82.7023,
    lat: 38.5355
  }, {
    lng: -82.7026,
    lat: 38.5356
  }, {
    lng: -82.7028,
    lat: 38.5357
  }, {
    lng: -82.7031,
    lat: 38.5358
  }, {
    lng: -82.7038,
    lat: 38.5361
  }, {
    lng: -82.7045,
    lat: 38.5365
  }, {
    lng: -82.7053,
    lat: 38.5369
  }, {
    lng: -82.7057,
    lat: 38.5371
  }, {
    lng: -82.7066,
    lat: 38.5376
  }, {
    lng: -82.7073,
    lat: 38.538
  }, {
    lng: -82.7079,
    lat: 38.5383
  }, {
    lng: -82.7085,
    lat: 38.5387
  }, {
    lng: -82.7092,
    lat: 38.539
  }, {
    lng: -82.7098,
    lat: 38.5393
  }, {
    lng: -82.7105,
    lat: 38.5396
  }, {
    lng: -82.7112,
    lat: 38.5399
  }, {
    lng: -82.7118,
    lat: 38.5402
  }, {
    lng: -82.7126,
    lat: 38.5405
  }, {
    lng: -82.7132,
    lat: 38.5407
  }, {
    lng: -82.7135,
    lat: 38.5408
  }, {
    lng: -82.714,
    lat: 38.541
  }, {
    lng: -82.7143,
    lat: 38.5407
  }, {
    lng: -82.715,
    lat: 38.5405
  }, {
    lng: -82.7148,
    lat: 38.5404
  }, {
    lng: -82.715,
    lat: 38.5404
  }, {
    lng: -82.7152,
    lat: 38.5404
  }, {
    lng: -82.7153,
    lat: 38.5404
  }, {
    lng: -82.7153,
    lat: 38.5403
  }, {
    lng: -82.7153,
    lat: 38.5402
  }, {
    lng: -82.7151,
    lat: 38.54
  }, {
    lng: -82.715,
    lat: 38.5398
  }, {
    lng: -82.7148,
    lat: 38.5395
  }, {
    lng: -82.7147,
    lat: 38.5392
  }, {
    lng: -82.7148,
    lat: 38.539
  }, {
    lng: -82.7151,
    lat: 38.5389
  }, {
    lng: -82.7156,
    lat: 38.5388
  }, {
    lng: -82.716,
    lat: 38.5389
  }, {
    lng: -82.7164,
    lat: 38.5387
  }, {
    lng: -82.7168,
    lat: 38.5385
  }, {
    lng: -82.717,
    lat: 38.5383
  }, {
    lng: -82.717,
    lat: 38.5379
  }, {
    lng: -82.717,
    lat: 38.5378
  }, {
    lng: -82.7168,
    lat: 38.5375
  }, {
    lng: -82.7167,
    lat: 38.5373
  }, {
    lng: -82.7164,
    lat: 38.5369
  }, {
    lng: -82.7161,
    lat: 38.5367
  }, {
    lng: -82.7158,
    lat: 38.5364
  }, {
    lng: -82.7154,
    lat: 38.5362
  }, {
    lng: -82.715,
    lat: 38.5362
  }, {
    lng: -82.7147,
    lat: 38.5359
  }, {
    lng: -82.7145,
    lat: 38.5358
  }, {
    lng: -82.7146,
    lat: 38.5352
  }, {
    lng: -82.7146,
    lat: 38.5354
  }, {
    lng: -82.7147,
    lat: 38.5354
  }, {
    lng: -82.7147,
    lat: 38.5354
  }, {
    lng: -82.7148,
    lat: 38.5354
  }, {
    lng: -82.7149,
    lat: 38.5353
  }, {
    lng: -82.715,
    lat: 38.5353
  }, {
    lng: -82.7151,
    lat: 38.5352
  }, {
    lng: -82.7152,
    lat: 38.5351
  }, {
    lng: -82.7155,
    lat: 38.535
  }, {
    lng: -82.7158,
    lat: 38.5348
  }, {
    lng: -82.716,
    lat: 38.5347
  }, {
    lng: -82.7161,
    lat: 38.5346
  }, {
    lng: -82.7163,
    lat: 38.5346
  }, {
    lng: -82.7164,
    lat: 38.5345
  }, {
    lng: -82.7166,
    lat: 38.5345
  }, {
    lng: -82.7169,
    lat: 38.5344
  }, {
    lng: -82.717,
    lat: 38.5343
  }, {
    lng: -82.7171,
    lat: 38.5343
  }, {
    lng: -82.7174,
    lat: 38.5341
  }, {
    lng: -82.7177,
    lat: 38.5337
  }, {
    lng: -82.7179,
    lat: 38.5335
  }, {
    lng: -82.7181,
    lat: 38.5334
  }, {
    lng: -82.7181,
    lat: 38.5333
  }, {
    lng: -82.7182,
    lat: 38.5331
  }, {
    lng: -82.7184,
    lat: 38.533
  }, {
    lng: -82.7185,
    lat: 38.5328
  }, {
    lng: -82.7186,
    lat: 38.5328
  }, {
    lng: -82.7186,
    lat: 38.5327
  }, {
    lng: -82.7189,
    lat: 38.5325
  }, {
    lng: -82.719,
    lat: 38.5324
  }, {
    lng: -82.7191,
    lat: 38.5324
  }, {
    lng: -82.7192,
    lat: 38.5323
  }, {
    lng: -82.7193,
    lat: 38.5322
  }, {
    lng: -82.7194,
    lat: 38.5322
  }, {
    lng: -82.7194,
    lat: 38.532
  }, {
    lng: -82.7193,
    lat: 38.5319
  }, {
    lng: -82.7205,
    lat: 38.5315
  }, {
    lng: -82.7217,
    lat: 38.5309
  }, {
    lng: -82.7233,
    lat: 38.5296
  }, {
    lng: -82.7235,
    lat: 38.5292
  }, {
    lng: -82.7238,
    lat: 38.5292
  }, {
    lng: -82.724,
    lat: 38.5288
  }, {
    lng: -82.7241,
    lat: 38.5286
  }, {
    lng: -82.7242,
    lat: 38.5285
  }, {
    lng: -82.7244,
    lat: 38.5282
  }, {
    lng: -82.7247,
    lat: 38.5282
  }, {
    lng: -82.7248,
    lat: 38.5282
  }, {
    lng: -82.725,
    lat: 38.5281
  }, {
    lng: -82.7249,
    lat: 38.528
  }, {
    lng: -82.7248,
    lat: 38.5279
  }, {
    lng: -82.7247,
    lat: 38.5277
  }, {
    lng: -82.7245,
    lat: 38.5275
  }, {
    lng: -82.7243,
    lat: 38.5272
  }, {
    lng: -82.7242,
    lat: 38.5272
  }, {
    lng: -82.7241,
    lat: 38.5271
  }, {
    lng: -82.724,
    lat: 38.527
  }, {
    lng: -82.7238,
    lat: 38.5269
  }, {
    lng: -82.7236,
    lat: 38.5269
  }, {
    lng: -82.7229,
    lat: 38.5265
  }, {
    lng: -82.7223,
    lat: 38.5275
  }, {
    lng: -82.7223,
    lat: 38.5275
  }, {
    lng: -82.7223,
    lat: 38.5276
  }, {
    lng: -82.7222,
    lat: 38.5276
  }, {
    lng: -82.7221,
    lat: 38.5275
  }, {
    lng: -82.7215,
    lat: 38.5271
  }, {
    lng: -82.7212,
    lat: 38.527
  }, {
    lng: -82.7211,
    lat: 38.5269
  }, {
    lng: -82.721,
    lat: 38.5269
  }, {
    lng: -82.721,
    lat: 38.5269
  }, {
    lng: -82.7216,
    lat: 38.526
  }, {
    lng: -82.7209,
    lat: 38.5257
  }, {
    lng: -82.7207,
    lat: 38.5256
  }, {
    lng: -82.7203,
    lat: 38.5253
  }, {
    lng: -82.7199,
    lat: 38.5249
  }, {
    lng: -82.7194,
    lat: 38.5245
  }, {
    lng: -82.7186,
    lat: 38.5245
  }, {
    lng: -82.7181,
    lat: 38.5248
  }, {
    lng: -82.7176,
    lat: 38.5251
  }, {
    lng: -82.7181,
    lat: 38.5253
  }, {
    lng: -82.719,
    lat: 38.5258
  }, {
    lng: -82.719,
    lat: 38.5258
  }, {
    lng: -82.719,
    lat: 38.5258
  }, {
    lng: -82.7189,
    lat: 38.5259
  }, {
    lng: -82.7189,
    lat: 38.526
  }, {
    lng: -82.7188,
    lat: 38.5261
  }, {
    lng: -82.7186,
    lat: 38.5262
  }, {
    lng: -82.7179,
    lat: 38.5268
  }, {
    lng: -82.7175,
    lat: 38.5271
  }, {
    lng: -82.7172,
    lat: 38.5275
  }, {
    lng: -82.7155,
    lat: 38.5266
  }, {
    lng: -82.7145,
    lat: 38.5261
  }, {
    lng: -82.7143,
    lat: 38.526
  }, {
    lng: -82.7138,
    lat: 38.5257
  }, {
    lng: -82.714,
    lat: 38.5255
  }, {
    lng: -82.7142,
    lat: 38.5254
  }, {
    lng: -82.7147,
    lat: 38.5249
  }, {
    lng: -82.7153,
    lat: 38.5244
  }, {
    lng: -82.7155,
    lat: 38.5242
  }, {
    lng: -82.7157,
    lat: 38.524
  }, {
    lng: -82.7162,
    lat: 38.5236
  }, {
    lng: -82.7164,
    lat: 38.5234
  }, {
    lng: -82.7168,
    lat: 38.5231
  }, {
    lng: -82.7172,
    lat: 38.5226
  }, {
    lng: -82.7187,
    lat: 38.5213
  }, {
    lng: -82.7187,
    lat: 38.5213
  }, {
    lng: -82.719,
    lat: 38.521
  }, {
    lng: -82.7196,
    lat: 38.5205
  }, {
    lng: -82.7184,
    lat: 38.5199
  }, {
    lng: -82.7184,
    lat: 38.5199
  }, {
    lng: -82.7184,
    lat: 38.5199
  }, {
    lng: -82.7184,
    lat: 38.5198
  }, {
    lng: -82.7189,
    lat: 38.5194
  }, {
    lng: -82.717,
    lat: 38.5182
  }, {
    lng: -82.7161,
    lat: 38.5178
  }, {
    lng: -82.7159,
    lat: 38.5182
  }, {
    lng: -82.7163,
    lat: 38.5184
  }, {
    lng: -82.7163,
    lat: 38.5184
  }, {
    lng: -82.7163,
    lat: 38.5184
  }, {
    lng: -82.7163,
    lat: 38.5185
  }, {
    lng: -82.7158,
    lat: 38.5193
  }, {
    lng: -82.7156,
    lat: 38.5197
  }, {
    lng: -82.7155,
    lat: 38.5197
  }, {
    lng: -82.7155,
    lat: 38.5198
  }, {
    lng: -82.7154,
    lat: 38.5198
  }, {
    lng: -82.715,
    lat: 38.52
  }, {
    lng: -82.7142,
    lat: 38.5205
  }, {
    lng: -82.7141,
    lat: 38.5204
  }, {
    lng: -82.714,
    lat: 38.5203
  }, {
    lng: -82.714,
    lat: 38.5203
  }, {
    lng: -82.7139,
    lat: 38.5202
  }, {
    lng: -82.7134,
    lat: 38.5199
  }, {
    lng: -82.7132,
    lat: 38.5198
  }, {
    lng: -82.7129,
    lat: 38.5196
  }, {
    lng: -82.7126,
    lat: 38.5194
  }, {
    lng: -82.7123,
    lat: 38.5193
  }, {
    lng: -82.7117,
    lat: 38.519
  }, {
    lng: -82.7113,
    lat: 38.5189
  }, {
    lng: -82.711,
    lat: 38.5188
  }, {
    lng: -82.7101,
    lat: 38.5184
  }, {
    lng: -82.7099,
    lat: 38.5183
  }, {
    lng: -82.7092,
    lat: 38.5181
  }, {
    lng: -82.7085,
    lat: 38.5178
  }, {
    lng: -82.7074,
    lat: 38.5173
  }, {
    lng: -82.7071,
    lat: 38.5172
  }, {
    lng: -82.7051,
    lat: 38.5165
  }, {
    lng: -82.7046,
    lat: 38.5163
  }, {
    lng: -82.7042,
    lat: 38.517
  }, {
    lng: -82.704,
    lat: 38.5169
  }, {
    lng: -82.7038,
    lat: 38.5168
  }, {
    lng: -82.7037,
    lat: 38.5167
  }, {
    lng: -82.7033,
    lat: 38.5172
  }, {
    lng: -82.7009,
    lat: 38.5194
  }, {
    lng: -82.7009,
    lat: 38.5197
  }, {
    lng: -82.7011,
    lat: 38.5199
  }, {
    lng: -82.701,
    lat: 38.52
  }, {
    lng: -82.7007,
    lat: 38.5201
  }, {
    lng: -82.7008,
    lat: 38.5203
  }, {
    lng: -82.7005,
    lat: 38.521
  }, {
    lng: -82.7008,
    lat: 38.521
  }, {
    lng: -82.7012,
    lat: 38.52
  }, {
    lng: -82.7014,
    lat: 38.52
  }, {
    lng: -82.7009,
    lat: 38.5213
  }, {
    lng: -82.7,
    lat: 38.5231
  }, {
    lng: -82.6999,
    lat: 38.5232
  }, {
    lng: -82.6999,
    lat: 38.5232
  }, {
    lng: -82.6998,
    lat: 38.5232
  }, {
    lng: -82.6997,
    lat: 38.5232
  }, {
    lng: -82.6996,
    lat: 38.5232
  }, {
    lng: -82.6994,
    lat: 38.5232
  }, {
    lng: -82.699,
    lat: 38.5234
  }, {
    lng: -82.6978,
    lat: 38.5244
  }]]],
  options: {
    fillColor: '#0fbb58',
    fillOpacity: 0.4,
    strokeColor: '#0B8C42',
    strokeWeight: 1,
    strokeOpacity: 0.4,
    clickable: true,
    visible: true,
    zIndex: 1000
  }
};
var carrierRoute09 = {
  "carrierRoute": "41102R005",
  "paths": [[[{
    "lng": -82.7197,
    "lat": 38.4936
  }, {
    "lng": -82.7199,
    "lat": 38.4938
  }, {
    "lng": -82.7199,
    "lat": 38.494
  }, {
    "lng": -82.72,
    "lat": 38.494
  }, {
    "lng": -82.7198,
    "lat": 38.4935
  }, {
    "lng": -82.7197,
    "lat": 38.4936
  }]], [[{
    "lng": -82.6721,
    "lat": 38.4656
  }, {
    "lng": -82.6722,
    "lat": 38.4656
  }, {
    "lng": -82.6722,
    "lat": 38.4656
  }, {
    "lng": -82.6725,
    "lat": 38.4656
  }, {
    "lng": -82.6726,
    "lat": 38.4656
  }, {
    "lng": -82.6728,
    "lat": 38.4655
  }, {
    "lng": -82.673,
    "lat": 38.4655
  }, {
    "lng": -82.6735,
    "lat": 38.4654
  }, {
    "lng": -82.6736,
    "lat": 38.4653
  }, {
    "lng": -82.6777,
    "lat": 38.4651
  }, {
    "lng": -82.6784,
    "lat": 38.4653
  }, {
    "lng": -82.6794,
    "lat": 38.4657
  }, {
    "lng": -82.6797,
    "lat": 38.4658
  }, {
    "lng": -82.6814,
    "lat": 38.4663
  }, {
    "lng": -82.6829,
    "lat": 38.4672
  }, {
    "lng": -82.6837,
    "lat": 38.4675
  }, {
    "lng": -82.689,
    "lat": 38.4723
  }, {
    "lng": -82.6887,
    "lat": 38.4726
  }, {
    "lng": -82.6883,
    "lat": 38.4727
  }, {
    "lng": -82.688,
    "lat": 38.4729
  }, {
    "lng": -82.6876,
    "lat": 38.473
  }, {
    "lng": -82.6874,
    "lat": 38.473
  }, {
    "lng": -82.6874,
    "lat": 38.4731
  }, {
    "lng": -82.6871,
    "lat": 38.4731
  }, {
    "lng": -82.6868,
    "lat": 38.4731
  }, {
    "lng": -82.6866,
    "lat": 38.4731
  }, {
    "lng": -82.6862,
    "lat": 38.4731
  }, {
    "lng": -82.6859,
    "lat": 38.4731
  }, {
    "lng": -82.6859,
    "lat": 38.4733
  }, {
    "lng": -82.6857,
    "lat": 38.4743
  }, {
    "lng": -82.6862,
    "lat": 38.4744
  }, {
    "lng": -82.6864,
    "lat": 38.4744
  }, {
    "lng": -82.6867,
    "lat": 38.4745
  }, {
    "lng": -82.6868,
    "lat": 38.4746
  }, {
    "lng": -82.6868,
    "lat": 38.4747
  }, {
    "lng": -82.6868,
    "lat": 38.4749
  }, {
    "lng": -82.6868,
    "lat": 38.475
  }, {
    "lng": -82.6867,
    "lat": 38.4755
  }, {
    "lng": -82.687,
    "lat": 38.4755
  }, {
    "lng": -82.6876,
    "lat": 38.4754
  }, {
    "lng": -82.6884,
    "lat": 38.4754
  }, {
    "lng": -82.6897,
    "lat": 38.4752
  }, {
    "lng": -82.6902,
    "lat": 38.4751
  }, {
    "lng": -82.6907,
    "lat": 38.4749
  }, {
    "lng": -82.6909,
    "lat": 38.4749
  }, {
    "lng": -82.6909,
    "lat": 38.4748
  }, {
    "lng": -82.6911,
    "lat": 38.4748
  }, {
    "lng": -82.6912,
    "lat": 38.4747
  }, {
    "lng": -82.6913,
    "lat": 38.4747
  }, {
    "lng": -82.6914,
    "lat": 38.4747
  }, {
    "lng": -82.6915,
    "lat": 38.4746
  }, {
    "lng": -82.6916,
    "lat": 38.4746
  }, {
    "lng": -82.6922,
    "lat": 38.4762
  }, {
    "lng": -82.692,
    "lat": 38.4776
  }, {
    "lng": -82.6924,
    "lat": 38.4791
  }, {
    "lng": -82.6925,
    "lat": 38.4795
  }, {
    "lng": -82.6923,
    "lat": 38.4804
  }, {
    "lng": -82.692,
    "lat": 38.4812
  }, {
    "lng": -82.6917,
    "lat": 38.4819
  }, {
    "lng": -82.6914,
    "lat": 38.4821
  }, {
    "lng": -82.6913,
    "lat": 38.4821
  }, {
    "lng": -82.6911,
    "lat": 38.4821
  }, {
    "lng": -82.6911,
    "lat": 38.4821
  }, {
    "lng": -82.6909,
    "lat": 38.482
  }, {
    "lng": -82.6909,
    "lat": 38.4819
  }, {
    "lng": -82.6907,
    "lat": 38.4818
  }, {
    "lng": -82.6905,
    "lat": 38.4816
  }, {
    "lng": -82.6902,
    "lat": 38.4815
  }, {
    "lng": -82.6902,
    "lat": 38.4828
  }, {
    "lng": -82.6904,
    "lat": 38.4838
  }, {
    "lng": -82.6906,
    "lat": 38.4837
  }, {
    "lng": -82.6908,
    "lat": 38.4836
  }, {
    "lng": -82.6909,
    "lat": 38.4836
  }, {
    "lng": -82.691,
    "lat": 38.4835
  }, {
    "lng": -82.6911,
    "lat": 38.4835
  }, {
    "lng": -82.6912,
    "lat": 38.4835
  }, {
    "lng": -82.6916,
    "lat": 38.4835
  }, {
    "lng": -82.6922,
    "lat": 38.4836
  }, {
    "lng": -82.6923,
    "lat": 38.4836
  }, {
    "lng": -82.6927,
    "lat": 38.4837
  }, {
    "lng": -82.6931,
    "lat": 38.4837
  }, {
    "lng": -82.6936,
    "lat": 38.4838
  }, {
    "lng": -82.6938,
    "lat": 38.4838
  }, {
    "lng": -82.6939,
    "lat": 38.4838
  }, {
    "lng": -82.6943,
    "lat": 38.4837
  }, {
    "lng": -82.6944,
    "lat": 38.4837
  }, {
    "lng": -82.6946,
    "lat": 38.4837
  }, {
    "lng": -82.6946,
    "lat": 38.4838
  }, {
    "lng": -82.6947,
    "lat": 38.4841
  }, {
    "lng": -82.6948,
    "lat": 38.4843
  }, {
    "lng": -82.6948,
    "lat": 38.4847
  }, {
    "lng": -82.6948,
    "lat": 38.4847
  }, {
    "lng": -82.6948,
    "lat": 38.4848
  }, {
    "lng": -82.6949,
    "lat": 38.485
  }, {
    "lng": -82.6949,
    "lat": 38.485
  }, {
    "lng": -82.6951,
    "lat": 38.4852
  }, {
    "lng": -82.6943,
    "lat": 38.4857
  }, {
    "lng": -82.6961,
    "lat": 38.4874
  }, {
    "lng": -82.702,
    "lat": 38.4926
  }, {
    "lng": -82.7055,
    "lat": 38.4954
  }, {
    "lng": -82.7057,
    "lat": 38.4954
  }, {
    "lng": -82.706,
    "lat": 38.4956
  }, {
    "lng": -82.7066,
    "lat": 38.4959
  }, {
    "lng": -82.7076,
    "lat": 38.4963
  }, {
    "lng": -82.7085,
    "lat": 38.4966
  }, {
    "lng": -82.7098,
    "lat": 38.4968
  }, {
    "lng": -82.7111,
    "lat": 38.497
  }, {
    "lng": -82.712,
    "lat": 38.4971
  }, {
    "lng": -82.7127,
    "lat": 38.4972
  }, {
    "lng": -82.7139,
    "lat": 38.4974
  }, {
    "lng": -82.7147,
    "lat": 38.4978
  }, {
    "lng": -82.7151,
    "lat": 38.4982
  }, {
    "lng": -82.7154,
    "lat": 38.4986
  }, {
    "lng": -82.7154,
    "lat": 38.4986
  }, {
    "lng": -82.7155,
    "lat": 38.4985
  }, {
    "lng": -82.7158,
    "lat": 38.4982
  }, {
    "lng": -82.7158,
    "lat": 38.4981
  }, {
    "lng": -82.7159,
    "lat": 38.498
  }, {
    "lng": -82.7163,
    "lat": 38.4974
  }, {
    "lng": -82.7163,
    "lat": 38.4973
  }, {
    "lng": -82.7165,
    "lat": 38.4971
  }, {
    "lng": -82.7168,
    "lat": 38.4966
  }, {
    "lng": -82.7176,
    "lat": 38.4955
  }, {
    "lng": -82.7177,
    "lat": 38.4952
  }, {
    "lng": -82.718,
    "lat": 38.4949
  }, {
    "lng": -82.7182,
    "lat": 38.4947
  }, {
    "lng": -82.7183,
    "lat": 38.4946
  }, {
    "lng": -82.7184,
    "lat": 38.4945
  }, {
    "lng": -82.7187,
    "lat": 38.4941
  }, {
    "lng": -82.7188,
    "lat": 38.494
  }, {
    "lng": -82.719,
    "lat": 38.4938
  }, {
    "lng": -82.7189,
    "lat": 38.4937
  }, {
    "lng": -82.7188,
    "lat": 38.4934
  }, {
    "lng": -82.7192,
    "lat": 38.4933
  }, {
    "lng": -82.719,
    "lat": 38.4923
  }, {
    "lng": -82.7195,
    "lat": 38.4922
  }, {
    "lng": -82.7204,
    "lat": 38.4926
  }, {
    "lng": -82.7211,
    "lat": 38.4936
  }, {
    "lng": -82.7226,
    "lat": 38.4927
  }, {
    "lng": -82.723,
    "lat": 38.4926
  }, {
    "lng": -82.7233,
    "lat": 38.4928
  }, {
    "lng": -82.7234,
    "lat": 38.4928
  }, {
    "lng": -82.7235,
    "lat": 38.4929
  }, {
    "lng": -82.7237,
    "lat": 38.4927
  }, {
    "lng": -82.7241,
    "lat": 38.4924
  }, {
    "lng": -82.7242,
    "lat": 38.4922
  }, {
    "lng": -82.7243,
    "lat": 38.492
  }, {
    "lng": -82.7245,
    "lat": 38.4919
  }, {
    "lng": -82.7255,
    "lat": 38.4914
  }, {
    "lng": -82.7267,
    "lat": 38.4909
  }, {
    "lng": -82.7268,
    "lat": 38.4909
  }, {
    "lng": -82.7272,
    "lat": 38.4906
  }, {
    "lng": -82.7275,
    "lat": 38.4903
  }, {
    "lng": -82.7288,
    "lat": 38.4894
  }, {
    "lng": -82.7295,
    "lat": 38.4889
  }, {
    "lng": -82.7298,
    "lat": 38.4887
  }, {
    "lng": -82.73,
    "lat": 38.4885
  }, {
    "lng": -82.7301,
    "lat": 38.4884
  }, {
    "lng": -82.7303,
    "lat": 38.4879
  }, {
    "lng": -82.7305,
    "lat": 38.4874
  }, {
    "lng": -82.7306,
    "lat": 38.4869
  }, {
    "lng": -82.7309,
    "lat": 38.4858
  }, {
    "lng": -82.7308,
    "lat": 38.4851
  }, {
    "lng": -82.7306,
    "lat": 38.4845
  }, {
    "lng": -82.7304,
    "lat": 38.4841
  }, {
    "lng": -82.7303,
    "lat": 38.4838
  }, {
    "lng": -82.7298,
    "lat": 38.4833
  }, {
    "lng": -82.7294,
    "lat": 38.4829
  }, {
    "lng": -82.7297,
    "lat": 38.4829
  }, {
    "lng": -82.7296,
    "lat": 38.4827
  }, {
    "lng": -82.7296,
    "lat": 38.4824
  }, {
    "lng": -82.7297,
    "lat": 38.4819
  }, {
    "lng": -82.7297,
    "lat": 38.4818
  }, {
    "lng": -82.7298,
    "lat": 38.4815
  }, {
    "lng": -82.7299,
    "lat": 38.4813
  }, {
    "lng": -82.73,
    "lat": 38.481
  }, {
    "lng": -82.73,
    "lat": 38.4808
  }, {
    "lng": -82.7301,
    "lat": 38.4804
  }, {
    "lng": -82.7302,
    "lat": 38.4802
  }, {
    "lng": -82.7301,
    "lat": 38.48
  }, {
    "lng": -82.7299,
    "lat": 38.4799
  }, {
    "lng": -82.7297,
    "lat": 38.4797
  }, {
    "lng": -82.7294,
    "lat": 38.4795
  }, {
    "lng": -82.7291,
    "lat": 38.4793
  }, {
    "lng": -82.729,
    "lat": 38.4792
  }, {
    "lng": -82.7289,
    "lat": 38.4788
  }, {
    "lng": -82.7288,
    "lat": 38.4785
  }, {
    "lng": -82.7286,
    "lat": 38.4783
  }, {
    "lng": -82.7283,
    "lat": 38.478
  }, {
    "lng": -82.7279,
    "lat": 38.4778
  }, {
    "lng": -82.7276,
    "lat": 38.4776
  }, {
    "lng": -82.7274,
    "lat": 38.4775
  }, {
    "lng": -82.7271,
    "lat": 38.4771
  }, {
    "lng": -82.7267,
    "lat": 38.4767
  }, {
    "lng": -82.7266,
    "lat": 38.4764
  }, {
    "lng": -82.7263,
    "lat": 38.4762
  }, {
    "lng": -82.7261,
    "lat": 38.476
  }, {
    "lng": -82.7258,
    "lat": 38.4757
  }, {
    "lng": -82.7255,
    "lat": 38.4756
  }, {
    "lng": -82.7252,
    "lat": 38.4754
  }, {
    "lng": -82.7225,
    "lat": 38.4753
  }, {
    "lng": -82.7239,
    "lat": 38.4707
  }, {
    "lng": -82.7241,
    "lat": 38.4709
  }, {
    "lng": -82.7241,
    "lat": 38.471
  }, {
    "lng": -82.7242,
    "lat": 38.471
  }, {
    "lng": -82.7242,
    "lat": 38.4711
  }, {
    "lng": -82.7243,
    "lat": 38.4712
  }, {
    "lng": -82.7244,
    "lat": 38.4712
  }, {
    "lng": -82.7244,
    "lat": 38.4712
  }, {
    "lng": -82.7245,
    "lat": 38.4712
  }, {
    "lng": -82.7247,
    "lat": 38.4712
  }, {
    "lng": -82.7247,
    "lat": 38.4712
  }, {
    "lng": -82.725,
    "lat": 38.4712
  }, {
    "lng": -82.7251,
    "lat": 38.4712
  }, {
    "lng": -82.7252,
    "lat": 38.4711
  }, {
    "lng": -82.7255,
    "lat": 38.471
  }, {
    "lng": -82.7258,
    "lat": 38.4709
  }, {
    "lng": -82.7262,
    "lat": 38.4706
  }, {
    "lng": -82.7263,
    "lat": 38.4706
  }, {
    "lng": -82.7263,
    "lat": 38.4705
  }, {
    "lng": -82.7263,
    "lat": 38.4705
  }, {
    "lng": -82.7263,
    "lat": 38.4705
  }, {
    "lng": -82.7263,
    "lat": 38.4704
  }, {
    "lng": -82.7263,
    "lat": 38.4704
  }, {
    "lng": -82.7262,
    "lat": 38.47
  }, {
    "lng": -82.7257,
    "lat": 38.4698
  }, {
    "lng": -82.7249,
    "lat": 38.4694
  }, {
    "lng": -82.7232,
    "lat": 38.4682
  }, {
    "lng": -82.7227,
    "lat": 38.4681
  }, {
    "lng": -82.7208,
    "lat": 38.4686
  }, {
    "lng": -82.7204,
    "lat": 38.4686
  }, {
    "lng": -82.7202,
    "lat": 38.4685
  }, {
    "lng": -82.7199,
    "lat": 38.4682
  }, {
    "lng": -82.7196,
    "lat": 38.4678
  }, {
    "lng": -82.7167,
    "lat": 38.4699
  }, {
    "lng": -82.7148,
    "lat": 38.4712
  }, {
    "lng": -82.7072,
    "lat": 38.4766
  }, {
    "lng": -82.7071,
    "lat": 38.4766
  }, {
    "lng": -82.7063,
    "lat": 38.4764
  }, {
    "lng": -82.7058,
    "lat": 38.4762
  }, {
    "lng": -82.7054,
    "lat": 38.4761
  }, {
    "lng": -82.7053,
    "lat": 38.4761
  }, {
    "lng": -82.7051,
    "lat": 38.476
  }, {
    "lng": -82.705,
    "lat": 38.4759
  }, {
    "lng": -82.7049,
    "lat": 38.4759
  }, {
    "lng": -82.7048,
    "lat": 38.4759
  }, {
    "lng": -82.7047,
    "lat": 38.4758
  }, {
    "lng": -82.7045,
    "lat": 38.4758
  }, {
    "lng": -82.7041,
    "lat": 38.4758
  }, {
    "lng": -82.7045,
    "lat": 38.4754
  }, {
    "lng": -82.7053,
    "lat": 38.4741
  }, {
    "lng": -82.7053,
    "lat": 38.474
  }, {
    "lng": -82.7056,
    "lat": 38.4734
  }, {
    "lng": -82.7056,
    "lat": 38.4733
  }, {
    "lng": -82.7057,
    "lat": 38.4732
  }, {
    "lng": -82.7058,
    "lat": 38.4729
  }, {
    "lng": -82.7058,
    "lat": 38.4728
  }, {
    "lng": -82.7059,
    "lat": 38.4726
  }, {
    "lng": -82.7059,
    "lat": 38.4725
  }, {
    "lng": -82.7059,
    "lat": 38.4724
  }, {
    "lng": -82.7058,
    "lat": 38.4722
  }, {
    "lng": -82.7058,
    "lat": 38.4721
  }, {
    "lng": -82.7057,
    "lat": 38.472
  }, {
    "lng": -82.7057,
    "lat": 38.4719
  }, {
    "lng": -82.7057,
    "lat": 38.4718
  }, {
    "lng": -82.7056,
    "lat": 38.4717
  }, {
    "lng": -82.7056,
    "lat": 38.4715
  }, {
    "lng": -82.7056,
    "lat": 38.4714
  }, {
    "lng": -82.7056,
    "lat": 38.4714
  }, {
    "lng": -82.7057,
    "lat": 38.4713
  }, {
    "lng": -82.7057,
    "lat": 38.4712
  }, {
    "lng": -82.7058,
    "lat": 38.4707
  }, {
    "lng": -82.7059,
    "lat": 38.4702
  }, {
    "lng": -82.706,
    "lat": 38.4699
  }, {
    "lng": -82.706,
    "lat": 38.4698
  }, {
    "lng": -82.7059,
    "lat": 38.4698
  }, {
    "lng": -82.7058,
    "lat": 38.4699
  }, {
    "lng": -82.7056,
    "lat": 38.47
  }, {
    "lng": -82.7056,
    "lat": 38.4701
  }, {
    "lng": -82.7055,
    "lat": 38.4701
  }, {
    "lng": -82.7046,
    "lat": 38.4706
  }, {
    "lng": -82.7045,
    "lat": 38.4707
  }, {
    "lng": -82.7044,
    "lat": 38.4708
  }, {
    "lng": -82.7042,
    "lat": 38.4708
  }, {
    "lng": -82.704,
    "lat": 38.4708
  }, {
    "lng": -82.7038,
    "lat": 38.4709
  }, {
    "lng": -82.7035,
    "lat": 38.4709
  }, {
    "lng": -82.7033,
    "lat": 38.4708
  }, {
    "lng": -82.703,
    "lat": 38.4708
  }, {
    "lng": -82.7027,
    "lat": 38.4706
  }, {
    "lng": -82.7024,
    "lat": 38.4705
  }, {
    "lng": -82.7022,
    "lat": 38.4704
  }, {
    "lng": -82.7021,
    "lat": 38.4704
  }, {
    "lng": -82.7022,
    "lat": 38.4699
  }, {
    "lng": -82.7022,
    "lat": 38.4696
  }, {
    "lng": -82.7022,
    "lat": 38.4695
  }, {
    "lng": -82.7021,
    "lat": 38.4693
  }, {
    "lng": -82.7019,
    "lat": 38.4687
  }, {
    "lng": -82.7011,
    "lat": 38.4682
  }, {
    "lng": -82.6999,
    "lat": 38.4672
  }, {
    "lng": -82.6999,
    "lat": 38.4672
  }, {
    "lng": -82.6999,
    "lat": 38.4671
  }, {
    "lng": -82.7,
    "lat": 38.4669
  }, {
    "lng": -82.7001,
    "lat": 38.4667
  }, {
    "lng": -82.7001,
    "lat": 38.4664
  }, {
    "lng": -82.7,
    "lat": 38.466
  }, {
    "lng": -82.7,
    "lat": 38.466
  }, {
    "lng": -82.6999,
    "lat": 38.4659
  }, {
    "lng": -82.6999,
    "lat": 38.4658
  }, {
    "lng": -82.6997,
    "lat": 38.4657
  }, {
    "lng": -82.6983,
    "lat": 38.4649
  }, {
    "lng": -82.698,
    "lat": 38.4648
  }, {
    "lng": -82.6976,
    "lat": 38.4645
  }, {
    "lng": -82.6975,
    "lat": 38.4644
  }, {
    "lng": -82.6971,
    "lat": 38.4641
  }, {
    "lng": -82.697,
    "lat": 38.4641
  }, {
    "lng": -82.6966,
    "lat": 38.464
  }, {
    "lng": -82.6964,
    "lat": 38.4639
  }, {
    "lng": -82.6962,
    "lat": 38.4639
  }, {
    "lng": -82.696,
    "lat": 38.464
  }, {
    "lng": -82.6957,
    "lat": 38.464
  }, {
    "lng": -82.6954,
    "lat": 38.464
  }, {
    "lng": -82.6953,
    "lat": 38.464
  }, {
    "lng": -82.6952,
    "lat": 38.464
  }, {
    "lng": -82.6952,
    "lat": 38.4638
  }, {
    "lng": -82.6952,
    "lat": 38.4638
  }, {
    "lng": -82.6952,
    "lat": 38.4637
  }, {
    "lng": -82.6952,
    "lat": 38.4636
  }, {
    "lng": -82.6952,
    "lat": 38.4634
  }, {
    "lng": -82.6952,
    "lat": 38.4631
  }, {
    "lng": -82.6952,
    "lat": 38.463
  }, {
    "lng": -82.6952,
    "lat": 38.4629
  }, {
    "lng": -82.6952,
    "lat": 38.4628
  }, {
    "lng": -82.6952,
    "lat": 38.4626
  }, {
    "lng": -82.6953,
    "lat": 38.4625
  }, {
    "lng": -82.6953,
    "lat": 38.4624
  }, {
    "lng": -82.6953,
    "lat": 38.4622
  }, {
    "lng": -82.6953,
    "lat": 38.4619
  }, {
    "lng": -82.6953,
    "lat": 38.4618
  }, {
    "lng": -82.6953,
    "lat": 38.4615
  }, {
    "lng": -82.6954,
    "lat": 38.4614
  }, {
    "lng": -82.6957,
    "lat": 38.4612
  }, {
    "lng": -82.6959,
    "lat": 38.461
  }, {
    "lng": -82.696,
    "lat": 38.461
  }, {
    "lng": -82.6962,
    "lat": 38.4608
  }, {
    "lng": -82.6964,
    "lat": 38.4608
  }, {
    "lng": -82.6966,
    "lat": 38.4607
  }, {
    "lng": -82.6966,
    "lat": 38.4607
  }, {
    "lng": -82.6966,
    "lat": 38.4607
  }, {
    "lng": -82.6971,
    "lat": 38.4606
  }, {
    "lng": -82.6972,
    "lat": 38.4605
  }, {
    "lng": -82.6973,
    "lat": 38.4605
  }, {
    "lng": -82.6974,
    "lat": 38.4605
  }, {
    "lng": -82.6975,
    "lat": 38.4605
  }, {
    "lng": -82.6985,
    "lat": 38.4604
  }, {
    "lng": -82.6988,
    "lat": 38.4604
  }, {
    "lng": -82.6989,
    "lat": 38.4604
  }, {
    "lng": -82.6989,
    "lat": 38.4603
  }, {
    "lng": -82.6991,
    "lat": 38.4603
  }, {
    "lng": -82.6992,
    "lat": 38.4603
  }, {
    "lng": -82.6993,
    "lat": 38.4605
  }, {
    "lng": -82.6993,
    "lat": 38.4606
  }, {
    "lng": -82.6997,
    "lat": 38.461
  }, {
    "lng": -82.6998,
    "lat": 38.4611
  }, {
    "lng": -82.7002,
    "lat": 38.4616
  }, {
    "lng": -82.7006,
    "lat": 38.4619
  }, {
    "lng": -82.7007,
    "lat": 38.462
  }, {
    "lng": -82.701,
    "lat": 38.4623
  }, {
    "lng": -82.7011,
    "lat": 38.4624
  }, {
    "lng": -82.7012,
    "lat": 38.4624
  }, {
    "lng": -82.7013,
    "lat": 38.4625
  }, {
    "lng": -82.7013,
    "lat": 38.4625
  }, {
    "lng": -82.7014,
    "lat": 38.4626
  }, {
    "lng": -82.7017,
    "lat": 38.4626
  }, {
    "lng": -82.7018,
    "lat": 38.4627
  }, {
    "lng": -82.7022,
    "lat": 38.4627
  }, {
    "lng": -82.7023,
    "lat": 38.4627
  }, {
    "lng": -82.7026,
    "lat": 38.4626
  }, {
    "lng": -82.7031,
    "lat": 38.4624
  }, {
    "lng": -82.7034,
    "lat": 38.4627
  }, {
    "lng": -82.7036,
    "lat": 38.4629
  }, {
    "lng": -82.7038,
    "lat": 38.463
  }, {
    "lng": -82.7038,
    "lat": 38.463
  }, {
    "lng": -82.7039,
    "lat": 38.4631
  }, {
    "lng": -82.704,
    "lat": 38.4631
  }, {
    "lng": -82.7041,
    "lat": 38.4631
  }, {
    "lng": -82.7041,
    "lat": 38.4631
  }, {
    "lng": -82.7042,
    "lat": 38.4631
  }, {
    "lng": -82.7042,
    "lat": 38.4631
  }, {
    "lng": -82.7045,
    "lat": 38.463
  }, {
    "lng": -82.7054,
    "lat": 38.4626
  }, {
    "lng": -82.7054,
    "lat": 38.4626
  }, {
    "lng": -82.7057,
    "lat": 38.4625
  }, {
    "lng": -82.7062,
    "lat": 38.4623
  }, {
    "lng": -82.7064,
    "lat": 38.4623
  }, {
    "lng": -82.7066,
    "lat": 38.4622
  }, {
    "lng": -82.7068,
    "lat": 38.4622
  }, {
    "lng": -82.707,
    "lat": 38.4622
  }, {
    "lng": -82.7072,
    "lat": 38.4622
  }, {
    "lng": -82.7076,
    "lat": 38.4622
  }, {
    "lng": -82.7077,
    "lat": 38.4622
  }, {
    "lng": -82.7078,
    "lat": 38.4622
  }, {
    "lng": -82.7079,
    "lat": 38.4621
  }, {
    "lng": -82.7079,
    "lat": 38.462
  }, {
    "lng": -82.7078,
    "lat": 38.4619
  }, {
    "lng": -82.7077,
    "lat": 38.4617
  }, {
    "lng": -82.7076,
    "lat": 38.4616
  }, {
    "lng": -82.7075,
    "lat": 38.4615
  }, {
    "lng": -82.7075,
    "lat": 38.4614
  }, {
    "lng": -82.7074,
    "lat": 38.4613
  }, {
    "lng": -82.7076,
    "lat": 38.4613
  }, {
    "lng": -82.7076,
    "lat": 38.4608
  }, {
    "lng": -82.7076,
    "lat": 38.4605
  }, {
    "lng": -82.7076,
    "lat": 38.4604
  }, {
    "lng": -82.7072,
    "lat": 38.4595
  }, {
    "lng": -82.7072,
    "lat": 38.4593
  }, {
    "lng": -82.7073,
    "lat": 38.4586
  }, {
    "lng": -82.7071,
    "lat": 38.4582
  }, {
    "lng": -82.7069,
    "lat": 38.4578
  }, {
    "lng": -82.7069,
    "lat": 38.4578
  }, {
    "lng": -82.7066,
    "lat": 38.4573
  }, {
    "lng": -82.7066,
    "lat": 38.4568
  }, {
    "lng": -82.7068,
    "lat": 38.4563
  }, {
    "lng": -82.706,
    "lat": 38.4563
  }, {
    "lng": -82.7054,
    "lat": 38.4564
  }, {
    "lng": -82.7051,
    "lat": 38.4564
  }, {
    "lng": -82.7047,
    "lat": 38.4564
  }, {
    "lng": -82.7044,
    "lat": 38.4563
  }, {
    "lng": -82.7034,
    "lat": 38.4562
  }, {
    "lng": -82.7002,
    "lat": 38.4558
  }, {
    "lng": -82.6997,
    "lat": 38.4558
  }, {
    "lng": -82.6991,
    "lat": 38.4557
  }, {
    "lng": -82.6987,
    "lat": 38.4557
  }, {
    "lng": -82.6984,
    "lat": 38.4556
  }, {
    "lng": -82.698,
    "lat": 38.4556
  }, {
    "lng": -82.6976,
    "lat": 38.4555
  }, {
    "lng": -82.6974,
    "lat": 38.4555
  }, {
    "lng": -82.6972,
    "lat": 38.4555
  }, {
    "lng": -82.6972,
    "lat": 38.4555
  }, {
    "lng": -82.6968,
    "lat": 38.4554
  }, {
    "lng": -82.6963,
    "lat": 38.4553
  }, {
    "lng": -82.6954,
    "lat": 38.4552
  }, {
    "lng": -82.6943,
    "lat": 38.4549
  }, {
    "lng": -82.6939,
    "lat": 38.4547
  }, {
    "lng": -82.6934,
    "lat": 38.4545
  }, {
    "lng": -82.693,
    "lat": 38.4542
  }, {
    "lng": -82.693,
    "lat": 38.4542
  }, {
    "lng": -82.6925,
    "lat": 38.4539
  }, {
    "lng": -82.6921,
    "lat": 38.4535
  }, {
    "lng": -82.692,
    "lat": 38.4534
  }, {
    "lng": -82.692,
    "lat": 38.4533
  }, {
    "lng": -82.6903,
    "lat": 38.4512
  }, {
    "lng": -82.6901,
    "lat": 38.4511
  }, {
    "lng": -82.69,
    "lat": 38.4509
  }, {
    "lng": -82.6898,
    "lat": 38.4508
  }, {
    "lng": -82.6897,
    "lat": 38.4506
  }, {
    "lng": -82.6896,
    "lat": 38.4506
  }, {
    "lng": -82.6895,
    "lat": 38.4506
  }, {
    "lng": -82.6893,
    "lat": 38.4504
  }, {
    "lng": -82.6891,
    "lat": 38.4504
  }, {
    "lng": -82.689,
    "lat": 38.4503
  }, {
    "lng": -82.6889,
    "lat": 38.4503
  }, {
    "lng": -82.6885,
    "lat": 38.4504
  }, {
    "lng": -82.6885,
    "lat": 38.4504
  }, {
    "lng": -82.6883,
    "lat": 38.4505
  }, {
    "lng": -82.6881,
    "lat": 38.4506
  }, {
    "lng": -82.6881,
    "lat": 38.4506
  }, {
    "lng": -82.688,
    "lat": 38.4507
  }, {
    "lng": -82.6877,
    "lat": 38.4509
  }, {
    "lng": -82.6876,
    "lat": 38.4512
  }, {
    "lng": -82.6873,
    "lat": 38.4517
  }, {
    "lng": -82.6869,
    "lat": 38.4522
  }, {
    "lng": -82.6865,
    "lat": 38.4526
  }, {
    "lng": -82.6861,
    "lat": 38.453
  }, {
    "lng": -82.6856,
    "lat": 38.4534
  }, {
    "lng": -82.6851,
    "lat": 38.4536
  }, {
    "lng": -82.6844,
    "lat": 38.4539
  }, {
    "lng": -82.6839,
    "lat": 38.454
  }, {
    "lng": -82.6835,
    "lat": 38.4542
  }, {
    "lng": -82.6831,
    "lat": 38.4543
  }, {
    "lng": -82.682,
    "lat": 38.4545
  }, {
    "lng": -82.6813,
    "lat": 38.4547
  }, {
    "lng": -82.6808,
    "lat": 38.4549
  }, {
    "lng": -82.6805,
    "lat": 38.455
  }, {
    "lng": -82.68,
    "lat": 38.4552
  }, {
    "lng": -82.6784,
    "lat": 38.4562
  }, {
    "lng": -82.6782,
    "lat": 38.4564
  }, {
    "lng": -82.6779,
    "lat": 38.4566
  }, {
    "lng": -82.6777,
    "lat": 38.4567
  }, {
    "lng": -82.6777,
    "lat": 38.4567
  }, {
    "lng": -82.6776,
    "lat": 38.4569
  }, {
    "lng": -82.6773,
    "lat": 38.4572
  }, {
    "lng": -82.6772,
    "lat": 38.4574
  }, {
    "lng": -82.6771,
    "lat": 38.4576
  }, {
    "lng": -82.6768,
    "lat": 38.458
  }, {
    "lng": -82.6767,
    "lat": 38.4585
  }, {
    "lng": -82.6765,
    "lat": 38.4589
  }, {
    "lng": -82.6764,
    "lat": 38.4591
  }, {
    "lng": -82.6762,
    "lat": 38.4596
  }, {
    "lng": -82.6759,
    "lat": 38.46
  }, {
    "lng": -82.6757,
    "lat": 38.4603
  }, {
    "lng": -82.6755,
    "lat": 38.4605
  }, {
    "lng": -82.6752,
    "lat": 38.4609
  }, {
    "lng": -82.6748,
    "lat": 38.4612
  }, {
    "lng": -82.6739,
    "lat": 38.4619
  }, {
    "lng": -82.6735,
    "lat": 38.4622
  }, {
    "lng": -82.6733,
    "lat": 38.4624
  }, {
    "lng": -82.6731,
    "lat": 38.4626
  }, {
    "lng": -82.6729,
    "lat": 38.4628
  }, {
    "lng": -82.6727,
    "lat": 38.463
  }, {
    "lng": -82.6726,
    "lat": 38.4633
  }, {
    "lng": -82.6726,
    "lat": 38.4633
  }, {
    "lng": -82.6725,
    "lat": 38.4634
  }, {
    "lng": -82.6724,
    "lat": 38.4635
  }, {
    "lng": -82.6724,
    "lat": 38.4636
  }, {
    "lng": -82.6724,
    "lat": 38.4637
  }, {
    "lng": -82.6723,
    "lat": 38.4638
  }, {
    "lng": -82.6723,
    "lat": 38.4638
  }, {
    "lng": -82.6722,
    "lat": 38.464
  }, {
    "lng": -82.6721,
    "lat": 38.4644
  }, {
    "lng": -82.6721,
    "lat": 38.4644
  }, {
    "lng": -82.6721,
    "lat": 38.4645
  }, {
    "lng": -82.6721,
    "lat": 38.4649
  }, {
    "lng": -82.6721,
    "lat": 38.4656
  }]]],
  "options": {
    "fillColor": "#f50d0d",
    "fillOpacity": 0.4,
    "strokeColor": "#BA0808",
    "strokeWeight": 1,
    "strokeOpacity": 0.4,
    "clickable": true,
    "visible": true,
    "zIndex": 1000
  }
};
var carrierRoute10 = {
  carrierRoute: '41102R004',
  paths: [[[{
    lng: -82.6737,
    lat: 38.453
  }, {
    lng: -82.6737,
    lat: 38.4531
  }, {
    lng: -82.6738,
    lat: 38.4532
  }, {
    lng: -82.674,
    lat: 38.4534
  }, {
    lng: -82.6741,
    lat: 38.4536
  }, {
    lng: -82.6743,
    lat: 38.4537
  }, {
    lng: -82.6744,
    lat: 38.4538
  }, {
    lng: -82.6745,
    lat: 38.4539
  }, {
    lng: -82.6746,
    lat: 38.4539
  }, {
    lng: -82.6748,
    lat: 38.4541
  }, {
    lng: -82.6749,
    lat: 38.4542
  }, {
    lng: -82.675,
    lat: 38.4542
  }, {
    lng: -82.6754,
    lat: 38.4544
  }, {
    lng: -82.6756,
    lat: 38.4545
  }, {
    lng: -82.6758,
    lat: 38.4547
  }, {
    lng: -82.6762,
    lat: 38.455
  }, {
    lng: -82.6764,
    lat: 38.4552
  }, {
    lng: -82.6764,
    lat: 38.4552
  }, {
    lng: -82.6765,
    lat: 38.4553
  }, {
    lng: -82.6765,
    lat: 38.4553
  }, {
    lng: -82.6765,
    lat: 38.4554
  }, {
    lng: -82.6766,
    lat: 38.4555
  }, {
    lng: -82.6766,
    lat: 38.4556
  }, {
    lng: -82.6766,
    lat: 38.4557
  }, {
    lng: -82.6766,
    lat: 38.4558
  }, {
    lng: -82.6766,
    lat: 38.4559
  }, {
    lng: -82.6766,
    lat: 38.456
  }, {
    lng: -82.6766,
    lat: 38.4562
  }, {
    lng: -82.6766,
    lat: 38.4566
  }, {
    lng: -82.6766,
    lat: 38.4571
  }, {
    lng: -82.6765,
    lat: 38.4574
  }, {
    lng: -82.6766,
    lat: 38.4577
  }, {
    lng: -82.6766,
    lat: 38.4576
  }, {
    lng: -82.6767,
    lat: 38.4575
  }, {
    lng: -82.6768,
    lat: 38.4574
  }, {
    lng: -82.6769,
    lat: 38.4572
  }, {
    lng: -82.677,
    lat: 38.4571
  }, {
    lng: -82.6771,
    lat: 38.4569
  }, {
    lng: -82.6771,
    lat: 38.4568
  }, {
    lng: -82.677,
    lat: 38.4565
  }, {
    lng: -82.6769,
    lat: 38.4564
  }, {
    lng: -82.677,
    lat: 38.4561
  }, {
    lng: -82.6773,
    lat: 38.4559
  }, {
    lng: -82.6776,
    lat: 38.4558
  }, {
    lng: -82.6778,
    lat: 38.4557
  }, {
    lng: -82.6778,
    lat: 38.4556
  }, {
    lng: -82.6778,
    lat: 38.4556
  }, {
    lng: -82.6779,
    lat: 38.4555
  }, {
    lng: -82.6784,
    lat: 38.4555
  }, {
    lng: -82.6787,
    lat: 38.4554
  }, {
    lng: -82.679,
    lat: 38.4552
  }, {
    lng: -82.6792,
    lat: 38.455
  }, {
    lng: -82.6793,
    lat: 38.4549
  }, {
    lng: -82.6795,
    lat: 38.4542
  }, {
    lng: -82.6799,
    lat: 38.4528
  }, {
    lng: -82.6805,
    lat: 38.4502
  }, {
    lng: -82.6811,
    lat: 38.4507
  }, {
    lng: -82.682,
    lat: 38.4441
  }, {
    lng: -82.6831,
    lat: 38.4443
  }, {
    lng: -82.6838,
    lat: 38.4445
  }, {
    lng: -82.684,
    lat: 38.4446
  }, {
    lng: -82.6845,
    lat: 38.4448
  }, {
    lng: -82.6849,
    lat: 38.445
  }, {
    lng: -82.6855,
    lat: 38.4453
  }, {
    lng: -82.6859,
    lat: 38.4455
  }, {
    lng: -82.6861,
    lat: 38.4453
  }, {
    lng: -82.6865,
    lat: 38.4454
  }, {
    lng: -82.6869,
    lat: 38.4457
  }, {
    lng: -82.6875,
    lat: 38.446
  }, {
    lng: -82.6877,
    lat: 38.4462
  }, {
    lng: -82.688,
    lat: 38.4465
  }, {
    lng: -82.6886,
    lat: 38.4472
  }, {
    lng: -82.6887,
    lat: 38.4471
  }, {
    lng: -82.6891,
    lat: 38.4468
  }, {
    lng: -82.6891,
    lat: 38.4468
  }, {
    lng: -82.689,
    lat: 38.4468
  }, {
    lng: -82.689,
    lat: 38.4468
  }, {
    lng: -82.6887,
    lat: 38.4467
  }, {
    lng: -82.6885,
    lat: 38.4466
  }, {
    lng: -82.6885,
    lat: 38.4466
  }, {
    lng: -82.6884,
    lat: 38.4465
  }, {
    lng: -82.6884,
    lat: 38.4464
  }, {
    lng: -82.6883,
    lat: 38.4464
  }, {
    lng: -82.6882,
    lat: 38.4463
  }, {
    lng: -82.6881,
    lat: 38.4462
  }, {
    lng: -82.6881,
    lat: 38.4461
  }, {
    lng: -82.6881,
    lat: 38.4461
  }, {
    lng: -82.6881,
    lat: 38.446
  }, {
    lng: -82.6881,
    lat: 38.446
  }, {
    lng: -82.6882,
    lat: 38.4459
  }, {
    lng: -82.6884,
    lat: 38.4458
  }, {
    lng: -82.6887,
    lat: 38.4456
  }, {
    lng: -82.6895,
    lat: 38.4451
  }, {
    lng: -82.6896,
    lat: 38.4451
  }, {
    lng: -82.6896,
    lat: 38.4451
  }, {
    lng: -82.6897,
    lat: 38.4451
  }, {
    lng: -82.6897,
    lat: 38.4451
  }, {
    lng: -82.69,
    lat: 38.4454
  }, {
    lng: -82.6901,
    lat: 38.4455
  }, {
    lng: -82.6902,
    lat: 38.4455
  }, {
    lng: -82.6902,
    lat: 38.4455
  }, {
    lng: -82.6902,
    lat: 38.4456
  }, {
    lng: -82.6902,
    lat: 38.4458
  }, {
    lng: -82.6902,
    lat: 38.4459
  }, {
    lng: -82.6903,
    lat: 38.446
  }, {
    lng: -82.6903,
    lat: 38.446
  }, {
    lng: -82.6903,
    lat: 38.4461
  }, {
    lng: -82.6903,
    lat: 38.4461
  }, {
    lng: -82.6906,
    lat: 38.446
  }, {
    lng: -82.691,
    lat: 38.4458
  }, {
    lng: -82.6919,
    lat: 38.4457
  }, {
    lng: -82.6928,
    lat: 38.4456
  }, {
    lng: -82.6938,
    lat: 38.4456
  }, {
    lng: -82.694,
    lat: 38.4456
  }, {
    lng: -82.6944,
    lat: 38.4457
  }, {
    lng: -82.6952,
    lat: 38.4458
  }, {
    lng: -82.6964,
    lat: 38.4459
  }, {
    lng: -82.6972,
    lat: 38.4459
  }, {
    lng: -82.6973,
    lat: 38.4459
  }, {
    lng: -82.6975,
    lat: 38.4459
  }, {
    lng: -82.698,
    lat: 38.4458
  }, {
    lng: -82.6987,
    lat: 38.4458
  }, {
    lng: -82.699,
    lat: 38.4457
  }, {
    lng: -82.6998,
    lat: 38.4456
  }, {
    lng: -82.7003,
    lat: 38.4455
  }, {
    lng: -82.701,
    lat: 38.4453
  }, {
    lng: -82.7014,
    lat: 38.4451
  }, {
    lng: -82.7023,
    lat: 38.4448
  }, {
    lng: -82.7028,
    lat: 38.4446
  }, {
    lng: -82.7037,
    lat: 38.444
  }, {
    lng: -82.7038,
    lat: 38.4441
  }, {
    lng: -82.7044,
    lat: 38.4445
  }, {
    lng: -82.7047,
    lat: 38.4448
  }, {
    lng: -82.7049,
    lat: 38.4449
  }, {
    lng: -82.7052,
    lat: 38.445
  }, {
    lng: -82.7058,
    lat: 38.4453
  }, {
    lng: -82.7061,
    lat: 38.4454
  }, {
    lng: -82.7066,
    lat: 38.4456
  }, {
    lng: -82.707,
    lat: 38.4458
  }, {
    lng: -82.7071,
    lat: 38.4458
  }, {
    lng: -82.7074,
    lat: 38.446
  }, {
    lng: -82.7075,
    lat: 38.4461
  }, {
    lng: -82.7078,
    lat: 38.4463
  }, {
    lng: -82.708,
    lat: 38.4464
  }, {
    lng: -82.7082,
    lat: 38.4466
  }, {
    lng: -82.7083,
    lat: 38.4466
  }, {
    lng: -82.7083,
    lat: 38.4467
  }, {
    lng: -82.7084,
    lat: 38.4468
  }, {
    lng: -82.7084,
    lat: 38.4468
  }, {
    lng: -82.7085,
    lat: 38.4468
  }, {
    lng: -82.7086,
    lat: 38.4469
  }, {
    lng: -82.7086,
    lat: 38.4469
  }, {
    lng: -82.7087,
    lat: 38.4469
  }, {
    lng: -82.7088,
    lat: 38.4469
  }, {
    lng: -82.7097,
    lat: 38.4466
  }, {
    lng: -82.7103,
    lat: 38.4465
  }, {
    lng: -82.7114,
    lat: 38.4466
  }, {
    lng: -82.7122,
    lat: 38.4468
  }, {
    lng: -82.7137,
    lat: 38.4472
  }, {
    lng: -82.7135,
    lat: 38.4475
  }, {
    lng: -82.7137,
    lat: 38.4475
  }, {
    lng: -82.714,
    lat: 38.4476
  }, {
    lng: -82.7142,
    lat: 38.4476
  }, {
    lng: -82.7146,
    lat: 38.4476
  }, {
    lng: -82.7159,
    lat: 38.4477
  }, {
    lng: -82.7166,
    lat: 38.4477
  }, {
    lng: -82.7168,
    lat: 38.4477
  }, {
    lng: -82.7174,
    lat: 38.4477
  }, {
    lng: -82.7175,
    lat: 38.4478
  }, {
    lng: -82.72,
    lat: 38.4412
  }, {
    lng: -82.7203,
    lat: 38.438
  }, {
    lng: -82.7204,
    lat: 38.4376
  }, {
    lng: -82.7209,
    lat: 38.4342
  }, {
    lng: -82.7208,
    lat: 38.4342
  }, {
    lng: -82.7189,
    lat: 38.4348
  }, {
    lng: -82.7189,
    lat: 38.4348
  }, {
    lng: -82.7187,
    lat: 38.4348
  }, {
    lng: -82.7186,
    lat: 38.4348
  }, {
    lng: -82.7185,
    lat: 38.4347
  }, {
    lng: -82.7184,
    lat: 38.4347
  }, {
    lng: -82.7183,
    lat: 38.4347
  }, {
    lng: -82.7182,
    lat: 38.4347
  }, {
    lng: -82.7181,
    lat: 38.4347
  }, {
    lng: -82.7174,
    lat: 38.4348
  }, {
    lng: -82.7173,
    lat: 38.4348
  }, {
    lng: -82.7173,
    lat: 38.4348
  }, {
    lng: -82.717,
    lat: 38.4342
  }, {
    lng: -82.7169,
    lat: 38.4342
  }, {
    lng: -82.7167,
    lat: 38.4341
  }, {
    lng: -82.7165,
    lat: 38.4339
  }, {
    lng: -82.7163,
    lat: 38.4339
  }, {
    lng: -82.7162,
    lat: 38.4338
  }, {
    lng: -82.7158,
    lat: 38.4337
  }, {
    lng: -82.7153,
    lat: 38.4337
  }, {
    lng: -82.7144,
    lat: 38.4337
  }, {
    lng: -82.714,
    lat: 38.4337
  }, {
    lng: -82.7136,
    lat: 38.4336
  }, {
    lng: -82.7135,
    lat: 38.4336
  }, {
    lng: -82.7133,
    lat: 38.4335
  }, {
    lng: -82.7132,
    lat: 38.4335
  }, {
    lng: -82.713,
    lat: 38.4334
  }, {
    lng: -82.7128,
    lat: 38.4333
  }, {
    lng: -82.7127,
    lat: 38.4333
  }, {
    lng: -82.7118,
    lat: 38.4326
  }, {
    lng: -82.7117,
    lat: 38.4326
  }, {
    lng: -82.7115,
    lat: 38.4325
  }, {
    lng: -82.7113,
    lat: 38.4324
  }, {
    lng: -82.7111,
    lat: 38.4323
  }, {
    lng: -82.7109,
    lat: 38.4323
  }, {
    lng: -82.7107,
    lat: 38.4322
  }, {
    lng: -82.7104,
    lat: 38.4322
  }, {
    lng: -82.7104,
    lat: 38.4322
  }, {
    lng: -82.7102,
    lat: 38.4321
  }, {
    lng: -82.7101,
    lat: 38.4321
  }, {
    lng: -82.7099,
    lat: 38.4321
  }, {
    lng: -82.7099,
    lat: 38.4322
  }, {
    lng: -82.7097,
    lat: 38.4322
  }, {
    lng: -82.7095,
    lat: 38.4323
  }, {
    lng: -82.7092,
    lat: 38.4323
  }, {
    lng: -82.7089,
    lat: 38.4324
  }, {
    lng: -82.7083,
    lat: 38.4323
  }, {
    lng: -82.7082,
    lat: 38.4323
  }, {
    lng: -82.7075,
    lat: 38.4321
  }, {
    lng: -82.7074,
    lat: 38.432
  }, {
    lng: -82.7075,
    lat: 38.4315
  }, {
    lng: -82.7076,
    lat: 38.4313
  }, {
    lng: -82.7078,
    lat: 38.4305
  }, {
    lng: -82.7081,
    lat: 38.4298
  }, {
    lng: -82.7081,
    lat: 38.4296
  }, {
    lng: -82.7082,
    lat: 38.4293
  }, {
    lng: -82.7083,
    lat: 38.4289
  }, {
    lng: -82.7084,
    lat: 38.4286
  }, {
    lng: -82.7085,
    lat: 38.4283
  }, {
    lng: -82.7086,
    lat: 38.428
  }, {
    lng: -82.7089,
    lat: 38.4272
  }, {
    lng: -82.709,
    lat: 38.427
  }, {
    lng: -82.7091,
    lat: 38.4265
  }, {
    lng: -82.7092,
    lat: 38.4262
  }, {
    lng: -82.7092,
    lat: 38.4262
  }, {
    lng: -82.7093,
    lat: 38.4261
  }, {
    lng: -82.7093,
    lat: 38.4259
  }, {
    lng: -82.7093,
    lat: 38.4257
  }, {
    lng: -82.7092,
    lat: 38.4254
  }, {
    lng: -82.7092,
    lat: 38.425
  }, {
    lng: -82.7092,
    lat: 38.4249
  }, {
    lng: -82.7091,
    lat: 38.4246
  }, {
    lng: -82.7088,
    lat: 38.4244
  }, {
    lng: -82.7081,
    lat: 38.4239
  }, {
    lng: -82.7065,
    lat: 38.4226
  }, {
    lng: -82.7058,
    lat: 38.4214
  }, {
    lng: -82.7054,
    lat: 38.4203
  }, {
    lng: -82.7053,
    lat: 38.419
  }, {
    lng: -82.7054,
    lat: 38.4185
  }, {
    lng: -82.7052,
    lat: 38.4186
  }, {
    lng: -82.705,
    lat: 38.4186
  }, {
    lng: -82.7048,
    lat: 38.4185
  }, {
    lng: -82.7046,
    lat: 38.4185
  }, {
    lng: -82.7039,
    lat: 38.4195
  }, {
    lng: -82.7037,
    lat: 38.4197
  }, {
    lng: -82.7034,
    lat: 38.4201
  }, {
    lng: -82.7032,
    lat: 38.4204
  }, {
    lng: -82.7021,
    lat: 38.4218
  }, {
    lng: -82.702,
    lat: 38.422
  }, {
    lng: -82.7017,
    lat: 38.4224
  }, {
    lng: -82.7006,
    lat: 38.4238
  }, {
    lng: -82.7005,
    lat: 38.4239
  }, {
    lng: -82.6993,
    lat: 38.4254
  }, {
    lng: -82.6989,
    lat: 38.4259
  }, {
    lng: -82.6965,
    lat: 38.4289
  }, {
    lng: -82.6945,
    lat: 38.4314
  }, {
    lng: -82.694,
    lat: 38.4321
  }, {
    lng: -82.694,
    lat: 38.4321
  }, {
    lng: -82.6939,
    lat: 38.4322
  }, {
    lng: -82.6934,
    lat: 38.4328
  }, {
    lng: -82.6929,
    lat: 38.4335
  }, {
    lng: -82.6928,
    lat: 38.4337
  }, {
    lng: -82.6925,
    lat: 38.434
  }, {
    lng: -82.6917,
    lat: 38.435
  }, {
    lng: -82.6913,
    lat: 38.4355
  }, {
    lng: -82.6911,
    lat: 38.4358
  }, {
    lng: -82.691,
    lat: 38.4357
  }, {
    lng: -82.6909,
    lat: 38.4357
  }, {
    lng: -82.6909,
    lat: 38.4357
  }, {
    lng: -82.6904,
    lat: 38.4362
  }, {
    lng: -82.6903,
    lat: 38.4364
  }, {
    lng: -82.6901,
    lat: 38.4365
  }, {
    lng: -82.6903,
    lat: 38.4365
  }, {
    lng: -82.6904,
    lat: 38.4366
  }, {
    lng: -82.6903,
    lat: 38.4366
  }, {
    lng: -82.6899,
    lat: 38.4369
  }, {
    lng: -82.6896,
    lat: 38.437
  }, {
    lng: -82.6893,
    lat: 38.4371
  }, {
    lng: -82.6888,
    lat: 38.4373
  }, {
    lng: -82.687,
    lat: 38.4376
  }, {
    lng: -82.6854,
    lat: 38.438
  }, {
    lng: -82.684,
    lat: 38.4383
  }, {
    lng: -82.6833,
    lat: 38.4384
  }, {
    lng: -82.6829,
    lat: 38.4386
  }, {
    lng: -82.6824,
    lat: 38.4388
  }, {
    lng: -82.6822,
    lat: 38.4389
  }, {
    lng: -82.6819,
    lat: 38.4391
  }, {
    lng: -82.6818,
    lat: 38.4392
  }, {
    lng: -82.6815,
    lat: 38.4394
  }, {
    lng: -82.6814,
    lat: 38.4396
  }, {
    lng: -82.6813,
    lat: 38.4397
  }, {
    lng: -82.6809,
    lat: 38.4403
  }, {
    lng: -82.6808,
    lat: 38.4403
  }, {
    lng: -82.6807,
    lat: 38.4406
  }, {
    lng: -82.6806,
    lat: 38.4405
  }, {
    lng: -82.6805,
    lat: 38.4407
  }, {
    lng: -82.6805,
    lat: 38.4412
  }, {
    lng: -82.6805,
    lat: 38.4415
  }, {
    lng: -82.6805,
    lat: 38.4418
  }, {
    lng: -82.6805,
    lat: 38.442
  }, {
    lng: -82.6808,
    lat: 38.4434
  }, {
    lng: -82.6808,
    lat: 38.4435
  }, {
    lng: -82.6808,
    lat: 38.444
  }, {
    lng: -82.6806,
    lat: 38.4439
  }, {
    lng: -82.6806,
    lat: 38.4439
  }, {
    lng: -82.6806,
    lat: 38.4443
  }, {
    lng: -82.6804,
    lat: 38.445
  }, {
    lng: -82.6802,
    lat: 38.4455
  }, {
    lng: -82.68,
    lat: 38.4465
  }, {
    lng: -82.6799,
    lat: 38.4467
  }, {
    lng: -82.6799,
    lat: 38.4469
  }, {
    lng: -82.6797,
    lat: 38.4472
  }, {
    lng: -82.6796,
    lat: 38.4473
  }, {
    lng: -82.6795,
    lat: 38.4475
  }, {
    lng: -82.6794,
    lat: 38.4476
  }, {
    lng: -82.6793,
    lat: 38.4478
  }, {
    lng: -82.6791,
    lat: 38.4479
  }, {
    lng: -82.679,
    lat: 38.448
  }, {
    lng: -82.6788,
    lat: 38.4481
  }, {
    lng: -82.6786,
    lat: 38.4483
  }, {
    lng: -82.6779,
    lat: 38.4486
  }, {
    lng: -82.6778,
    lat: 38.4487
  }, {
    lng: -82.6774,
    lat: 38.4489
  }, {
    lng: -82.6771,
    lat: 38.4491
  }, {
    lng: -82.6769,
    lat: 38.4492
  }, {
    lng: -82.6768,
    lat: 38.4493
  }, {
    lng: -82.6767,
    lat: 38.4494
  }, {
    lng: -82.6764,
    lat: 38.4496
  }, {
    lng: -82.6762,
    lat: 38.4498
  }, {
    lng: -82.676,
    lat: 38.45
  }, {
    lng: -82.6759,
    lat: 38.4501
  }, {
    lng: -82.6758,
    lat: 38.4502
  }, {
    lng: -82.6757,
    lat: 38.4504
  }, {
    lng: -82.6756,
    lat: 38.4505
  }, {
    lng: -82.6754,
    lat: 38.4508
  }, {
    lng: -82.6753,
    lat: 38.4509
  }, {
    lng: -82.6751,
    lat: 38.4511
  }, {
    lng: -82.675,
    lat: 38.4512
  }, {
    lng: -82.675,
    lat: 38.4513
  }, {
    lng: -82.6747,
    lat: 38.4516
  }, {
    lng: -82.6746,
    lat: 38.4518
  }, {
    lng: -82.6746,
    lat: 38.4518
  }, {
    lng: -82.6746,
    lat: 38.4518
  }, {
    lng: -82.6746,
    lat: 38.4519
  }, {
    lng: -82.6747,
    lat: 38.4519
  }, {
    lng: -82.6748,
    lat: 38.4519
  }, {
    lng: -82.6749,
    lat: 38.452
  }, {
    lng: -82.675,
    lat: 38.452
  }, {
    lng: -82.6745,
    lat: 38.4524
  }, {
    lng: -82.6737,
    lat: 38.453
  }]]],
  options: {
    fillColor: '#f50d0d',
    fillOpacity: 0.4,
    strokeColor: '#BA0808',
    strokeWeight: 1,
    strokeOpacity: 0.4,
    clickable: true,
    visible: true,
    zIndex: 1000
  }
};
var carrierRoute11 = {
  "carrierRoute": "41102R003",
  "paths": [[[{
    "lng": -82.6877,
    "lat": 38.4509
  }, {
    "lng": -82.688,
    "lat": 38.4507
  }, {
    "lng": -82.6881,
    "lat": 38.4506
  }, {
    "lng": -82.6881,
    "lat": 38.4506
  }, {
    "lng": -82.6883,
    "lat": 38.4505
  }, {
    "lng": -82.6885,
    "lat": 38.4504
  }, {
    "lng": -82.6885,
    "lat": 38.4504
  }, {
    "lng": -82.6889,
    "lat": 38.4503
  }, {
    "lng": -82.689,
    "lat": 38.4503
  }, {
    "lng": -82.6891,
    "lat": 38.4504
  }, {
    "lng": -82.6893,
    "lat": 38.4504
  }, {
    "lng": -82.6895,
    "lat": 38.4506
  }, {
    "lng": -82.6896,
    "lat": 38.4506
  }, {
    "lng": -82.6897,
    "lat": 38.4506
  }, {
    "lng": -82.6898,
    "lat": 38.4508
  }, {
    "lng": -82.69,
    "lat": 38.4509
  }, {
    "lng": -82.6901,
    "lat": 38.4511
  }, {
    "lng": -82.6903,
    "lat": 38.4512
  }, {
    "lng": -82.692,
    "lat": 38.4533
  }, {
    "lng": -82.692,
    "lat": 38.4534
  }, {
    "lng": -82.6921,
    "lat": 38.4535
  }, {
    "lng": -82.6925,
    "lat": 38.4539
  }, {
    "lng": -82.693,
    "lat": 38.4542
  }, {
    "lng": -82.693,
    "lat": 38.4542
  }, {
    "lng": -82.6934,
    "lat": 38.4545
  }, {
    "lng": -82.6939,
    "lat": 38.4547
  }, {
    "lng": -82.6943,
    "lat": 38.4549
  }, {
    "lng": -82.6954,
    "lat": 38.4552
  }, {
    "lng": -82.6963,
    "lat": 38.4553
  }, {
    "lng": -82.6968,
    "lat": 38.4554
  }, {
    "lng": -82.6972,
    "lat": 38.4555
  }, {
    "lng": -82.6972,
    "lat": 38.4555
  }, {
    "lng": -82.6974,
    "lat": 38.4555
  }, {
    "lng": -82.6976,
    "lat": 38.4555
  }, {
    "lng": -82.698,
    "lat": 38.4556
  }, {
    "lng": -82.6984,
    "lat": 38.4556
  }, {
    "lng": -82.6987,
    "lat": 38.4557
  }, {
    "lng": -82.6991,
    "lat": 38.4557
  }, {
    "lng": -82.6997,
    "lat": 38.4558
  }, {
    "lng": -82.7002,
    "lat": 38.4558
  }, {
    "lng": -82.7034,
    "lat": 38.4562
  }, {
    "lng": -82.7044,
    "lat": 38.4563
  }, {
    "lng": -82.7047,
    "lat": 38.4564
  }, {
    "lng": -82.7051,
    "lat": 38.4564
  }, {
    "lng": -82.7054,
    "lat": 38.4564
  }, {
    "lng": -82.706,
    "lat": 38.4563
  }, {
    "lng": -82.7068,
    "lat": 38.4563
  }, {
    "lng": -82.7066,
    "lat": 38.4568
  }, {
    "lng": -82.7066,
    "lat": 38.4573
  }, {
    "lng": -82.7069,
    "lat": 38.4578
  }, {
    "lng": -82.7069,
    "lat": 38.4578
  }, {
    "lng": -82.7071,
    "lat": 38.4582
  }, {
    "lng": -82.7073,
    "lat": 38.4586
  }, {
    "lng": -82.7072,
    "lat": 38.4593
  }, {
    "lng": -82.7072,
    "lat": 38.4595
  }, {
    "lng": -82.7076,
    "lat": 38.4604
  }, {
    "lng": -82.7076,
    "lat": 38.4605
  }, {
    "lng": -82.7076,
    "lat": 38.4608
  }, {
    "lng": -82.7076,
    "lat": 38.4613
  }, {
    "lng": -82.7074,
    "lat": 38.4613
  }, {
    "lng": -82.7075,
    "lat": 38.4614
  }, {
    "lng": -82.7075,
    "lat": 38.4615
  }, {
    "lng": -82.7076,
    "lat": 38.4616
  }, {
    "lng": -82.7077,
    "lat": 38.4617
  }, {
    "lng": -82.7078,
    "lat": 38.4619
  }, {
    "lng": -82.7079,
    "lat": 38.462
  }, {
    "lng": -82.7079,
    "lat": 38.4621
  }, {
    "lng": -82.7078,
    "lat": 38.4622
  }, {
    "lng": -82.7077,
    "lat": 38.4622
  }, {
    "lng": -82.7076,
    "lat": 38.4622
  }, {
    "lng": -82.7072,
    "lat": 38.4622
  }, {
    "lng": -82.707,
    "lat": 38.4622
  }, {
    "lng": -82.7068,
    "lat": 38.4622
  }, {
    "lng": -82.7066,
    "lat": 38.4622
  }, {
    "lng": -82.7064,
    "lat": 38.4623
  }, {
    "lng": -82.7062,
    "lat": 38.4623
  }, {
    "lng": -82.7057,
    "lat": 38.4625
  }, {
    "lng": -82.7054,
    "lat": 38.4626
  }, {
    "lng": -82.7054,
    "lat": 38.4626
  }, {
    "lng": -82.7045,
    "lat": 38.463
  }, {
    "lng": -82.7042,
    "lat": 38.4631
  }, {
    "lng": -82.7042,
    "lat": 38.4631
  }, {
    "lng": -82.7041,
    "lat": 38.4631
  }, {
    "lng": -82.7041,
    "lat": 38.4631
  }, {
    "lng": -82.704,
    "lat": 38.4631
  }, {
    "lng": -82.7039,
    "lat": 38.4631
  }, {
    "lng": -82.7038,
    "lat": 38.463
  }, {
    "lng": -82.7038,
    "lat": 38.463
  }, {
    "lng": -82.7036,
    "lat": 38.4629
  }, {
    "lng": -82.7034,
    "lat": 38.4627
  }, {
    "lng": -82.7031,
    "lat": 38.4624
  }, {
    "lng": -82.7026,
    "lat": 38.4626
  }, {
    "lng": -82.7023,
    "lat": 38.4627
  }, {
    "lng": -82.7022,
    "lat": 38.4627
  }, {
    "lng": -82.7018,
    "lat": 38.4627
  }, {
    "lng": -82.7017,
    "lat": 38.4626
  }, {
    "lng": -82.7014,
    "lat": 38.4626
  }, {
    "lng": -82.7013,
    "lat": 38.4625
  }, {
    "lng": -82.7013,
    "lat": 38.4625
  }, {
    "lng": -82.7012,
    "lat": 38.4624
  }, {
    "lng": -82.7011,
    "lat": 38.4624
  }, {
    "lng": -82.701,
    "lat": 38.4623
  }, {
    "lng": -82.7007,
    "lat": 38.462
  }, {
    "lng": -82.7006,
    "lat": 38.4619
  }, {
    "lng": -82.7002,
    "lat": 38.4616
  }, {
    "lng": -82.6998,
    "lat": 38.4611
  }, {
    "lng": -82.6997,
    "lat": 38.461
  }, {
    "lng": -82.6993,
    "lat": 38.4606
  }, {
    "lng": -82.6993,
    "lat": 38.4605
  }, {
    "lng": -82.6992,
    "lat": 38.4603
  }, {
    "lng": -82.6991,
    "lat": 38.4603
  }, {
    "lng": -82.6989,
    "lat": 38.4603
  }, {
    "lng": -82.6989,
    "lat": 38.4604
  }, {
    "lng": -82.6988,
    "lat": 38.4604
  }, {
    "lng": -82.6985,
    "lat": 38.4604
  }, {
    "lng": -82.6975,
    "lat": 38.4605
  }, {
    "lng": -82.6974,
    "lat": 38.4605
  }, {
    "lng": -82.6973,
    "lat": 38.4605
  }, {
    "lng": -82.6972,
    "lat": 38.4605
  }, {
    "lng": -82.6971,
    "lat": 38.4606
  }, {
    "lng": -82.6966,
    "lat": 38.4607
  }, {
    "lng": -82.6966,
    "lat": 38.4607
  }, {
    "lng": -82.6966,
    "lat": 38.4607
  }, {
    "lng": -82.6964,
    "lat": 38.4608
  }, {
    "lng": -82.6962,
    "lat": 38.4608
  }, {
    "lng": -82.696,
    "lat": 38.461
  }, {
    "lng": -82.6959,
    "lat": 38.461
  }, {
    "lng": -82.6957,
    "lat": 38.4612
  }, {
    "lng": -82.6954,
    "lat": 38.4614
  }, {
    "lng": -82.6953,
    "lat": 38.4615
  }, {
    "lng": -82.6953,
    "lat": 38.4618
  }, {
    "lng": -82.6953,
    "lat": 38.4619
  }, {
    "lng": -82.6953,
    "lat": 38.4622
  }, {
    "lng": -82.6953,
    "lat": 38.4624
  }, {
    "lng": -82.6953,
    "lat": 38.4625
  }, {
    "lng": -82.6952,
    "lat": 38.4626
  }, {
    "lng": -82.6952,
    "lat": 38.4628
  }, {
    "lng": -82.6952,
    "lat": 38.4629
  }, {
    "lng": -82.6952,
    "lat": 38.463
  }, {
    "lng": -82.6952,
    "lat": 38.4631
  }, {
    "lng": -82.6952,
    "lat": 38.4634
  }, {
    "lng": -82.6952,
    "lat": 38.4636
  }, {
    "lng": -82.6952,
    "lat": 38.4637
  }, {
    "lng": -82.6952,
    "lat": 38.4638
  }, {
    "lng": -82.6952,
    "lat": 38.4638
  }, {
    "lng": -82.6952,
    "lat": 38.464
  }, {
    "lng": -82.6953,
    "lat": 38.464
  }, {
    "lng": -82.6954,
    "lat": 38.464
  }, {
    "lng": -82.6957,
    "lat": 38.464
  }, {
    "lng": -82.696,
    "lat": 38.464
  }, {
    "lng": -82.6962,
    "lat": 38.4639
  }, {
    "lng": -82.6964,
    "lat": 38.4639
  }, {
    "lng": -82.6966,
    "lat": 38.464
  }, {
    "lng": -82.697,
    "lat": 38.4641
  }, {
    "lng": -82.6971,
    "lat": 38.4641
  }, {
    "lng": -82.6975,
    "lat": 38.4644
  }, {
    "lng": -82.6976,
    "lat": 38.4645
  }, {
    "lng": -82.698,
    "lat": 38.4648
  }, {
    "lng": -82.6983,
    "lat": 38.4649
  }, {
    "lng": -82.6997,
    "lat": 38.4657
  }, {
    "lng": -82.6999,
    "lat": 38.4658
  }, {
    "lng": -82.6999,
    "lat": 38.4659
  }, {
    "lng": -82.7,
    "lat": 38.466
  }, {
    "lng": -82.7,
    "lat": 38.466
  }, {
    "lng": -82.7001,
    "lat": 38.4664
  }, {
    "lng": -82.7001,
    "lat": 38.4667
  }, {
    "lng": -82.7,
    "lat": 38.4669
  }, {
    "lng": -82.6999,
    "lat": 38.4671
  }, {
    "lng": -82.6999,
    "lat": 38.4672
  }, {
    "lng": -82.6999,
    "lat": 38.4672
  }, {
    "lng": -82.7011,
    "lat": 38.4682
  }, {
    "lng": -82.7019,
    "lat": 38.4687
  }, {
    "lng": -82.7021,
    "lat": 38.4693
  }, {
    "lng": -82.7022,
    "lat": 38.4695
  }, {
    "lng": -82.7022,
    "lat": 38.4696
  }, {
    "lng": -82.7022,
    "lat": 38.4699
  }, {
    "lng": -82.7021,
    "lat": 38.4704
  }, {
    "lng": -82.7022,
    "lat": 38.4704
  }, {
    "lng": -82.7024,
    "lat": 38.4705
  }, {
    "lng": -82.7027,
    "lat": 38.4706
  }, {
    "lng": -82.703,
    "lat": 38.4708
  }, {
    "lng": -82.7033,
    "lat": 38.4708
  }, {
    "lng": -82.7035,
    "lat": 38.4709
  }, {
    "lng": -82.7038,
    "lat": 38.4709
  }, {
    "lng": -82.704,
    "lat": 38.4708
  }, {
    "lng": -82.7042,
    "lat": 38.4708
  }, {
    "lng": -82.7044,
    "lat": 38.4708
  }, {
    "lng": -82.7045,
    "lat": 38.4707
  }, {
    "lng": -82.7046,
    "lat": 38.4706
  }, {
    "lng": -82.7055,
    "lat": 38.4701
  }, {
    "lng": -82.7056,
    "lat": 38.4701
  }, {
    "lng": -82.7056,
    "lat": 38.47
  }, {
    "lng": -82.7058,
    "lat": 38.4699
  }, {
    "lng": -82.7059,
    "lat": 38.4698
  }, {
    "lng": -82.706,
    "lat": 38.4698
  }, {
    "lng": -82.706,
    "lat": 38.4699
  }, {
    "lng": -82.7059,
    "lat": 38.4702
  }, {
    "lng": -82.7058,
    "lat": 38.4707
  }, {
    "lng": -82.7057,
    "lat": 38.4712
  }, {
    "lng": -82.7057,
    "lat": 38.4713
  }, {
    "lng": -82.7056,
    "lat": 38.4714
  }, {
    "lng": -82.7056,
    "lat": 38.4714
  }, {
    "lng": -82.7056,
    "lat": 38.4715
  }, {
    "lng": -82.7056,
    "lat": 38.4717
  }, {
    "lng": -82.7057,
    "lat": 38.4718
  }, {
    "lng": -82.7057,
    "lat": 38.4719
  }, {
    "lng": -82.7057,
    "lat": 38.472
  }, {
    "lng": -82.7058,
    "lat": 38.4721
  }, {
    "lng": -82.7058,
    "lat": 38.4722
  }, {
    "lng": -82.7059,
    "lat": 38.4724
  }, {
    "lng": -82.7059,
    "lat": 38.4725
  }, {
    "lng": -82.7059,
    "lat": 38.4726
  }, {
    "lng": -82.7058,
    "lat": 38.4728
  }, {
    "lng": -82.7058,
    "lat": 38.4729
  }, {
    "lng": -82.7057,
    "lat": 38.4732
  }, {
    "lng": -82.7056,
    "lat": 38.4733
  }, {
    "lng": -82.7056,
    "lat": 38.4734
  }, {
    "lng": -82.7053,
    "lat": 38.474
  }, {
    "lng": -82.7053,
    "lat": 38.4741
  }, {
    "lng": -82.7045,
    "lat": 38.4754
  }, {
    "lng": -82.7041,
    "lat": 38.4758
  }, {
    "lng": -82.7045,
    "lat": 38.4758
  }, {
    "lng": -82.7047,
    "lat": 38.4758
  }, {
    "lng": -82.7048,
    "lat": 38.4759
  }, {
    "lng": -82.7049,
    "lat": 38.4759
  }, {
    "lng": -82.705,
    "lat": 38.4759
  }, {
    "lng": -82.7051,
    "lat": 38.476
  }, {
    "lng": -82.7053,
    "lat": 38.4761
  }, {
    "lng": -82.7054,
    "lat": 38.4761
  }, {
    "lng": -82.7058,
    "lat": 38.4762
  }, {
    "lng": -82.7063,
    "lat": 38.4764
  }, {
    "lng": -82.7071,
    "lat": 38.4766
  }, {
    "lng": -82.7072,
    "lat": 38.4766
  }, {
    "lng": -82.7148,
    "lat": 38.4712
  }, {
    "lng": -82.7167,
    "lat": 38.4699
  }, {
    "lng": -82.7196,
    "lat": 38.4678
  }, {
    "lng": -82.7199,
    "lat": 38.4682
  }, {
    "lng": -82.7202,
    "lat": 38.4685
  }, {
    "lng": -82.7204,
    "lat": 38.4686
  }, {
    "lng": -82.7208,
    "lat": 38.4686
  }, {
    "lng": -82.7227,
    "lat": 38.4681
  }, {
    "lng": -82.7232,
    "lat": 38.4682
  }, {
    "lng": -82.7249,
    "lat": 38.4694
  }, {
    "lng": -82.7257,
    "lat": 38.4698
  }, {
    "lng": -82.7262,
    "lat": 38.47
  }, {
    "lng": -82.7271,
    "lat": 38.4702
  }, {
    "lng": -82.7282,
    "lat": 38.4704
  }, {
    "lng": -82.7304,
    "lat": 38.4711
  }, {
    "lng": -82.731,
    "lat": 38.4713
  }, {
    "lng": -82.7313,
    "lat": 38.4713
  }, {
    "lng": -82.7317,
    "lat": 38.4715
  }, {
    "lng": -82.7325,
    "lat": 38.4722
  }, {
    "lng": -82.7328,
    "lat": 38.4725
  }, {
    "lng": -82.7332,
    "lat": 38.4727
  }, {
    "lng": -82.7335,
    "lat": 38.4729
  }, {
    "lng": -82.7336,
    "lat": 38.473
  }, {
    "lng": -82.7337,
    "lat": 38.4733
  }, {
    "lng": -82.7339,
    "lat": 38.4735
  }, {
    "lng": -82.7342,
    "lat": 38.4735
  }, {
    "lng": -82.7344,
    "lat": 38.4735
  }, {
    "lng": -82.7348,
    "lat": 38.4736
  }, {
    "lng": -82.7352,
    "lat": 38.4736
  }, {
    "lng": -82.7365,
    "lat": 38.4736
  }, {
    "lng": -82.7373,
    "lat": 38.4735
  }, {
    "lng": -82.7378,
    "lat": 38.4733
  }, {
    "lng": -82.7384,
    "lat": 38.4728
  }, {
    "lng": -82.7389,
    "lat": 38.4723
  }, {
    "lng": -82.7394,
    "lat": 38.4718
  }, {
    "lng": -82.74,
    "lat": 38.4714
  }, {
    "lng": -82.7408,
    "lat": 38.4711
  }, {
    "lng": -82.7413,
    "lat": 38.4709
  }, {
    "lng": -82.7417,
    "lat": 38.471
  }, {
    "lng": -82.7425,
    "lat": 38.4711
  }, {
    "lng": -82.7431,
    "lat": 38.471
  }, {
    "lng": -82.7436,
    "lat": 38.471
  }, {
    "lng": -82.7441,
    "lat": 38.4712
  }, {
    "lng": -82.7445,
    "lat": 38.4712
  }, {
    "lng": -82.7451,
    "lat": 38.4706
  }, {
    "lng": -82.7453,
    "lat": 38.4703
  }, {
    "lng": -82.7453,
    "lat": 38.4699
  }, {
    "lng": -82.7451,
    "lat": 38.4694
  }, {
    "lng": -82.7462,
    "lat": 38.4685
  }, {
    "lng": -82.7468,
    "lat": 38.4682
  }, {
    "lng": -82.7472,
    "lat": 38.468
  }, {
    "lng": -82.7476,
    "lat": 38.4677
  }, {
    "lng": -82.7479,
    "lat": 38.4674
  }, {
    "lng": -82.749,
    "lat": 38.4672
  }, {
    "lng": -82.7493,
    "lat": 38.4667
  }, {
    "lng": -82.7494,
    "lat": 38.4667
  }, {
    "lng": -82.7496,
    "lat": 38.4667
  }, {
    "lng": -82.75,
    "lat": 38.4669
  }, {
    "lng": -82.7503,
    "lat": 38.4672
  }, {
    "lng": -82.751,
    "lat": 38.4674
  }, {
    "lng": -82.7515,
    "lat": 38.4676
  }, {
    "lng": -82.7516,
    "lat": 38.4675
  }, {
    "lng": -82.7516,
    "lat": 38.4674
  }, {
    "lng": -82.7517,
    "lat": 38.4673
  }, {
    "lng": -82.7517,
    "lat": 38.4672
  }, {
    "lng": -82.7517,
    "lat": 38.4671
  }, {
    "lng": -82.7517,
    "lat": 38.467
  }, {
    "lng": -82.7517,
    "lat": 38.4669
  }, {
    "lng": -82.7518,
    "lat": 38.4668
  }, {
    "lng": -82.7519,
    "lat": 38.4667
  }, {
    "lng": -82.7519,
    "lat": 38.4666
  }, {
    "lng": -82.752,
    "lat": 38.4665
  }, {
    "lng": -82.7521,
    "lat": 38.4664
  }, {
    "lng": -82.7523,
    "lat": 38.4663
  }, {
    "lng": -82.7524,
    "lat": 38.4662
  }, {
    "lng": -82.7525,
    "lat": 38.4661
  }, {
    "lng": -82.7527,
    "lat": 38.466
  }, {
    "lng": -82.7529,
    "lat": 38.4659
  }, {
    "lng": -82.7531,
    "lat": 38.4659
  }, {
    "lng": -82.7533,
    "lat": 38.4658
  }, {
    "lng": -82.7535,
    "lat": 38.4658
  }, {
    "lng": -82.7536,
    "lat": 38.4658
  }, {
    "lng": -82.7538,
    "lat": 38.4658
  }, {
    "lng": -82.7539,
    "lat": 38.4658
  }, {
    "lng": -82.7541,
    "lat": 38.4657
  }, {
    "lng": -82.7542,
    "lat": 38.4657
  }, {
    "lng": -82.7543,
    "lat": 38.4656
  }, {
    "lng": -82.7548,
    "lat": 38.4656
  }, {
    "lng": -82.7553,
    "lat": 38.4655
  }, {
    "lng": -82.7557,
    "lat": 38.4654
  }, {
    "lng": -82.7558,
    "lat": 38.4653
  }, {
    "lng": -82.7561,
    "lat": 38.465
  }, {
    "lng": -82.7564,
    "lat": 38.4648
  }, {
    "lng": -82.7569,
    "lat": 38.4646
  }, {
    "lng": -82.7572,
    "lat": 38.4646
  }, {
    "lng": -82.7575,
    "lat": 38.4649
  }, {
    "lng": -82.7579,
    "lat": 38.4652
  }, {
    "lng": -82.7583,
    "lat": 38.4654
  }, {
    "lng": -82.7586,
    "lat": 38.4654
  }, {
    "lng": -82.7589,
    "lat": 38.4653
  }, {
    "lng": -82.7591,
    "lat": 38.4651
  }, {
    "lng": -82.7593,
    "lat": 38.4648
  }, {
    "lng": -82.7595,
    "lat": 38.4645
  }, {
    "lng": -82.7597,
    "lat": 38.4644
  }, {
    "lng": -82.7601,
    "lat": 38.4642
  }, {
    "lng": -82.7604,
    "lat": 38.4641
  }, {
    "lng": -82.7609,
    "lat": 38.4639
  }, {
    "lng": -82.7615,
    "lat": 38.4635
  }, {
    "lng": -82.7622,
    "lat": 38.4631
  }, {
    "lng": -82.7625,
    "lat": 38.463
  }, {
    "lng": -82.7626,
    "lat": 38.4628
  }, {
    "lng": -82.7624,
    "lat": 38.4627
  }, {
    "lng": -82.7621,
    "lat": 38.4626
  }, {
    "lng": -82.7612,
    "lat": 38.4624
  }, {
    "lng": -82.7608,
    "lat": 38.4622
  }, {
    "lng": -82.7605,
    "lat": 38.4621
  }, {
    "lng": -82.7601,
    "lat": 38.4621
  }, {
    "lng": -82.7597,
    "lat": 38.4619
  }, {
    "lng": -82.7595,
    "lat": 38.4616
  }, {
    "lng": -82.7592,
    "lat": 38.4614
  }, {
    "lng": -82.7589,
    "lat": 38.4612
  }, {
    "lng": -82.7587,
    "lat": 38.4608
  }, {
    "lng": -82.7588,
    "lat": 38.4605
  }, {
    "lng": -82.7589,
    "lat": 38.4602
  }, {
    "lng": -82.7592,
    "lat": 38.46
  }, {
    "lng": -82.7594,
    "lat": 38.4597
  }, {
    "lng": -82.7595,
    "lat": 38.4595
  }, {
    "lng": -82.7593,
    "lat": 38.4592
  }, {
    "lng": -82.759,
    "lat": 38.4588
  }, {
    "lng": -82.7588,
    "lat": 38.4584
  }, {
    "lng": -82.759,
    "lat": 38.4578
  }, {
    "lng": -82.7594,
    "lat": 38.4574
  }, {
    "lng": -82.7601,
    "lat": 38.4571
  }, {
    "lng": -82.7606,
    "lat": 38.457
  }, {
    "lng": -82.761,
    "lat": 38.4571
  }, {
    "lng": -82.7614,
    "lat": 38.4574
  }, {
    "lng": -82.7616,
    "lat": 38.4573
  }, {
    "lng": -82.7618,
    "lat": 38.4572
  }, {
    "lng": -82.7624,
    "lat": 38.456
  }, {
    "lng": -82.763,
    "lat": 38.4549
  }, {
    "lng": -82.7631,
    "lat": 38.4546
  }, {
    "lng": -82.7633,
    "lat": 38.4544
  }, {
    "lng": -82.7637,
    "lat": 38.4542
  }, {
    "lng": -82.7663,
    "lat": 38.453
  }, {
    "lng": -82.7701,
    "lat": 38.4512
  }, {
    "lng": -82.7735,
    "lat": 38.4513
  }, {
    "lng": -82.7753,
    "lat": 38.4505
  }, {
    "lng": -82.7759,
    "lat": 38.4503
  }, {
    "lng": -82.7761,
    "lat": 38.4501
  }, {
    "lng": -82.7763,
    "lat": 38.4496
  }, {
    "lng": -82.7765,
    "lat": 38.449
  }, {
    "lng": -82.7765,
    "lat": 38.449
  }, {
    "lng": -82.7767,
    "lat": 38.4482
  }, {
    "lng": -82.7767,
    "lat": 38.4477
  }, {
    "lng": -82.7765,
    "lat": 38.447
  }, {
    "lng": -82.7764,
    "lat": 38.4467
  }, {
    "lng": -82.776,
    "lat": 38.4465
  }, {
    "lng": -82.7763,
    "lat": 38.4462
  }, {
    "lng": -82.7765,
    "lat": 38.446
  }, {
    "lng": -82.7762,
    "lat": 38.4457
  }, {
    "lng": -82.7753,
    "lat": 38.445
  }, {
    "lng": -82.775,
    "lat": 38.4449
  }, {
    "lng": -82.7748,
    "lat": 38.4448
  }, {
    "lng": -82.7747,
    "lat": 38.4447
  }, {
    "lng": -82.7746,
    "lat": 38.4446
  }, {
    "lng": -82.7745,
    "lat": 38.4445
  }, {
    "lng": -82.7745,
    "lat": 38.4444
  }, {
    "lng": -82.7745,
    "lat": 38.4439
  }, {
    "lng": -82.7744,
    "lat": 38.4436
  }, {
    "lng": -82.7744,
    "lat": 38.4434
  }, {
    "lng": -82.7743,
    "lat": 38.4432
  }, {
    "lng": -82.7742,
    "lat": 38.4428
  }, {
    "lng": -82.7741,
    "lat": 38.4425
  }, {
    "lng": -82.774,
    "lat": 38.4423
  }, {
    "lng": -82.7739,
    "lat": 38.4421
  }, {
    "lng": -82.7738,
    "lat": 38.4419
  }, {
    "lng": -82.7737,
    "lat": 38.4417
  }, {
    "lng": -82.7736,
    "lat": 38.4415
  }, {
    "lng": -82.7735,
    "lat": 38.4414
  }, {
    "lng": -82.7734,
    "lat": 38.4413
  }, {
    "lng": -82.7732,
    "lat": 38.4412
  }, {
    "lng": -82.7729,
    "lat": 38.4409
  }, {
    "lng": -82.7721,
    "lat": 38.4402
  }, {
    "lng": -82.7718,
    "lat": 38.44
  }, {
    "lng": -82.7715,
    "lat": 38.4397
  }, {
    "lng": -82.7714,
    "lat": 38.4396
  }, {
    "lng": -82.7712,
    "lat": 38.4394
  }, {
    "lng": -82.771,
    "lat": 38.4392
  }, {
    "lng": -82.7708,
    "lat": 38.439
  }, {
    "lng": -82.7705,
    "lat": 38.4386
  }, {
    "lng": -82.7704,
    "lat": 38.4385
  }, {
    "lng": -82.7703,
    "lat": 38.4382
  }, {
    "lng": -82.7702,
    "lat": 38.4381
  }, {
    "lng": -82.7701,
    "lat": 38.4379
  }, {
    "lng": -82.77,
    "lat": 38.4377
  }, {
    "lng": -82.7699,
    "lat": 38.4374
  }, {
    "lng": -82.7698,
    "lat": 38.4371
  }, {
    "lng": -82.7698,
    "lat": 38.4367
  }, {
    "lng": -82.7697,
    "lat": 38.4363
  }, {
    "lng": -82.7696,
    "lat": 38.4359
  }, {
    "lng": -82.7693,
    "lat": 38.4345
  }, {
    "lng": -82.7692,
    "lat": 38.4344
  }, {
    "lng": -82.7692,
    "lat": 38.4341
  }, {
    "lng": -82.7691,
    "lat": 38.4339
  }, {
    "lng": -82.7691,
    "lat": 38.4338
  }, {
    "lng": -82.769,
    "lat": 38.4337
  }, {
    "lng": -82.7691,
    "lat": 38.4336
  }, {
    "lng": -82.7691,
    "lat": 38.4336
  }, {
    "lng": -82.7692,
    "lat": 38.4336
  }, {
    "lng": -82.7694,
    "lat": 38.4331
  }, {
    "lng": -82.7694,
    "lat": 38.4329
  }, {
    "lng": -82.769,
    "lat": 38.4326
  }, {
    "lng": -82.7688,
    "lat": 38.4324
  }, {
    "lng": -82.7685,
    "lat": 38.4321
  }, {
    "lng": -82.7681,
    "lat": 38.4319
  }, {
    "lng": -82.768,
    "lat": 38.4316
  }, {
    "lng": -82.768,
    "lat": 38.4315
  }, {
    "lng": -82.768,
    "lat": 38.4312
  }, {
    "lng": -82.7683,
    "lat": 38.4308
  }, {
    "lng": -82.7686,
    "lat": 38.4304
  }, {
    "lng": -82.7686,
    "lat": 38.4303
  }, {
    "lng": -82.7686,
    "lat": 38.4302
  }, {
    "lng": -82.7686,
    "lat": 38.43
  }, {
    "lng": -82.7683,
    "lat": 38.4298
  }, {
    "lng": -82.7676,
    "lat": 38.4299
  }, {
    "lng": -82.7671,
    "lat": 38.4299
  }, {
    "lng": -82.7669,
    "lat": 38.4299
  }, {
    "lng": -82.7667,
    "lat": 38.4296
  }, {
    "lng": -82.7667,
    "lat": 38.4294
  }, {
    "lng": -82.7669,
    "lat": 38.4293
  }, {
    "lng": -82.7673,
    "lat": 38.4291
  }, {
    "lng": -82.7679,
    "lat": 38.4288
  }, {
    "lng": -82.7684,
    "lat": 38.4286
  }, {
    "lng": -82.7688,
    "lat": 38.4283
  }, {
    "lng": -82.7689,
    "lat": 38.428
  }, {
    "lng": -82.7687,
    "lat": 38.4278
  }, {
    "lng": -82.7681,
    "lat": 38.4276
  }, {
    "lng": -82.7669,
    "lat": 38.4275
  }, {
    "lng": -82.7661,
    "lat": 38.4276
  }, {
    "lng": -82.7655,
    "lat": 38.4278
  }, {
    "lng": -82.7648,
    "lat": 38.428
  }, {
    "lng": -82.7641,
    "lat": 38.4282
  }, {
    "lng": -82.7636,
    "lat": 38.4283
  }, {
    "lng": -82.7629,
    "lat": 38.4285
  }, {
    "lng": -82.7624,
    "lat": 38.4288
  }, {
    "lng": -82.7621,
    "lat": 38.4289
  }, {
    "lng": -82.7619,
    "lat": 38.4292
  }, {
    "lng": -82.7617,
    "lat": 38.4296
  }, {
    "lng": -82.7615,
    "lat": 38.4297
  }, {
    "lng": -82.7612,
    "lat": 38.43
  }, {
    "lng": -82.7609,
    "lat": 38.4303
  }, {
    "lng": -82.7606,
    "lat": 38.4307
  }, {
    "lng": -82.7603,
    "lat": 38.4311
  }, {
    "lng": -82.7599,
    "lat": 38.4315
  }, {
    "lng": -82.7595,
    "lat": 38.4318
  }, {
    "lng": -82.7591,
    "lat": 38.4322
  }, {
    "lng": -82.7587,
    "lat": 38.4325
  }, {
    "lng": -82.7584,
    "lat": 38.4327
  }, {
    "lng": -82.7579,
    "lat": 38.4329
  }, {
    "lng": -82.7575,
    "lat": 38.4329
  }, {
    "lng": -82.757,
    "lat": 38.4326
  }, {
    "lng": -82.7568,
    "lat": 38.4324
  }, {
    "lng": -82.7565,
    "lat": 38.432
  }, {
    "lng": -82.7566,
    "lat": 38.4316
  }, {
    "lng": -82.7563,
    "lat": 38.4314
  }, {
    "lng": -82.756,
    "lat": 38.4308
  }, {
    "lng": -82.7557,
    "lat": 38.4303
  }, {
    "lng": -82.7553,
    "lat": 38.4297
  }, {
    "lng": -82.7547,
    "lat": 38.4293
  }, {
    "lng": -82.7543,
    "lat": 38.429
  }, {
    "lng": -82.7538,
    "lat": 38.4288
  }, {
    "lng": -82.7534,
    "lat": 38.4289
  }, {
    "lng": -82.753,
    "lat": 38.4289
  }, {
    "lng": -82.7528,
    "lat": 38.4288
  }, {
    "lng": -82.7523,
    "lat": 38.4286
  }, {
    "lng": -82.7517,
    "lat": 38.4284
  }, {
    "lng": -82.751,
    "lat": 38.4282
  }, {
    "lng": -82.7505,
    "lat": 38.4282
  }, {
    "lng": -82.7505,
    "lat": 38.4282
  }, {
    "lng": -82.7504,
    "lat": 38.4282
  }, {
    "lng": -82.7498,
    "lat": 38.4284
  }, {
    "lng": -82.7489,
    "lat": 38.4289
  }, {
    "lng": -82.7486,
    "lat": 38.4292
  }, {
    "lng": -82.7479,
    "lat": 38.4299
  }, {
    "lng": -82.7474,
    "lat": 38.43
  }, {
    "lng": -82.7472,
    "lat": 38.43
  }, {
    "lng": -82.747,
    "lat": 38.4294
  }, {
    "lng": -82.7467,
    "lat": 38.4292
  }, {
    "lng": -82.7465,
    "lat": 38.4291
  }, {
    "lng": -82.7455,
    "lat": 38.4293
  }, {
    "lng": -82.745,
    "lat": 38.4295
  }, {
    "lng": -82.7451,
    "lat": 38.4299
  }, {
    "lng": -82.745,
    "lat": 38.4304
  }, {
    "lng": -82.7445,
    "lat": 38.4309
  }, {
    "lng": -82.7438,
    "lat": 38.4313
  }, {
    "lng": -82.7435,
    "lat": 38.4315
  }, {
    "lng": -82.7432,
    "lat": 38.4317
  }, {
    "lng": -82.7431,
    "lat": 38.4317
  }, {
    "lng": -82.7426,
    "lat": 38.4322
  }, {
    "lng": -82.742,
    "lat": 38.4326
  }, {
    "lng": -82.742,
    "lat": 38.4326
  }, {
    "lng": -82.7419,
    "lat": 38.4327
  }, {
    "lng": -82.7421,
    "lat": 38.4329
  }, {
    "lng": -82.7418,
    "lat": 38.4332
  }, {
    "lng": -82.7412,
    "lat": 38.4334
  }, {
    "lng": -82.7408,
    "lat": 38.4335
  }, {
    "lng": -82.7404,
    "lat": 38.4333
  }, {
    "lng": -82.74,
    "lat": 38.4334
  }, {
    "lng": -82.7396,
    "lat": 38.434
  }, {
    "lng": -82.7393,
    "lat": 38.4344
  }, {
    "lng": -82.7391,
    "lat": 38.4347
  }, {
    "lng": -82.7389,
    "lat": 38.4349
  }, {
    "lng": -82.738,
    "lat": 38.4347
  }, {
    "lng": -82.7374,
    "lat": 38.4345
  }, {
    "lng": -82.7366,
    "lat": 38.4342
  }, {
    "lng": -82.7363,
    "lat": 38.434
  }, {
    "lng": -82.7361,
    "lat": 38.434
  }, {
    "lng": -82.736,
    "lat": 38.4339
  }, {
    "lng": -82.7357,
    "lat": 38.4337
  }, {
    "lng": -82.7352,
    "lat": 38.4334
  }, {
    "lng": -82.7347,
    "lat": 38.433
  }, {
    "lng": -82.7344,
    "lat": 38.4328
  }, {
    "lng": -82.7343,
    "lat": 38.4327
  }, {
    "lng": -82.7336,
    "lat": 38.4322
  }, {
    "lng": -82.733,
    "lat": 38.432
  }, {
    "lng": -82.732,
    "lat": 38.4319
  }, {
    "lng": -82.7313,
    "lat": 38.4319
  }, {
    "lng": -82.7311,
    "lat": 38.432
  }, {
    "lng": -82.731,
    "lat": 38.4322
  }, {
    "lng": -82.7307,
    "lat": 38.4323
  }, {
    "lng": -82.7305,
    "lat": 38.4325
  }, {
    "lng": -82.7302,
    "lat": 38.4326
  }, {
    "lng": -82.7299,
    "lat": 38.4327
  }, {
    "lng": -82.7297,
    "lat": 38.4328
  }, {
    "lng": -82.7291,
    "lat": 38.4329
  }, {
    "lng": -82.7289,
    "lat": 38.4329
  }, {
    "lng": -82.7287,
    "lat": 38.433
  }, {
    "lng": -82.7286,
    "lat": 38.433
  }, {
    "lng": -82.7284,
    "lat": 38.4329
  }, {
    "lng": -82.7283,
    "lat": 38.4329
  }, {
    "lng": -82.728,
    "lat": 38.4329
  }, {
    "lng": -82.7277,
    "lat": 38.4328
  }, {
    "lng": -82.7275,
    "lat": 38.4328
  }, {
    "lng": -82.7272,
    "lat": 38.4328
  }, {
    "lng": -82.7269,
    "lat": 38.4329
  }, {
    "lng": -82.7266,
    "lat": 38.433
  }, {
    "lng": -82.7264,
    "lat": 38.4331
  }, {
    "lng": -82.7263,
    "lat": 38.4331
  }, {
    "lng": -82.7261,
    "lat": 38.4331
  }, {
    "lng": -82.7261,
    "lat": 38.4331
  }, {
    "lng": -82.7257,
    "lat": 38.433
  }, {
    "lng": -82.7255,
    "lat": 38.433
  }, {
    "lng": -82.7255,
    "lat": 38.433
  }, {
    "lng": -82.7253,
    "lat": 38.433
  }, {
    "lng": -82.7244,
    "lat": 38.4328
  }, {
    "lng": -82.7242,
    "lat": 38.4328
  }, {
    "lng": -82.724,
    "lat": 38.4327
  }, {
    "lng": -82.7238,
    "lat": 38.4327
  }, {
    "lng": -82.7236,
    "lat": 38.4326
  }, {
    "lng": -82.7235,
    "lat": 38.4325
  }, {
    "lng": -82.7234,
    "lat": 38.4325
  }, {
    "lng": -82.7228,
    "lat": 38.4327
  }, {
    "lng": -82.7223,
    "lat": 38.4329
  }, {
    "lng": -82.7219,
    "lat": 38.4333
  }, {
    "lng": -82.7215,
    "lat": 38.4339
  }, {
    "lng": -82.7212,
    "lat": 38.434
  }, {
    "lng": -82.7211,
    "lat": 38.434
  }, {
    "lng": -82.7209,
    "lat": 38.4342
  }, {
    "lng": -82.7204,
    "lat": 38.4376
  }, {
    "lng": -82.7203,
    "lat": 38.438
  }, {
    "lng": -82.72,
    "lat": 38.4412
  }, {
    "lng": -82.7175,
    "lat": 38.4478
  }, {
    "lng": -82.7174,
    "lat": 38.4477
  }, {
    "lng": -82.7168,
    "lat": 38.4477
  }, {
    "lng": -82.7166,
    "lat": 38.4477
  }, {
    "lng": -82.7159,
    "lat": 38.4477
  }, {
    "lng": -82.7146,
    "lat": 38.4476
  }, {
    "lng": -82.7142,
    "lat": 38.4476
  }, {
    "lng": -82.714,
    "lat": 38.4476
  }, {
    "lng": -82.7137,
    "lat": 38.4475
  }, {
    "lng": -82.7135,
    "lat": 38.4475
  }, {
    "lng": -82.7137,
    "lat": 38.4472
  }, {
    "lng": -82.7122,
    "lat": 38.4468
  }, {
    "lng": -82.7114,
    "lat": 38.4466
  }, {
    "lng": -82.7103,
    "lat": 38.4465
  }, {
    "lng": -82.7097,
    "lat": 38.4466
  }, {
    "lng": -82.7088,
    "lat": 38.4469
  }, {
    "lng": -82.7087,
    "lat": 38.4469
  }, {
    "lng": -82.7086,
    "lat": 38.4469
  }, {
    "lng": -82.7086,
    "lat": 38.4469
  }, {
    "lng": -82.7085,
    "lat": 38.4468
  }, {
    "lng": -82.7084,
    "lat": 38.4468
  }, {
    "lng": -82.7084,
    "lat": 38.4468
  }, {
    "lng": -82.7083,
    "lat": 38.4467
  }, {
    "lng": -82.7083,
    "lat": 38.4466
  }, {
    "lng": -82.7082,
    "lat": 38.4466
  }, {
    "lng": -82.708,
    "lat": 38.4464
  }, {
    "lng": -82.7078,
    "lat": 38.4463
  }, {
    "lng": -82.7075,
    "lat": 38.4461
  }, {
    "lng": -82.7074,
    "lat": 38.446
  }, {
    "lng": -82.7071,
    "lat": 38.4458
  }, {
    "lng": -82.707,
    "lat": 38.4458
  }, {
    "lng": -82.7066,
    "lat": 38.4456
  }, {
    "lng": -82.7061,
    "lat": 38.4454
  }, {
    "lng": -82.7058,
    "lat": 38.4453
  }, {
    "lng": -82.7052,
    "lat": 38.445
  }, {
    "lng": -82.7049,
    "lat": 38.4449
  }, {
    "lng": -82.7047,
    "lat": 38.4448
  }, {
    "lng": -82.7044,
    "lat": 38.4445
  }, {
    "lng": -82.7038,
    "lat": 38.4441
  }, {
    "lng": -82.7029,
    "lat": 38.4446
  }, {
    "lng": -82.7021,
    "lat": 38.445
  }, {
    "lng": -82.7006,
    "lat": 38.4454
  }, {
    "lng": -82.6994,
    "lat": 38.4458
  }, {
    "lng": -82.6991,
    "lat": 38.4458
  }, {
    "lng": -82.6986,
    "lat": 38.4459
  }, {
    "lng": -82.6983,
    "lat": 38.4459
  }, {
    "lng": -82.698,
    "lat": 38.446
  }, {
    "lng": -82.698,
    "lat": 38.4461
  }, {
    "lng": -82.698,
    "lat": 38.4465
  }, {
    "lng": -82.6979,
    "lat": 38.4466
  }, {
    "lng": -82.6977,
    "lat": 38.4467
  }, {
    "lng": -82.6942,
    "lat": 38.4469
  }, {
    "lng": -82.689,
    "lat": 38.4473
  }, {
    "lng": -82.6887,
    "lat": 38.4477
  }, {
    "lng": -82.6885,
    "lat": 38.4482
  }, {
    "lng": -82.6883,
    "lat": 38.4487
  }, {
    "lng": -82.6879,
    "lat": 38.4504
  }, {
    "lng": -82.6877,
    "lat": 38.4509
  }]]],
  "options": {
    "fillColor": "#f50d0d",
    "fillOpacity": 0.4,
    "strokeColor": "#BA0808",
    "strokeWeight": 1,
    "strokeOpacity": 0.4,
    "clickable": true,
    "visible": true,
    "zIndex": 1000
  }
};
var carrierRoute12 = {
  carrierRoute: '41102C020',
  paths: [[[{
    lng: -82.6457,
    lat: 38.456
  }, {
    lng: -82.6461,
    lat: 38.4562
  }, {
    lng: -82.6467,
    lat: 38.4566
  }, {
    lng: -82.647,
    lat: 38.4568
  }, {
    lng: -82.6474,
    lat: 38.457
  }, {
    lng: -82.6474,
    lat: 38.457
  }, {
    lng: -82.6477,
    lat: 38.4572
  }, {
    lng: -82.648,
    lat: 38.4571
  }, {
    lng: -82.6483,
    lat: 38.4569
  }, {
    lng: -82.6485,
    lat: 38.4566
  }, {
    lng: -82.6499,
    lat: 38.4555
  }, {
    lng: -82.65,
    lat: 38.4556
  }, {
    lng: -82.6502,
    lat: 38.4555
  }, {
    lng: -82.6504,
    lat: 38.4554
  }, {
    lng: -82.6508,
    lat: 38.4552
  }, {
    lng: -82.6511,
    lat: 38.4555
  }, {
    lng: -82.6513,
    lat: 38.4556
  }, {
    lng: -82.6519,
    lat: 38.4561
  }, {
    lng: -82.6526,
    lat: 38.4566
  }, {
    lng: -82.653,
    lat: 38.4568
  }, {
    lng: -82.6529,
    lat: 38.4569
  }, {
    lng: -82.6519,
    lat: 38.458
  }, {
    lng: -82.6517,
    lat: 38.4583
  }, {
    lng: -82.6517,
    lat: 38.4583
  }, {
    lng: -82.6519,
    lat: 38.4584
  }, {
    lng: -82.6522,
    lat: 38.4585
  }, {
    lng: -82.6523,
    lat: 38.4586
  }, {
    lng: -82.6523,
    lat: 38.4586
  }, {
    lng: -82.6523,
    lat: 38.4587
  }, {
    lng: -82.6522,
    lat: 38.4589
  }, {
    lng: -82.6521,
    lat: 38.459
  }, {
    lng: -82.6521,
    lat: 38.4591
  }, {
    lng: -82.6521,
    lat: 38.4592
  }, {
    lng: -82.6522,
    lat: 38.4593
  }, {
    lng: -82.6522,
    lat: 38.4594
  }, {
    lng: -82.6523,
    lat: 38.4595
  }, {
    lng: -82.6525,
    lat: 38.4595
  }, {
    lng: -82.6526,
    lat: 38.4596
  }, {
    lng: -82.6529,
    lat: 38.4598
  }, {
    lng: -82.653,
    lat: 38.4598
  }, {
    lng: -82.6531,
    lat: 38.4599
  }, {
    lng: -82.6537,
    lat: 38.4602
  }, {
    lng: -82.6544,
    lat: 38.4607
  }, {
    lng: -82.6551,
    lat: 38.4611
  }, {
    lng: -82.6555,
    lat: 38.4615
  }, {
    lng: -82.6558,
    lat: 38.4618
  }, {
    lng: -82.6561,
    lat: 38.4621
  }, {
    lng: -82.6566,
    lat: 38.4625
  }, {
    lng: -82.6574,
    lat: 38.4634
  }, {
    lng: -82.658,
    lat: 38.4639
  }, {
    lng: -82.6582,
    lat: 38.4642
  }, {
    lng: -82.6584,
    lat: 38.4644
  }, {
    lng: -82.6585,
    lat: 38.4646
  }, {
    lng: -82.6586,
    lat: 38.4647
  }, {
    lng: -82.6586,
    lat: 38.4647
  }, {
    lng: -82.659,
    lat: 38.4653
  }, {
    lng: -82.6591,
    lat: 38.4653
  }, {
    lng: -82.6591,
    lat: 38.4652
  }, {
    lng: -82.6593,
    lat: 38.465
  }, {
    lng: -82.6594,
    lat: 38.4649
  }, {
    lng: -82.6597,
    lat: 38.4648
  }, {
    lng: -82.6597,
    lat: 38.4648
  }, {
    lng: -82.6596,
    lat: 38.4646
  }, {
    lng: -82.6596,
    lat: 38.4644
  }, {
    lng: -82.6595,
    lat: 38.4643
  }, {
    lng: -82.6595,
    lat: 38.4641
  }, {
    lng: -82.6595,
    lat: 38.464
  }, {
    lng: -82.6595,
    lat: 38.464
  }, {
    lng: -82.6595,
    lat: 38.4632
  }, {
    lng: -82.6598,
    lat: 38.4631
  }, {
    lng: -82.6598,
    lat: 38.4631
  }, {
    lng: -82.6607,
    lat: 38.463
  }, {
    lng: -82.6608,
    lat: 38.463
  }, {
    lng: -82.6609,
    lat: 38.463
  }, {
    lng: -82.6611,
    lat: 38.4629
  }, {
    lng: -82.6612,
    lat: 38.4629
  }, {
    lng: -82.6612,
    lat: 38.4629
  }, {
    lng: -82.6613,
    lat: 38.4629
  }, {
    lng: -82.6616,
    lat: 38.4628
  }, {
    lng: -82.6616,
    lat: 38.4628
  }, {
    lng: -82.6617,
    lat: 38.4628
  }, {
    lng: -82.6617,
    lat: 38.4628
  }, {
    lng: -82.6617,
    lat: 38.4628
  }, {
    lng: -82.6618,
    lat: 38.4628
  }, {
    lng: -82.662,
    lat: 38.4628
  }, {
    lng: -82.6622,
    lat: 38.4629
  }, {
    lng: -82.6626,
    lat: 38.4623
  }, {
    lng: -82.6627,
    lat: 38.4621
  }, {
    lng: -82.6632,
    lat: 38.4616
  }, {
    lng: -82.6633,
    lat: 38.4615
  }, {
    lng: -82.6633,
    lat: 38.4614
  }, {
    lng: -82.6633,
    lat: 38.4614
  }, {
    lng: -82.6632,
    lat: 38.4614
  }, {
    lng: -82.6631,
    lat: 38.4613
  }, {
    lng: -82.663,
    lat: 38.4613
  }, {
    lng: -82.6631,
    lat: 38.4612
  }, {
    lng: -82.6631,
    lat: 38.4611
  }, {
    lng: -82.6631,
    lat: 38.461
  }, {
    lng: -82.6631,
    lat: 38.4607
  }, {
    lng: -82.6631,
    lat: 38.4605
  }, {
    lng: -82.6631,
    lat: 38.4603
  }, {
    lng: -82.6632,
    lat: 38.4599
  }, {
    lng: -82.6629,
    lat: 38.4597
  }, {
    lng: -82.6628,
    lat: 38.4596
  }, {
    lng: -82.6627,
    lat: 38.4595
  }, {
    lng: -82.6627,
    lat: 38.4594
  }, {
    lng: -82.6626,
    lat: 38.4594
  }, {
    lng: -82.6626,
    lat: 38.4593
  }, {
    lng: -82.6625,
    lat: 38.4592
  }, {
    lng: -82.6625,
    lat: 38.4591
  }, {
    lng: -82.6625,
    lat: 38.4589
  }, {
    lng: -82.6624,
    lat: 38.4588
  }, {
    lng: -82.6623,
    lat: 38.4586
  }, {
    lng: -82.662,
    lat: 38.4583
  }, {
    lng: -82.6615,
    lat: 38.4578
  }, {
    lng: -82.6614,
    lat: 38.4578
  }, {
    lng: -82.6614,
    lat: 38.4577
  }, {
    lng: -82.6612,
    lat: 38.4576
  }, {
    lng: -82.6611,
    lat: 38.4576
  }, {
    lng: -82.661,
    lat: 38.4575
  }, {
    lng: -82.661,
    lat: 38.4575
  }, {
    lng: -82.6609,
    lat: 38.4574
  }, {
    lng: -82.6609,
    lat: 38.4574
  }, {
    lng: -82.6606,
    lat: 38.4573
  }, {
    lng: -82.6603,
    lat: 38.4572
  }, {
    lng: -82.6602,
    lat: 38.4571
  }, {
    lng: -82.66,
    lat: 38.457
  }, {
    lng: -82.6599,
    lat: 38.457
  }, {
    lng: -82.6597,
    lat: 38.4569
  }, {
    lng: -82.6589,
    lat: 38.4566
  }, {
    lng: -82.6578,
    lat: 38.4563
  }, {
    lng: -82.6572,
    lat: 38.456
  }, {
    lng: -82.6568,
    lat: 38.4558
  }, {
    lng: -82.6564,
    lat: 38.4556
  }, {
    lng: -82.6559,
    lat: 38.4554
  }, {
    lng: -82.6555,
    lat: 38.4555
  }, {
    lng: -82.6551,
    lat: 38.4556
  }, {
    lng: -82.6546,
    lat: 38.4558
  }, {
    lng: -82.6542,
    lat: 38.4554
  }, {
    lng: -82.6529,
    lat: 38.4543
  }, {
    lng: -82.6526,
    lat: 38.454
  }, {
    lng: -82.6533,
    lat: 38.4538
  }, {
    lng: -82.6537,
    lat: 38.4537
  }, {
    lng: -82.6553,
    lat: 38.4531
  }, {
    lng: -82.6541,
    lat: 38.4521
  }, {
    lng: -82.6535,
    lat: 38.4518
  }, {
    lng: -82.6532,
    lat: 38.4517
  }, {
    lng: -82.6525,
    lat: 38.4514
  }, {
    lng: -82.6522,
    lat: 38.4513
  }, {
    lng: -82.6521,
    lat: 38.4513
  }, {
    lng: -82.6519,
    lat: 38.4512
  }, {
    lng: -82.6519,
    lat: 38.4512
  }, {
    lng: -82.6517,
    lat: 38.4512
  }, {
    lng: -82.6515,
    lat: 38.4511
  }, {
    lng: -82.6514,
    lat: 38.451
  }, {
    lng: -82.6513,
    lat: 38.451
  }, {
    lng: -82.6512,
    lat: 38.4509
  }, {
    lng: -82.6512,
    lat: 38.4509
  }, {
    lng: -82.6512,
    lat: 38.4508
  }, {
    lng: -82.6511,
    lat: 38.4508
  }, {
    lng: -82.6511,
    lat: 38.4507
  }, {
    lng: -82.6511,
    lat: 38.4507
  }, {
    lng: -82.651,
    lat: 38.4507
  }, {
    lng: -82.651,
    lat: 38.4506
  }, {
    lng: -82.6508,
    lat: 38.4506
  }, {
    lng: -82.6507,
    lat: 38.4505
  }, {
    lng: -82.6506,
    lat: 38.4504
  }, {
    lng: -82.6505,
    lat: 38.4504
  }, {
    lng: -82.6502,
    lat: 38.4502
  }, {
    lng: -82.65,
    lat: 38.4502
  }, {
    lng: -82.6499,
    lat: 38.4501
  }, {
    lng: -82.6497,
    lat: 38.45
  }, {
    lng: -82.6495,
    lat: 38.45
  }, {
    lng: -82.6494,
    lat: 38.4499
  }, {
    lng: -82.6491,
    lat: 38.4499
  }, {
    lng: -82.6486,
    lat: 38.4497
  }, {
    lng: -82.6483,
    lat: 38.4496
  }, {
    lng: -82.6479,
    lat: 38.4495
  }, {
    lng: -82.6479,
    lat: 38.4495
  }, {
    lng: -82.6478,
    lat: 38.4496
  }, {
    lng: -82.6476,
    lat: 38.4499
  }, {
    lng: -82.6474,
    lat: 38.4501
  }, {
    lng: -82.6473,
    lat: 38.4502
  }, {
    lng: -82.647,
    lat: 38.4506
  }, {
    lng: -82.6468,
    lat: 38.4508
  }, {
    lng: -82.6467,
    lat: 38.4509
  }, {
    lng: -82.6463,
    lat: 38.4514
  }, {
    lng: -82.6462,
    lat: 38.4515
  }, {
    lng: -82.6464,
    lat: 38.452
  }, {
    lng: -82.6469,
    lat: 38.4527
  }, {
    lng: -82.6496,
    lat: 38.4518
  }, {
    lng: -82.6503,
    lat: 38.4516
  }, {
    lng: -82.6504,
    lat: 38.4515
  }, {
    lng: -82.6505,
    lat: 38.4515
  }, {
    lng: -82.6506,
    lat: 38.4515
  }, {
    lng: -82.6506,
    lat: 38.4515
  }, {
    lng: -82.6507,
    lat: 38.4515
  }, {
    lng: -82.6507,
    lat: 38.4515
  }, {
    lng: -82.6507,
    lat: 38.4516
  }, {
    lng: -82.6507,
    lat: 38.4516
  }, {
    lng: -82.6508,
    lat: 38.4517
  }, {
    lng: -82.6508,
    lat: 38.4518
  }, {
    lng: -82.6509,
    lat: 38.4519
  }, {
    lng: -82.651,
    lat: 38.4521
  }, {
    lng: -82.6511,
    lat: 38.4522
  }, {
    lng: -82.6511,
    lat: 38.4523
  }, {
    lng: -82.6511,
    lat: 38.4524
  }, {
    lng: -82.651,
    lat: 38.4524
  }, {
    lng: -82.6509,
    lat: 38.4525
  }, {
    lng: -82.6505,
    lat: 38.4526
  }, {
    lng: -82.6502,
    lat: 38.4527
  }, {
    lng: -82.6501,
    lat: 38.4527
  }, {
    lng: -82.6498,
    lat: 38.4528
  }, {
    lng: -82.6495,
    lat: 38.4529
  }, {
    lng: -82.6474,
    lat: 38.4536
  }, {
    lng: -82.6476,
    lat: 38.4541
  }, {
    lng: -82.6478,
    lat: 38.4546
  }, {
    lng: -82.6478,
    lat: 38.4546
  }, {
    lng: -82.6475,
    lat: 38.4547
  }, {
    lng: -82.6474,
    lat: 38.4548
  }, {
    lng: -82.6472,
    lat: 38.4548
  }, {
    lng: -82.6471,
    lat: 38.4549
  }, {
    lng: -82.647,
    lat: 38.455
  }, {
    lng: -82.6467,
    lat: 38.4552
  }, {
    lng: -82.6465,
    lat: 38.4554
  }, {
    lng: -82.6465,
    lat: 38.4554
  }, {
    lng: -82.6464,
    lat: 38.4554
  }, {
    lng: -82.6457,
    lat: 38.456
  }]]],
  options: {
    fillColor: '#f50d0d',
    fillOpacity: 0.4,
    strokeColor: '#BA0808',
    strokeWeight: 1,
    strokeOpacity: 0.4,
    clickable: true,
    visible: true,
    zIndex: 1000
  }
};
var carrierRoute13 = {
  carrierRoute: '41102C018',
  paths: [[[{
    lng: -82.6704,
    lat: 38.4732
  }, {
    lng: -82.6707,
    lat: 38.4732
  }, {
    lng: -82.6721,
    lat: 38.4735
  }, {
    lng: -82.6723,
    lat: 38.4736
  }, {
    lng: -82.6724,
    lat: 38.4733
  }, {
    lng: -82.6726,
    lat: 38.4732
  }, {
    lng: -82.6728,
    lat: 38.4732
  }, {
    lng: -82.6728,
    lat: 38.4734
  }, {
    lng: -82.6727,
    lat: 38.4735
  }, {
    lng: -82.6726,
    lat: 38.4736
  }, {
    lng: -82.6725,
    lat: 38.4736
  }, {
    lng: -82.6725,
    lat: 38.4737
  }, {
    lng: -82.6725,
    lat: 38.4737
  }, {
    lng: -82.6724,
    lat: 38.4738
  }, {
    lng: -82.6724,
    lat: 38.4739
  }, {
    lng: -82.6723,
    lat: 38.4739
  }, {
    lng: -82.6723,
    lat: 38.474
  }, {
    lng: -82.6723,
    lat: 38.4741
  }, {
    lng: -82.6724,
    lat: 38.4744
  }, {
    lng: -82.6725,
    lat: 38.4745
  }, {
    lng: -82.6726,
    lat: 38.4746
  }, {
    lng: -82.6726,
    lat: 38.4747
  }, {
    lng: -82.6727,
    lat: 38.4748
  }, {
    lng: -82.6729,
    lat: 38.4748
  }, {
    lng: -82.6732,
    lat: 38.4749
  }, {
    lng: -82.6735,
    lat: 38.475
  }, {
    lng: -82.6739,
    lat: 38.4752
  }, {
    lng: -82.6747,
    lat: 38.4755
  }, {
    lng: -82.6766,
    lat: 38.4761
  }, {
    lng: -82.6779,
    lat: 38.4766
  }, {
    lng: -82.678,
    lat: 38.4766
  }, {
    lng: -82.6783,
    lat: 38.4767
  }, {
    lng: -82.6784,
    lat: 38.4768
  }, {
    lng: -82.6789,
    lat: 38.477
  }, {
    lng: -82.6788,
    lat: 38.4772
  }, {
    lng: -82.6787,
    lat: 38.4772
  }, {
    lng: -82.6781,
    lat: 38.478
  }, {
    lng: -82.678,
    lat: 38.4782
  }, {
    lng: -82.6776,
    lat: 38.4787
  }, {
    lng: -82.6775,
    lat: 38.4789
  }, {
    lng: -82.6772,
    lat: 38.4792
  }, {
    lng: -82.6771,
    lat: 38.4794
  }, {
    lng: -82.677,
    lat: 38.4795
  }, {
    lng: -82.677,
    lat: 38.4796
  }, {
    lng: -82.6768,
    lat: 38.4798
  }, {
    lng: -82.6766,
    lat: 38.48
  }, {
    lng: -82.6762,
    lat: 38.4803
  }, {
    lng: -82.6762,
    lat: 38.4802
  }, {
    lng: -82.6761,
    lat: 38.4801
  }, {
    lng: -82.6758,
    lat: 38.4799
  }, {
    lng: -82.6757,
    lat: 38.4798
  }, {
    lng: -82.6756,
    lat: 38.4798
  }, {
    lng: -82.6756,
    lat: 38.4798
  }, {
    lng: -82.6755,
    lat: 38.4798
  }, {
    lng: -82.6755,
    lat: 38.4798
  }, {
    lng: -82.6754,
    lat: 38.4799
  }, {
    lng: -82.6752,
    lat: 38.4801
  }, {
    lng: -82.6751,
    lat: 38.4802
  }, {
    lng: -82.6751,
    lat: 38.4803
  }, {
    lng: -82.675,
    lat: 38.4803
  }, {
    lng: -82.6749,
    lat: 38.4804
  }, {
    lng: -82.6749,
    lat: 38.4805
  }, {
    lng: -82.6747,
    lat: 38.4807
  }, {
    lng: -82.6744,
    lat: 38.4811
  }, {
    lng: -82.6737,
    lat: 38.4807
  }, {
    lng: -82.6733,
    lat: 38.4812
  }, {
    lng: -82.6729,
    lat: 38.4816
  }, {
    lng: -82.6727,
    lat: 38.4819
  }, {
    lng: -82.6725,
    lat: 38.4821
  }, {
    lng: -82.6723,
    lat: 38.4822
  }, {
    lng: -82.6721,
    lat: 38.4825
  }, {
    lng: -82.672,
    lat: 38.4826
  }, {
    lng: -82.6718,
    lat: 38.4827
  }, {
    lng: -82.6718,
    lat: 38.4827
  }, {
    lng: -82.6716,
    lat: 38.4828
  }, {
    lng: -82.6711,
    lat: 38.483
  }, {
    lng: -82.6706,
    lat: 38.4833
  }, {
    lng: -82.6709,
    lat: 38.4836
  }, {
    lng: -82.671,
    lat: 38.4838
  }, {
    lng: -82.6711,
    lat: 38.4839
  }, {
    lng: -82.6711,
    lat: 38.4839
  }, {
    lng: -82.6712,
    lat: 38.484
  }, {
    lng: -82.6712,
    lat: 38.4841
  }, {
    lng: -82.6713,
    lat: 38.4841
  }, {
    lng: -82.6713,
    lat: 38.4842
  }, {
    lng: -82.6716,
    lat: 38.4842
  }, {
    lng: -82.6717,
    lat: 38.4843
  }, {
    lng: -82.6719,
    lat: 38.4844
  }, {
    lng: -82.6722,
    lat: 38.4845
  }, {
    lng: -82.6723,
    lat: 38.4845
  }, {
    lng: -82.6725,
    lat: 38.4846
  }, {
    lng: -82.6725,
    lat: 38.4846
  }, {
    lng: -82.6726,
    lat: 38.4846
  }, {
    lng: -82.6727,
    lat: 38.4847
  }, {
    lng: -82.6728,
    lat: 38.4848
  }, {
    lng: -82.6729,
    lat: 38.4848
  }, {
    lng: -82.6729,
    lat: 38.4849
  }, {
    lng: -82.673,
    lat: 38.4849
  }, {
    lng: -82.6731,
    lat: 38.485
  }, {
    lng: -82.6732,
    lat: 38.4851
  }, {
    lng: -82.6733,
    lat: 38.4852
  }, {
    lng: -82.6734,
    lat: 38.4852
  }, {
    lng: -82.6736,
    lat: 38.4855
  }, {
    lng: -82.6742,
    lat: 38.4852
  }, {
    lng: -82.6751,
    lat: 38.4852
  }, {
    lng: -82.6757,
    lat: 38.4853
  }, {
    lng: -82.6761,
    lat: 38.4852
  }, {
    lng: -82.6764,
    lat: 38.4851
  }, {
    lng: -82.6769,
    lat: 38.4849
  }, {
    lng: -82.6772,
    lat: 38.4848
  }, {
    lng: -82.6773,
    lat: 38.4847
  }, {
    lng: -82.6774,
    lat: 38.4846
  }, {
    lng: -82.6775,
    lat: 38.4845
  }, {
    lng: -82.6775,
    lat: 38.4843
  }, {
    lng: -82.6775,
    lat: 38.4842
  }, {
    lng: -82.6774,
    lat: 38.4841
  }, {
    lng: -82.6772,
    lat: 38.4839
  }, {
    lng: -82.6773,
    lat: 38.4839
  }, {
    lng: -82.6774,
    lat: 38.4839
  }, {
    lng: -82.6776,
    lat: 38.4839
  }, {
    lng: -82.6778,
    lat: 38.4839
  }, {
    lng: -82.678,
    lat: 38.484
  }, {
    lng: -82.6784,
    lat: 38.4841
  }, {
    lng: -82.6788,
    lat: 38.4842
  }, {
    lng: -82.679,
    lat: 38.4842
  }, {
    lng: -82.6798,
    lat: 38.4844
  }, {
    lng: -82.6802,
    lat: 38.4845
  }, {
    lng: -82.681,
    lat: 38.4848
  }, {
    lng: -82.6815,
    lat: 38.485
  }, {
    lng: -82.6816,
    lat: 38.4849
  }, {
    lng: -82.682,
    lat: 38.4847
  }, {
    lng: -82.6823,
    lat: 38.4845
  }, {
    lng: -82.6827,
    lat: 38.4844
  }, {
    lng: -82.6829,
    lat: 38.4844
  }, {
    lng: -82.6832,
    lat: 38.4844
  }, {
    lng: -82.6834,
    lat: 38.4843
  }, {
    lng: -82.6837,
    lat: 38.4842
  }, {
    lng: -82.684,
    lat: 38.484
  }, {
    lng: -82.6841,
    lat: 38.4838
  }, {
    lng: -82.6843,
    lat: 38.4837
  }, {
    lng: -82.6843,
    lat: 38.4836
  }, {
    lng: -82.6843,
    lat: 38.4835
  }, {
    lng: -82.6843,
    lat: 38.4835
  }, {
    lng: -82.6845,
    lat: 38.4832
  }, {
    lng: -82.6845,
    lat: 38.4832
  }, {
    lng: -82.6845,
    lat: 38.4832
  }, {
    lng: -82.6847,
    lat: 38.4831
  }, {
    lng: -82.6848,
    lat: 38.4829
  }, {
    lng: -82.6848,
    lat: 38.4828
  }, {
    lng: -82.6849,
    lat: 38.4827
  }, {
    lng: -82.685,
    lat: 38.4826
  }, {
    lng: -82.6851,
    lat: 38.4825
  }, {
    lng: -82.6851,
    lat: 38.4822
  }, {
    lng: -82.6851,
    lat: 38.4821
  }, {
    lng: -82.685,
    lat: 38.482
  }, {
    lng: -82.6849,
    lat: 38.482
  }, {
    lng: -82.6849,
    lat: 38.482
  }, {
    lng: -82.686,
    lat: 38.4806
  }, {
    lng: -82.6866,
    lat: 38.481
  }, {
    lng: -82.6866,
    lat: 38.481
  }, {
    lng: -82.687,
    lat: 38.4808
  }, {
    lng: -82.6871,
    lat: 38.4808
  }, {
    lng: -82.6872,
    lat: 38.4808
  }, {
    lng: -82.6874,
    lat: 38.4808
  }, {
    lng: -82.6876,
    lat: 38.4809
  }, {
    lng: -82.6879,
    lat: 38.4809
  }, {
    lng: -82.688,
    lat: 38.481
  }, {
    lng: -82.6882,
    lat: 38.4813
  }, {
    lng: -82.6882,
    lat: 38.4814
  }, {
    lng: -82.6884,
    lat: 38.4817
  }, {
    lng: -82.6885,
    lat: 38.4819
  }, {
    lng: -82.6887,
    lat: 38.4821
  }, {
    lng: -82.6889,
    lat: 38.4825
  }, {
    lng: -82.6893,
    lat: 38.4829
  }, {
    lng: -82.6897,
    lat: 38.4834
  }, {
    lng: -82.6898,
    lat: 38.4836
  }, {
    lng: -82.6899,
    lat: 38.4836
  }, {
    lng: -82.6899,
    lat: 38.4837
  }, {
    lng: -82.69,
    lat: 38.4838
  }, {
    lng: -82.6901,
    lat: 38.4838
  }, {
    lng: -82.6902,
    lat: 38.4839
  }, {
    lng: -82.6903,
    lat: 38.4839
  }, {
    lng: -82.6904,
    lat: 38.4838
  }, {
    lng: -82.6902,
    lat: 38.4828
  }, {
    lng: -82.6902,
    lat: 38.4815
  }, {
    lng: -82.6905,
    lat: 38.4816
  }, {
    lng: -82.6907,
    lat: 38.4818
  }, {
    lng: -82.6909,
    lat: 38.4819
  }, {
    lng: -82.6909,
    lat: 38.482
  }, {
    lng: -82.6911,
    lat: 38.4821
  }, {
    lng: -82.6911,
    lat: 38.4821
  }, {
    lng: -82.6913,
    lat: 38.4821
  }, {
    lng: -82.6914,
    lat: 38.4821
  }, {
    lng: -82.6917,
    lat: 38.4819
  }, {
    lng: -82.692,
    lat: 38.4812
  }, {
    lng: -82.6923,
    lat: 38.4804
  }, {
    lng: -82.6925,
    lat: 38.4795
  }, {
    lng: -82.6924,
    lat: 38.4791
  }, {
    lng: -82.692,
    lat: 38.4776
  }, {
    lng: -82.6922,
    lat: 38.4762
  }, {
    lng: -82.6916,
    lat: 38.4746
  }, {
    lng: -82.6915,
    lat: 38.4746
  }, {
    lng: -82.6914,
    lat: 38.4747
  }, {
    lng: -82.6913,
    lat: 38.4747
  }, {
    lng: -82.6912,
    lat: 38.4747
  }, {
    lng: -82.6911,
    lat: 38.4748
  }, {
    lng: -82.6909,
    lat: 38.4748
  }, {
    lng: -82.6909,
    lat: 38.4749
  }, {
    lng: -82.6907,
    lat: 38.4749
  }, {
    lng: -82.6902,
    lat: 38.4751
  }, {
    lng: -82.6897,
    lat: 38.4752
  }, {
    lng: -82.6884,
    lat: 38.4754
  }, {
    lng: -82.6876,
    lat: 38.4754
  }, {
    lng: -82.687,
    lat: 38.4755
  }, {
    lng: -82.6867,
    lat: 38.4755
  }, {
    lng: -82.6868,
    lat: 38.475
  }, {
    lng: -82.6868,
    lat: 38.4749
  }, {
    lng: -82.6868,
    lat: 38.4747
  }, {
    lng: -82.6868,
    lat: 38.4746
  }, {
    lng: -82.6867,
    lat: 38.4745
  }, {
    lng: -82.6864,
    lat: 38.4744
  }, {
    lng: -82.6862,
    lat: 38.4744
  }, {
    lng: -82.6857,
    lat: 38.4743
  }, {
    lng: -82.6859,
    lat: 38.4733
  }, {
    lng: -82.6859,
    lat: 38.4731
  }, {
    lng: -82.6862,
    lat: 38.4731
  }, {
    lng: -82.6866,
    lat: 38.4731
  }, {
    lng: -82.6868,
    lat: 38.4731
  }, {
    lng: -82.6871,
    lat: 38.4731
  }, {
    lng: -82.6874,
    lat: 38.4731
  }, {
    lng: -82.6874,
    lat: 38.473
  }, {
    lng: -82.6876,
    lat: 38.473
  }, {
    lng: -82.688,
    lat: 38.4729
  }, {
    lng: -82.6883,
    lat: 38.4727
  }, {
    lng: -82.6887,
    lat: 38.4726
  }, {
    lng: -82.689,
    lat: 38.4723
  }, {
    lng: -82.6837,
    lat: 38.4675
  }, {
    lng: -82.6829,
    lat: 38.4672
  }, {
    lng: -82.6814,
    lat: 38.4663
  }, {
    lng: -82.6797,
    lat: 38.4658
  }, {
    lng: -82.6794,
    lat: 38.4657
  }, {
    lng: -82.6784,
    lat: 38.4653
  }, {
    lng: -82.6777,
    lat: 38.4651
  }, {
    lng: -82.6736,
    lat: 38.4653
  }, {
    lng: -82.6735,
    lat: 38.4654
  }, {
    lng: -82.673,
    lat: 38.4655
  }, {
    lng: -82.6728,
    lat: 38.4655
  }, {
    lng: -82.6726,
    lat: 38.4656
  }, {
    lng: -82.6725,
    lat: 38.4656
  }, {
    lng: -82.6722,
    lat: 38.4656
  }, {
    lng: -82.6722,
    lat: 38.4656
  }, {
    lng: -82.6721,
    lat: 38.4656
  }, {
    lng: -82.6719,
    lat: 38.4656
  }, {
    lng: -82.6718,
    lat: 38.4669
  }, {
    lng: -82.6716,
    lat: 38.4669
  }, {
    lng: -82.6714,
    lat: 38.4669
  }, {
    lng: -82.6714,
    lat: 38.467
  }, {
    lng: -82.6714,
    lat: 38.4671
  }, {
    lng: -82.6715,
    lat: 38.4673
  }, {
    lng: -82.6715,
    lat: 38.4675
  }, {
    lng: -82.6714,
    lat: 38.4677
  }, {
    lng: -82.6713,
    lat: 38.468
  }, {
    lng: -82.6707,
    lat: 38.4685
  }, {
    lng: -82.6706,
    lat: 38.4686
  }, {
    lng: -82.6706,
    lat: 38.4688
  }, {
    lng: -82.6706,
    lat: 38.4688
  }, {
    lng: -82.6705,
    lat: 38.469
  }, {
    lng: -82.6705,
    lat: 38.4692
  }, {
    lng: -82.6706,
    lat: 38.4695
  }, {
    lng: -82.6706,
    lat: 38.4696
  }, {
    lng: -82.6706,
    lat: 38.4697
  }, {
    lng: -82.6706,
    lat: 38.4699
  }, {
    lng: -82.6707,
    lat: 38.4702
  }, {
    lng: -82.6709,
    lat: 38.4704
  }, {
    lng: -82.6711,
    lat: 38.4705
  }, {
    lng: -82.6712,
    lat: 38.4705
  }, {
    lng: -82.671,
    lat: 38.4713
  }, {
    lng: -82.6706,
    lat: 38.4728
  }, {
    lng: -82.6705,
    lat: 38.4731
  }, {
    lng: -82.6704,
    lat: 38.4732
  }]]],
  options: {
    fillColor: '#f50d0d',
    fillOpacity: 0.4,
    strokeColor: '#BA0808',
    strokeWeight: 1,
    strokeOpacity: 0.4,
    clickable: true,
    visible: true,
    zIndex: 1000
  }
};
var carrierRoute14 = {
  carrierRoute: '41102C014',
  paths: [[[{
    lng: -82.659,
    lat: 38.4653
  }, {
    lng: -82.659,
    lat: 38.4654
  }, {
    lng: -82.659,
    lat: 38.4654
  }, {
    lng: -82.6591,
    lat: 38.4655
  }, {
    lng: -82.6594,
    lat: 38.4654
  }, {
    lng: -82.66,
    lat: 38.4654
  }, {
    lng: -82.66,
    lat: 38.4655
  }, {
    lng: -82.6601,
    lat: 38.4657
  }, {
    lng: -82.6601,
    lat: 38.4657
  }, {
    lng: -82.6601,
    lat: 38.4658
  }, {
    lng: -82.6602,
    lat: 38.4658
  }, {
    lng: -82.6603,
    lat: 38.4658
  }, {
    lng: -82.6603,
    lat: 38.4658
  }, {
    lng: -82.6603,
    lat: 38.4658
  }, {
    lng: -82.6622,
    lat: 38.4655
  }, {
    lng: -82.6622,
    lat: 38.4655
  }, {
    lng: -82.6632,
    lat: 38.4653
  }, {
    lng: -82.6635,
    lat: 38.4653
  }, {
    lng: -82.6636,
    lat: 38.4653
  }, {
    lng: -82.6637,
    lat: 38.4653
  }, {
    lng: -82.6638,
    lat: 38.4652
  }, {
    lng: -82.6643,
    lat: 38.4651
  }, {
    lng: -82.6643,
    lat: 38.4651
  }, {
    lng: -82.6649,
    lat: 38.465
  }, {
    lng: -82.6651,
    lat: 38.4649
  }, {
    lng: -82.6655,
    lat: 38.4648
  }, {
    lng: -82.6655,
    lat: 38.4649
  }, {
    lng: -82.6655,
    lat: 38.4649
  }, {
    lng: -82.6655,
    lat: 38.4649
  }, {
    lng: -82.6655,
    lat: 38.4649
  }, {
    lng: -82.6656,
    lat: 38.465
  }, {
    lng: -82.6658,
    lat: 38.465
  }, {
    lng: -82.6667,
    lat: 38.4653
  }, {
    lng: -82.6668,
    lat: 38.4653
  }, {
    lng: -82.6669,
    lat: 38.4653
  }, {
    lng: -82.667,
    lat: 38.4654
  }, {
    lng: -82.667,
    lat: 38.4655
  }, {
    lng: -82.667,
    lat: 38.4655
  }, {
    lng: -82.6678,
    lat: 38.4656
  }, {
    lng: -82.6686,
    lat: 38.4657
  }, {
    lng: -82.6684,
    lat: 38.4679
  }, {
    lng: -82.6684,
    lat: 38.4679
  }, {
    lng: -82.6684,
    lat: 38.468
  }, {
    lng: -82.6684,
    lat: 38.4681
  }, {
    lng: -82.6684,
    lat: 38.4682
  }, {
    lng: -82.6684,
    lat: 38.4682
  }, {
    lng: -82.6684,
    lat: 38.4683
  }, {
    lng: -82.6684,
    lat: 38.4683
  }, {
    lng: -82.6684,
    lat: 38.4683
  }, {
    lng: -82.6684,
    lat: 38.4684
  }, {
    lng: -82.6686,
    lat: 38.4684
  }, {
    lng: -82.6687,
    lat: 38.4684
  }, {
    lng: -82.6688,
    lat: 38.4684
  }, {
    lng: -82.6688,
    lat: 38.4685
  }, {
    lng: -82.6688,
    lat: 38.4685
  }, {
    lng: -82.6688,
    lat: 38.4686
  }, {
    lng: -82.6688,
    lat: 38.4688
  }, {
    lng: -82.6687,
    lat: 38.4692
  }, {
    lng: -82.6687,
    lat: 38.4698
  }, {
    lng: -82.6687,
    lat: 38.4701
  }, {
    lng: -82.6686,
    lat: 38.4705
  }, {
    lng: -82.6686,
    lat: 38.4711
  }, {
    lng: -82.6685,
    lat: 38.4718
  }, {
    lng: -82.6685,
    lat: 38.472
  }, {
    lng: -82.6685,
    lat: 38.4722
  }, {
    lng: -82.6685,
    lat: 38.4728
  }, {
    lng: -82.6685,
    lat: 38.473
  }, {
    lng: -82.6659,
    lat: 38.4768
  }, {
    lng: -82.6661,
    lat: 38.4768
  }, {
    lng: -82.6662,
    lat: 38.4769
  }, {
    lng: -82.6664,
    lat: 38.477
  }, {
    lng: -82.6666,
    lat: 38.4771
  }, {
    lng: -82.6667,
    lat: 38.4772
  }, {
    lng: -82.6669,
    lat: 38.4773
  }, {
    lng: -82.667,
    lat: 38.4774
  }, {
    lng: -82.6672,
    lat: 38.4775
  }, {
    lng: -82.6672,
    lat: 38.4776
  }, {
    lng: -82.6673,
    lat: 38.4776
  }, {
    lng: -82.6674,
    lat: 38.4778
  }, {
    lng: -82.6675,
    lat: 38.4778
  }, {
    lng: -82.6675,
    lat: 38.4778
  }, {
    lng: -82.6675,
    lat: 38.4779
  }, {
    lng: -82.6675,
    lat: 38.4779
  }, {
    lng: -82.6675,
    lat: 38.4779
  }, {
    lng: -82.6676,
    lat: 38.4782
  }, {
    lng: -82.6677,
    lat: 38.4787
  }, {
    lng: -82.6677,
    lat: 38.4787
  }, {
    lng: -82.6677,
    lat: 38.4788
  }, {
    lng: -82.6678,
    lat: 38.479
  }, {
    lng: -82.6679,
    lat: 38.4791
  }, {
    lng: -82.6686,
    lat: 38.4797
  }, {
    lng: -82.6688,
    lat: 38.4799
  }, {
    lng: -82.6689,
    lat: 38.48
  }, {
    lng: -82.6689,
    lat: 38.48
  }, {
    lng: -82.669,
    lat: 38.4804
  }, {
    lng: -82.669,
    lat: 38.4806
  }, {
    lng: -82.6691,
    lat: 38.4808
  }, {
    lng: -82.6691,
    lat: 38.4808
  }, {
    lng: -82.6692,
    lat: 38.4809
  }, {
    lng: -82.6694,
    lat: 38.4813
  }, {
    lng: -82.6699,
    lat: 38.4819
  }, {
    lng: -82.6702,
    lat: 38.4826
  }, {
    lng: -82.6703,
    lat: 38.4828
  }, {
    lng: -82.6706,
    lat: 38.4833
  }, {
    lng: -82.6711,
    lat: 38.483
  }, {
    lng: -82.6716,
    lat: 38.4828
  }, {
    lng: -82.6718,
    lat: 38.4827
  }, {
    lng: -82.6718,
    lat: 38.4827
  }, {
    lng: -82.672,
    lat: 38.4826
  }, {
    lng: -82.6721,
    lat: 38.4825
  }, {
    lng: -82.6723,
    lat: 38.4822
  }, {
    lng: -82.6725,
    lat: 38.4821
  }, {
    lng: -82.6727,
    lat: 38.4819
  }, {
    lng: -82.6729,
    lat: 38.4816
  }, {
    lng: -82.6733,
    lat: 38.4812
  }, {
    lng: -82.6737,
    lat: 38.4807
  }, {
    lng: -82.6744,
    lat: 38.4811
  }, {
    lng: -82.6747,
    lat: 38.4807
  }, {
    lng: -82.6749,
    lat: 38.4805
  }, {
    lng: -82.6749,
    lat: 38.4804
  }, {
    lng: -82.675,
    lat: 38.4803
  }, {
    lng: -82.6751,
    lat: 38.4803
  }, {
    lng: -82.6751,
    lat: 38.4802
  }, {
    lng: -82.6752,
    lat: 38.4801
  }, {
    lng: -82.6754,
    lat: 38.4799
  }, {
    lng: -82.6755,
    lat: 38.4798
  }, {
    lng: -82.6755,
    lat: 38.4798
  }, {
    lng: -82.6756,
    lat: 38.4798
  }, {
    lng: -82.6756,
    lat: 38.4798
  }, {
    lng: -82.6757,
    lat: 38.4798
  }, {
    lng: -82.6758,
    lat: 38.4799
  }, {
    lng: -82.6761,
    lat: 38.4801
  }, {
    lng: -82.6762,
    lat: 38.4802
  }, {
    lng: -82.6762,
    lat: 38.4803
  }, {
    lng: -82.6766,
    lat: 38.48
  }, {
    lng: -82.6768,
    lat: 38.4798
  }, {
    lng: -82.677,
    lat: 38.4796
  }, {
    lng: -82.677,
    lat: 38.4795
  }, {
    lng: -82.6771,
    lat: 38.4794
  }, {
    lng: -82.6772,
    lat: 38.4792
  }, {
    lng: -82.6775,
    lat: 38.4789
  }, {
    lng: -82.6776,
    lat: 38.4787
  }, {
    lng: -82.678,
    lat: 38.4782
  }, {
    lng: -82.6781,
    lat: 38.478
  }, {
    lng: -82.6787,
    lat: 38.4772
  }, {
    lng: -82.6788,
    lat: 38.4772
  }, {
    lng: -82.6789,
    lat: 38.477
  }, {
    lng: -82.6784,
    lat: 38.4768
  }, {
    lng: -82.6783,
    lat: 38.4767
  }, {
    lng: -82.678,
    lat: 38.4766
  }, {
    lng: -82.6779,
    lat: 38.4766
  }, {
    lng: -82.6766,
    lat: 38.4761
  }, {
    lng: -82.6747,
    lat: 38.4755
  }, {
    lng: -82.6739,
    lat: 38.4752
  }, {
    lng: -82.6735,
    lat: 38.475
  }, {
    lng: -82.6732,
    lat: 38.4749
  }, {
    lng: -82.6729,
    lat: 38.4748
  }, {
    lng: -82.6727,
    lat: 38.4748
  }, {
    lng: -82.6726,
    lat: 38.4747
  }, {
    lng: -82.6726,
    lat: 38.4746
  }, {
    lng: -82.6725,
    lat: 38.4745
  }, {
    lng: -82.6724,
    lat: 38.4744
  }, {
    lng: -82.6723,
    lat: 38.4741
  }, {
    lng: -82.6723,
    lat: 38.474
  }, {
    lng: -82.6723,
    lat: 38.4739
  }, {
    lng: -82.6724,
    lat: 38.4739
  }, {
    lng: -82.6724,
    lat: 38.4738
  }, {
    lng: -82.6725,
    lat: 38.4737
  }, {
    lng: -82.6725,
    lat: 38.4737
  }, {
    lng: -82.6725,
    lat: 38.4736
  }, {
    lng: -82.6726,
    lat: 38.4736
  }, {
    lng: -82.6727,
    lat: 38.4735
  }, {
    lng: -82.6728,
    lat: 38.4734
  }, {
    lng: -82.6728,
    lat: 38.4732
  }, {
    lng: -82.6726,
    lat: 38.4732
  }, {
    lng: -82.6724,
    lat: 38.4733
  }, {
    lng: -82.6723,
    lat: 38.4736
  }, {
    lng: -82.6721,
    lat: 38.4735
  }, {
    lng: -82.6707,
    lat: 38.4732
  }, {
    lng: -82.6704,
    lat: 38.4732
  }, {
    lng: -82.6705,
    lat: 38.4731
  }, {
    lng: -82.6706,
    lat: 38.4728
  }, {
    lng: -82.671,
    lat: 38.4713
  }, {
    lng: -82.6712,
    lat: 38.4705
  }, {
    lng: -82.6711,
    lat: 38.4705
  }, {
    lng: -82.6709,
    lat: 38.4704
  }, {
    lng: -82.6707,
    lat: 38.4702
  }, {
    lng: -82.6706,
    lat: 38.4699
  }, {
    lng: -82.6706,
    lat: 38.4697
  }, {
    lng: -82.6706,
    lat: 38.4696
  }, {
    lng: -82.6706,
    lat: 38.4695
  }, {
    lng: -82.6705,
    lat: 38.4692
  }, {
    lng: -82.6705,
    lat: 38.469
  }, {
    lng: -82.6706,
    lat: 38.4688
  }, {
    lng: -82.6706,
    lat: 38.4688
  }, {
    lng: -82.6706,
    lat: 38.4686
  }, {
    lng: -82.6707,
    lat: 38.4685
  }, {
    lng: -82.6713,
    lat: 38.468
  }, {
    lng: -82.6714,
    lat: 38.4677
  }, {
    lng: -82.6715,
    lat: 38.4675
  }, {
    lng: -82.6715,
    lat: 38.4673
  }, {
    lng: -82.6714,
    lat: 38.4671
  }, {
    lng: -82.6714,
    lat: 38.467
  }, {
    lng: -82.6714,
    lat: 38.4669
  }, {
    lng: -82.671,
    lat: 38.4664
  }, {
    lng: -82.671,
    lat: 38.4663
  }, {
    lng: -82.6709,
    lat: 38.4662
  }, {
    lng: -82.6709,
    lat: 38.4661
  }, {
    lng: -82.6709,
    lat: 38.466
  }, {
    lng: -82.671,
    lat: 38.4657
  }, {
    lng: -82.671,
    lat: 38.4654
  }, {
    lng: -82.671,
    lat: 38.4652
  }, {
    lng: -82.671,
    lat: 38.465
  }, {
    lng: -82.6708,
    lat: 38.4649
  }, {
    lng: -82.6706,
    lat: 38.4648
  }, {
    lng: -82.6707,
    lat: 38.4646
  }, {
    lng: -82.6709,
    lat: 38.4645
  }, {
    lng: -82.671,
    lat: 38.4643
  }, {
    lng: -82.6709,
    lat: 38.4642
  }, {
    lng: -82.6709,
    lat: 38.4641
  }, {
    lng: -82.6708,
    lat: 38.4641
  }, {
    lng: -82.6706,
    lat: 38.464
  }, {
    lng: -82.6705,
    lat: 38.4639
  }, {
    lng: -82.6705,
    lat: 38.4638
  }, {
    lng: -82.6706,
    lat: 38.4637
  }, {
    lng: -82.6706,
    lat: 38.4635
  }, {
    lng: -82.6706,
    lat: 38.4635
  }, {
    lng: -82.6707,
    lat: 38.4632
  }, {
    lng: -82.6707,
    lat: 38.4631
  }, {
    lng: -82.6706,
    lat: 38.4629
  }, {
    lng: -82.6706,
    lat: 38.4628
  }, {
    lng: -82.6706,
    lat: 38.4627
  }, {
    lng: -82.6706,
    lat: 38.4626
  }, {
    lng: -82.6707,
    lat: 38.4626
  }, {
    lng: -82.6707,
    lat: 38.4625
  }, {
    lng: -82.6707,
    lat: 38.4624
  }, {
    lng: -82.671,
    lat: 38.4622
  }, {
    lng: -82.6713,
    lat: 38.4621
  }, {
    lng: -82.6716,
    lat: 38.462
  }, {
    lng: -82.6717,
    lat: 38.4619
  }, {
    lng: -82.6717,
    lat: 38.4618
  }, {
    lng: -82.6719,
    lat: 38.4615
  }, {
    lng: -82.6722,
    lat: 38.4613
  }, {
    lng: -82.6727,
    lat: 38.4611
  }, {
    lng: -82.6731,
    lat: 38.461
  }, {
    lng: -82.6736,
    lat: 38.461
  }, {
    lng: -82.6741,
    lat: 38.461
  }, {
    lng: -82.6746,
    lat: 38.4608
  }, {
    lng: -82.675,
    lat: 38.4605
  }, {
    lng: -82.6754,
    lat: 38.4601
  }, {
    lng: -82.6756,
    lat: 38.4597
  }, {
    lng: -82.6757,
    lat: 38.4596
  }, {
    lng: -82.676,
    lat: 38.4592
  }, {
    lng: -82.6761,
    lat: 38.4591
  }, {
    lng: -82.6762,
    lat: 38.459
  }, {
    lng: -82.6763,
    lat: 38.4586
  }, {
    lng: -82.6762,
    lat: 38.4584
  }, {
    lng: -82.6762,
    lat: 38.4582
  }, {
    lng: -82.6764,
    lat: 38.4579
  }, {
    lng: -82.6764,
    lat: 38.4578
  }, {
    lng: -82.6765,
    lat: 38.4578
  }, {
    lng: -82.6766,
    lat: 38.4577
  }, {
    lng: -82.6765,
    lat: 38.4574
  }, {
    lng: -82.6766,
    lat: 38.4571
  }, {
    lng: -82.6766,
    lat: 38.4566
  }, {
    lng: -82.6766,
    lat: 38.4562
  }, {
    lng: -82.6766,
    lat: 38.456
  }, {
    lng: -82.6766,
    lat: 38.4559
  }, {
    lng: -82.6766,
    lat: 38.4558
  }, {
    lng: -82.6766,
    lat: 38.4557
  }, {
    lng: -82.6766,
    lat: 38.4556
  }, {
    lng: -82.6766,
    lat: 38.4555
  }, {
    lng: -82.6765,
    lat: 38.4554
  }, {
    lng: -82.6765,
    lat: 38.4553
  }, {
    lng: -82.6765,
    lat: 38.4553
  }, {
    lng: -82.6764,
    lat: 38.4552
  }, {
    lng: -82.6764,
    lat: 38.4552
  }, {
    lng: -82.6762,
    lat: 38.455
  }, {
    lng: -82.6758,
    lat: 38.4547
  }, {
    lng: -82.6756,
    lat: 38.4545
  }, {
    lng: -82.6754,
    lat: 38.4544
  }, {
    lng: -82.675,
    lat: 38.4542
  }, {
    lng: -82.6749,
    lat: 38.4542
  }, {
    lng: -82.6748,
    lat: 38.4541
  }, {
    lng: -82.6746,
    lat: 38.4539
  }, {
    lng: -82.6745,
    lat: 38.4539
  }, {
    lng: -82.6744,
    lat: 38.4538
  }, {
    lng: -82.6743,
    lat: 38.4537
  }, {
    lng: -82.6741,
    lat: 38.4536
  }, {
    lng: -82.674,
    lat: 38.4534
  }, {
    lng: -82.6738,
    lat: 38.4532
  }, {
    lng: -82.6735,
    lat: 38.4534
  }, {
    lng: -82.6728,
    lat: 38.4539
  }, {
    lng: -82.6725,
    lat: 38.4539
  }, {
    lng: -82.6723,
    lat: 38.454
  }, {
    lng: -82.6719,
    lat: 38.4542
  }, {
    lng: -82.6718,
    lat: 38.4542
  }, {
    lng: -82.6711,
    lat: 38.4547
  }, {
    lng: -82.6694,
    lat: 38.4557
  }, {
    lng: -82.6688,
    lat: 38.4561
  }, {
    lng: -82.6686,
    lat: 38.456
  }, {
    lng: -82.6676,
    lat: 38.4552
  }, {
    lng: -82.6667,
    lat: 38.4546
  }, {
    lng: -82.6666,
    lat: 38.4548
  }, {
    lng: -82.6665,
    lat: 38.4549
  }, {
    lng: -82.6664,
    lat: 38.4551
  }, {
    lng: -82.6664,
    lat: 38.4552
  }, {
    lng: -82.6663,
    lat: 38.4553
  }, {
    lng: -82.6661,
    lat: 38.4558
  }, {
    lng: -82.666,
    lat: 38.456
  }, {
    lng: -82.666,
    lat: 38.4562
  }, {
    lng: -82.666,
    lat: 38.4563
  }, {
    lng: -82.666,
    lat: 38.4564
  }, {
    lng: -82.666,
    lat: 38.4565
  }, {
    lng: -82.6661,
    lat: 38.4566
  }, {
    lng: -82.6661,
    lat: 38.4566
  }, {
    lng: -82.6658,
    lat: 38.4569
  }, {
    lng: -82.6657,
    lat: 38.4571
  }, {
    lng: -82.6669,
    lat: 38.4577
  }, {
    lng: -82.6668,
    lat: 38.4577
  }, {
    lng: -82.6666,
    lat: 38.458
  }, {
    lng: -82.6666,
    lat: 38.458
  }, {
    lng: -82.6665,
    lat: 38.4581
  }, {
    lng: -82.6662,
    lat: 38.4584
  }, {
    lng: -82.6656,
    lat: 38.4588
  }, {
    lng: -82.6655,
    lat: 38.4589
  }, {
    lng: -82.6648,
    lat: 38.4593
  }, {
    lng: -82.6647,
    lat: 38.4594
  }, {
    lng: -82.6646,
    lat: 38.4594
  }, {
    lng: -82.6645,
    lat: 38.4595
  }, {
    lng: -82.6642,
    lat: 38.4598
  }, {
    lng: -82.6641,
    lat: 38.4599
  }, {
    lng: -82.664,
    lat: 38.46
  }, {
    lng: -82.6639,
    lat: 38.4602
  }, {
    lng: -82.6639,
    lat: 38.4602
  }, {
    lng: -82.6637,
    lat: 38.4606
  }, {
    lng: -82.6636,
    lat: 38.461
  }, {
    lng: -82.6633,
    lat: 38.4614
  }, {
    lng: -82.6633,
    lat: 38.4615
  }, {
    lng: -82.6632,
    lat: 38.4616
  }, {
    lng: -82.6627,
    lat: 38.4621
  }, {
    lng: -82.6626,
    lat: 38.4623
  }, {
    lng: -82.6622,
    lat: 38.4629
  }, {
    lng: -82.662,
    lat: 38.4628
  }, {
    lng: -82.6618,
    lat: 38.4628
  }, {
    lng: -82.6617,
    lat: 38.4628
  }, {
    lng: -82.6617,
    lat: 38.4628
  }, {
    lng: -82.6617,
    lat: 38.4628
  }, {
    lng: -82.6616,
    lat: 38.4628
  }, {
    lng: -82.6616,
    lat: 38.4628
  }, {
    lng: -82.6613,
    lat: 38.4629
  }, {
    lng: -82.6612,
    lat: 38.4629
  }, {
    lng: -82.6612,
    lat: 38.4629
  }, {
    lng: -82.6611,
    lat: 38.4629
  }, {
    lng: -82.6609,
    lat: 38.463
  }, {
    lng: -82.6608,
    lat: 38.463
  }, {
    lng: -82.6607,
    lat: 38.463
  }, {
    lng: -82.6598,
    lat: 38.4631
  }, {
    lng: -82.6598,
    lat: 38.4631
  }, {
    lng: -82.6595,
    lat: 38.4632
  }, {
    lng: -82.6595,
    lat: 38.464
  }, {
    lng: -82.6595,
    lat: 38.464
  }, {
    lng: -82.6595,
    lat: 38.4641
  }, {
    lng: -82.6595,
    lat: 38.4643
  }, {
    lng: -82.6596,
    lat: 38.4644
  }, {
    lng: -82.6596,
    lat: 38.4646
  }, {
    lng: -82.6597,
    lat: 38.4648
  }, {
    lng: -82.6597,
    lat: 38.4648
  }, {
    lng: -82.6594,
    lat: 38.4649
  }, {
    lng: -82.6593,
    lat: 38.465
  }, {
    lng: -82.6591,
    lat: 38.4652
  }, {
    lng: -82.6591,
    lat: 38.4653
  }, {
    lng: -82.659,
    lat: 38.4653
  }]]],
  options: {
    fillColor: '#f50d0d',
    fillOpacity: 0.4,
    strokeColor: '#BA0808',
    strokeWeight: 1,
    strokeOpacity: 0.4,
    clickable: true,
    visible: true,
    zIndex: 1000
  }
};
var carrierRoute15 = {
  carrierRoute: '41101C016',
  paths: [[[{
    lng: -82.6729,
    lat: 38.4949
  }, {
    lng: -82.6813,
    lat: 38.4909
  }, {
    lng: -82.6828,
    lat: 38.4892
  }, {
    lng: -82.6832,
    lat: 38.4886
  }, {
    lng: -82.6834,
    lat: 38.4883
  }, {
    lng: -82.6835,
    lat: 38.4882
  }, {
    lng: -82.6835,
    lat: 38.4882
  }, {
    lng: -82.6837,
    lat: 38.4882
  }, {
    lng: -82.6837,
    lat: 38.4882
  }, {
    lng: -82.6838,
    lat: 38.4882
  }, {
    lng: -82.6839,
    lat: 38.4882
  }, {
    lng: -82.6841,
    lat: 38.4883
  }, {
    lng: -82.6843,
    lat: 38.4885
  }, {
    lng: -82.6847,
    lat: 38.4887
  }, {
    lng: -82.6847,
    lat: 38.4887
  }, {
    lng: -82.685,
    lat: 38.489
  }, {
    lng: -82.6851,
    lat: 38.4892
  }, {
    lng: -82.6852,
    lat: 38.4892
  }, {
    lng: -82.6854,
    lat: 38.4893
  }, {
    lng: -82.6858,
    lat: 38.4894
  }, {
    lng: -82.6861,
    lat: 38.4894
  }, {
    lng: -82.6863,
    lat: 38.4895
  }, {
    lng: -82.6864,
    lat: 38.4895
  }, {
    lng: -82.6865,
    lat: 38.4895
  }, {
    lng: -82.6868,
    lat: 38.4896
  }, {
    lng: -82.687,
    lat: 38.4896
  }, {
    lng: -82.6872,
    lat: 38.4895
  }, {
    lng: -82.6873,
    lat: 38.4895
  }, {
    lng: -82.6874,
    lat: 38.4895
  }, {
    lng: -82.6877,
    lat: 38.4895
  }, {
    lng: -82.6878,
    lat: 38.4895
  }, {
    lng: -82.6878,
    lat: 38.4895
  }, {
    lng: -82.6879,
    lat: 38.4894
  }, {
    lng: -82.6879,
    lat: 38.4893
  }, {
    lng: -82.688,
    lat: 38.4892
  }, {
    lng: -82.688,
    lat: 38.4892
  }, {
    lng: -82.6881,
    lat: 38.4892
  }, {
    lng: -82.6885,
    lat: 38.4893
  }, {
    lng: -82.6889,
    lat: 38.4894
  }, {
    lng: -82.6892,
    lat: 38.4892
  }, {
    lng: -82.6895,
    lat: 38.489
  }, {
    lng: -82.6894,
    lat: 38.4891
  }, {
    lng: -82.6893,
    lat: 38.4894
  }, {
    lng: -82.6893,
    lat: 38.4895
  }, {
    lng: -82.6892,
    lat: 38.4898
  }, {
    lng: -82.6887,
    lat: 38.491
  }, {
    lng: -82.6887,
    lat: 38.4911
  }, {
    lng: -82.6886,
    lat: 38.4913
  }, {
    lng: -82.6885,
    lat: 38.4914
  }, {
    lng: -82.6885,
    lat: 38.4915
  }, {
    lng: -82.6884,
    lat: 38.4916
  }, {
    lng: -82.6884,
    lat: 38.4916
  }, {
    lng: -82.6882,
    lat: 38.4919
  }, {
    lng: -82.688,
    lat: 38.4921
  }, {
    lng: -82.6877,
    lat: 38.4923
  }, {
    lng: -82.6875,
    lat: 38.4924
  }, {
    lng: -82.6874,
    lat: 38.4925
  }, {
    lng: -82.6869,
    lat: 38.4928
  }, {
    lng: -82.6864,
    lat: 38.493
  }, {
    lng: -82.6861,
    lat: 38.4932
  }, {
    lng: -82.686,
    lat: 38.4932
  }, {
    lng: -82.6857,
    lat: 38.4934
  }, {
    lng: -82.6854,
    lat: 38.4934
  }, {
    lng: -82.6852,
    lat: 38.4935
  }, {
    lng: -82.6851,
    lat: 38.4935
  }, {
    lng: -82.6849,
    lat: 38.4935
  }, {
    lng: -82.6848,
    lat: 38.4935
  }, {
    lng: -82.6844,
    lat: 38.4936
  }, {
    lng: -82.6842,
    lat: 38.4936
  }, {
    lng: -82.6841,
    lat: 38.4937
  }, {
    lng: -82.6839,
    lat: 38.4938
  }, {
    lng: -82.6837,
    lat: 38.494
  }, {
    lng: -82.6835,
    lat: 38.4941
  }, {
    lng: -82.6834,
    lat: 38.4943
  }, {
    lng: -82.683,
    lat: 38.4946
  }, {
    lng: -82.6828,
    lat: 38.4951
  }, {
    lng: -82.6827,
    lat: 38.4953
  }, {
    lng: -82.6827,
    lat: 38.4954
  }, {
    lng: -82.6826,
    lat: 38.4954
  }, {
    lng: -82.6825,
    lat: 38.4955
  }, {
    lng: -82.6823,
    lat: 38.4956
  }, {
    lng: -82.6823,
    lat: 38.4981
  }, {
    lng: -82.6822,
    lat: 38.4987
  }, {
    lng: -82.6822,
    lat: 38.4987
  }, {
    lng: -82.6822,
    lat: 38.4988
  }, {
    lng: -82.6822,
    lat: 38.4988
  }, {
    lng: -82.6823,
    lat: 38.4988
  }, {
    lng: -82.6824,
    lat: 38.4989
  }, {
    lng: -82.6826,
    lat: 38.4989
  }, {
    lng: -82.6827,
    lat: 38.499
  }, {
    lng: -82.6828,
    lat: 38.499
  }, {
    lng: -82.6828,
    lat: 38.4992
  }, {
    lng: -82.6829,
    lat: 38.4999
  }, {
    lng: -82.6828,
    lat: 38.5014
  }, {
    lng: -82.6841,
    lat: 38.5028
  }, {
    lng: -82.6843,
    lat: 38.503
  }, {
    lng: -82.6854,
    lat: 38.5025
  }, {
    lng: -82.6892,
    lat: 38.5037
  }, {
    lng: -82.6894,
    lat: 38.5035
  }, {
    lng: -82.6895,
    lat: 38.5034
  }, {
    lng: -82.6894,
    lat: 38.5032
  }, {
    lng: -82.6892,
    lat: 38.5031
  }, {
    lng: -82.6893,
    lat: 38.503
  }, {
    lng: -82.6894,
    lat: 38.5029
  }, {
    lng: -82.6894,
    lat: 38.5029
  }, {
    lng: -82.6894,
    lat: 38.5028
  }, {
    lng: -82.6893,
    lat: 38.5027
  }, {
    lng: -82.6892,
    lat: 38.5026
  }, {
    lng: -82.6896,
    lat: 38.5025
  }, {
    lng: -82.6901,
    lat: 38.5026
  }, {
    lng: -82.6902,
    lat: 38.5028
  }, {
    lng: -82.6904,
    lat: 38.5029
  }, {
    lng: -82.6909,
    lat: 38.503
  }, {
    lng: -82.6912,
    lat: 38.5031
  }, {
    lng: -82.6912,
    lat: 38.5031
  }, {
    lng: -82.6913,
    lat: 38.5032
  }, {
    lng: -82.6916,
    lat: 38.5033
  }, {
    lng: -82.692,
    lat: 38.5033
  }, {
    lng: -82.6924,
    lat: 38.5032
  }, {
    lng: -82.6926,
    lat: 38.5032
  }, {
    lng: -82.6927,
    lat: 38.5031
  }, {
    lng: -82.693,
    lat: 38.503
  }, {
    lng: -82.6931,
    lat: 38.503
  }, {
    lng: -82.6932,
    lat: 38.5028
  }, {
    lng: -82.6938,
    lat: 38.5022
  }, {
    lng: -82.694,
    lat: 38.502
  }, {
    lng: -82.6941,
    lat: 38.5019
  }, {
    lng: -82.6945,
    lat: 38.5018
  }, {
    lng: -82.6949,
    lat: 38.5016
  }, {
    lng: -82.6951,
    lat: 38.5016
  }, {
    lng: -82.695,
    lat: 38.5017
  }, {
    lng: -82.6945,
    lat: 38.5021
  }, {
    lng: -82.6941,
    lat: 38.5024
  }, {
    lng: -82.694,
    lat: 38.5025
  }, {
    lng: -82.6938,
    lat: 38.5026
  }, {
    lng: -82.6938,
    lat: 38.5026
  }, {
    lng: -82.6937,
    lat: 38.5027
  }, {
    lng: -82.6937,
    lat: 38.5028
  }, {
    lng: -82.6937,
    lat: 38.5029
  }, {
    lng: -82.6937,
    lat: 38.503
  }, {
    lng: -82.6937,
    lat: 38.5031
  }, {
    lng: -82.6937,
    lat: 38.5032
  }, {
    lng: -82.6938,
    lat: 38.5034
  }, {
    lng: -82.6939,
    lat: 38.5035
  }, {
    lng: -82.6942,
    lat: 38.5037
  }, {
    lng: -82.6949,
    lat: 38.5041
  }, {
    lng: -82.6958,
    lat: 38.5044
  }, {
    lng: -82.6965,
    lat: 38.5034
  }, {
    lng: -82.697,
    lat: 38.5025
  }, {
    lng: -82.6971,
    lat: 38.5021
  }, {
    lng: -82.6981,
    lat: 38.5021
  }, {
    lng: -82.698,
    lat: 38.5022
  }, {
    lng: -82.698,
    lat: 38.5023
  }, {
    lng: -82.698,
    lat: 38.5024
  }, {
    lng: -82.698,
    lat: 38.5026
  }, {
    lng: -82.698,
    lat: 38.5027
  }, {
    lng: -82.6981,
    lat: 38.503
  }, {
    lng: -82.6981,
    lat: 38.5032
  }, {
    lng: -82.6982,
    lat: 38.5034
  }, {
    lng: -82.6983,
    lat: 38.5035
  }, {
    lng: -82.6984,
    lat: 38.5037
  }, {
    lng: -82.6985,
    lat: 38.5038
  }, {
    lng: -82.6985,
    lat: 38.504
  }, {
    lng: -82.6985,
    lat: 38.5041
  }, {
    lng: -82.6985,
    lat: 38.5044
  }, {
    lng: -82.6985,
    lat: 38.5047
  }, {
    lng: -82.6984,
    lat: 38.505
  }, {
    lng: -82.6983,
    lat: 38.5053
  }, {
    lng: -82.699,
    lat: 38.5054
  }, {
    lng: -82.6995,
    lat: 38.5054
  }, {
    lng: -82.6998,
    lat: 38.5053
  }, {
    lng: -82.6999,
    lat: 38.5053
  }, {
    lng: -82.7002,
    lat: 38.5053
  }, {
    lng: -82.7003,
    lat: 38.5053
  }, {
    lng: -82.7007,
    lat: 38.5051
  }, {
    lng: -82.7009,
    lat: 38.5051
  }, {
    lng: -82.7012,
    lat: 38.5049
  }, {
    lng: -82.7029,
    lat: 38.5037
  }, {
    lng: -82.7036,
    lat: 38.5032
  }, {
    lng: -82.7042,
    lat: 38.5028
  }, {
    lng: -82.7043,
    lat: 38.5027
  }, {
    lng: -82.7048,
    lat: 38.5023
  }, {
    lng: -82.705,
    lat: 38.5022
  }, {
    lng: -82.7052,
    lat: 38.5021
  }, {
    lng: -82.7055,
    lat: 38.5018
  }, {
    lng: -82.7056,
    lat: 38.5017
  }, {
    lng: -82.7058,
    lat: 38.5016
  }, {
    lng: -82.7062,
    lat: 38.5012
  }, {
    lng: -82.7065,
    lat: 38.501
  }, {
    lng: -82.7069,
    lat: 38.5007
  }, {
    lng: -82.7071,
    lat: 38.5005
  }, {
    lng: -82.7074,
    lat: 38.5004
  }, {
    lng: -82.7076,
    lat: 38.5003
  }, {
    lng: -82.7078,
    lat: 38.5002
  }, {
    lng: -82.7078,
    lat: 38.5002
  }, {
    lng: -82.7082,
    lat: 38.5
  }, {
    lng: -82.7084,
    lat: 38.5
  }, {
    lng: -82.7086,
    lat: 38.4999
  }, {
    lng: -82.7087,
    lat: 38.4999
  }, {
    lng: -82.7088,
    lat: 38.4999
  }, {
    lng: -82.709,
    lat: 38.4999
  }, {
    lng: -82.7099,
    lat: 38.5001
  }, {
    lng: -82.7106,
    lat: 38.5001
  }, {
    lng: -82.7109,
    lat: 38.5001
  }, {
    lng: -82.7123,
    lat: 38.5002
  }, {
    lng: -82.7125,
    lat: 38.5002
  }, {
    lng: -82.7131,
    lat: 38.5002
  }, {
    lng: -82.7137,
    lat: 38.5002
  }, {
    lng: -82.7138,
    lat: 38.5001
  }, {
    lng: -82.714,
    lat: 38.5001
  }, {
    lng: -82.7141,
    lat: 38.5001
  }, {
    lng: -82.7142,
    lat: 38.5001
  }, {
    lng: -82.7143,
    lat: 38.5
  }, {
    lng: -82.7146,
    lat: 38.4999
  }, {
    lng: -82.7148,
    lat: 38.4999
  }, {
    lng: -82.7148,
    lat: 38.4998
  }, {
    lng: -82.7149,
    lat: 38.4998
  }, {
    lng: -82.7151,
    lat: 38.4997
  }, {
    lng: -82.7151,
    lat: 38.4996
  }, {
    lng: -82.7154,
    lat: 38.4994
  }, {
    lng: -82.7157,
    lat: 38.4992
  }, {
    lng: -82.7158,
    lat: 38.499
  }, {
    lng: -82.7154,
    lat: 38.4986
  }, {
    lng: -82.7154,
    lat: 38.4986
  }, {
    lng: -82.7151,
    lat: 38.4982
  }, {
    lng: -82.7147,
    lat: 38.4978
  }, {
    lng: -82.7139,
    lat: 38.4974
  }, {
    lng: -82.7127,
    lat: 38.4972
  }, {
    lng: -82.712,
    lat: 38.4971
  }, {
    lng: -82.7111,
    lat: 38.497
  }, {
    lng: -82.7098,
    lat: 38.4968
  }, {
    lng: -82.7085,
    lat: 38.4966
  }, {
    lng: -82.7076,
    lat: 38.4963
  }, {
    lng: -82.7066,
    lat: 38.4959
  }, {
    lng: -82.706,
    lat: 38.4956
  }, {
    lng: -82.7057,
    lat: 38.4954
  }, {
    lng: -82.7055,
    lat: 38.4954
  }, {
    lng: -82.702,
    lat: 38.4926
  }, {
    lng: -82.6961,
    lat: 38.4874
  }, {
    lng: -82.6943,
    lat: 38.4857
  }, {
    lng: -82.6951,
    lat: 38.4852
  }, {
    lng: -82.6949,
    lat: 38.485
  }, {
    lng: -82.6949,
    lat: 38.485
  }, {
    lng: -82.6948,
    lat: 38.4848
  }, {
    lng: -82.6948,
    lat: 38.4847
  }, {
    lng: -82.6948,
    lat: 38.4847
  }, {
    lng: -82.6948,
    lat: 38.4843
  }, {
    lng: -82.6947,
    lat: 38.4841
  }, {
    lng: -82.6946,
    lat: 38.4838
  }, {
    lng: -82.6946,
    lat: 38.4837
  }, {
    lng: -82.6944,
    lat: 38.4837
  }, {
    lng: -82.6943,
    lat: 38.4837
  }, {
    lng: -82.6939,
    lat: 38.4838
  }, {
    lng: -82.6938,
    lat: 38.4838
  }, {
    lng: -82.6936,
    lat: 38.4838
  }, {
    lng: -82.6931,
    lat: 38.4837
  }, {
    lng: -82.6927,
    lat: 38.4837
  }, {
    lng: -82.6923,
    lat: 38.4836
  }, {
    lng: -82.6922,
    lat: 38.4836
  }, {
    lng: -82.6916,
    lat: 38.4835
  }, {
    lng: -82.6912,
    lat: 38.4835
  }, {
    lng: -82.6911,
    lat: 38.4835
  }, {
    lng: -82.691,
    lat: 38.4835
  }, {
    lng: -82.6909,
    lat: 38.4836
  }, {
    lng: -82.6908,
    lat: 38.4836
  }, {
    lng: -82.6906,
    lat: 38.4837
  }, {
    lng: -82.6904,
    lat: 38.4838
  }, {
    lng: -82.6903,
    lat: 38.4839
  }, {
    lng: -82.6902,
    lat: 38.4839
  }, {
    lng: -82.6901,
    lat: 38.4838
  }, {
    lng: -82.69,
    lat: 38.4838
  }, {
    lng: -82.6899,
    lat: 38.4837
  }, {
    lng: -82.6899,
    lat: 38.4836
  }, {
    lng: -82.6898,
    lat: 38.4836
  }, {
    lng: -82.6897,
    lat: 38.4834
  }, {
    lng: -82.6893,
    lat: 38.4829
  }, {
    lng: -82.6889,
    lat: 38.4825
  }, {
    lng: -82.6887,
    lat: 38.4821
  }, {
    lng: -82.6885,
    lat: 38.4819
  }, {
    lng: -82.6884,
    lat: 38.4817
  }, {
    lng: -82.6882,
    lat: 38.4814
  }, {
    lng: -82.6882,
    lat: 38.4813
  }, {
    lng: -82.688,
    lat: 38.481
  }, {
    lng: -82.6879,
    lat: 38.4809
  }, {
    lng: -82.6876,
    lat: 38.4809
  }, {
    lng: -82.6874,
    lat: 38.4808
  }, {
    lng: -82.6872,
    lat: 38.4808
  }, {
    lng: -82.6871,
    lat: 38.4808
  }, {
    lng: -82.687,
    lat: 38.4808
  }, {
    lng: -82.6866,
    lat: 38.481
  }, {
    lng: -82.6866,
    lat: 38.481
  }, {
    lng: -82.686,
    lat: 38.4806
  }, {
    lng: -82.6849,
    lat: 38.482
  }, {
    lng: -82.6849,
    lat: 38.482
  }, {
    lng: -82.685,
    lat: 38.482
  }, {
    lng: -82.6851,
    lat: 38.4821
  }, {
    lng: -82.6851,
    lat: 38.4822
  }, {
    lng: -82.6851,
    lat: 38.4825
  }, {
    lng: -82.685,
    lat: 38.4826
  }, {
    lng: -82.6849,
    lat: 38.4827
  }, {
    lng: -82.6848,
    lat: 38.4828
  }, {
    lng: -82.6848,
    lat: 38.4829
  }, {
    lng: -82.6847,
    lat: 38.4831
  }, {
    lng: -82.6845,
    lat: 38.4832
  }, {
    lng: -82.6845,
    lat: 38.4832
  }, {
    lng: -82.6845,
    lat: 38.4832
  }, {
    lng: -82.6843,
    lat: 38.4835
  }, {
    lng: -82.6843,
    lat: 38.4835
  }, {
    lng: -82.6843,
    lat: 38.4836
  }, {
    lng: -82.6843,
    lat: 38.4837
  }, {
    lng: -82.6841,
    lat: 38.4838
  }, {
    lng: -82.684,
    lat: 38.484
  }, {
    lng: -82.6837,
    lat: 38.4842
  }, {
    lng: -82.6834,
    lat: 38.4843
  }, {
    lng: -82.6832,
    lat: 38.4844
  }, {
    lng: -82.6829,
    lat: 38.4844
  }, {
    lng: -82.6827,
    lat: 38.4844
  }, {
    lng: -82.6823,
    lat: 38.4845
  }, {
    lng: -82.682,
    lat: 38.4847
  }, {
    lng: -82.6816,
    lat: 38.4849
  }, {
    lng: -82.6815,
    lat: 38.485
  }, {
    lng: -82.6815,
    lat: 38.4851
  }, {
    lng: -82.6813,
    lat: 38.4853
  }, {
    lng: -82.681,
    lat: 38.4856
  }, {
    lng: -82.6808,
    lat: 38.4857
  }, {
    lng: -82.6807,
    lat: 38.4859
  }, {
    lng: -82.6807,
    lat: 38.4861
  }, {
    lng: -82.6807,
    lat: 38.4862
  }, {
    lng: -82.6808,
    lat: 38.4863
  }, {
    lng: -82.681,
    lat: 38.4865
  }, {
    lng: -82.6814,
    lat: 38.4867
  }, {
    lng: -82.6815,
    lat: 38.487
  }, {
    lng: -82.6815,
    lat: 38.4871
  }, {
    lng: -82.6815,
    lat: 38.4875
  }, {
    lng: -82.6815,
    lat: 38.4876
  }, {
    lng: -82.6816,
    lat: 38.4878
  }, {
    lng: -82.6817,
    lat: 38.4879
  }, {
    lng: -82.6817,
    lat: 38.4882
  }, {
    lng: -82.6817,
    lat: 38.4883
  }, {
    lng: -82.6816,
    lat: 38.4886
  }, {
    lng: -82.6816,
    lat: 38.4887
  }, {
    lng: -82.6816,
    lat: 38.4887
  }, {
    lng: -82.6815,
    lat: 38.4888
  }, {
    lng: -82.6811,
    lat: 38.4888
  }, {
    lng: -82.6807,
    lat: 38.4888
  }, {
    lng: -82.6801,
    lat: 38.4887
  }, {
    lng: -82.6795,
    lat: 38.4885
  }, {
    lng: -82.679,
    lat: 38.4884
  }, {
    lng: -82.6784,
    lat: 38.4882
  }, {
    lng: -82.6782,
    lat: 38.4882
  }, {
    lng: -82.6778,
    lat: 38.4882
  }, {
    lng: -82.6779,
    lat: 38.4884
  }, {
    lng: -82.6781,
    lat: 38.4886
  }, {
    lng: -82.6781,
    lat: 38.4889
  }, {
    lng: -82.678,
    lat: 38.4891
  }, {
    lng: -82.6779,
    lat: 38.4894
  }, {
    lng: -82.6778,
    lat: 38.4895
  }, {
    lng: -82.6778,
    lat: 38.4897
  }, {
    lng: -82.6776,
    lat: 38.4899
  }, {
    lng: -82.6776,
    lat: 38.4902
  }, {
    lng: -82.6775,
    lat: 38.4905
  }, {
    lng: -82.6773,
    lat: 38.4908
  }, {
    lng: -82.677,
    lat: 38.4907
  }, {
    lng: -82.6769,
    lat: 38.4907
  }, {
    lng: -82.6769,
    lat: 38.4907
  }, {
    lng: -82.6767,
    lat: 38.4906
  }, {
    lng: -82.6766,
    lat: 38.4904
  }, {
    lng: -82.6766,
    lat: 38.4903
  }, {
    lng: -82.6764,
    lat: 38.4902
  }, {
    lng: -82.6762,
    lat: 38.4899
  }, {
    lng: -82.6761,
    lat: 38.4896
  }, {
    lng: -82.676,
    lat: 38.4894
  }, {
    lng: -82.6757,
    lat: 38.4894
  }, {
    lng: -82.6756,
    lat: 38.4895
  }, {
    lng: -82.6753,
    lat: 38.4897
  }, {
    lng: -82.6751,
    lat: 38.4897
  }, {
    lng: -82.6747,
    lat: 38.4898
  }, {
    lng: -82.6746,
    lat: 38.4899
  }, {
    lng: -82.6744,
    lat: 38.4902
  }, {
    lng: -82.6743,
    lat: 38.4904
  }, {
    lng: -82.6743,
    lat: 38.4908
  }, {
    lng: -82.6742,
    lat: 38.4912
  }, {
    lng: -82.6741,
    lat: 38.4915
  }, {
    lng: -82.674,
    lat: 38.4919
  }, {
    lng: -82.6737,
    lat: 38.4921
  }, {
    lng: -82.6734,
    lat: 38.4924
  }, {
    lng: -82.6734,
    lat: 38.4925
  }, {
    lng: -82.6734,
    lat: 38.4927
  }, {
    lng: -82.6734,
    lat: 38.4927
  }, {
    lng: -82.6734,
    lat: 38.4927
  }, {
    lng: -82.6734,
    lat: 38.4928
  }, {
    lng: -82.6736,
    lat: 38.493
  }, {
    lng: -82.6737,
    lat: 38.4932
  }, {
    lng: -82.6738,
    lat: 38.4934
  }, {
    lng: -82.6738,
    lat: 38.4934
  }, {
    lng: -82.6739,
    lat: 38.4936
  }, {
    lng: -82.6738,
    lat: 38.4938
  }, {
    lng: -82.6737,
    lat: 38.494
  }, {
    lng: -82.6734,
    lat: 38.4943
  }, {
    lng: -82.6733,
    lat: 38.4944
  }, {
    lng: -82.6731,
    lat: 38.4946
  }, {
    lng: -82.6729,
    lat: 38.4949
  }]]],
  options: {
    fillColor: '#f50d0d',
    fillOpacity: 0.4,
    strokeColor: '#BA0808',
    strokeWeight: 1,
    strokeOpacity: 0.4,
    clickable: true,
    visible: true,
    zIndex: 1000
  }
};
var carrierRoute16 = {
  "carrierRoute": "41101C003",
  "paths": [[[{
    "lng": -82.6524,
    "lat": 38.4877
  }, {
    "lng": -82.6534,
    "lat": 38.4887
  }, {
    "lng": -82.6545,
    "lat": 38.4896
  }, {
    "lng": -82.6544,
    "lat": 38.4898
  }, {
    "lng": -82.6543,
    "lat": 38.4898
  }, {
    "lng": -82.6542,
    "lat": 38.4899
  }, {
    "lng": -82.6534,
    "lat": 38.4901
  }, {
    "lng": -82.6537,
    "lat": 38.4902
  }, {
    "lng": -82.6546,
    "lat": 38.4906
  }, {
    "lng": -82.6549,
    "lat": 38.4906
  }, {
    "lng": -82.655,
    "lat": 38.4907
  }, {
    "lng": -82.6555,
    "lat": 38.491
  }, {
    "lng": -82.6558,
    "lat": 38.4913
  }, {
    "lng": -82.6561,
    "lat": 38.4915
  }, {
    "lng": -82.6565,
    "lat": 38.4918
  }, {
    "lng": -82.657,
    "lat": 38.4923
  }, {
    "lng": -82.6578,
    "lat": 38.4929
  }, {
    "lng": -82.6583,
    "lat": 38.4933
  }, {
    "lng": -82.6589,
    "lat": 38.4938
  }, {
    "lng": -82.6593,
    "lat": 38.494
  }, {
    "lng": -82.6593,
    "lat": 38.4941
  }, {
    "lng": -82.6595,
    "lat": 38.4942
  }, {
    "lng": -82.6597,
    "lat": 38.4943
  }, {
    "lng": -82.6597,
    "lat": 38.4943
  }, {
    "lng": -82.6599,
    "lat": 38.4945
  }, {
    "lng": -82.6604,
    "lat": 38.495
  }, {
    "lng": -82.6609,
    "lat": 38.4955
  }, {
    "lng": -82.6615,
    "lat": 38.4961
  }, {
    "lng": -82.6621,
    "lat": 38.4968
  }, {
    "lng": -82.6628,
    "lat": 38.4976
  }, {
    "lng": -82.6633,
    "lat": 38.4983
  }, {
    "lng": -82.6634,
    "lat": 38.4984
  }, {
    "lng": -82.6635,
    "lat": 38.4984
  }, {
    "lng": -82.6635,
    "lat": 38.4985
  }, {
    "lng": -82.6636,
    "lat": 38.4986
  }, {
    "lng": -82.6637,
    "lat": 38.4987
  }, {
    "lng": -82.6641,
    "lat": 38.499
  }, {
    "lng": -82.6649,
    "lat": 38.4997
  }, {
    "lng": -82.6654,
    "lat": 38.5001
  }, {
    "lng": -82.6661,
    "lat": 38.5007
  }, {
    "lng": -82.6669,
    "lat": 38.5015
  }, {
    "lng": -82.6675,
    "lat": 38.5022
  }, {
    "lng": -82.6681,
    "lat": 38.503
  }, {
    "lng": -82.6685,
    "lat": 38.5037
  }, {
    "lng": -82.6686,
    "lat": 38.5039
  }, {
    "lng": -82.6689,
    "lat": 38.5041
  }, {
    "lng": -82.6693,
    "lat": 38.5044
  }, {
    "lng": -82.6698,
    "lat": 38.505
  }, {
    "lng": -82.6703,
    "lat": 38.5055
  }, {
    "lng": -82.6708,
    "lat": 38.506
  }, {
    "lng": -82.6714,
    "lat": 38.5067
  }, {
    "lng": -82.672,
    "lat": 38.5072
  }, {
    "lng": -82.6721,
    "lat": 38.5074
  }, {
    "lng": -82.6725,
    "lat": 38.5077
  }, {
    "lng": -82.6732,
    "lat": 38.5082
  }, {
    "lng": -82.6733,
    "lat": 38.5083
  }, {
    "lng": -82.674,
    "lat": 38.5088
  }, {
    "lng": -82.6746,
    "lat": 38.5093
  }, {
    "lng": -82.675,
    "lat": 38.5096
  }, {
    "lng": -82.6755,
    "lat": 38.5102
  }, {
    "lng": -82.676,
    "lat": 38.5107
  }, {
    "lng": -82.6766,
    "lat": 38.5112
  }, {
    "lng": -82.6772,
    "lat": 38.5117
  }, {
    "lng": -82.678,
    "lat": 38.5124
  }, {
    "lng": -82.6788,
    "lat": 38.5131
  }, {
    "lng": -82.6795,
    "lat": 38.5138
  }, {
    "lng": -82.6801,
    "lat": 38.5145
  }, {
    "lng": -82.6806,
    "lat": 38.5151
  }, {
    "lng": -82.6811,
    "lat": 38.5155
  }, {
    "lng": -82.6813,
    "lat": 38.5158
  }, {
    "lng": -82.6816,
    "lat": 38.5162
  }, {
    "lng": -82.6818,
    "lat": 38.5164
  }, {
    "lng": -82.6819,
    "lat": 38.5165
  }, {
    "lng": -82.6821,
    "lat": 38.5168
  }, {
    "lng": -82.6823,
    "lat": 38.5175
  }, {
    "lng": -82.6828,
    "lat": 38.5182
  }, {
    "lng": -82.6832,
    "lat": 38.5189
  }, {
    "lng": -82.6836,
    "lat": 38.5195
  }, {
    "lng": -82.6843,
    "lat": 38.5204
  }, {
    "lng": -82.685,
    "lat": 38.5215
  }, {
    "lng": -82.6857,
    "lat": 38.5224
  }, {
    "lng": -82.6861,
    "lat": 38.5231
  }, {
    "lng": -82.6863,
    "lat": 38.5234
  }, {
    "lng": -82.6865,
    "lat": 38.5237
  }, {
    "lng": -82.6866,
    "lat": 38.5238
  }, {
    "lng": -82.6868,
    "lat": 38.5241
  }, {
    "lng": -82.6872,
    "lat": 38.5248
  }, {
    "lng": -82.6878,
    "lat": 38.5248
  }, {
    "lng": -82.6877,
    "lat": 38.5243
  }, {
    "lng": -82.6876,
    "lat": 38.5241
  }, {
    "lng": -82.6876,
    "lat": 38.524
  }, {
    "lng": -82.6876,
    "lat": 38.5239
  }, {
    "lng": -82.6876,
    "lat": 38.5239
  }, {
    "lng": -82.6876,
    "lat": 38.5239
  }, {
    "lng": -82.6876,
    "lat": 38.5239
  }, {
    "lng": -82.6876,
    "lat": 38.5239
  }, {
    "lng": -82.6876,
    "lat": 38.5238
  }, {
    "lng": -82.6877,
    "lat": 38.5238
  }, {
    "lng": -82.6877,
    "lat": 38.5238
  }, {
    "lng": -82.6877,
    "lat": 38.5238
  }, {
    "lng": -82.6877,
    "lat": 38.5237
  }, {
    "lng": -82.6878,
    "lat": 38.5237
  }, {
    "lng": -82.6878,
    "lat": 38.5234
  }, {
    "lng": -82.6876,
    "lat": 38.5232
  }, {
    "lng": -82.6874,
    "lat": 38.5229
  }, {
    "lng": -82.6873,
    "lat": 38.5228
  }, {
    "lng": -82.6869,
    "lat": 38.5224
  }, {
    "lng": -82.6866,
    "lat": 38.5219
  }, {
    "lng": -82.6863,
    "lat": 38.5216
  }, {
    "lng": -82.6861,
    "lat": 38.5212
  }, {
    "lng": -82.6858,
    "lat": 38.5208
  }, {
    "lng": -82.6855,
    "lat": 38.52
  }, {
    "lng": -82.6852,
    "lat": 38.5194
  }, {
    "lng": -82.6852,
    "lat": 38.5192
  }, {
    "lng": -82.6852,
    "lat": 38.5192
  }, {
    "lng": -82.685,
    "lat": 38.5188
  }, {
    "lng": -82.6849,
    "lat": 38.5186
  }, {
    "lng": -82.6849,
    "lat": 38.5185
  }, {
    "lng": -82.6846,
    "lat": 38.5179
  }, {
    "lng": -82.6843,
    "lat": 38.5171
  }, {
    "lng": -82.6841,
    "lat": 38.5167
  }, {
    "lng": -82.684,
    "lat": 38.5163
  }, {
    "lng": -82.6837,
    "lat": 38.5156
  }, {
    "lng": -82.6834,
    "lat": 38.515
  }, {
    "lng": -82.6836,
    "lat": 38.5149
  }, {
    "lng": -82.6837,
    "lat": 38.5148
  }, {
    "lng": -82.6839,
    "lat": 38.5147
  }, {
    "lng": -82.684,
    "lat": 38.5146
  }, {
    "lng": -82.6842,
    "lat": 38.5144
  }, {
    "lng": -82.6844,
    "lat": 38.5143
  }, {
    "lng": -82.6845,
    "lat": 38.5142
  }, {
    "lng": -82.6847,
    "lat": 38.514
  }, {
    "lng": -82.6849,
    "lat": 38.514
  }, {
    "lng": -82.6851,
    "lat": 38.5139
  }, {
    "lng": -82.6854,
    "lat": 38.5138
  }, {
    "lng": -82.6858,
    "lat": 38.5137
  }, {
    "lng": -82.6861,
    "lat": 38.5136
  }, {
    "lng": -82.6865,
    "lat": 38.5135
  }, {
    "lng": -82.6869,
    "lat": 38.5133
  }, {
    "lng": -82.6872,
    "lat": 38.513
  }, {
    "lng": -82.6873,
    "lat": 38.5129
  }, {
    "lng": -82.6874,
    "lat": 38.5128
  }, {
    "lng": -82.6876,
    "lat": 38.5125
  }, {
    "lng": -82.6878,
    "lat": 38.512
  }, {
    "lng": -82.6877,
    "lat": 38.512
  }, {
    "lng": -82.6876,
    "lat": 38.512
  }, {
    "lng": -82.6875,
    "lat": 38.5119
  }, {
    "lng": -82.6873,
    "lat": 38.5119
  }, {
    "lng": -82.6869,
    "lat": 38.5116
  }, {
    "lng": -82.6866,
    "lat": 38.5113
  }, {
    "lng": -82.6864,
    "lat": 38.5111
  }, {
    "lng": -82.6861,
    "lat": 38.5108
  }, {
    "lng": -82.6861,
    "lat": 38.5108
  }, {
    "lng": -82.6857,
    "lat": 38.5104
  }, {
    "lng": -82.6852,
    "lat": 38.5096
  }, {
    "lng": -82.6849,
    "lat": 38.509
  }, {
    "lng": -82.6847,
    "lat": 38.5086
  }, {
    "lng": -82.6844,
    "lat": 38.5084
  }, {
    "lng": -82.6841,
    "lat": 38.5081
  }, {
    "lng": -82.6838,
    "lat": 38.5079
  }, {
    "lng": -82.6835,
    "lat": 38.5078
  }, {
    "lng": -82.6827,
    "lat": 38.5074
  }, {
    "lng": -82.6821,
    "lat": 38.5071
  }, {
    "lng": -82.6818,
    "lat": 38.5068
  }, {
    "lng": -82.6816,
    "lat": 38.5067
  }, {
    "lng": -82.6815,
    "lat": 38.5065
  }, {
    "lng": -82.6815,
    "lat": 38.5063
  }, {
    "lng": -82.6816,
    "lat": 38.5062
  }, {
    "lng": -82.6816,
    "lat": 38.5061
  }, {
    "lng": -82.682,
    "lat": 38.5059
  }, {
    "lng": -82.6821,
    "lat": 38.5058
  }, {
    "lng": -82.6822,
    "lat": 38.5059
  }, {
    "lng": -82.6822,
    "lat": 38.5059
  }, {
    "lng": -82.6823,
    "lat": 38.5061
  }, {
    "lng": -82.6825,
    "lat": 38.5061
  }, {
    "lng": -82.6826,
    "lat": 38.5061
  }, {
    "lng": -82.683,
    "lat": 38.506
  }, {
    "lng": -82.6831,
    "lat": 38.5059
  }, {
    "lng": -82.6831,
    "lat": 38.5058
  }, {
    "lng": -82.6831,
    "lat": 38.5053
  }, {
    "lng": -82.6831,
    "lat": 38.5048
  }, {
    "lng": -82.6831,
    "lat": 38.5041
  }, {
    "lng": -82.6836,
    "lat": 38.5043
  }, {
    "lng": -82.6838,
    "lat": 38.5043
  }, {
    "lng": -82.6839,
    "lat": 38.5043
  }, {
    "lng": -82.6842,
    "lat": 38.5043
  }, {
    "lng": -82.6844,
    "lat": 38.5043
  }, {
    "lng": -82.6847,
    "lat": 38.5044
  }, {
    "lng": -82.6892,
    "lat": 38.5045
  }, {
    "lng": -82.6907,
    "lat": 38.5045
  }, {
    "lng": -82.6907,
    "lat": 38.5047
  }, {
    "lng": -82.6907,
    "lat": 38.5048
  }, {
    "lng": -82.6907,
    "lat": 38.505
  }, {
    "lng": -82.6907,
    "lat": 38.5051
  }, {
    "lng": -82.6907,
    "lat": 38.5053
  }, {
    "lng": -82.6907,
    "lat": 38.5055
  }, {
    "lng": -82.6908,
    "lat": 38.5057
  }, {
    "lng": -82.6908,
    "lat": 38.5058
  }, {
    "lng": -82.6908,
    "lat": 38.5062
  }, {
    "lng": -82.6907,
    "lat": 38.5066
  }, {
    "lng": -82.6906,
    "lat": 38.5071
  }, {
    "lng": -82.6904,
    "lat": 38.5075
  }, {
    "lng": -82.6903,
    "lat": 38.5078
  }, {
    "lng": -82.6903,
    "lat": 38.5081
  }, {
    "lng": -82.6903,
    "lat": 38.5083
  }, {
    "lng": -82.6903,
    "lat": 38.5085
  }, {
    "lng": -82.6904,
    "lat": 38.5088
  }, {
    "lng": -82.6904,
    "lat": 38.5089
  }, {
    "lng": -82.6904,
    "lat": 38.5094
  }, {
    "lng": -82.6903,
    "lat": 38.5096
  }, {
    "lng": -82.6902,
    "lat": 38.5098
  }, {
    "lng": -82.6902,
    "lat": 38.51
  }, {
    "lng": -82.6901,
    "lat": 38.5101
  }, {
    "lng": -82.69,
    "lat": 38.5103
  }, {
    "lng": -82.6899,
    "lat": 38.5104
  }, {
    "lng": -82.6898,
    "lat": 38.5105
  }, {
    "lng": -82.6896,
    "lat": 38.5106
  }, {
    "lng": -82.6897,
    "lat": 38.5107
  }, {
    "lng": -82.6899,
    "lat": 38.5108
  }, {
    "lng": -82.6901,
    "lat": 38.5109
  }, {
    "lng": -82.6902,
    "lat": 38.5109
  }, {
    "lng": -82.6904,
    "lat": 38.5109
  }, {
    "lng": -82.6906,
    "lat": 38.511
  }, {
    "lng": -82.6909,
    "lat": 38.5109
  }, {
    "lng": -82.691,
    "lat": 38.5109
  }, {
    "lng": -82.6911,
    "lat": 38.5108
  }, {
    "lng": -82.6911,
    "lat": 38.5108
  }, {
    "lng": -82.6912,
    "lat": 38.5108
  }, {
    "lng": -82.6913,
    "lat": 38.5107
  }, {
    "lng": -82.6915,
    "lat": 38.5106
  }, {
    "lng": -82.6923,
    "lat": 38.5098
  }, {
    "lng": -82.6925,
    "lat": 38.5096
  }, {
    "lng": -82.6925,
    "lat": 38.5096
  }, {
    "lng": -82.6926,
    "lat": 38.5095
  }, {
    "lng": -82.6927,
    "lat": 38.5094
  }, {
    "lng": -82.6928,
    "lat": 38.5094
  }, {
    "lng": -82.6929,
    "lat": 38.5093
  }, {
    "lng": -82.6931,
    "lat": 38.5093
  }, {
    "lng": -82.6933,
    "lat": 38.5093
  }, {
    "lng": -82.6934,
    "lat": 38.5093
  }, {
    "lng": -82.6935,
    "lat": 38.5093
  }, {
    "lng": -82.6936,
    "lat": 38.5093
  }, {
    "lng": -82.6937,
    "lat": 38.5093
  }, {
    "lng": -82.6938,
    "lat": 38.5093
  }, {
    "lng": -82.6939,
    "lat": 38.5092
  }, {
    "lng": -82.6941,
    "lat": 38.5092
  }, {
    "lng": -82.6942,
    "lat": 38.5091
  }, {
    "lng": -82.6944,
    "lat": 38.509
  }, {
    "lng": -82.6945,
    "lat": 38.5088
  }, {
    "lng": -82.6946,
    "lat": 38.5087
  }, {
    "lng": -82.6946,
    "lat": 38.5086
  }, {
    "lng": -82.6948,
    "lat": 38.5083
  }, {
    "lng": -82.6949,
    "lat": 38.5078
  }, {
    "lng": -82.695,
    "lat": 38.5076
  }, {
    "lng": -82.6951,
    "lat": 38.5073
  }, {
    "lng": -82.6951,
    "lat": 38.5071
  }, {
    "lng": -82.695,
    "lat": 38.5068
  }, {
    "lng": -82.695,
    "lat": 38.5067
  }, {
    "lng": -82.6946,
    "lat": 38.5059
  }, {
    "lng": -82.6942,
    "lat": 38.5057
  }, {
    "lng": -82.694,
    "lat": 38.5056
  }, {
    "lng": -82.6938,
    "lat": 38.5055
  }, {
    "lng": -82.6937,
    "lat": 38.5054
  }, {
    "lng": -82.6935,
    "lat": 38.5052
  }, {
    "lng": -82.693,
    "lat": 38.5045
  }, {
    "lng": -82.6929,
    "lat": 38.5044
  }, {
    "lng": -82.6928,
    "lat": 38.5042
  }, {
    "lng": -82.6927,
    "lat": 38.5041
  }, {
    "lng": -82.6927,
    "lat": 38.5039
  }, {
    "lng": -82.6927,
    "lat": 38.5038
  }, {
    "lng": -82.6926,
    "lat": 38.5037
  }, {
    "lng": -82.6926,
    "lat": 38.5036
  }, {
    "lng": -82.6927,
    "lat": 38.5034
  }, {
    "lng": -82.6927,
    "lat": 38.5034
  }, {
    "lng": -82.6928,
    "lat": 38.5033
  }, {
    "lng": -82.6928,
    "lat": 38.5032
  }, {
    "lng": -82.6931,
    "lat": 38.503
  }, {
    "lng": -82.693,
    "lat": 38.503
  }, {
    "lng": -82.6927,
    "lat": 38.5031
  }, {
    "lng": -82.6926,
    "lat": 38.5032
  }, {
    "lng": -82.6924,
    "lat": 38.5032
  }, {
    "lng": -82.692,
    "lat": 38.5033
  }, {
    "lng": -82.6916,
    "lat": 38.5033
  }, {
    "lng": -82.6913,
    "lat": 38.5032
  }, {
    "lng": -82.6912,
    "lat": 38.5031
  }, {
    "lng": -82.6912,
    "lat": 38.5031
  }, {
    "lng": -82.6909,
    "lat": 38.503
  }, {
    "lng": -82.6904,
    "lat": 38.5029
  }, {
    "lng": -82.6902,
    "lat": 38.5028
  }, {
    "lng": -82.6901,
    "lat": 38.5026
  }, {
    "lng": -82.6896,
    "lat": 38.5025
  }, {
    "lng": -82.6892,
    "lat": 38.5026
  }, {
    "lng": -82.6893,
    "lat": 38.5027
  }, {
    "lng": -82.6894,
    "lat": 38.5028
  }, {
    "lng": -82.6894,
    "lat": 38.5029
  }, {
    "lng": -82.6894,
    "lat": 38.5029
  }, {
    "lng": -82.6893,
    "lat": 38.503
  }, {
    "lng": -82.6892,
    "lat": 38.5031
  }, {
    "lng": -82.6894,
    "lat": 38.5032
  }, {
    "lng": -82.6895,
    "lat": 38.5034
  }, {
    "lng": -82.6894,
    "lat": 38.5035
  }, {
    "lng": -82.6892,
    "lat": 38.5037
  }, {
    "lng": -82.6854,
    "lat": 38.5025
  }, {
    "lng": -82.6843,
    "lat": 38.503
  }, {
    "lng": -82.6841,
    "lat": 38.5028
  }, {
    "lng": -82.6828,
    "lat": 38.5014
  }, {
    "lng": -82.6829,
    "lat": 38.4999
  }, {
    "lng": -82.6828,
    "lat": 38.4992
  }, {
    "lng": -82.6828,
    "lat": 38.499
  }, {
    "lng": -82.6827,
    "lat": 38.499
  }, {
    "lng": -82.6826,
    "lat": 38.4989
  }, {
    "lng": -82.6824,
    "lat": 38.4989
  }, {
    "lng": -82.6823,
    "lat": 38.4988
  }, {
    "lng": -82.6822,
    "lat": 38.4988
  }, {
    "lng": -82.6822,
    "lat": 38.4988
  }, {
    "lng": -82.6822,
    "lat": 38.4987
  }, {
    "lng": -82.6822,
    "lat": 38.4987
  }, {
    "lng": -82.6823,
    "lat": 38.4981
  }, {
    "lng": -82.6823,
    "lat": 38.4956
  }, {
    "lng": -82.6825,
    "lat": 38.4955
  }, {
    "lng": -82.6826,
    "lat": 38.4954
  }, {
    "lng": -82.6827,
    "lat": 38.4954
  }, {
    "lng": -82.6827,
    "lat": 38.4953
  }, {
    "lng": -82.6828,
    "lat": 38.4951
  }, {
    "lng": -82.683,
    "lat": 38.4946
  }, {
    "lng": -82.6834,
    "lat": 38.4943
  }, {
    "lng": -82.6835,
    "lat": 38.4941
  }, {
    "lng": -82.6837,
    "lat": 38.494
  }, {
    "lng": -82.6839,
    "lat": 38.4938
  }, {
    "lng": -82.6841,
    "lat": 38.4937
  }, {
    "lng": -82.6842,
    "lat": 38.4936
  }, {
    "lng": -82.6844,
    "lat": 38.4936
  }, {
    "lng": -82.6848,
    "lat": 38.4935
  }, {
    "lng": -82.6849,
    "lat": 38.4935
  }, {
    "lng": -82.6851,
    "lat": 38.4935
  }, {
    "lng": -82.6852,
    "lat": 38.4935
  }, {
    "lng": -82.6854,
    "lat": 38.4934
  }, {
    "lng": -82.6857,
    "lat": 38.4934
  }, {
    "lng": -82.686,
    "lat": 38.4932
  }, {
    "lng": -82.6861,
    "lat": 38.4932
  }, {
    "lng": -82.6864,
    "lat": 38.493
  }, {
    "lng": -82.6869,
    "lat": 38.4928
  }, {
    "lng": -82.6874,
    "lat": 38.4925
  }, {
    "lng": -82.6875,
    "lat": 38.4924
  }, {
    "lng": -82.6877,
    "lat": 38.4923
  }, {
    "lng": -82.688,
    "lat": 38.4921
  }, {
    "lng": -82.6882,
    "lat": 38.4919
  }, {
    "lng": -82.6884,
    "lat": 38.4916
  }, {
    "lng": -82.6884,
    "lat": 38.4916
  }, {
    "lng": -82.6885,
    "lat": 38.4915
  }, {
    "lng": -82.6885,
    "lat": 38.4914
  }, {
    "lng": -82.6886,
    "lat": 38.4913
  }, {
    "lng": -82.6887,
    "lat": 38.4911
  }, {
    "lng": -82.6887,
    "lat": 38.491
  }, {
    "lng": -82.6892,
    "lat": 38.4898
  }, {
    "lng": -82.6893,
    "lat": 38.4895
  }, {
    "lng": -82.6893,
    "lat": 38.4894
  }, {
    "lng": -82.6894,
    "lat": 38.4891
  }, {
    "lng": -82.6895,
    "lat": 38.489
  }, {
    "lng": -82.6892,
    "lat": 38.4892
  }, {
    "lng": -82.6889,
    "lat": 38.4894
  }, {
    "lng": -82.6885,
    "lat": 38.4893
  }, {
    "lng": -82.6881,
    "lat": 38.4892
  }, {
    "lng": -82.688,
    "lat": 38.4892
  }, {
    "lng": -82.688,
    "lat": 38.4892
  }, {
    "lng": -82.6879,
    "lat": 38.4893
  }, {
    "lng": -82.6879,
    "lat": 38.4894
  }, {
    "lng": -82.6878,
    "lat": 38.4895
  }, {
    "lng": -82.6878,
    "lat": 38.4895
  }, {
    "lng": -82.6877,
    "lat": 38.4895
  }, {
    "lng": -82.6874,
    "lat": 38.4895
  }, {
    "lng": -82.6873,
    "lat": 38.4895
  }, {
    "lng": -82.6872,
    "lat": 38.4895
  }, {
    "lng": -82.687,
    "lat": 38.4896
  }, {
    "lng": -82.6868,
    "lat": 38.4896
  }, {
    "lng": -82.6865,
    "lat": 38.4895
  }, {
    "lng": -82.6864,
    "lat": 38.4895
  }, {
    "lng": -82.6863,
    "lat": 38.4895
  }, {
    "lng": -82.6861,
    "lat": 38.4894
  }, {
    "lng": -82.6858,
    "lat": 38.4894
  }, {
    "lng": -82.6854,
    "lat": 38.4893
  }, {
    "lng": -82.6852,
    "lat": 38.4892
  }, {
    "lng": -82.6851,
    "lat": 38.4892
  }, {
    "lng": -82.685,
    "lat": 38.489
  }, {
    "lng": -82.6847,
    "lat": 38.4887
  }, {
    "lng": -82.6847,
    "lat": 38.4887
  }, {
    "lng": -82.6843,
    "lat": 38.4885
  }, {
    "lng": -82.6841,
    "lat": 38.4883
  }, {
    "lng": -82.6839,
    "lat": 38.4882
  }, {
    "lng": -82.6838,
    "lat": 38.4882
  }, {
    "lng": -82.6837,
    "lat": 38.4882
  }, {
    "lng": -82.6837,
    "lat": 38.4882
  }, {
    "lng": -82.6835,
    "lat": 38.4882
  }, {
    "lng": -82.6835,
    "lat": 38.4882
  }, {
    "lng": -82.6834,
    "lat": 38.4883
  }, {
    "lng": -82.6832,
    "lat": 38.4886
  }, {
    "lng": -82.6828,
    "lat": 38.4892
  }, {
    "lng": -82.6813,
    "lat": 38.4909
  }, {
    "lng": -82.6729,
    "lat": 38.4949
  }, {
    "lng": -82.6731,
    "lat": 38.4946
  }, {
    "lng": -82.6733,
    "lat": 38.4944
  }, {
    "lng": -82.6734,
    "lat": 38.4943
  }, {
    "lng": -82.6737,
    "lat": 38.494
  }, {
    "lng": -82.6738,
    "lat": 38.4938
  }, {
    "lng": -82.6739,
    "lat": 38.4936
  }, {
    "lng": -82.6738,
    "lat": 38.4934
  }, {
    "lng": -82.6738,
    "lat": 38.4934
  }, {
    "lng": -82.6737,
    "lat": 38.4932
  }, {
    "lng": -82.6736,
    "lat": 38.493
  }, {
    "lng": -82.6734,
    "lat": 38.4928
  }, {
    "lng": -82.6734,
    "lat": 38.4927
  }, {
    "lng": -82.6734,
    "lat": 38.4927
  }, {
    "lng": -82.6734,
    "lat": 38.4927
  }, {
    "lng": -82.6734,
    "lat": 38.4925
  }, {
    "lng": -82.6734,
    "lat": 38.4924
  }, {
    "lng": -82.6737,
    "lat": 38.4921
  }, {
    "lng": -82.674,
    "lat": 38.4919
  }, {
    "lng": -82.6741,
    "lat": 38.4915
  }, {
    "lng": -82.6742,
    "lat": 38.4912
  }, {
    "lng": -82.6743,
    "lat": 38.4908
  }, {
    "lng": -82.6743,
    "lat": 38.4904
  }, {
    "lng": -82.6744,
    "lat": 38.4902
  }, {
    "lng": -82.6746,
    "lat": 38.4899
  }, {
    "lng": -82.6747,
    "lat": 38.4898
  }, {
    "lng": -82.6751,
    "lat": 38.4897
  }, {
    "lng": -82.6753,
    "lat": 38.4897
  }, {
    "lng": -82.6756,
    "lat": 38.4895
  }, {
    "lng": -82.6757,
    "lat": 38.4894
  }, {
    "lng": -82.676,
    "lat": 38.4894
  }, {
    "lng": -82.6761,
    "lat": 38.4896
  }, {
    "lng": -82.6762,
    "lat": 38.4899
  }, {
    "lng": -82.6764,
    "lat": 38.4902
  }, {
    "lng": -82.6766,
    "lat": 38.4903
  }, {
    "lng": -82.6766,
    "lat": 38.4904
  }, {
    "lng": -82.6767,
    "lat": 38.4906
  }, {
    "lng": -82.6769,
    "lat": 38.4907
  }, {
    "lng": -82.6769,
    "lat": 38.4907
  }, {
    "lng": -82.677,
    "lat": 38.4907
  }, {
    "lng": -82.6773,
    "lat": 38.4908
  }, {
    "lng": -82.6775,
    "lat": 38.4905
  }, {
    "lng": -82.6776,
    "lat": 38.4902
  }, {
    "lng": -82.6776,
    "lat": 38.4899
  }, {
    "lng": -82.6778,
    "lat": 38.4897
  }, {
    "lng": -82.6778,
    "lat": 38.4895
  }, {
    "lng": -82.6779,
    "lat": 38.4894
  }, {
    "lng": -82.678,
    "lat": 38.4891
  }, {
    "lng": -82.6781,
    "lat": 38.4889
  }, {
    "lng": -82.6781,
    "lat": 38.4886
  }, {
    "lng": -82.6779,
    "lat": 38.4884
  }, {
    "lng": -82.6778,
    "lat": 38.4882
  }, {
    "lng": -82.6782,
    "lat": 38.4882
  }, {
    "lng": -82.6784,
    "lat": 38.4882
  }, {
    "lng": -82.679,
    "lat": 38.4884
  }, {
    "lng": -82.6795,
    "lat": 38.4885
  }, {
    "lng": -82.6801,
    "lat": 38.4887
  }, {
    "lng": -82.6807,
    "lat": 38.4888
  }, {
    "lng": -82.6811,
    "lat": 38.4888
  }, {
    "lng": -82.6815,
    "lat": 38.4888
  }, {
    "lng": -82.6816,
    "lat": 38.4887
  }, {
    "lng": -82.6816,
    "lat": 38.4887
  }, {
    "lng": -82.6816,
    "lat": 38.4886
  }, {
    "lng": -82.6817,
    "lat": 38.4883
  }, {
    "lng": -82.6817,
    "lat": 38.4882
  }, {
    "lng": -82.6817,
    "lat": 38.4879
  }, {
    "lng": -82.6816,
    "lat": 38.4878
  }, {
    "lng": -82.6815,
    "lat": 38.4876
  }, {
    "lng": -82.6815,
    "lat": 38.4875
  }, {
    "lng": -82.6815,
    "lat": 38.4871
  }, {
    "lng": -82.6815,
    "lat": 38.487
  }, {
    "lng": -82.6814,
    "lat": 38.4867
  }, {
    "lng": -82.681,
    "lat": 38.4865
  }, {
    "lng": -82.6808,
    "lat": 38.4863
  }, {
    "lng": -82.6807,
    "lat": 38.4862
  }, {
    "lng": -82.6807,
    "lat": 38.4861
  }, {
    "lng": -82.6807,
    "lat": 38.4859
  }, {
    "lng": -82.6808,
    "lat": 38.4857
  }, {
    "lng": -82.681,
    "lat": 38.4856
  }, {
    "lng": -82.6813,
    "lat": 38.4853
  }, {
    "lng": -82.6815,
    "lat": 38.4851
  }, {
    "lng": -82.6815,
    "lat": 38.485
  }, {
    "lng": -82.681,
    "lat": 38.4848
  }, {
    "lng": -82.6802,
    "lat": 38.4845
  }, {
    "lng": -82.6798,
    "lat": 38.4844
  }, {
    "lng": -82.679,
    "lat": 38.4842
  }, {
    "lng": -82.6788,
    "lat": 38.4842
  }, {
    "lng": -82.6784,
    "lat": 38.4841
  }, {
    "lng": -82.678,
    "lat": 38.484
  }, {
    "lng": -82.6778,
    "lat": 38.4839
  }, {
    "lng": -82.6776,
    "lat": 38.4839
  }, {
    "lng": -82.6774,
    "lat": 38.4839
  }, {
    "lng": -82.6773,
    "lat": 38.4839
  }, {
    "lng": -82.6772,
    "lat": 38.4839
  }, {
    "lng": -82.6774,
    "lat": 38.4841
  }, {
    "lng": -82.6775,
    "lat": 38.4842
  }, {
    "lng": -82.6775,
    "lat": 38.4843
  }, {
    "lng": -82.6775,
    "lat": 38.4845
  }, {
    "lng": -82.6774,
    "lat": 38.4846
  }, {
    "lng": -82.6773,
    "lat": 38.4847
  }, {
    "lng": -82.6772,
    "lat": 38.4848
  }, {
    "lng": -82.6769,
    "lat": 38.4849
  }, {
    "lng": -82.6764,
    "lat": 38.4851
  }, {
    "lng": -82.6761,
    "lat": 38.4852
  }, {
    "lng": -82.6757,
    "lat": 38.4853
  }, {
    "lng": -82.6751,
    "lat": 38.4852
  }, {
    "lng": -82.6742,
    "lat": 38.4852
  }, {
    "lng": -82.6736,
    "lat": 38.4855
  }, {
    "lng": -82.6733,
    "lat": 38.4856
  }, {
    "lng": -82.6731,
    "lat": 38.4856
  }, {
    "lng": -82.673,
    "lat": 38.4857
  }, {
    "lng": -82.6728,
    "lat": 38.4857
  }, {
    "lng": -82.6727,
    "lat": 38.4858
  }, {
    "lng": -82.6726,
    "lat": 38.4859
  }, {
    "lng": -82.6724,
    "lat": 38.4861
  }, {
    "lng": -82.6721,
    "lat": 38.4863
  }, {
    "lng": -82.672,
    "lat": 38.4864
  }, {
    "lng": -82.6718,
    "lat": 38.4866
  }, {
    "lng": -82.6715,
    "lat": 38.4868
  }, {
    "lng": -82.6715,
    "lat": 38.4869
  }, {
    "lng": -82.6713,
    "lat": 38.4871
  }, {
    "lng": -82.6711,
    "lat": 38.4873
  }, {
    "lng": -82.671,
    "lat": 38.4874
  }, {
    "lng": -82.6708,
    "lat": 38.4876
  }, {
    "lng": -82.6707,
    "lat": 38.4876
  }, {
    "lng": -82.6706,
    "lat": 38.4877
  }, {
    "lng": -82.6706,
    "lat": 38.4877
  }, {
    "lng": -82.6705,
    "lat": 38.4878
  }, {
    "lng": -82.6705,
    "lat": 38.4879
  }, {
    "lng": -82.6704,
    "lat": 38.488
  }, {
    "lng": -82.6704,
    "lat": 38.4882
  }, {
    "lng": -82.6703,
    "lat": 38.4882
  }, {
    "lng": -82.6702,
    "lat": 38.4883
  }, {
    "lng": -82.67,
    "lat": 38.4885
  }, {
    "lng": -82.6699,
    "lat": 38.4885
  }, {
    "lng": -82.6698,
    "lat": 38.4886
  }, {
    "lng": -82.6697,
    "lat": 38.4887
  }, {
    "lng": -82.6696,
    "lat": 38.4888
  }, {
    "lng": -82.6696,
    "lat": 38.4889
  }, {
    "lng": -82.6695,
    "lat": 38.489
  }, {
    "lng": -82.6694,
    "lat": 38.4891
  }, {
    "lng": -82.6694,
    "lat": 38.4892
  }, {
    "lng": -82.6693,
    "lat": 38.4892
  }, {
    "lng": -82.6693,
    "lat": 38.4893
  }, {
    "lng": -82.6693,
    "lat": 38.4894
  }, {
    "lng": -82.6692,
    "lat": 38.4895
  }, {
    "lng": -82.6692,
    "lat": 38.4896
  }, {
    "lng": -82.6692,
    "lat": 38.4897
  }, {
    "lng": -82.6691,
    "lat": 38.4899
  }, {
    "lng": -82.669,
    "lat": 38.49
  }, {
    "lng": -82.6686,
    "lat": 38.4904
  }, {
    "lng": -82.6683,
    "lat": 38.4906
  }, {
    "lng": -82.668,
    "lat": 38.4905
  }, {
    "lng": -82.6679,
    "lat": 38.4904
  }, {
    "lng": -82.6678,
    "lat": 38.4903
  }, {
    "lng": -82.6677,
    "lat": 38.4902
  }, {
    "lng": -82.6677,
    "lat": 38.4902
  }, {
    "lng": -82.6677,
    "lat": 38.4901
  }, {
    "lng": -82.6676,
    "lat": 38.49
  }, {
    "lng": -82.6676,
    "lat": 38.4899
  }, {
    "lng": -82.6676,
    "lat": 38.4899
  }, {
    "lng": -82.6676,
    "lat": 38.4898
  }, {
    "lng": -82.6675,
    "lat": 38.4896
  }, {
    "lng": -82.6675,
    "lat": 38.4895
  }, {
    "lng": -82.6674,
    "lat": 38.4893
  }, {
    "lng": -82.6674,
    "lat": 38.4892
  }, {
    "lng": -82.6674,
    "lat": 38.4892
  }, {
    "lng": -82.6673,
    "lat": 38.4891
  }, {
    "lng": -82.6671,
    "lat": 38.4889
  }, {
    "lng": -82.667,
    "lat": 38.4888
  }, {
    "lng": -82.6668,
    "lat": 38.4887
  }, {
    "lng": -82.6666,
    "lat": 38.4885
  }, {
    "lng": -82.6657,
    "lat": 38.488
  }, {
    "lng": -82.6649,
    "lat": 38.4873
  }, {
    "lng": -82.6646,
    "lat": 38.4871
  }, {
    "lng": -82.6645,
    "lat": 38.4871
  }, {
    "lng": -82.6644,
    "lat": 38.4871
  }, {
    "lng": -82.6643,
    "lat": 38.4872
  }, {
    "lng": -82.664,
    "lat": 38.4871
  }, {
    "lng": -82.6636,
    "lat": 38.4869
  }, {
    "lng": -82.6633,
    "lat": 38.4867
  }, {
    "lng": -82.6629,
    "lat": 38.4865
  }, {
    "lng": -82.663,
    "lat": 38.4869
  }, {
    "lng": -82.6628,
    "lat": 38.4869
  }, {
    "lng": -82.6627,
    "lat": 38.4868
  }, {
    "lng": -82.6625,
    "lat": 38.4868
  }, {
    "lng": -82.6621,
    "lat": 38.4867
  }, {
    "lng": -82.6621,
    "lat": 38.4867
  }, {
    "lng": -82.662,
    "lat": 38.4867
  }, {
    "lng": -82.6617,
    "lat": 38.4866
  }, {
    "lng": -82.6616,
    "lat": 38.4867
  }, {
    "lng": -82.6614,
    "lat": 38.4867
  }, {
    "lng": -82.6613,
    "lat": 38.4867
  }, {
    "lng": -82.6612,
    "lat": 38.4867
  }, {
    "lng": -82.6611,
    "lat": 38.4867
  }, {
    "lng": -82.661,
    "lat": 38.4867
  }, {
    "lng": -82.6609,
    "lat": 38.4867
  }, {
    "lng": -82.6605,
    "lat": 38.4868
  }, {
    "lng": -82.6604,
    "lat": 38.4869
  }, {
    "lng": -82.6603,
    "lat": 38.4869
  }, {
    "lng": -82.6602,
    "lat": 38.4869
  }, {
    "lng": -82.6596,
    "lat": 38.487
  }, {
    "lng": -82.6589,
    "lat": 38.4872
  }, {
    "lng": -82.6586,
    "lat": 38.4872
  }, {
    "lng": -82.6582,
    "lat": 38.4872
  }, {
    "lng": -82.6577,
    "lat": 38.4872
  }, {
    "lng": -82.6575,
    "lat": 38.4871
  }, {
    "lng": -82.6574,
    "lat": 38.4872
  }, {
    "lng": -82.6573,
    "lat": 38.4872
  }, {
    "lng": -82.6569,
    "lat": 38.487
  }, {
    "lng": -82.6569,
    "lat": 38.4872
  }, {
    "lng": -82.657,
    "lat": 38.4873
  }, {
    "lng": -82.6571,
    "lat": 38.4875
  }, {
    "lng": -82.6567,
    "lat": 38.4875
  }, {
    "lng": -82.657,
    "lat": 38.4876
  }, {
    "lng": -82.6565,
    "lat": 38.4887
  }, {
    "lng": -82.6561,
    "lat": 38.4893
  }, {
    "lng": -82.6558,
    "lat": 38.4892
  }, {
    "lng": -82.6527,
    "lat": 38.4878
  }, {
    "lng": -82.6524,
    "lat": 38.4877
  }]]],
  "options": {
    "fillColor": "#f50d0d",
    "fillOpacity": 0.4,
    "strokeColor": "#BA0808",
    "strokeWeight": 1,
    "strokeOpacity": 0.4,
    "clickable": true,
    "visible": true,
    "zIndex": 1000
  }
};
var carrierRoute17 = {
  carrierRoute: '41129R003',
  paths: [[[{
    lng: -82.5945,
    lat: 38.3998
  }, {
    lng: -82.5947,
    lat: 38.4002
  }, {
    lng: -82.5948,
    lat: 38.4001
  }, {
    lng: -82.5952,
    lat: 38.3997
  }, {
    lng: -82.5954,
    lat: 38.3996
  }, {
    lng: -82.5956,
    lat: 38.3996
  }, {
    lng: -82.5959,
    lat: 38.3996
  }, {
    lng: -82.5967,
    lat: 38.3996
  }, {
    lng: -82.597,
    lat: 38.3995
  }, {
    lng: -82.5973,
    lat: 38.399
  }, {
    lng: -82.5973,
    lat: 38.3988
  }, {
    lng: -82.5975,
    lat: 38.3985
  }, {
    lng: -82.598,
    lat: 38.3984
  }, {
    lng: -82.6005,
    lat: 38.3976
  }, {
    lng: -82.6009,
    lat: 38.3977
  }, {
    lng: -82.6009,
    lat: 38.3975
  }, {
    lng: -82.6009,
    lat: 38.3974
  }, {
    lng: -82.6009,
    lat: 38.3973
  }, {
    lng: -82.6009,
    lat: 38.3973
  }, {
    lng: -82.6009,
    lat: 38.397
  }, {
    lng: -82.6011,
    lat: 38.397
  }, {
    lng: -82.6012,
    lat: 38.397
  }, {
    lng: -82.6012,
    lat: 38.397
  }, {
    lng: -82.6012,
    lat: 38.397
  }, {
    lng: -82.6013,
    lat: 38.3969
  }, {
    lng: -82.6013,
    lat: 38.3969
  }, {
    lng: -82.6014,
    lat: 38.3969
  }, {
    lng: -82.6015,
    lat: 38.3969
  }, {
    lng: -82.6018,
    lat: 38.3969
  }, {
    lng: -82.6019,
    lat: 38.3969
  }, {
    lng: -82.602,
    lat: 38.3969
  }, {
    lng: -82.602,
    lat: 38.3969
  }, {
    lng: -82.6021,
    lat: 38.3968
  }, {
    lng: -82.6022,
    lat: 38.3967
  }, {
    lng: -82.6023,
    lat: 38.3966
  }, {
    lng: -82.6024,
    lat: 38.3965
  }, {
    lng: -82.6024,
    lat: 38.3963
  }, {
    lng: -82.6024,
    lat: 38.3962
  }, {
    lng: -82.6024,
    lat: 38.396
  }, {
    lng: -82.6024,
    lat: 38.3959
  }, {
    lng: -82.6024,
    lat: 38.3958
  }, {
    lng: -82.6024,
    lat: 38.3956
  }, {
    lng: -82.6025,
    lat: 38.3953
  }, {
    lng: -82.6025,
    lat: 38.3952
  }, {
    lng: -82.6025,
    lat: 38.3952
  }, {
    lng: -82.6025,
    lat: 38.3947
  }, {
    lng: -82.6026,
    lat: 38.3944
  }, {
    lng: -82.6029,
    lat: 38.394
  }, {
    lng: -82.6038,
    lat: 38.3946
  }, {
    lng: -82.6046,
    lat: 38.3939
  }, {
    lng: -82.6059,
    lat: 38.3942
  }, {
    lng: -82.6062,
    lat: 38.3943
  }, {
    lng: -82.6064,
    lat: 38.3943
  }, {
    lng: -82.6068,
    lat: 38.3943
  }, {
    lng: -82.6072,
    lat: 38.3943
  }, {
    lng: -82.6076,
    lat: 38.3942
  }, {
    lng: -82.6079,
    lat: 38.3942
  }, {
    lng: -82.6081,
    lat: 38.3942
  }, {
    lng: -82.6088,
    lat: 38.3941
  }, {
    lng: -82.6086,
    lat: 38.3938
  }, {
    lng: -82.6075,
    lat: 38.3938
  }, {
    lng: -82.6067,
    lat: 38.3935
  }, {
    lng: -82.6062,
    lat: 38.3936
  }, {
    lng: -82.6059,
    lat: 38.3937
  }, {
    lng: -82.606,
    lat: 38.3934
  }, {
    lng: -82.606,
    lat: 38.3932
  }, {
    lng: -82.6061,
    lat: 38.3932
  }, {
    lng: -82.6061,
    lat: 38.3931
  }, {
    lng: -82.6061,
    lat: 38.3931
  }, {
    lng: -82.6063,
    lat: 38.3931
  }, {
    lng: -82.6064,
    lat: 38.3931
  }, {
    lng: -82.6066,
    lat: 38.3932
  }, {
    lng: -82.6068,
    lat: 38.3932
  }, {
    lng: -82.6073,
    lat: 38.3932
  }, {
    lng: -82.6076,
    lat: 38.3932
  }, {
    lng: -82.6076,
    lat: 38.3932
  }, {
    lng: -82.6078,
    lat: 38.3932
  }, {
    lng: -82.608,
    lat: 38.3932
  }, {
    lng: -82.6081,
    lat: 38.3931
  }, {
    lng: -82.6081,
    lat: 38.3931
  }, {
    lng: -82.6082,
    lat: 38.393
  }, {
    lng: -82.6082,
    lat: 38.3929
  }, {
    lng: -82.6082,
    lat: 38.3928
  }, {
    lng: -82.6083,
    lat: 38.3927
  }, {
    lng: -82.6084,
    lat: 38.3924
  }, {
    lng: -82.6084,
    lat: 38.3922
  }, {
    lng: -82.6085,
    lat: 38.392
  }, {
    lng: -82.6086,
    lat: 38.3916
  }, {
    lng: -82.6087,
    lat: 38.3912
  }, {
    lng: -82.6088,
    lat: 38.3909
  }, {
    lng: -82.6089,
    lat: 38.3906
  }, {
    lng: -82.6092,
    lat: 38.3894
  }, {
    lng: -82.6097,
    lat: 38.3888
  }, {
    lng: -82.6099,
    lat: 38.3884
  }, {
    lng: -82.6101,
    lat: 38.3877
  }, {
    lng: -82.6098,
    lat: 38.3875
  }, {
    lng: -82.6094,
    lat: 38.3871
  }, {
    lng: -82.6093,
    lat: 38.387
  }, {
    lng: -82.6092,
    lat: 38.387
  }, {
    lng: -82.6086,
    lat: 38.3867
  }, {
    lng: -82.6095,
    lat: 38.3862
  }, {
    lng: -82.6098,
    lat: 38.386
  }, {
    lng: -82.6099,
    lat: 38.3859
  }, {
    lng: -82.61,
    lat: 38.3858
  }, {
    lng: -82.6102,
    lat: 38.3857
  }, {
    lng: -82.6102,
    lat: 38.3856
  }, {
    lng: -82.6103,
    lat: 38.3855
  }, {
    lng: -82.6103,
    lat: 38.3855
  }, {
    lng: -82.6103,
    lat: 38.3854
  }, {
    lng: -82.6103,
    lat: 38.3853
  }, {
    lng: -82.6103,
    lat: 38.3852
  }, {
    lng: -82.6102,
    lat: 38.3852
  }, {
    lng: -82.6101,
    lat: 38.385
  }, {
    lng: -82.6098,
    lat: 38.3847
  }, {
    lng: -82.6097,
    lat: 38.3846
  }, {
    lng: -82.6096,
    lat: 38.3845
  }, {
    lng: -82.6095,
    lat: 38.3843
  }, {
    lng: -82.6095,
    lat: 38.3841
  }, {
    lng: -82.6094,
    lat: 38.384
  }, {
    lng: -82.6094,
    lat: 38.3838
  }, {
    lng: -82.6094,
    lat: 38.3835
  }, {
    lng: -82.6094,
    lat: 38.3832
  }, {
    lng: -82.6094,
    lat: 38.383
  }, {
    lng: -82.6094,
    lat: 38.3829
  }, {
    lng: -82.6095,
    lat: 38.3827
  }, {
    lng: -82.6096,
    lat: 38.3826
  }, {
    lng: -82.6097,
    lat: 38.3825
  }, {
    lng: -82.6098,
    lat: 38.3824
  }, {
    lng: -82.6101,
    lat: 38.3822
  }, {
    lng: -82.6104,
    lat: 38.382
  }, {
    lng: -82.6106,
    lat: 38.382
  }, {
    lng: -82.6108,
    lat: 38.382
  }, {
    lng: -82.6109,
    lat: 38.382
  }, {
    lng: -82.6111,
    lat: 38.382
  }, {
    lng: -82.6119,
    lat: 38.3822
  }, {
    lng: -82.6135,
    lat: 38.3825
  }, {
    lng: -82.6138,
    lat: 38.3826
  }, {
    lng: -82.6143,
    lat: 38.3828
  }, {
    lng: -82.6146,
    lat: 38.3828
  }, {
    lng: -82.6149,
    lat: 38.3829
  }, {
    lng: -82.6151,
    lat: 38.383
  }, {
    lng: -82.6154,
    lat: 38.383
  }, {
    lng: -82.6159,
    lat: 38.3831
  }, {
    lng: -82.6164,
    lat: 38.3832
  }, {
    lng: -82.6167,
    lat: 38.3832
  }, {
    lng: -82.617,
    lat: 38.3832
  }, {
    lng: -82.6172,
    lat: 38.3832
  }, {
    lng: -82.6174,
    lat: 38.3831
  }, {
    lng: -82.6176,
    lat: 38.383
  }, {
    lng: -82.6178,
    lat: 38.383
  }, {
    lng: -82.618,
    lat: 38.3829
  }, {
    lng: -82.6183,
    lat: 38.3827
  }, {
    lng: -82.6187,
    lat: 38.3825
  }, {
    lng: -82.6188,
    lat: 38.3824
  }, {
    lng: -82.619,
    lat: 38.3824
  }, {
    lng: -82.6192,
    lat: 38.3823
  }, {
    lng: -82.6194,
    lat: 38.3823
  }, {
    lng: -82.6198,
    lat: 38.3823
  }, {
    lng: -82.6201,
    lat: 38.3823
  }, {
    lng: -82.6207,
    lat: 38.3824
  }, {
    lng: -82.6211,
    lat: 38.3824
  }, {
    lng: -82.6215,
    lat: 38.3825
  }, {
    lng: -82.6224,
    lat: 38.3826
  }, {
    lng: -82.623,
    lat: 38.3826
  }, {
    lng: -82.6236,
    lat: 38.3828
  }, {
    lng: -82.6247,
    lat: 38.3829
  }, {
    lng: -82.6249,
    lat: 38.3829
  }, {
    lng: -82.6251,
    lat: 38.3829
  }, {
    lng: -82.6253,
    lat: 38.3829
  }, {
    lng: -82.6255,
    lat: 38.3829
  }, {
    lng: -82.6257,
    lat: 38.3833
  }, {
    lng: -82.6263,
    lat: 38.3844
  }, {
    lng: -82.6267,
    lat: 38.3849
  }, {
    lng: -82.6267,
    lat: 38.3843
  }, {
    lng: -82.6266,
    lat: 38.384
  }, {
    lng: -82.6262,
    lat: 38.3831
  }, {
    lng: -82.626,
    lat: 38.3828
  }, {
    lng: -82.6264,
    lat: 38.3827
  }, {
    lng: -82.6266,
    lat: 38.3826
  }, {
    lng: -82.6268,
    lat: 38.3826
  }, {
    lng: -82.627,
    lat: 38.3825
  }, {
    lng: -82.6272,
    lat: 38.3825
  }, {
    lng: -82.6278,
    lat: 38.3825
  }, {
    lng: -82.6283,
    lat: 38.3824
  }, {
    lng: -82.6286,
    lat: 38.3824
  }, {
    lng: -82.6289,
    lat: 38.3824
  }, {
    lng: -82.6291,
    lat: 38.3825
  }, {
    lng: -82.6293,
    lat: 38.3825
  }, {
    lng: -82.6302,
    lat: 38.3826
  }, {
    lng: -82.6305,
    lat: 38.3827
  }, {
    lng: -82.6311,
    lat: 38.3828
  }, {
    lng: -82.6314,
    lat: 38.3829
  }, {
    lng: -82.6315,
    lat: 38.3829
  }, {
    lng: -82.6331,
    lat: 38.3832
  }, {
    lng: -82.6334,
    lat: 38.3833
  }, {
    lng: -82.6346,
    lat: 38.3837
  }, {
    lng: -82.6354,
    lat: 38.384
  }, {
    lng: -82.6369,
    lat: 38.3844
  }, {
    lng: -82.6379,
    lat: 38.3848
  }, {
    lng: -82.6389,
    lat: 38.3854
  }, {
    lng: -82.6395,
    lat: 38.3857
  }, {
    lng: -82.6414,
    lat: 38.3872
  }, {
    lng: -82.6421,
    lat: 38.3877
  }, {
    lng: -82.6433,
    lat: 38.3886
  }, {
    lng: -82.6439,
    lat: 38.3891
  }, {
    lng: -82.6445,
    lat: 38.3898
  }, {
    lng: -82.6448,
    lat: 38.3905
  }, {
    lng: -82.6449,
    lat: 38.3909
  }, {
    lng: -82.645,
    lat: 38.3912
  }, {
    lng: -82.6455,
    lat: 38.3915
  }, {
    lng: -82.6466,
    lat: 38.3918
  }, {
    lng: -82.647,
    lat: 38.3919
  }, {
    lng: -82.6482,
    lat: 38.3921
  }, {
    lng: -82.6496,
    lat: 38.3926
  }, {
    lng: -82.65,
    lat: 38.3927
  }, {
    lng: -82.6502,
    lat: 38.3928
  }, {
    lng: -82.6505,
    lat: 38.393
  }, {
    lng: -82.6508,
    lat: 38.3931
  }, {
    lng: -82.6514,
    lat: 38.3933
  }, {
    lng: -82.6515,
    lat: 38.3934
  }, {
    lng: -82.6516,
    lat: 38.3934
  }, {
    lng: -82.6517,
    lat: 38.3936
  }, {
    lng: -82.6518,
    lat: 38.3937
  }, {
    lng: -82.6519,
    lat: 38.3939
  }, {
    lng: -82.6521,
    lat: 38.3941
  }, {
    lng: -82.6522,
    lat: 38.3943
  }, {
    lng: -82.6523,
    lat: 38.3945
  }, {
    lng: -82.6524,
    lat: 38.3946
  }, {
    lng: -82.6525,
    lat: 38.3948
  }, {
    lng: -82.653,
    lat: 38.3952
  }, {
    lng: -82.653,
    lat: 38.3953
  }, {
    lng: -82.6531,
    lat: 38.3955
  }, {
    lng: -82.6532,
    lat: 38.3959
  }, {
    lng: -82.6533,
    lat: 38.3962
  }, {
    lng: -82.6538,
    lat: 38.397
  }, {
    lng: -82.6539,
    lat: 38.3972
  }, {
    lng: -82.653,
    lat: 38.3974
  }, {
    lng: -82.6526,
    lat: 38.3975
  }, {
    lng: -82.6527,
    lat: 38.3985
  }, {
    lng: -82.6527,
    lat: 38.3986
  }, {
    lng: -82.6523,
    lat: 38.399
  }, {
    lng: -82.6515,
    lat: 38.3994
  }, {
    lng: -82.651,
    lat: 38.4
  }, {
    lng: -82.6502,
    lat: 38.4001
  }, {
    lng: -82.6493,
    lat: 38.4
  }, {
    lng: -82.6487,
    lat: 38.3999
  }, {
    lng: -82.6481,
    lat: 38.3997
  }, {
    lng: -82.6481,
    lat: 38.3997
  }, {
    lng: -82.6488,
    lat: 38.4007
  }, {
    lng: -82.6492,
    lat: 38.4016
  }, {
    lng: -82.6493,
    lat: 38.4019
  }, {
    lng: -82.6497,
    lat: 38.4026
  }, {
    lng: -82.6501,
    lat: 38.4033
  }, {
    lng: -82.6507,
    lat: 38.404
  }, {
    lng: -82.651,
    lat: 38.4044
  }, {
    lng: -82.6517,
    lat: 38.4051
  }, {
    lng: -82.6519,
    lat: 38.4054
  }, {
    lng: -82.6525,
    lat: 38.4064
  }, {
    lng: -82.6534,
    lat: 38.4078
  }, {
    lng: -82.6537,
    lat: 38.4082
  }, {
    lng: -82.6549,
    lat: 38.4078
  }, {
    lng: -82.656,
    lat: 38.4073
  }, {
    lng: -82.6567,
    lat: 38.4072
  }, {
    lng: -82.6578,
    lat: 38.4071
  }, {
    lng: -82.6571,
    lat: 38.4078
  }, {
    lng: -82.6566,
    lat: 38.4093
  }, {
    lng: -82.6566,
    lat: 38.4112
  }, {
    lng: -82.6566,
    lat: 38.4115
  }, {
    lng: -82.6566,
    lat: 38.4121
  }, {
    lng: -82.6562,
    lat: 38.413
  }, {
    lng: -82.6558,
    lat: 38.4137
  }, {
    lng: -82.6553,
    lat: 38.4144
  }, {
    lng: -82.6549,
    lat: 38.4146
  }, {
    lng: -82.6545,
    lat: 38.4149
  }, {
    lng: -82.654,
    lat: 38.415
  }, {
    lng: -82.6526,
    lat: 38.4149
  }, {
    lng: -82.6518,
    lat: 38.4146
  }, {
    lng: -82.651,
    lat: 38.4143
  }, {
    lng: -82.6499,
    lat: 38.4135
  }, {
    lng: -82.6495,
    lat: 38.4132
  }, {
    lng: -82.6483,
    lat: 38.4124
  }, {
    lng: -82.6474,
    lat: 38.4127
  }, {
    lng: -82.6465,
    lat: 38.4132
  }, {
    lng: -82.6456,
    lat: 38.4139
  }, {
    lng: -82.6447,
    lat: 38.4149
  }, {
    lng: -82.644,
    lat: 38.4154
  }, {
    lng: -82.6437,
    lat: 38.4157
  }, {
    lng: -82.6433,
    lat: 38.4159
  }, {
    lng: -82.6422,
    lat: 38.416
  }, {
    lng: -82.6417,
    lat: 38.4161
  }, {
    lng: -82.6413,
    lat: 38.4163
  }, {
    lng: -82.6408,
    lat: 38.4168
  }, {
    lng: -82.6408,
    lat: 38.4163
  }, {
    lng: -82.6408,
    lat: 38.4162
  }, {
    lng: -82.6408,
    lat: 38.416
  }, {
    lng: -82.6406,
    lat: 38.4157
  }, {
    lng: -82.6402,
    lat: 38.4153
  }, {
    lng: -82.6393,
    lat: 38.4146
  }, {
    lng: -82.6391,
    lat: 38.4144
  }, {
    lng: -82.6391,
    lat: 38.4141
  }, {
    lng: -82.6391,
    lat: 38.4137
  }, {
    lng: -82.6391,
    lat: 38.4132
  }, {
    lng: -82.6392,
    lat: 38.4125
  }, {
    lng: -82.6393,
    lat: 38.412
  }, {
    lng: -82.6393,
    lat: 38.4119
  }, {
    lng: -82.6393,
    lat: 38.4117
  }, {
    lng: -82.6393,
    lat: 38.4116
  }, {
    lng: -82.6391,
    lat: 38.4109
  }, {
    lng: -82.6386,
    lat: 38.4098
  }, {
    lng: -82.6377,
    lat: 38.4075
  }, {
    lng: -82.6373,
    lat: 38.4069
  }, {
    lng: -82.6369,
    lat: 38.4061
  }, {
    lng: -82.6363,
    lat: 38.4053
  }, {
    lng: -82.6356,
    lat: 38.4043
  }, {
    lng: -82.6351,
    lat: 38.4037
  }, {
    lng: -82.6345,
    lat: 38.4035
  }, {
    lng: -82.6343,
    lat: 38.4035
  }, {
    lng: -82.634,
    lat: 38.4034
  }, {
    lng: -82.6334,
    lat: 38.4032
  }, {
    lng: -82.6321,
    lat: 38.4026
  }, {
    lng: -82.6316,
    lat: 38.4025
  }, {
    lng: -82.6312,
    lat: 38.4027
  }, {
    lng: -82.6308,
    lat: 38.4032
  }, {
    lng: -82.6301,
    lat: 38.4036
  }, {
    lng: -82.6292,
    lat: 38.404
  }, {
    lng: -82.6284,
    lat: 38.4041
  }, {
    lng: -82.6278,
    lat: 38.4042
  }, {
    lng: -82.6268,
    lat: 38.4044
  }, {
    lng: -82.6258,
    lat: 38.4042
  }, {
    lng: -82.624,
    lat: 38.4038
  }, {
    lng: -82.6239,
    lat: 38.4039
  }, {
    lng: -82.6238,
    lat: 38.404
  }, {
    lng: -82.6236,
    lat: 38.4041
  }, {
    lng: -82.6232,
    lat: 38.4042
  }, {
    lng: -82.6227,
    lat: 38.4045
  }, {
    lng: -82.6225,
    lat: 38.4047
  }, {
    lng: -82.6218,
    lat: 38.4051
  }, {
    lng: -82.6214,
    lat: 38.4054
  }, {
    lng: -82.6211,
    lat: 38.4055
  }, {
    lng: -82.6208,
    lat: 38.4056
  }, {
    lng: -82.6205,
    lat: 38.4057
  }, {
    lng: -82.6201,
    lat: 38.4058
  }, {
    lng: -82.6199,
    lat: 38.4058
  }, {
    lng: -82.6195,
    lat: 38.4058
  }, {
    lng: -82.619,
    lat: 38.4058
  }, {
    lng: -82.6187,
    lat: 38.4058
  }, {
    lng: -82.6185,
    lat: 38.4058
  }, {
    lng: -82.6183,
    lat: 38.4057
  }, {
    lng: -82.6181,
    lat: 38.4056
  }, {
    lng: -82.618,
    lat: 38.4056
  }, {
    lng: -82.6178,
    lat: 38.4054
  }, {
    lng: -82.6174,
    lat: 38.4052
  }, {
    lng: -82.6159,
    lat: 38.4044
  }, {
    lng: -82.6148,
    lat: 38.4034
  }, {
    lng: -82.6143,
    lat: 38.4031
  }, {
    lng: -82.6127,
    lat: 38.4021
  }, {
    lng: -82.6123,
    lat: 38.4018
  }, {
    lng: -82.6114,
    lat: 38.401
  }, {
    lng: -82.6112,
    lat: 38.4011
  }, {
    lng: -82.6112,
    lat: 38.4012
  }, {
    lng: -82.6112,
    lat: 38.4014
  }, {
    lng: -82.6112,
    lat: 38.4017
  }, {
    lng: -82.6112,
    lat: 38.4022
  }, {
    lng: -82.6109,
    lat: 38.4033
  }, {
    lng: -82.6103,
    lat: 38.4042
  }, {
    lng: -82.6097,
    lat: 38.4048
  }, {
    lng: -82.6089,
    lat: 38.405
  }, {
    lng: -82.6084,
    lat: 38.4053
  }, {
    lng: -82.6082,
    lat: 38.4055
  }, {
    lng: -82.6079,
    lat: 38.4058
  }, {
    lng: -82.6075,
    lat: 38.4062
  }, {
    lng: -82.6072,
    lat: 38.4065
  }, {
    lng: -82.6072,
    lat: 38.4066
  }, {
    lng: -82.6071,
    lat: 38.4067
  }, {
    lng: -82.6069,
    lat: 38.4073
  }, {
    lng: -82.6068,
    lat: 38.4074
  }, {
    lng: -82.607,
    lat: 38.4077
  }, {
    lng: -82.6072,
    lat: 38.4079
  }, {
    lng: -82.6072,
    lat: 38.408
  }, {
    lng: -82.6072,
    lat: 38.408
  }, {
    lng: -82.6072,
    lat: 38.4081
  }, {
    lng: -82.6072,
    lat: 38.4081
  }, {
    lng: -82.6071,
    lat: 38.4082
  }, {
    lng: -82.607,
    lat: 38.4083
  }, {
    lng: -82.607,
    lat: 38.4083
  }, {
    lng: -82.6069,
    lat: 38.4084
  }, {
    lng: -82.6069,
    lat: 38.4084
  }, {
    lng: -82.6069,
    lat: 38.4085
  }, {
    lng: -82.6068,
    lat: 38.4086
  }, {
    lng: -82.6068,
    lat: 38.4087
  }, {
    lng: -82.6067,
    lat: 38.4091
  }, {
    lng: -82.6067,
    lat: 38.4093
  }, {
    lng: -82.6067,
    lat: 38.4095
  }, {
    lng: -82.6067,
    lat: 38.4096
  }, {
    lng: -82.6068,
    lat: 38.4103
  }, {
    lng: -82.6068,
    lat: 38.4104
  }, {
    lng: -82.6069,
    lat: 38.4105
  }, {
    lng: -82.6069,
    lat: 38.4106
  }, {
    lng: -82.6068,
    lat: 38.4107
  }, {
    lng: -82.6068,
    lat: 38.4107
  }, {
    lng: -82.6068,
    lat: 38.4108
  }, {
    lng: -82.6068,
    lat: 38.4108
  }, {
    lng: -82.6067,
    lat: 38.4108
  }, {
    lng: -82.6067,
    lat: 38.4109
  }, {
    lng: -82.6066,
    lat: 38.4109
  }, {
    lng: -82.6066,
    lat: 38.4109
  }, {
    lng: -82.6065,
    lat: 38.4109
  }, {
    lng: -82.6063,
    lat: 38.4109
  }, {
    lng: -82.6062,
    lat: 38.4109
  }, {
    lng: -82.6061,
    lat: 38.4109
  }, {
    lng: -82.606,
    lat: 38.411
  }, {
    lng: -82.6059,
    lat: 38.411
  }, {
    lng: -82.6058,
    lat: 38.411
  }, {
    lng: -82.6057,
    lat: 38.411
  }, {
    lng: -82.6056,
    lat: 38.411
  }, {
    lng: -82.6055,
    lat: 38.4111
  }, {
    lng: -82.6055,
    lat: 38.4111
  }, {
    lng: -82.6054,
    lat: 38.4112
  }, {
    lng: -82.6053,
    lat: 38.4113
  }, {
    lng: -82.6052,
    lat: 38.4114
  }, {
    lng: -82.6051,
    lat: 38.4115
  }, {
    lng: -82.605,
    lat: 38.4116
  }, {
    lng: -82.6049,
    lat: 38.4117
  }, {
    lng: -82.6049,
    lat: 38.4117
  }, {
    lng: -82.6049,
    lat: 38.4118
  }, {
    lng: -82.6048,
    lat: 38.4121
  }, {
    lng: -82.6047,
    lat: 38.4137
  }, {
    lng: -82.6047,
    lat: 38.4143
  }, {
    lng: -82.6113,
    lat: 38.4119
  }, {
    lng: -82.6113,
    lat: 38.4118
  }, {
    lng: -82.6116,
    lat: 38.4112
  }, {
    lng: -82.6116,
    lat: 38.4116
  }, {
    lng: -82.6116,
    lat: 38.4118
  }, {
    lng: -82.6114,
    lat: 38.4121
  }, {
    lng: -82.6113,
    lat: 38.4124
  }, {
    lng: -82.611,
    lat: 38.4127
  }, {
    lng: -82.6108,
    lat: 38.4128
  }, {
    lng: -82.6107,
    lat: 38.4129
  }, {
    lng: -82.6107,
    lat: 38.4129
  }, {
    lng: -82.6106,
    lat: 38.413
  }, {
    lng: -82.6098,
    lat: 38.4137
  }, {
    lng: -82.6096,
    lat: 38.414
  }, {
    lng: -82.6099,
    lat: 38.4141
  }, {
    lng: -82.6097,
    lat: 38.4144
  }, {
    lng: -82.6094,
    lat: 38.4147
  }, {
    lng: -82.6086,
    lat: 38.417
  }, {
    lng: -82.6082,
    lat: 38.4185
  }, {
    lng: -82.6081,
    lat: 38.4194
  }, {
    lng: -82.6073,
    lat: 38.4198
  }, {
    lng: -82.6064,
    lat: 38.4195
  }, {
    lng: -82.606,
    lat: 38.4194
  }, {
    lng: -82.6056,
    lat: 38.4195
  }, {
    lng: -82.6052,
    lat: 38.4198
  }, {
    lng: -82.6046,
    lat: 38.4198
  }, {
    lng: -82.6039,
    lat: 38.4203
  }, {
    lng: -82.6028,
    lat: 38.4209
  }, {
    lng: -82.6038,
    lat: 38.4222
  }, {
    lng: -82.6045,
    lat: 38.4231
  }, {
    lng: -82.6068,
    lat: 38.4273
  }, {
    lng: -82.6083,
    lat: 38.4316
  }, {
    lng: -82.6084,
    lat: 38.4321
  }, {
    lng: -82.6089,
    lat: 38.4331
  }, {
    lng: -82.61,
    lat: 38.4335
  }, {
    lng: -82.609,
    lat: 38.4348
  }, {
    lng: -82.6105,
    lat: 38.4347
  }, {
    lng: -82.6111,
    lat: 38.4348
  }, {
    lng: -82.6113,
    lat: 38.4347
  }, {
    lng: -82.6115,
    lat: 38.4345
  }, {
    lng: -82.6118,
    lat: 38.4342
  }, {
    lng: -82.612,
    lat: 38.434
  }, {
    lng: -82.6121,
    lat: 38.4338
  }, {
    lng: -82.6122,
    lat: 38.4337
  }, {
    lng: -82.6122,
    lat: 38.4336
  }, {
    lng: -82.6122,
    lat: 38.4335
  }, {
    lng: -82.6122,
    lat: 38.4333
  }, {
    lng: -82.6123,
    lat: 38.4332
  }, {
    lng: -82.6124,
    lat: 38.433
  }, {
    lng: -82.6126,
    lat: 38.4327
  }, {
    lng: -82.6127,
    lat: 38.4327
  }, {
    lng: -82.6128,
    lat: 38.4326
  }, {
    lng: -82.6131,
    lat: 38.4325
  }, {
    lng: -82.6133,
    lat: 38.4325
  }, {
    lng: -82.6137,
    lat: 38.4325
  }, {
    lng: -82.6138,
    lat: 38.4325
  }, {
    lng: -82.6139,
    lat: 38.4325
  }, {
    lng: -82.6141,
    lat: 38.4325
  }, {
    lng: -82.6143,
    lat: 38.4325
  }, {
    lng: -82.6144,
    lat: 38.4326
  }, {
    lng: -82.6146,
    lat: 38.4326
  }, {
    lng: -82.615,
    lat: 38.4327
  }, {
    lng: -82.6153,
    lat: 38.4327
  }, {
    lng: -82.6154,
    lat: 38.4328
  }, {
    lng: -82.6155,
    lat: 38.4329
  }, {
    lng: -82.6158,
    lat: 38.4333
  }, {
    lng: -82.6159,
    lat: 38.4334
  }, {
    lng: -82.616,
    lat: 38.4337
  }, {
    lng: -82.6163,
    lat: 38.434
  }, {
    lng: -82.6167,
    lat: 38.4343
  }, {
    lng: -82.6165,
    lat: 38.4343
  }, {
    lng: -82.616,
    lat: 38.4346
  }, {
    lng: -82.6156,
    lat: 38.4347
  }, {
    lng: -82.6153,
    lat: 38.4349
  }, {
    lng: -82.6151,
    lat: 38.435
  }, {
    lng: -82.615,
    lat: 38.4351
  }, {
    lng: -82.615,
    lat: 38.4351
  }, {
    lng: -82.6149,
    lat: 38.4351
  }, {
    lng: -82.6149,
    lat: 38.4352
  }, {
    lng: -82.6149,
    lat: 38.4353
  }, {
    lng: -82.6149,
    lat: 38.4354
  }, {
    lng: -82.6148,
    lat: 38.4354
  }, {
    lng: -82.6147,
    lat: 38.4355
  }, {
    lng: -82.6146,
    lat: 38.4355
  }, {
    lng: -82.6145,
    lat: 38.4355
  }, {
    lng: -82.6144,
    lat: 38.4353
  }, {
    lng: -82.6143,
    lat: 38.4352
  }, {
    lng: -82.6143,
    lat: 38.4351
  }, {
    lng: -82.6142,
    lat: 38.435
  }, {
    lng: -82.6141,
    lat: 38.435
  }, {
    lng: -82.6139,
    lat: 38.4348
  }, {
    lng: -82.6138,
    lat: 38.4347
  }, {
    lng: -82.6137,
    lat: 38.4346
  }, {
    lng: -82.6136,
    lat: 38.4346
  }, {
    lng: -82.6136,
    lat: 38.4346
  }, {
    lng: -82.6135,
    lat: 38.4347
  }, {
    lng: -82.6135,
    lat: 38.4347
  }, {
    lng: -82.6134,
    lat: 38.4348
  }, {
    lng: -82.6133,
    lat: 38.435
  }, {
    lng: -82.6132,
    lat: 38.4353
  }, {
    lng: -82.6131,
    lat: 38.4356
  }, {
    lng: -82.613,
    lat: 38.4357
  }, {
    lng: -82.6129,
    lat: 38.4358
  }, {
    lng: -82.6128,
    lat: 38.4358
  }, {
    lng: -82.6126,
    lat: 38.4359
  }, {
    lng: -82.6124,
    lat: 38.4359
  }, {
    lng: -82.612,
    lat: 38.436
  }, {
    lng: -82.6119,
    lat: 38.4361
  }, {
    lng: -82.6126,
    lat: 38.4375
  }, {
    lng: -82.6138,
    lat: 38.4371
  }, {
    lng: -82.6142,
    lat: 38.437
  }, {
    lng: -82.6146,
    lat: 38.4368
  }, {
    lng: -82.6155,
    lat: 38.4364
  }, {
    lng: -82.6171,
    lat: 38.4355
  }, {
    lng: -82.6171,
    lat: 38.436
  }, {
    lng: -82.6171,
    lat: 38.436
  }, {
    lng: -82.6179,
    lat: 38.4354
  }, {
    lng: -82.6179,
    lat: 38.4353
  }, {
    lng: -82.618,
    lat: 38.4353
  }, {
    lng: -82.6181,
    lat: 38.4352
  }, {
    lng: -82.6183,
    lat: 38.4352
  }, {
    lng: -82.6187,
    lat: 38.4351
  }, {
    lng: -82.619,
    lat: 38.4352
  }, {
    lng: -82.6201,
    lat: 38.4355
  }, {
    lng: -82.6204,
    lat: 38.4356
  }, {
    lng: -82.6207,
    lat: 38.4356
  }, {
    lng: -82.6206,
    lat: 38.4377
  }, {
    lng: -82.6205,
    lat: 38.4391
  }, {
    lng: -82.6205,
    lat: 38.4392
  }, {
    lng: -82.6213,
    lat: 38.4391
  }, {
    lng: -82.6216,
    lat: 38.4389
  }, {
    lng: -82.6218,
    lat: 38.4387
  }, {
    lng: -82.6219,
    lat: 38.4384
  }, {
    lng: -82.6221,
    lat: 38.4382
  }, {
    lng: -82.6224,
    lat: 38.438
  }, {
    lng: -82.6225,
    lat: 38.438
  }, {
    lng: -82.6227,
    lat: 38.438
  }, {
    lng: -82.6229,
    lat: 38.4382
  }, {
    lng: -82.6231,
    lat: 38.4384
  }, {
    lng: -82.6233,
    lat: 38.4387
  }, {
    lng: -82.6234,
    lat: 38.4387
  }, {
    lng: -82.6236,
    lat: 38.4388
  }, {
    lng: -82.6239,
    lat: 38.4388
  }, {
    lng: -82.6243,
    lat: 38.4387
  }, {
    lng: -82.6246,
    lat: 38.4385
  }, {
    lng: -82.625,
    lat: 38.4383
  }, {
    lng: -82.6252,
    lat: 38.438
  }, {
    lng: -82.6254,
    lat: 38.4377
  }, {
    lng: -82.6257,
    lat: 38.4375
  }, {
    lng: -82.6259,
    lat: 38.4372
  }, {
    lng: -82.6263,
    lat: 38.437
  }, {
    lng: -82.6265,
    lat: 38.4368
  }, {
    lng: -82.627,
    lat: 38.4367
  }, {
    lng: -82.6276,
    lat: 38.4366
  }, {
    lng: -82.6278,
    lat: 38.4365
  }, {
    lng: -82.6288,
    lat: 38.4366
  }, {
    lng: -82.6292,
    lat: 38.4367
  }, {
    lng: -82.6296,
    lat: 38.4368
  }, {
    lng: -82.6304,
    lat: 38.437
  }, {
    lng: -82.6305,
    lat: 38.437
  }, {
    lng: -82.631,
    lat: 38.437
  }, {
    lng: -82.6314,
    lat: 38.437
  }, {
    lng: -82.6311,
    lat: 38.4368
  }, {
    lng: -82.6309,
    lat: 38.4367
  }, {
    lng: -82.6306,
    lat: 38.4364
  }, {
    lng: -82.6304,
    lat: 38.4361
  }, {
    lng: -82.6309,
    lat: 38.4362
  }, {
    lng: -82.631,
    lat: 38.4362
  }, {
    lng: -82.6334,
    lat: 38.4361
  }, {
    lng: -82.634,
    lat: 38.4358
  }, {
    lng: -82.6342,
    lat: 38.4357
  }, {
    lng: -82.635,
    lat: 38.4353
  }, {
    lng: -82.6353,
    lat: 38.4348
  }, {
    lng: -82.6354,
    lat: 38.4347
  }, {
    lng: -82.6357,
    lat: 38.4342
  }, {
    lng: -82.6362,
    lat: 38.4331
  }, {
    lng: -82.6365,
    lat: 38.4327
  }, {
    lng: -82.637,
    lat: 38.4324
  }, {
    lng: -82.6384,
    lat: 38.4318
  }, {
    lng: -82.6397,
    lat: 38.4315
  }, {
    lng: -82.6417,
    lat: 38.4312
  }, {
    lng: -82.6444,
    lat: 38.4312
  }, {
    lng: -82.6449,
    lat: 38.4311
  }, {
    lng: -82.645,
    lat: 38.4311
  }, {
    lng: -82.6452,
    lat: 38.4311
  }, {
    lng: -82.6458,
    lat: 38.4309
  }, {
    lng: -82.6464,
    lat: 38.4306
  }, {
    lng: -82.648,
    lat: 38.4299
  }, {
    lng: -82.6483,
    lat: 38.4298
  }, {
    lng: -82.6496,
    lat: 38.4294
  }, {
    lng: -82.6515,
    lat: 38.4289
  }, {
    lng: -82.6521,
    lat: 38.4287
  }, {
    lng: -82.6528,
    lat: 38.4283
  }, {
    lng: -82.6529,
    lat: 38.4283
  }, {
    lng: -82.6539,
    lat: 38.4276
  }, {
    lng: -82.6546,
    lat: 38.4283
  }, {
    lng: -82.6571,
    lat: 38.4305
  }, {
    lng: -82.6574,
    lat: 38.4307
  }, {
    lng: -82.658,
    lat: 38.4307
  }, {
    lng: -82.6588,
    lat: 38.4304
  }, {
    lng: -82.661,
    lat: 38.4304
  }, {
    lng: -82.6626,
    lat: 38.4303
  }, {
    lng: -82.6627,
    lat: 38.4303
  }, {
    lng: -82.6629,
    lat: 38.4294
  }, {
    lng: -82.6636,
    lat: 38.4278
  }, {
    lng: -82.6642,
    lat: 38.4275
  }, {
    lng: -82.6644,
    lat: 38.4275
  }, {
    lng: -82.666,
    lat: 38.427
  }, {
    lng: -82.667,
    lat: 38.4267
  }, {
    lng: -82.6676,
    lat: 38.4261
  }, {
    lng: -82.6685,
    lat: 38.4249
  }, {
    lng: -82.6686,
    lat: 38.4246
  }, {
    lng: -82.669,
    lat: 38.4234
  }, {
    lng: -82.6696,
    lat: 38.4218
  }, {
    lng: -82.6698,
    lat: 38.4209
  }, {
    lng: -82.6676,
    lat: 38.4202
  }, {
    lng: -82.6667,
    lat: 38.4199
  }, {
    lng: -82.6661,
    lat: 38.4195
  }, {
    lng: -82.6649,
    lat: 38.4187
  }, {
    lng: -82.6642,
    lat: 38.4184
  }, {
    lng: -82.6635,
    lat: 38.4182
  }, {
    lng: -82.6631,
    lat: 38.4182
  }, {
    lng: -82.6621,
    lat: 38.418
  }, {
    lng: -82.6615,
    lat: 38.4179
  }, {
    lng: -82.6611,
    lat: 38.4176
  }, {
    lng: -82.6611,
    lat: 38.4174
  }, {
    lng: -82.6615,
    lat: 38.4175
  }, {
    lng: -82.662,
    lat: 38.4175
  }, {
    lng: -82.6624,
    lat: 38.4173
  }, {
    lng: -82.663,
    lat: 38.4169
  }, {
    lng: -82.6639,
    lat: 38.4162
  }, {
    lng: -82.6647,
    lat: 38.4159
  }, {
    lng: -82.6676,
    lat: 38.4147
  }, {
    lng: -82.668,
    lat: 38.4142
  }, {
    lng: -82.6683,
    lat: 38.413
  }, {
    lng: -82.6684,
    lat: 38.4125
  }, {
    lng: -82.6686,
    lat: 38.412
  }, {
    lng: -82.6695,
    lat: 38.4114
  }, {
    lng: -82.67,
    lat: 38.4109
  }, {
    lng: -82.67,
    lat: 38.4108
  }, {
    lng: -82.6698,
    lat: 38.4108
  }, {
    lng: -82.6697,
    lat: 38.4108
  }, {
    lng: -82.6696,
    lat: 38.4108
  }, {
    lng: -82.6696,
    lat: 38.4108
  }, {
    lng: -82.6694,
    lat: 38.4107
  }, {
    lng: -82.6694,
    lat: 38.4107
  }, {
    lng: -82.6693,
    lat: 38.4107
  }, {
    lng: -82.6692,
    lat: 38.4106
  }, {
    lng: -82.6691,
    lat: 38.4105
  }, {
    lng: -82.6688,
    lat: 38.4103
  }, {
    lng: -82.6686,
    lat: 38.4102
  }, {
    lng: -82.6685,
    lat: 38.4101
  }, {
    lng: -82.6684,
    lat: 38.4099
  }, {
    lng: -82.6682,
    lat: 38.4097
  }, {
    lng: -82.6681,
    lat: 38.4097
  }, {
    lng: -82.668,
    lat: 38.4096
  }, {
    lng: -82.6679,
    lat: 38.4095
  }, {
    lng: -82.6678,
    lat: 38.4095
  }, {
    lng: -82.6677,
    lat: 38.4094
  }, {
    lng: -82.6677,
    lat: 38.4094
  }, {
    lng: -82.6675,
    lat: 38.4094
  }, {
    lng: -82.6673,
    lat: 38.4093
  }, {
    lng: -82.6671,
    lat: 38.4092
  }, {
    lng: -82.667,
    lat: 38.4091
  }, {
    lng: -82.6668,
    lat: 38.409
  }, {
    lng: -82.6663,
    lat: 38.4087
  }, {
    lng: -82.6659,
    lat: 38.4085
  }, {
    lng: -82.6657,
    lat: 38.4084
  }, {
    lng: -82.6655,
    lat: 38.4083
  }, {
    lng: -82.665,
    lat: 38.4082
  }, {
    lng: -82.6648,
    lat: 38.4081
  }, {
    lng: -82.6646,
    lat: 38.408
  }, {
    lng: -82.6641,
    lat: 38.4078
  }, {
    lng: -82.6639,
    lat: 38.4077
  }, {
    lng: -82.6637,
    lat: 38.4076
  }, {
    lng: -82.6635,
    lat: 38.4075
  }, {
    lng: -82.6631,
    lat: 38.4073
  }, {
    lng: -82.6628,
    lat: 38.4071
  }, {
    lng: -82.6625,
    lat: 38.407
  }, {
    lng: -82.6622,
    lat: 38.4069
  }, {
    lng: -82.6619,
    lat: 38.4067
  }, {
    lng: -82.6617,
    lat: 38.4066
  }, {
    lng: -82.6614,
    lat: 38.4065
  }, {
    lng: -82.6613,
    lat: 38.4064
  }, {
    lng: -82.6611,
    lat: 38.4064
  }, {
    lng: -82.6609,
    lat: 38.4062
  }, {
    lng: -82.6607,
    lat: 38.4061
  }, {
    lng: -82.6606,
    lat: 38.4059
  }, {
    lng: -82.6605,
    lat: 38.4059
  }, {
    lng: -82.6604,
    lat: 38.4058
  }, {
    lng: -82.6603,
    lat: 38.4057
  }, {
    lng: -82.6603,
    lat: 38.4056
  }, {
    lng: -82.6607,
    lat: 38.4055
  }, {
    lng: -82.6603,
    lat: 38.4053
  }, {
    lng: -82.6597,
    lat: 38.4046
  }, {
    lng: -82.659,
    lat: 38.4036
  }, {
    lng: -82.6578,
    lat: 38.402
  }, {
    lng: -82.6566,
    lat: 38.4003
  }, {
    lng: -82.6563,
    lat: 38.4001
  }, {
    lng: -82.6555,
    lat: 38.3996
  }, {
    lng: -82.6551,
    lat: 38.3996
  }, {
    lng: -82.655,
    lat: 38.3996
  }, {
    lng: -82.6549,
    lat: 38.3996
  }, {
    lng: -82.6548,
    lat: 38.3995
  }, {
    lng: -82.6548,
    lat: 38.3994
  }, {
    lng: -82.6549,
    lat: 38.3993
  }, {
    lng: -82.6551,
    lat: 38.3992
  }, {
    lng: -82.6552,
    lat: 38.3991
  }, {
    lng: -82.6554,
    lat: 38.399
  }, {
    lng: -82.6555,
    lat: 38.3989
  }, {
    lng: -82.6557,
    lat: 38.3989
  }, {
    lng: -82.6581,
    lat: 38.3989
  }, {
    lng: -82.6582,
    lat: 38.3989
  }, {
    lng: -82.6588,
    lat: 38.3988
  }, {
    lng: -82.6596,
    lat: 38.3986
  }, {
    lng: -82.6602,
    lat: 38.3983
  }, {
    lng: -82.6609,
    lat: 38.3983
  }, {
    lng: -82.6617,
    lat: 38.3983
  }, {
    lng: -82.6625,
    lat: 38.3985
  }, {
    lng: -82.663,
    lat: 38.3985
  }, {
    lng: -82.6627,
    lat: 38.3981
  }, {
    lng: -82.6626,
    lat: 38.398
  }, {
    lng: -82.6625,
    lat: 38.3977
  }, {
    lng: -82.6623,
    lat: 38.3971
  }, {
    lng: -82.6622,
    lat: 38.3966
  }, {
    lng: -82.6621,
    lat: 38.3963
  }, {
    lng: -82.6614,
    lat: 38.3957
  }, {
    lng: -82.6615,
    lat: 38.3954
  }, {
    lng: -82.6616,
    lat: 38.3952
  }, {
    lng: -82.6621,
    lat: 38.3947
  }, {
    lng: -82.6622,
    lat: 38.3944
  }, {
    lng: -82.6621,
    lat: 38.3933
  }, {
    lng: -82.662,
    lat: 38.3924
  }, {
    lng: -82.6621,
    lat: 38.3919
  }, {
    lng: -82.6624,
    lat: 38.3914
  }, {
    lng: -82.6629,
    lat: 38.3904
  }, {
    lng: -82.6631,
    lat: 38.39
  }, {
    lng: -82.6635,
    lat: 38.3896
  }, {
    lng: -82.664,
    lat: 38.3893
  }, {
    lng: -82.6642,
    lat: 38.3889
  }, {
    lng: -82.6644,
    lat: 38.3884
  }, {
    lng: -82.6644,
    lat: 38.3882
  }, {
    lng: -82.6644,
    lat: 38.3881
  }, {
    lng: -82.6638,
    lat: 38.3877
  }, {
    lng: -82.6636,
    lat: 38.3878
  }, {
    lng: -82.6633,
    lat: 38.3878
  }, {
    lng: -82.6629,
    lat: 38.3877
  }, {
    lng: -82.6614,
    lat: 38.3878
  }, {
    lng: -82.6609,
    lat: 38.3879
  }, {
    lng: -82.6607,
    lat: 38.3879
  }, {
    lng: -82.6606,
    lat: 38.3878
  }, {
    lng: -82.6606,
    lat: 38.3874
  }, {
    lng: -82.6609,
    lat: 38.3869
  }, {
    lng: -82.6616,
    lat: 38.3863
  }, {
    lng: -82.6622,
    lat: 38.3858
  }, {
    lng: -82.6625,
    lat: 38.3855
  }, {
    lng: -82.6621,
    lat: 38.3851
  }, {
    lng: -82.6612,
    lat: 38.3847
  }, {
    lng: -82.6603,
    lat: 38.3844
  }, {
    lng: -82.659,
    lat: 38.3841
  }, {
    lng: -82.6582,
    lat: 38.3837
  }, {
    lng: -82.6578,
    lat: 38.3833
  }, {
    lng: -82.6578,
    lat: 38.3826
  }, {
    lng: -82.6579,
    lat: 38.3824
  }, {
    lng: -82.6585,
    lat: 38.3817
  }, {
    lng: -82.6588,
    lat: 38.3813
  }, {
    lng: -82.659,
    lat: 38.3812
  }, {
    lng: -82.6593,
    lat: 38.3812
  }, {
    lng: -82.6603,
    lat: 38.3815
  }, {
    lng: -82.6608,
    lat: 38.3815
  }, {
    lng: -82.6616,
    lat: 38.3812
  }, {
    lng: -82.662,
    lat: 38.381
  }, {
    lng: -82.6622,
    lat: 38.3807
  }, {
    lng: -82.6615,
    lat: 38.3795
  }, {
    lng: -82.6609,
    lat: 38.3786
  }, {
    lng: -82.6612,
    lat: 38.3785
  }, {
    lng: -82.6617,
    lat: 38.3783
  }, {
    lng: -82.6623,
    lat: 38.3781
  }, {
    lng: -82.6628,
    lat: 38.378
  }, {
    lng: -82.6634,
    lat: 38.3778
  }, {
    lng: -82.6639,
    lat: 38.3777
  }, {
    lng: -82.6646,
    lat: 38.3775
  }, {
    lng: -82.6653,
    lat: 38.3774
  }, {
    lng: -82.6662,
    lat: 38.3772
  }, {
    lng: -82.6671,
    lat: 38.377
  }, {
    lng: -82.6681,
    lat: 38.3769
  }, {
    lng: -82.6692,
    lat: 38.3767
  }, {
    lng: -82.6706,
    lat: 38.3764
  }, {
    lng: -82.6716,
    lat: 38.3762
  }, {
    lng: -82.6727,
    lat: 38.376
  }, {
    lng: -82.6734,
    lat: 38.3759
  }, {
    lng: -82.6743,
    lat: 38.3757
  }, {
    lng: -82.6756,
    lat: 38.3755
  }, {
    lng: -82.6775,
    lat: 38.3751
  }, {
    lng: -82.6802,
    lat: 38.3747
  }, {
    lng: -82.6808,
    lat: 38.3746
  }, {
    lng: -82.6814,
    lat: 38.3744
  }, {
    lng: -82.6818,
    lat: 38.3743
  }, {
    lng: -82.6821,
    lat: 38.3743
  }, {
    lng: -82.6831,
    lat: 38.374
  }, {
    lng: -82.684,
    lat: 38.3738
  }, {
    lng: -82.685,
    lat: 38.3735
  }, {
    lng: -82.6853,
    lat: 38.3734
  }, {
    lng: -82.6866,
    lat: 38.373
  }, {
    lng: -82.6871,
    lat: 38.3729
  }, {
    lng: -82.6907,
    lat: 38.3718
  }, {
    lng: -82.6911,
    lat: 38.3717
  }, {
    lng: -82.6945,
    lat: 38.3707
  }, {
    lng: -82.6961,
    lat: 38.3702
  }, {
    lng: -82.6973,
    lat: 38.3698
  }, {
    lng: -82.6984,
    lat: 38.3695
  }, {
    lng: -82.6987,
    lat: 38.3694
  }, {
    lng: -82.6989,
    lat: 38.3693
  }, {
    lng: -82.6989,
    lat: 38.3693
  }, {
    lng: -82.6988,
    lat: 38.3691
  }, {
    lng: -82.6987,
    lat: 38.3688
  }, {
    lng: -82.6986,
    lat: 38.3687
  }, {
    lng: -82.6986,
    lat: 38.3684
  }, {
    lng: -82.6986,
    lat: 38.3679
  }, {
    lng: -82.6986,
    lat: 38.3675
  }, {
    lng: -82.6989,
    lat: 38.3674
  }, {
    lng: -82.6989,
    lat: 38.3672
  }, {
    lng: -82.6989,
    lat: 38.3668
  }, {
    lng: -82.6989,
    lat: 38.3665
  }, {
    lng: -82.6989,
    lat: 38.3663
  }, {
    lng: -82.699,
    lat: 38.366
  }, {
    lng: -82.6989,
    lat: 38.3659
  }, {
    lng: -82.6989,
    lat: 38.3657
  }, {
    lng: -82.6989,
    lat: 38.3656
  }, {
    lng: -82.6989,
    lat: 38.3648
  }, {
    lng: -82.6989,
    lat: 38.3646
  }, {
    lng: -82.6988,
    lat: 38.3643
  }, {
    lng: -82.6985,
    lat: 38.3635
  }, {
    lng: -82.6982,
    lat: 38.3629
  }, {
    lng: -82.6982,
    lat: 38.3628
  }, {
    lng: -82.6981,
    lat: 38.3627
  }, {
    lng: -82.6981,
    lat: 38.3626
  }, {
    lng: -82.6981,
    lat: 38.3625
  }, {
    lng: -82.698,
    lat: 38.3624
  }, {
    lng: -82.698,
    lat: 38.3623
  }, {
    lng: -82.698,
    lat: 38.3622
  }, {
    lng: -82.698,
    lat: 38.3621
  }, {
    lng: -82.6979,
    lat: 38.362
  }, {
    lng: -82.6979,
    lat: 38.3619
  }, {
    lng: -82.6979,
    lat: 38.3618
  }, {
    lng: -82.6979,
    lat: 38.3617
  }, {
    lng: -82.6979,
    lat: 38.3616
  }, {
    lng: -82.6979,
    lat: 38.3615
  }, {
    lng: -82.6979,
    lat: 38.3613
  }, {
    lng: -82.6979,
    lat: 38.3611
  }, {
    lng: -82.6979,
    lat: 38.3608
  }, {
    lng: -82.6979,
    lat: 38.3607
  }, {
    lng: -82.6979,
    lat: 38.3606
  }, {
    lng: -82.6978,
    lat: 38.3605
  }, {
    lng: -82.6978,
    lat: 38.3603
  }, {
    lng: -82.6978,
    lat: 38.3602
  }, {
    lng: -82.6978,
    lat: 38.36
  }, {
    lng: -82.6977,
    lat: 38.3596
  }, {
    lng: -82.6976,
    lat: 38.3593
  }, {
    lng: -82.6975,
    lat: 38.3589
  }, {
    lng: -82.6975,
    lat: 38.3587
  }, {
    lng: -82.6974,
    lat: 38.3585
  }, {
    lng: -82.6973,
    lat: 38.358
  }, {
    lng: -82.6972,
    lat: 38.3578
  }, {
    lng: -82.6972,
    lat: 38.3569
  }, {
    lng: -82.6961,
    lat: 38.3569
  }, {
    lng: -82.6958,
    lat: 38.3568
  }, {
    lng: -82.6954,
    lat: 38.3567
  }, {
    lng: -82.6953,
    lat: 38.3567
  }, {
    lng: -82.6952,
    lat: 38.3567
  }, {
    lng: -82.6951,
    lat: 38.3567
  }, {
    lng: -82.695,
    lat: 38.3567
  }, {
    lng: -82.6949,
    lat: 38.3567
  }, {
    lng: -82.6948,
    lat: 38.3568
  }, {
    lng: -82.6947,
    lat: 38.3569
  }, {
    lng: -82.6945,
    lat: 38.357
  }, {
    lng: -82.6944,
    lat: 38.3571
  }, {
    lng: -82.6943,
    lat: 38.3572
  }, {
    lng: -82.6942,
    lat: 38.3573
  }, {
    lng: -82.694,
    lat: 38.3573
  }, {
    lng: -82.6939,
    lat: 38.3574
  }, {
    lng: -82.6938,
    lat: 38.3574
  }, {
    lng: -82.6936,
    lat: 38.3575
  }, {
    lng: -82.6924,
    lat: 38.3578
  }, {
    lng: -82.6918,
    lat: 38.358
  }, {
    lng: -82.6915,
    lat: 38.3581
  }, {
    lng: -82.6913,
    lat: 38.3581
  }, {
    lng: -82.6913,
    lat: 38.3575
  }, {
    lng: -82.6887,
    lat: 38.3572
  }, {
    lng: -82.6886,
    lat: 38.3575
  }, {
    lng: -82.6885,
    lat: 38.3576
  }, {
    lng: -82.6885,
    lat: 38.3577
  }, {
    lng: -82.6885,
    lat: 38.3578
  }, {
    lng: -82.6885,
    lat: 38.358
  }, {
    lng: -82.6885,
    lat: 38.358
  }, {
    lng: -82.6886,
    lat: 38.3581
  }, {
    lng: -82.6885,
    lat: 38.3582
  }, {
    lng: -82.6884,
    lat: 38.3583
  }, {
    lng: -82.6883,
    lat: 38.3585
  }, {
    lng: -82.6882,
    lat: 38.3592
  }, {
    lng: -82.6881,
    lat: 38.3597
  }, {
    lng: -82.6881,
    lat: 38.3599
  }, {
    lng: -82.6882,
    lat: 38.3601
  }, {
    lng: -82.6882,
    lat: 38.3602
  }, {
    lng: -82.6883,
    lat: 38.3604
  }, {
    lng: -82.6884,
    lat: 38.3607
  }, {
    lng: -82.6885,
    lat: 38.3609
  }, {
    lng: -82.6885,
    lat: 38.3611
  }, {
    lng: -82.6886,
    lat: 38.3617
  }, {
    lng: -82.6886,
    lat: 38.3625
  }, {
    lng: -82.6886,
    lat: 38.3627
  }, {
    lng: -82.6886,
    lat: 38.3628
  }, {
    lng: -82.6886,
    lat: 38.363
  }, {
    lng: -82.6881,
    lat: 38.3632
  }, {
    lng: -82.6878,
    lat: 38.3634
  }, {
    lng: -82.6878,
    lat: 38.3636
  }, {
    lng: -82.6873,
    lat: 38.364
  }, {
    lng: -82.6853,
    lat: 38.365
  }, {
    lng: -82.6834,
    lat: 38.3655
  }, {
    lng: -82.6826,
    lat: 38.3658
  }, {
    lng: -82.6821,
    lat: 38.3658
  }, {
    lng: -82.6815,
    lat: 38.3656
  }, {
    lng: -82.6803,
    lat: 38.3652
  }, {
    lng: -82.68,
    lat: 38.3649
  }, {
    lng: -82.6798,
    lat: 38.3649
  }, {
    lng: -82.6791,
    lat: 38.3646
  }, {
    lng: -82.677,
    lat: 38.3628
  }, {
    lng: -82.6765,
    lat: 38.3626
  }, {
    lng: -82.6755,
    lat: 38.3624
  }, {
    lng: -82.6715,
    lat: 38.3627
  }, {
    lng: -82.6701,
    lat: 38.3631
  }, {
    lng: -82.668,
    lat: 38.3634
  }, {
    lng: -82.6676,
    lat: 38.3636
  }, {
    lng: -82.6674,
    lat: 38.3639
  }, {
    lng: -82.6672,
    lat: 38.3654
  }, {
    lng: -82.6659,
    lat: 38.366
  }, {
    lng: -82.6653,
    lat: 38.3662
  }, {
    lng: -82.6649,
    lat: 38.3661
  }, {
    lng: -82.6647,
    lat: 38.3659
  }, {
    lng: -82.6642,
    lat: 38.3659
  }, {
    lng: -82.6641,
    lat: 38.366
  }, {
    lng: -82.6615,
    lat: 38.3685
  }, {
    lng: -82.6611,
    lat: 38.3693
  }, {
    lng: -82.6612,
    lat: 38.3698
  }, {
    lng: -82.6613,
    lat: 38.3699
  }, {
    lng: -82.6613,
    lat: 38.3699
  }, {
    lng: -82.6612,
    lat: 38.3701
  }, {
    lng: -82.6609,
    lat: 38.3703
  }, {
    lng: -82.6607,
    lat: 38.3704
  }, {
    lng: -82.6606,
    lat: 38.3705
  }, {
    lng: -82.6604,
    lat: 38.3706
  }, {
    lng: -82.6603,
    lat: 38.3707
  }, {
    lng: -82.6602,
    lat: 38.3707
  }, {
    lng: -82.6601,
    lat: 38.3707
  }, {
    lng: -82.6599,
    lat: 38.3707
  }, {
    lng: -82.6597,
    lat: 38.3708
  }, {
    lng: -82.6589,
    lat: 38.3709
  }, {
    lng: -82.6587,
    lat: 38.3709
  }, {
    lng: -82.6585,
    lat: 38.3709
  }, {
    lng: -82.6583,
    lat: 38.3709
  }, {
    lng: -82.658,
    lat: 38.3709
  }, {
    lng: -82.6576,
    lat: 38.3708
  }, {
    lng: -82.6573,
    lat: 38.3707
  }, {
    lng: -82.657,
    lat: 38.3707
  }, {
    lng: -82.6565,
    lat: 38.3706
  }, {
    lng: -82.656,
    lat: 38.3705
  }, {
    lng: -82.6557,
    lat: 38.3704
  }, {
    lng: -82.6551,
    lat: 38.3703
  }, {
    lng: -82.6548,
    lat: 38.3702
  }, {
    lng: -82.6544,
    lat: 38.3699
  }, {
    lng: -82.6543,
    lat: 38.3698
  }, {
    lng: -82.6542,
    lat: 38.3696
  }, {
    lng: -82.6541,
    lat: 38.3695
  }, {
    lng: -82.654,
    lat: 38.3693
  }, {
    lng: -82.6539,
    lat: 38.3692
  }, {
    lng: -82.6538,
    lat: 38.3687
  }, {
    lng: -82.6538,
    lat: 38.3686
  }, {
    lng: -82.6537,
    lat: 38.3685
  }, {
    lng: -82.6536,
    lat: 38.3684
  }, {
    lng: -82.6535,
    lat: 38.3684
  }, {
    lng: -82.6534,
    lat: 38.3683
  }, {
    lng: -82.6533,
    lat: 38.3683
  }, {
    lng: -82.6532,
    lat: 38.3682
  }, {
    lng: -82.653,
    lat: 38.3679
  }, {
    lng: -82.6528,
    lat: 38.3678
  }, {
    lng: -82.6527,
    lat: 38.3678
  }, {
    lng: -82.6526,
    lat: 38.3678
  }, {
    lng: -82.6525,
    lat: 38.3678
  }, {
    lng: -82.6524,
    lat: 38.3678
  }, {
    lng: -82.6523,
    lat: 38.3679
  }, {
    lng: -82.6522,
    lat: 38.3679
  }, {
    lng: -82.6522,
    lat: 38.3681
  }, {
    lng: -82.6522,
    lat: 38.3685
  }, {
    lng: -82.6522,
    lat: 38.3687
  }, {
    lng: -82.6522,
    lat: 38.3688
  }, {
    lng: -82.652,
    lat: 38.3694
  }, {
    lng: -82.6519,
    lat: 38.3694
  }, {
    lng: -82.6518,
    lat: 38.3694
  }, {
    lng: -82.6517,
    lat: 38.3695
  }, {
    lng: -82.6516,
    lat: 38.3695
  }, {
    lng: -82.6515,
    lat: 38.3695
  }, {
    lng: -82.6514,
    lat: 38.3695
  }, {
    lng: -82.6508,
    lat: 38.3693
  }, {
    lng: -82.6507,
    lat: 38.3693
  }, {
    lng: -82.6506,
    lat: 38.3694
  }, {
    lng: -82.6506,
    lat: 38.3695
  }, {
    lng: -82.6506,
    lat: 38.3696
  }, {
    lng: -82.6505,
    lat: 38.3698
  }, {
    lng: -82.6505,
    lat: 38.3702
  }, {
    lng: -82.6505,
    lat: 38.3703
  }, {
    lng: -82.6505,
    lat: 38.3703
  }, {
    lng: -82.6505,
    lat: 38.3703
  }, {
    lng: -82.6505,
    lat: 38.3703
  }, {
    lng: -82.6505,
    lat: 38.3703
  }, {
    lng: -82.6505,
    lat: 38.3703
  }, {
    lng: -82.6505,
    lat: 38.3703
  }, {
    lng: -82.6505,
    lat: 38.3703
  }, {
    lng: -82.6505,
    lat: 38.3703
  }, {
    lng: -82.6504,
    lat: 38.3703
  }, {
    lng: -82.6504,
    lat: 38.3703
  }, {
    lng: -82.6504,
    lat: 38.3703
  }, {
    lng: -82.6503,
    lat: 38.3702
  }, {
    lng: -82.6502,
    lat: 38.3699
  }, {
    lng: -82.6501,
    lat: 38.3697
  }, {
    lng: -82.6501,
    lat: 38.3694
  }, {
    lng: -82.6501,
    lat: 38.3693
  }, {
    lng: -82.6502,
    lat: 38.3688
  }, {
    lng: -82.6504,
    lat: 38.3684
  }, {
    lng: -82.6505,
    lat: 38.3679
  }, {
    lng: -82.6509,
    lat: 38.3667
  }, {
    lng: -82.6511,
    lat: 38.3658
  }, {
    lng: -82.6509,
    lat: 38.3653
  }, {
    lng: -82.6508,
    lat: 38.3651
  }, {
    lng: -82.6506,
    lat: 38.3649
  }, {
    lng: -82.6505,
    lat: 38.365
  }, {
    lng: -82.65,
    lat: 38.3651
  }, {
    lng: -82.6489,
    lat: 38.3647
  }, {
    lng: -82.6484,
    lat: 38.3644
  }, {
    lng: -82.6467,
    lat: 38.3636
  }, {
    lng: -82.6462,
    lat: 38.3634
  }, {
    lng: -82.6458,
    lat: 38.3634
  }, {
    lng: -82.6449,
    lat: 38.3639
  }, {
    lng: -82.6444,
    lat: 38.364
  }, {
    lng: -82.6437,
    lat: 38.3641
  }, {
    lng: -82.6432,
    lat: 38.3639
  }, {
    lng: -82.6428,
    lat: 38.3636
  }, {
    lng: -82.6426,
    lat: 38.3633
  }, {
    lng: -82.6422,
    lat: 38.3621
  }, {
    lng: -82.6419,
    lat: 38.3619
  }, {
    lng: -82.6415,
    lat: 38.3604
  }, {
    lng: -82.641,
    lat: 38.3597
  }, {
    lng: -82.6408,
    lat: 38.3595
  }, {
    lng: -82.6405,
    lat: 38.3594
  }, {
    lng: -82.6391,
    lat: 38.3591
  }, {
    lng: -82.6382,
    lat: 38.3582
  }, {
    lng: -82.6367,
    lat: 38.3571
  }, {
    lng: -82.6359,
    lat: 38.3566
  }, {
    lng: -82.6351,
    lat: 38.3564
  }, {
    lng: -82.634,
    lat: 38.3565
  }, {
    lng: -82.6325,
    lat: 38.3568
  }, {
    lng: -82.6313,
    lat: 38.3572
  }, {
    lng: -82.6301,
    lat: 38.358
  }, {
    lng: -82.6293,
    lat: 38.3585
  }, {
    lng: -82.6283,
    lat: 38.3589
  }, {
    lng: -82.6282,
    lat: 38.359
  }, {
    lng: -82.628,
    lat: 38.3591
  }, {
    lng: -82.6278,
    lat: 38.3592
  }, {
    lng: -82.6275,
    lat: 38.3594
  }, {
    lng: -82.6273,
    lat: 38.3596
  }, {
    lng: -82.6271,
    lat: 38.3598
  }, {
    lng: -82.6268,
    lat: 38.3601
  }, {
    lng: -82.6266,
    lat: 38.3602
  }, {
    lng: -82.6265,
    lat: 38.3602
  }, {
    lng: -82.6262,
    lat: 38.3603
  }, {
    lng: -82.6249,
    lat: 38.3605
  }, {
    lng: -82.6225,
    lat: 38.3608
  }, {
    lng: -82.6224,
    lat: 38.3608
  }, {
    lng: -82.6205,
    lat: 38.3607
  }, {
    lng: -82.6211,
    lat: 38.3618
  }, {
    lng: -82.6232,
    lat: 38.3639
  }, {
    lng: -82.6249,
    lat: 38.3648
  }, {
    lng: -82.6299,
    lat: 38.3674
  }, {
    lng: -82.6319,
    lat: 38.3685
  }, {
    lng: -82.6321,
    lat: 38.3688
  }, {
    lng: -82.6335,
    lat: 38.3704
  }, {
    lng: -82.634,
    lat: 38.3721
  }, {
    lng: -82.6341,
    lat: 38.3742
  }, {
    lng: -82.6336,
    lat: 38.3765
  }, {
    lng: -82.6322,
    lat: 38.3814
  }, {
    lng: -82.632,
    lat: 38.3813
  }, {
    lng: -82.6315,
    lat: 38.3812
  }, {
    lng: -82.6306,
    lat: 38.3809
  }, {
    lng: -82.6302,
    lat: 38.3808
  }, {
    lng: -82.6297,
    lat: 38.3807
  }, {
    lng: -82.6292,
    lat: 38.3806
  }, {
    lng: -82.6286,
    lat: 38.3805
  }, {
    lng: -82.6284,
    lat: 38.3805
  }, {
    lng: -82.6281,
    lat: 38.3804
  }, {
    lng: -82.6275,
    lat: 38.3804
  }, {
    lng: -82.6248,
    lat: 38.3801
  }, {
    lng: -82.6238,
    lat: 38.38
  }, {
    lng: -82.6219,
    lat: 38.3797
  }, {
    lng: -82.6208,
    lat: 38.3796
  }, {
    lng: -82.62,
    lat: 38.3796
  }, {
    lng: -82.6188,
    lat: 38.3795
  }, {
    lng: -82.6186,
    lat: 38.3795
  }, {
    lng: -82.6181,
    lat: 38.3795
  }, {
    lng: -82.6166,
    lat: 38.3795
  }, {
    lng: -82.6155,
    lat: 38.3796
  }, {
    lng: -82.6144,
    lat: 38.3796
  }, {
    lng: -82.6135,
    lat: 38.3796
  }, {
    lng: -82.613,
    lat: 38.3796
  }, {
    lng: -82.6127,
    lat: 38.3796
  }, {
    lng: -82.6125,
    lat: 38.3796
  }, {
    lng: -82.6123,
    lat: 38.3796
  }, {
    lng: -82.6121,
    lat: 38.3796
  }, {
    lng: -82.612,
    lat: 38.3796
  }, {
    lng: -82.6118,
    lat: 38.3796
  }, {
    lng: -82.6117,
    lat: 38.3796
  }, {
    lng: -82.6116,
    lat: 38.3795
  }, {
    lng: -82.6114,
    lat: 38.3795
  }, {
    lng: -82.6113,
    lat: 38.3795
  }, {
    lng: -82.6103,
    lat: 38.3792
  }, {
    lng: -82.6072,
    lat: 38.3784
  }, {
    lng: -82.6071,
    lat: 38.3783
  }, {
    lng: -82.607,
    lat: 38.3783
  }, {
    lng: -82.6069,
    lat: 38.3783
  }, {
    lng: -82.6068,
    lat: 38.3783
  }, {
    lng: -82.6066,
    lat: 38.3784
  }, {
    lng: -82.6065,
    lat: 38.3784
  }, {
    lng: -82.6064,
    lat: 38.3784
  }, {
    lng: -82.6066,
    lat: 38.379
  }, {
    lng: -82.6066,
    lat: 38.3792
  }, {
    lng: -82.6066,
    lat: 38.3793
  }, {
    lng: -82.6066,
    lat: 38.3793
  }, {
    lng: -82.6065,
    lat: 38.3794
  }, {
    lng: -82.6065,
    lat: 38.3794
  }, {
    lng: -82.6065,
    lat: 38.3795
  }, {
    lng: -82.6063,
    lat: 38.3796
  }, {
    lng: -82.606,
    lat: 38.3798
  }, {
    lng: -82.6058,
    lat: 38.3799
  }, {
    lng: -82.6056,
    lat: 38.38
  }, {
    lng: -82.6055,
    lat: 38.38
  }, {
    lng: -82.6053,
    lat: 38.3801
  }, {
    lng: -82.6051,
    lat: 38.3801
  }, {
    lng: -82.6049,
    lat: 38.3802
  }, {
    lng: -82.6047,
    lat: 38.3802
  }, {
    lng: -82.6045,
    lat: 38.3802
  }, {
    lng: -82.6042,
    lat: 38.3802
  }, {
    lng: -82.605,
    lat: 38.3802
  }, {
    lng: -82.6071,
    lat: 38.3802
  }, {
    lng: -82.6071,
    lat: 38.3803
  }, {
    lng: -82.6072,
    lat: 38.3804
  }, {
    lng: -82.6072,
    lat: 38.3805
  }, {
    lng: -82.6076,
    lat: 38.3813
  }, {
    lng: -82.6074,
    lat: 38.3813
  }, {
    lng: -82.6073,
    lat: 38.3813
  }, {
    lng: -82.6072,
    lat: 38.3813
  }, {
    lng: -82.6073,
    lat: 38.3814
  }, {
    lng: -82.6074,
    lat: 38.3815
  }, {
    lng: -82.6075,
    lat: 38.3816
  }, {
    lng: -82.6076,
    lat: 38.3817
  }, {
    lng: -82.6076,
    lat: 38.3817
  }, {
    lng: -82.6077,
    lat: 38.3818
  }, {
    lng: -82.6078,
    lat: 38.382
  }, {
    lng: -82.6083,
    lat: 38.3833
  }, {
    lng: -82.6083,
    lat: 38.3835
  }, {
    lng: -82.6084,
    lat: 38.3837
  }, {
    lng: -82.6084,
    lat: 38.384
  }, {
    lng: -82.6084,
    lat: 38.3842
  }, {
    lng: -82.6084,
    lat: 38.3843
  }, {
    lng: -82.6084,
    lat: 38.3848
  }, {
    lng: -82.6083,
    lat: 38.3853
  }, {
    lng: -82.6083,
    lat: 38.3853
  }, {
    lng: -82.6081,
    lat: 38.3857
  }, {
    lng: -82.6081,
    lat: 38.3858
  }, {
    lng: -82.6075,
    lat: 38.3857
  }, {
    lng: -82.6063,
    lat: 38.3855
  }, {
    lng: -82.6052,
    lat: 38.3849
  }, {
    lng: -82.6042,
    lat: 38.3845
  }, {
    lng: -82.6033,
    lat: 38.3844
  }, {
    lng: -82.6018,
    lat: 38.3841
  }, {
    lng: -82.6014,
    lat: 38.3836
  }, {
    lng: -82.6008,
    lat: 38.383
  }, {
    lng: -82.6006,
    lat: 38.3822
  }, {
    lng: -82.6006,
    lat: 38.3814
  }, {
    lng: -82.6005,
    lat: 38.3814
  }, {
    lng: -82.6004,
    lat: 38.3814
  }, {
    lng: -82.6003,
    lat: 38.3814
  }, {
    lng: -82.6001,
    lat: 38.3814
  }, {
    lng: -82.5999,
    lat: 38.3815
  }, {
    lng: -82.5994,
    lat: 38.3814
  }, {
    lng: -82.599,
    lat: 38.3813
  }, {
    lng: -82.5986,
    lat: 38.3812
  }, {
    lng: -82.5982,
    lat: 38.3812
  }, {
    lng: -82.5979,
    lat: 38.3812
  }, {
    lng: -82.5976,
    lat: 38.3813
  }, {
    lng: -82.5973,
    lat: 38.3814
  }, {
    lng: -82.5969,
    lat: 38.3817
  }, {
    lng: -82.5966,
    lat: 38.3821
  }, {
    lng: -82.5962,
    lat: 38.3823
  }, {
    lng: -82.5958,
    lat: 38.3825
  }, {
    lng: -82.5955,
    lat: 38.3826
  }, {
    lng: -82.5954,
    lat: 38.3827
  }, {
    lng: -82.5954,
    lat: 38.3828
  }, {
    lng: -82.5967,
    lat: 38.3849
  }, {
    lng: -82.5977,
    lat: 38.3862
  }, {
    lng: -82.5986,
    lat: 38.3878
  }, {
    lng: -82.5993,
    lat: 38.3887
  }, {
    lng: -82.5996,
    lat: 38.3895
  }, {
    lng: -82.5997,
    lat: 38.3904
  }, {
    lng: -82.5996,
    lat: 38.3913
  }, {
    lng: -82.5994,
    lat: 38.3925
  }, {
    lng: -82.5992,
    lat: 38.3932
  }, {
    lng: -82.599,
    lat: 38.3937
  }, {
    lng: -82.5988,
    lat: 38.394
  }, {
    lng: -82.5985,
    lat: 38.3944
  }, {
    lng: -82.5978,
    lat: 38.3952
  }, {
    lng: -82.5972,
    lat: 38.3958
  }, {
    lng: -82.5966,
    lat: 38.3961
  }, {
    lng: -82.5961,
    lat: 38.3966
  }, {
    lng: -82.5956,
    lat: 38.397
  }, {
    lng: -82.5951,
    lat: 38.3977
  }, {
    lng: -82.5948,
    lat: 38.3983
  }, {
    lng: -82.5947,
    lat: 38.3988
  }, {
    lng: -82.5945,
    lat: 38.3998
  }]]],
  options: {
    fillColor: '#009aee',
    fillOpacity: 0.4,
    strokeColor: '#0073B3',
    strokeWeight: 1,
    strokeOpacity: 0.4,
    clickable: true,
    visible: true,
    zIndex: 1000
  }
};
var carrierRoute18 = {
  carrierRoute: '41121H061',
  paths: [[[{
    lng: -82.7557,
    lat: 38.4654
  }, {
    lng: -82.7557,
    lat: 38.4657
  }, {
    lng: -82.7558,
    lat: 38.4659
  }, {
    lng: -82.756,
    lat: 38.466
  }, {
    lng: -82.7563,
    lat: 38.4661
  }, {
    lng: -82.7567,
    lat: 38.4662
  }, {
    lng: -82.7569,
    lat: 38.4663
  }, {
    lng: -82.757,
    lat: 38.4664
  }, {
    lng: -82.7571,
    lat: 38.4666
  }, {
    lng: -82.7568,
    lat: 38.4668
  }, {
    lng: -82.7563,
    lat: 38.4672
  }, {
    lng: -82.756,
    lat: 38.4676
  }, {
    lng: -82.7558,
    lat: 38.4679
  }, {
    lng: -82.7557,
    lat: 38.4681
  }, {
    lng: -82.7556,
    lat: 38.4684
  }, {
    lng: -82.7557,
    lat: 38.4686
  }, {
    lng: -82.7559,
    lat: 38.4688
  }, {
    lng: -82.7563,
    lat: 38.469
  }, {
    lng: -82.7571,
    lat: 38.4691
  }, {
    lng: -82.7575,
    lat: 38.4691
  }, {
    lng: -82.7588,
    lat: 38.4685
  }, {
    lng: -82.759,
    lat: 38.4684
  }, {
    lng: -82.7598,
    lat: 38.4675
  }, {
    lng: -82.7605,
    lat: 38.4672
  }, {
    lng: -82.7609,
    lat: 38.4671
  }, {
    lng: -82.7613,
    lat: 38.4671
  }, {
    lng: -82.7619,
    lat: 38.467
  }, {
    lng: -82.7624,
    lat: 38.4669
  }, {
    lng: -82.7631,
    lat: 38.4669
  }, {
    lng: -82.7646,
    lat: 38.4665
  }, {
    lng: -82.765,
    lat: 38.4665
  }, {
    lng: -82.7652,
    lat: 38.4666
  }, {
    lng: -82.7653,
    lat: 38.4668
  }, {
    lng: -82.7653,
    lat: 38.467
  }, {
    lng: -82.7646,
    lat: 38.4676
  }, {
    lng: -82.7646,
    lat: 38.4679
  }, {
    lng: -82.7646,
    lat: 38.4681
  }, {
    lng: -82.7648,
    lat: 38.4683
  }, {
    lng: -82.7655,
    lat: 38.4684
  }, {
    lng: -82.7658,
    lat: 38.4686
  }, {
    lng: -82.7659,
    lat: 38.4688
  }, {
    lng: -82.7658,
    lat: 38.4692
  }, {
    lng: -82.7653,
    lat: 38.4706
  }, {
    lng: -82.765,
    lat: 38.4708
  }, {
    lng: -82.7647,
    lat: 38.4708
  }, {
    lng: -82.7642,
    lat: 38.4707
  }, {
    lng: -82.7639,
    lat: 38.47
  }, {
    lng: -82.7636,
    lat: 38.4698
  }, {
    lng: -82.7632,
    lat: 38.4697
  }, {
    lng: -82.7629,
    lat: 38.4699
  }, {
    lng: -82.7619,
    lat: 38.4711
  }, {
    lng: -82.7615,
    lat: 38.4716
  }, {
    lng: -82.7615,
    lat: 38.4721
  }, {
    lng: -82.7616,
    lat: 38.4724
  }, {
    lng: -82.7624,
    lat: 38.4728
  }, {
    lng: -82.7636,
    lat: 38.4731
  }, {
    lng: -82.7637,
    lat: 38.4732
  }, {
    lng: -82.7637,
    lat: 38.4734
  }, {
    lng: -82.7633,
    lat: 38.4736
  }, {
    lng: -82.7632,
    lat: 38.4741
  }, {
    lng: -82.763,
    lat: 38.4743
  }, {
    lng: -82.7627,
    lat: 38.4744
  }, {
    lng: -82.7619,
    lat: 38.4745
  }, {
    lng: -82.7611,
    lat: 38.4743
  }, {
    lng: -82.7606,
    lat: 38.4747
  }, {
    lng: -82.7605,
    lat: 38.475
  }, {
    lng: -82.7606,
    lat: 38.4759
  }, {
    lng: -82.7608,
    lat: 38.4762
  }, {
    lng: -82.7611,
    lat: 38.4765
  }, {
    lng: -82.7613,
    lat: 38.4769
  }, {
    lng: -82.7615,
    lat: 38.4778
  }, {
    lng: -82.7621,
    lat: 38.4786
  }, {
    lng: -82.7622,
    lat: 38.4788
  }, {
    lng: -82.7623,
    lat: 38.4788
  }, {
    lng: -82.7626,
    lat: 38.4786
  }, {
    lng: -82.7626,
    lat: 38.4786
  }, {
    lng: -82.7631,
    lat: 38.4791
  }, {
    lng: -82.7634,
    lat: 38.4796
  }, {
    lng: -82.7637,
    lat: 38.4801
  }, {
    lng: -82.7639,
    lat: 38.4805
  }, {
    lng: -82.7638,
    lat: 38.4809
  }, {
    lng: -82.7642,
    lat: 38.4812
  }, {
    lng: -82.7677,
    lat: 38.4829
  }, {
    lng: -82.7696,
    lat: 38.4836
  }, {
    lng: -82.7698,
    lat: 38.4837
  }, {
    lng: -82.7708,
    lat: 38.484
  }, {
    lng: -82.7712,
    lat: 38.4841
  }, {
    lng: -82.7727,
    lat: 38.4846
  }, {
    lng: -82.7738,
    lat: 38.4847
  }, {
    lng: -82.7742,
    lat: 38.4848
  }, {
    lng: -82.7746,
    lat: 38.4848
  }, {
    lng: -82.7751,
    lat: 38.4847
  }, {
    lng: -82.7758,
    lat: 38.4847
  }, {
    lng: -82.7762,
    lat: 38.4847
  }, {
    lng: -82.7767,
    lat: 38.4845
  }, {
    lng: -82.7774,
    lat: 38.4847
  }, {
    lng: -82.7777,
    lat: 38.4847
  }, {
    lng: -82.778,
    lat: 38.4847
  }, {
    lng: -82.7784,
    lat: 38.4847
  }, {
    lng: -82.7785,
    lat: 38.4844
  }, {
    lng: -82.7789,
    lat: 38.4841
  }, {
    lng: -82.7792,
    lat: 38.4839
  }, {
    lng: -82.7796,
    lat: 38.4837
  }, {
    lng: -82.7829,
    lat: 38.4831
  }, {
    lng: -82.7832,
    lat: 38.483
  }, {
    lng: -82.7833,
    lat: 38.4829
  }, {
    lng: -82.7836,
    lat: 38.4823
  }, {
    lng: -82.784,
    lat: 38.4821
  }, {
    lng: -82.784,
    lat: 38.482
  }, {
    lng: -82.7848,
    lat: 38.4818
  }, {
    lng: -82.7856,
    lat: 38.4818
  }, {
    lng: -82.7864,
    lat: 38.4817
  }, {
    lng: -82.787,
    lat: 38.4816
  }, {
    lng: -82.7879,
    lat: 38.4812
  }, {
    lng: -82.7896,
    lat: 38.4813
  }, {
    lng: -82.7896,
    lat: 38.4811
  }, {
    lng: -82.7896,
    lat: 38.481
  }, {
    lng: -82.7897,
    lat: 38.4808
  }, {
    lng: -82.7899,
    lat: 38.4797
  }, {
    lng: -82.7901,
    lat: 38.4789
  }, {
    lng: -82.7902,
    lat: 38.4787
  }, {
    lng: -82.7902,
    lat: 38.4785
  }, {
    lng: -82.7903,
    lat: 38.4785
  }, {
    lng: -82.7903,
    lat: 38.4784
  }, {
    lng: -82.7903,
    lat: 38.4784
  }, {
    lng: -82.7903,
    lat: 38.4783
  }, {
    lng: -82.7904,
    lat: 38.4783
  }, {
    lng: -82.7904,
    lat: 38.4783
  }, {
    lng: -82.7904,
    lat: 38.4782
  }, {
    lng: -82.7905,
    lat: 38.4782
  }, {
    lng: -82.7906,
    lat: 38.4782
  }, {
    lng: -82.7906,
    lat: 38.4781
  }, {
    lng: -82.7907,
    lat: 38.4781
  }, {
    lng: -82.7907,
    lat: 38.4781
  }, {
    lng: -82.7908,
    lat: 38.478
  }, {
    lng: -82.791,
    lat: 38.478
  }, {
    lng: -82.7921,
    lat: 38.4776
  }, {
    lng: -82.7932,
    lat: 38.4772
  }, {
    lng: -82.7933,
    lat: 38.4775
  }, {
    lng: -82.7936,
    lat: 38.4779
  }, {
    lng: -82.7937,
    lat: 38.4781
  }, {
    lng: -82.7938,
    lat: 38.4782
  }, {
    lng: -82.7942,
    lat: 38.4789
  }, {
    lng: -82.795,
    lat: 38.48
  }, {
    lng: -82.7951,
    lat: 38.4803
  }, {
    lng: -82.7953,
    lat: 38.4806
  }, {
    lng: -82.7955,
    lat: 38.481
  }, {
    lng: -82.7956,
    lat: 38.4812
  }, {
    lng: -82.7957,
    lat: 38.4814
  }, {
    lng: -82.7959,
    lat: 38.4817
  }, {
    lng: -82.7961,
    lat: 38.482
  }, {
    lng: -82.7961,
    lat: 38.4822
  }, {
    lng: -82.7962,
    lat: 38.4823
  }, {
    lng: -82.7963,
    lat: 38.4825
  }, {
    lng: -82.7963,
    lat: 38.4826
  }, {
    lng: -82.7963,
    lat: 38.4827
  }, {
    lng: -82.7964,
    lat: 38.4828
  }, {
    lng: -82.7965,
    lat: 38.483
  }, {
    lng: -82.7965,
    lat: 38.4833
  }, {
    lng: -82.7966,
    lat: 38.4835
  }, {
    lng: -82.7967,
    lat: 38.4837
  }, {
    lng: -82.7967,
    lat: 38.4839
  }, {
    lng: -82.7968,
    lat: 38.484
  }, {
    lng: -82.7968,
    lat: 38.4841
  }, {
    lng: -82.7968,
    lat: 38.4843
  }, {
    lng: -82.7969,
    lat: 38.4846
  }, {
    lng: -82.797,
    lat: 38.4848
  }, {
    lng: -82.797,
    lat: 38.4852
  }, {
    lng: -82.7971,
    lat: 38.4857
  }, {
    lng: -82.7972,
    lat: 38.4859
  }, {
    lng: -82.7972,
    lat: 38.4861
  }, {
    lng: -82.7972,
    lat: 38.4862
  }, {
    lng: -82.7972,
    lat: 38.4865
  }, {
    lng: -82.7972,
    lat: 38.4869
  }, {
    lng: -82.7972,
    lat: 38.4869
  }, {
    lng: -82.7972,
    lat: 38.4869
  }, {
    lng: -82.7972,
    lat: 38.487
  }, {
    lng: -82.7972,
    lat: 38.4872
  }, {
    lng: -82.7972,
    lat: 38.4873
  }, {
    lng: -82.7972,
    lat: 38.4874
  }, {
    lng: -82.7972,
    lat: 38.4876
  }, {
    lng: -82.7972,
    lat: 38.4877
  }, {
    lng: -82.7972,
    lat: 38.4878
  }, {
    lng: -82.7972,
    lat: 38.4882
  }, {
    lng: -82.7972,
    lat: 38.4885
  }, {
    lng: -82.7972,
    lat: 38.4889
  }, {
    lng: -82.7971,
    lat: 38.4892
  }, {
    lng: -82.7971,
    lat: 38.4896
  }, {
    lng: -82.7971,
    lat: 38.4898
  }, {
    lng: -82.797,
    lat: 38.4901
  }, {
    lng: -82.797,
    lat: 38.4902
  }, {
    lng: -82.7969,
    lat: 38.4904
  }, {
    lng: -82.7969,
    lat: 38.4907
  }, {
    lng: -82.7968,
    lat: 38.4909
  }, {
    lng: -82.7967,
    lat: 38.4912
  }, {
    lng: -82.7967,
    lat: 38.4913
  }, {
    lng: -82.7966,
    lat: 38.4917
  }, {
    lng: -82.7965,
    lat: 38.4918
  }, {
    lng: -82.7964,
    lat: 38.4921
  }, {
    lng: -82.7964,
    lat: 38.4923
  }, {
    lng: -82.7963,
    lat: 38.4924
  }, {
    lng: -82.7962,
    lat: 38.4925
  }, {
    lng: -82.7961,
    lat: 38.4927
  }, {
    lng: -82.7961,
    lat: 38.4929
  }, {
    lng: -82.7959,
    lat: 38.4932
  }, {
    lng: -82.7959,
    lat: 38.4934
  }, {
    lng: -82.7958,
    lat: 38.4935
  }, {
    lng: -82.7957,
    lat: 38.4938
  }, {
    lng: -82.7953,
    lat: 38.4945
  }, {
    lng: -82.7952,
    lat: 38.4948
  }, {
    lng: -82.795,
    lat: 38.4951
  }, {
    lng: -82.7949,
    lat: 38.4953
  }, {
    lng: -82.7949,
    lat: 38.4954
  }, {
    lng: -82.7948,
    lat: 38.4956
  }, {
    lng: -82.7948,
    lat: 38.4957
  }, {
    lng: -82.7947,
    lat: 38.4958
  }, {
    lng: -82.7947,
    lat: 38.4958
  }, {
    lng: -82.7947,
    lat: 38.4959
  }, {
    lng: -82.7947,
    lat: 38.496
  }, {
    lng: -82.7947,
    lat: 38.4961
  }, {
    lng: -82.7946,
    lat: 38.4962
  }, {
    lng: -82.7946,
    lat: 38.4963
  }, {
    lng: -82.7946,
    lat: 38.4964
  }, {
    lng: -82.7946,
    lat: 38.4966
  }, {
    lng: -82.7946,
    lat: 38.4967
  }, {
    lng: -82.7946,
    lat: 38.497
  }, {
    lng: -82.7946,
    lat: 38.4971
  }, {
    lng: -82.7946,
    lat: 38.4972
  }, {
    lng: -82.7946,
    lat: 38.4973
  }, {
    lng: -82.7946,
    lat: 38.4974
  }, {
    lng: -82.7946,
    lat: 38.4977
  }, {
    lng: -82.7946,
    lat: 38.4977
  }, {
    lng: -82.7946,
    lat: 38.4978
  }, {
    lng: -82.7949,
    lat: 38.4979
  }, {
    lng: -82.795,
    lat: 38.498
  }, {
    lng: -82.7952,
    lat: 38.498
  }, {
    lng: -82.7953,
    lat: 38.498
  }, {
    lng: -82.7954,
    lat: 38.498
  }, {
    lng: -82.7956,
    lat: 38.4979
  }, {
    lng: -82.7958,
    lat: 38.4979
  }, {
    lng: -82.796,
    lat: 38.4979
  }, {
    lng: -82.7961,
    lat: 38.498
  }, {
    lng: -82.7969,
    lat: 38.4981
  }, {
    lng: -82.7977,
    lat: 38.4983
  }, {
    lng: -82.7983,
    lat: 38.4985
  }, {
    lng: -82.7988,
    lat: 38.4989
  }, {
    lng: -82.7993,
    lat: 38.4992
  }, {
    lng: -82.7998,
    lat: 38.4992
  }, {
    lng: -82.8001,
    lat: 38.499
  }, {
    lng: -82.8005,
    lat: 38.4988
  }, {
    lng: -82.8006,
    lat: 38.4988
  }, {
    lng: -82.8011,
    lat: 38.4991
  }, {
    lng: -82.8012,
    lat: 38.4994
  }, {
    lng: -82.8014,
    lat: 38.4996
  }, {
    lng: -82.8023,
    lat: 38.5008
  }, {
    lng: -82.8024,
    lat: 38.5012
  }, {
    lng: -82.8023,
    lat: 38.5017
  }, {
    lng: -82.8024,
    lat: 38.5021
  }, {
    lng: -82.8027,
    lat: 38.5024
  }, {
    lng: -82.8029,
    lat: 38.5027
  }, {
    lng: -82.803,
    lat: 38.503
  }, {
    lng: -82.8033,
    lat: 38.5033
  }, {
    lng: -82.8035,
    lat: 38.5033
  }, {
    lng: -82.804,
    lat: 38.5034
  }, {
    lng: -82.8043,
    lat: 38.5035
  }, {
    lng: -82.8046,
    lat: 38.5038
  }, {
    lng: -82.8048,
    lat: 38.5037
  }, {
    lng: -82.8052,
    lat: 38.5036
  }, {
    lng: -82.8055,
    lat: 38.5036
  }, {
    lng: -82.806,
    lat: 38.5035
  }, {
    lng: -82.8063,
    lat: 38.5036
  }, {
    lng: -82.8066,
    lat: 38.5036
  }, {
    lng: -82.8067,
    lat: 38.5037
  }, {
    lng: -82.8068,
    lat: 38.5037
  }, {
    lng: -82.8075,
    lat: 38.5037
  }, {
    lng: -82.808,
    lat: 38.5038
  }, {
    lng: -82.8083,
    lat: 38.5042
  }, {
    lng: -82.8084,
    lat: 38.5045
  }, {
    lng: -82.8085,
    lat: 38.5045
  }, {
    lng: -82.8086,
    lat: 38.5047
  }, {
    lng: -82.8088,
    lat: 38.5048
  }, {
    lng: -82.8092,
    lat: 38.5047
  }, {
    lng: -82.8094,
    lat: 38.5044
  }, {
    lng: -82.8099,
    lat: 38.504
  }, {
    lng: -82.8102,
    lat: 38.5039
  }, {
    lng: -82.8105,
    lat: 38.5038
  }, {
    lng: -82.8122,
    lat: 38.5042
  }, {
    lng: -82.813,
    lat: 38.5045
  }, {
    lng: -82.8135,
    lat: 38.5046
  }, {
    lng: -82.8136,
    lat: 38.5046
  }, {
    lng: -82.814,
    lat: 38.5047
  }, {
    lng: -82.8143,
    lat: 38.5045
  }, {
    lng: -82.8147,
    lat: 38.5041
  }, {
    lng: -82.8148,
    lat: 38.5039
  }, {
    lng: -82.815,
    lat: 38.5038
  }, {
    lng: -82.8152,
    lat: 38.5037
  }, {
    lng: -82.8154,
    lat: 38.5037
  }, {
    lng: -82.816,
    lat: 38.5037
  }, {
    lng: -82.8161,
    lat: 38.5037
  }, {
    lng: -82.8163,
    lat: 38.5036
  }, {
    lng: -82.8165,
    lat: 38.5036
  }, {
    lng: -82.8167,
    lat: 38.5035
  }, {
    lng: -82.8169,
    lat: 38.5035
  }, {
    lng: -82.8173,
    lat: 38.5035
  }, {
    lng: -82.8177,
    lat: 38.5035
  }, {
    lng: -82.818,
    lat: 38.5036
  }, {
    lng: -82.8183,
    lat: 38.5036
  }, {
    lng: -82.8185,
    lat: 38.5037
  }, {
    lng: -82.8186,
    lat: 38.5038
  }, {
    lng: -82.8189,
    lat: 38.5039
  }, {
    lng: -82.819,
    lat: 38.504
  }, {
    lng: -82.8192,
    lat: 38.5043
  }, {
    lng: -82.8194,
    lat: 38.5045
  }, {
    lng: -82.8197,
    lat: 38.5045
  }, {
    lng: -82.82,
    lat: 38.5044
  }, {
    lng: -82.8201,
    lat: 38.5042
  }, {
    lng: -82.8201,
    lat: 38.5037
  }, {
    lng: -82.8201,
    lat: 38.5034
  }, {
    lng: -82.8202,
    lat: 38.5029
  }, {
    lng: -82.8204,
    lat: 38.5026
  }, {
    lng: -82.8208,
    lat: 38.5022
  }, {
    lng: -82.8212,
    lat: 38.5018
  }, {
    lng: -82.8215,
    lat: 38.5016
  }, {
    lng: -82.8219,
    lat: 38.5016
  }, {
    lng: -82.8222,
    lat: 38.5016
  }, {
    lng: -82.8223,
    lat: 38.5017
  }, {
    lng: -82.8223,
    lat: 38.5019
  }, {
    lng: -82.8223,
    lat: 38.5022
  }, {
    lng: -82.8221,
    lat: 38.5025
  }, {
    lng: -82.8216,
    lat: 38.5028
  }, {
    lng: -82.8214,
    lat: 38.5031
  }, {
    lng: -82.8212,
    lat: 38.5033
  }, {
    lng: -82.8211,
    lat: 38.5036
  }, {
    lng: -82.8212,
    lat: 38.5038
  }, {
    lng: -82.8216,
    lat: 38.504
  }, {
    lng: -82.8222,
    lat: 38.5043
  }, {
    lng: -82.8225,
    lat: 38.5044
  }, {
    lng: -82.8231,
    lat: 38.5043
  }, {
    lng: -82.8236,
    lat: 38.5043
  }, {
    lng: -82.824,
    lat: 38.504
  }, {
    lng: -82.8243,
    lat: 38.5036
  }, {
    lng: -82.8244,
    lat: 38.5032
  }, {
    lng: -82.8245,
    lat: 38.503
  }, {
    lng: -82.8247,
    lat: 38.5028
  }, {
    lng: -82.8251,
    lat: 38.5028
  }, {
    lng: -82.8254,
    lat: 38.503
  }, {
    lng: -82.8256,
    lat: 38.5032
  }, {
    lng: -82.8257,
    lat: 38.5034
  }, {
    lng: -82.8259,
    lat: 38.5033
  }, {
    lng: -82.8264,
    lat: 38.5029
  }, {
    lng: -82.8269,
    lat: 38.5024
  }, {
    lng: -82.8272,
    lat: 38.5021
  }, {
    lng: -82.8274,
    lat: 38.5018
  }, {
    lng: -82.8276,
    lat: 38.5013
  }, {
    lng: -82.8278,
    lat: 38.501
  }, {
    lng: -82.8281,
    lat: 38.5009
  }, {
    lng: -82.8286,
    lat: 38.5009
  }, {
    lng: -82.8292,
    lat: 38.5012
  }, {
    lng: -82.8293,
    lat: 38.5013
  }, {
    lng: -82.8293,
    lat: 38.5012
  }, {
    lng: -82.8297,
    lat: 38.5009
  }, {
    lng: -82.8301,
    lat: 38.5005
  }, {
    lng: -82.8304,
    lat: 38.5002
  }, {
    lng: -82.8305,
    lat: 38.5
  }, {
    lng: -82.8307,
    lat: 38.4997
  }, {
    lng: -82.8308,
    lat: 38.4994
  }, {
    lng: -82.8309,
    lat: 38.4994
  }, {
    lng: -82.831,
    lat: 38.4988
  }, {
    lng: -82.8311,
    lat: 38.4985
  }, {
    lng: -82.8312,
    lat: 38.4981
  }, {
    lng: -82.8313,
    lat: 38.4978
  }, {
    lng: -82.8313,
    lat: 38.4965
  }, {
    lng: -82.8313,
    lat: 38.4958
  }, {
    lng: -82.8312,
    lat: 38.4954
  }, {
    lng: -82.8311,
    lat: 38.4948
  }, {
    lng: -82.831,
    lat: 38.4946
  }, {
    lng: -82.8307,
    lat: 38.4937
  }, {
    lng: -82.8304,
    lat: 38.4933
  }, {
    lng: -82.83,
    lat: 38.4925
  }, {
    lng: -82.8299,
    lat: 38.4921
  }, {
    lng: -82.83,
    lat: 38.4917
  }, {
    lng: -82.83,
    lat: 38.4914
  }, {
    lng: -82.8301,
    lat: 38.4913
  }, {
    lng: -82.8302,
    lat: 38.4911
  }, {
    lng: -82.8303,
    lat: 38.491
  }, {
    lng: -82.8304,
    lat: 38.4909
  }, {
    lng: -82.8305,
    lat: 38.4907
  }, {
    lng: -82.8306,
    lat: 38.4906
  }, {
    lng: -82.8311,
    lat: 38.4903
  }, {
    lng: -82.8313,
    lat: 38.4902
  }, {
    lng: -82.8315,
    lat: 38.4902
  }, {
    lng: -82.8321,
    lat: 38.4901
  }, {
    lng: -82.8325,
    lat: 38.49
  }, {
    lng: -82.8329,
    lat: 38.4901
  }, {
    lng: -82.8331,
    lat: 38.4901
  }, {
    lng: -82.8335,
    lat: 38.4902
  }, {
    lng: -82.8339,
    lat: 38.4903
  }, {
    lng: -82.8339,
    lat: 38.4903
  }, {
    lng: -82.8339,
    lat: 38.4899
  }, {
    lng: -82.8335,
    lat: 38.4898
  }, {
    lng: -82.8329,
    lat: 38.4897
  }, {
    lng: -82.8324,
    lat: 38.4898
  }, {
    lng: -82.8315,
    lat: 38.4899
  }, {
    lng: -82.831,
    lat: 38.4901
  }, {
    lng: -82.8307,
    lat: 38.4899
  }, {
    lng: -82.83,
    lat: 38.4899
  }, {
    lng: -82.8296,
    lat: 38.4897
  }, {
    lng: -82.8292,
    lat: 38.4891
  }, {
    lng: -82.8294,
    lat: 38.4884
  }, {
    lng: -82.8298,
    lat: 38.4881
  }, {
    lng: -82.8309,
    lat: 38.4875
  }, {
    lng: -82.8322,
    lat: 38.487
  }, {
    lng: -82.8332,
    lat: 38.4868
  }, {
    lng: -82.8338,
    lat: 38.4866
  }, {
    lng: -82.8341,
    lat: 38.4866
  }, {
    lng: -82.8347,
    lat: 38.4867
  }, {
    lng: -82.8363,
    lat: 38.4879
  }, {
    lng: -82.8369,
    lat: 38.4884
  }, {
    lng: -82.8374,
    lat: 38.4886
  }, {
    lng: -82.838,
    lat: 38.4888
  }, {
    lng: -82.8404,
    lat: 38.4884
  }, {
    lng: -82.8411,
    lat: 38.4883
  }, {
    lng: -82.8424,
    lat: 38.4883
  }, {
    lng: -82.8432,
    lat: 38.4885
  }, {
    lng: -82.844,
    lat: 38.4886
  }, {
    lng: -82.8448,
    lat: 38.4884
  }, {
    lng: -82.8457,
    lat: 38.4883
  }, {
    lng: -82.8458,
    lat: 38.4883
  }, {
    lng: -82.8465,
    lat: 38.4879
  }, {
    lng: -82.8472,
    lat: 38.4876
  }, {
    lng: -82.8476,
    lat: 38.4875
  }, {
    lng: -82.8484,
    lat: 38.4875
  }, {
    lng: -82.8492,
    lat: 38.4878
  }, {
    lng: -82.85,
    lat: 38.4879
  }, {
    lng: -82.8508,
    lat: 38.4875
  }, {
    lng: -82.8513,
    lat: 38.4872
  }, {
    lng: -82.8517,
    lat: 38.4866
  }, {
    lng: -82.8518,
    lat: 38.4863
  }, {
    lng: -82.8516,
    lat: 38.4859
  }, {
    lng: -82.8512,
    lat: 38.4858
  }, {
    lng: -82.8509,
    lat: 38.4857
  }, {
    lng: -82.8502,
    lat: 38.4857
  }, {
    lng: -82.8494,
    lat: 38.4858
  }, {
    lng: -82.8486,
    lat: 38.4858
  }, {
    lng: -82.8479,
    lat: 38.4855
  }, {
    lng: -82.8472,
    lat: 38.4849
  }, {
    lng: -82.8467,
    lat: 38.484
  }, {
    lng: -82.8464,
    lat: 38.4834
  }, {
    lng: -82.8462,
    lat: 38.4829
  }, {
    lng: -82.8464,
    lat: 38.4824
  }, {
    lng: -82.8476,
    lat: 38.4817
  }, {
    lng: -82.8483,
    lat: 38.4811
  }, {
    lng: -82.8491,
    lat: 38.4802
  }, {
    lng: -82.8494,
    lat: 38.4799
  }, {
    lng: -82.8503,
    lat: 38.4794
  }, {
    lng: -82.8511,
    lat: 38.4791
  }, {
    lng: -82.8512,
    lat: 38.4788
  }, {
    lng: -82.8506,
    lat: 38.4784
  }, {
    lng: -82.8493,
    lat: 38.4783
  }, {
    lng: -82.8489,
    lat: 38.4781
  }, {
    lng: -82.8487,
    lat: 38.4775
  }, {
    lng: -82.8488,
    lat: 38.4769
  }, {
    lng: -82.8491,
    lat: 38.4761
  }, {
    lng: -82.8499,
    lat: 38.4751
  }, {
    lng: -82.8507,
    lat: 38.4744
  }, {
    lng: -82.8518,
    lat: 38.4738
  }, {
    lng: -82.8527,
    lat: 38.4735
  }, {
    lng: -82.8534,
    lat: 38.4733
  }, {
    lng: -82.8542,
    lat: 38.4734
  }, {
    lng: -82.8548,
    lat: 38.4735
  }, {
    lng: -82.8557,
    lat: 38.4739
  }, {
    lng: -82.8569,
    lat: 38.4738
  }, {
    lng: -82.858,
    lat: 38.4729
  }, {
    lng: -82.8586,
    lat: 38.4721
  }, {
    lng: -82.859,
    lat: 38.4715
  }, {
    lng: -82.8596,
    lat: 38.4712
  }, {
    lng: -82.8605,
    lat: 38.471
  }, {
    lng: -82.8616,
    lat: 38.4711
  }, {
    lng: -82.8623,
    lat: 38.4711
  }, {
    lng: -82.8629,
    lat: 38.4709
  }, {
    lng: -82.8633,
    lat: 38.4706
  }, {
    lng: -82.8634,
    lat: 38.4702
  }, {
    lng: -82.8635,
    lat: 38.4699
  }, {
    lng: -82.8632,
    lat: 38.4695
  }, {
    lng: -82.863,
    lat: 38.4693
  }, {
    lng: -82.8627,
    lat: 38.469
  }, {
    lng: -82.8625,
    lat: 38.4686
  }, {
    lng: -82.8625,
    lat: 38.4685
  }, {
    lng: -82.8625,
    lat: 38.4683
  }, {
    lng: -82.8624,
    lat: 38.4679
  }, {
    lng: -82.8625,
    lat: 38.4669
  }, {
    lng: -82.8624,
    lat: 38.4665
  }, {
    lng: -82.8622,
    lat: 38.4664
  }, {
    lng: -82.8619,
    lat: 38.4662
  }, {
    lng: -82.8618,
    lat: 38.4661
  }, {
    lng: -82.8612,
    lat: 38.466
  }, {
    lng: -82.8607,
    lat: 38.4656
  }, {
    lng: -82.8608,
    lat: 38.4652
  }, {
    lng: -82.8609,
    lat: 38.4649
  }, {
    lng: -82.8609,
    lat: 38.4648
  }, {
    lng: -82.8612,
    lat: 38.4644
  }, {
    lng: -82.8617,
    lat: 38.4637
  }, {
    lng: -82.8619,
    lat: 38.4632
  }, {
    lng: -82.8616,
    lat: 38.4624
  }, {
    lng: -82.8612,
    lat: 38.462
  }, {
    lng: -82.8605,
    lat: 38.4617
  }, {
    lng: -82.8598,
    lat: 38.4615
  }, {
    lng: -82.8594,
    lat: 38.4614
  }, {
    lng: -82.8591,
    lat: 38.4611
  }, {
    lng: -82.859,
    lat: 38.4605
  }, {
    lng: -82.8589,
    lat: 38.4603
  }, {
    lng: -82.8589,
    lat: 38.4601
  }, {
    lng: -82.8589,
    lat: 38.4596
  }, {
    lng: -82.8589,
    lat: 38.4589
  }, {
    lng: -82.8587,
    lat: 38.4584
  }, {
    lng: -82.8585,
    lat: 38.458
  }, {
    lng: -82.8582,
    lat: 38.4577
  }, {
    lng: -82.8579,
    lat: 38.4575
  }, {
    lng: -82.8572,
    lat: 38.4571
  }, {
    lng: -82.8561,
    lat: 38.4569
  }, {
    lng: -82.8554,
    lat: 38.4567
  }, {
    lng: -82.8543,
    lat: 38.4564
  }, {
    lng: -82.8537,
    lat: 38.456
  }, {
    lng: -82.8534,
    lat: 38.4553
  }, {
    lng: -82.8533,
    lat: 38.4552
  }, {
    lng: -82.8533,
    lat: 38.4542
  }, {
    lng: -82.8536,
    lat: 38.4535
  }, {
    lng: -82.8545,
    lat: 38.4524
  }, {
    lng: -82.8549,
    lat: 38.4518
  }, {
    lng: -82.8555,
    lat: 38.4514
  }, {
    lng: -82.8568,
    lat: 38.4507
  }, {
    lng: -82.858,
    lat: 38.4502
  }, {
    lng: -82.859,
    lat: 38.4496
  }, {
    lng: -82.8599,
    lat: 38.449
  }, {
    lng: -82.8607,
    lat: 38.4484
  }, {
    lng: -82.8613,
    lat: 38.4477
  }, {
    lng: -82.8617,
    lat: 38.447
  }, {
    lng: -82.8621,
    lat: 38.4462
  }, {
    lng: -82.8622,
    lat: 38.4451
  }, {
    lng: -82.8623,
    lat: 38.444
  }, {
    lng: -82.862,
    lat: 38.4431
  }, {
    lng: -82.8617,
    lat: 38.4425
  }, {
    lng: -82.8613,
    lat: 38.4419
  }, {
    lng: -82.861,
    lat: 38.4413
  }, {
    lng: -82.8603,
    lat: 38.4402
  }, {
    lng: -82.8602,
    lat: 38.4401
  }, {
    lng: -82.8595,
    lat: 38.4393
  }, {
    lng: -82.8588,
    lat: 38.4384
  }, {
    lng: -82.8588,
    lat: 38.4384
  }, {
    lng: -82.8585,
    lat: 38.438
  }, {
    lng: -82.8584,
    lat: 38.4376
  }, {
    lng: -82.8583,
    lat: 38.4372
  }, {
    lng: -82.8581,
    lat: 38.437
  }, {
    lng: -82.858,
    lat: 38.4366
  }, {
    lng: -82.8581,
    lat: 38.4361
  }, {
    lng: -82.8584,
    lat: 38.4355
  }, {
    lng: -82.8586,
    lat: 38.4351
  }, {
    lng: -82.859,
    lat: 38.4347
  }, {
    lng: -82.8593,
    lat: 38.434
  }, {
    lng: -82.8598,
    lat: 38.4335
  }, {
    lng: -82.8602,
    lat: 38.4335
  }, {
    lng: -82.8609,
    lat: 38.4335
  }, {
    lng: -82.862,
    lat: 38.4335
  }, {
    lng: -82.8625,
    lat: 38.4334
  }, {
    lng: -82.8628,
    lat: 38.4331
  }, {
    lng: -82.8633,
    lat: 38.4329
  }, {
    lng: -82.8633,
    lat: 38.4329
  }, {
    lng: -82.8631,
    lat: 38.4197
  }, {
    lng: -82.8634,
    lat: 38.4198
  }, {
    lng: -82.8651,
    lat: 38.4207
  }, {
    lng: -82.8656,
    lat: 38.4209
  }, {
    lng: -82.8662,
    lat: 38.421
  }, {
    lng: -82.8667,
    lat: 38.4209
  }, {
    lng: -82.8678,
    lat: 38.4205
  }, {
    lng: -82.869,
    lat: 38.4203
  }, {
    lng: -82.8692,
    lat: 38.4203
  }, {
    lng: -82.8694,
    lat: 38.4202
  }, {
    lng: -82.8698,
    lat: 38.4199
  }, {
    lng: -82.8704,
    lat: 38.4195
  }, {
    lng: -82.8706,
    lat: 38.4194
  }, {
    lng: -82.8712,
    lat: 38.4192
  }, {
    lng: -82.8717,
    lat: 38.4192
  }, {
    lng: -82.8734,
    lat: 38.4194
  }, {
    lng: -82.8742,
    lat: 38.4195
  }, {
    lng: -82.8749,
    lat: 38.4195
  }, {
    lng: -82.8757,
    lat: 38.4196
  }, {
    lng: -82.8761,
    lat: 38.4198
  }, {
    lng: -82.8766,
    lat: 38.4196
  }, {
    lng: -82.8772,
    lat: 38.4183
  }, {
    lng: -82.8777,
    lat: 38.418
  }, {
    lng: -82.878,
    lat: 38.4176
  }, {
    lng: -82.8781,
    lat: 38.4166
  }, {
    lng: -82.8786,
    lat: 38.4163
  }, {
    lng: -82.8785,
    lat: 38.4146
  }, {
    lng: -82.8782,
    lat: 38.4143
  }, {
    lng: -82.8777,
    lat: 38.4141
  }, {
    lng: -82.8773,
    lat: 38.4137
  }, {
    lng: -82.8766,
    lat: 38.4132
  }, {
    lng: -82.8755,
    lat: 38.4126
  }, {
    lng: -82.8749,
    lat: 38.4125
  }, {
    lng: -82.8745,
    lat: 38.4069
  }, {
    lng: -82.8741,
    lat: 38.4068
  }, {
    lng: -82.8733,
    lat: 38.4069
  }, {
    lng: -82.8732,
    lat: 38.4069
  }, {
    lng: -82.873,
    lat: 38.4066
  }, {
    lng: -82.8729,
    lat: 38.4064
  }, {
    lng: -82.8725,
    lat: 38.4058
  }, {
    lng: -82.8718,
    lat: 38.4052
  }, {
    lng: -82.8707,
    lat: 38.4045
  }, {
    lng: -82.8702,
    lat: 38.4042
  }, {
    lng: -82.8694,
    lat: 38.4043
  }, {
    lng: -82.8693,
    lat: 38.4035
  }, {
    lng: -82.87,
    lat: 38.4025
  }, {
    lng: -82.8701,
    lat: 38.4021
  }, {
    lng: -82.8702,
    lat: 38.4015
  }, {
    lng: -82.8702,
    lat: 38.4012
  }, {
    lng: -82.8698,
    lat: 38.4002
  }, {
    lng: -82.8697,
    lat: 38.3996
  }, {
    lng: -82.8697,
    lat: 38.3993
  }, {
    lng: -82.8693,
    lat: 38.399
  }, {
    lng: -82.8692,
    lat: 38.3987
  }, {
    lng: -82.8693,
    lat: 38.3983
  }, {
    lng: -82.8697,
    lat: 38.3978
  }, {
    lng: -82.8697,
    lat: 38.3973
  }, {
    lng: -82.87,
    lat: 38.3969
  }, {
    lng: -82.8699,
    lat: 38.3965
  }, {
    lng: -82.8694,
    lat: 38.3959
  }, {
    lng: -82.8693,
    lat: 38.3951
  }, {
    lng: -82.8695,
    lat: 38.3946
  }, {
    lng: -82.8694,
    lat: 38.394
  }, {
    lng: -82.8691,
    lat: 38.3936
  }, {
    lng: -82.869,
    lat: 38.3935
  }, {
    lng: -82.869,
    lat: 38.3926
  }, {
    lng: -82.8689,
    lat: 38.3924
  }, {
    lng: -82.8681,
    lat: 38.3919
  }, {
    lng: -82.868,
    lat: 38.3917
  }, {
    lng: -82.8679,
    lat: 38.3914
  }, {
    lng: -82.8681,
    lat: 38.3906
  }, {
    lng: -82.8682,
    lat: 38.3903
  }, {
    lng: -82.8683,
    lat: 38.39
  }, {
    lng: -82.8687,
    lat: 38.3895
  }, {
    lng: -82.869,
    lat: 38.3891
  }, {
    lng: -82.8693,
    lat: 38.3886
  }, {
    lng: -82.8693,
    lat: 38.3877
  }, {
    lng: -82.8691,
    lat: 38.3874
  }, {
    lng: -82.8679,
    lat: 38.3873
  }, {
    lng: -82.867,
    lat: 38.3873
  }, {
    lng: -82.8665,
    lat: 38.3874
  }, {
    lng: -82.8657,
    lat: 38.3873
  }, {
    lng: -82.8649,
    lat: 38.3871
  }, {
    lng: -82.8481,
    lat: 38.3818
  }, {
    lng: -82.8417,
    lat: 38.3802
  }, {
    lng: -82.8414,
    lat: 38.3801
  }, {
    lng: -82.8317,
    lat: 38.3776
  }, {
    lng: -82.8226,
    lat: 38.3752
  }, {
    lng: -82.8225,
    lat: 38.3755
  }, {
    lng: -82.8224,
    lat: 38.3758
  }, {
    lng: -82.8222,
    lat: 38.3762
  }, {
    lng: -82.8222,
    lat: 38.3764
  }, {
    lng: -82.8222,
    lat: 38.3765
  }, {
    lng: -82.8221,
    lat: 38.3767
  }, {
    lng: -82.8221,
    lat: 38.3769
  }, {
    lng: -82.822,
    lat: 38.377
  }, {
    lng: -82.822,
    lat: 38.3773
  }, {
    lng: -82.822,
    lat: 38.3774
  }, {
    lng: -82.8219,
    lat: 38.3775
  }, {
    lng: -82.8219,
    lat: 38.3776
  }, {
    lng: -82.8219,
    lat: 38.3777
  }, {
    lng: -82.8218,
    lat: 38.3778
  }, {
    lng: -82.8218,
    lat: 38.3779
  }, {
    lng: -82.8217,
    lat: 38.378
  }, {
    lng: -82.8216,
    lat: 38.3781
  }, {
    lng: -82.8215,
    lat: 38.3782
  }, {
    lng: -82.8213,
    lat: 38.3784
  }, {
    lng: -82.8212,
    lat: 38.3786
  }, {
    lng: -82.8209,
    lat: 38.3784
  }, {
    lng: -82.8206,
    lat: 38.3781
  }, {
    lng: -82.8204,
    lat: 38.3779
  }, {
    lng: -82.8202,
    lat: 38.3778
  }, {
    lng: -82.82,
    lat: 38.3776
  }, {
    lng: -82.8199,
    lat: 38.3776
  }, {
    lng: -82.8198,
    lat: 38.3775
  }, {
    lng: -82.8196,
    lat: 38.3773
  }, {
    lng: -82.8194,
    lat: 38.3772
  }, {
    lng: -82.8192,
    lat: 38.3771
  }, {
    lng: -82.819,
    lat: 38.3769
  }, {
    lng: -82.8179,
    lat: 38.3762
  }, {
    lng: -82.8177,
    lat: 38.3762
  }, {
    lng: -82.8177,
    lat: 38.3764
  }, {
    lng: -82.8177,
    lat: 38.3766
  }, {
    lng: -82.8177,
    lat: 38.3767
  }, {
    lng: -82.8174,
    lat: 38.3768
  }, {
    lng: -82.817,
    lat: 38.3769
  }, {
    lng: -82.8164,
    lat: 38.3771
  }, {
    lng: -82.8161,
    lat: 38.3772
  }, {
    lng: -82.8159,
    lat: 38.3774
  }, {
    lng: -82.8159,
    lat: 38.3776
  }, {
    lng: -82.816,
    lat: 38.3782
  }, {
    lng: -82.8159,
    lat: 38.3785
  }, {
    lng: -82.8157,
    lat: 38.3789
  }, {
    lng: -82.8156,
    lat: 38.3792
  }, {
    lng: -82.8152,
    lat: 38.3798
  }, {
    lng: -82.8149,
    lat: 38.3801
  }, {
    lng: -82.8148,
    lat: 38.3802
  }, {
    lng: -82.8144,
    lat: 38.3802
  }, {
    lng: -82.8142,
    lat: 38.3803
  }, {
    lng: -82.814,
    lat: 38.3805
  }, {
    lng: -82.8139,
    lat: 38.3807
  }, {
    lng: -82.8138,
    lat: 38.3812
  }, {
    lng: -82.8138,
    lat: 38.3816
  }, {
    lng: -82.8137,
    lat: 38.3818
  }, {
    lng: -82.8135,
    lat: 38.3819
  }, {
    lng: -82.8131,
    lat: 38.382
  }, {
    lng: -82.8126,
    lat: 38.3823
  }, {
    lng: -82.8123,
    lat: 38.3824
  }, {
    lng: -82.8121,
    lat: 38.3826
  }, {
    lng: -82.812,
    lat: 38.3829
  }, {
    lng: -82.812,
    lat: 38.3833
  }, {
    lng: -82.8119,
    lat: 38.3835
  }, {
    lng: -82.8116,
    lat: 38.3838
  }, {
    lng: -82.8112,
    lat: 38.3841
  }, {
    lng: -82.8108,
    lat: 38.3848
  }, {
    lng: -82.8105,
    lat: 38.3854
  }, {
    lng: -82.8101,
    lat: 38.3859
  }, {
    lng: -82.8098,
    lat: 38.3863
  }, {
    lng: -82.8089,
    lat: 38.387
  }, {
    lng: -82.8088,
    lat: 38.3871
  }, {
    lng: -82.809,
    lat: 38.3872
  }, {
    lng: -82.8096,
    lat: 38.3872
  }, {
    lng: -82.8103,
    lat: 38.3876
  }, {
    lng: -82.811,
    lat: 38.3881
  }, {
    lng: -82.8111,
    lat: 38.3883
  }, {
    lng: -82.8112,
    lat: 38.3884
  }, {
    lng: -82.8112,
    lat: 38.3886
  }, {
    lng: -82.8112,
    lat: 38.3887
  }, {
    lng: -82.8112,
    lat: 38.3889
  }, {
    lng: -82.8112,
    lat: 38.3891
  }, {
    lng: -82.811,
    lat: 38.3897
  }, {
    lng: -82.8104,
    lat: 38.3906
  }, {
    lng: -82.8101,
    lat: 38.391
  }, {
    lng: -82.81,
    lat: 38.3913
  }, {
    lng: -82.81,
    lat: 38.3916
  }, {
    lng: -82.81,
    lat: 38.392
  }, {
    lng: -82.8101,
    lat: 38.3923
  }, {
    lng: -82.8104,
    lat: 38.3925
  }, {
    lng: -82.8107,
    lat: 38.3928
  }, {
    lng: -82.8106,
    lat: 38.393
  }, {
    lng: -82.8106,
    lat: 38.3932
  }, {
    lng: -82.8097,
    lat: 38.3944
  }, {
    lng: -82.8094,
    lat: 38.3946
  }, {
    lng: -82.8085,
    lat: 38.3952
  }, {
    lng: -82.808,
    lat: 38.3954
  }, {
    lng: -82.8075,
    lat: 38.3956
  }, {
    lng: -82.807,
    lat: 38.3957
  }, {
    lng: -82.8065,
    lat: 38.3957
  }, {
    lng: -82.8058,
    lat: 38.3958
  }, {
    lng: -82.8055,
    lat: 38.3959
  }, {
    lng: -82.8052,
    lat: 38.3961
  }, {
    lng: -82.8048,
    lat: 38.3967
  }, {
    lng: -82.8046,
    lat: 38.397
  }, {
    lng: -82.8044,
    lat: 38.3973
  }, {
    lng: -82.804,
    lat: 38.3976
  }, {
    lng: -82.8037,
    lat: 38.3977
  }, {
    lng: -82.8032,
    lat: 38.3979
  }, {
    lng: -82.8028,
    lat: 38.398
  }, {
    lng: -82.8026,
    lat: 38.3979
  }, {
    lng: -82.802,
    lat: 38.3979
  }, {
    lng: -82.8016,
    lat: 38.3978
  }, {
    lng: -82.8013,
    lat: 38.3978
  }, {
    lng: -82.801,
    lat: 38.3979
  }, {
    lng: -82.8004,
    lat: 38.3979
  }, {
    lng: -82.7999,
    lat: 38.3979
  }, {
    lng: -82.7995,
    lat: 38.398
  }, {
    lng: -82.7991,
    lat: 38.3982
  }, {
    lng: -82.7988,
    lat: 38.3986
  }, {
    lng: -82.7986,
    lat: 38.3988
  }, {
    lng: -82.7985,
    lat: 38.3991
  }, {
    lng: -82.7985,
    lat: 38.3998
  }, {
    lng: -82.7984,
    lat: 38.4
  }, {
    lng: -82.7982,
    lat: 38.4002
  }, {
    lng: -82.798,
    lat: 38.4002
  }, {
    lng: -82.7975,
    lat: 38.4002
  }, {
    lng: -82.7972,
    lat: 38.4002
  }, {
    lng: -82.797,
    lat: 38.4003
  }, {
    lng: -82.7968,
    lat: 38.4005
  }, {
    lng: -82.7965,
    lat: 38.4006
  }, {
    lng: -82.7958,
    lat: 38.4007
  }, {
    lng: -82.7956,
    lat: 38.4009
  }, {
    lng: -82.7953,
    lat: 38.401
  }, {
    lng: -82.795,
    lat: 38.4011
  }, {
    lng: -82.7948,
    lat: 38.4011
  }, {
    lng: -82.7943,
    lat: 38.4008
  }, {
    lng: -82.794,
    lat: 38.4008
  }, {
    lng: -82.7938,
    lat: 38.4008
  }, {
    lng: -82.7935,
    lat: 38.4009
  }, {
    lng: -82.7934,
    lat: 38.4015
  }, {
    lng: -82.7933,
    lat: 38.402
  }, {
    lng: -82.7931,
    lat: 38.4024
  }, {
    lng: -82.7929,
    lat: 38.4025
  }, {
    lng: -82.7927,
    lat: 38.4025
  }, {
    lng: -82.7921,
    lat: 38.4025
  }, {
    lng: -82.7918,
    lat: 38.4024
  }, {
    lng: -82.7916,
    lat: 38.4024
  }, {
    lng: -82.7914,
    lat: 38.4026
  }, {
    lng: -82.7913,
    lat: 38.4029
  }, {
    lng: -82.7911,
    lat: 38.4034
  }, {
    lng: -82.7908,
    lat: 38.4038
  }, {
    lng: -82.7905,
    lat: 38.4042
  }, {
    lng: -82.7903,
    lat: 38.4044
  }, {
    lng: -82.7901,
    lat: 38.4044
  }, {
    lng: -82.7892,
    lat: 38.4045
  }, {
    lng: -82.789,
    lat: 38.4046
  }, {
    lng: -82.7888,
    lat: 38.4047
  }, {
    lng: -82.7887,
    lat: 38.4051
  }, {
    lng: -82.7892,
    lat: 38.4057
  }, {
    lng: -82.7899,
    lat: 38.4065
  }, {
    lng: -82.7901,
    lat: 38.4069
  }, {
    lng: -82.7901,
    lat: 38.4071
  }, {
    lng: -82.7896,
    lat: 38.4074
  }, {
    lng: -82.7892,
    lat: 38.4079
  }, {
    lng: -82.7889,
    lat: 38.4087
  }, {
    lng: -82.7888,
    lat: 38.4091
  }, {
    lng: -82.7889,
    lat: 38.4095
  }, {
    lng: -82.7888,
    lat: 38.4097
  }, {
    lng: -82.7887,
    lat: 38.4099
  }, {
    lng: -82.7885,
    lat: 38.4102
  }, {
    lng: -82.7885,
    lat: 38.4104
  }, {
    lng: -82.7887,
    lat: 38.4106
  }, {
    lng: -82.7889,
    lat: 38.4107
  }, {
    lng: -82.7892,
    lat: 38.4109
  }, {
    lng: -82.7893,
    lat: 38.411
  }, {
    lng: -82.7889,
    lat: 38.412
  }, {
    lng: -82.7885,
    lat: 38.4127
  }, {
    lng: -82.7883,
    lat: 38.4129
  }, {
    lng: -82.788,
    lat: 38.413
  }, {
    lng: -82.7878,
    lat: 38.4129
  }, {
    lng: -82.7876,
    lat: 38.4128
  }, {
    lng: -82.787,
    lat: 38.4124
  }, {
    lng: -82.7867,
    lat: 38.4123
  }, {
    lng: -82.7864,
    lat: 38.4122
  }, {
    lng: -82.7859,
    lat: 38.4123
  }, {
    lng: -82.7856,
    lat: 38.4122
  }, {
    lng: -82.7852,
    lat: 38.4121
  }, {
    lng: -82.7849,
    lat: 38.4122
  }, {
    lng: -82.7842,
    lat: 38.4126
  }, {
    lng: -82.7838,
    lat: 38.4128
  }, {
    lng: -82.7832,
    lat: 38.413
  }, {
    lng: -82.7829,
    lat: 38.4132
  }, {
    lng: -82.7828,
    lat: 38.4134
  }, {
    lng: -82.7827,
    lat: 38.4135
  }, {
    lng: -82.7827,
    lat: 38.4141
  }, {
    lng: -82.7826,
    lat: 38.4144
  }, {
    lng: -82.7824,
    lat: 38.4145
  }, {
    lng: -82.782,
    lat: 38.4145
  }, {
    lng: -82.7814,
    lat: 38.4148
  }, {
    lng: -82.7811,
    lat: 38.4148
  }, {
    lng: -82.7809,
    lat: 38.4147
  }, {
    lng: -82.7807,
    lat: 38.4145
  }, {
    lng: -82.7805,
    lat: 38.4143
  }, {
    lng: -82.7804,
    lat: 38.4141
  }, {
    lng: -82.7801,
    lat: 38.4139
  }, {
    lng: -82.7796,
    lat: 38.4139
  }, {
    lng: -82.7795,
    lat: 38.414
  }, {
    lng: -82.7792,
    lat: 38.4143
  }, {
    lng: -82.779,
    lat: 38.4146
  }, {
    lng: -82.7789,
    lat: 38.4148
  }, {
    lng: -82.7787,
    lat: 38.4149
  }, {
    lng: -82.7783,
    lat: 38.4149
  }, {
    lng: -82.7777,
    lat: 38.4149
  }, {
    lng: -82.7774,
    lat: 38.4148
  }, {
    lng: -82.7772,
    lat: 38.4149
  }, {
    lng: -82.7771,
    lat: 38.4154
  }, {
    lng: -82.777,
    lat: 38.4157
  }, {
    lng: -82.7769,
    lat: 38.4158
  }, {
    lng: -82.7766,
    lat: 38.4163
  }, {
    lng: -82.7766,
    lat: 38.4166
  }, {
    lng: -82.7765,
    lat: 38.417
  }, {
    lng: -82.7763,
    lat: 38.4173
  }, {
    lng: -82.7761,
    lat: 38.4175
  }, {
    lng: -82.7758,
    lat: 38.4177
  }, {
    lng: -82.7755,
    lat: 38.4178
  }, {
    lng: -82.775,
    lat: 38.4179
  }, {
    lng: -82.7744,
    lat: 38.418
  }, {
    lng: -82.7739,
    lat: 38.4181
  }, {
    lng: -82.7738,
    lat: 38.4183
  }, {
    lng: -82.7737,
    lat: 38.4186
  }, {
    lng: -82.7736,
    lat: 38.4188
  }, {
    lng: -82.7737,
    lat: 38.4191
  }, {
    lng: -82.7738,
    lat: 38.4194
  }, {
    lng: -82.774,
    lat: 38.4198
  }, {
    lng: -82.7742,
    lat: 38.42
  }, {
    lng: -82.7745,
    lat: 38.4201
  }, {
    lng: -82.7747,
    lat: 38.4201
  }, {
    lng: -82.7755,
    lat: 38.4202
  }, {
    lng: -82.7757,
    lat: 38.4202
  }, {
    lng: -82.7762,
    lat: 38.4205
  }, {
    lng: -82.7765,
    lat: 38.4208
  }, {
    lng: -82.777,
    lat: 38.4214
  }, {
    lng: -82.7771,
    lat: 38.4218
  }, {
    lng: -82.7767,
    lat: 38.4224
  }, {
    lng: -82.7763,
    lat: 38.4228
  }, {
    lng: -82.7758,
    lat: 38.4233
  }, {
    lng: -82.7753,
    lat: 38.424
  }, {
    lng: -82.7747,
    lat: 38.4247
  }, {
    lng: -82.7746,
    lat: 38.425
  }, {
    lng: -82.7748,
    lat: 38.4254
  }, {
    lng: -82.775,
    lat: 38.4258
  }, {
    lng: -82.7751,
    lat: 38.426
  }, {
    lng: -82.7751,
    lat: 38.426
  }, {
    lng: -82.7752,
    lat: 38.4262
  }, {
    lng: -82.7752,
    lat: 38.4263
  }, {
    lng: -82.7748,
    lat: 38.4268
  }, {
    lng: -82.7748,
    lat: 38.427
  }, {
    lng: -82.7749,
    lat: 38.4272
  }, {
    lng: -82.775,
    lat: 38.4275
  }, {
    lng: -82.7747,
    lat: 38.4281
  }, {
    lng: -82.7744,
    lat: 38.4286
  }, {
    lng: -82.7741,
    lat: 38.4287
  }, {
    lng: -82.7737,
    lat: 38.4288
  }, {
    lng: -82.7729,
    lat: 38.4289
  }, {
    lng: -82.7726,
    lat: 38.4292
  }, {
    lng: -82.7723,
    lat: 38.43
  }, {
    lng: -82.772,
    lat: 38.4302
  }, {
    lng: -82.7712,
    lat: 38.4311
  }, {
    lng: -82.7707,
    lat: 38.432
  }, {
    lng: -82.7706,
    lat: 38.4322
  }, {
    lng: -82.7703,
    lat: 38.4329
  }, {
    lng: -82.7698,
    lat: 38.4332
  }, {
    lng: -82.7693,
    lat: 38.4335
  }, {
    lng: -82.7693,
    lat: 38.434
  }, {
    lng: -82.7692,
    lat: 38.4341
  }, {
    lng: -82.7692,
    lat: 38.4344
  }, {
    lng: -82.7693,
    lat: 38.4345
  }, {
    lng: -82.7696,
    lat: 38.4359
  }, {
    lng: -82.7697,
    lat: 38.4363
  }, {
    lng: -82.7698,
    lat: 38.4367
  }, {
    lng: -82.7698,
    lat: 38.4371
  }, {
    lng: -82.7699,
    lat: 38.4374
  }, {
    lng: -82.77,
    lat: 38.4377
  }, {
    lng: -82.7701,
    lat: 38.4379
  }, {
    lng: -82.7702,
    lat: 38.4381
  }, {
    lng: -82.7703,
    lat: 38.4382
  }, {
    lng: -82.7704,
    lat: 38.4385
  }, {
    lng: -82.7705,
    lat: 38.4386
  }, {
    lng: -82.7708,
    lat: 38.439
  }, {
    lng: -82.771,
    lat: 38.4392
  }, {
    lng: -82.7712,
    lat: 38.4394
  }, {
    lng: -82.7714,
    lat: 38.4396
  }, {
    lng: -82.7715,
    lat: 38.4397
  }, {
    lng: -82.7718,
    lat: 38.44
  }, {
    lng: -82.7721,
    lat: 38.4402
  }, {
    lng: -82.7729,
    lat: 38.4409
  }, {
    lng: -82.7732,
    lat: 38.4412
  }, {
    lng: -82.7734,
    lat: 38.4413
  }, {
    lng: -82.7735,
    lat: 38.4414
  }, {
    lng: -82.7736,
    lat: 38.4415
  }, {
    lng: -82.7737,
    lat: 38.4417
  }, {
    lng: -82.7738,
    lat: 38.4419
  }, {
    lng: -82.7739,
    lat: 38.4421
  }, {
    lng: -82.774,
    lat: 38.4423
  }, {
    lng: -82.7741,
    lat: 38.4425
  }, {
    lng: -82.7742,
    lat: 38.4428
  }, {
    lng: -82.7743,
    lat: 38.4432
  }, {
    lng: -82.7744,
    lat: 38.4434
  }, {
    lng: -82.7744,
    lat: 38.4436
  }, {
    lng: -82.7745,
    lat: 38.4439
  }, {
    lng: -82.7745,
    lat: 38.4444
  }, {
    lng: -82.7745,
    lat: 38.4445
  }, {
    lng: -82.7746,
    lat: 38.4446
  }, {
    lng: -82.7747,
    lat: 38.4447
  }, {
    lng: -82.7748,
    lat: 38.4448
  }, {
    lng: -82.775,
    lat: 38.4449
  }, {
    lng: -82.7753,
    lat: 38.445
  }, {
    lng: -82.7762,
    lat: 38.4457
  }, {
    lng: -82.7765,
    lat: 38.446
  }, {
    lng: -82.7763,
    lat: 38.4462
  }, {
    lng: -82.776,
    lat: 38.4465
  }, {
    lng: -82.7764,
    lat: 38.4467
  }, {
    lng: -82.7765,
    lat: 38.447
  }, {
    lng: -82.7767,
    lat: 38.4477
  }, {
    lng: -82.7767,
    lat: 38.4482
  }, {
    lng: -82.7765,
    lat: 38.449
  }, {
    lng: -82.7765,
    lat: 38.449
  }, {
    lng: -82.7763,
    lat: 38.4496
  }, {
    lng: -82.7761,
    lat: 38.4501
  }, {
    lng: -82.7759,
    lat: 38.4503
  }, {
    lng: -82.7753,
    lat: 38.4505
  }, {
    lng: -82.7735,
    lat: 38.4513
  }, {
    lng: -82.7701,
    lat: 38.4512
  }, {
    lng: -82.7663,
    lat: 38.453
  }, {
    lng: -82.7637,
    lat: 38.4542
  }, {
    lng: -82.7633,
    lat: 38.4544
  }, {
    lng: -82.7631,
    lat: 38.4546
  }, {
    lng: -82.763,
    lat: 38.4549
  }, {
    lng: -82.7624,
    lat: 38.456
  }, {
    lng: -82.7618,
    lat: 38.4572
  }, {
    lng: -82.7616,
    lat: 38.4573
  }, {
    lng: -82.7614,
    lat: 38.4574
  }, {
    lng: -82.761,
    lat: 38.4571
  }, {
    lng: -82.7606,
    lat: 38.457
  }, {
    lng: -82.7601,
    lat: 38.4571
  }, {
    lng: -82.7594,
    lat: 38.4574
  }, {
    lng: -82.759,
    lat: 38.4578
  }, {
    lng: -82.7588,
    lat: 38.4584
  }, {
    lng: -82.759,
    lat: 38.4588
  }, {
    lng: -82.7593,
    lat: 38.4592
  }, {
    lng: -82.7595,
    lat: 38.4595
  }, {
    lng: -82.7594,
    lat: 38.4597
  }, {
    lng: -82.7592,
    lat: 38.46
  }, {
    lng: -82.7589,
    lat: 38.4602
  }, {
    lng: -82.7588,
    lat: 38.4605
  }, {
    lng: -82.7587,
    lat: 38.4608
  }, {
    lng: -82.7589,
    lat: 38.4612
  }, {
    lng: -82.7592,
    lat: 38.4614
  }, {
    lng: -82.7595,
    lat: 38.4616
  }, {
    lng: -82.7597,
    lat: 38.4619
  }, {
    lng: -82.7601,
    lat: 38.4621
  }, {
    lng: -82.7605,
    lat: 38.4621
  }, {
    lng: -82.7608,
    lat: 38.4622
  }, {
    lng: -82.7612,
    lat: 38.4624
  }, {
    lng: -82.7621,
    lat: 38.4626
  }, {
    lng: -82.7624,
    lat: 38.4627
  }, {
    lng: -82.7626,
    lat: 38.4628
  }, {
    lng: -82.7625,
    lat: 38.463
  }, {
    lng: -82.7622,
    lat: 38.4631
  }, {
    lng: -82.7615,
    lat: 38.4635
  }, {
    lng: -82.7609,
    lat: 38.4639
  }, {
    lng: -82.7604,
    lat: 38.4641
  }, {
    lng: -82.7601,
    lat: 38.4642
  }, {
    lng: -82.7597,
    lat: 38.4644
  }, {
    lng: -82.7595,
    lat: 38.4645
  }, {
    lng: -82.7593,
    lat: 38.4648
  }, {
    lng: -82.7591,
    lat: 38.4651
  }, {
    lng: -82.7589,
    lat: 38.4653
  }, {
    lng: -82.7586,
    lat: 38.4654
  }, {
    lng: -82.7583,
    lat: 38.4654
  }, {
    lng: -82.7579,
    lat: 38.4652
  }, {
    lng: -82.7575,
    lat: 38.4649
  }, {
    lng: -82.7572,
    lat: 38.4646
  }, {
    lng: -82.7569,
    lat: 38.4646
  }, {
    lng: -82.7564,
    lat: 38.4648
  }, {
    lng: -82.7561,
    lat: 38.465
  }, {
    lng: -82.7558,
    lat: 38.4653
  }, {
    lng: -82.7557,
    lat: 38.4654
  }], [{
    lng: -82.8604,
    lat: 38.4408
  }, {
    lng: -82.8613,
    lat: 38.4419
  }, {
    lng: -82.8611,
    lat: 38.4419
  }, {
    lng: -82.861,
    lat: 38.442
  }, {
    lng: -82.8607,
    lat: 38.4411
  }, {
    lng: -82.8604,
    lat: 38.4408
  }]]],
  options: {
    fillColor: '#009aee',
    fillOpacity: 0.4,
    strokeColor: '#0073B3',
    strokeWeight: 1,
    strokeOpacity: 0.4,
    clickable: true,
    visible: true,
    zIndex: 1000
  }
};
var carrierRoute19 = {
  "carrierRoute": "41102R009",
  "paths": [[[{
    "lng": -82.6331,
    "lat": 38.4369
  }, {
    "lng": -82.6332,
    "lat": 38.4369
  }, {
    "lng": -82.6334,
    "lat": 38.4369
  }, {
    "lng": -82.6336,
    "lat": 38.437
  }, {
    "lng": -82.634,
    "lat": 38.437
  }, {
    "lng": -82.6344,
    "lat": 38.4373
  }, {
    "lng": -82.6347,
    "lat": 38.4377
  }, {
    "lng": -82.6349,
    "lat": 38.4383
  }, {
    "lng": -82.6347,
    "lat": 38.4388
  }, {
    "lng": -82.635,
    "lat": 38.4396
  }, {
    "lng": -82.6357,
    "lat": 38.4412
  }, {
    "lng": -82.6357,
    "lat": 38.442
  }, {
    "lng": -82.6357,
    "lat": 38.4422
  }, {
    "lng": -82.6357,
    "lat": 38.4426
  }, {
    "lng": -82.6358,
    "lat": 38.4427
  }, {
    "lng": -82.6359,
    "lat": 38.4429
  }, {
    "lng": -82.636,
    "lat": 38.443
  }, {
    "lng": -82.636,
    "lat": 38.4431
  }, {
    "lng": -82.6361,
    "lat": 38.4431
  }, {
    "lng": -82.6361,
    "lat": 38.4432
  }, {
    "lng": -82.6365,
    "lat": 38.4436
  }, {
    "lng": -82.6367,
    "lat": 38.4438
  }, {
    "lng": -82.6367,
    "lat": 38.4439
  }, {
    "lng": -82.6368,
    "lat": 38.4441
  }, {
    "lng": -82.6368,
    "lat": 38.4444
  }, {
    "lng": -82.6369,
    "lat": 38.4445
  }, {
    "lng": -82.6369,
    "lat": 38.4446
  }, {
    "lng": -82.6369,
    "lat": 38.4447
  }, {
    "lng": -82.6369,
    "lat": 38.4449
  }, {
    "lng": -82.6369,
    "lat": 38.445
  }, {
    "lng": -82.6369,
    "lat": 38.4451
  }, {
    "lng": -82.6369,
    "lat": 38.4453
  }, {
    "lng": -82.6369,
    "lat": 38.4454
  }, {
    "lng": -82.6369,
    "lat": 38.4455
  }, {
    "lng": -82.6369,
    "lat": 38.4457
  }, {
    "lng": -82.6369,
    "lat": 38.446
  }, {
    "lng": -82.6369,
    "lat": 38.4461
  }, {
    "lng": -82.6369,
    "lat": 38.4467
  }, {
    "lng": -82.6369,
    "lat": 38.4469
  }, {
    "lng": -82.637,
    "lat": 38.447
  }, {
    "lng": -82.6371,
    "lat": 38.4472
  }, {
    "lng": -82.6372,
    "lat": 38.4475
  }, {
    "lng": -82.6372,
    "lat": 38.4476
  }, {
    "lng": -82.6372,
    "lat": 38.4477
  }, {
    "lng": -82.6373,
    "lat": 38.448
  }, {
    "lng": -82.6373,
    "lat": 38.4483
  }, {
    "lng": -82.6373,
    "lat": 38.4484
  }, {
    "lng": -82.6373,
    "lat": 38.4486
  }, {
    "lng": -82.6373,
    "lat": 38.4486
  }, {
    "lng": -82.6377,
    "lat": 38.4485
  }, {
    "lng": -82.6379,
    "lat": 38.4485
  }, {
    "lng": -82.638,
    "lat": 38.4485
  }, {
    "lng": -82.6381,
    "lat": 38.4485
  }, {
    "lng": -82.6382,
    "lat": 38.4485
  }, {
    "lng": -82.6388,
    "lat": 38.4483
  }, {
    "lng": -82.639,
    "lat": 38.4482
  }, {
    "lng": -82.6402,
    "lat": 38.4482
  }, {
    "lng": -82.6414,
    "lat": 38.4481
  }, {
    "lng": -82.6413,
    "lat": 38.448
  }, {
    "lng": -82.6404,
    "lat": 38.4471
  }, {
    "lng": -82.6403,
    "lat": 38.447
  }, {
    "lng": -82.6402,
    "lat": 38.4469
  }, {
    "lng": -82.64,
    "lat": 38.4468
  }, {
    "lng": -82.6399,
    "lat": 38.4467
  }, {
    "lng": -82.6398,
    "lat": 38.4466
  }, {
    "lng": -82.6398,
    "lat": 38.4466
  }, {
    "lng": -82.6397,
    "lat": 38.4465
  }, {
    "lng": -82.6395,
    "lat": 38.4463
  }, {
    "lng": -82.6394,
    "lat": 38.4462
  }, {
    "lng": -82.6394,
    "lat": 38.4461
  }, {
    "lng": -82.6393,
    "lat": 38.4458
  }, {
    "lng": -82.6389,
    "lat": 38.4447
  }, {
    "lng": -82.6388,
    "lat": 38.4445
  }, {
    "lng": -82.6384,
    "lat": 38.4432
  }, {
    "lng": -82.6387,
    "lat": 38.4431
  }, {
    "lng": -82.6392,
    "lat": 38.4431
  }, {
    "lng": -82.6404,
    "lat": 38.4431
  }, {
    "lng": -82.6413,
    "lat": 38.4429
  }, {
    "lng": -82.6424,
    "lat": 38.4429
  }, {
    "lng": -82.6427,
    "lat": 38.4434
  }, {
    "lng": -82.6429,
    "lat": 38.4433
  }, {
    "lng": -82.643,
    "lat": 38.4433
  }, {
    "lng": -82.643,
    "lat": 38.4432
  }, {
    "lng": -82.6431,
    "lat": 38.4432
  }, {
    "lng": -82.6432,
    "lat": 38.4432
  }, {
    "lng": -82.6434,
    "lat": 38.4437
  }, {
    "lng": -82.6439,
    "lat": 38.4439
  }, {
    "lng": -82.6445,
    "lat": 38.4443
  }, {
    "lng": -82.6452,
    "lat": 38.4448
  }, {
    "lng": -82.6454,
    "lat": 38.4453
  }, {
    "lng": -82.6454,
    "lat": 38.4459
  }, {
    "lng": -82.6458,
    "lat": 38.446
  }, {
    "lng": -82.6459,
    "lat": 38.4461
  }, {
    "lng": -82.646,
    "lat": 38.4462
  }, {
    "lng": -82.6462,
    "lat": 38.4466
  }, {
    "lng": -82.6463,
    "lat": 38.4466
  }, {
    "lng": -82.6464,
    "lat": 38.4467
  }, {
    "lng": -82.6465,
    "lat": 38.4468
  }, {
    "lng": -82.6467,
    "lat": 38.4469
  }, {
    "lng": -82.6469,
    "lat": 38.447
  }, {
    "lng": -82.6471,
    "lat": 38.4471
  }, {
    "lng": -82.6473,
    "lat": 38.4472
  }, {
    "lng": -82.6475,
    "lat": 38.4473
  }, {
    "lng": -82.6475,
    "lat": 38.4473
  }, {
    "lng": -82.6476,
    "lat": 38.4473
  }, {
    "lng": -82.6475,
    "lat": 38.4474
  }, {
    "lng": -82.6474,
    "lat": 38.4477
  }, {
    "lng": -82.6473,
    "lat": 38.4481
  }, {
    "lng": -82.6473,
    "lat": 38.4483
  }, {
    "lng": -82.6479,
    "lat": 38.4477
  }, {
    "lng": -82.6592,
    "lat": 38.4492
  }, {
    "lng": -82.6606,
    "lat": 38.449
  }, {
    "lng": -82.6611,
    "lat": 38.449
  }, {
    "lng": -82.6623,
    "lat": 38.4491
  }, {
    "lng": -82.6629,
    "lat": 38.449
  }, {
    "lng": -82.6635,
    "lat": 38.4487
  }, {
    "lng": -82.6643,
    "lat": 38.4482
  }, {
    "lng": -82.6653,
    "lat": 38.4476
  }, {
    "lng": -82.666,
    "lat": 38.4469
  }, {
    "lng": -82.6666,
    "lat": 38.4465
  }, {
    "lng": -82.6666,
    "lat": 38.4462
  }, {
    "lng": -82.6666,
    "lat": 38.4459
  }, {
    "lng": -82.6666,
    "lat": 38.4455
  }, {
    "lng": -82.6667,
    "lat": 38.445
  }, {
    "lng": -82.6669,
    "lat": 38.4444
  }, {
    "lng": -82.667,
    "lat": 38.4444
  }, {
    "lng": -82.6671,
    "lat": 38.4445
  }, {
    "lng": -82.6672,
    "lat": 38.4446
  }, {
    "lng": -82.6673,
    "lat": 38.4446
  }, {
    "lng": -82.6678,
    "lat": 38.4447
  }, {
    "lng": -82.668,
    "lat": 38.4447
  }, {
    "lng": -82.6682,
    "lat": 38.4447
  }, {
    "lng": -82.6684,
    "lat": 38.4448
  }, {
    "lng": -82.6688,
    "lat": 38.4449
  }, {
    "lng": -82.669,
    "lat": 38.4449
  }, {
    "lng": -82.6691,
    "lat": 38.445
  }, {
    "lng": -82.6691,
    "lat": 38.445
  }, {
    "lng": -82.6692,
    "lat": 38.445
  }, {
    "lng": -82.6693,
    "lat": 38.4451
  }, {
    "lng": -82.6694,
    "lat": 38.4452
  }, {
    "lng": -82.6695,
    "lat": 38.4453
  }, {
    "lng": -82.6696,
    "lat": 38.4454
  }, {
    "lng": -82.6697,
    "lat": 38.4455
  }, {
    "lng": -82.6698,
    "lat": 38.4456
  }, {
    "lng": -82.67,
    "lat": 38.4456
  }, {
    "lng": -82.6701,
    "lat": 38.4457
  }, {
    "lng": -82.6703,
    "lat": 38.4457
  }, {
    "lng": -82.6703,
    "lat": 38.4457
  }, {
    "lng": -82.6705,
    "lat": 38.4457
  }, {
    "lng": -82.6705,
    "lat": 38.4457
  }, {
    "lng": -82.6707,
    "lat": 38.4456
  }, {
    "lng": -82.6708,
    "lat": 38.4456
  }, {
    "lng": -82.671,
    "lat": 38.4455
  }, {
    "lng": -82.6711,
    "lat": 38.4455
  }, {
    "lng": -82.6712,
    "lat": 38.4455
  }, {
    "lng": -82.6715,
    "lat": 38.4454
  }, {
    "lng": -82.6718,
    "lat": 38.4454
  }, {
    "lng": -82.6719,
    "lat": 38.4454
  }, {
    "lng": -82.672,
    "lat": 38.4454
  }, {
    "lng": -82.6722,
    "lat": 38.4454
  }, {
    "lng": -82.6724,
    "lat": 38.4455
  }, {
    "lng": -82.6726,
    "lat": 38.4456
  }, {
    "lng": -82.6727,
    "lat": 38.4456
  }, {
    "lng": -82.6728,
    "lat": 38.4457
  }, {
    "lng": -82.6728,
    "lat": 38.4457
  }, {
    "lng": -82.6728,
    "lat": 38.4457
  }, {
    "lng": -82.6726,
    "lat": 38.4462
  }, {
    "lng": -82.6725,
    "lat": 38.4462
  }, {
    "lng": -82.6725,
    "lat": 38.4463
  }, {
    "lng": -82.6724,
    "lat": 38.4464
  }, {
    "lng": -82.6719,
    "lat": 38.447
  }, {
    "lng": -82.6713,
    "lat": 38.4474
  }, {
    "lng": -82.6714,
    "lat": 38.4474
  }, {
    "lng": -82.6718,
    "lat": 38.4476
  }, {
    "lng": -82.6723,
    "lat": 38.4478
  }, {
    "lng": -82.6725,
    "lat": 38.4479
  }, {
    "lng": -82.6725,
    "lat": 38.4479
  }, {
    "lng": -82.6726,
    "lat": 38.448
  }, {
    "lng": -82.6727,
    "lat": 38.448
  }, {
    "lng": -82.6727,
    "lat": 38.448
  }, {
    "lng": -82.6728,
    "lat": 38.4481
  }, {
    "lng": -82.6728,
    "lat": 38.4481
  }, {
    "lng": -82.673,
    "lat": 38.4481
  }, {
    "lng": -82.6732,
    "lat": 38.4481
  }, {
    "lng": -82.6733,
    "lat": 38.4481
  }, {
    "lng": -82.6734,
    "lat": 38.4481
  }, {
    "lng": -82.6734,
    "lat": 38.4482
  }, {
    "lng": -82.6736,
    "lat": 38.4483
  }, {
    "lng": -82.6738,
    "lat": 38.4483
  }, {
    "lng": -82.674,
    "lat": 38.4485
  }, {
    "lng": -82.6742,
    "lat": 38.4486
  }, {
    "lng": -82.6744,
    "lat": 38.4488
  }, {
    "lng": -82.6745,
    "lat": 38.4488
  }, {
    "lng": -82.676,
    "lat": 38.45
  }, {
    "lng": -82.6762,
    "lat": 38.4498
  }, {
    "lng": -82.6764,
    "lat": 38.4496
  }, {
    "lng": -82.6767,
    "lat": 38.4494
  }, {
    "lng": -82.6768,
    "lat": 38.4493
  }, {
    "lng": -82.6769,
    "lat": 38.4492
  }, {
    "lng": -82.6771,
    "lat": 38.4491
  }, {
    "lng": -82.6774,
    "lat": 38.4489
  }, {
    "lng": -82.6778,
    "lat": 38.4487
  }, {
    "lng": -82.6779,
    "lat": 38.4486
  }, {
    "lng": -82.6786,
    "lat": 38.4483
  }, {
    "lng": -82.6788,
    "lat": 38.4481
  }, {
    "lng": -82.679,
    "lat": 38.448
  }, {
    "lng": -82.6791,
    "lat": 38.4479
  }, {
    "lng": -82.6793,
    "lat": 38.4478
  }, {
    "lng": -82.6794,
    "lat": 38.4476
  }, {
    "lng": -82.6795,
    "lat": 38.4475
  }, {
    "lng": -82.6796,
    "lat": 38.4473
  }, {
    "lng": -82.6797,
    "lat": 38.4472
  }, {
    "lng": -82.6799,
    "lat": 38.4469
  }, {
    "lng": -82.6799,
    "lat": 38.4467
  }, {
    "lng": -82.68,
    "lat": 38.4465
  }, {
    "lng": -82.6802,
    "lat": 38.4455
  }, {
    "lng": -82.6804,
    "lat": 38.445
  }, {
    "lng": -82.6806,
    "lat": 38.4443
  }, {
    "lng": -82.6806,
    "lat": 38.4439
  }, {
    "lng": -82.6806,
    "lat": 38.4439
  }, {
    "lng": -82.6808,
    "lat": 38.444
  }, {
    "lng": -82.6808,
    "lat": 38.4435
  }, {
    "lng": -82.6808,
    "lat": 38.4434
  }, {
    "lng": -82.6805,
    "lat": 38.442
  }, {
    "lng": -82.6805,
    "lat": 38.4418
  }, {
    "lng": -82.6805,
    "lat": 38.4415
  }, {
    "lng": -82.6805,
    "lat": 38.4412
  }, {
    "lng": -82.6805,
    "lat": 38.4407
  }, {
    "lng": -82.6806,
    "lat": 38.4405
  }, {
    "lng": -82.6807,
    "lat": 38.4406
  }, {
    "lng": -82.6808,
    "lat": 38.4403
  }, {
    "lng": -82.6809,
    "lat": 38.4403
  }, {
    "lng": -82.6813,
    "lat": 38.4397
  }, {
    "lng": -82.6814,
    "lat": 38.4396
  }, {
    "lng": -82.6815,
    "lat": 38.4394
  }, {
    "lng": -82.6818,
    "lat": 38.4392
  }, {
    "lng": -82.6819,
    "lat": 38.4391
  }, {
    "lng": -82.6822,
    "lat": 38.4389
  }, {
    "lng": -82.6824,
    "lat": 38.4388
  }, {
    "lng": -82.6829,
    "lat": 38.4386
  }, {
    "lng": -82.6833,
    "lat": 38.4384
  }, {
    "lng": -82.684,
    "lat": 38.4383
  }, {
    "lng": -82.6854,
    "lat": 38.438
  }, {
    "lng": -82.687,
    "lat": 38.4376
  }, {
    "lng": -82.6888,
    "lat": 38.4373
  }, {
    "lng": -82.6893,
    "lat": 38.4371
  }, {
    "lng": -82.6896,
    "lat": 38.437
  }, {
    "lng": -82.6899,
    "lat": 38.4369
  }, {
    "lng": -82.6903,
    "lat": 38.4366
  }, {
    "lng": -82.6904,
    "lat": 38.4366
  }, {
    "lng": -82.6903,
    "lat": 38.4365
  }, {
    "lng": -82.6901,
    "lat": 38.4365
  }, {
    "lng": -82.6903,
    "lat": 38.4364
  }, {
    "lng": -82.6904,
    "lat": 38.4362
  }, {
    "lng": -82.6909,
    "lat": 38.4357
  }, {
    "lng": -82.6909,
    "lat": 38.4357
  }, {
    "lng": -82.6912,
    "lat": 38.4353
  }, {
    "lng": -82.6914,
    "lat": 38.4351
  }, {
    "lng": -82.6918,
    "lat": 38.4346
  }, {
    "lng": -82.6925,
    "lat": 38.4337
  }, {
    "lng": -82.6927,
    "lat": 38.4335
  }, {
    "lng": -82.6928,
    "lat": 38.4333
  }, {
    "lng": -82.6933,
    "lat": 38.4327
  }, {
    "lng": -82.6932,
    "lat": 38.4326
  }, {
    "lng": -82.6931,
    "lat": 38.4326
  }, {
    "lng": -82.6931,
    "lat": 38.4326
  }, {
    "lng": -82.693,
    "lat": 38.4325
  }, {
    "lng": -82.6932,
    "lat": 38.4319
  }, {
    "lng": -82.6933,
    "lat": 38.4317
  }, {
    "lng": -82.6933,
    "lat": 38.4314
  }, {
    "lng": -82.6934,
    "lat": 38.4313
  }, {
    "lng": -82.6934,
    "lat": 38.4312
  }, {
    "lng": -82.6935,
    "lat": 38.4308
  }, {
    "lng": -82.6936,
    "lat": 38.4306
  }, {
    "lng": -82.6937,
    "lat": 38.4302
  }, {
    "lng": -82.6937,
    "lat": 38.4299
  }, {
    "lng": -82.6937,
    "lat": 38.4295
  }, {
    "lng": -82.6938,
    "lat": 38.4294
  }, {
    "lng": -82.6938,
    "lat": 38.4291
  }, {
    "lng": -82.6939,
    "lat": 38.429
  }, {
    "lng": -82.6939,
    "lat": 38.4289
  }, {
    "lng": -82.6938,
    "lat": 38.4288
  }, {
    "lng": -82.694,
    "lat": 38.4286
  }, {
    "lng": -82.694,
    "lat": 38.4285
  }, {
    "lng": -82.6941,
    "lat": 38.4284
  }, {
    "lng": -82.6942,
    "lat": 38.4283
  }, {
    "lng": -82.6944,
    "lat": 38.428
  }, {
    "lng": -82.6945,
    "lat": 38.4279
  }, {
    "lng": -82.6947,
    "lat": 38.4278
  }, {
    "lng": -82.6948,
    "lat": 38.4275
  }, {
    "lng": -82.6938,
    "lat": 38.4264
  }, {
    "lng": -82.6933,
    "lat": 38.4259
  }, {
    "lng": -82.6933,
    "lat": 38.4259
  }, {
    "lng": -82.6929,
    "lat": 38.4257
  }, {
    "lng": -82.6923,
    "lat": 38.4255
  }, {
    "lng": -82.6922,
    "lat": 38.4254
  }, {
    "lng": -82.6922,
    "lat": 38.4249
  }, {
    "lng": -82.6921,
    "lat": 38.4244
  }, {
    "lng": -82.6927,
    "lat": 38.4243
  }, {
    "lng": -82.6934,
    "lat": 38.4241
  }, {
    "lng": -82.6937,
    "lat": 38.424
  }, {
    "lng": -82.6939,
    "lat": 38.424
  }, {
    "lng": -82.6941,
    "lat": 38.4239
  }, {
    "lng": -82.6941,
    "lat": 38.4238
  }, {
    "lng": -82.6947,
    "lat": 38.4233
  }, {
    "lng": -82.6951,
    "lat": 38.423
  }, {
    "lng": -82.6952,
    "lat": 38.4229
  }, {
    "lng": -82.6953,
    "lat": 38.4227
  }, {
    "lng": -82.6955,
    "lat": 38.4226
  }, {
    "lng": -82.6956,
    "lat": 38.4223
  }, {
    "lng": -82.6956,
    "lat": 38.4222
  }, {
    "lng": -82.6958,
    "lat": 38.4215
  }, {
    "lng": -82.6959,
    "lat": 38.4213
  }, {
    "lng": -82.6959,
    "lat": 38.4211
  }, {
    "lng": -82.6961,
    "lat": 38.4207
  }, {
    "lng": -82.6961,
    "lat": 38.4207
  }, {
    "lng": -82.6964,
    "lat": 38.4203
  }, {
    "lng": -82.6968,
    "lat": 38.4198
  }, {
    "lng": -82.697,
    "lat": 38.4195
  }, {
    "lng": -82.6972,
    "lat": 38.4188
  }, {
    "lng": -82.6973,
    "lat": 38.4187
  }, {
    "lng": -82.6974,
    "lat": 38.4186
  }, {
    "lng": -82.6976,
    "lat": 38.4186
  }, {
    "lng": -82.6978,
    "lat": 38.4186
  }, {
    "lng": -82.6979,
    "lat": 38.4186
  }, {
    "lng": -82.6981,
    "lat": 38.4187
  }, {
    "lng": -82.6982,
    "lat": 38.4187
  }, {
    "lng": -82.6983,
    "lat": 38.4188
  }, {
    "lng": -82.6984,
    "lat": 38.4189
  }, {
    "lng": -82.6985,
    "lat": 38.4192
  }, {
    "lng": -82.6984,
    "lat": 38.4184
  }, {
    "lng": -82.6981,
    "lat": 38.4182
  }, {
    "lng": -82.698,
    "lat": 38.418
  }, {
    "lng": -82.6979,
    "lat": 38.418
  }, {
    "lng": -82.6973,
    "lat": 38.4179
  }, {
    "lng": -82.6972,
    "lat": 38.4178
  }, {
    "lng": -82.6968,
    "lat": 38.4178
  }, {
    "lng": -82.6964,
    "lat": 38.4178
  }, {
    "lng": -82.696,
    "lat": 38.4178
  }, {
    "lng": -82.6955,
    "lat": 38.4178
  }, {
    "lng": -82.6952,
    "lat": 38.4178
  }, {
    "lng": -82.6949,
    "lat": 38.4178
  }, {
    "lng": -82.6943,
    "lat": 38.4177
  }, {
    "lng": -82.6932,
    "lat": 38.4177
  }, {
    "lng": -82.6933,
    "lat": 38.417
  }, {
    "lng": -82.6936,
    "lat": 38.417
  }, {
    "lng": -82.6942,
    "lat": 38.4169
  }, {
    "lng": -82.6947,
    "lat": 38.4167
  }, {
    "lng": -82.6953,
    "lat": 38.4168
  }, {
    "lng": -82.6961,
    "lat": 38.4167
  }, {
    "lng": -82.6992,
    "lat": 38.4169
  }, {
    "lng": -82.6992,
    "lat": 38.4166
  }, {
    "lng": -82.6992,
    "lat": 38.4158
  }, {
    "lng": -82.6992,
    "lat": 38.4156
  }, {
    "lng": -82.6991,
    "lat": 38.4147
  }, {
    "lng": -82.6991,
    "lat": 38.4146
  }, {
    "lng": -82.6991,
    "lat": 38.4145
  }, {
    "lng": -82.6991,
    "lat": 38.4143
  }, {
    "lng": -82.6993,
    "lat": 38.4141
  }, {
    "lng": -82.6994,
    "lat": 38.414
  }, {
    "lng": -82.6995,
    "lat": 38.4139
  }, {
    "lng": -82.7002,
    "lat": 38.4137
  }, {
    "lng": -82.7004,
    "lat": 38.4136
  }, {
    "lng": -82.7005,
    "lat": 38.4135
  }, {
    "lng": -82.7005,
    "lat": 38.4135
  }, {
    "lng": -82.7006,
    "lat": 38.4134
  }, {
    "lng": -82.7006,
    "lat": 38.4133
  }, {
    "lng": -82.7006,
    "lat": 38.4131
  }, {
    "lng": -82.7003,
    "lat": 38.4124
  }, {
    "lng": -82.7003,
    "lat": 38.4122
  }, {
    "lng": -82.6997,
    "lat": 38.411
  }, {
    "lng": -82.6994,
    "lat": 38.4106
  }, {
    "lng": -82.6992,
    "lat": 38.4105
  }, {
    "lng": -82.699,
    "lat": 38.4104
  }, {
    "lng": -82.6983,
    "lat": 38.4102
  }, {
    "lng": -82.6973,
    "lat": 38.41
  }, {
    "lng": -82.6965,
    "lat": 38.4099
  }, {
    "lng": -82.696,
    "lat": 38.4097
  }, {
    "lng": -82.6953,
    "lat": 38.4095
  }, {
    "lng": -82.695,
    "lat": 38.4093
  }, {
    "lng": -82.6947,
    "lat": 38.4092
  }, {
    "lng": -82.6944,
    "lat": 38.4091
  }, {
    "lng": -82.6941,
    "lat": 38.4091
  }, {
    "lng": -82.6936,
    "lat": 38.4091
  }, {
    "lng": -82.6934,
    "lat": 38.409
  }, {
    "lng": -82.6933,
    "lat": 38.409
  }, {
    "lng": -82.6932,
    "lat": 38.4089
  }, {
    "lng": -82.6931,
    "lat": 38.4088
  }, {
    "lng": -82.693,
    "lat": 38.4087
  }, {
    "lng": -82.6928,
    "lat": 38.4085
  }, {
    "lng": -82.6926,
    "lat": 38.4083
  }, {
    "lng": -82.6925,
    "lat": 38.4082
  }, {
    "lng": -82.6923,
    "lat": 38.4082
  }, {
    "lng": -82.6922,
    "lat": 38.4081
  }, {
    "lng": -82.692,
    "lat": 38.4081
  }, {
    "lng": -82.6917,
    "lat": 38.408
  }, {
    "lng": -82.6912,
    "lat": 38.408
  }, {
    "lng": -82.6908,
    "lat": 38.4079
  }, {
    "lng": -82.6899,
    "lat": 38.4078
  }, {
    "lng": -82.6896,
    "lat": 38.4083
  }, {
    "lng": -82.6895,
    "lat": 38.4084
  }, {
    "lng": -82.6894,
    "lat": 38.4085
  }, {
    "lng": -82.6893,
    "lat": 38.4088
  }, {
    "lng": -82.6893,
    "lat": 38.4089
  }, {
    "lng": -82.6893,
    "lat": 38.4091
  }, {
    "lng": -82.6894,
    "lat": 38.4093
  }, {
    "lng": -82.6895,
    "lat": 38.4094
  }, {
    "lng": -82.6898,
    "lat": 38.4098
  }, {
    "lng": -82.69,
    "lat": 38.4101
  }, {
    "lng": -82.6904,
    "lat": 38.4105
  }, {
    "lng": -82.6905,
    "lat": 38.4107
  }, {
    "lng": -82.6907,
    "lat": 38.4109
  }, {
    "lng": -82.6907,
    "lat": 38.4111
  }, {
    "lng": -82.6908,
    "lat": 38.4111
  }, {
    "lng": -82.6909,
    "lat": 38.4113
  }, {
    "lng": -82.6909,
    "lat": 38.4114
  }, {
    "lng": -82.6909,
    "lat": 38.4116
  }, {
    "lng": -82.691,
    "lat": 38.4119
  }, {
    "lng": -82.6909,
    "lat": 38.4125
  }, {
    "lng": -82.6909,
    "lat": 38.4131
  }, {
    "lng": -82.6903,
    "lat": 38.414
  }, {
    "lng": -82.6902,
    "lat": 38.4142
  }, {
    "lng": -82.6902,
    "lat": 38.4143
  }, {
    "lng": -82.6899,
    "lat": 38.4145
  }, {
    "lng": -82.6897,
    "lat": 38.4145
  }, {
    "lng": -82.6894,
    "lat": 38.4149
  }, {
    "lng": -82.6892,
    "lat": 38.4147
  }, {
    "lng": -82.6887,
    "lat": 38.4143
  }, {
    "lng": -82.6881,
    "lat": 38.414
  }, {
    "lng": -82.6868,
    "lat": 38.4142
  }, {
    "lng": -82.6861,
    "lat": 38.4146
  }, {
    "lng": -82.6857,
    "lat": 38.4147
  }, {
    "lng": -82.6851,
    "lat": 38.4149
  }, {
    "lng": -82.6846,
    "lat": 38.4148
  }, {
    "lng": -82.6842,
    "lat": 38.4147
  }, {
    "lng": -82.684,
    "lat": 38.4146
  }, {
    "lng": -82.6828,
    "lat": 38.4141
  }, {
    "lng": -82.6813,
    "lat": 38.413
  }, {
    "lng": -82.6805,
    "lat": 38.4126
  }, {
    "lng": -82.6796,
    "lat": 38.4124
  }, {
    "lng": -82.6787,
    "lat": 38.4123
  }, {
    "lng": -82.6778,
    "lat": 38.412
  }, {
    "lng": -82.6776,
    "lat": 38.4119
  }, {
    "lng": -82.6768,
    "lat": 38.4116
  }, {
    "lng": -82.6762,
    "lat": 38.4117
  }, {
    "lng": -82.6761,
    "lat": 38.412
  }, {
    "lng": -82.6761,
    "lat": 38.4121
  }, {
    "lng": -82.6761,
    "lat": 38.4122
  }, {
    "lng": -82.6761,
    "lat": 38.4122
  }, {
    "lng": -82.6761,
    "lat": 38.4123
  }, {
    "lng": -82.6761,
    "lat": 38.4124
  }, {
    "lng": -82.6762,
    "lat": 38.4125
  }, {
    "lng": -82.676,
    "lat": 38.4125
  }, {
    "lng": -82.6746,
    "lat": 38.4124
  }, {
    "lng": -82.6733,
    "lat": 38.4121
  }, {
    "lng": -82.6732,
    "lat": 38.4121
  }, {
    "lng": -82.6729,
    "lat": 38.4119
  }, {
    "lng": -82.6726,
    "lat": 38.4117
  }, {
    "lng": -82.6721,
    "lat": 38.4114
  }, {
    "lng": -82.6704,
    "lat": 38.4109
  }, {
    "lng": -82.67,
    "lat": 38.4109
  }, {
    "lng": -82.6695,
    "lat": 38.4114
  }, {
    "lng": -82.6686,
    "lat": 38.412
  }, {
    "lng": -82.6684,
    "lat": 38.4125
  }, {
    "lng": -82.6683,
    "lat": 38.413
  }, {
    "lng": -82.668,
    "lat": 38.4142
  }, {
    "lng": -82.6676,
    "lat": 38.4147
  }, {
    "lng": -82.6647,
    "lat": 38.4159
  }, {
    "lng": -82.6639,
    "lat": 38.4162
  }, {
    "lng": -82.663,
    "lat": 38.4169
  }, {
    "lng": -82.6624,
    "lat": 38.4173
  }, {
    "lng": -82.662,
    "lat": 38.4175
  }, {
    "lng": -82.6615,
    "lat": 38.4175
  }, {
    "lng": -82.6611,
    "lat": 38.4174
  }, {
    "lng": -82.6611,
    "lat": 38.4176
  }, {
    "lng": -82.6615,
    "lat": 38.4179
  }, {
    "lng": -82.6621,
    "lat": 38.418
  }, {
    "lng": -82.6631,
    "lat": 38.4182
  }, {
    "lng": -82.6635,
    "lat": 38.4182
  }, {
    "lng": -82.6642,
    "lat": 38.4184
  }, {
    "lng": -82.6649,
    "lat": 38.4187
  }, {
    "lng": -82.6661,
    "lat": 38.4195
  }, {
    "lng": -82.6667,
    "lat": 38.4199
  }, {
    "lng": -82.6676,
    "lat": 38.4202
  }, {
    "lng": -82.6698,
    "lat": 38.4209
  }, {
    "lng": -82.6696,
    "lat": 38.4218
  }, {
    "lng": -82.669,
    "lat": 38.4234
  }, {
    "lng": -82.6686,
    "lat": 38.4246
  }, {
    "lng": -82.6685,
    "lat": 38.4249
  }, {
    "lng": -82.6676,
    "lat": 38.4261
  }, {
    "lng": -82.667,
    "lat": 38.4267
  }, {
    "lng": -82.666,
    "lat": 38.427
  }, {
    "lng": -82.6644,
    "lat": 38.4275
  }, {
    "lng": -82.6642,
    "lat": 38.4275
  }, {
    "lng": -82.6636,
    "lat": 38.4278
  }, {
    "lng": -82.6629,
    "lat": 38.4294
  }, {
    "lng": -82.6627,
    "lat": 38.4303
  }, {
    "lng": -82.6626,
    "lat": 38.4303
  }, {
    "lng": -82.661,
    "lat": 38.4304
  }, {
    "lng": -82.6588,
    "lat": 38.4304
  }, {
    "lng": -82.658,
    "lat": 38.4307
  }, {
    "lng": -82.6574,
    "lat": 38.4307
  }, {
    "lng": -82.6571,
    "lat": 38.4305
  }, {
    "lng": -82.6546,
    "lat": 38.4283
  }, {
    "lng": -82.6539,
    "lat": 38.4276
  }, {
    "lng": -82.6529,
    "lat": 38.4283
  }, {
    "lng": -82.6528,
    "lat": 38.4283
  }, {
    "lng": -82.6521,
    "lat": 38.4287
  }, {
    "lng": -82.6515,
    "lat": 38.4289
  }, {
    "lng": -82.6496,
    "lat": 38.4294
  }, {
    "lng": -82.6483,
    "lat": 38.4298
  }, {
    "lng": -82.648,
    "lat": 38.4299
  }, {
    "lng": -82.6464,
    "lat": 38.4306
  }, {
    "lng": -82.6458,
    "lat": 38.4309
  }, {
    "lng": -82.6452,
    "lat": 38.4311
  }, {
    "lng": -82.645,
    "lat": 38.4311
  }, {
    "lng": -82.6449,
    "lat": 38.4311
  }, {
    "lng": -82.6444,
    "lat": 38.4312
  }, {
    "lng": -82.6417,
    "lat": 38.4312
  }, {
    "lng": -82.6397,
    "lat": 38.4315
  }, {
    "lng": -82.6384,
    "lat": 38.4318
  }, {
    "lng": -82.637,
    "lat": 38.4324
  }, {
    "lng": -82.6365,
    "lat": 38.4327
  }, {
    "lng": -82.6362,
    "lat": 38.4331
  }, {
    "lng": -82.6357,
    "lat": 38.4342
  }, {
    "lng": -82.6354,
    "lat": 38.4347
  }, {
    "lng": -82.6353,
    "lat": 38.4348
  }, {
    "lng": -82.635,
    "lat": 38.4353
  }, {
    "lng": -82.6342,
    "lat": 38.4357
  }, {
    "lng": -82.634,
    "lat": 38.4358
  }, {
    "lng": -82.6334,
    "lat": 38.4361
  }, {
    "lng": -82.6332,
    "lat": 38.4365
  }, {
    "lng": -82.6332,
    "lat": 38.4366
  }, {
    "lng": -82.6331,
    "lat": 38.4369
  }]]],
  "options": {
    "fillColor": "#009aee",
    "fillOpacity": 0.4,
    "strokeColor": "#0073B3",
    "strokeWeight": 1,
    "strokeOpacity": 0.4,
    "clickable": true,
    "visible": true,
    "zIndex": 1000
  }
};
var carrierRoute20 = {
  "carrierRoute": "41102R008",
  "paths": [[[{
    "lng": -82.7074,
    "lat": 38.432
  }, {
    "lng": -82.7075,
    "lat": 38.4321
  }, {
    "lng": -82.7082,
    "lat": 38.4323
  }, {
    "lng": -82.7083,
    "lat": 38.4323
  }, {
    "lng": -82.7089,
    "lat": 38.4324
  }, {
    "lng": -82.7092,
    "lat": 38.4323
  }, {
    "lng": -82.7095,
    "lat": 38.4323
  }, {
    "lng": -82.7097,
    "lat": 38.4322
  }, {
    "lng": -82.7099,
    "lat": 38.4322
  }, {
    "lng": -82.7099,
    "lat": 38.4321
  }, {
    "lng": -82.7101,
    "lat": 38.4321
  }, {
    "lng": -82.7102,
    "lat": 38.4321
  }, {
    "lng": -82.7104,
    "lat": 38.4322
  }, {
    "lng": -82.7104,
    "lat": 38.4322
  }, {
    "lng": -82.7107,
    "lat": 38.4322
  }, {
    "lng": -82.7109,
    "lat": 38.4323
  }, {
    "lng": -82.7111,
    "lat": 38.4323
  }, {
    "lng": -82.7113,
    "lat": 38.4324
  }, {
    "lng": -82.7115,
    "lat": 38.4325
  }, {
    "lng": -82.7117,
    "lat": 38.4326
  }, {
    "lng": -82.7118,
    "lat": 38.4326
  }, {
    "lng": -82.7127,
    "lat": 38.4333
  }, {
    "lng": -82.7128,
    "lat": 38.4333
  }, {
    "lng": -82.713,
    "lat": 38.4334
  }, {
    "lng": -82.7132,
    "lat": 38.4335
  }, {
    "lng": -82.7133,
    "lat": 38.4335
  }, {
    "lng": -82.7135,
    "lat": 38.4336
  }, {
    "lng": -82.7136,
    "lat": 38.4336
  }, {
    "lng": -82.714,
    "lat": 38.4337
  }, {
    "lng": -82.7144,
    "lat": 38.4337
  }, {
    "lng": -82.7153,
    "lat": 38.4337
  }, {
    "lng": -82.7158,
    "lat": 38.4337
  }, {
    "lng": -82.7162,
    "lat": 38.4338
  }, {
    "lng": -82.7163,
    "lat": 38.4339
  }, {
    "lng": -82.7165,
    "lat": 38.4339
  }, {
    "lng": -82.7167,
    "lat": 38.4341
  }, {
    "lng": -82.7169,
    "lat": 38.4342
  }, {
    "lng": -82.717,
    "lat": 38.4342
  }, {
    "lng": -82.7173,
    "lat": 38.4348
  }, {
    "lng": -82.7173,
    "lat": 38.4348
  }, {
    "lng": -82.7174,
    "lat": 38.4348
  }, {
    "lng": -82.7181,
    "lat": 38.4347
  }, {
    "lng": -82.7182,
    "lat": 38.4347
  }, {
    "lng": -82.7183,
    "lat": 38.4347
  }, {
    "lng": -82.7184,
    "lat": 38.4347
  }, {
    "lng": -82.7185,
    "lat": 38.4347
  }, {
    "lng": -82.7186,
    "lat": 38.4348
  }, {
    "lng": -82.7187,
    "lat": 38.4348
  }, {
    "lng": -82.7189,
    "lat": 38.4348
  }, {
    "lng": -82.7189,
    "lat": 38.4348
  }, {
    "lng": -82.7208,
    "lat": 38.4342
  }, {
    "lng": -82.7209,
    "lat": 38.4342
  }, {
    "lng": -82.7211,
    "lat": 38.434
  }, {
    "lng": -82.7212,
    "lat": 38.434
  }, {
    "lng": -82.7215,
    "lat": 38.4339
  }, {
    "lng": -82.7219,
    "lat": 38.4333
  }, {
    "lng": -82.7223,
    "lat": 38.4329
  }, {
    "lng": -82.7228,
    "lat": 38.4327
  }, {
    "lng": -82.7234,
    "lat": 38.4325
  }, {
    "lng": -82.7235,
    "lat": 38.4325
  }, {
    "lng": -82.7236,
    "lat": 38.4326
  }, {
    "lng": -82.7238,
    "lat": 38.4327
  }, {
    "lng": -82.724,
    "lat": 38.4327
  }, {
    "lng": -82.7242,
    "lat": 38.4328
  }, {
    "lng": -82.7244,
    "lat": 38.4328
  }, {
    "lng": -82.7253,
    "lat": 38.433
  }, {
    "lng": -82.7255,
    "lat": 38.433
  }, {
    "lng": -82.7255,
    "lat": 38.433
  }, {
    "lng": -82.7257,
    "lat": 38.433
  }, {
    "lng": -82.7261,
    "lat": 38.4331
  }, {
    "lng": -82.7261,
    "lat": 38.4331
  }, {
    "lng": -82.7263,
    "lat": 38.4331
  }, {
    "lng": -82.7264,
    "lat": 38.4331
  }, {
    "lng": -82.7266,
    "lat": 38.433
  }, {
    "lng": -82.7269,
    "lat": 38.4329
  }, {
    "lng": -82.7272,
    "lat": 38.4328
  }, {
    "lng": -82.7275,
    "lat": 38.4328
  }, {
    "lng": -82.7277,
    "lat": 38.4328
  }, {
    "lng": -82.728,
    "lat": 38.4329
  }, {
    "lng": -82.7283,
    "lat": 38.4329
  }, {
    "lng": -82.7284,
    "lat": 38.4329
  }, {
    "lng": -82.7286,
    "lat": 38.433
  }, {
    "lng": -82.7287,
    "lat": 38.433
  }, {
    "lng": -82.7289,
    "lat": 38.4329
  }, {
    "lng": -82.7291,
    "lat": 38.4329
  }, {
    "lng": -82.7297,
    "lat": 38.4328
  }, {
    "lng": -82.7299,
    "lat": 38.4327
  }, {
    "lng": -82.7302,
    "lat": 38.4326
  }, {
    "lng": -82.7305,
    "lat": 38.4325
  }, {
    "lng": -82.7307,
    "lat": 38.4323
  }, {
    "lng": -82.731,
    "lat": 38.4322
  }, {
    "lng": -82.7311,
    "lat": 38.432
  }, {
    "lng": -82.7313,
    "lat": 38.4319
  }, {
    "lng": -82.732,
    "lat": 38.4319
  }, {
    "lng": -82.733,
    "lat": 38.432
  }, {
    "lng": -82.7336,
    "lat": 38.4322
  }, {
    "lng": -82.7343,
    "lat": 38.4327
  }, {
    "lng": -82.7344,
    "lat": 38.4328
  }, {
    "lng": -82.7347,
    "lat": 38.433
  }, {
    "lng": -82.7352,
    "lat": 38.4334
  }, {
    "lng": -82.7357,
    "lat": 38.4337
  }, {
    "lng": -82.736,
    "lat": 38.4339
  }, {
    "lng": -82.7361,
    "lat": 38.434
  }, {
    "lng": -82.7363,
    "lat": 38.434
  }, {
    "lng": -82.7366,
    "lat": 38.4342
  }, {
    "lng": -82.7374,
    "lat": 38.4345
  }, {
    "lng": -82.738,
    "lat": 38.4347
  }, {
    "lng": -82.7389,
    "lat": 38.4349
  }, {
    "lng": -82.7391,
    "lat": 38.4347
  }, {
    "lng": -82.7393,
    "lat": 38.4344
  }, {
    "lng": -82.7396,
    "lat": 38.434
  }, {
    "lng": -82.74,
    "lat": 38.4334
  }, {
    "lng": -82.7404,
    "lat": 38.4333
  }, {
    "lng": -82.7408,
    "lat": 38.4335
  }, {
    "lng": -82.7412,
    "lat": 38.4334
  }, {
    "lng": -82.7418,
    "lat": 38.4332
  }, {
    "lng": -82.7421,
    "lat": 38.4329
  }, {
    "lng": -82.7419,
    "lat": 38.4327
  }, {
    "lng": -82.742,
    "lat": 38.4326
  }, {
    "lng": -82.742,
    "lat": 38.4326
  }, {
    "lng": -82.7426,
    "lat": 38.4322
  }, {
    "lng": -82.7431,
    "lat": 38.4317
  }, {
    "lng": -82.7432,
    "lat": 38.4317
  }, {
    "lng": -82.7435,
    "lat": 38.4315
  }, {
    "lng": -82.7438,
    "lat": 38.4313
  }, {
    "lng": -82.7445,
    "lat": 38.4309
  }, {
    "lng": -82.745,
    "lat": 38.4304
  }, {
    "lng": -82.7451,
    "lat": 38.4299
  }, {
    "lng": -82.745,
    "lat": 38.4295
  }, {
    "lng": -82.7455,
    "lat": 38.4293
  }, {
    "lng": -82.7465,
    "lat": 38.4291
  }, {
    "lng": -82.7467,
    "lat": 38.4292
  }, {
    "lng": -82.747,
    "lat": 38.4294
  }, {
    "lng": -82.7472,
    "lat": 38.43
  }, {
    "lng": -82.7474,
    "lat": 38.43
  }, {
    "lng": -82.7479,
    "lat": 38.4299
  }, {
    "lng": -82.7486,
    "lat": 38.4292
  }, {
    "lng": -82.7489,
    "lat": 38.4289
  }, {
    "lng": -82.7498,
    "lat": 38.4284
  }, {
    "lng": -82.7504,
    "lat": 38.4282
  }, {
    "lng": -82.7505,
    "lat": 38.4282
  }, {
    "lng": -82.7505,
    "lat": 38.4282
  }, {
    "lng": -82.751,
    "lat": 38.4282
  }, {
    "lng": -82.7517,
    "lat": 38.4284
  }, {
    "lng": -82.7523,
    "lat": 38.4286
  }, {
    "lng": -82.7528,
    "lat": 38.4288
  }, {
    "lng": -82.753,
    "lat": 38.4289
  }, {
    "lng": -82.7534,
    "lat": 38.4289
  }, {
    "lng": -82.7538,
    "lat": 38.4288
  }, {
    "lng": -82.7543,
    "lat": 38.429
  }, {
    "lng": -82.7547,
    "lat": 38.4293
  }, {
    "lng": -82.7553,
    "lat": 38.4297
  }, {
    "lng": -82.7557,
    "lat": 38.4303
  }, {
    "lng": -82.756,
    "lat": 38.4308
  }, {
    "lng": -82.7563,
    "lat": 38.4314
  }, {
    "lng": -82.7566,
    "lat": 38.4316
  }, {
    "lng": -82.7565,
    "lat": 38.432
  }, {
    "lng": -82.7568,
    "lat": 38.4324
  }, {
    "lng": -82.757,
    "lat": 38.4326
  }, {
    "lng": -82.7575,
    "lat": 38.4329
  }, {
    "lng": -82.7579,
    "lat": 38.4329
  }, {
    "lng": -82.7584,
    "lat": 38.4327
  }, {
    "lng": -82.7587,
    "lat": 38.4325
  }, {
    "lng": -82.7591,
    "lat": 38.4322
  }, {
    "lng": -82.7595,
    "lat": 38.4318
  }, {
    "lng": -82.7599,
    "lat": 38.4315
  }, {
    "lng": -82.7603,
    "lat": 38.4311
  }, {
    "lng": -82.7606,
    "lat": 38.4307
  }, {
    "lng": -82.7609,
    "lat": 38.4303
  }, {
    "lng": -82.7612,
    "lat": 38.43
  }, {
    "lng": -82.7615,
    "lat": 38.4297
  }, {
    "lng": -82.7617,
    "lat": 38.4296
  }, {
    "lng": -82.7619,
    "lat": 38.4292
  }, {
    "lng": -82.7621,
    "lat": 38.4289
  }, {
    "lng": -82.7624,
    "lat": 38.4288
  }, {
    "lng": -82.7629,
    "lat": 38.4285
  }, {
    "lng": -82.7636,
    "lat": 38.4283
  }, {
    "lng": -82.7641,
    "lat": 38.4282
  }, {
    "lng": -82.7648,
    "lat": 38.428
  }, {
    "lng": -82.7655,
    "lat": 38.4278
  }, {
    "lng": -82.7661,
    "lat": 38.4276
  }, {
    "lng": -82.7669,
    "lat": 38.4275
  }, {
    "lng": -82.7681,
    "lat": 38.4276
  }, {
    "lng": -82.7687,
    "lat": 38.4278
  }, {
    "lng": -82.7689,
    "lat": 38.428
  }, {
    "lng": -82.7688,
    "lat": 38.4283
  }, {
    "lng": -82.7684,
    "lat": 38.4286
  }, {
    "lng": -82.7679,
    "lat": 38.4288
  }, {
    "lng": -82.7673,
    "lat": 38.4291
  }, {
    "lng": -82.7669,
    "lat": 38.4293
  }, {
    "lng": -82.7667,
    "lat": 38.4294
  }, {
    "lng": -82.7667,
    "lat": 38.4296
  }, {
    "lng": -82.7669,
    "lat": 38.4299
  }, {
    "lng": -82.7671,
    "lat": 38.4299
  }, {
    "lng": -82.7676,
    "lat": 38.4299
  }, {
    "lng": -82.7683,
    "lat": 38.4298
  }, {
    "lng": -82.7686,
    "lat": 38.43
  }, {
    "lng": -82.7686,
    "lat": 38.4302
  }, {
    "lng": -82.7686,
    "lat": 38.4303
  }, {
    "lng": -82.7686,
    "lat": 38.4304
  }, {
    "lng": -82.7683,
    "lat": 38.4308
  }, {
    "lng": -82.768,
    "lat": 38.4312
  }, {
    "lng": -82.768,
    "lat": 38.4315
  }, {
    "lng": -82.768,
    "lat": 38.4316
  }, {
    "lng": -82.7681,
    "lat": 38.4319
  }, {
    "lng": -82.7685,
    "lat": 38.4321
  }, {
    "lng": -82.7688,
    "lat": 38.4324
  }, {
    "lng": -82.769,
    "lat": 38.4326
  }, {
    "lng": -82.7694,
    "lat": 38.4329
  }, {
    "lng": -82.7694,
    "lat": 38.4331
  }, {
    "lng": -82.7692,
    "lat": 38.4336
  }, {
    "lng": -82.7691,
    "lat": 38.4336
  }, {
    "lng": -82.7691,
    "lat": 38.4336
  }, {
    "lng": -82.769,
    "lat": 38.4337
  }, {
    "lng": -82.7691,
    "lat": 38.4338
  }, {
    "lng": -82.7691,
    "lat": 38.4339
  }, {
    "lng": -82.7692,
    "lat": 38.4341
  }, {
    "lng": -82.7693,
    "lat": 38.434
  }, {
    "lng": -82.7693,
    "lat": 38.4335
  }, {
    "lng": -82.7698,
    "lat": 38.4332
  }, {
    "lng": -82.7703,
    "lat": 38.4329
  }, {
    "lng": -82.7706,
    "lat": 38.4322
  }, {
    "lng": -82.7707,
    "lat": 38.432
  }, {
    "lng": -82.7712,
    "lat": 38.4311
  }, {
    "lng": -82.772,
    "lat": 38.4302
  }, {
    "lng": -82.7723,
    "lat": 38.43
  }, {
    "lng": -82.7726,
    "lat": 38.4292
  }, {
    "lng": -82.7729,
    "lat": 38.4289
  }, {
    "lng": -82.7737,
    "lat": 38.4288
  }, {
    "lng": -82.7741,
    "lat": 38.4287
  }, {
    "lng": -82.7744,
    "lat": 38.4286
  }, {
    "lng": -82.7747,
    "lat": 38.4281
  }, {
    "lng": -82.775,
    "lat": 38.4275
  }, {
    "lng": -82.7749,
    "lat": 38.4272
  }, {
    "lng": -82.7748,
    "lat": 38.427
  }, {
    "lng": -82.7748,
    "lat": 38.4268
  }, {
    "lng": -82.7752,
    "lat": 38.4263
  }, {
    "lng": -82.7752,
    "lat": 38.4262
  }, {
    "lng": -82.7751,
    "lat": 38.426
  }, {
    "lng": -82.7751,
    "lat": 38.426
  }, {
    "lng": -82.775,
    "lat": 38.4258
  }, {
    "lng": -82.7748,
    "lat": 38.4254
  }, {
    "lng": -82.7746,
    "lat": 38.425
  }, {
    "lng": -82.7747,
    "lat": 38.4247
  }, {
    "lng": -82.7753,
    "lat": 38.424
  }, {
    "lng": -82.7758,
    "lat": 38.4233
  }, {
    "lng": -82.7763,
    "lat": 38.4228
  }, {
    "lng": -82.7767,
    "lat": 38.4224
  }, {
    "lng": -82.7771,
    "lat": 38.4218
  }, {
    "lng": -82.777,
    "lat": 38.4214
  }, {
    "lng": -82.7765,
    "lat": 38.4208
  }, {
    "lng": -82.7762,
    "lat": 38.4205
  }, {
    "lng": -82.7757,
    "lat": 38.4202
  }, {
    "lng": -82.7755,
    "lat": 38.4202
  }, {
    "lng": -82.7747,
    "lat": 38.4201
  }, {
    "lng": -82.7745,
    "lat": 38.4201
  }, {
    "lng": -82.7742,
    "lat": 38.42
  }, {
    "lng": -82.774,
    "lat": 38.4198
  }, {
    "lng": -82.7738,
    "lat": 38.4194
  }, {
    "lng": -82.7737,
    "lat": 38.4191
  }, {
    "lng": -82.7736,
    "lat": 38.4188
  }, {
    "lng": -82.7737,
    "lat": 38.4186
  }, {
    "lng": -82.7738,
    "lat": 38.4183
  }, {
    "lng": -82.7739,
    "lat": 38.4181
  }, {
    "lng": -82.7744,
    "lat": 38.418
  }, {
    "lng": -82.775,
    "lat": 38.4179
  }, {
    "lng": -82.7755,
    "lat": 38.4178
  }, {
    "lng": -82.7758,
    "lat": 38.4177
  }, {
    "lng": -82.7761,
    "lat": 38.4175
  }, {
    "lng": -82.7763,
    "lat": 38.4173
  }, {
    "lng": -82.7765,
    "lat": 38.417
  }, {
    "lng": -82.7766,
    "lat": 38.4166
  }, {
    "lng": -82.7766,
    "lat": 38.4163
  }, {
    "lng": -82.7769,
    "lat": 38.4158
  }, {
    "lng": -82.777,
    "lat": 38.4157
  }, {
    "lng": -82.7771,
    "lat": 38.4154
  }, {
    "lng": -82.7772,
    "lat": 38.4149
  }, {
    "lng": -82.7774,
    "lat": 38.4148
  }, {
    "lng": -82.7777,
    "lat": 38.4149
  }, {
    "lng": -82.7783,
    "lat": 38.4149
  }, {
    "lng": -82.7787,
    "lat": 38.4149
  }, {
    "lng": -82.7789,
    "lat": 38.4148
  }, {
    "lng": -82.779,
    "lat": 38.4146
  }, {
    "lng": -82.7792,
    "lat": 38.4143
  }, {
    "lng": -82.7795,
    "lat": 38.414
  }, {
    "lng": -82.7796,
    "lat": 38.4139
  }, {
    "lng": -82.7801,
    "lat": 38.4139
  }, {
    "lng": -82.7804,
    "lat": 38.4141
  }, {
    "lng": -82.7805,
    "lat": 38.4143
  }, {
    "lng": -82.7807,
    "lat": 38.4145
  }, {
    "lng": -82.7809,
    "lat": 38.4147
  }, {
    "lng": -82.7811,
    "lat": 38.4148
  }, {
    "lng": -82.7814,
    "lat": 38.4148
  }, {
    "lng": -82.782,
    "lat": 38.4145
  }, {
    "lng": -82.7824,
    "lat": 38.4145
  }, {
    "lng": -82.7826,
    "lat": 38.4144
  }, {
    "lng": -82.7827,
    "lat": 38.4141
  }, {
    "lng": -82.7827,
    "lat": 38.4135
  }, {
    "lng": -82.7828,
    "lat": 38.4134
  }, {
    "lng": -82.7829,
    "lat": 38.4132
  }, {
    "lng": -82.7832,
    "lat": 38.413
  }, {
    "lng": -82.7838,
    "lat": 38.4128
  }, {
    "lng": -82.7842,
    "lat": 38.4126
  }, {
    "lng": -82.7849,
    "lat": 38.4122
  }, {
    "lng": -82.7852,
    "lat": 38.4121
  }, {
    "lng": -82.7856,
    "lat": 38.4122
  }, {
    "lng": -82.7859,
    "lat": 38.4123
  }, {
    "lng": -82.7864,
    "lat": 38.4122
  }, {
    "lng": -82.7867,
    "lat": 38.4123
  }, {
    "lng": -82.787,
    "lat": 38.4124
  }, {
    "lng": -82.7876,
    "lat": 38.4128
  }, {
    "lng": -82.7878,
    "lat": 38.4129
  }, {
    "lng": -82.788,
    "lat": 38.413
  }, {
    "lng": -82.7883,
    "lat": 38.4129
  }, {
    "lng": -82.7885,
    "lat": 38.4127
  }, {
    "lng": -82.7889,
    "lat": 38.412
  }, {
    "lng": -82.7893,
    "lat": 38.411
  }, {
    "lng": -82.7892,
    "lat": 38.4109
  }, {
    "lng": -82.7889,
    "lat": 38.4107
  }, {
    "lng": -82.7887,
    "lat": 38.4106
  }, {
    "lng": -82.7885,
    "lat": 38.4104
  }, {
    "lng": -82.7885,
    "lat": 38.4102
  }, {
    "lng": -82.7887,
    "lat": 38.4099
  }, {
    "lng": -82.7888,
    "lat": 38.4097
  }, {
    "lng": -82.7889,
    "lat": 38.4095
  }, {
    "lng": -82.7888,
    "lat": 38.4091
  }, {
    "lng": -82.7889,
    "lat": 38.4087
  }, {
    "lng": -82.7892,
    "lat": 38.4079
  }, {
    "lng": -82.7896,
    "lat": 38.4074
  }, {
    "lng": -82.7901,
    "lat": 38.4071
  }, {
    "lng": -82.7901,
    "lat": 38.4069
  }, {
    "lng": -82.7899,
    "lat": 38.4065
  }, {
    "lng": -82.7892,
    "lat": 38.4057
  }, {
    "lng": -82.7887,
    "lat": 38.4051
  }, {
    "lng": -82.7888,
    "lat": 38.4047
  }, {
    "lng": -82.789,
    "lat": 38.4046
  }, {
    "lng": -82.7892,
    "lat": 38.4045
  }, {
    "lng": -82.7901,
    "lat": 38.4044
  }, {
    "lng": -82.7903,
    "lat": 38.4044
  }, {
    "lng": -82.7905,
    "lat": 38.4042
  }, {
    "lng": -82.7908,
    "lat": 38.4038
  }, {
    "lng": -82.7911,
    "lat": 38.4034
  }, {
    "lng": -82.7913,
    "lat": 38.4029
  }, {
    "lng": -82.7914,
    "lat": 38.4026
  }, {
    "lng": -82.7916,
    "lat": 38.4024
  }, {
    "lng": -82.7918,
    "lat": 38.4024
  }, {
    "lng": -82.7921,
    "lat": 38.4025
  }, {
    "lng": -82.7927,
    "lat": 38.4025
  }, {
    "lng": -82.7929,
    "lat": 38.4025
  }, {
    "lng": -82.7931,
    "lat": 38.4024
  }, {
    "lng": -82.7933,
    "lat": 38.402
  }, {
    "lng": -82.7934,
    "lat": 38.4015
  }, {
    "lng": -82.7935,
    "lat": 38.4009
  }, {
    "lng": -82.7938,
    "lat": 38.4008
  }, {
    "lng": -82.794,
    "lat": 38.4008
  }, {
    "lng": -82.7943,
    "lat": 38.4008
  }, {
    "lng": -82.7948,
    "lat": 38.4011
  }, {
    "lng": -82.795,
    "lat": 38.4011
  }, {
    "lng": -82.7953,
    "lat": 38.401
  }, {
    "lng": -82.7956,
    "lat": 38.4009
  }, {
    "lng": -82.7958,
    "lat": 38.4007
  }, {
    "lng": -82.7965,
    "lat": 38.4006
  }, {
    "lng": -82.7968,
    "lat": 38.4005
  }, {
    "lng": -82.797,
    "lat": 38.4003
  }, {
    "lng": -82.7972,
    "lat": 38.4002
  }, {
    "lng": -82.7975,
    "lat": 38.4002
  }, {
    "lng": -82.798,
    "lat": 38.4002
  }, {
    "lng": -82.7982,
    "lat": 38.4002
  }, {
    "lng": -82.7984,
    "lat": 38.4
  }, {
    "lng": -82.7985,
    "lat": 38.3998
  }, {
    "lng": -82.7985,
    "lat": 38.3991
  }, {
    "lng": -82.7986,
    "lat": 38.3988
  }, {
    "lng": -82.7988,
    "lat": 38.3986
  }, {
    "lng": -82.7991,
    "lat": 38.3982
  }, {
    "lng": -82.7995,
    "lat": 38.398
  }, {
    "lng": -82.7999,
    "lat": 38.3979
  }, {
    "lng": -82.8004,
    "lat": 38.3979
  }, {
    "lng": -82.801,
    "lat": 38.3979
  }, {
    "lng": -82.8013,
    "lat": 38.3978
  }, {
    "lng": -82.8016,
    "lat": 38.3978
  }, {
    "lng": -82.802,
    "lat": 38.3979
  }, {
    "lng": -82.8026,
    "lat": 38.3979
  }, {
    "lng": -82.8028,
    "lat": 38.398
  }, {
    "lng": -82.8032,
    "lat": 38.3979
  }, {
    "lng": -82.8037,
    "lat": 38.3977
  }, {
    "lng": -82.804,
    "lat": 38.3976
  }, {
    "lng": -82.8044,
    "lat": 38.3973
  }, {
    "lng": -82.8046,
    "lat": 38.397
  }, {
    "lng": -82.8048,
    "lat": 38.3967
  }, {
    "lng": -82.8052,
    "lat": 38.3961
  }, {
    "lng": -82.8055,
    "lat": 38.3959
  }, {
    "lng": -82.8058,
    "lat": 38.3958
  }, {
    "lng": -82.8065,
    "lat": 38.3957
  }, {
    "lng": -82.807,
    "lat": 38.3957
  }, {
    "lng": -82.8075,
    "lat": 38.3956
  }, {
    "lng": -82.808,
    "lat": 38.3954
  }, {
    "lng": -82.8085,
    "lat": 38.3952
  }, {
    "lng": -82.8094,
    "lat": 38.3946
  }, {
    "lng": -82.8097,
    "lat": 38.3944
  }, {
    "lng": -82.8106,
    "lat": 38.3932
  }, {
    "lng": -82.8106,
    "lat": 38.393
  }, {
    "lng": -82.8107,
    "lat": 38.3928
  }, {
    "lng": -82.8104,
    "lat": 38.3925
  }, {
    "lng": -82.8101,
    "lat": 38.3923
  }, {
    "lng": -82.81,
    "lat": 38.392
  }, {
    "lng": -82.81,
    "lat": 38.3916
  }, {
    "lng": -82.81,
    "lat": 38.3913
  }, {
    "lng": -82.8101,
    "lat": 38.391
  }, {
    "lng": -82.8104,
    "lat": 38.3906
  }, {
    "lng": -82.811,
    "lat": 38.3897
  }, {
    "lng": -82.8112,
    "lat": 38.3891
  }, {
    "lng": -82.8112,
    "lat": 38.3889
  }, {
    "lng": -82.8112,
    "lat": 38.3887
  }, {
    "lng": -82.8112,
    "lat": 38.3886
  }, {
    "lng": -82.8112,
    "lat": 38.3884
  }, {
    "lng": -82.8111,
    "lat": 38.3883
  }, {
    "lng": -82.811,
    "lat": 38.3881
  }, {
    "lng": -82.8103,
    "lat": 38.3876
  }, {
    "lng": -82.8096,
    "lat": 38.3872
  }, {
    "lng": -82.809,
    "lat": 38.3872
  }, {
    "lng": -82.8088,
    "lat": 38.3871
  }, {
    "lng": -82.8089,
    "lat": 38.387
  }, {
    "lng": -82.8098,
    "lat": 38.3863
  }, {
    "lng": -82.8101,
    "lat": 38.3859
  }, {
    "lng": -82.8105,
    "lat": 38.3854
  }, {
    "lng": -82.8108,
    "lat": 38.3848
  }, {
    "lng": -82.8112,
    "lat": 38.3841
  }, {
    "lng": -82.8116,
    "lat": 38.3838
  }, {
    "lng": -82.8119,
    "lat": 38.3835
  }, {
    "lng": -82.812,
    "lat": 38.3833
  }, {
    "lng": -82.812,
    "lat": 38.3829
  }, {
    "lng": -82.8121,
    "lat": 38.3826
  }, {
    "lng": -82.8123,
    "lat": 38.3824
  }, {
    "lng": -82.8126,
    "lat": 38.3823
  }, {
    "lng": -82.8131,
    "lat": 38.382
  }, {
    "lng": -82.8135,
    "lat": 38.3819
  }, {
    "lng": -82.8137,
    "lat": 38.3818
  }, {
    "lng": -82.8138,
    "lat": 38.3816
  }, {
    "lng": -82.8138,
    "lat": 38.3812
  }, {
    "lng": -82.8139,
    "lat": 38.3807
  }, {
    "lng": -82.814,
    "lat": 38.3805
  }, {
    "lng": -82.8142,
    "lat": 38.3803
  }, {
    "lng": -82.8144,
    "lat": 38.3802
  }, {
    "lng": -82.8148,
    "lat": 38.3802
  }, {
    "lng": -82.8149,
    "lat": 38.3801
  }, {
    "lng": -82.8152,
    "lat": 38.3798
  }, {
    "lng": -82.8156,
    "lat": 38.3792
  }, {
    "lng": -82.8157,
    "lat": 38.3789
  }, {
    "lng": -82.8159,
    "lat": 38.3785
  }, {
    "lng": -82.816,
    "lat": 38.3782
  }, {
    "lng": -82.8159,
    "lat": 38.3776
  }, {
    "lng": -82.8159,
    "lat": 38.3774
  }, {
    "lng": -82.8161,
    "lat": 38.3772
  }, {
    "lng": -82.8164,
    "lat": 38.3771
  }, {
    "lng": -82.817,
    "lat": 38.3769
  }, {
    "lng": -82.8174,
    "lat": 38.3768
  }, {
    "lng": -82.8177,
    "lat": 38.3767
  }, {
    "lng": -82.8177,
    "lat": 38.3766
  }, {
    "lng": -82.8177,
    "lat": 38.3764
  }, {
    "lng": -82.8177,
    "lat": 38.3762
  }, {
    "lng": -82.8176,
    "lat": 38.376
  }, {
    "lng": -82.8175,
    "lat": 38.3758
  }, {
    "lng": -82.8173,
    "lat": 38.3756
  }, {
    "lng": -82.8172,
    "lat": 38.3755
  }, {
    "lng": -82.8171,
    "lat": 38.3754
  }, {
    "lng": -82.8171,
    "lat": 38.3753
  }, {
    "lng": -82.8171,
    "lat": 38.3752
  }, {
    "lng": -82.8172,
    "lat": 38.3751
  }, {
    "lng": -82.8172,
    "lat": 38.3749
  }, {
    "lng": -82.8173,
    "lat": 38.3747
  }, {
    "lng": -82.8174,
    "lat": 38.3745
  }, {
    "lng": -82.8174,
    "lat": 38.3742
  }, {
    "lng": -82.8175,
    "lat": 38.374
  }, {
    "lng": -82.8175,
    "lat": 38.3739
  }, {
    "lng": -82.8036,
    "lat": 38.3701
  }, {
    "lng": -82.8027,
    "lat": 38.3699
  }, {
    "lng": -82.7967,
    "lat": 38.3683
  }, {
    "lng": -82.7905,
    "lat": 38.3698
  }, {
    "lng": -82.7844,
    "lat": 38.3714
  }, {
    "lng": -82.7783,
    "lat": 38.3731
  }, {
    "lng": -82.7722,
    "lat": 38.3747
  }, {
    "lng": -82.766,
    "lat": 38.3763
  }, {
    "lng": -82.7619,
    "lat": 38.3745
  }, {
    "lng": -82.7619,
    "lat": 38.373
  }, {
    "lng": -82.7621,
    "lat": 38.3727
  }, {
    "lng": -82.7621,
    "lat": 38.3726
  }, {
    "lng": -82.762,
    "lat": 38.3725
  }, {
    "lng": -82.7619,
    "lat": 38.3724
  }, {
    "lng": -82.7617,
    "lat": 38.3721
  }, {
    "lng": -82.7616,
    "lat": 38.372
  }, {
    "lng": -82.7614,
    "lat": 38.3718
  }, {
    "lng": -82.7607,
    "lat": 38.3722
  }, {
    "lng": -82.7604,
    "lat": 38.3724
  }, {
    "lng": -82.7602,
    "lat": 38.3725
  }, {
    "lng": -82.7601,
    "lat": 38.3726
  }, {
    "lng": -82.7598,
    "lat": 38.3727
  }, {
    "lng": -82.7595,
    "lat": 38.373
  }, {
    "lng": -82.7591,
    "lat": 38.3733
  }, {
    "lng": -82.7589,
    "lat": 38.3735
  }, {
    "lng": -82.7586,
    "lat": 38.3737
  }, {
    "lng": -82.7585,
    "lat": 38.3739
  }, {
    "lng": -82.7582,
    "lat": 38.3742
  }, {
    "lng": -82.7581,
    "lat": 38.3743
  }, {
    "lng": -82.7581,
    "lat": 38.3744
  }, {
    "lng": -82.7582,
    "lat": 38.3744
  }, {
    "lng": -82.7582,
    "lat": 38.3745
  }, {
    "lng": -82.7582,
    "lat": 38.3746
  }, {
    "lng": -82.7582,
    "lat": 38.3747
  }, {
    "lng": -82.7582,
    "lat": 38.3748
  }, {
    "lng": -82.7582,
    "lat": 38.3749
  }, {
    "lng": -82.7581,
    "lat": 38.3773
  }, {
    "lng": -82.758,
    "lat": 38.378
  }, {
    "lng": -82.7578,
    "lat": 38.3783
  }, {
    "lng": -82.7575,
    "lat": 38.3788
  }, {
    "lng": -82.7566,
    "lat": 38.3796
  }, {
    "lng": -82.7561,
    "lat": 38.3799
  }, {
    "lng": -82.7553,
    "lat": 38.38
  }, {
    "lng": -82.7533,
    "lat": 38.3801
  }, {
    "lng": -82.753,
    "lat": 38.3801
  }, {
    "lng": -82.7528,
    "lat": 38.3801
  }, {
    "lng": -82.7526,
    "lat": 38.3802
  }, {
    "lng": -82.7525,
    "lat": 38.3802
  }, {
    "lng": -82.7525,
    "lat": 38.3802
  }, {
    "lng": -82.7524,
    "lat": 38.3802
  }, {
    "lng": -82.7523,
    "lat": 38.3802
  }, {
    "lng": -82.7523,
    "lat": 38.3803
  }, {
    "lng": -82.7522,
    "lat": 38.3803
  }, {
    "lng": -82.7518,
    "lat": 38.3805
  }, {
    "lng": -82.7513,
    "lat": 38.3807
  }, {
    "lng": -82.751,
    "lat": 38.3808
  }, {
    "lng": -82.7508,
    "lat": 38.3809
  }, {
    "lng": -82.7507,
    "lat": 38.3809
  }, {
    "lng": -82.7506,
    "lat": 38.3809
  }, {
    "lng": -82.7506,
    "lat": 38.3809
  }, {
    "lng": -82.7503,
    "lat": 38.3809
  }, {
    "lng": -82.7499,
    "lat": 38.3812
  }, {
    "lng": -82.7496,
    "lat": 38.3815
  }, {
    "lng": -82.7493,
    "lat": 38.3818
  }, {
    "lng": -82.7488,
    "lat": 38.3823
  }, {
    "lng": -82.7485,
    "lat": 38.3826
  }, {
    "lng": -82.7482,
    "lat": 38.3831
  }, {
    "lng": -82.748,
    "lat": 38.3833
  }, {
    "lng": -82.7475,
    "lat": 38.384
  }, {
    "lng": -82.7472,
    "lat": 38.3843
  }, {
    "lng": -82.7471,
    "lat": 38.3846
  }, {
    "lng": -82.7464,
    "lat": 38.3856
  }, {
    "lng": -82.745,
    "lat": 38.3875
  }, {
    "lng": -82.7448,
    "lat": 38.3878
  }, {
    "lng": -82.7442,
    "lat": 38.3885
  }, {
    "lng": -82.744,
    "lat": 38.3886
  }, {
    "lng": -82.7439,
    "lat": 38.3887
  }, {
    "lng": -82.7437,
    "lat": 38.3889
  }, {
    "lng": -82.7435,
    "lat": 38.389
  }, {
    "lng": -82.743,
    "lat": 38.3893
  }, {
    "lng": -82.7427,
    "lat": 38.3894
  }, {
    "lng": -82.7425,
    "lat": 38.3894
  }, {
    "lng": -82.7422,
    "lat": 38.3895
  }, {
    "lng": -82.742,
    "lat": 38.3896
  }, {
    "lng": -82.7418,
    "lat": 38.3896
  }, {
    "lng": -82.7413,
    "lat": 38.3897
  }, {
    "lng": -82.741,
    "lat": 38.3897
  }, {
    "lng": -82.7406,
    "lat": 38.3897
  }, {
    "lng": -82.7404,
    "lat": 38.3896
  }, {
    "lng": -82.74,
    "lat": 38.3896
  }, {
    "lng": -82.7396,
    "lat": 38.3895
  }, {
    "lng": -82.7393,
    "lat": 38.3894
  }, {
    "lng": -82.7388,
    "lat": 38.3891
  }, {
    "lng": -82.7384,
    "lat": 38.3889
  }, {
    "lng": -82.738,
    "lat": 38.3886
  }, {
    "lng": -82.7375,
    "lat": 38.3882
  }, {
    "lng": -82.7373,
    "lat": 38.388
  }, {
    "lng": -82.7372,
    "lat": 38.3879
  }, {
    "lng": -82.737,
    "lat": 38.3879
  }, {
    "lng": -82.7368,
    "lat": 38.3878
  }, {
    "lng": -82.7365,
    "lat": 38.3877
  }, {
    "lng": -82.7363,
    "lat": 38.3876
  }, {
    "lng": -82.7361,
    "lat": 38.3875
  }, {
    "lng": -82.7359,
    "lat": 38.3875
  }, {
    "lng": -82.7357,
    "lat": 38.3874
  }, {
    "lng": -82.7355,
    "lat": 38.3874
  }, {
    "lng": -82.7353,
    "lat": 38.3873
  }, {
    "lng": -82.735,
    "lat": 38.3873
  }, {
    "lng": -82.7347,
    "lat": 38.3873
  }, {
    "lng": -82.7344,
    "lat": 38.3873
  }, {
    "lng": -82.7321,
    "lat": 38.3875
  }, {
    "lng": -82.7316,
    "lat": 38.3875
  }, {
    "lng": -82.731,
    "lat": 38.3875
  }, {
    "lng": -82.7307,
    "lat": 38.3875
  }, {
    "lng": -82.7301,
    "lat": 38.3875
  }, {
    "lng": -82.7294,
    "lat": 38.3875
  }, {
    "lng": -82.7289,
    "lat": 38.3875
  }, {
    "lng": -82.7285,
    "lat": 38.3875
  }, {
    "lng": -82.7279,
    "lat": 38.3875
  }, {
    "lng": -82.7248,
    "lat": 38.3873
  }, {
    "lng": -82.7229,
    "lat": 38.3872
  }, {
    "lng": -82.7227,
    "lat": 38.3872
  }, {
    "lng": -82.7208,
    "lat": 38.3871
  }, {
    "lng": -82.7209,
    "lat": 38.3872
  }, {
    "lng": -82.721,
    "lat": 38.3873
  }, {
    "lng": -82.7211,
    "lat": 38.3875
  }, {
    "lng": -82.7211,
    "lat": 38.3877
  }, {
    "lng": -82.7212,
    "lat": 38.3878
  }, {
    "lng": -82.7209,
    "lat": 38.3879
  }, {
    "lng": -82.7206,
    "lat": 38.3876
  }, {
    "lng": -82.7206,
    "lat": 38.3873
  }, {
    "lng": -82.7205,
    "lat": 38.3871
  }, {
    "lng": -82.7202,
    "lat": 38.3868
  }, {
    "lng": -82.7201,
    "lat": 38.3868
  }, {
    "lng": -82.7197,
    "lat": 38.3865
  }, {
    "lng": -82.7198,
    "lat": 38.3862
  }, {
    "lng": -82.7204,
    "lat": 38.3858
  }, {
    "lng": -82.7209,
    "lat": 38.3856
  }, {
    "lng": -82.7215,
    "lat": 38.3857
  }, {
    "lng": -82.722,
    "lat": 38.3855
  }, {
    "lng": -82.7218,
    "lat": 38.3849
  }, {
    "lng": -82.7213,
    "lat": 38.3846
  }, {
    "lng": -82.7202,
    "lat": 38.3842
  }, {
    "lng": -82.7191,
    "lat": 38.3841
  }, {
    "lng": -82.7185,
    "lat": 38.3845
  }, {
    "lng": -82.7182,
    "lat": 38.385
  }, {
    "lng": -82.7178,
    "lat": 38.3849
  }, {
    "lng": -82.7172,
    "lat": 38.3842
  }, {
    "lng": -82.7168,
    "lat": 38.3838
  }, {
    "lng": -82.7164,
    "lat": 38.3833
  }, {
    "lng": -82.7169,
    "lat": 38.3829
  }, {
    "lng": -82.7177,
    "lat": 38.3824
  }, {
    "lng": -82.7179,
    "lat": 38.3818
  }, {
    "lng": -82.7182,
    "lat": 38.3813
  }, {
    "lng": -82.7176,
    "lat": 38.3809
  }, {
    "lng": -82.7174,
    "lat": 38.3802
  }, {
    "lng": -82.718,
    "lat": 38.3797
  }, {
    "lng": -82.7184,
    "lat": 38.3793
  }, {
    "lng": -82.7182,
    "lat": 38.3791
  }, {
    "lng": -82.7174,
    "lat": 38.3791
  }, {
    "lng": -82.7173,
    "lat": 38.3791
  }, {
    "lng": -82.7166,
    "lat": 38.3787
  }, {
    "lng": -82.7162,
    "lat": 38.3782
  }, {
    "lng": -82.7161,
    "lat": 38.3781
  }, {
    "lng": -82.7155,
    "lat": 38.3777
  }, {
    "lng": -82.7153,
    "lat": 38.3775
  }, {
    "lng": -82.7145,
    "lat": 38.3766
  }, {
    "lng": -82.714,
    "lat": 38.3765
  }, {
    "lng": -82.7133,
    "lat": 38.377
  }, {
    "lng": -82.713,
    "lat": 38.3771
  }, {
    "lng": -82.7122,
    "lat": 38.3765
  }, {
    "lng": -82.7116,
    "lat": 38.376
  }, {
    "lng": -82.7111,
    "lat": 38.3754
  }, {
    "lng": -82.711,
    "lat": 38.375
  }, {
    "lng": -82.7108,
    "lat": 38.3749
  }, {
    "lng": -82.7104,
    "lat": 38.3744
  }, {
    "lng": -82.7104,
    "lat": 38.3742
  }, {
    "lng": -82.7102,
    "lat": 38.374
  }, {
    "lng": -82.7099,
    "lat": 38.3744
  }, {
    "lng": -82.7095,
    "lat": 38.3748
  }, {
    "lng": -82.7097,
    "lat": 38.3749
  }, {
    "lng": -82.71,
    "lat": 38.3751
  }, {
    "lng": -82.7103,
    "lat": 38.3753
  }, {
    "lng": -82.7106,
    "lat": 38.3756
  }, {
    "lng": -82.7111,
    "lat": 38.376
  }, {
    "lng": -82.7116,
    "lat": 38.3765
  }, {
    "lng": -82.7118,
    "lat": 38.3767
  }, {
    "lng": -82.7123,
    "lat": 38.3772
  }, {
    "lng": -82.7136,
    "lat": 38.3784
  }, {
    "lng": -82.7142,
    "lat": 38.3791
  }, {
    "lng": -82.7146,
    "lat": 38.3796
  }, {
    "lng": -82.7149,
    "lat": 38.3801
  }, {
    "lng": -82.7152,
    "lat": 38.3808
  }, {
    "lng": -82.7155,
    "lat": 38.3817
  }, {
    "lng": -82.7156,
    "lat": 38.3822
  }, {
    "lng": -82.7157,
    "lat": 38.3825
  }, {
    "lng": -82.7158,
    "lat": 38.3831
  }, {
    "lng": -82.7158,
    "lat": 38.3835
  }, {
    "lng": -82.716,
    "lat": 38.3847
  }, {
    "lng": -82.716,
    "lat": 38.3848
  }, {
    "lng": -82.7161,
    "lat": 38.3855
  }, {
    "lng": -82.7162,
    "lat": 38.3859
  }, {
    "lng": -82.7162,
    "lat": 38.386
  }, {
    "lng": -82.7162,
    "lat": 38.386
  }, {
    "lng": -82.7163,
    "lat": 38.3868
  }, {
    "lng": -82.7162,
    "lat": 38.387
  }, {
    "lng": -82.7167,
    "lat": 38.387
  }, {
    "lng": -82.7177,
    "lat": 38.387
  }, {
    "lng": -82.7182,
    "lat": 38.387
  }, {
    "lng": -82.7181,
    "lat": 38.3871
  }, {
    "lng": -82.718,
    "lat": 38.3873
  }, {
    "lng": -82.718,
    "lat": 38.3873
  }, {
    "lng": -82.7179,
    "lat": 38.3874
  }, {
    "lng": -82.7178,
    "lat": 38.3874
  }, {
    "lng": -82.7178,
    "lat": 38.3875
  }, {
    "lng": -82.7177,
    "lat": 38.3875
  }, {
    "lng": -82.7176,
    "lat": 38.3875
  }, {
    "lng": -82.7175,
    "lat": 38.3876
  }, {
    "lng": -82.7174,
    "lat": 38.3876
  }, {
    "lng": -82.7174,
    "lat": 38.3876
  }, {
    "lng": -82.7174,
    "lat": 38.3877
  }, {
    "lng": -82.7173,
    "lat": 38.3877
  }, {
    "lng": -82.7173,
    "lat": 38.3878
  }, {
    "lng": -82.7172,
    "lat": 38.3878
  }, {
    "lng": -82.7168,
    "lat": 38.3881
  }, {
    "lng": -82.7162,
    "lat": 38.3885
  }, {
    "lng": -82.7159,
    "lat": 38.3887
  }, {
    "lng": -82.7158,
    "lat": 38.3887
  }, {
    "lng": -82.7158,
    "lat": 38.3887
  }, {
    "lng": -82.7158,
    "lat": 38.3887
  }, {
    "lng": -82.7157,
    "lat": 38.3887
  }, {
    "lng": -82.7156,
    "lat": 38.3887
  }, {
    "lng": -82.7154,
    "lat": 38.3889
  }, {
    "lng": -82.7154,
    "lat": 38.3889
  }, {
    "lng": -82.7151,
    "lat": 38.3892
  }, {
    "lng": -82.7151,
    "lat": 38.3892
  }, {
    "lng": -82.7146,
    "lat": 38.3896
  }, {
    "lng": -82.7146,
    "lat": 38.3896
  }, {
    "lng": -82.714,
    "lat": 38.39
  }, {
    "lng": -82.714,
    "lat": 38.39
  }, {
    "lng": -82.7124,
    "lat": 38.3911
  }, {
    "lng": -82.7124,
    "lat": 38.3913
  }, {
    "lng": -82.7124,
    "lat": 38.3916
  }, {
    "lng": -82.7123,
    "lat": 38.392
  }, {
    "lng": -82.7121,
    "lat": 38.3925
  }, {
    "lng": -82.7117,
    "lat": 38.3929
  }, {
    "lng": -82.7115,
    "lat": 38.3932
  }, {
    "lng": -82.7111,
    "lat": 38.3935
  }, {
    "lng": -82.7109,
    "lat": 38.3937
  }, {
    "lng": -82.7107,
    "lat": 38.3941
  }, {
    "lng": -82.7108,
    "lat": 38.3944
  }, {
    "lng": -82.7114,
    "lat": 38.3956
  }, {
    "lng": -82.7116,
    "lat": 38.3962
  }, {
    "lng": -82.7119,
    "lat": 38.3969
  }, {
    "lng": -82.7122,
    "lat": 38.3977
  }, {
    "lng": -82.7122,
    "lat": 38.3978
  }, {
    "lng": -82.7128,
    "lat": 38.3983
  }, {
    "lng": -82.7133,
    "lat": 38.3985
  }, {
    "lng": -82.7136,
    "lat": 38.3983
  }, {
    "lng": -82.7137,
    "lat": 38.3982
  }, {
    "lng": -82.7143,
    "lat": 38.3986
  }, {
    "lng": -82.7146,
    "lat": 38.3991
  }, {
    "lng": -82.7149,
    "lat": 38.3995
  }, {
    "lng": -82.7154,
    "lat": 38.3998
  }, {
    "lng": -82.716,
    "lat": 38.4001
  }, {
    "lng": -82.7163,
    "lat": 38.4001
  }, {
    "lng": -82.7164,
    "lat": 38.4001
  }, {
    "lng": -82.7166,
    "lat": 38.4001
  }, {
    "lng": -82.7167,
    "lat": 38.4003
  }, {
    "lng": -82.7167,
    "lat": 38.4007
  }, {
    "lng": -82.7165,
    "lat": 38.401
  }, {
    "lng": -82.7164,
    "lat": 38.4014
  }, {
    "lng": -82.7162,
    "lat": 38.4018
  }, {
    "lng": -82.7162,
    "lat": 38.402
  }, {
    "lng": -82.7164,
    "lat": 38.4022
  }, {
    "lng": -82.7167,
    "lat": 38.4021
  }, {
    "lng": -82.7172,
    "lat": 38.4022
  }, {
    "lng": -82.7174,
    "lat": 38.4024
  }, {
    "lng": -82.7172,
    "lat": 38.4028
  }, {
    "lng": -82.7169,
    "lat": 38.403
  }, {
    "lng": -82.7166,
    "lat": 38.4036
  }, {
    "lng": -82.7165,
    "lat": 38.404
  }, {
    "lng": -82.7164,
    "lat": 38.4043
  }, {
    "lng": -82.7164,
    "lat": 38.4046
  }, {
    "lng": -82.7166,
    "lat": 38.4048
  }, {
    "lng": -82.7167,
    "lat": 38.4049
  }, {
    "lng": -82.7168,
    "lat": 38.405
  }, {
    "lng": -82.7169,
    "lat": 38.4051
  }, {
    "lng": -82.7176,
    "lat": 38.4053
  }, {
    "lng": -82.7182,
    "lat": 38.4056
  }, {
    "lng": -82.7188,
    "lat": 38.4058
  }, {
    "lng": -82.7193,
    "lat": 38.406
  }, {
    "lng": -82.7197,
    "lat": 38.406
  }, {
    "lng": -82.7195,
    "lat": 38.406
  }, {
    "lng": -82.7194,
    "lat": 38.4059
  }, {
    "lng": -82.7202,
    "lat": 38.405
  }, {
    "lng": -82.7204,
    "lat": 38.4048
  }, {
    "lng": -82.7209,
    "lat": 38.4044
  }, {
    "lng": -82.7213,
    "lat": 38.4042
  }, {
    "lng": -82.7218,
    "lat": 38.404
  }, {
    "lng": -82.722,
    "lat": 38.4039
  }, {
    "lng": -82.7224,
    "lat": 38.4038
  }, {
    "lng": -82.7228,
    "lat": 38.4037
  }, {
    "lng": -82.7231,
    "lat": 38.4037
  }, {
    "lng": -82.7235,
    "lat": 38.4036
  }, {
    "lng": -82.7236,
    "lat": 38.4037
  }, {
    "lng": -82.7237,
    "lat": 38.4037
  }, {
    "lng": -82.7241,
    "lat": 38.4036
  }, {
    "lng": -82.7245,
    "lat": 38.4036
  }, {
    "lng": -82.7249,
    "lat": 38.4035
  }, {
    "lng": -82.7257,
    "lat": 38.4034
  }, {
    "lng": -82.7264,
    "lat": 38.4033
  }, {
    "lng": -82.7272,
    "lat": 38.4031
  }, {
    "lng": -82.7275,
    "lat": 38.4031
  }, {
    "lng": -82.7279,
    "lat": 38.403
  }, {
    "lng": -82.7282,
    "lat": 38.403
  }, {
    "lng": -82.7285,
    "lat": 38.403
  }, {
    "lng": -82.7287,
    "lat": 38.4031
  }, {
    "lng": -82.7289,
    "lat": 38.4031
  }, {
    "lng": -82.729,
    "lat": 38.4031
  }, {
    "lng": -82.7291,
    "lat": 38.4032
  }, {
    "lng": -82.7288,
    "lat": 38.4034
  }, {
    "lng": -82.7289,
    "lat": 38.4035
  }, {
    "lng": -82.7291,
    "lat": 38.4036
  }, {
    "lng": -82.7291,
    "lat": 38.4037
  }, {
    "lng": -82.7291,
    "lat": 38.4039
  }, {
    "lng": -82.7291,
    "lat": 38.4045
  }, {
    "lng": -82.729,
    "lat": 38.4053
  }, {
    "lng": -82.729,
    "lat": 38.4057
  }, {
    "lng": -82.7291,
    "lat": 38.4063
  }, {
    "lng": -82.7293,
    "lat": 38.4069
  }, {
    "lng": -82.7295,
    "lat": 38.4077
  }, {
    "lng": -82.73,
    "lat": 38.4081
  }, {
    "lng": -82.7301,
    "lat": 38.4087
  }, {
    "lng": -82.7299,
    "lat": 38.4092
  }, {
    "lng": -82.7301,
    "lat": 38.4099
  }, {
    "lng": -82.7301,
    "lat": 38.41
  }, {
    "lng": -82.7306,
    "lat": 38.4101
  }, {
    "lng": -82.7308,
    "lat": 38.4103
  }, {
    "lng": -82.7309,
    "lat": 38.4106
  }, {
    "lng": -82.7312,
    "lat": 38.4109
  }, {
    "lng": -82.7312,
    "lat": 38.411
  }, {
    "lng": -82.7312,
    "lat": 38.4111
  }, {
    "lng": -82.7306,
    "lat": 38.4115
  }, {
    "lng": -82.7311,
    "lat": 38.4118
  }, {
    "lng": -82.7314,
    "lat": 38.4121
  }, {
    "lng": -82.7318,
    "lat": 38.4125
  }, {
    "lng": -82.732,
    "lat": 38.4132
  }, {
    "lng": -82.7321,
    "lat": 38.4143
  }, {
    "lng": -82.7319,
    "lat": 38.4152
  }, {
    "lng": -82.7318,
    "lat": 38.4156
  }, {
    "lng": -82.7315,
    "lat": 38.4159
  }, {
    "lng": -82.7309,
    "lat": 38.4161
  }, {
    "lng": -82.7303,
    "lat": 38.4163
  }, {
    "lng": -82.7294,
    "lat": 38.4165
  }, {
    "lng": -82.7291,
    "lat": 38.4165
  }, {
    "lng": -82.7289,
    "lat": 38.4165
  }, {
    "lng": -82.7279,
    "lat": 38.4164
  }, {
    "lng": -82.7275,
    "lat": 38.4164
  }, {
    "lng": -82.7264,
    "lat": 38.4167
  }, {
    "lng": -82.7259,
    "lat": 38.4169
  }, {
    "lng": -82.7255,
    "lat": 38.4172
  }, {
    "lng": -82.7253,
    "lat": 38.4174
  }, {
    "lng": -82.725,
    "lat": 38.4179
  }, {
    "lng": -82.7242,
    "lat": 38.4197
  }, {
    "lng": -82.7241,
    "lat": 38.4201
  }, {
    "lng": -82.7241,
    "lat": 38.4208
  }, {
    "lng": -82.7244,
    "lat": 38.4219
  }, {
    "lng": -82.7245,
    "lat": 38.4221
  }, {
    "lng": -82.7245,
    "lat": 38.4222
  }, {
    "lng": -82.7247,
    "lat": 38.4225
  }, {
    "lng": -82.7248,
    "lat": 38.4228
  }, {
    "lng": -82.7249,
    "lat": 38.4229
  }, {
    "lng": -82.7249,
    "lat": 38.4231
  }, {
    "lng": -82.7249,
    "lat": 38.4233
  }, {
    "lng": -82.7248,
    "lat": 38.4236
  }, {
    "lng": -82.7248,
    "lat": 38.424
  }, {
    "lng": -82.7248,
    "lat": 38.4246
  }, {
    "lng": -82.7248,
    "lat": 38.4247
  }, {
    "lng": -82.7247,
    "lat": 38.4248
  }, {
    "lng": -82.7246,
    "lat": 38.425
  }, {
    "lng": -82.7245,
    "lat": 38.4251
  }, {
    "lng": -82.7244,
    "lat": 38.4252
  }, {
    "lng": -82.7242,
    "lat": 38.4253
  }, {
    "lng": -82.7241,
    "lat": 38.4254
  }, {
    "lng": -82.7239,
    "lat": 38.4255
  }, {
    "lng": -82.7236,
    "lat": 38.4257
  }, {
    "lng": -82.7233,
    "lat": 38.4259
  }, {
    "lng": -82.7232,
    "lat": 38.426
  }, {
    "lng": -82.723,
    "lat": 38.4263
  }, {
    "lng": -82.7229,
    "lat": 38.4264
  }, {
    "lng": -82.7227,
    "lat": 38.4269
  }, {
    "lng": -82.7223,
    "lat": 38.4275
  }, {
    "lng": -82.7218,
    "lat": 38.428
  }, {
    "lng": -82.7213,
    "lat": 38.4287
  }, {
    "lng": -82.7212,
    "lat": 38.43
  }, {
    "lng": -82.7204,
    "lat": 38.4297
  }, {
    "lng": -82.7202,
    "lat": 38.4298
  }, {
    "lng": -82.7201,
    "lat": 38.4299
  }, {
    "lng": -82.7199,
    "lat": 38.4301
  }, {
    "lng": -82.7197,
    "lat": 38.4303
  }, {
    "lng": -82.7195,
    "lat": 38.4304
  }, {
    "lng": -82.7194,
    "lat": 38.4305
  }, {
    "lng": -82.7193,
    "lat": 38.4306
  }, {
    "lng": -82.7191,
    "lat": 38.4306
  }, {
    "lng": -82.719,
    "lat": 38.4306
  }, {
    "lng": -82.7187,
    "lat": 38.4306
  }, {
    "lng": -82.7186,
    "lat": 38.4306
  }, {
    "lng": -82.7183,
    "lat": 38.4306
  }, {
    "lng": -82.7179,
    "lat": 38.4306
  }, {
    "lng": -82.7177,
    "lat": 38.4306
  }, {
    "lng": -82.7175,
    "lat": 38.4306
  }, {
    "lng": -82.7173,
    "lat": 38.4306
  }, {
    "lng": -82.717,
    "lat": 38.4307
  }, {
    "lng": -82.717,
    "lat": 38.4307
  }, {
    "lng": -82.7166,
    "lat": 38.4308
  }, {
    "lng": -82.7163,
    "lat": 38.4309
  }, {
    "lng": -82.7161,
    "lat": 38.431
  }, {
    "lng": -82.7158,
    "lat": 38.431
  }, {
    "lng": -82.7152,
    "lat": 38.4312
  }, {
    "lng": -82.7146,
    "lat": 38.4313
  }, {
    "lng": -82.7141,
    "lat": 38.4314
  }, {
    "lng": -82.714,
    "lat": 38.4314
  }, {
    "lng": -82.7139,
    "lat": 38.4315
  }, {
    "lng": -82.7124,
    "lat": 38.4318
  }, {
    "lng": -82.7122,
    "lat": 38.4319
  }, {
    "lng": -82.712,
    "lat": 38.432
  }, {
    "lng": -82.7117,
    "lat": 38.4321
  }, {
    "lng": -82.7102,
    "lat": 38.4306
  }, {
    "lng": -82.7097,
    "lat": 38.4295
  }, {
    "lng": -82.7093,
    "lat": 38.4287
  }, {
    "lng": -82.7095,
    "lat": 38.428
  }, {
    "lng": -82.7097,
    "lat": 38.4277
  }, {
    "lng": -82.7111,
    "lat": 38.4277
  }, {
    "lng": -82.7099,
    "lat": 38.4273
  }, {
    "lng": -82.709,
    "lat": 38.427
  }, {
    "lng": -82.7089,
    "lat": 38.4272
  }, {
    "lng": -82.7086,
    "lat": 38.428
  }, {
    "lng": -82.7085,
    "lat": 38.4283
  }, {
    "lng": -82.7084,
    "lat": 38.4286
  }, {
    "lng": -82.7083,
    "lat": 38.4289
  }, {
    "lng": -82.7082,
    "lat": 38.4293
  }, {
    "lng": -82.7081,
    "lat": 38.4296
  }, {
    "lng": -82.7081,
    "lat": 38.4298
  }, {
    "lng": -82.7078,
    "lat": 38.4305
  }, {
    "lng": -82.7076,
    "lat": 38.4313
  }, {
    "lng": -82.7075,
    "lat": 38.4315
  }, {
    "lng": -82.7074,
    "lat": 38.432
  }]]],
  "options": {
    "fillColor": "#009aee",
    "fillOpacity": 0.4,
    "strokeColor": "#0073B3",
    "strokeWeight": 1,
    "strokeOpacity": 0.4,
    "clickable": true,
    "visible": true,
    "zIndex": 1000
  }
};
var carrierRoute21 = {
  "carrierRoute": "41102R007",
  "paths": [[[{
    "lng": -82.69,
    "lat": 38.4021
  }, {
    "lng": -82.6903,
    "lat": 38.4026
  }, {
    "lng": -82.6909,
    "lat": 38.4034
  }, {
    "lng": -82.6911,
    "lat": 38.4037
  }, {
    "lng": -82.6912,
    "lat": 38.4043
  }, {
    "lng": -82.6911,
    "lat": 38.405
  }, {
    "lng": -82.6928,
    "lat": 38.4057
  }, {
    "lng": -82.6931,
    "lat": 38.406
  }, {
    "lng": -82.6933,
    "lat": 38.4062
  }, {
    "lng": -82.6937,
    "lat": 38.4062
  }, {
    "lng": -82.6946,
    "lat": 38.4061
  }, {
    "lng": -82.6954,
    "lat": 38.406
  }, {
    "lng": -82.6956,
    "lat": 38.4061
  }, {
    "lng": -82.6963,
    "lat": 38.4066
  }, {
    "lng": -82.6983,
    "lat": 38.4076
  }, {
    "lng": -82.6989,
    "lat": 38.4079
  }, {
    "lng": -82.6992,
    "lat": 38.4081
  }, {
    "lng": -82.6994,
    "lat": 38.4082
  }, {
    "lng": -82.6997,
    "lat": 38.4083
  }, {
    "lng": -82.6998,
    "lat": 38.4083
  }, {
    "lng": -82.7,
    "lat": 38.4083
  }, {
    "lng": -82.7007,
    "lat": 38.4083
  }, {
    "lng": -82.7015,
    "lat": 38.4084
  }, {
    "lng": -82.7022,
    "lat": 38.4085
  }, {
    "lng": -82.7026,
    "lat": 38.4088
  }, {
    "lng": -82.7033,
    "lat": 38.4091
  }, {
    "lng": -82.7042,
    "lat": 38.4095
  }, {
    "lng": -82.7054,
    "lat": 38.4101
  }, {
    "lng": -82.7063,
    "lat": 38.4105
  }, {
    "lng": -82.7078,
    "lat": 38.411
  }, {
    "lng": -82.7082,
    "lat": 38.4112
  }, {
    "lng": -82.7087,
    "lat": 38.4115
  }, {
    "lng": -82.7098,
    "lat": 38.4123
  }, {
    "lng": -82.71,
    "lat": 38.4126
  }, {
    "lng": -82.7102,
    "lat": 38.4128
  }, {
    "lng": -82.7068,
    "lat": 38.4155
  }, {
    "lng": -82.7066,
    "lat": 38.4154
  }, {
    "lng": -82.7052,
    "lat": 38.4141
  }, {
    "lng": -82.705,
    "lat": 38.4139
  }, {
    "lng": -82.7049,
    "lat": 38.4137
  }, {
    "lng": -82.7046,
    "lat": 38.4135
  }, {
    "lng": -82.7045,
    "lat": 38.4135
  }, {
    "lng": -82.7042,
    "lat": 38.4134
  }, {
    "lng": -82.7039,
    "lat": 38.4133
  }, {
    "lng": -82.7035,
    "lat": 38.4132
  }, {
    "lng": -82.7033,
    "lat": 38.4131
  }, {
    "lng": -82.703,
    "lat": 38.413
  }, {
    "lng": -82.7028,
    "lat": 38.413
  }, {
    "lng": -82.7027,
    "lat": 38.413
  }, {
    "lng": -82.7025,
    "lat": 38.413
  }, {
    "lng": -82.7021,
    "lat": 38.4131
  }, {
    "lng": -82.7015,
    "lat": 38.4133
  }, {
    "lng": -82.7015,
    "lat": 38.4133
  }, {
    "lng": -82.7011,
    "lat": 38.4132
  }, {
    "lng": -82.7006,
    "lat": 38.4131
  }, {
    "lng": -82.7006,
    "lat": 38.4133
  }, {
    "lng": -82.7006,
    "lat": 38.4134
  }, {
    "lng": -82.7005,
    "lat": 38.4135
  }, {
    "lng": -82.7005,
    "lat": 38.4135
  }, {
    "lng": -82.7004,
    "lat": 38.4136
  }, {
    "lng": -82.7002,
    "lat": 38.4137
  }, {
    "lng": -82.6995,
    "lat": 38.4139
  }, {
    "lng": -82.6994,
    "lat": 38.414
  }, {
    "lng": -82.6993,
    "lat": 38.4141
  }, {
    "lng": -82.6991,
    "lat": 38.4143
  }, {
    "lng": -82.6991,
    "lat": 38.4145
  }, {
    "lng": -82.6991,
    "lat": 38.4146
  }, {
    "lng": -82.6991,
    "lat": 38.4147
  }, {
    "lng": -82.6992,
    "lat": 38.4156
  }, {
    "lng": -82.6992,
    "lat": 38.4158
  }, {
    "lng": -82.6992,
    "lat": 38.4166
  }, {
    "lng": -82.6992,
    "lat": 38.4169
  }, {
    "lng": -82.6961,
    "lat": 38.4167
  }, {
    "lng": -82.6953,
    "lat": 38.4168
  }, {
    "lng": -82.6947,
    "lat": 38.4167
  }, {
    "lng": -82.6942,
    "lat": 38.4169
  }, {
    "lng": -82.6936,
    "lat": 38.417
  }, {
    "lng": -82.6933,
    "lat": 38.417
  }, {
    "lng": -82.6932,
    "lat": 38.4177
  }, {
    "lng": -82.6943,
    "lat": 38.4177
  }, {
    "lng": -82.6949,
    "lat": 38.4178
  }, {
    "lng": -82.6952,
    "lat": 38.4178
  }, {
    "lng": -82.6955,
    "lat": 38.4178
  }, {
    "lng": -82.696,
    "lat": 38.4178
  }, {
    "lng": -82.6964,
    "lat": 38.4178
  }, {
    "lng": -82.6968,
    "lat": 38.4178
  }, {
    "lng": -82.6972,
    "lat": 38.4178
  }, {
    "lng": -82.6973,
    "lat": 38.4179
  }, {
    "lng": -82.6979,
    "lat": 38.418
  }, {
    "lng": -82.698,
    "lat": 38.418
  }, {
    "lng": -82.6981,
    "lat": 38.4182
  }, {
    "lng": -82.6984,
    "lat": 38.4184
  }, {
    "lng": -82.6985,
    "lat": 38.4192
  }, {
    "lng": -82.6984,
    "lat": 38.4189
  }, {
    "lng": -82.6983,
    "lat": 38.4188
  }, {
    "lng": -82.6982,
    "lat": 38.4187
  }, {
    "lng": -82.6981,
    "lat": 38.4187
  }, {
    "lng": -82.6979,
    "lat": 38.4186
  }, {
    "lng": -82.6978,
    "lat": 38.4186
  }, {
    "lng": -82.6976,
    "lat": 38.4186
  }, {
    "lng": -82.6974,
    "lat": 38.4186
  }, {
    "lng": -82.6973,
    "lat": 38.4187
  }, {
    "lng": -82.6972,
    "lat": 38.4188
  }, {
    "lng": -82.697,
    "lat": 38.4195
  }, {
    "lng": -82.6968,
    "lat": 38.4198
  }, {
    "lng": -82.6964,
    "lat": 38.4203
  }, {
    "lng": -82.6961,
    "lat": 38.4207
  }, {
    "lng": -82.6961,
    "lat": 38.4207
  }, {
    "lng": -82.6959,
    "lat": 38.4211
  }, {
    "lng": -82.6959,
    "lat": 38.4213
  }, {
    "lng": -82.6958,
    "lat": 38.4215
  }, {
    "lng": -82.6956,
    "lat": 38.4222
  }, {
    "lng": -82.6956,
    "lat": 38.4223
  }, {
    "lng": -82.6955,
    "lat": 38.4226
  }, {
    "lng": -82.6953,
    "lat": 38.4227
  }, {
    "lng": -82.6952,
    "lat": 38.4229
  }, {
    "lng": -82.6951,
    "lat": 38.423
  }, {
    "lng": -82.6947,
    "lat": 38.4233
  }, {
    "lng": -82.6941,
    "lat": 38.4238
  }, {
    "lng": -82.6941,
    "lat": 38.4239
  }, {
    "lng": -82.6939,
    "lat": 38.424
  }, {
    "lng": -82.6937,
    "lat": 38.424
  }, {
    "lng": -82.6934,
    "lat": 38.4241
  }, {
    "lng": -82.6927,
    "lat": 38.4243
  }, {
    "lng": -82.6921,
    "lat": 38.4244
  }, {
    "lng": -82.6922,
    "lat": 38.4249
  }, {
    "lng": -82.6922,
    "lat": 38.4254
  }, {
    "lng": -82.6923,
    "lat": 38.4255
  }, {
    "lng": -82.6929,
    "lat": 38.4257
  }, {
    "lng": -82.6933,
    "lat": 38.4259
  }, {
    "lng": -82.6933,
    "lat": 38.4259
  }, {
    "lng": -82.6938,
    "lat": 38.4264
  }, {
    "lng": -82.6948,
    "lat": 38.4275
  }, {
    "lng": -82.6947,
    "lat": 38.4278
  }, {
    "lng": -82.6945,
    "lat": 38.4279
  }, {
    "lng": -82.6944,
    "lat": 38.428
  }, {
    "lng": -82.6942,
    "lat": 38.4283
  }, {
    "lng": -82.6941,
    "lat": 38.4284
  }, {
    "lng": -82.694,
    "lat": 38.4285
  }, {
    "lng": -82.694,
    "lat": 38.4286
  }, {
    "lng": -82.6938,
    "lat": 38.4288
  }, {
    "lng": -82.6939,
    "lat": 38.4289
  }, {
    "lng": -82.6939,
    "lat": 38.429
  }, {
    "lng": -82.6938,
    "lat": 38.4291
  }, {
    "lng": -82.6938,
    "lat": 38.4294
  }, {
    "lng": -82.6937,
    "lat": 38.4295
  }, {
    "lng": -82.6937,
    "lat": 38.4299
  }, {
    "lng": -82.6937,
    "lat": 38.4302
  }, {
    "lng": -82.6936,
    "lat": 38.4306
  }, {
    "lng": -82.6935,
    "lat": 38.4308
  }, {
    "lng": -82.6934,
    "lat": 38.4312
  }, {
    "lng": -82.6934,
    "lat": 38.4313
  }, {
    "lng": -82.6933,
    "lat": 38.4314
  }, {
    "lng": -82.6933,
    "lat": 38.4317
  }, {
    "lng": -82.6932,
    "lat": 38.4319
  }, {
    "lng": -82.693,
    "lat": 38.4325
  }, {
    "lng": -82.6931,
    "lat": 38.4326
  }, {
    "lng": -82.6931,
    "lat": 38.4326
  }, {
    "lng": -82.6932,
    "lat": 38.4326
  }, {
    "lng": -82.6933,
    "lat": 38.4327
  }, {
    "lng": -82.6928,
    "lat": 38.4333
  }, {
    "lng": -82.6927,
    "lat": 38.4335
  }, {
    "lng": -82.6925,
    "lat": 38.4337
  }, {
    "lng": -82.6918,
    "lat": 38.4346
  }, {
    "lng": -82.6914,
    "lat": 38.4351
  }, {
    "lng": -82.6912,
    "lat": 38.4353
  }, {
    "lng": -82.6909,
    "lat": 38.4357
  }, {
    "lng": -82.691,
    "lat": 38.4357
  }, {
    "lng": -82.6911,
    "lat": 38.4358
  }, {
    "lng": -82.6913,
    "lat": 38.4355
  }, {
    "lng": -82.6917,
    "lat": 38.435
  }, {
    "lng": -82.6925,
    "lat": 38.434
  }, {
    "lng": -82.6928,
    "lat": 38.4337
  }, {
    "lng": -82.6929,
    "lat": 38.4335
  }, {
    "lng": -82.6934,
    "lat": 38.4328
  }, {
    "lng": -82.6939,
    "lat": 38.4322
  }, {
    "lng": -82.694,
    "lat": 38.4321
  }, {
    "lng": -82.694,
    "lat": 38.4321
  }, {
    "lng": -82.6945,
    "lat": 38.4314
  }, {
    "lng": -82.6965,
    "lat": 38.4289
  }, {
    "lng": -82.6989,
    "lat": 38.4259
  }, {
    "lng": -82.6988,
    "lat": 38.4258
  }, {
    "lng": -82.6987,
    "lat": 38.4258
  }, {
    "lng": -82.6988,
    "lat": 38.4257
  }, {
    "lng": -82.6991,
    "lat": 38.4253
  }, {
    "lng": -82.7002,
    "lat": 38.4238
  }, {
    "lng": -82.7003,
    "lat": 38.4238
  }, {
    "lng": -82.7005,
    "lat": 38.4239
  }, {
    "lng": -82.7006,
    "lat": 38.4238
  }, {
    "lng": -82.7017,
    "lat": 38.4224
  }, {
    "lng": -82.702,
    "lat": 38.422
  }, {
    "lng": -82.7021,
    "lat": 38.4218
  }, {
    "lng": -82.7032,
    "lat": 38.4204
  }, {
    "lng": -82.7034,
    "lat": 38.4201
  }, {
    "lng": -82.7037,
    "lat": 38.4197
  }, {
    "lng": -82.7039,
    "lat": 38.4195
  }, {
    "lng": -82.7046,
    "lat": 38.4185
  }, {
    "lng": -82.7048,
    "lat": 38.4185
  }, {
    "lng": -82.705,
    "lat": 38.4186
  }, {
    "lng": -82.7052,
    "lat": 38.4186
  }, {
    "lng": -82.7054,
    "lat": 38.4185
  }, {
    "lng": -82.7055,
    "lat": 38.4185
  }, {
    "lng": -82.7058,
    "lat": 38.4175
  }, {
    "lng": -82.7063,
    "lat": 38.4168
  }, {
    "lng": -82.7068,
    "lat": 38.4168
  }, {
    "lng": -82.707,
    "lat": 38.417
  }, {
    "lng": -82.7074,
    "lat": 38.4173
  }, {
    "lng": -82.7075,
    "lat": 38.4173
  }, {
    "lng": -82.7076,
    "lat": 38.4172
  }, {
    "lng": -82.7078,
    "lat": 38.4166
  }, {
    "lng": -82.7078,
    "lat": 38.4162
  }, {
    "lng": -82.7081,
    "lat": 38.4157
  }, {
    "lng": -82.7086,
    "lat": 38.4152
  }, {
    "lng": -82.7098,
    "lat": 38.4148
  }, {
    "lng": -82.7107,
    "lat": 38.4146
  }, {
    "lng": -82.7111,
    "lat": 38.4141
  }, {
    "lng": -82.7117,
    "lat": 38.4135
  }, {
    "lng": -82.712,
    "lat": 38.413
  }, {
    "lng": -82.7121,
    "lat": 38.4124
  }, {
    "lng": -82.7123,
    "lat": 38.4122
  }, {
    "lng": -82.7127,
    "lat": 38.4119
  }, {
    "lng": -82.7132,
    "lat": 38.4117
  }, {
    "lng": -82.7139,
    "lat": 38.4112
  }, {
    "lng": -82.7143,
    "lat": 38.4107
  }, {
    "lng": -82.715,
    "lat": 38.4101
  }, {
    "lng": -82.715,
    "lat": 38.4099
  }, {
    "lng": -82.715,
    "lat": 38.4095
  }, {
    "lng": -82.7154,
    "lat": 38.409
  }, {
    "lng": -82.7154,
    "lat": 38.4084
  }, {
    "lng": -82.7154,
    "lat": 38.4079
  }, {
    "lng": -82.7156,
    "lat": 38.407
  }, {
    "lng": -82.7157,
    "lat": 38.4064
  }, {
    "lng": -82.7146,
    "lat": 38.4068
  }, {
    "lng": -82.7146,
    "lat": 38.4068
  }, {
    "lng": -82.7146,
    "lat": 38.4066
  }, {
    "lng": -82.7145,
    "lat": 38.4065
  }, {
    "lng": -82.7144,
    "lat": 38.4063
  }, {
    "lng": -82.7143,
    "lat": 38.4062
  }, {
    "lng": -82.7141,
    "lat": 38.4059
  }, {
    "lng": -82.7139,
    "lat": 38.4056
  }, {
    "lng": -82.7133,
    "lat": 38.4048
  }, {
    "lng": -82.7122,
    "lat": 38.4031
  }, {
    "lng": -82.7119,
    "lat": 38.402
  }, {
    "lng": -82.7118,
    "lat": 38.4018
  }, {
    "lng": -82.7118,
    "lat": 38.4017
  }, {
    "lng": -82.7117,
    "lat": 38.4013
  }, {
    "lng": -82.7117,
    "lat": 38.401
  }, {
    "lng": -82.7116,
    "lat": 38.4007
  }, {
    "lng": -82.7116,
    "lat": 38.4006
  }, {
    "lng": -82.7115,
    "lat": 38.4004
  }, {
    "lng": -82.7115,
    "lat": 38.4003
  }, {
    "lng": -82.7111,
    "lat": 38.3984
  }, {
    "lng": -82.7109,
    "lat": 38.3976
  }, {
    "lng": -82.7106,
    "lat": 38.3963
  }, {
    "lng": -82.7105,
    "lat": 38.3959
  }, {
    "lng": -82.7104,
    "lat": 38.3953
  }, {
    "lng": -82.7104,
    "lat": 38.3947
  }, {
    "lng": -82.7103,
    "lat": 38.394
  }, {
    "lng": -82.7103,
    "lat": 38.394
  }, {
    "lng": -82.7104,
    "lat": 38.3938
  }, {
    "lng": -82.7104,
    "lat": 38.3937
  }, {
    "lng": -82.7105,
    "lat": 38.3934
  }, {
    "lng": -82.7105,
    "lat": 38.3931
  }, {
    "lng": -82.7106,
    "lat": 38.3929
  }, {
    "lng": -82.711,
    "lat": 38.3923
  }, {
    "lng": -82.7112,
    "lat": 38.392
  }, {
    "lng": -82.7116,
    "lat": 38.3917
  }, {
    "lng": -82.7116,
    "lat": 38.3916
  }, {
    "lng": -82.7115,
    "lat": 38.3915
  }, {
    "lng": -82.7112,
    "lat": 38.3913
  }, {
    "lng": -82.7111,
    "lat": 38.3912
  }, {
    "lng": -82.7111,
    "lat": 38.3911
  }, {
    "lng": -82.711,
    "lat": 38.3911
  }, {
    "lng": -82.7109,
    "lat": 38.391
  }, {
    "lng": -82.7108,
    "lat": 38.3909
  }, {
    "lng": -82.7105,
    "lat": 38.3908
  }, {
    "lng": -82.7103,
    "lat": 38.3907
  }, {
    "lng": -82.7101,
    "lat": 38.3906
  }, {
    "lng": -82.709,
    "lat": 38.3905
  }, {
    "lng": -82.7089,
    "lat": 38.3905
  }, {
    "lng": -82.7081,
    "lat": 38.3904
  }, {
    "lng": -82.7077,
    "lat": 38.3903
  }, {
    "lng": -82.7074,
    "lat": 38.3902
  }, {
    "lng": -82.707,
    "lat": 38.3901
  }, {
    "lng": -82.7065,
    "lat": 38.3901
  }, {
    "lng": -82.7062,
    "lat": 38.39
  }, {
    "lng": -82.706,
    "lat": 38.39
  }, {
    "lng": -82.7057,
    "lat": 38.39
  }, {
    "lng": -82.7053,
    "lat": 38.3901
  }, {
    "lng": -82.705,
    "lat": 38.3901
  }, {
    "lng": -82.7042,
    "lat": 38.3903
  }, {
    "lng": -82.7037,
    "lat": 38.3904
  }, {
    "lng": -82.7035,
    "lat": 38.39
  }, {
    "lng": -82.703,
    "lat": 38.3892
  }, {
    "lng": -82.7027,
    "lat": 38.3888
  }, {
    "lng": -82.7019,
    "lat": 38.3892
  }, {
    "lng": -82.7018,
    "lat": 38.3892
  }, {
    "lng": -82.7014,
    "lat": 38.3895
  }, {
    "lng": -82.7001,
    "lat": 38.3908
  }, {
    "lng": -82.6998,
    "lat": 38.391
  }, {
    "lng": -82.6997,
    "lat": 38.3911
  }, {
    "lng": -82.6993,
    "lat": 38.3914
  }, {
    "lng": -82.699,
    "lat": 38.3915
  }, {
    "lng": -82.6988,
    "lat": 38.3916
  }, {
    "lng": -82.6984,
    "lat": 38.3919
  }, {
    "lng": -82.6981,
    "lat": 38.3921
  }, {
    "lng": -82.6978,
    "lat": 38.3923
  }, {
    "lng": -82.6976,
    "lat": 38.3924
  }, {
    "lng": -82.6974,
    "lat": 38.3925
  }, {
    "lng": -82.6972,
    "lat": 38.3926
  }, {
    "lng": -82.6969,
    "lat": 38.3926
  }, {
    "lng": -82.6965,
    "lat": 38.3927
  }, {
    "lng": -82.696,
    "lat": 38.3926
  }, {
    "lng": -82.6945,
    "lat": 38.3925
  }, {
    "lng": -82.6943,
    "lat": 38.3925
  }, {
    "lng": -82.6941,
    "lat": 38.3925
  }, {
    "lng": -82.6936,
    "lat": 38.3926
  }, {
    "lng": -82.6934,
    "lat": 38.3926
  }, {
    "lng": -82.6935,
    "lat": 38.3928
  }, {
    "lng": -82.6937,
    "lat": 38.3928
  }, {
    "lng": -82.6939,
    "lat": 38.3929
  }, {
    "lng": -82.6946,
    "lat": 38.3928
  }, {
    "lng": -82.6948,
    "lat": 38.3928
  }, {
    "lng": -82.6953,
    "lat": 38.3929
  }, {
    "lng": -82.6966,
    "lat": 38.393
  }, {
    "lng": -82.696,
    "lat": 38.3932
  }, {
    "lng": -82.6952,
    "lat": 38.3936
  }, {
    "lng": -82.694,
    "lat": 38.3942
  }, {
    "lng": -82.6939,
    "lat": 38.3949
  }, {
    "lng": -82.6939,
    "lat": 38.3949
  }, {
    "lng": -82.6938,
    "lat": 38.3951
  }, {
    "lng": -82.6937,
    "lat": 38.3956
  }, {
    "lng": -82.6933,
    "lat": 38.3963
  }, {
    "lng": -82.6929,
    "lat": 38.3971
  }, {
    "lng": -82.6922,
    "lat": 38.3983
  }, {
    "lng": -82.6928,
    "lat": 38.3982
  }, {
    "lng": -82.6925,
    "lat": 38.3988
  }, {
    "lng": -82.6923,
    "lat": 38.3991
  }, {
    "lng": -82.6922,
    "lat": 38.3994
  }, {
    "lng": -82.6921,
    "lat": 38.3997
  }, {
    "lng": -82.692,
    "lat": 38.3998
  }, {
    "lng": -82.6919,
    "lat": 38.3999
  }, {
    "lng": -82.6918,
    "lat": 38.4
  }, {
    "lng": -82.6917,
    "lat": 38.4002
  }, {
    "lng": -82.691,
    "lat": 38.401
  }, {
    "lng": -82.6907,
    "lat": 38.4013
  }, {
    "lng": -82.6904,
    "lat": 38.4016
  }, {
    "lng": -82.6901,
    "lat": 38.4019
  }, {
    "lng": -82.69,
    "lat": 38.4021
  }]]],
  "options": {
    "fillColor": "#009aee",
    "fillOpacity": 0.4,
    "strokeColor": "#0073B3",
    "strokeWeight": 1,
    "strokeOpacity": 0.4,
    "clickable": true,
    "visible": true,
    "zIndex": 1000
  }
};
var carrierRoute22 = {
  "carrierRoute": "41102R006",
  "paths": [[[{
    "lng": -82.6706,
    "lat": 38.4637
  }, {
    "lng": -82.6705,
    "lat": 38.4638
  }, {
    "lng": -82.6705,
    "lat": 38.4639
  }, {
    "lng": -82.6706,
    "lat": 38.464
  }, {
    "lng": -82.6708,
    "lat": 38.4641
  }, {
    "lng": -82.6709,
    "lat": 38.4641
  }, {
    "lng": -82.6709,
    "lat": 38.4642
  }, {
    "lng": -82.671,
    "lat": 38.4643
  }, {
    "lng": -82.6709,
    "lat": 38.4645
  }, {
    "lng": -82.6707,
    "lat": 38.4646
  }, {
    "lng": -82.6706,
    "lat": 38.4648
  }, {
    "lng": -82.6708,
    "lat": 38.4649
  }, {
    "lng": -82.671,
    "lat": 38.465
  }, {
    "lng": -82.671,
    "lat": 38.4652
  }, {
    "lng": -82.671,
    "lat": 38.4654
  }, {
    "lng": -82.671,
    "lat": 38.4657
  }, {
    "lng": -82.6709,
    "lat": 38.466
  }, {
    "lng": -82.6709,
    "lat": 38.4661
  }, {
    "lng": -82.6709,
    "lat": 38.4662
  }, {
    "lng": -82.671,
    "lat": 38.4663
  }, {
    "lng": -82.671,
    "lat": 38.4664
  }, {
    "lng": -82.6714,
    "lat": 38.4669
  }, {
    "lng": -82.6716,
    "lat": 38.4669
  }, {
    "lng": -82.6718,
    "lat": 38.4669
  }, {
    "lng": -82.6719,
    "lat": 38.4656
  }, {
    "lng": -82.6721,
    "lat": 38.4656
  }, {
    "lng": -82.6721,
    "lat": 38.4649
  }, {
    "lng": -82.6721,
    "lat": 38.4645
  }, {
    "lng": -82.6721,
    "lat": 38.4644
  }, {
    "lng": -82.6721,
    "lat": 38.4644
  }, {
    "lng": -82.6722,
    "lat": 38.464
  }, {
    "lng": -82.6723,
    "lat": 38.4638
  }, {
    "lng": -82.6723,
    "lat": 38.4638
  }, {
    "lng": -82.6724,
    "lat": 38.4637
  }, {
    "lng": -82.6724,
    "lat": 38.4636
  }, {
    "lng": -82.6724,
    "lat": 38.4635
  }, {
    "lng": -82.6725,
    "lat": 38.4634
  }, {
    "lng": -82.6726,
    "lat": 38.4633
  }, {
    "lng": -82.6726,
    "lat": 38.4633
  }, {
    "lng": -82.6727,
    "lat": 38.463
  }, {
    "lng": -82.6729,
    "lat": 38.4628
  }, {
    "lng": -82.6731,
    "lat": 38.4626
  }, {
    "lng": -82.6733,
    "lat": 38.4624
  }, {
    "lng": -82.6735,
    "lat": 38.4622
  }, {
    "lng": -82.6739,
    "lat": 38.4619
  }, {
    "lng": -82.6748,
    "lat": 38.4612
  }, {
    "lng": -82.6752,
    "lat": 38.4609
  }, {
    "lng": -82.6755,
    "lat": 38.4605
  }, {
    "lng": -82.6757,
    "lat": 38.4603
  }, {
    "lng": -82.6759,
    "lat": 38.46
  }, {
    "lng": -82.6762,
    "lat": 38.4596
  }, {
    "lng": -82.6764,
    "lat": 38.4591
  }, {
    "lng": -82.6765,
    "lat": 38.4589
  }, {
    "lng": -82.6767,
    "lat": 38.4585
  }, {
    "lng": -82.6768,
    "lat": 38.458
  }, {
    "lng": -82.6771,
    "lat": 38.4576
  }, {
    "lng": -82.6772,
    "lat": 38.4574
  }, {
    "lng": -82.6773,
    "lat": 38.4572
  }, {
    "lng": -82.6776,
    "lat": 38.4569
  }, {
    "lng": -82.6777,
    "lat": 38.4567
  }, {
    "lng": -82.6777,
    "lat": 38.4567
  }, {
    "lng": -82.6779,
    "lat": 38.4566
  }, {
    "lng": -82.6782,
    "lat": 38.4564
  }, {
    "lng": -82.6784,
    "lat": 38.4562
  }, {
    "lng": -82.68,
    "lat": 38.4552
  }, {
    "lng": -82.6805,
    "lat": 38.455
  }, {
    "lng": -82.6808,
    "lat": 38.4549
  }, {
    "lng": -82.6813,
    "lat": 38.4547
  }, {
    "lng": -82.682,
    "lat": 38.4545
  }, {
    "lng": -82.6831,
    "lat": 38.4543
  }, {
    "lng": -82.6835,
    "lat": 38.4542
  }, {
    "lng": -82.6839,
    "lat": 38.454
  }, {
    "lng": -82.6844,
    "lat": 38.4539
  }, {
    "lng": -82.6851,
    "lat": 38.4536
  }, {
    "lng": -82.6856,
    "lat": 38.4534
  }, {
    "lng": -82.6861,
    "lat": 38.453
  }, {
    "lng": -82.6865,
    "lat": 38.4526
  }, {
    "lng": -82.6869,
    "lat": 38.4522
  }, {
    "lng": -82.6873,
    "lat": 38.4517
  }, {
    "lng": -82.6876,
    "lat": 38.4512
  }, {
    "lng": -82.6877,
    "lat": 38.4509
  }, {
    "lng": -82.6879,
    "lat": 38.4504
  }, {
    "lng": -82.6883,
    "lat": 38.4487
  }, {
    "lng": -82.6885,
    "lat": 38.4482
  }, {
    "lng": -82.6887,
    "lat": 38.4477
  }, {
    "lng": -82.689,
    "lat": 38.4473
  }, {
    "lng": -82.6942,
    "lat": 38.4469
  }, {
    "lng": -82.6977,
    "lat": 38.4467
  }, {
    "lng": -82.6979,
    "lat": 38.4466
  }, {
    "lng": -82.698,
    "lat": 38.4465
  }, {
    "lng": -82.698,
    "lat": 38.4461
  }, {
    "lng": -82.698,
    "lat": 38.446
  }, {
    "lng": -82.6983,
    "lat": 38.4459
  }, {
    "lng": -82.6986,
    "lat": 38.4459
  }, {
    "lng": -82.6991,
    "lat": 38.4458
  }, {
    "lng": -82.6994,
    "lat": 38.4458
  }, {
    "lng": -82.7006,
    "lat": 38.4454
  }, {
    "lng": -82.7021,
    "lat": 38.445
  }, {
    "lng": -82.7029,
    "lat": 38.4446
  }, {
    "lng": -82.7038,
    "lat": 38.4441
  }, {
    "lng": -82.7037,
    "lat": 38.444
  }, {
    "lng": -82.7028,
    "lat": 38.4446
  }, {
    "lng": -82.7023,
    "lat": 38.4448
  }, {
    "lng": -82.7014,
    "lat": 38.4451
  }, {
    "lng": -82.701,
    "lat": 38.4453
  }, {
    "lng": -82.7003,
    "lat": 38.4455
  }, {
    "lng": -82.6998,
    "lat": 38.4456
  }, {
    "lng": -82.699,
    "lat": 38.4457
  }, {
    "lng": -82.6987,
    "lat": 38.4458
  }, {
    "lng": -82.698,
    "lat": 38.4458
  }, {
    "lng": -82.6975,
    "lat": 38.4459
  }, {
    "lng": -82.6973,
    "lat": 38.4459
  }, {
    "lng": -82.6972,
    "lat": 38.4459
  }, {
    "lng": -82.6964,
    "lat": 38.4459
  }, {
    "lng": -82.6952,
    "lat": 38.4458
  }, {
    "lng": -82.6944,
    "lat": 38.4457
  }, {
    "lng": -82.694,
    "lat": 38.4456
  }, {
    "lng": -82.6938,
    "lat": 38.4456
  }, {
    "lng": -82.6928,
    "lat": 38.4456
  }, {
    "lng": -82.6919,
    "lat": 38.4457
  }, {
    "lng": -82.691,
    "lat": 38.4458
  }, {
    "lng": -82.6906,
    "lat": 38.446
  }, {
    "lng": -82.6903,
    "lat": 38.4461
  }, {
    "lng": -82.6903,
    "lat": 38.4461
  }, {
    "lng": -82.6903,
    "lat": 38.446
  }, {
    "lng": -82.6903,
    "lat": 38.446
  }, {
    "lng": -82.6902,
    "lat": 38.4459
  }, {
    "lng": -82.6902,
    "lat": 38.4458
  }, {
    "lng": -82.6902,
    "lat": 38.4456
  }, {
    "lng": -82.6902,
    "lat": 38.4455
  }, {
    "lng": -82.6902,
    "lat": 38.4455
  }, {
    "lng": -82.6901,
    "lat": 38.4455
  }, {
    "lng": -82.69,
    "lat": 38.4454
  }, {
    "lng": -82.6897,
    "lat": 38.4451
  }, {
    "lng": -82.6897,
    "lat": 38.4451
  }, {
    "lng": -82.6896,
    "lat": 38.4451
  }, {
    "lng": -82.6896,
    "lat": 38.4451
  }, {
    "lng": -82.6895,
    "lat": 38.4451
  }, {
    "lng": -82.6887,
    "lat": 38.4456
  }, {
    "lng": -82.6884,
    "lat": 38.4458
  }, {
    "lng": -82.6882,
    "lat": 38.4459
  }, {
    "lng": -82.6881,
    "lat": 38.446
  }, {
    "lng": -82.6881,
    "lat": 38.446
  }, {
    "lng": -82.6881,
    "lat": 38.4461
  }, {
    "lng": -82.6881,
    "lat": 38.4461
  }, {
    "lng": -82.6881,
    "lat": 38.4462
  }, {
    "lng": -82.6882,
    "lat": 38.4463
  }, {
    "lng": -82.6883,
    "lat": 38.4464
  }, {
    "lng": -82.6884,
    "lat": 38.4464
  }, {
    "lng": -82.6884,
    "lat": 38.4465
  }, {
    "lng": -82.6885,
    "lat": 38.4466
  }, {
    "lng": -82.6885,
    "lat": 38.4466
  }, {
    "lng": -82.6887,
    "lat": 38.4467
  }, {
    "lng": -82.689,
    "lat": 38.4468
  }, {
    "lng": -82.689,
    "lat": 38.4468
  }, {
    "lng": -82.6891,
    "lat": 38.4468
  }, {
    "lng": -82.6891,
    "lat": 38.4468
  }, {
    "lng": -82.6887,
    "lat": 38.4471
  }, {
    "lng": -82.6886,
    "lat": 38.4472
  }, {
    "lng": -82.688,
    "lat": 38.4465
  }, {
    "lng": -82.6877,
    "lat": 38.4462
  }, {
    "lng": -82.6875,
    "lat": 38.446
  }, {
    "lng": -82.6869,
    "lat": 38.4457
  }, {
    "lng": -82.6865,
    "lat": 38.4454
  }, {
    "lng": -82.6861,
    "lat": 38.4453
  }, {
    "lng": -82.6859,
    "lat": 38.4455
  }, {
    "lng": -82.6855,
    "lat": 38.4453
  }, {
    "lng": -82.6849,
    "lat": 38.445
  }, {
    "lng": -82.6845,
    "lat": 38.4448
  }, {
    "lng": -82.684,
    "lat": 38.4446
  }, {
    "lng": -82.6838,
    "lat": 38.4445
  }, {
    "lng": -82.6831,
    "lat": 38.4443
  }, {
    "lng": -82.682,
    "lat": 38.4441
  }, {
    "lng": -82.6811,
    "lat": 38.4507
  }, {
    "lng": -82.6805,
    "lat": 38.4502
  }, {
    "lng": -82.6799,
    "lat": 38.4528
  }, {
    "lng": -82.6795,
    "lat": 38.4542
  }, {
    "lng": -82.6793,
    "lat": 38.4549
  }, {
    "lng": -82.6792,
    "lat": 38.455
  }, {
    "lng": -82.679,
    "lat": 38.4552
  }, {
    "lng": -82.6787,
    "lat": 38.4554
  }, {
    "lng": -82.6784,
    "lat": 38.4555
  }, {
    "lng": -82.6779,
    "lat": 38.4555
  }, {
    "lng": -82.6778,
    "lat": 38.4556
  }, {
    "lng": -82.6778,
    "lat": 38.4556
  }, {
    "lng": -82.6778,
    "lat": 38.4557
  }, {
    "lng": -82.6776,
    "lat": 38.4558
  }, {
    "lng": -82.6773,
    "lat": 38.4559
  }, {
    "lng": -82.677,
    "lat": 38.4561
  }, {
    "lng": -82.6769,
    "lat": 38.4564
  }, {
    "lng": -82.677,
    "lat": 38.4565
  }, {
    "lng": -82.6771,
    "lat": 38.4568
  }, {
    "lng": -82.6771,
    "lat": 38.4569
  }, {
    "lng": -82.677,
    "lat": 38.4571
  }, {
    "lng": -82.6769,
    "lat": 38.4572
  }, {
    "lng": -82.6768,
    "lat": 38.4574
  }, {
    "lng": -82.6767,
    "lat": 38.4575
  }, {
    "lng": -82.6766,
    "lat": 38.4576
  }, {
    "lng": -82.6766,
    "lat": 38.4577
  }, {
    "lng": -82.6765,
    "lat": 38.4578
  }, {
    "lng": -82.6764,
    "lat": 38.4578
  }, {
    "lng": -82.6764,
    "lat": 38.4579
  }, {
    "lng": -82.6762,
    "lat": 38.4582
  }, {
    "lng": -82.6762,
    "lat": 38.4584
  }, {
    "lng": -82.6763,
    "lat": 38.4586
  }, {
    "lng": -82.6762,
    "lat": 38.459
  }, {
    "lng": -82.6761,
    "lat": 38.4591
  }, {
    "lng": -82.676,
    "lat": 38.4592
  }, {
    "lng": -82.6757,
    "lat": 38.4596
  }, {
    "lng": -82.6756,
    "lat": 38.4597
  }, {
    "lng": -82.6754,
    "lat": 38.4601
  }, {
    "lng": -82.675,
    "lat": 38.4605
  }, {
    "lng": -82.6746,
    "lat": 38.4608
  }, {
    "lng": -82.6741,
    "lat": 38.461
  }, {
    "lng": -82.6736,
    "lat": 38.461
  }, {
    "lng": -82.6731,
    "lat": 38.461
  }, {
    "lng": -82.6727,
    "lat": 38.4611
  }, {
    "lng": -82.6722,
    "lat": 38.4613
  }, {
    "lng": -82.6719,
    "lat": 38.4615
  }, {
    "lng": -82.6717,
    "lat": 38.4618
  }, {
    "lng": -82.6717,
    "lat": 38.4619
  }, {
    "lng": -82.6716,
    "lat": 38.462
  }, {
    "lng": -82.6713,
    "lat": 38.4621
  }, {
    "lng": -82.671,
    "lat": 38.4622
  }, {
    "lng": -82.6707,
    "lat": 38.4624
  }, {
    "lng": -82.6707,
    "lat": 38.4625
  }, {
    "lng": -82.6707,
    "lat": 38.4626
  }, {
    "lng": -82.6706,
    "lat": 38.4626
  }, {
    "lng": -82.6706,
    "lat": 38.4627
  }, {
    "lng": -82.6706,
    "lat": 38.4628
  }, {
    "lng": -82.6706,
    "lat": 38.4629
  }, {
    "lng": -82.6707,
    "lat": 38.4631
  }, {
    "lng": -82.6707,
    "lat": 38.4632
  }, {
    "lng": -82.6706,
    "lat": 38.4635
  }, {
    "lng": -82.6706,
    "lat": 38.4635
  }, {
    "lng": -82.6706,
    "lat": 38.4637
  }]], [[{
    "lng": -82.7053,
    "lat": 38.419
  }, {
    "lng": -82.7054,
    "lat": 38.4203
  }, {
    "lng": -82.7058,
    "lat": 38.4214
  }, {
    "lng": -82.7065,
    "lat": 38.4226
  }, {
    "lng": -82.7081,
    "lat": 38.4239
  }, {
    "lng": -82.7088,
    "lat": 38.4244
  }, {
    "lng": -82.7091,
    "lat": 38.4246
  }, {
    "lng": -82.7092,
    "lat": 38.4249
  }, {
    "lng": -82.7092,
    "lat": 38.425
  }, {
    "lng": -82.7092,
    "lat": 38.4254
  }, {
    "lng": -82.7093,
    "lat": 38.4257
  }, {
    "lng": -82.7093,
    "lat": 38.4259
  }, {
    "lng": -82.7093,
    "lat": 38.4261
  }, {
    "lng": -82.7092,
    "lat": 38.4262
  }, {
    "lng": -82.7092,
    "lat": 38.4262
  }, {
    "lng": -82.7091,
    "lat": 38.4265
  }, {
    "lng": -82.709,
    "lat": 38.427
  }, {
    "lng": -82.7099,
    "lat": 38.4273
  }, {
    "lng": -82.7111,
    "lat": 38.4277
  }, {
    "lng": -82.7097,
    "lat": 38.4277
  }, {
    "lng": -82.7095,
    "lat": 38.428
  }, {
    "lng": -82.7093,
    "lat": 38.4287
  }, {
    "lng": -82.7097,
    "lat": 38.4295
  }, {
    "lng": -82.7102,
    "lat": 38.4306
  }, {
    "lng": -82.7117,
    "lat": 38.4321
  }, {
    "lng": -82.712,
    "lat": 38.432
  }, {
    "lng": -82.7122,
    "lat": 38.4319
  }, {
    "lng": -82.7124,
    "lat": 38.4318
  }, {
    "lng": -82.7139,
    "lat": 38.4315
  }, {
    "lng": -82.714,
    "lat": 38.4314
  }, {
    "lng": -82.7141,
    "lat": 38.4314
  }, {
    "lng": -82.7146,
    "lat": 38.4313
  }, {
    "lng": -82.7152,
    "lat": 38.4312
  }, {
    "lng": -82.7158,
    "lat": 38.431
  }, {
    "lng": -82.7161,
    "lat": 38.431
  }, {
    "lng": -82.7163,
    "lat": 38.4309
  }, {
    "lng": -82.7166,
    "lat": 38.4308
  }, {
    "lng": -82.717,
    "lat": 38.4307
  }, {
    "lng": -82.717,
    "lat": 38.4307
  }, {
    "lng": -82.7173,
    "lat": 38.4306
  }, {
    "lng": -82.7175,
    "lat": 38.4306
  }, {
    "lng": -82.7177,
    "lat": 38.4306
  }, {
    "lng": -82.7179,
    "lat": 38.4306
  }, {
    "lng": -82.7183,
    "lat": 38.4306
  }, {
    "lng": -82.7186,
    "lat": 38.4306
  }, {
    "lng": -82.7187,
    "lat": 38.4306
  }, {
    "lng": -82.719,
    "lat": 38.4306
  }, {
    "lng": -82.7191,
    "lat": 38.4306
  }, {
    "lng": -82.7193,
    "lat": 38.4306
  }, {
    "lng": -82.7194,
    "lat": 38.4305
  }, {
    "lng": -82.7195,
    "lat": 38.4304
  }, {
    "lng": -82.7197,
    "lat": 38.4303
  }, {
    "lng": -82.7199,
    "lat": 38.4301
  }, {
    "lng": -82.7201,
    "lat": 38.4299
  }, {
    "lng": -82.7202,
    "lat": 38.4298
  }, {
    "lng": -82.7204,
    "lat": 38.4297
  }, {
    "lng": -82.7212,
    "lat": 38.43
  }, {
    "lng": -82.7213,
    "lat": 38.4287
  }, {
    "lng": -82.7218,
    "lat": 38.428
  }, {
    "lng": -82.7223,
    "lat": 38.4275
  }, {
    "lng": -82.7227,
    "lat": 38.4269
  }, {
    "lng": -82.7229,
    "lat": 38.4264
  }, {
    "lng": -82.723,
    "lat": 38.4263
  }, {
    "lng": -82.7232,
    "lat": 38.426
  }, {
    "lng": -82.7233,
    "lat": 38.4259
  }, {
    "lng": -82.7236,
    "lat": 38.4257
  }, {
    "lng": -82.7239,
    "lat": 38.4255
  }, {
    "lng": -82.7241,
    "lat": 38.4254
  }, {
    "lng": -82.7242,
    "lat": 38.4253
  }, {
    "lng": -82.7244,
    "lat": 38.4252
  }, {
    "lng": -82.7245,
    "lat": 38.4251
  }, {
    "lng": -82.7246,
    "lat": 38.425
  }, {
    "lng": -82.7247,
    "lat": 38.4248
  }, {
    "lng": -82.7248,
    "lat": 38.4247
  }, {
    "lng": -82.7248,
    "lat": 38.4246
  }, {
    "lng": -82.7248,
    "lat": 38.424
  }, {
    "lng": -82.7248,
    "lat": 38.4236
  }, {
    "lng": -82.7249,
    "lat": 38.4233
  }, {
    "lng": -82.7249,
    "lat": 38.4231
  }, {
    "lng": -82.7249,
    "lat": 38.4229
  }, {
    "lng": -82.7248,
    "lat": 38.4228
  }, {
    "lng": -82.7247,
    "lat": 38.4225
  }, {
    "lng": -82.7245,
    "lat": 38.4222
  }, {
    "lng": -82.7245,
    "lat": 38.4221
  }, {
    "lng": -82.7244,
    "lat": 38.4219
  }, {
    "lng": -82.7241,
    "lat": 38.4208
  }, {
    "lng": -82.7241,
    "lat": 38.4201
  }, {
    "lng": -82.7242,
    "lat": 38.4197
  }, {
    "lng": -82.725,
    "lat": 38.4179
  }, {
    "lng": -82.7253,
    "lat": 38.4174
  }, {
    "lng": -82.7255,
    "lat": 38.4172
  }, {
    "lng": -82.7259,
    "lat": 38.4169
  }, {
    "lng": -82.7264,
    "lat": 38.4167
  }, {
    "lng": -82.7275,
    "lat": 38.4164
  }, {
    "lng": -82.7279,
    "lat": 38.4164
  }, {
    "lng": -82.7289,
    "lat": 38.4165
  }, {
    "lng": -82.7291,
    "lat": 38.4165
  }, {
    "lng": -82.7294,
    "lat": 38.4165
  }, {
    "lng": -82.7303,
    "lat": 38.4163
  }, {
    "lng": -82.7309,
    "lat": 38.4161
  }, {
    "lng": -82.7315,
    "lat": 38.4159
  }, {
    "lng": -82.7318,
    "lat": 38.4156
  }, {
    "lng": -82.7319,
    "lat": 38.4152
  }, {
    "lng": -82.7321,
    "lat": 38.4143
  }, {
    "lng": -82.732,
    "lat": 38.4132
  }, {
    "lng": -82.7318,
    "lat": 38.4125
  }, {
    "lng": -82.7314,
    "lat": 38.4121
  }, {
    "lng": -82.7311,
    "lat": 38.4118
  }, {
    "lng": -82.7306,
    "lat": 38.4115
  }, {
    "lng": -82.7312,
    "lat": 38.4111
  }, {
    "lng": -82.7312,
    "lat": 38.411
  }, {
    "lng": -82.7312,
    "lat": 38.4109
  }, {
    "lng": -82.7309,
    "lat": 38.4106
  }, {
    "lng": -82.7308,
    "lat": 38.4103
  }, {
    "lng": -82.7306,
    "lat": 38.4101
  }, {
    "lng": -82.7301,
    "lat": 38.41
  }, {
    "lng": -82.7301,
    "lat": 38.4099
  }, {
    "lng": -82.7299,
    "lat": 38.4092
  }, {
    "lng": -82.7301,
    "lat": 38.4087
  }, {
    "lng": -82.73,
    "lat": 38.4081
  }, {
    "lng": -82.7295,
    "lat": 38.4077
  }, {
    "lng": -82.7293,
    "lat": 38.4069
  }, {
    "lng": -82.7291,
    "lat": 38.4063
  }, {
    "lng": -82.729,
    "lat": 38.4057
  }, {
    "lng": -82.729,
    "lat": 38.4053
  }, {
    "lng": -82.7291,
    "lat": 38.4045
  }, {
    "lng": -82.7291,
    "lat": 38.4039
  }, {
    "lng": -82.7291,
    "lat": 38.4037
  }, {
    "lng": -82.7291,
    "lat": 38.4036
  }, {
    "lng": -82.7289,
    "lat": 38.4035
  }, {
    "lng": -82.7288,
    "lat": 38.4034
  }, {
    "lng": -82.7291,
    "lat": 38.4032
  }, {
    "lng": -82.729,
    "lat": 38.4031
  }, {
    "lng": -82.7289,
    "lat": 38.4031
  }, {
    "lng": -82.7287,
    "lat": 38.4031
  }, {
    "lng": -82.7285,
    "lat": 38.403
  }, {
    "lng": -82.7282,
    "lat": 38.403
  }, {
    "lng": -82.7279,
    "lat": 38.403
  }, {
    "lng": -82.7275,
    "lat": 38.4031
  }, {
    "lng": -82.7272,
    "lat": 38.4031
  }, {
    "lng": -82.7264,
    "lat": 38.4033
  }, {
    "lng": -82.7257,
    "lat": 38.4034
  }, {
    "lng": -82.7249,
    "lat": 38.4035
  }, {
    "lng": -82.7245,
    "lat": 38.4036
  }, {
    "lng": -82.7241,
    "lat": 38.4036
  }, {
    "lng": -82.7237,
    "lat": 38.4037
  }, {
    "lng": -82.7236,
    "lat": 38.4037
  }, {
    "lng": -82.7235,
    "lat": 38.4036
  }, {
    "lng": -82.7231,
    "lat": 38.4037
  }, {
    "lng": -82.7228,
    "lat": 38.4037
  }, {
    "lng": -82.7224,
    "lat": 38.4038
  }, {
    "lng": -82.722,
    "lat": 38.4039
  }, {
    "lng": -82.7218,
    "lat": 38.404
  }, {
    "lng": -82.7213,
    "lat": 38.4042
  }, {
    "lng": -82.7209,
    "lat": 38.4044
  }, {
    "lng": -82.7204,
    "lat": 38.4048
  }, {
    "lng": -82.7202,
    "lat": 38.405
  }, {
    "lng": -82.7194,
    "lat": 38.4059
  }, {
    "lng": -82.7195,
    "lat": 38.406
  }, {
    "lng": -82.7197,
    "lat": 38.406
  }, {
    "lng": -82.7193,
    "lat": 38.406
  }, {
    "lng": -82.7183,
    "lat": 38.407
  }, {
    "lng": -82.7173,
    "lat": 38.408
  }, {
    "lng": -82.7163,
    "lat": 38.4089
  }, {
    "lng": -82.715,
    "lat": 38.4099
  }, {
    "lng": -82.715,
    "lat": 38.4101
  }, {
    "lng": -82.7143,
    "lat": 38.4107
  }, {
    "lng": -82.7139,
    "lat": 38.4112
  }, {
    "lng": -82.7132,
    "lat": 38.4117
  }, {
    "lng": -82.7127,
    "lat": 38.4119
  }, {
    "lng": -82.7123,
    "lat": 38.4122
  }, {
    "lng": -82.7121,
    "lat": 38.4124
  }, {
    "lng": -82.712,
    "lat": 38.413
  }, {
    "lng": -82.7117,
    "lat": 38.4135
  }, {
    "lng": -82.7111,
    "lat": 38.4141
  }, {
    "lng": -82.7107,
    "lat": 38.4146
  }, {
    "lng": -82.7098,
    "lat": 38.4148
  }, {
    "lng": -82.7086,
    "lat": 38.4152
  }, {
    "lng": -82.7081,
    "lat": 38.4157
  }, {
    "lng": -82.7078,
    "lat": 38.4162
  }, {
    "lng": -82.7078,
    "lat": 38.4166
  }, {
    "lng": -82.7076,
    "lat": 38.4172
  }, {
    "lng": -82.7075,
    "lat": 38.4173
  }, {
    "lng": -82.7074,
    "lat": 38.4173
  }, {
    "lng": -82.707,
    "lat": 38.417
  }, {
    "lng": -82.7068,
    "lat": 38.4168
  }, {
    "lng": -82.7063,
    "lat": 38.4168
  }, {
    "lng": -82.7058,
    "lat": 38.4175
  }, {
    "lng": -82.7055,
    "lat": 38.4185
  }, {
    "lng": -82.7054,
    "lat": 38.4185
  }, {
    "lng": -82.7053,
    "lat": 38.419
  }]]],
  "options": {
    "fillColor": "#009aee",
    "fillOpacity": 0.4,
    "strokeColor": "#0073B3",
    "strokeWeight": 1,
    "strokeOpacity": 0.4,
    "clickable": true,
    "visible": true,
    "zIndex": 1000
  }
};
var carrierRoute23 = {
  carrierRoute: '41102C012',
  paths: [[[{
    lng: -82.6355,
    lat: 38.4524
  }, {
    lng: -82.6366,
    lat: 38.4527
  }, {
    lng: -82.6387,
    lat: 38.4531
  }, {
    lng: -82.6389,
    lat: 38.4532
  }, {
    lng: -82.6392,
    lat: 38.4532
  }, {
    lng: -82.642,
    lat: 38.4537
  }, {
    lng: -82.6421,
    lat: 38.4537
  }, {
    lng: -82.6422,
    lat: 38.4538
  }, {
    lng: -82.6425,
    lat: 38.4538
  }, {
    lng: -82.6426,
    lat: 38.4539
  }, {
    lng: -82.6428,
    lat: 38.4539
  }, {
    lng: -82.6429,
    lat: 38.454
  }, {
    lng: -82.6429,
    lat: 38.454
  }, {
    lng: -82.643,
    lat: 38.4541
  }, {
    lng: -82.6431,
    lat: 38.4541
  }, {
    lng: -82.6432,
    lat: 38.4542
  }, {
    lng: -82.6432,
    lat: 38.4543
  }, {
    lng: -82.6433,
    lat: 38.4543
  }, {
    lng: -82.6433,
    lat: 38.4544
  }, {
    lng: -82.6434,
    lat: 38.4545
  }, {
    lng: -82.6435,
    lat: 38.4546
  }, {
    lng: -82.6436,
    lat: 38.4547
  }, {
    lng: -82.6445,
    lat: 38.4552
  }, {
    lng: -82.6446,
    lat: 38.4553
  }, {
    lng: -82.6452,
    lat: 38.4556
  }, {
    lng: -82.6454,
    lat: 38.4558
  }, {
    lng: -82.6457,
    lat: 38.456
  }, {
    lng: -82.6464,
    lat: 38.4554
  }, {
    lng: -82.6465,
    lat: 38.4554
  }, {
    lng: -82.6465,
    lat: 38.4554
  }, {
    lng: -82.6467,
    lat: 38.4552
  }, {
    lng: -82.647,
    lat: 38.455
  }, {
    lng: -82.6471,
    lat: 38.4549
  }, {
    lng: -82.6472,
    lat: 38.4548
  }, {
    lng: -82.6474,
    lat: 38.4548
  }, {
    lng: -82.6475,
    lat: 38.4547
  }, {
    lng: -82.6478,
    lat: 38.4546
  }, {
    lng: -82.6478,
    lat: 38.4546
  }, {
    lng: -82.6476,
    lat: 38.4541
  }, {
    lng: -82.6474,
    lat: 38.4536
  }, {
    lng: -82.6495,
    lat: 38.4529
  }, {
    lng: -82.6498,
    lat: 38.4528
  }, {
    lng: -82.6501,
    lat: 38.4527
  }, {
    lng: -82.6502,
    lat: 38.4527
  }, {
    lng: -82.6505,
    lat: 38.4526
  }, {
    lng: -82.6509,
    lat: 38.4525
  }, {
    lng: -82.651,
    lat: 38.4524
  }, {
    lng: -82.6511,
    lat: 38.4524
  }, {
    lng: -82.6511,
    lat: 38.4523
  }, {
    lng: -82.6511,
    lat: 38.4522
  }, {
    lng: -82.651,
    lat: 38.4521
  }, {
    lng: -82.6509,
    lat: 38.4519
  }, {
    lng: -82.6508,
    lat: 38.4518
  }, {
    lng: -82.6508,
    lat: 38.4517
  }, {
    lng: -82.6507,
    lat: 38.4516
  }, {
    lng: -82.6507,
    lat: 38.4516
  }, {
    lng: -82.6507,
    lat: 38.4515
  }, {
    lng: -82.6507,
    lat: 38.4515
  }, {
    lng: -82.6506,
    lat: 38.4515
  }, {
    lng: -82.6506,
    lat: 38.4515
  }, {
    lng: -82.6505,
    lat: 38.4515
  }, {
    lng: -82.6504,
    lat: 38.4515
  }, {
    lng: -82.6503,
    lat: 38.4516
  }, {
    lng: -82.6496,
    lat: 38.4518
  }, {
    lng: -82.6469,
    lat: 38.4527
  }, {
    lng: -82.6464,
    lat: 38.452
  }, {
    lng: -82.6462,
    lat: 38.4515
  }, {
    lng: -82.6463,
    lat: 38.4514
  }, {
    lng: -82.6467,
    lat: 38.4509
  }, {
    lng: -82.6468,
    lat: 38.4508
  }, {
    lng: -82.647,
    lat: 38.4506
  }, {
    lng: -82.6473,
    lat: 38.4502
  }, {
    lng: -82.6474,
    lat: 38.4501
  }, {
    lng: -82.6476,
    lat: 38.4499
  }, {
    lng: -82.6478,
    lat: 38.4496
  }, {
    lng: -82.6479,
    lat: 38.4495
  }, {
    lng: -82.6475,
    lat: 38.4492
  }, {
    lng: -82.6472,
    lat: 38.449
  }, {
    lng: -82.6472,
    lat: 38.449
  }, {
    lng: -82.6472,
    lat: 38.4489
  }, {
    lng: -82.6472,
    lat: 38.4486
  }, {
    lng: -82.6473,
    lat: 38.4483
  }, {
    lng: -82.6473,
    lat: 38.4481
  }, {
    lng: -82.6474,
    lat: 38.4477
  }, {
    lng: -82.6475,
    lat: 38.4474
  }, {
    lng: -82.6476,
    lat: 38.4473
  }, {
    lng: -82.6475,
    lat: 38.4473
  }, {
    lng: -82.6475,
    lat: 38.4473
  }, {
    lng: -82.6473,
    lat: 38.4472
  }, {
    lng: -82.6471,
    lat: 38.4471
  }, {
    lng: -82.6469,
    lat: 38.447
  }, {
    lng: -82.6467,
    lat: 38.4469
  }, {
    lng: -82.6465,
    lat: 38.4468
  }, {
    lng: -82.6464,
    lat: 38.4467
  }, {
    lng: -82.6463,
    lat: 38.4466
  }, {
    lng: -82.6462,
    lat: 38.4466
  }, {
    lng: -82.646,
    lat: 38.4462
  }, {
    lng: -82.6459,
    lat: 38.4461
  }, {
    lng: -82.6458,
    lat: 38.446
  }, {
    lng: -82.6454,
    lat: 38.4459
  }, {
    lng: -82.6454,
    lat: 38.4453
  }, {
    lng: -82.6452,
    lat: 38.4448
  }, {
    lng: -82.6445,
    lat: 38.4443
  }, {
    lng: -82.6439,
    lat: 38.4439
  }, {
    lng: -82.6434,
    lat: 38.4437
  }, {
    lng: -82.6432,
    lat: 38.4432
  }, {
    lng: -82.6431,
    lat: 38.4432
  }, {
    lng: -82.643,
    lat: 38.4432
  }, {
    lng: -82.643,
    lat: 38.4433
  }, {
    lng: -82.6429,
    lat: 38.4433
  }, {
    lng: -82.6427,
    lat: 38.4434
  }, {
    lng: -82.6424,
    lat: 38.4429
  }, {
    lng: -82.6413,
    lat: 38.4429
  }, {
    lng: -82.6404,
    lat: 38.4431
  }, {
    lng: -82.6392,
    lat: 38.4431
  }, {
    lng: -82.6387,
    lat: 38.4431
  }, {
    lng: -82.6384,
    lat: 38.4432
  }, {
    lng: -82.6388,
    lat: 38.4445
  }, {
    lng: -82.6389,
    lat: 38.4447
  }, {
    lng: -82.6393,
    lat: 38.4458
  }, {
    lng: -82.6394,
    lat: 38.4461
  }, {
    lng: -82.6394,
    lat: 38.4462
  }, {
    lng: -82.6395,
    lat: 38.4463
  }, {
    lng: -82.6397,
    lat: 38.4465
  }, {
    lng: -82.6398,
    lat: 38.4466
  }, {
    lng: -82.6398,
    lat: 38.4466
  }, {
    lng: -82.6399,
    lat: 38.4467
  }, {
    lng: -82.64,
    lat: 38.4468
  }, {
    lng: -82.6402,
    lat: 38.4469
  }, {
    lng: -82.6403,
    lat: 38.447
  }, {
    lng: -82.6404,
    lat: 38.4471
  }, {
    lng: -82.6413,
    lat: 38.448
  }, {
    lng: -82.6414,
    lat: 38.4481
  }, {
    lng: -82.6402,
    lat: 38.4482
  }, {
    lng: -82.639,
    lat: 38.4482
  }, {
    lng: -82.6388,
    lat: 38.4483
  }, {
    lng: -82.6382,
    lat: 38.4485
  }, {
    lng: -82.6381,
    lat: 38.4485
  }, {
    lng: -82.638,
    lat: 38.4485
  }, {
    lng: -82.6379,
    lat: 38.4485
  }, {
    lng: -82.6377,
    lat: 38.4485
  }, {
    lng: -82.6373,
    lat: 38.4486
  }, {
    lng: -82.6373,
    lat: 38.4486
  }, {
    lng: -82.6373,
    lat: 38.4487
  }, {
    lng: -82.6373,
    lat: 38.4491
  }, {
    lng: -82.6372,
    lat: 38.4494
  }, {
    lng: -82.6372,
    lat: 38.4496
  }, {
    lng: -82.6372,
    lat: 38.4498
  }, {
    lng: -82.6372,
    lat: 38.45
  }, {
    lng: -82.6372,
    lat: 38.4501
  }, {
    lng: -82.6371,
    lat: 38.4502
  }, {
    lng: -82.637,
    lat: 38.4502
  }, {
    lng: -82.6369,
    lat: 38.4503
  }, {
    lng: -82.6368,
    lat: 38.4503
  }, {
    lng: -82.6366,
    lat: 38.4504
  }, {
    lng: -82.6365,
    lat: 38.4504
  }, {
    lng: -82.6364,
    lat: 38.4505
  }, {
    lng: -82.6364,
    lat: 38.4505
  }, {
    lng: -82.6364,
    lat: 38.4506
  }, {
    lng: -82.6363,
    lat: 38.4506
  }, {
    lng: -82.6362,
    lat: 38.4509
  }, {
    lng: -82.636,
    lat: 38.4515
  }, {
    lng: -82.6355,
    lat: 38.4524
  }]]],
  options: {
    fillColor: '#009aee',
    fillOpacity: 0.4,
    strokeColor: '#0073B3',
    strokeWeight: 1,
    strokeOpacity: 0.4,
    clickable: true,
    visible: true,
    zIndex: 1000
  }
};
var carrierRoute24 = {
  carrierRoute: '41101C019',
  paths: [[[{
    lng: -82.6202,
    lat: 38.4493
  }, {
    lng: -82.6203,
    lat: 38.4496
  }, {
    lng: -82.6203,
    lat: 38.4498
  }, {
    lng: -82.6203,
    lat: 38.4499
  }, {
    lng: -82.6204,
    lat: 38.4499
  }, {
    lng: -82.6205,
    lat: 38.45
  }, {
    lng: -82.6206,
    lat: 38.4501
  }, {
    lng: -82.6215,
    lat: 38.4507
  }, {
    lng: -82.6218,
    lat: 38.4509
  }, {
    lng: -82.622,
    lat: 38.451
  }, {
    lng: -82.6221,
    lat: 38.4511
  }, {
    lng: -82.6221,
    lat: 38.4513
  }, {
    lng: -82.6222,
    lat: 38.4515
  }, {
    lng: -82.6228,
    lat: 38.4532
  }, {
    lng: -82.6229,
    lat: 38.4533
  }, {
    lng: -82.623,
    lat: 38.4535
  }, {
    lng: -82.6231,
    lat: 38.4537
  }, {
    lng: -82.6232,
    lat: 38.4538
  }, {
    lng: -82.6233,
    lat: 38.454
  }, {
    lng: -82.6234,
    lat: 38.4541
  }, {
    lng: -82.6234,
    lat: 38.4542
  }, {
    lng: -82.6235,
    lat: 38.4547
  }, {
    lng: -82.6248,
    lat: 38.4546
  }, {
    lng: -82.6249,
    lat: 38.4546
  }, {
    lng: -82.6251,
    lat: 38.4546
  }, {
    lng: -82.6251,
    lat: 38.4546
  }, {
    lng: -82.6252,
    lat: 38.4546
  }, {
    lng: -82.6253,
    lat: 38.4547
  }, {
    lng: -82.6254,
    lat: 38.4547
  }, {
    lng: -82.6256,
    lat: 38.4548
  }, {
    lng: -82.6256,
    lat: 38.4549
  }, {
    lng: -82.6257,
    lat: 38.4549
  }, {
    lng: -82.6258,
    lat: 38.4551
  }, {
    lng: -82.6258,
    lat: 38.4552
  }, {
    lng: -82.6259,
    lat: 38.4552
  }, {
    lng: -82.6261,
    lat: 38.4553
  }, {
    lng: -82.6262,
    lat: 38.4553
  }, {
    lng: -82.6262,
    lat: 38.4551
  }, {
    lng: -82.6261,
    lat: 38.4551
  }, {
    lng: -82.6261,
    lat: 38.455
  }, {
    lng: -82.6261,
    lat: 38.455
  }, {
    lng: -82.6261,
    lat: 38.455
  }, {
    lng: -82.6261,
    lat: 38.455
  }, {
    lng: -82.6262,
    lat: 38.4549
  }, {
    lng: -82.6262,
    lat: 38.4549
  }, {
    lng: -82.6263,
    lat: 38.4549
  }, {
    lng: -82.6263,
    lat: 38.4549
  }, {
    lng: -82.6263,
    lat: 38.4548
  }, {
    lng: -82.6264,
    lat: 38.4547
  }, {
    lng: -82.6265,
    lat: 38.4547
  }, {
    lng: -82.6267,
    lat: 38.4545
  }, {
    lng: -82.6268,
    lat: 38.4544
  }, {
    lng: -82.6269,
    lat: 38.4543
  }, {
    lng: -82.6269,
    lat: 38.4542
  }, {
    lng: -82.628,
    lat: 38.454
  }, {
    lng: -82.6284,
    lat: 38.454
  }, {
    lng: -82.6293,
    lat: 38.4538
  }, {
    lng: -82.6295,
    lat: 38.4538
  }, {
    lng: -82.6295,
    lat: 38.4538
  }, {
    lng: -82.6297,
    lat: 38.4538
  }, {
    lng: -82.6299,
    lat: 38.4538
  }, {
    lng: -82.63,
    lat: 38.4538
  }, {
    lng: -82.6302,
    lat: 38.4539
  }, {
    lng: -82.6304,
    lat: 38.4539
  }, {
    lng: -82.6304,
    lat: 38.4539
  }, {
    lng: -82.6305,
    lat: 38.4539
  }, {
    lng: -82.6305,
    lat: 38.4539
  }, {
    lng: -82.6305,
    lat: 38.4538
  }, {
    lng: -82.6306,
    lat: 38.4538
  }, {
    lng: -82.6306,
    lat: 38.4536
  }, {
    lng: -82.6308,
    lat: 38.4532
  }, {
    lng: -82.6312,
    lat: 38.4533
  }, {
    lng: -82.6313,
    lat: 38.4533
  }, {
    lng: -82.6321,
    lat: 38.4536
  }, {
    lng: -82.633,
    lat: 38.454
  }, {
    lng: -82.6326,
    lat: 38.4547
  }, {
    lng: -82.6326,
    lat: 38.4548
  }, {
    lng: -82.6322,
    lat: 38.4555
  }, {
    lng: -82.632,
    lat: 38.4556
  }, {
    lng: -82.632,
    lat: 38.4556
  }, {
    lng: -82.6319,
    lat: 38.4557
  }, {
    lng: -82.6318,
    lat: 38.4559
  }, {
    lng: -82.6317,
    lat: 38.456
  }, {
    lng: -82.6317,
    lat: 38.4561
  }, {
    lng: -82.6316,
    lat: 38.4563
  }, {
    lng: -82.6315,
    lat: 38.4566
  }, {
    lng: -82.6316,
    lat: 38.4566
  }, {
    lng: -82.632,
    lat: 38.4565
  }, {
    lng: -82.6324,
    lat: 38.4564
  }, {
    lng: -82.6327,
    lat: 38.4566
  }, {
    lng: -82.6333,
    lat: 38.4565
  }, {
    lng: -82.6339,
    lat: 38.4565
  }, {
    lng: -82.6346,
    lat: 38.4563
  }, {
    lng: -82.6351,
    lat: 38.4564
  }, {
    lng: -82.6353,
    lat: 38.4565
  }, {
    lng: -82.6353,
    lat: 38.4566
  }, {
    lng: -82.6356,
    lat: 38.4567
  }, {
    lng: -82.6361,
    lat: 38.4569
  }, {
    lng: -82.6365,
    lat: 38.457
  }, {
    lng: -82.6377,
    lat: 38.4575
  }, {
    lng: -82.6378,
    lat: 38.4576
  }, {
    lng: -82.6379,
    lat: 38.4576
  }, {
    lng: -82.6387,
    lat: 38.4581
  }, {
    lng: -82.6391,
    lat: 38.4584
  }, {
    lng: -82.6394,
    lat: 38.4585
  }, {
    lng: -82.6398,
    lat: 38.4586
  }, {
    lng: -82.6401,
    lat: 38.4585
  }, {
    lng: -82.6401,
    lat: 38.4585
  }, {
    lng: -82.6397,
    lat: 38.4582
  }, {
    lng: -82.6396,
    lat: 38.4582
  }, {
    lng: -82.6392,
    lat: 38.4579
  }, {
    lng: -82.6392,
    lat: 38.4578
  }, {
    lng: -82.639,
    lat: 38.4577
  }, {
    lng: -82.6386,
    lat: 38.4575
  }, {
    lng: -82.6385,
    lat: 38.4575
  }, {
    lng: -82.6384,
    lat: 38.4574
  }, {
    lng: -82.6383,
    lat: 38.4573
  }, {
    lng: -82.6382,
    lat: 38.4573
  }, {
    lng: -82.6382,
    lat: 38.4572
  }, {
    lng: -82.6382,
    lat: 38.4571
  }, {
    lng: -82.6382,
    lat: 38.4571
  }, {
    lng: -82.6383,
    lat: 38.457
  }, {
    lng: -82.6384,
    lat: 38.457
  }, {
    lng: -82.6384,
    lat: 38.457
  }, {
    lng: -82.6387,
    lat: 38.4568
  }, {
    lng: -82.6389,
    lat: 38.4567
  }, {
    lng: -82.639,
    lat: 38.4564
  }, {
    lng: -82.6393,
    lat: 38.4556
  }, {
    lng: -82.6395,
    lat: 38.4552
  }, {
    lng: -82.6395,
    lat: 38.4552
  }, {
    lng: -82.6396,
    lat: 38.4551
  }, {
    lng: -82.6396,
    lat: 38.4551
  }, {
    lng: -82.6397,
    lat: 38.455
  }, {
    lng: -82.6397,
    lat: 38.455
  }, {
    lng: -82.6398,
    lat: 38.4549
  }, {
    lng: -82.6399,
    lat: 38.4548
  }, {
    lng: -82.64,
    lat: 38.4549
  }, {
    lng: -82.6401,
    lat: 38.455
  }, {
    lng: -82.6405,
    lat: 38.4551
  }, {
    lng: -82.6407,
    lat: 38.4551
  }, {
    lng: -82.6414,
    lat: 38.4553
  }, {
    lng: -82.6415,
    lat: 38.4553
  }, {
    lng: -82.6416,
    lat: 38.4553
  }, {
    lng: -82.6417,
    lat: 38.4553
  }, {
    lng: -82.6418,
    lat: 38.4553
  }, {
    lng: -82.6419,
    lat: 38.4553
  }, {
    lng: -82.642,
    lat: 38.4552
  }, {
    lng: -82.6425,
    lat: 38.4548
  }, {
    lng: -82.6427,
    lat: 38.4546
  }, {
    lng: -82.6428,
    lat: 38.4546
  }, {
    lng: -82.6433,
    lat: 38.4543
  }, {
    lng: -82.6432,
    lat: 38.4543
  }, {
    lng: -82.6432,
    lat: 38.4542
  }, {
    lng: -82.6431,
    lat: 38.4541
  }, {
    lng: -82.643,
    lat: 38.4541
  }, {
    lng: -82.6429,
    lat: 38.454
  }, {
    lng: -82.6429,
    lat: 38.454
  }, {
    lng: -82.6428,
    lat: 38.4539
  }, {
    lng: -82.6426,
    lat: 38.4539
  }, {
    lng: -82.6425,
    lat: 38.4538
  }, {
    lng: -82.6422,
    lat: 38.4538
  }, {
    lng: -82.6421,
    lat: 38.4537
  }, {
    lng: -82.642,
    lat: 38.4537
  }, {
    lng: -82.6392,
    lat: 38.4532
  }, {
    lng: -82.6389,
    lat: 38.4532
  }, {
    lng: -82.6387,
    lat: 38.4531
  }, {
    lng: -82.6366,
    lat: 38.4527
  }, {
    lng: -82.6355,
    lat: 38.4524
  }, {
    lng: -82.636,
    lat: 38.4515
  }, {
    lng: -82.6362,
    lat: 38.4509
  }, {
    lng: -82.6363,
    lat: 38.4506
  }, {
    lng: -82.6362,
    lat: 38.4506
  }, {
    lng: -82.6351,
    lat: 38.4502
  }, {
    lng: -82.6349,
    lat: 38.4501
  }, {
    lng: -82.6348,
    lat: 38.4501
  }, {
    lng: -82.6346,
    lat: 38.4501
  }, {
    lng: -82.6346,
    lat: 38.45
  }, {
    lng: -82.6344,
    lat: 38.45
  }, {
    lng: -82.6332,
    lat: 38.4496
  }, {
    lng: -82.6321,
    lat: 38.4492
  }, {
    lng: -82.6316,
    lat: 38.4484
  }, {
    lng: -82.6312,
    lat: 38.4478
  }, {
    lng: -82.6311,
    lat: 38.4477
  }, {
    lng: -82.6311,
    lat: 38.4476
  }, {
    lng: -82.6311,
    lat: 38.4476
  }, {
    lng: -82.631,
    lat: 38.4476
  }, {
    lng: -82.631,
    lat: 38.4476
  }, {
    lng: -82.6309,
    lat: 38.4476
  }, {
    lng: -82.6308,
    lat: 38.4476
  }, {
    lng: -82.6307,
    lat: 38.4477
  }, {
    lng: -82.6299,
    lat: 38.448
  }, {
    lng: -82.6297,
    lat: 38.4477
  }, {
    lng: -82.6303,
    lat: 38.4475
  }, {
    lng: -82.6303,
    lat: 38.4474
  }, {
    lng: -82.6306,
    lat: 38.4473
  }, {
    lng: -82.6308,
    lat: 38.4472
  }, {
    lng: -82.6308,
    lat: 38.4472
  }, {
    lng: -82.6308,
    lat: 38.4471
  }, {
    lng: -82.6309,
    lat: 38.447
  }, {
    lng: -82.6309,
    lat: 38.447
  }, {
    lng: -82.6308,
    lat: 38.4469
  }, {
    lng: -82.6308,
    lat: 38.4468
  }, {
    lng: -82.6308,
    lat: 38.4468
  }, {
    lng: -82.6307,
    lat: 38.4467
  }, {
    lng: -82.6306,
    lat: 38.4466
  }, {
    lng: -82.6306,
    lat: 38.4466
  }, {
    lng: -82.6305,
    lat: 38.4466
  }, {
    lng: -82.6304,
    lat: 38.4465
  }, {
    lng: -82.6303,
    lat: 38.4465
  }, {
    lng: -82.6302,
    lat: 38.4465
  }, {
    lng: -82.6301,
    lat: 38.4465
  }, {
    lng: -82.6299,
    lat: 38.4465
  }, {
    lng: -82.6295,
    lat: 38.4466
  }, {
    lng: -82.6292,
    lat: 38.4466
  }, {
    lng: -82.629,
    lat: 38.4466
  }, {
    lng: -82.6289,
    lat: 38.4466
  }, {
    lng: -82.6288,
    lat: 38.4466
  }, {
    lng: -82.6288,
    lat: 38.4466
  }, {
    lng: -82.6287,
    lat: 38.4466
  }, {
    lng: -82.6287,
    lat: 38.4466
  }, {
    lng: -82.6286,
    lat: 38.4466
  }, {
    lng: -82.6286,
    lat: 38.4466
  }, {
    lng: -82.6286,
    lat: 38.4466
  }, {
    lng: -82.6286,
    lat: 38.4465
  }, {
    lng: -82.6286,
    lat: 38.4465
  }, {
    lng: -82.6286,
    lat: 38.4464
  }, {
    lng: -82.6286,
    lat: 38.4463
  }, {
    lng: -82.6286,
    lat: 38.4462
  }, {
    lng: -82.6286,
    lat: 38.4458
  }, {
    lng: -82.6313,
    lat: 38.4457
  }, {
    lng: -82.6313,
    lat: 38.4454
  }, {
    lng: -82.6313,
    lat: 38.4453
  }, {
    lng: -82.6313,
    lat: 38.4452
  }, {
    lng: -82.6313,
    lat: 38.4452
  }, {
    lng: -82.6312,
    lat: 38.4451
  }, {
    lng: -82.6312,
    lat: 38.4451
  }, {
    lng: -82.6311,
    lat: 38.445
  }, {
    lng: -82.631,
    lat: 38.445
  }, {
    lng: -82.631,
    lat: 38.4449
  }, {
    lng: -82.6309,
    lat: 38.4449
  }, {
    lng: -82.6308,
    lat: 38.4448
  }, {
    lng: -82.6307,
    lat: 38.4448
  }, {
    lng: -82.6307,
    lat: 38.4448
  }, {
    lng: -82.6306,
    lat: 38.4448
  }, {
    lng: -82.6303,
    lat: 38.4449
  }, {
    lng: -82.6302,
    lat: 38.4449
  }, {
    lng: -82.6301,
    lat: 38.4449
  }, {
    lng: -82.63,
    lat: 38.4449
  }, {
    lng: -82.6297,
    lat: 38.4449
  }, {
    lng: -82.6295,
    lat: 38.4449
  }, {
    lng: -82.6295,
    lat: 38.4449
  }, {
    lng: -82.6294,
    lat: 38.4449
  }, {
    lng: -82.6292,
    lat: 38.4449
  }, {
    lng: -82.6289,
    lat: 38.4449
  }, {
    lng: -82.6285,
    lat: 38.4449
  }, {
    lng: -82.6284,
    lat: 38.4449
  }, {
    lng: -82.6282,
    lat: 38.4449
  }, {
    lng: -82.6278,
    lat: 38.4449
  }, {
    lng: -82.6272,
    lat: 38.4448
  }, {
    lng: -82.627,
    lat: 38.4448
  }, {
    lng: -82.6268,
    lat: 38.4448
  }, {
    lng: -82.6265,
    lat: 38.4448
  }, {
    lng: -82.6263,
    lat: 38.4448
  }, {
    lng: -82.6262,
    lat: 38.4448
  }, {
    lng: -82.6261,
    lat: 38.4448
  }, {
    lng: -82.6261,
    lat: 38.4448
  }, {
    lng: -82.6259,
    lat: 38.4448
  }, {
    lng: -82.6258,
    lat: 38.4449
  }, {
    lng: -82.6256,
    lat: 38.4449
  }, {
    lng: -82.6253,
    lat: 38.445
  }, {
    lng: -82.6251,
    lat: 38.4451
  }, {
    lng: -82.6244,
    lat: 38.4453
  }, {
    lng: -82.6243,
    lat: 38.4454
  }, {
    lng: -82.6241,
    lat: 38.4455
  }, {
    lng: -82.624,
    lat: 38.4455
  }, {
    lng: -82.6236,
    lat: 38.4457
  }, {
    lng: -82.6235,
    lat: 38.4458
  }, {
    lng: -82.6238,
    lat: 38.4459
  }, {
    lng: -82.624,
    lat: 38.4461
  }, {
    lng: -82.6247,
    lat: 38.4466
  }, {
    lng: -82.6248,
    lat: 38.4466
  }, {
    lng: -82.625,
    lat: 38.4468
  }, {
    lng: -82.625,
    lat: 38.4469
  }, {
    lng: -82.6251,
    lat: 38.4469
  }, {
    lng: -82.6252,
    lat: 38.447
  }, {
    lng: -82.6253,
    lat: 38.4472
  }, {
    lng: -82.6253,
    lat: 38.4472
  }, {
    lng: -82.6253,
    lat: 38.4473
  }, {
    lng: -82.6254,
    lat: 38.4475
  }, {
    lng: -82.6254,
    lat: 38.4476
  }, {
    lng: -82.6253,
    lat: 38.4479
  }, {
    lng: -82.6253,
    lat: 38.4482
  }, {
    lng: -82.6253,
    lat: 38.4483
  }, {
    lng: -82.6253,
    lat: 38.4486
  }, {
    lng: -82.6254,
    lat: 38.4489
  }, {
    lng: -82.6255,
    lat: 38.4491
  }, {
    lng: -82.6256,
    lat: 38.4494
  }, {
    lng: -82.6256,
    lat: 38.4495
  }, {
    lng: -82.6256,
    lat: 38.4496
  }, {
    lng: -82.6255,
    lat: 38.4496
  }, {
    lng: -82.6254,
    lat: 38.4496
  }, {
    lng: -82.6252,
    lat: 38.4495
  }, {
    lng: -82.6251,
    lat: 38.4495
  }, {
    lng: -82.625,
    lat: 38.4495
  }, {
    lng: -82.6247,
    lat: 38.4496
  }, {
    lng: -82.6244,
    lat: 38.4496
  }, {
    lng: -82.6243,
    lat: 38.4496
  }, {
    lng: -82.6236,
    lat: 38.4497
  }, {
    lng: -82.6232,
    lat: 38.4498
  }, {
    lng: -82.6228,
    lat: 38.4499
  }, {
    lng: -82.6224,
    lat: 38.45
  }, {
    lng: -82.6223,
    lat: 38.45
  }, {
    lng: -82.6221,
    lat: 38.45
  }, {
    lng: -82.622,
    lat: 38.4499
  }, {
    lng: -82.6218,
    lat: 38.4498
  }, {
    lng: -82.6214,
    lat: 38.4496
  }, {
    lng: -82.621,
    lat: 38.4493
  }, {
    lng: -82.621,
    lat: 38.4493
  }, {
    lng: -82.6209,
    lat: 38.4493
  }, {
    lng: -82.6209,
    lat: 38.4492
  }, {
    lng: -82.6208,
    lat: 38.4492
  }, {
    lng: -82.6205,
    lat: 38.4493
  }, {
    lng: -82.6203,
    lat: 38.4493
  }, {
    lng: -82.6203,
    lat: 38.4493
  }, {
    lng: -82.6202,
    lat: 38.4493
  }]]],
  options: {
    fillColor: '#009aee',
    fillOpacity: 0.4,
    strokeColor: '#0073B3',
    strokeWeight: 1,
    strokeOpacity: 0.4,
    clickable: true,
    visible: true,
    zIndex: 1000
  }
};
var carrierRoute25 = {
  "carrierRoute": "41101C013",
  "paths": [[[{
    "lng": -82.612,
    "lat": 38.4474
  }, {
    "lng": -82.6121,
    "lat": 38.4476
  }, {
    "lng": -82.6121,
    "lat": 38.4477
  }, {
    "lng": -82.6124,
    "lat": 38.4476
  }, {
    "lng": -82.6125,
    "lat": 38.4476
  }, {
    "lng": -82.6126,
    "lat": 38.4475
  }, {
    "lng": -82.6128,
    "lat": 38.4473
  }, {
    "lng": -82.613,
    "lat": 38.4472
  }, {
    "lng": -82.6132,
    "lat": 38.447
  }, {
    "lng": -82.6132,
    "lat": 38.4469
  }, {
    "lng": -82.6133,
    "lat": 38.4468
  }, {
    "lng": -82.6134,
    "lat": 38.4467
  }, {
    "lng": -82.6134,
    "lat": 38.4467
  }, {
    "lng": -82.6136,
    "lat": 38.4463
  }, {
    "lng": -82.6144,
    "lat": 38.4466
  }, {
    "lng": -82.6144,
    "lat": 38.4466
  }, {
    "lng": -82.6145,
    "lat": 38.4466
  }, {
    "lng": -82.6149,
    "lat": 38.4465
  }, {
    "lng": -82.6155,
    "lat": 38.4464
  }, {
    "lng": -82.6154,
    "lat": 38.4459
  }, {
    "lng": -82.6158,
    "lat": 38.4458
  }, {
    "lng": -82.616,
    "lat": 38.4457
  }, {
    "lng": -82.6164,
    "lat": 38.4455
  }, {
    "lng": -82.6166,
    "lat": 38.4454
  }, {
    "lng": -82.6166,
    "lat": 38.4454
  }, {
    "lng": -82.6167,
    "lat": 38.4454
  }, {
    "lng": -82.6169,
    "lat": 38.4454
  }, {
    "lng": -82.617,
    "lat": 38.4454
  }, {
    "lng": -82.6172,
    "lat": 38.4454
  }, {
    "lng": -82.6176,
    "lat": 38.4454
  }, {
    "lng": -82.6179,
    "lat": 38.4454
  }, {
    "lng": -82.6181,
    "lat": 38.4453
  }, {
    "lng": -82.6181,
    "lat": 38.4453
  }, {
    "lng": -82.6182,
    "lat": 38.4453
  }, {
    "lng": -82.6183,
    "lat": 38.4453
  }, {
    "lng": -82.6184,
    "lat": 38.4452
  }, {
    "lng": -82.6184,
    "lat": 38.4452
  }, {
    "lng": -82.6185,
    "lat": 38.4451
  }, {
    "lng": -82.6188,
    "lat": 38.4449
  }, {
    "lng": -82.619,
    "lat": 38.4448
  }, {
    "lng": -82.6191,
    "lat": 38.4447
  }, {
    "lng": -82.6191,
    "lat": 38.4447
  }, {
    "lng": -82.6192,
    "lat": 38.4447
  }, {
    "lng": -82.6192,
    "lat": 38.4447
  }, {
    "lng": -82.6193,
    "lat": 38.4447
  }, {
    "lng": -82.6194,
    "lat": 38.4447
  }, {
    "lng": -82.6195,
    "lat": 38.4447
  }, {
    "lng": -82.6197,
    "lat": 38.4448
  }, {
    "lng": -82.62,
    "lat": 38.4449
  }, {
    "lng": -82.6203,
    "lat": 38.4449
  }, {
    "lng": -82.6213,
    "lat": 38.4453
  }, {
    "lng": -82.6221,
    "lat": 38.4457
  }, {
    "lng": -82.6224,
    "lat": 38.4458
  }, {
    "lng": -82.6225,
    "lat": 38.4458
  }, {
    "lng": -82.6226,
    "lat": 38.4458
  }, {
    "lng": -82.6226,
    "lat": 38.4458
  }, {
    "lng": -82.6228,
    "lat": 38.4458
  }, {
    "lng": -82.6232,
    "lat": 38.4458
  }, {
    "lng": -82.6234,
    "lat": 38.4458
  }, {
    "lng": -82.6235,
    "lat": 38.4458
  }, {
    "lng": -82.6236,
    "lat": 38.4457
  }, {
    "lng": -82.624,
    "lat": 38.4455
  }, {
    "lng": -82.6241,
    "lat": 38.4455
  }, {
    "lng": -82.6243,
    "lat": 38.4454
  }, {
    "lng": -82.6244,
    "lat": 38.4453
  }, {
    "lng": -82.6251,
    "lat": 38.4451
  }, {
    "lng": -82.6253,
    "lat": 38.445
  }, {
    "lng": -82.6256,
    "lat": 38.4449
  }, {
    "lng": -82.6258,
    "lat": 38.4449
  }, {
    "lng": -82.6259,
    "lat": 38.4448
  }, {
    "lng": -82.6261,
    "lat": 38.4448
  }, {
    "lng": -82.6261,
    "lat": 38.4448
  }, {
    "lng": -82.6262,
    "lat": 38.4448
  }, {
    "lng": -82.6263,
    "lat": 38.4448
  }, {
    "lng": -82.6265,
    "lat": 38.4448
  }, {
    "lng": -82.6268,
    "lat": 38.4448
  }, {
    "lng": -82.627,
    "lat": 38.4448
  }, {
    "lng": -82.6272,
    "lat": 38.4448
  }, {
    "lng": -82.6278,
    "lat": 38.4449
  }, {
    "lng": -82.6282,
    "lat": 38.4449
  }, {
    "lng": -82.6284,
    "lat": 38.4449
  }, {
    "lng": -82.6285,
    "lat": 38.4449
  }, {
    "lng": -82.6289,
    "lat": 38.4449
  }, {
    "lng": -82.6292,
    "lat": 38.4449
  }, {
    "lng": -82.6294,
    "lat": 38.4449
  }, {
    "lng": -82.6295,
    "lat": 38.4449
  }, {
    "lng": -82.6295,
    "lat": 38.4449
  }, {
    "lng": -82.6297,
    "lat": 38.4449
  }, {
    "lng": -82.63,
    "lat": 38.4449
  }, {
    "lng": -82.6301,
    "lat": 38.4449
  }, {
    "lng": -82.6302,
    "lat": 38.4449
  }, {
    "lng": -82.6303,
    "lat": 38.4449
  }, {
    "lng": -82.6306,
    "lat": 38.4448
  }, {
    "lng": -82.6307,
    "lat": 38.4448
  }, {
    "lng": -82.6307,
    "lat": 38.4448
  }, {
    "lng": -82.6308,
    "lat": 38.4448
  }, {
    "lng": -82.6309,
    "lat": 38.4449
  }, {
    "lng": -82.631,
    "lat": 38.4449
  }, {
    "lng": -82.631,
    "lat": 38.445
  }, {
    "lng": -82.6311,
    "lat": 38.445
  }, {
    "lng": -82.6312,
    "lat": 38.4451
  }, {
    "lng": -82.6312,
    "lat": 38.4451
  }, {
    "lng": -82.6313,
    "lat": 38.4452
  }, {
    "lng": -82.6313,
    "lat": 38.4452
  }, {
    "lng": -82.6313,
    "lat": 38.4453
  }, {
    "lng": -82.6313,
    "lat": 38.4454
  }, {
    "lng": -82.6313,
    "lat": 38.4457
  }, {
    "lng": -82.6286,
    "lat": 38.4458
  }, {
    "lng": -82.6286,
    "lat": 38.4462
  }, {
    "lng": -82.6286,
    "lat": 38.4463
  }, {
    "lng": -82.6286,
    "lat": 38.4464
  }, {
    "lng": -82.6286,
    "lat": 38.4465
  }, {
    "lng": -82.6286,
    "lat": 38.4465
  }, {
    "lng": -82.6286,
    "lat": 38.4466
  }, {
    "lng": -82.6286,
    "lat": 38.4466
  }, {
    "lng": -82.6286,
    "lat": 38.4466
  }, {
    "lng": -82.6287,
    "lat": 38.4466
  }, {
    "lng": -82.6287,
    "lat": 38.4466
  }, {
    "lng": -82.6288,
    "lat": 38.4466
  }, {
    "lng": -82.6288,
    "lat": 38.4466
  }, {
    "lng": -82.6289,
    "lat": 38.4466
  }, {
    "lng": -82.629,
    "lat": 38.4466
  }, {
    "lng": -82.6292,
    "lat": 38.4466
  }, {
    "lng": -82.6295,
    "lat": 38.4466
  }, {
    "lng": -82.6299,
    "lat": 38.4465
  }, {
    "lng": -82.6301,
    "lat": 38.4465
  }, {
    "lng": -82.6302,
    "lat": 38.4465
  }, {
    "lng": -82.6303,
    "lat": 38.4465
  }, {
    "lng": -82.6304,
    "lat": 38.4465
  }, {
    "lng": -82.6305,
    "lat": 38.4466
  }, {
    "lng": -82.6306,
    "lat": 38.4466
  }, {
    "lng": -82.6306,
    "lat": 38.4466
  }, {
    "lng": -82.6307,
    "lat": 38.4467
  }, {
    "lng": -82.6308,
    "lat": 38.4468
  }, {
    "lng": -82.6308,
    "lat": 38.4468
  }, {
    "lng": -82.6308,
    "lat": 38.4469
  }, {
    "lng": -82.6309,
    "lat": 38.447
  }, {
    "lng": -82.6309,
    "lat": 38.447
  }, {
    "lng": -82.6308,
    "lat": 38.4471
  }, {
    "lng": -82.6308,
    "lat": 38.4472
  }, {
    "lng": -82.6308,
    "lat": 38.4472
  }, {
    "lng": -82.6306,
    "lat": 38.4473
  }, {
    "lng": -82.6303,
    "lat": 38.4474
  }, {
    "lng": -82.6303,
    "lat": 38.4475
  }, {
    "lng": -82.6297,
    "lat": 38.4477
  }, {
    "lng": -82.6299,
    "lat": 38.448
  }, {
    "lng": -82.6307,
    "lat": 38.4477
  }, {
    "lng": -82.6308,
    "lat": 38.4476
  }, {
    "lng": -82.6309,
    "lat": 38.4476
  }, {
    "lng": -82.631,
    "lat": 38.4476
  }, {
    "lng": -82.631,
    "lat": 38.4476
  }, {
    "lng": -82.6311,
    "lat": 38.4476
  }, {
    "lng": -82.6311,
    "lat": 38.4476
  }, {
    "lng": -82.6311,
    "lat": 38.4477
  }, {
    "lng": -82.6312,
    "lat": 38.4478
  }, {
    "lng": -82.6316,
    "lat": 38.4484
  }, {
    "lng": -82.6321,
    "lat": 38.4492
  }, {
    "lng": -82.6332,
    "lat": 38.4496
  }, {
    "lng": -82.6344,
    "lat": 38.45
  }, {
    "lng": -82.6346,
    "lat": 38.45
  }, {
    "lng": -82.6346,
    "lat": 38.4501
  }, {
    "lng": -82.6348,
    "lat": 38.4501
  }, {
    "lng": -82.6349,
    "lat": 38.4501
  }, {
    "lng": -82.6351,
    "lat": 38.4502
  }, {
    "lng": -82.6362,
    "lat": 38.4506
  }, {
    "lng": -82.6363,
    "lat": 38.4506
  }, {
    "lng": -82.6364,
    "lat": 38.4506
  }, {
    "lng": -82.6364,
    "lat": 38.4505
  }, {
    "lng": -82.6364,
    "lat": 38.4505
  }, {
    "lng": -82.6365,
    "lat": 38.4504
  }, {
    "lng": -82.6366,
    "lat": 38.4504
  }, {
    "lng": -82.6368,
    "lat": 38.4503
  }, {
    "lng": -82.6369,
    "lat": 38.4503
  }, {
    "lng": -82.637,
    "lat": 38.4502
  }, {
    "lng": -82.6371,
    "lat": 38.4502
  }, {
    "lng": -82.6372,
    "lat": 38.4501
  }, {
    "lng": -82.6372,
    "lat": 38.45
  }, {
    "lng": -82.6372,
    "lat": 38.4498
  }, {
    "lng": -82.6372,
    "lat": 38.4496
  }, {
    "lng": -82.6372,
    "lat": 38.4494
  }, {
    "lng": -82.6373,
    "lat": 38.4491
  }, {
    "lng": -82.6373,
    "lat": 38.4487
  }, {
    "lng": -82.6373,
    "lat": 38.4486
  }, {
    "lng": -82.6373,
    "lat": 38.4484
  }, {
    "lng": -82.6373,
    "lat": 38.4483
  }, {
    "lng": -82.6373,
    "lat": 38.448
  }, {
    "lng": -82.6372,
    "lat": 38.4477
  }, {
    "lng": -82.6372,
    "lat": 38.4476
  }, {
    "lng": -82.6372,
    "lat": 38.4475
  }, {
    "lng": -82.6371,
    "lat": 38.4472
  }, {
    "lng": -82.637,
    "lat": 38.447
  }, {
    "lng": -82.6369,
    "lat": 38.4469
  }, {
    "lng": -82.6369,
    "lat": 38.4467
  }, {
    "lng": -82.6369,
    "lat": 38.4461
  }, {
    "lng": -82.6369,
    "lat": 38.446
  }, {
    "lng": -82.6369,
    "lat": 38.4457
  }, {
    "lng": -82.6369,
    "lat": 38.4455
  }, {
    "lng": -82.6369,
    "lat": 38.4454
  }, {
    "lng": -82.6369,
    "lat": 38.4453
  }, {
    "lng": -82.6369,
    "lat": 38.4451
  }, {
    "lng": -82.6369,
    "lat": 38.445
  }, {
    "lng": -82.6369,
    "lat": 38.4449
  }, {
    "lng": -82.6369,
    "lat": 38.4447
  }, {
    "lng": -82.6369,
    "lat": 38.4446
  }, {
    "lng": -82.6369,
    "lat": 38.4445
  }, {
    "lng": -82.6368,
    "lat": 38.4444
  }, {
    "lng": -82.6368,
    "lat": 38.4441
  }, {
    "lng": -82.6367,
    "lat": 38.4439
  }, {
    "lng": -82.6367,
    "lat": 38.4438
  }, {
    "lng": -82.6365,
    "lat": 38.4436
  }, {
    "lng": -82.6361,
    "lat": 38.4432
  }, {
    "lng": -82.6361,
    "lat": 38.4431
  }, {
    "lng": -82.636,
    "lat": 38.4431
  }, {
    "lng": -82.636,
    "lat": 38.443
  }, {
    "lng": -82.6359,
    "lat": 38.4429
  }, {
    "lng": -82.6358,
    "lat": 38.4427
  }, {
    "lng": -82.6357,
    "lat": 38.4426
  }, {
    "lng": -82.6357,
    "lat": 38.4422
  }, {
    "lng": -82.6357,
    "lat": 38.442
  }, {
    "lng": -82.6357,
    "lat": 38.4412
  }, {
    "lng": -82.635,
    "lat": 38.4396
  }, {
    "lng": -82.6347,
    "lat": 38.4388
  }, {
    "lng": -82.6349,
    "lat": 38.4383
  }, {
    "lng": -82.6347,
    "lat": 38.4377
  }, {
    "lng": -82.6344,
    "lat": 38.4373
  }, {
    "lng": -82.634,
    "lat": 38.437
  }, {
    "lng": -82.6336,
    "lat": 38.437
  }, {
    "lng": -82.6334,
    "lat": 38.4369
  }, {
    "lng": -82.6332,
    "lat": 38.4369
  }, {
    "lng": -82.6331,
    "lat": 38.4369
  }, {
    "lng": -82.6332,
    "lat": 38.4366
  }, {
    "lng": -82.6332,
    "lat": 38.4365
  }, {
    "lng": -82.6334,
    "lat": 38.4361
  }, {
    "lng": -82.631,
    "lat": 38.4362
  }, {
    "lng": -82.6309,
    "lat": 38.4362
  }, {
    "lng": -82.6304,
    "lat": 38.4361
  }, {
    "lng": -82.6306,
    "lat": 38.4364
  }, {
    "lng": -82.6309,
    "lat": 38.4367
  }, {
    "lng": -82.6311,
    "lat": 38.4368
  }, {
    "lng": -82.6314,
    "lat": 38.437
  }, {
    "lng": -82.631,
    "lat": 38.437
  }, {
    "lng": -82.6305,
    "lat": 38.437
  }, {
    "lng": -82.6304,
    "lat": 38.437
  }, {
    "lng": -82.6296,
    "lat": 38.4368
  }, {
    "lng": -82.6292,
    "lat": 38.4367
  }, {
    "lng": -82.6288,
    "lat": 38.4366
  }, {
    "lng": -82.6278,
    "lat": 38.4365
  }, {
    "lng": -82.6276,
    "lat": 38.4366
  }, {
    "lng": -82.627,
    "lat": 38.4367
  }, {
    "lng": -82.6265,
    "lat": 38.4368
  }, {
    "lng": -82.6263,
    "lat": 38.437
  }, {
    "lng": -82.6259,
    "lat": 38.4372
  }, {
    "lng": -82.6257,
    "lat": 38.4375
  }, {
    "lng": -82.6254,
    "lat": 38.4377
  }, {
    "lng": -82.6252,
    "lat": 38.438
  }, {
    "lng": -82.625,
    "lat": 38.4383
  }, {
    "lng": -82.6246,
    "lat": 38.4385
  }, {
    "lng": -82.6243,
    "lat": 38.4387
  }, {
    "lng": -82.6239,
    "lat": 38.4388
  }, {
    "lng": -82.6236,
    "lat": 38.4388
  }, {
    "lng": -82.6234,
    "lat": 38.4387
  }, {
    "lng": -82.6233,
    "lat": 38.4387
  }, {
    "lng": -82.6231,
    "lat": 38.4384
  }, {
    "lng": -82.6229,
    "lat": 38.4382
  }, {
    "lng": -82.6227,
    "lat": 38.438
  }, {
    "lng": -82.6225,
    "lat": 38.438
  }, {
    "lng": -82.6224,
    "lat": 38.438
  }, {
    "lng": -82.6221,
    "lat": 38.4382
  }, {
    "lng": -82.6219,
    "lat": 38.4384
  }, {
    "lng": -82.6218,
    "lat": 38.4387
  }, {
    "lng": -82.6216,
    "lat": 38.4389
  }, {
    "lng": -82.6213,
    "lat": 38.4391
  }, {
    "lng": -82.6205,
    "lat": 38.4392
  }, {
    "lng": -82.6203,
    "lat": 38.4392
  }, {
    "lng": -82.6199,
    "lat": 38.4393
  }, {
    "lng": -82.6196,
    "lat": 38.4395
  }, {
    "lng": -82.6195,
    "lat": 38.4396
  }, {
    "lng": -82.6194,
    "lat": 38.4396
  }, {
    "lng": -82.6193,
    "lat": 38.4397
  }, {
    "lng": -82.6191,
    "lat": 38.4396
  }, {
    "lng": -82.6184,
    "lat": 38.4398
  }, {
    "lng": -82.6181,
    "lat": 38.4401
  }, {
    "lng": -82.6148,
    "lat": 38.4412
  }, {
    "lng": -82.6147,
    "lat": 38.4412
  }, {
    "lng": -82.6146,
    "lat": 38.4412
  }, {
    "lng": -82.6142,
    "lat": 38.4414
  }, {
    "lng": -82.614,
    "lat": 38.4416
  }, {
    "lng": -82.6141,
    "lat": 38.4421
  }, {
    "lng": -82.6143,
    "lat": 38.4424
  }, {
    "lng": -82.6147,
    "lat": 38.4429
  }, {
    "lng": -82.6148,
    "lat": 38.443
  }, {
    "lng": -82.6153,
    "lat": 38.4433
  }, {
    "lng": -82.6157,
    "lat": 38.4439
  }, {
    "lng": -82.6157,
    "lat": 38.444
  }, {
    "lng": -82.6154,
    "lat": 38.4447
  }, {
    "lng": -82.6157,
    "lat": 38.4453
  }, {
    "lng": -82.6157,
    "lat": 38.4454
  }, {
    "lng": -82.6156,
    "lat": 38.4454
  }, {
    "lng": -82.6155,
    "lat": 38.4454
  }, {
    "lng": -82.615,
    "lat": 38.4453
  }, {
    "lng": -82.6145,
    "lat": 38.4455
  }, {
    "lng": -82.6138,
    "lat": 38.4456
  }, {
    "lng": -82.6136,
    "lat": 38.4455
  }, {
    "lng": -82.6134,
    "lat": 38.4453
  }, {
    "lng": -82.6134,
    "lat": 38.4453
  }, {
    "lng": -82.6131,
    "lat": 38.4455
  }, {
    "lng": -82.6128,
    "lat": 38.4458
  }, {
    "lng": -82.6127,
    "lat": 38.446
  }, {
    "lng": -82.6126,
    "lat": 38.4465
  }, {
    "lng": -82.6124,
    "lat": 38.447
  }, {
    "lng": -82.6123,
    "lat": 38.4471
  }, {
    "lng": -82.612,
    "lat": 38.4474
  }]]],
  "options": {
    "fillColor": "#009aee",
    "fillOpacity": 0.4,
    "strokeColor": "#0073B3",
    "strokeWeight": 1,
    "strokeOpacity": 0.4,
    "clickable": true,
    "visible": true,
    "zIndex": 1000
  }
};
var carrierRoutes = [carrierRoute01, carrierRoute02, carrierRoute03, carrierRoute04, carrierRoute05, carrierRoute06, carrierRoute07, carrierRoute08, carrierRoute09, carrierRoute10, carrierRoute11, carrierRoute12, carrierRoute13, carrierRoute14, carrierRoute15, carrierRoute16, carrierRoute17, carrierRoute18, carrierRoute19, carrierRoute20, carrierRoute21, carrierRoute22, carrierRoute23, carrierRoute24, carrierRoute25];
var carrierRoutesSampleData =
/*#__PURE__*/
Object.freeze({
  __proto__: null,
  carrierRoutes: carrierRoutes
});
var img$m = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='96' height='96' viewBox='0 0 96 96'%3e%3cdefs%3e%3cstyle%3e.a%7bfill:%23f50d0d%3bstroke:white%3bstroke-width:4px%3b%7d.b%7bfill:white%3b%7d.c%7bstroke:none%3b%7d.d%7bfill:none%3b%7d%3c/style%3e%3c/defs%3e%3cg transform='translate(-109 -80)'%3e%3cg class='a' transform='translate(109 80)'%3e%3ccircle class='c' cx='48' cy='48' r='48'/%3e%3ccircle class='d' cx='48' cy='48' r='46'/%3e%3c/g%3e%3cpath class='b' d='M2012.47-187h3.6a25.4%2c25.4%2c0%2c0%2c0%2c20.812%2c0h3.6c.082.081.153.218.246.234a8.163%2c8.163%2c0%2c0%2c1%2c6.484%2c5.523%2c16.3%2c16.3%2c0%2c0%2c1-.075%2c11.648%2c31.7%2c31.7%2c0%2c0%2c1-1.553%2c4.057%2c24.933%2c24.933%2c0%2c0%2c0-2.6%2c12.89%2c51.445%2c51.445%2c0%2c0%2c1-2.242%2c17.857c-.7%2c2.242-1.52%2c4.461-3.86%2c5.6H2035.6a3.488%2c3.488%2c0%2c0%2c1-2.2-2.608%2c17.133%2c17.133%2c0%2c0%2c1-.622-5.072c.109-2.82.322-5.637.479-8.456a16.2%2c16.2%2c0%2c0%2c0-.736-6.069%2c6%2c6%2c0%2c0%2c0-5.782-4.441%2c5.954%2c5.954%2c0%2c0%2c0-6.144%2c4.1%2c13.05%2c13.05%2c0%2c0%2c0-.678%2c2.593c-.543%2c3.21.074%2c6.4.123%2c9.6a29.208%2c29.208%2c0%2c0%2c1-.115%2c6.272c-.337%2c1.675-.582%2c3.434-2.572%2c4.077h-1.285a6.468%2c6.468%2c0%2c0%2c1-2.971-3.347%2c25.243%2c25.243%2c0%2c0%2c1-1.4-4.11%2c63.372%2c63.372%2c0%2c0%2c1-1.7-18.575%2c17.853%2c17.853%2c0%2c0%2c0-1.546-7.837%2c66.458%2c66.458%2c0%2c0%2c1-3.078-8.124%2c16.469%2c16.469%2c0%2c0%2c1-.524-6.979C2005.51-182.7%2c2007.89-185.812%2c2012.47-187Z' transform='translate(-1869.68 286)'/%3e%3c/g%3e%3c/svg%3e";
var officeMarkerCoordinates = {
  lat: 38.508612,
  lng: -82.693395
};
var officeMarkersSampleData =
/*#__PURE__*/
Object.freeze({
  __proto__: null,
  officeMarkerCoordinates: officeMarkerCoordinates,
  officeMarkerUrl: img$m
});
var designMailings = [{
  id: '1',
  tdw: '20 Jun',
  name: 'MVP-234',
  account: 'MVP Dental 123',
  quantity: '5000',
  zone: 'Zone 1',
  zoneColor: 'red',
  tracking: '(606) 230-3928',
  logisticsId: '007VTJSA'
}, {
  id: '2',
  tdw: '24 Jun',
  name: 'MVP-234',
  account: 'MVP Dental 123',
  quantity: '5000',
  zone: 'Zone 2',
  zoneColor: 'green',
  tracking: '(606) 230-3936',
  logisticsId: '007VTJSB'
}, {
  id: '3',
  tdw: '30 Jun',
  name: 'MVP-234',
  account: 'MVP Dental 123',
  quantity: '5000',
  zone: 'Zone 3',
  zoneColor: 'blue',
  tracking: '(606) 230-3941',
  logisticsId: '107VTJSO'
}];
var designMailingsSampleData =
/*#__PURE__*/
Object.freeze({
  __proto__: null,
  designMailings: designMailings
});
var comments = [{
  id: 'front-99',
  cardFace: CardFace.Front,
  x: 80,
  y: 94,
  dateOriginallyPosted: new Date(2020, 8, 8),
  messages: [{
    id: 'front-99-message-1',
    postedBy: 'John Doe',
    message: 'This is a test.',
    datePosted: new Date(2020, 8, 8)
  }],
  status: CommentStatus.Pending
}, {
  id: 'front-1',
  cardFace: CardFace.Front,
  x: 14,
  y: 84,
  dateOriginallyPosted: new Date(2020, 4, 26),
  messages: [{
    id: 'front-1-message-1',
    postedBy: 'John Doe',
    message: 'This is a test.',
    datePosted: new Date(2020, 4, 26)
  }],
  status: CommentStatus.Pending
}, {
  id: 'front-2',
  cardFace: CardFace.Front,
  x: 6,
  y: 40,
  dateOriginallyPosted: new Date(2020, 4, 26),
  messages: [{
    id: 'front-2-message-1',
    postedBy: 'John Doe',
    message: 'This is another comment.',
    datePosted: new Date(2020, 4, 26)
  }, {
    id: 'front-2-message-2',
    postedBy: 'Dan Duncan',
    message: 'Thanks will fix this.',
    datePosted: new Date(2020, 4, 27)
  }, {
    id: 'front-2-message-3',
    postedBy: 'John Doe',
    message: 'Yet another comment.',
    datePosted: new Date(2020, 4, 27)
  }, {
    id: 'front-2-message-4',
    postedBy: 'John Doe',
    message: 'This is another comment.',
    datePosted: new Date(2020, 4, 26)
  }, {
    id: 'front-2-message-5',
    postedBy: 'Dan Duncan',
    message: 'Thanks will fix this.',
    datePosted: new Date(2020, 4, 27)
  }, {
    id: 'front-2-message-6',
    postedBy: 'John Doe',
    message: 'Yet another comment.',
    datePosted: new Date(2020, 4, 27)
  }, {
    id: 'front-2-message-7',
    postedBy: 'John Doe',
    message: 'This is another comment.',
    datePosted: new Date(2020, 4, 26)
  }, {
    id: 'front-2-message-8',
    postedBy: 'Dan Duncan',
    message: 'Thanks will fix this.',
    datePosted: new Date(2020, 4, 27)
  }, {
    id: 'front-2-message-9',
    postedBy: 'John Doe',
    message: 'Yet another comment. Last comment in thread.',
    datePosted: new Date(2020, 4, 27)
  }],
  status: CommentStatus.Rejected
}, {
  id: 'front-3',
  cardFace: CardFace.Front,
  x: 100,
  y: 7,
  dateOriginallyPosted: new Date(2020, 4, 26),
  messages: [{
    id: 'front-3-message-1',
    postedBy: 'John Doe',
    message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum imperdiet felis ut pretium rutrum. Etiam condimentum non sapien elementum fermentum. Ut ut mollis magna. Morbi tellus massa, elementum id purus vitae, tempus elementum dolor. Duis malesuada dolor vitae diam interdum malesuada. Integer sollicitudin sed augue dictum euismod. Aenean feugiat consectetur felis, fringilla sagittis diam congue vel. Donec iaculis, augue vitae convallis mattis, ex urna sollicitudin odio, in sodales urna mi ac arcu. Donec eu consequat massa.',
    datePosted: new Date(2020, 4, 26)
  }],
  status: CommentStatus.Accepted
}, {
  id: 'front-4',
  cardFace: CardFace.Front,
  x: 50,
  y: 50,
  dateOriginallyPosted: new Date(2020, 4, 27),
  messages: [{
    id: 'front-4-message-1',
    postedBy: 'John Doe',
    message: 'Accepted comment.',
    datePosted: new Date(2020, 4, 27)
  }],
  status: CommentStatus.Pending
}, {
  id: 'front-5',
  cardFace: CardFace.Front,
  x: 35,
  y: 80,
  dateOriginallyPosted: new Date(2020, 4, 27),
  messages: [{
    id: 'front-5-message-1',
    postedBy: 'John Doe',
    message: 'Accepted comment.',
    datePosted: new Date(2020, 4, 27)
  }],
  status: CommentStatus.Pending
}, {
  id: 'front-6',
  cardFace: CardFace.Front,
  x: 75,
  y: 33,
  dateOriginallyPosted: new Date(2020, 4, 27),
  messages: [{
    id: 'front-6-message-1',
    postedBy: 'John Doe',
    message: 'Accepted comment.',
    datePosted: new Date(2020, 4, 27)
  }],
  status: CommentStatus.Pending
}, {
  id: 'front-7',
  cardFace: CardFace.Front,
  x: 15,
  y: 23,
  dateOriginallyPosted: new Date(2020, 4, 27),
  messages: [{
    id: 'front-7-message-1',
    postedBy: 'John Doe',
    message: 'Accepted comment.',
    datePosted: new Date(2020, 4, 27)
  }],
  status: CommentStatus.Pending
}, {
  id: 'back-1',
  cardFace: CardFace.Back,
  x: 65,
  y: 76,
  dateOriginallyPosted: new Date(2020, 4, 26),
  messages: [{
    id: 'back-1-message-1',
    postedBy: 'John Doe',
    message: 'This is another comment.',
    datePosted: new Date(2020, 4, 26)
  }, {
    id: 'back-1-message-2',
    postedBy: 'Dan Duncan',
    message: 'Thanks will fix this.',
    datePosted: new Date(2020, 4, 27)
  }, {
    id: 'back-1-message-3',
    postedBy: 'John Doe',
    message: 'Yet another comment.',
    datePosted: new Date(2020, 4, 27)
  }],
  status: CommentStatus.Pending
}, {
  id: 'back-2',
  cardFace: CardFace.Back,
  x: 70,
  y: 38,
  dateOriginallyPosted: new Date(2020, 4, 26),
  messages: [{
    id: 'back-2-message-1',
    postedBy: 'John Doe',
    message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum imperdiet felis ut pretium rutrum. Etiam condimentum non sapien elementum fermentum. Ut ut mollis magna. Morbi tellus massa, elementum id purus vitae, tempus elementum dolor. Duis malesuada dolor vitae diam interdum malesuada. Integer sollicitudin sed augue dictum euismod. Aenean feugiat consectetur felis, fringilla sagittis diam congue vel. Donec iaculis, augue vitae convallis mattis, ex urna sollicitudin odio, in sodales urna mi ac arcu. Donec eu consequat massa.',
    datePosted: new Date(2020, 4, 26)
  }],
  status: CommentStatus.Pending
}, {
  id: 'back-3',
  cardFace: CardFace.Back,
  x: 10,
  y: 10,
  dateOriginallyPosted: new Date(2020, 4, 27),
  messages: [{
    id: 'back-3-message-1',
    postedBy: 'John Doe',
    message: 'Accepted comment.',
    datePosted: new Date(2020, 4, 27)
  }],
  status: CommentStatus.Pending
}];
var designReviewFinalLook =
/*#__PURE__*/
Object.freeze({
  __proto__: null,
  comments: comments
});
var comments$1 = [{
  id: 'front-99',
  cardFace: CardFace.Front,
  x: 50,
  y: 98,
  dateOriginallyPosted: new Date(2020, 8, 8),
  messages: [{
    id: 'front-99-message-1',
    postedBy: 'John Doe',
    message: 'This is a test.',
    datePosted: new Date(2020, 8, 8)
  }],
  status: CommentStatus.Pending
}, {
  id: 'front-1',
  cardFace: CardFace.Front,
  x: 13,
  y: 89,
  dateOriginallyPosted: new Date(2020, 4, 26),
  messages: [{
    id: 'front-1-message-1',
    postedBy: 'John Doe',
    message: 'This is a test.',
    datePosted: new Date(2020, 4, 26)
  }],
  status: CommentStatus.Pending
}, {
  id: 'front-2',
  cardFace: CardFace.Front,
  x: 80,
  y: 60,
  dateOriginallyPosted: new Date(2020, 4, 26),
  messages: [{
    id: 'front-2-message-1',
    postedBy: 'John Doe',
    message: 'This is another comment.',
    datePosted: new Date(2020, 4, 26)
  }, {
    id: 'front-2-message-2',
    postedBy: 'Dan Duncan',
    message: 'Thanks will fix this.',
    datePosted: new Date(2020, 4, 27)
  }, {
    id: 'front-2-message-3',
    postedBy: 'John Doe',
    message: 'Yet another comment.',
    datePosted: new Date(2020, 4, 27)
  }, {
    id: 'front-2-message-4',
    postedBy: 'John Doe',
    message: 'This is another comment.',
    datePosted: new Date(2020, 4, 26)
  }, {
    id: 'front-2-message-5',
    postedBy: 'Dan Duncan',
    message: 'Thanks will fix this.',
    datePosted: new Date(2020, 4, 27)
  }, {
    id: 'front-2-message-6',
    postedBy: 'John Doe',
    message: 'Yet another comment.',
    datePosted: new Date(2020, 4, 27)
  }, {
    id: 'front-2-message-7',
    postedBy: 'John Doe',
    message: 'This is another comment.',
    datePosted: new Date(2020, 4, 26)
  }, {
    id: 'front-2-message-8',
    postedBy: 'Dan Duncan',
    message: 'Thanks will fix this.',
    datePosted: new Date(2020, 4, 27)
  }, {
    id: 'front-2-message-9',
    postedBy: 'John Doe',
    message: 'Yet another comment.',
    datePosted: new Date(2020, 4, 27)
  }, {
    id: 'front-2-message-10',
    postedBy: 'John Doe',
    message: 'This is another comment.',
    datePosted: new Date(2020, 4, 26)
  }, {
    id: 'front-2-message-11',
    postedBy: 'Dan Duncan',
    message: 'Thanks will fix this.',
    datePosted: new Date(2020, 4, 27)
  }, {
    id: 'front-2-message-12',
    postedBy: 'John Doe',
    message: 'Yet another comment.',
    datePosted: new Date(2020, 4, 27)
  }, {
    id: 'front-2-message-13',
    postedBy: 'John Doe',
    message: 'This is another comment.',
    datePosted: new Date(2020, 4, 26)
  }, {
    id: 'front-2-message-14',
    postedBy: 'Dan Duncan',
    message: 'Thanks will fix this.',
    datePosted: new Date(2020, 4, 27)
  }, {
    id: 'front-2-message-15',
    postedBy: 'John Doe',
    message: 'Yet another comment.',
    datePosted: new Date(2020, 4, 27)
  }, {
    id: 'front-2-message-16',
    postedBy: 'John Doe',
    message: 'This is another comment.',
    datePosted: new Date(2020, 4, 26)
  }, {
    id: 'front-2-message-17',
    postedBy: 'Dan Duncan',
    message: 'Thanks will fix this.',
    datePosted: new Date(2020, 4, 27)
  }, {
    id: 'front-2-message-18',
    postedBy: 'John Doe',
    message: 'Yet another comment.',
    datePosted: new Date(2020, 4, 27)
  }, {
    id: 'front-2-message-19',
    postedBy: 'John Doe',
    message: 'This is another comment.',
    datePosted: new Date(2020, 4, 26)
  }, {
    id: 'front-2-message-20',
    postedBy: 'Dan Duncan',
    message: 'Thanks will fix this.',
    datePosted: new Date(2020, 4, 27)
  }, {
    id: 'front-2-message-21',
    postedBy: 'John Doe',
    message: 'Yet another comment.',
    datePosted: new Date(2020, 4, 27)
  }, {
    id: 'front-2-message-22',
    postedBy: 'John Doe',
    message: 'This is another comment.',
    datePosted: new Date(2020, 4, 26)
  }, {
    id: 'front-2-message-23',
    postedBy: 'Dan Duncan',
    message: 'Thanks will fix this.',
    datePosted: new Date(2020, 4, 27)
  }, {
    id: 'front-2-message-24',
    postedBy: 'John Doe',
    message: 'Yet another comment.',
    datePosted: new Date(2020, 4, 27)
  }],
  status: CommentStatus.Pending
}, {
  id: 'front-3',
  cardFace: CardFace.Front,
  x: 35,
  y: 77,
  dateOriginallyPosted: new Date(2020, 4, 26),
  messages: [{
    id: 'front-3-message-1',
    postedBy: 'John Doe',
    message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum imperdiet felis ut pretium rutrum. Etiam condimentum non sapien elementum fermentum. Ut ut mollis magna. Morbi tellus massa, elementum id purus vitae, tempus elementum dolor. Duis malesuada dolor vitae diam interdum malesuada. Integer sollicitudin sed augue dictum euismod. Aenean feugiat consectetur felis, fringilla sagittis diam congue vel. Donec iaculis, augue vitae convallis mattis, ex urna sollicitudin odio, in sodales urna mi ac arcu. Donec eu consequat massa.',
    datePosted: new Date(2020, 4, 26)
  }],
  status: CommentStatus.Pending
}, {
  id: 'front-4',
  cardFace: CardFace.Front,
  x: 95,
  y: 80,
  dateOriginallyPosted: new Date(2020, 4, 27),
  messages: [{
    id: 'front-4-message-1',
    postedBy: 'John Doe',
    message: 'Accepted comment.',
    datePosted: new Date(2020, 4, 27)
  }],
  status: CommentStatus.Pending
}, {
  id: 'back-1',
  cardFace: CardFace.Back,
  x: 10,
  y: 85,
  dateOriginallyPosted: new Date(2020, 4, 26),
  messages: [{
    id: 'back-1-message-1',
    postedBy: 'John Doe',
    message: 'This is another comment.',
    datePosted: new Date(2020, 4, 26)
  }, {
    id: 'back-1-message-2',
    postedBy: 'Dan Duncan',
    message: 'Thanks will fix this.',
    datePosted: new Date(2020, 4, 27)
  }, {
    id: 'back-1-message-3',
    postedBy: 'John Doe',
    message: 'Yet another comment.',
    datePosted: new Date(2020, 4, 27)
  }],
  status: CommentStatus.Pending
}, {
  id: 'back-2',
  cardFace: CardFace.Back,
  x: 70,
  y: 38,
  dateOriginallyPosted: new Date(2020, 4, 26),
  messages: [{
    id: 'back-2-message-1',
    postedBy: 'John Doe',
    message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum imperdiet felis ut pretium rutrum. Etiam condimentum non sapien elementum fermentum. Ut ut mollis magna. Morbi tellus massa, elementum id purus vitae, tempus elementum dolor. Duis malesuada dolor vitae diam interdum malesuada. Integer sollicitudin sed augue dictum euismod. Aenean feugiat consectetur felis, fringilla sagittis diam congue vel. Donec iaculis, augue vitae convallis mattis, ex urna sollicitudin odio, in sodales urna mi ac arcu. Donec eu consequat massa.',
    datePosted: new Date(2020, 4, 26)
  }],
  status: CommentStatus.Pending
}, {
  id: 'back-3',
  cardFace: CardFace.Back,
  x: 10,
  y: 10,
  dateOriginallyPosted: new Date(2020, 4, 27),
  messages: [{
    id: 'back-3-message-1',
    postedBy: 'John Doe',
    message: 'Accepted comment.',
    datePosted: new Date(2020, 4, 27)
  }],
  status: CommentStatus.Pending
}];
var revisionReview =
/*#__PURE__*/
Object.freeze({
  __proto__: null,
  comments: comments$1
});
var reviewCommentsSampleData =
/*#__PURE__*/
Object.freeze({
  __proto__: null,
  designReviewFinalLookComments: designReviewFinalLook,
  revisionReviewComments: revisionReview
});
var designMediaTypes = {
  Postcard_6x11: {
    width: 6,
    height: 11,
    currentVersionFrontUrl: 'https://mvpmailhouse.nyc3.digitaloceanspaces.com/01196-MVP-6-FRONT-FULL.png',
    currentVersionBackUrl: 'https://mvpmailhouse.nyc3.digitaloceanspaces.com/01196-MVP-6-BACK-FULL.png',
    currentVersionFrontThumbnailUrl: 'https://mvpmailhouse.nyc3.digitaloceanspaces.com/01196-MVP-6-FRONT-THUMBNAIL.png',
    currentVersionBackThumbnailUrl: 'https://mvpmailhouse.nyc3.digitaloceanspaces.com/01196-MVP-6-BACK-THUMBNAIL.png'
  },
  Postcard_6x11_portrait: {
    width: 6,
    height: 11,
    currentVersionFrontUrl: 'https://mvpmailhouse.nyc3.digitaloceanspaces.com/a0G1I00000EGsOaUAL-FRONT-FULL.png',
    currentVersionBackUrl: 'https://mvpmailhouse.nyc3.digitaloceanspaces.com/a0G1I00000EGsOaUAL-BACK-FULL.png',
    currentVersionFrontThumbnailUrl: 'https://mvpmailhouse.nyc3.digitaloceanspaces.com/a0G1I00000EGsOaUAL-FRONT-THUMBNAIL.png',
    currentVersionBackThumbnailUrl: 'https://mvpmailhouse.nyc3.digitaloceanspaces.com/a0G1I00000EGsOaUAL-BACK-THUMBNAIL.png'
  },
  Postcard_4x6: {
    width: 4,
    height: 6,
    currentVersionFrontUrl: 'https://media.mvpmailhouse.com/staging-files/a0G0v000003YQ6WEAW-FRONT-FULL.png',
    currentVersionBackUrl: 'https://media.mvpmailhouse.com/staging-files/a0G0v000003YQ6WEAW-BACK-FULL.png',
    currentVersionFrontThumbnailUrl: 'https://media.mvpmailhouse.com/staging-files/a0G0v000003YQ6WEAW-FRONT-THUMBNAIL.png',
    currentVersionBackThumbnailUrl: 'https://media.mvpmailhouse.com/staging-files/a0G0v000003YQ6WEAW-BACK-THUMBNAIL.png'
  },
  Trifold_5x9: {
    width: 5,
    height: 9,
    currentVersionFrontUrl: 'https://media.mvpmailhouse.com/staging-files/a0G0v000003YRcHEAW-FRONT-FULL.png',
    currentVersionBackUrl: 'https://media.mvpmailhouse.com/staging-files/a0G0v000003YRcHEAW-BACK-FULL.png',
    currentVersionFrontThumbnailUrl: 'https://media.mvpmailhouse.com/staging-files/a0G0v000003YRcHEAW-FRONT-THUMBNAIL.png',
    currentVersionBackThumbnailUrl: 'https://media.mvpmailhouse.com/staging-files/a0G0v000003YRcHEAW-BACK-THUMBNAIL.png'
  }
};
var designMediaTypesSampleData =
/*#__PURE__*/
Object.freeze({
  __proto__: null,
  designMediaTypes: designMediaTypes
});

var sampleData = _objectSpread({}, carrierRoutesSampleData, officeMarkersSampleData, designConceptsSampleData, designMailingsSampleData, reviewCommentsSampleData, designMediaTypesSampleData);

export { ActionType, ActionsOverlayContainer, AnimatedPaper, BottomOverlay, CampaignDesignStatus, CampaignMediaModalType, CampaignMediaStatus, CampaignReviewType, CardFace, CheckedBadge, Colors, CommentStatus, DEFAULT_CENTER, DEFAULT_ZOOM, DefaultImagePlaceholder, Design, DesignConceptModalSelector, DesignConceptModalTypes, DesignConceptPreview, DesignConceptSelection, DesignLabScaffold, DesignReview, DesignReviewExperience, DesignReviewProvider, DesignReviewViewedAs, DesignSide, DesignStatus, DesignTaskType, DesignType, DesignVersion, DesignVersionStatus, GoogleMap, Header, HelpModal, ImageLoader, ImageSlider, ImageViewer, ImageViewerControls, LoadingLabel, MarkerRevisionReview, MediaType, Modal, NumberedBadge, PlainNumberedBadge, PortraitLoader, PostcardBottomOverlay, RejectedBadge, ReviewComment, ReviewCommentStatus, Rotate, SlideUpTransition, Status, TaskQueue, TaskQueueModel, TaskType, ThemeProvider, Thumbnail$1 as Thumbnail, ThumbnailElement, ThumbnailPlaceholder, ThumbnailSwitcherOverlay, ThumbnailWithMarkers, ThumbnailsWithMarkers, Tooltip, TwoSidedImageViewer, VideoModal, ViewingArea, ViewingAreaTopRightOverlay, Workflow, convertReviewCommentToCommentMarker, convertReviewCommentToCommentMarkerMessage, formatPhoneNumber, getDimensionFactorsByMediaType, getFollowingReviewFromNextReview, getNextValue, sampleData, setProducedState, useBottomOverlayStyles, useDesignConceptModalSelector, useEscape, useImageDimensions, useImageLoader, useImageViewer, useImageViewerControlsStyles, useImageViewerStyles, useMeasure, useResizeHandlers, useScaledComments, useWindowMeasure };